const constant = window.constant = {}

constant.dashboard = [
  {
    label: 'Last 1 month',
    value: 1
  },
  {
    label: 'Last 3 months',
    value: 3
  },
  {
    label: 'Last 12 months',
    value: 12
  }
]

constant.licenseValidityUnits = [
  {
    unit: 0,
    name: 'unlimited',
    displayName: 'Unlimited'
  },
  {
    unit: 1,
    name: 'year',
    displayName: 'Yearly'
  },
  {
    unit: 2,
    name: 'month',
    displayName: 'Monthly'
  },
  {
    unit: 3,
    name: 'week',
    displayName: 'Weekly'
  },
  {
    unit: 4,
    name: 'day',
    displayName: 'daily'
  }
]

constant.trendGraphs = [
  {
    name: 'overAllVibration',
    internalName: 'overAllVibration',
    reportPath: 'overAllVibration',
    displayName: 'Overall Vibration'
  },
  {
    name: 'crestFactor',
    internalName: 'crestFactor',
    reportPath: 'crestFactor',
    displayName: 'Crest Factor'
  }
]

constant.trendWithFaults = [
  {
    name: 'bearing',
    internalName: 'bearing',
    reportPath: 'bearingLevel',
    displayName: 'Bearing'
  },
  {
    name: 'unbalance',
    internalName: 'balance',
    reportPath: 'unbalanceLevel',
    displayName: 'Balance'
  },
  {
    name: 'misalignment',
    internalName: 'alignment',
    reportPath: 'misalignmentLevel',
    displayName: 'Alignment'
  },
  {
    name: 'operation',
    internalName: 'operation',
    reportPath: 'operationLevel',
    displayName: 'Operation'
  }
]

constant.distributorRoles = [
  {
    id: 1,
    internalName: 'SalesRep',
    name: 'Sales Rep'
  }
]

constant.typesOfMachine = [
  {
    id: 0,
    name: 'motor',
    displayName: 'Motor',
    icon: 'icon-motor',
    sortOrder: 1
  },
  {
    id: 1,
    name: 'pump',
    displayName: 'Pump',
    icon: 'icon-pump',
    sortOrder: 2
  },
  {
    id: 2,
    name: 'fan',
    displayName: 'Fan',
    icon: 'icon-fan',
    sortOrder: 3
  },
  {
    id: 3,
    name: 'compressor',
    displayName: 'Compressor',
    icon: 'icon-compressor',
    sortOrder: 4
  },
  {
    id: 4,
    name: 'machine',
    displayName: 'Monitoring Machine',
    icon: 'icon-monitoring-machine',
    sortOrder: 5
  }
]

constant.points = [
  {
    id: 1,
    name: 'Load End/Inboard'
  },
  {
    id: 2,
    name: 'Free End/Outboard'
  }
]

constant.motorReportPropertiesSequence = [
  {
    displayName: 'Roller Bearings',
    changeName: 'Roller Bearings',
    severityName: 'bearingSeverity',
    recommendationName: 'bearingRecommendations',
    color: 'blue'
  },
  {
    displayName: 'Unbalance',
    changeName: 'Balance',
    severityName: 'unbalanceSeverity',
    recommendationName: 'unbalanceRecommendations',
    color: '#dd8237'
  },
  {
    displayName: 'Misalignment',
    changeName: 'Alignment',
    severityName: 'misalignmentSeverity',
    recommendationName: 'misalignmentRecommendations',
    color: '#00a3a3'
  },
  {
    displayName: 'Operation',
    changeName: 'Operation',
    severityName: 'operationSeverity',
    recommendationName: 'operationRecommendations',
    color: 'purple'
  },
  {
    displayName: 'Operation',
    changeName: 'Operation',
    severityName: 'electricalSeverity',
    recommendationName: 'electricalRecommendations',
    color: 'purple'
  },
  {
    displayName: 'Final Report',
    changeName: 'Final Report',
    severityName: 'finalSeverity',
    recommendationName: 'finalRecommendations',
    color: 'green'
  }
]

constant.machineReportPropertiesSequence = [
  {
    displayName: 'Vibration Severity',
    severityName: 'vibrationSeverity',
    recommendationName: 'vibrationSeverityRecommendations',
    color: '#dd8237'
  },
  {
    displayName: 'Shock Severity',
    severityName: 'shockSeverity',
    recommendationName: 'shockSeverityRecommendations',
    color: '#00a3a3'
  }
]

constant.machineConditions = [
  {
    id: 1,
    state: 'EEEEE1',
    condition: 'Excellent condition',
    color: '#10aef0'
  },
  {
    id: 2,
    state: 'EEEEE2',
    condition: 'Good condition',
    color: '#8cc63f'
  },
  {
    id: 3,
    state: 'EEEEE3',
    condition: 'Passable condition',
    color: '#fcb040'
  },
  {
    id: 4,
    state: 'EEEEE4',
    condition: 'Warning condition',
    color: '#f1592a',
    note: 'If it is possible that external sources are contaminating (or adding up) the vibrations then isolate external sources and analyze the machine again.'
  },
  {
    id: 5,
    state: 'EEEEE5',
    condition: 'Alert condition',
    color: '#c0352e',
    note: ' There is significant vibration contamination from external sources and it is recommended to isolate machine from such external sources and analyze again.'
  }
]

constant.readingTypes = [
  {
    id: 1,
    internalName: 'portable',
    displayName: 'Handheld',
    assessmentLabel: 'Handheld Assessment'
  },
  {
    id: 2,
    internalName: 'permanent',
    displayName: 'Fixed',
    assessmentLabel: 'Condition Monitoring'
  }
]
constant.deviceTypes = [
  {
    id: 1,
    internalName: 'portable',
    displayName: 'Handheld'
  },
  {
    id: 2,
    internalName: 'permanent',
    displayName: 'Fixed'
  }
]

constant.licenseTypes = [
  {
    id: 1,
    internalName: 'analysisPack',
    displayName: 'Analysis Pack'
  },
  {
    id: 2,
    internalName: 'subscriptionKit',
    displayName: 'Subscription Kit'
  },
  {
    id: 3,
    internalName: 'fixedDevice',
    displayName: 'Fixed Device'
  },
  {
    id: 4,
    internalName: 'handheldDevice',
    displayName: 'Handheld Device'
  }
]

constant.machineStates = [
  {
    id: -1,
    internalName: 'unknown',
    displayName: 'Unknown',
    color: '#707172'
  },
  {
    id: 0,
    internalName: 'learning',
    displayName: 'Learning Mode',
    color: '#63ba3c'
  },
  {
    id: 1,
    internalName: 'normal',
    displayName: 'Acceptable',
    color: '#10aef0'
  },
  {
    id: 2,
    internalName: 'warning',
    displayName: 'Warning',
    color: '#fcb040'
  },
  {
    id: 3,
    internalName: 'alert',
    displayName: 'Alert',
    color: '#c0352e'
  }
]
constant.machineVibrationPointsMap = [
  { point: '1x', axis: 'x', pointLevel: 1, XYZPoint: ['x0c', 'x0a', 'x0s'] },
  { point: '1y', axis: 'y', pointLevel: 1, XYZPoint: ['y0c', 'y0a', 'y0s'] },
  { point: '1z', axis: 'z', pointLevel: 1, XYZPoint: ['z0c', 'z0a', 'z0s'] },
  { point: '2x', axis: 'x', pointLevel: 2, XYZPoint: ['x1c', 'x1a', 'x1s'] },
  { point: '2y', axis: 'y', pointLevel: 2, XYZPoint: ['y1c', 'y1a', 'y1s'] },
  { point: '2z', axis: 'z', pointLevel: 2, XYZPoint: ['z1c', 'z1a', 'z1s'] }
]

constant.deviceStates = [
  {
    id: 1,
    internalName: 'configured',
    displayName: 'Configured'
  },
  {
    id: 2,
    internalName: 'monitoring',
    displayName: 'Monitoring'
  },
  {
    id: 3,
    internalName: 'deepSleep',
    displayName: 'Deep Sleep'
  }
]

constant.roles = [
  {
    id: 1,
    level: 1,
    name: 'Admin',
    assignRoleTo: [
      {
        id: 1,
        name: 'Admin'
      },
      {
        id: 2,
        name: 'Manager'
      },
      {
        id: 3,
        name: 'Engineer'
      },
      {
        id: 4,
        name: 'Technician'
      }
    ]
  },
  {
    id: 2,
    level: 2,
    name: 'Manager',
    assignRoleTo: [
      {
        id: 1,
        name: 'Admin'
      },
      {
        id: 2,
        name: 'Manager'
      },
      {
        id: 3,
        name: 'Engineer'
      },
      {
        id: 4,
        name: 'Technician'
      }
    ]
  },
  {
    id: 3,
    level: 3,
    name: 'Engineer',
    assignRoleTo: [
      {
        id: 4,
        name: 'Technician'
      }
    ]
  },
  {
    id: 4,
    level: 4,
    name: 'Technician',
    assignRoleTo: []
  }
]

constant.resourceTypes = [
  {
    id: 1,
    internalName: 'company',
    displayName: 'Company'
  },
  {
    id: 2,
    internalName: 'hierarchy',
    displayName: 'Organization Structure'
  },
  {
    id: 3,
    internalName: 'machine',
    displayName: 'Machine'
  },
  {
    id: 4,
    internalName: 'route',
    displayName: 'route'
  }
]

constant.userDefinedLimits = {
  overallVibration: {
    warning: 2.8,
    alert: 7.1
  },
  crestFactor: {
    warning: 4,
    alert: 7
  }
}

constant.statesOfMachine = [
  {
    id: 0,
    internalName: 'new',
    displayName: 'New'
  },
  {
    id: 1,
    internalName: 'configured',
    displayName: 'Configured'
  },
  {
    id: 2,
    internalName: 'monitoring',
    displayName: 'Monitoring'
  },
  {
    id: 3,
    internalName: 'unmonitored',
    displayName: 'Unmonitored'
  }
]
constant.dateFormats = {
  default: 'MMM dd, yyyy hh:mm a',
  licensesTableDateFormat: 'MMM dd, yyyy'
}

constant.sortBy = [
  {
    id: 1,
    internalName: 'name',
    displayName: 'Name'
  },
  {
    id: 2,
    internalName: 'createdOn',
    displayName: 'Created'
  }
]

constant.orderBy = [{
  id: 1,
  internalName: 1,
  displayName: 'Ascending'
},
{
  id: 2,
  internalName: -1,
  displayName: 'Descending'
}]

constant.sortByForUser = [
  {
    type: 'sort',
    internalName: 'firstName',
    displayName: 'Name'
  },
  {
    type: 'sort',
    internalName: 'created',
    displayName: 'Created'
  }
]

constant.defaultHierarchyLevels = [
  {
    level: 1,
    name: '(Plant)'
  },
  {
    level: 2,
    name: '(Plant/Area)'
  },
  {
    level: 3,
    name: '(Plant/Area/Section)'
  }
]

constant.learningModeInOptions = [
  {
    id: 1,
    name: 'Operating days'
  },
  {
    id: 2,
    name: 'Operating hours'
  },
  {
    id: 3,
    name: 'Operating minutes'
  }
]

constant.readingsByInterval = [
  {
    interval: 5,
    readings: 12
  },
  {
    interval: 6,
    readings: 10
  },
  {
    interval: 10,
    readings: 6
  },
  {
    interval: 12,
    readings: 5
  },
  {
    interval: 15,
    readings: 4
  },
  {
    interval: 20,
    readings: 3
  },
  {
    interval: 30,
    readings: 2
  },
  {
    interval: 60,
    readings: 1
  }
]

constant.availableReadingsInHour = [12, 10, 6, 5, 4, 3, 2, 1]
constant.toastrMessages = {
  exists: {
    machine: 'Machine name already exists.',
    user: 'Username already exists.'
  },
  notFound: {
    distributor: 'Distributors not found.',
    customer: 'Customers not found.',
    machine: 'Machines not found.'
  },
  success: {
    addMachine: 'Machine added.',
    updateMachine: 'Machine updated.',
    deleteMachine: 'Machine deleted.',
    saveOrgStructure: 'Organization Structure saved successfully',
    hierarchyStructure: 'Organization Structure cannot be changed later. Do you want to continue? ',
    addHierarchy: '{Hierarchy} created.',
    updateHierarchy: '{Hierarchy} updated.',
    deleteHierarchy: '{Hierarchy} deleted.',
    deleteHierarchyPopupMsg: 'The {level} {name} can not be deleted as it has one or more machines/users/routes/lower organizational units.',
    deleteLowestHierarchyPopupMsg: ' The {level} {name} can not be deleted as it has one or more machines/users/routes/lower organizational units.',
    deleteHierarchyPopup: 'Delete organizational unit?',
    addCustomer: 'Customer created.',
    updateCustomer: 'Customer updated.',
    activateCustomer: 'Customer activated.',
    deactivateCustomer: 'Customer deactivated.',
    addUser: 'User created.',
    updateUser: 'User updated. ',
    assignRole: 'Role assigned to the user.',
    removeRole: 'Role unassigned to the user.',
    activateUser: 'User activated.',
    deactivateUser: 'User deactivated.',
    refreshEventLogList: 'Machine log list refreshed.',
    resetPassword: 'Reset password link is sent to the registered email address.',
    changePassword: 'Password updated.',
    assignLicense: 'Licenses assigned.',
    addRoute: 'Route created.',
    updateRoute: 'Route updated.',
    deleteRoute: 'Route deleted.',
    addComposite: 'Composite machine added.',
    updateComposite: 'Composite machine updated.',
    deleteComposite: 'Composite machine deleted.',
    detachDevice: 'Device detached successfully.',
    /* new Messages */
    renewLicense: 'License renew successfully.',
    addDevice: 'Device addded successfully.',
    updateDevice: 'Device updated successfully.',
    deleteDevice: 'Device deleted successfully.',
    addDistributor: 'Distributor created.',
    updateDistributor: 'Distributor updated.',
    activateDistributor: 'Distributor activated.',
    deactivateDistributor: 'Distributor deactivated.',
    addAdminUser: 'Admin user added successfully.',
    updateUserSetting: 'User setting updated successfully.'
  },
  invalid: {
    superAdmin: 'You do not have enough privileges to proceed. Please contact your administrator.',
    access: 'You do not have enough privileges to proceed. Please contact your administrator.',
    /* new below this */
    reqiredRole: 'Please assign one role to user.',
    removeOnlyOneRoleValidationMsg: 'User must have minimum one role assigned. Please add another role to user and then remove current role.',
    removeEngineerRoleValidationMsg: 'Please remove assigned machines/routes of the user and then remove this role.'
  }
}

/* new constants */
constant.webAppTexts = {
  popupMessages: {
    deleteHierarchy: 'Are you sure you want to remove <strong> {name} </strong> from the organization structure?',
    deleteLowestHierarchyWithMachines: 'The {level} <strong> {name} </strong> can not be deleted as it has one or more machines configured in it. All configured machines under <strong> {name} </strong> need to be deleted first and then <strong> {name} </strong> can be deleted.',
    deleteHierarchyWithSubLevels: 'The {level} <strong> {name} </strong> can not be deleted as one or more active {unit}s avaliable in it. All active {unit}s under <strong> {name} </strong> need to be deleted first and then <strong> {name} </strong> can be deleted.',
    deleteHierarchyWithUsers: 'The {level} <strong> {name} </strong> can not be deleted as one or more users are avaliable in it. All users need to be removed first and then <strong> {name} </strong> can be deleted.',
    deleteHierarchyWithMachinesAndUsers: 'The {level} <strong> {name} </strong> can not be deleted as one or more machines and users are avaliable in it. All machines and users need to be removed first and then <strong> {name} </strong> can be deleted.',
    deleteHierarchyWithSubLevelsAndUsers: 'The {level} <strong> {name} </strong> can not be deleted as one or more {unit}s and users are avaliable in it. All {unit}s and users need to be removed first and then <strong> {name} </strong> can be deleted.',
    deleteComposite: 'Deleting <strong> {machine} </strong> will remove all machines from this composite machine. Are you sure you want to delete composite machine <strong> {machine} </strong>?',
    detachDevice: 'Are you sure you want to detach the device <strong> {name}</strong>?',
    deleteMachine: 'Are you sure you want to delete machine <strong> {machine} </strong>?',
    deleteMachineWithDevice: 'The machine <strong> {machine} </strong> can not be deleted as vibzer device is attached to it. Vibzer device need to remove first and then <strong> {machine} </strong> can be deleted.',
    deleteDevice: 'Are you sure you want to delete device with MAC ID <strong> {deviceMacId} </strong>?'
  },
  labels: {
    name: 'Name',
    firstName: 'First name',
    lastName: 'Last name',
    description: 'Description',
    owner: 'Owner',
    select: 'Select',
    level1: 'Display label for level 1',
    level2: 'Display label for level 2',
    level3: 'Display label for level 3',
    role: 'Role',
    organizationalUnit: 'Organizational Unit',
    details: 'Details',
    address: 'Address',
    users: 'Users',
    lineFrequency: 'Line frequency',
    analysisLanguage: 'Analysis report language',
    conditionAssessment: 'Condition Assessment',
    conditionMonitoring: 'Condition Monitoring',
    notApplicable: 'Not Applicable',
    machine: 'Machine',
    schedule: 'Schedule',
    frequency: 'Frequency',
    email: 'Email',
    sameAsCompanyAddress: 'Same as company address',
    addressLine1: 'Address line 1',
    addressLine2: 'Address line 2',
    addressLine3: 'Address line 3',
    city: 'City',
    state: 'State',
    country: 'Country',
    zipCode: 'ZIP code',
    phoneNo: 'Phone No.',
    phone: 'Phone',
    selectHierarchyLevel: 'Select level(s)',
    userDetails: 'User Details',
    selectTimezone: 'Select timezone',
    conditionAssessmentPoints: 'Condition Assessment (Handheld device)',
    enableConditionMonitoring: 'Enable condition monitoring (Fixed device)',
    generateWarningAndAlerts: 'Generate warning and alerts based on',
    selectReadingPoint: 'Select reading point(s)',
    managers: 'Manager(s)',
    faultyDevice: 'Faulty device',
    otherReason: 'Other reasons',
    comment: 'Comment',
    salesRep: 'Sales rep',
    for: 'For',
    customer: 'Customer',
    machineType: 'Machine type',
    machineOperationSchedule: 'Machine operation schedule',
    learningModeConfig: 'Learning mode configuration',
    minNoOfReading: 'Minimum no. of readings',
    in: 'In',
    operatingDays: 'Operating days',
    operatingHours: 'Operating hours',
    days: 'days',
    monitoringScheduleInNormal: 'Monitoring schedule in Normal condition',
    monitoringDays: 'Monitoring days',
    monitoringTime: 'Monitoring time',
    at: 'At',
    hours: 'hour(s)',
    minutes: 'minute(s)',
    selectAllHours: 'Select all hours',
    minutesDuringOperation: 'Minutes during operation hours',
    monitoringScheduleInWarning: 'Monitoring schedule in Warning condition',
    monitoringScheduleInAlert: 'Monitoring Schedule In Alert Condition',
    learningCount: 'Minimum no. of readings',
    minLearningDays: 'Minimum days',
    maxLearningDays: 'Maximum days',
    customerName: 'Customer name',
    licenseType: 'License type',
    license: 'License',
    quantity: 'Quantity',
    activationDate: 'Activation date',
    partNo: 'Part no.',
    selectDevices: 'Select devices',
    deviceType: 'Device type',
    deviceState: 'Device state',
    newActivationDate: 'New Activation Date',
    newExpiryDate: 'New Expiry Date',
    LicenseSummery: 'License Information',
    /* New */
    distributors: 'Distributors',
    deviceMacId: 'Mac ID',
    serialNumber: 'Serial Number',
    distributor: 'Distributor',
    reportError: 'Report Error',
    testReading: 'Test Reading',
    assignUser: 'Assign User',
    existingUser: 'Existing User',
    newUser: 'New User',
    selectUser: 'Select User',
    Days: 'Days',
    postFix: 'Postfix Text',
    duplicateMachineCount: 'Duplication Count',
    severityUnit: 'Severity Unit',
    fromMachine: 'From Machine',
    toMachine: 'To Machine',
    calibrationConstants: 'Calibration Constants',
    physicalConversionConstant: 'Physical Conversion Constant',
    ordinateToOrigin: 'Ordinate To Origin',
    rawToPhysicalDevidationFactor: 'Raw To Physical Deviation Factor'
  },
  placeholder: {
    enterFirstName: 'Enter first name',
    enterLastName: 'Enter last name',
    machineName: 'Enter machine name',
    description: 'Enter description',
    allMachinesDeletedFromRoute: 'All machines from this route has been deleted.',
    allMachinesDeletedFromComposite: 'All machines from this composite machine has been deleted.',
    machinesNotAvaliable: 'Machines not available',
    addMachinesInComposite: 'Add machines in composite machine',
    compositeMachineOwner: 'Select owner for composite machine',
    selectLevel: 'Select {level}',
    searchRoute: 'Enter route name',
    searchComposite: 'Enter composite machine name',
    level1: 'E.g. Plant, Factory',
    level2: 'E.g. Area, Product Line, Department',
    level3: 'E.g. Section, Floor',
    name: 'Enter name',
    lineFrequency: 'Select line frequency',
    analysisLanguage: 'Select analysis report language',
    otherFrequency: 'Enter line frequency',
    addressLine1: 'Enter address line 1',
    addressLine2: 'Enter address line 2',
    addressLine3: 'Enter address line 3',
    city: 'Enter city',
    state: 'Enter state',
    country: 'Enter country',
    zipCode: 'Enter ZIP code',
    phoneNo: 'Enter phone number',
    email: 'Enter email',
    machineType: 'Select machine type',
    routeUser: 'Assign users to route for analysis',
    NA: 'N/A',
    selectUser: 'Select user',
    selectOwnerForMachine: 'Select owner for machine',
    selectSalesRep: 'Select sales rep',
    searchCustomer: 'Search customer',
    selectOrder: 'Select order',
    selectSort: 'Select sort',
    selectOperatingDays: 'Select operating days',
    selectOperatingHours: 'Select operating hours',
    selectMonitoringDays: 'Select monitoring days',
    selectMonitoringTime: 'Select monitoring time',
    selectScheduleType: 'Select schedule type',
    searchAdmin: 'Search admin',
    emailAddress: 'Enter email address',
    /* new placeholders */
    learningCount: 'Enter learning reading count',
    minLearningDays: 'Enter days',
    maxLearningDays: 'Enter days',
    enterQuantity: 'Enter quantity',
    selectActivationDate: 'Select activation date',
    licenseType: 'Select license type',
    selectLicense: 'Select license',
    selectDeviceType: 'Select device type',
    selectDeviceState: 'Select device state',
    notAttached: '<<Not attached>>',
    unsold: '<<Unsold>>',
    comment: 'Please enter comment here',
    selectDistributor: 'Select Distributor',
    enterMacId: 'Enter device MAC ID',
    enterSerialNumber: 'Enter serial number',
    searchDistributor: 'Enter distributor name',
    selectFrequency: 'Select frequency',
    enter: 'Enter {frequencyType}',
    enterPostFix: 'Enter postfix text',
    duplicateMachineCount: 'Enter how many times machine duplicate',
    enterPhysicalConversionConstant: 'Enter physical conversion constant',
    enterOrdinateToOrigin: 'Enter ordinate to origin',
    enterRawToPhysicalDevidationFactor: 'Enter raw to physical deviation factor',
    selectPoint: 'Select Point'
  },
  errorMessages: {
    notificationTypeRequired: 'Please select at least single notification type for ',
    notificationFrequencyRequired: 'Please select at least single notification frequency for ',
    permanentNotificationTypeRequired: 'Please select at least single monitored notification type for ',
    machineNameRequired: 'Machine name is required',
    invalidMachineName: 'Please enter valid machine name',
    addMachineInComposite: 'Please add atleast single machine in composite machine',
    faliedToDelete: 'Failed to delete',
    selectOwner: 'Owner is required',
    name: 'Name is required',
    levelOneName: 'Level-1 Name is required',
    levelTwoName: 'Level-2 Name is required',
    levelThreeName: 'Level-3 Name is required',
    levelRequired: '{level} is required',
    timezoneRequired: 'Timezone is required',
    limitRequired: 'Limit is required',
    limitValueRequired: 'Please fill all limit fields. The limit values should be between 0 to 999',
    alertLimitRequired: 'Alert limit values should be greater than warning limit values.',
    assessmentPointRequired: 'Please select atleast single assessment point',
    machineTypeRequired: 'Machine type is required',
    dayRequired: 'Select at least one day',
    hourRequired: 'Select at least one hour',
    invalidName: 'Please enter valid name.',
    specialCharactersNotAllowed: 'Special characters like \ / : * ? " <> | and spaces, numbers are not allowed.',
    firstNameRequired: 'First name is required',
    lasttNameRequired: 'Last name is required',
    emailIdRequired: 'Email ID is required',
    enterValidEmailAddress: 'Please enter valid email address eg. jhon@due.com or jhon_123@due.co.uk',
    phoneNoRequired: 'Phone No. is required',
    phoneNoInvalid: 'Phone No. is invalid',
    /* New messages */
    deactiveCustomerAccount: 'Your customer account has been deactivated. Please activate it and try again.',
    validMinLearningDaysCount: 'Please enter valid count for minimum learning days.',
    validMaxLearningDaysCount: 'Please enter valid count for maximum learning days.',
    validLearningCount: 'Please enter valid count for learning readings.',
    requireMinLearningDaysCount: 'Minimum learning days is required.',
    requireMaxLearningDaysCount: 'Maximum learning days is required.',
    requireLearningCount: 'Learning reading count is required.',
    minimumMaxLearningDaysCount: 'Minimum count of max learning days should be greater than min learning days.',
    minimumLearningCount: 'Minimum count is 3.',
    licenseTypeRequired: 'License type is required',
    licenseRequired: 'License is required',
    quantityRequired: 'Quantity is required',
    minQuantity: 'Quantity should be one or more.',
    maxQuantity: 'Quantity should not be greater than 999.',
    activationDateRequired: 'Activation date is required',
    partNoRequired: 'Part no. is required',
    deviceRequired: 'Please select at-least single device',
    macIdRequired: 'Device MAC ID is required.',
    macIdPattern: 'Invalid MAC ID.',
    serialNumberRequired: 'Serial number is required.',
    serialNumberPattern: 'Invalid serial number pattern',
    addAdminUser: 'Fail to add admin user.',
    minReadingCountRequired: 'Minimum reading count is required',
    possibleReadingCount: 'Based on above operation schedule, device can take only {totalReadings} readings with {minutes} minutes interval in learning mode.',
    isRequired: ' is required',
    minFiveMinRequired: 'Minimum 5 minutes is required',
    notValidNumber: 'Please enter valid number',
    minReadingCount: 'Minimum reading count should be greater than 2',
    minLearningmodeTime: '{time} should be greater than 0',
    physicalConversionConstantRequired: 'Physical conversion constant is required',
    ordinateToOriginRequired: 'Ordinate to origin is required',
    rawToPhysicalDevidationFactorRequired: 'Raw to physical deviation factor is required'
  },
  tooltips: {
    addUser: 'Add user',
    editUser: 'Edit user',
    removeRole: 'Remove role',
    addRoute: 'Add route',
    editRoute: 'Edit route',
    deleteRoute: 'Delete route',
    addComposite: 'Add composite machine',
    viewRoute: 'Route details',
    viewComposite: 'Composite machine details',
    editComposite: 'Edit composite machine',
    deleteComposite: 'Delete composite machine',
    trends: 'Trends',
    sessions: 'Sessions',
    machineLogs: 'Machine logs',
    activateUser: 'Activate user',
    deActivateUser: 'Deactivate user',
    resetPassword: 'Reset password',
    viewReport: 'View report',
    wave: 'Wave',
    raw: 'Raw',
    spectrum: 'Spectrum',
    dateRestriction: 'Date restriction',
    addMachine: 'Add machine',
    clearFilter: 'Clear filter',
    hideFilter: 'Hide filter',
    filterMachines: 'Filter machines',
    addCustomer: 'Add customer',
    detachDevice: 'Detach device',
    removeLicense: 'Remove license',
    /* new */
    addDevice: 'Add Device',
    updateDevice: 'Edit Device',
    deleteDevice: 'Delete Device',
    addDistributor: 'Add Distributor'
  },
  notes: {
    addMachinesInComposite: 'Drag and drop machines to add machines in composite machine',
    loadingRoutes: 'Loading routes ...',
    loadingDevices: 'Loading devices...',
    loadingCustomers: 'Loading customers...',
    loadingUsers: 'Loading users...',
    loadingUserRoles: 'Loading user roles...',
    noCustomerFound: 'No customers found',
    noRouteFound: 'No route found ...!!!',
    loadingComposites: 'Loading composite machines ...',
    noCompositeFound: 'No composite machine found ...!!!',
    noUserFound: 'No user found',
    noRoleFound: 'No role found',
    noDeviceFound: 'No device found',
    noRoleAssigned: 'No role assigned',
    learningMode: 'Estimated duration of learning period: ',
    scheduleNotApplicable: 'Monitoring schedule NOT applicable.',
    machineDragMsg: 'Drag machine(s) from Available Machines list and drop in Assigned Machines list.',
    noMachineAvailable: 'No machine available',
    notAbleToChangeMachineInfo: 'Below information is used for machine analysis. You cannot change this information as machine has been already analyzed.',
    notAbleToChangeMachineInfoLater: 'Below information is used for machine analysis. You cannot change this information as machine has been already analyzed.',
    loadingMachines: 'Loading machines...',
    noMachineFound: 'No machine found . . .!!!',
    supportingCompressorTypes: 'We support only these types of compressor: Rotary Screw and Centrifugal',
    nearestTimeWillChosen: 'Note: Nearest operating time will be choosen if machine is not operating during that time.',
    disabledHoursAreNonOperatingHours: 'Note: Disabled hours are non operating hours based on operating schedule.',
    learningConfiguration: 'The machine will be in learning mode until minimum number of readings are taken for minimum number of days. The maximum days is cut off of time for both.',
    demoPurposeSetting: 'Below Settings are for demo purpose only.',
    defaultValuesOfLearningMode: 'The default values are actual values used by the system.',
    /* new */
    loadingDistributors: 'Loading distributors...',
    noDistributorFound: 'No distributors found . . .!!!',
    noTestReadingReport: 'Reports are not available for test reading.',
    failToGenerateReport: 'Report generation failed.',
    readingInterval: 'Reading interval',
    minutes: 'minutes',
    overallVibrationNote: 'Note: The overall vibration values are derived from available data and may differ with measured values.',
    noDataAvailable: 'No data available. Please click Recalculate to load graphs.',
    clickRecalculateToLoad: 'Please update calibration constants and click Recalculate to view updated graphs.'
  },
  breadcrumbs: {
    customersList: 'Customers',
    addComposite: 'Add Composite Machine',
    editComposite: 'Edit Composite Machine',
    compositeMachineList: 'Composite Machines',
    userList: 'Users',
    addUser: 'Add User',
    editUser: 'Edit User',
    routeList: 'Routes',
    addMachine: 'Add Machine',
    editMachine: 'Edit Machine',
    machineList: 'Machines',
    trends: 'Trends',
    sessions: 'Sessions',
    alerts: 'Alerts',
    deviceList: 'Devices',
    admins: 'Admins',
    addRoute: 'Add Route',
    editRoute: 'Edit Route',
    addLicenses: 'Add Licenses',
    /* new */
    distributorsList: 'Distributors',
    addDistributor: 'Add Distributor',
    editDistributor: 'Edit Distributor',
    regenerateReport: 'Regenerate Report'
  },
  headings: {
    basicInfo: 'Basic Information',
    personalInformation: 'Personal Information',
    machineInfo: 'Machine Information',
    technicalInfo: 'Technical Information',
    identification: 'Identification',
    monitoringSchedule: 'Monitoring Schedule',
    watchers: 'Watchers',
    compositeMachines: "Composite's Machines",
    avaliableMachines: 'Available Machines',
    assignedMachines: 'Assigned Machines',
    deleteComposite: 'Delete Composite Machine',
    organizationStructure: 'Organization Structure Setup',
    organizationName: 'Organization Name',
    unitName: 'Unit Name',
    roles: 'Roles',
    role: 'Role',
    personalInfo: 'Personal Information',
    createDemoCustomer: 'Create Demo Customer Account',
    detachDevice: 'Detach Device',
    deviceId: 'Device ID',
    type: 'Type',
    associatedMachine: 'Associated Machine',
    status: 'Status',
    point: 'Point',
    attachedDevice: 'Attached device',
    state: 'State',
    permissibleLimits: 'Permissible Limits',
    autoDerivedLimits: 'Automatically derived limits',
    userDefinedLimits: 'User defined limits',
    parameter: 'Parameter',
    normal: 'Normal',
    warning: 'Warning',
    alert: 'Alert',
    overallVibration: 'Overall Vibration (mm/s',
    crestFactor: 'Crest Factor',
    weeklyDigest: 'Weekly Digest',
    onConditionChange: 'On Condition Change',
    machineCondition: 'Machine Condition',
    notificationFrequency: 'Notification Frequency',
    userAndRole: 'User/Role',
    notificationReceivers: 'Notification receivers',
    filter: 'Filter',
    condition: 'Condition',
    unitTypes: 'Unit Types',
    unitType: 'Unit Type',
    monitoringState: 'Monitoring State',
    machineName: 'Machine Name',
    customerName: 'Customer Name',
    salesRep: 'Sales Rep',
    licenses: 'Licenses',
    created: 'Created',
    handheldDevices: 'Handheld Devices',
    analysisPacks: 'Analysis Packs',
    fixedDevices: 'Fixed Devices',
    subscriptionKits: 'Subscription Kits',
    addAdmin: 'Add Admin',
    /* New headings */
    select: 'Select',
    serialNo: 'Serial No.',
    macId: 'MAC-ID',
    addLicense: 'Add License',
    licenseType: 'License Type',
    licenseName: 'License Name',
    partNo: 'Part No.',
    activationDate: 'Activation Date',
    location: 'Location',
    customer: 'Customer',
    learningModeConfiguration: 'Machine Learning Configurations',
    renewLicense: 'Renew License',
    actions: 'Actions',
    distributor: 'Distributor',
    addDevice: 'Add Device',
    updateDevice: 'Edit Device',
    deleteDevice: 'Delete Device',
    distributorName: 'Distributor Name',
    reportSetting: 'Report',
    lastMeasurement: 'Last Measurement', 
    deviceCalibration: 'Device Calibration',
    calibrationConstants: 'Calibration Constants',
    readingPoint: 'Reading Point',
    spectrumChart: 'Spectrum Chart',
    waveChart: 'Wave Chart',
    graphView: 'Graph View',
    calibratedCharts: 'Calibrated Charts'
 
  },
  buttons: {
    save: 'Save',
    update: 'Update',
    cancel: 'Cancel',
    back: 'Back',
    confirm: 'Confirm',
    addRole: 'Add Role',
    createAndLogin: 'Create & Login',
    changePassword: 'Change Password',
    updateProfile: 'Update Profile',
    add: 'Add',
    ok: 'Ok',
    reset: 'Reset',
    recalculate: 'Recalculate',
    saveAndClose: 'Save Calibration Values & Close'
  },
  sidebarMenu: {
    loginAsCustomer: 'Login As Customer',
    loginAsDistributor: 'Login As SalesRep'
  },
  
  // }
}

constant.severityUnits = [{
  divideFactor: 1,
  displayName: 'mm/s',
  internalName: 'mmPerSec'
},
{
  divideFactor: 25.4,
  displayName: 'inch/s',
  internalName: 'inchPerSec'
}];
constant.calibrationAxes = [{ key: 'x', label: 'X Axis' }, { key: 'y', label: 'Y Axis' }, { key: 'z', label: 'Z Axis' }];
// module.exports = constant
//! api-check version 7.5.5 built with ♥ by Kent C. Dodds <kent@doddsfamily.us> (http://kent.doddsfamily.us) (ó ì_í)=óò=(ì_í ò)

(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define(factory);
	else if(typeof exports === 'object')
		exports["apiCheck"] = factory();
	else
		root["apiCheck"] = factory();
})(this, function() {
return /******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};

/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {

/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;

/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};

/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;

/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}


/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;

/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;

/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";

/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';

	Object.defineProperty(exports, '__esModule', {
	  value: true
	});

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

	var _apiCheck = __webpack_require__(1);

	var _apiCheck2 = _interopRequireDefault(_apiCheck);

	exports['default'] = _apiCheck2['default'];
	module.exports = exports['default'];

/***/ },
/* 1 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';

	var stringify = __webpack_require__(2);
	var apiCheckUtil = __webpack_require__(3);
	var each = apiCheckUtil.each;
	var isError = apiCheckUtil.isError;
	var t = apiCheckUtil.t;
	var arrayify = apiCheckUtil.arrayify;
	var getCheckerDisplay = apiCheckUtil.getCheckerDisplay;
	var typeOf = apiCheckUtil.typeOf;
	var getError = apiCheckUtil.getError;

	var checkers = __webpack_require__(4);
	var apiCheckApis = getApiCheckApis();

	module.exports = getApiCheckInstance;
	module.exports.VERSION = ("7.5.5");
	module.exports.utils = apiCheckUtil;
	module.exports.globalConfig = {
	  verbose: false,
	  disabled: false
	};

	var apiCheckApiCheck = getApiCheckInstance({
	  output: { prefix: 'apiCheck' }
	});
	module.exports.internalChecker = apiCheckApiCheck;

	each(checkers, function (checker, name) {
	  return module.exports[name] = checker;
	});

	function getApiCheckInstance() {   // eslint-disable-line
	  var config = arguments.length <= 0 || arguments[0] === undefined ? {} : arguments[0];
	  var extraCheckers = arguments.length <= 1 || arguments[1] === undefined ? {} : arguments[1];

	  /* eslint complexity:[2, 6] */
	  if (apiCheckApiCheck && arguments.length) {
	    apiCheckApiCheck['throw'](apiCheckApis.getApiCheckInstanceCheckers, arguments, {
	      prefix: 'creating an apiCheck instance'
	    });
	  }

	  var additionalProperties = {
	    'throw': getApiCheck(true),
	    warn: getApiCheck(false),
	    getErrorMessage: getErrorMessage,
	    handleErrorMessage: handleErrorMessage,
	    config: {
	      output: config.output || {
	        prefix: '',
	        suffix: '',
	        docsBaseUrl: ''
	      },
	      verbose: config.verbose || false,
	      disabled: config.disabled || false
	    },
	    utils: apiCheckUtil
	  };

	  each(additionalProperties, function (wrapper, name) {
	    return apiCheck[name] = wrapper;
	  });

	  var disabled = apiCheck.disabled || module.exports.globalConfig.disabled;
	  each(checkers.getCheckers(disabled), function (checker, name) {
	    return apiCheck[name] = checker;
	  });
	  each(extraCheckers, function (checker, name) {
	    return apiCheck[name] = checker;
	  });

	  return apiCheck;

	  /**
	   * This is the instance function. Other things are attached to this see additional properties above.
	   * @param {Array} api - the checkers to check with
	   * @param {Array} args - the args to check
	   * @param {Object} output - output options
	   * @returns {Object} - if this has a failed = true property, then it failed
	   */
	  function apiCheck(api, args, output) {
	    /* eslint complexity:[2, 8] */
	    if (apiCheck.config.disabled || module.exports.globalConfig.disabled) {
	      return {
	        apiTypes: {}, argTypes: {},
	        passed: true, message: '',
	        failed: false
	      }; // empty version of what is normally returned
	    }
	    checkApiCheckApi(arguments);
	    if (!Array.isArray(api)) {
	      api = [api];
	      args = [args];
	    } else {
	      // turn arguments into an array
	      args = Array.prototype.slice.call(args);
	    }
	    var messages = checkEnoughArgs(api, args);
	    if (!messages.length) {
	      // this is where we actually go perform the checks.
	      messages = checkApiWithArgs(api, args);
	    }

	    var returnObject = getTypes(api, args);
	    returnObject.args = args;
	    if (messages.length) {
	      returnObject.message = apiCheck.getErrorMessage(api, args, messages, output);
	      returnObject.failed = true;
	      returnObject.passed = false;
	    } else {
	      returnObject.message = '';
	      returnObject.failed = false;
	      returnObject.passed = true;
	    }
	    return returnObject;
	  }

	  /**
	   * checkApiCheckApi, should be read like: check apiCheck api. As in, check the api for apiCheck :-)
	   * @param {Array} checkApiArgs - args provided to apiCheck function
	   */
	  function checkApiCheckApi(checkApiArgs) {
	    var api = checkApiArgs[0];
	    var args = checkApiArgs[1];
	    var isArrayOrArgs = Array.isArray(args) || args && typeof args === 'object' && typeof args.length === 'number';

	    if (Array.isArray(api) && !isArrayOrArgs) {
	      throw new Error(getErrorMessage(api, [args], ['If an array is provided for the api, an array must be provided for the args as well.'], { prefix: 'apiCheck' }));
	    }
	    // dog fooding here
	    var errors = checkApiWithArgs(apiCheckApis.checkApiCheckApi, checkApiArgs);
	    if (errors.length) {
	      var message = apiCheck.getErrorMessage(apiCheckApis.checkApiCheckApi, checkApiArgs, errors, {
	        prefix: 'apiCheck'
	      });
	      apiCheck.handleErrorMessage(message, true);
	    }
	  }

	  function getApiCheck(shouldThrow) {
	    return function apiCheckWrapper(api, args, output) {
	      var result = apiCheck(api, args, output);
	      apiCheck.handleErrorMessage(result.message, shouldThrow);
	      return result; // wont get here if an error is thrown
	    };
	  }

	  function handleErrorMessage(message, shouldThrow) {
	    if (shouldThrow && message) {
	      throw new Error(message);
	    } else if (message) {
	      /* eslint no-console:0 */
	      console.warn(message);
	    }
	  }

	  function getErrorMessage(api, args) { // eslint-disable-line
	    var messages = arguments.length <= 2 || arguments[2] === undefined ? [] : arguments[2];
	    var output = arguments.length <= 3 || arguments[3] === undefined ? {} : arguments[3];

	    var gOut = apiCheck.config.output || {};
	    var prefix = getPrefix();
	    var suffix = getSuffix();
	    var url = getUrl();
	    var message = 'apiCheck failed! ' + messages.join(', ');
	    var passedAndShouldHavePassed = '\n\n' + buildMessageFromApiAndArgs(api, args);
	    return (prefix + ' ' + message + ' ' + suffix + ' ' + (url || '') + passedAndShouldHavePassed).trim();

	    function getPrefix() {
	      var p = output.onlyPrefix;
	      if (!p) {
	        p = ((gOut.prefix || '') + ' ' + (output.prefix || '')).trim();
	      }
	      return p;
	    }

	    function getSuffix() {
	      var s = output.onlySuffix;
	      if (!s) {
	        s = ((output.suffix || '') + ' ' + (gOut.suffix || '')).trim();
	      }
	      return s;
	    }

	    function getUrl() {
	      var u = output.url;
	      if (!u) {
	        u = gOut.docsBaseUrl && output.urlSuffix && ('' + gOut.docsBaseUrl + output.urlSuffix).trim();
	      }
	      return u;
	    }
	  }

	  function buildMessageFromApiAndArgs(api, args) {
	    var _getTypes = getTypes(api, args);

	    var apiTypes = _getTypes.apiTypes;
	    var argTypes = _getTypes.argTypes;

	    var copy = Array.prototype.slice.call(args || []);
	    var replacedItems = [];
	    replaceFunctionWithName(copy);
	    var passedArgs = getObjectString(copy);
	    argTypes = getObjectString(argTypes);
	    apiTypes = getObjectString(apiTypes);

	    return generateMessage();

	    // functions

	    function replaceFunctionWithName(obj) {
	      each(obj, function (val, name) {
	        /* eslint complexity:[2, 6] */
	        if (replacedItems.indexOf(val) === -1) {
	          // avoid recursive problems
	          replacedItems.push(val);
	          if (typeof val === 'object') {
	            replaceFunctionWithName(obj);
	          } else if (typeof val === 'function') {
	            obj[name] = val.displayName || val.name || 'anonymous function';
	          }
	        }
	      });
	    }

	    function getObjectString(types) {
	      if (!types || !types.length) {
	        return 'nothing';
	      } else if (types && types.length === 1) {
	        types = types[0];
	      }
	      return stringify(types, null, 2);
	    }

	    function generateMessage() {
	      var n = '\n';
	      var useS = true;
	      if (args && args.length === 1) {
	        if (typeof args[0] === 'object' && args[0] !== null) {
	          useS = !!Object.keys(args[0]).length;
	        } else {
	          useS = false;
	        }
	      }
	      var types = 'type' + (useS ? 's' : '');
	      var newLine = n + n;
	      return 'You passed:' + n + passedArgs + newLine + ('With the ' + types + ':' + n + argTypes + newLine) + ('The API calls for:' + n + apiTypes);
	    }
	  }

	  function getTypes(api, args) {
	    api = arrayify(api);
	    args = arrayify(args);
	    var apiTypes = api.map(function (checker, index) {
	      var specified = module.exports.globalConfig.hasOwnProperty('verbose');
	      return getCheckerDisplay(checker, {
	        terse: specified ? !module.exports.globalConfig.verbose : !apiCheck.config.verbose,
	        obj: args[index],
	        addHelpers: true
	      });
	    });
	    var argTypes = args.map(function (arg) {
	      return getArgDisplay(arg, []);
	    });
	    return { argTypes: argTypes, apiTypes: apiTypes };
	  }
	}

	// STATELESS FUNCTIONS

	/**
	 * This is where the magic happens for actually checking the arguments with the api.
	 * @param {Array} api - checkers
	 * @param  {Array} args - and arguments object
	 * @returns {Array} - the error messages
	 */
	function checkApiWithArgs(api, args) { // eslint-disable-line
	  /* eslint complexity:[2, 7] */
	  var messages = [];
	  var failed = false;
	  var checkerIndex = 0;
	  var argIndex = 0;
	  var arg = undefined,
	      checker = undefined,
	      res = undefined,
	      lastChecker = undefined,
	      argName = undefined,
	      argFailed = undefined,
	      skipPreviousChecker = undefined;
	  /* jshint -W084 */
	  while ((checker = api[checkerIndex++]) && argIndex < args.length) {
	    arg = args[argIndex++];
	    argName = 'Argument ' + argIndex + (checker.isOptional ? ' (optional)' : '');
	    res = checker(arg, 'value', argName);
	    argFailed = isError(res);
	    lastChecker = checkerIndex >= api.length;
	    skipPreviousChecker = checkerIndex > 1 && api[checkerIndex - 1].isOptional;
	    if (argFailed && lastChecker || argFailed && !lastChecker && !checker.isOptional && !skipPreviousChecker) {
	      failed = true;
	      messages.push(getCheckerErrorMessage(res, checker, arg));
	    } else if (argFailed && checker.isOptional) {
	      argIndex--;
	    } else {
	      messages.push(t(argName) + ' passed');
	    }
	  }
	  return failed ? messages : [];
	}

	checkerTypeType.type = 'function with __apiCheckData property and `${function.type}` property';
	function checkerTypeType(checkerType, name, location) {
	  var apiCheckDataChecker = checkers.shape({
	    type: checkers.string,
	    optional: checkers.bool
	  });
	  var asFunc = checkers.func.withProperties({ __apiCheckData: apiCheckDataChecker });
	  var asShape = checkers.shape({ __apiCheckData: apiCheckDataChecker });
	  var wrongShape = checkers.oneOfType([asFunc, asShape])(checkerType, name, location);
	  if (isError(wrongShape)) {
	    return wrongShape;
	  }
	  if (typeof checkerType !== 'function' && !checkerType.hasOwnProperty(checkerType.__apiCheckData.type)) {
	    return getError(name, location, checkerTypeType.type);
	  }
	}

	function getCheckerErrorMessage(res, checker, val) {
	  var checkerHelp = getCheckerHelp(checker, val);
	  checkerHelp = checkerHelp ? ' - ' + checkerHelp : '';
	  return res.message + checkerHelp;
	}

	function getCheckerHelp(_ref, val) {
	  var help = _ref.help;

	  if (!help) {
	    return '';
	  }
	  if (typeof help === 'function') {
	    help = help(val);
	  }
	  return help;
	}

	function checkEnoughArgs(api, args) {
	  var requiredArgs = api.filter(function (a) {
	    return !a.isOptional;
	  });
	  if (args.length < requiredArgs.length) {
	    return ['Not enough arguments specified. Requires `' + requiredArgs.length + '`, you passed `' + args.length + '`'];
	  } else {
	    return [];
	  }
	}

	function getArgDisplay(arg, gottenArgs) {
	  /* eslint complexity:[2, 7] */
	  var cName = arg && arg.constructor && arg.constructor.name;
	  var type = typeOf(arg);
	  if (type === 'function') {
	    if (hasKeys()) {
	      var properties = stringify(getDisplayIfNotGotten());
	      return cName + ' (with properties: ' + properties + ')';
	    }
	    return cName;
	  }

	  if (arg === null) {
	    return 'null';
	  }

	  if (type !== 'array' && type !== 'object') {
	    return type;
	  }

	  if (hasKeys()) {
	    return getDisplayIfNotGotten();
	  }

	  return cName;

	  // utility functions
	  function hasKeys() {
	    return arg && Object.keys(arg).length;
	  }

	  function getDisplayIfNotGotten() {
	    if (gottenArgs.indexOf(arg) !== -1) {
	      return '[Circular]';
	    }
	    gottenArgs.push(arg);
	    return getDisplay(arg, gottenArgs);
	  }
	}

	function getDisplay(obj, gottenArgs) {
	  var argDisplay = {};
	  each(obj, function (v, k) {
	    return argDisplay[k] = getArgDisplay(v, gottenArgs);
	  });
	  return argDisplay;
	}

	function getApiCheckApis() {
	  var os = checkers.string.optional;

	  var checkerFnChecker = checkers.func.withProperties({
	    type: checkers.oneOfType([checkers.string, checkerTypeType]).optional,
	    displayName: checkers.string.optional,
	    shortType: checkers.string.optional,
	    notOptional: checkers.bool.optional,
	    notRequired: checkers.bool.optional
	  });

	  var getApiCheckInstanceCheckers = [checkers.shape({
	    output: checkers.shape({
	      prefix: checkers.string.optional,
	      suffix: checkers.string.optional,
	      docsBaseUrl: checkers.string.optional
	    }).strict.optional,
	    verbose: checkers.bool.optional,
	    disabled: checkers.bool.optional
	  }).strict.optional, checkers.objectOf(checkerFnChecker).optional];

	  var checkApiCheckApi = [checkers.typeOrArrayOf(checkerFnChecker), checkers.any.optional, checkers.shape({
	    prefix: os, suffix: os, urlSuffix: os, // appended case
	    onlyPrefix: os, onlySuffix: os, url: os // override case
	  }).strict.optional];

	  return {
	    checkerFnChecker: checkerFnChecker,
	    getApiCheckInstanceCheckers: getApiCheckInstanceCheckers,
	    checkApiCheckApi: checkApiCheckApi
	  };
	}

/***/ },
/* 2 */
/***/ function(module, exports) {

	module.exports = stringify;

	function getSerialize (fn, decycle) {
	  var seen = [], keys = [];
	  decycle = decycle || function(key, value) {
	    return '[Circular ' + getPath(value, seen, keys) + ']'
	  };
	  return function(key, value) {
	    var ret = value;
	    if (typeof value === 'object' && value) {
	      if (seen.indexOf(value) !== -1)
	        ret = decycle(key, value);
	      else {
	        seen.push(value);
	        keys.push(key);
	      }
	    }
	    if (fn) ret = fn(key, ret);
	    return ret;
	  }
	}

	function getPath (value, seen, keys) {
	  var index = seen.indexOf(value);
	  var path = [ keys[index] ];
	  for (index--; index >= 0; index--) {
	    if (seen[index][ path[0] ] === value) {
	      value = seen[index];
	      path.unshift(keys[index]);
	    }
	  }
	  return '~' + path.join('.');
	}

	function stringify(obj, fn, spaces, decycle) {
	  return JSON.stringify(obj, getSerialize(fn, decycle), spaces);
	}

	stringify.getSerialize = getSerialize;


/***/ },
/* 3 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';

	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

	var stringify = __webpack_require__(2);
	var checkerHelpers = {
	  addOptional: addOptional, getRequiredVersion: getRequiredVersion, setupChecker: setupChecker, addNullable: addNullable
	};

	module.exports = {
	  each: each, copy: copy, typeOf: typeOf, arrayify: arrayify, getCheckerDisplay: getCheckerDisplay,
	  isError: isError, list: list, getError: getError, nAtL: nAtL, t: t, undef: undef, checkerHelpers: checkerHelpers,
	  noop: noop
	};

	function copy(obj) {
	  var type = typeOf(obj);
	  var daCopy = undefined;
	  if (type === 'array') {
	    daCopy = [];
	  } else if (type === 'object') {
	    daCopy = {};
	  } else {
	    return obj;
	  }
	  each(obj, function (val, key) {
	    daCopy[key] = val; // cannot single-line this because we don't want to abort the each
	  });
	  return daCopy;
	}

	function typeOf(obj) {
	  if (Array.isArray(obj)) {
	    return 'array';
	  } else if (obj instanceof RegExp) {
	    return 'object';
	  } else {
	    return typeof obj;
	  }
	}

	function getCheckerDisplay(checker, options) {
	  /* eslint complexity:[2, 7] */
	  var display = undefined;
	  var short = options && options.short;
	  if (short && checker.shortType) {
	    display = checker.shortType;
	  } else if (!short && typeof checker.type === 'object' || checker.type === 'function') {
	    display = getCheckerType(checker, options);
	  } else {
	    display = getCheckerType(checker, options) || checker.displayName || checker.name;
	  }
	  return display;
	}

	function getCheckerType(_ref, options) {
	  var type = _ref.type;

	  if (typeof type === 'function') {
	    var __apiCheckData = type.__apiCheckData;
	    var typeTypes = type(options);
	    type = _defineProperty({
	      __apiCheckData: __apiCheckData
	    }, __apiCheckData.type, typeTypes);
	  }
	  return type;
	}

	function arrayify(obj) {
	  if (!obj) {
	    return [];
	  } else if (Array.isArray(obj)) {
	    return obj;
	  } else {
	    return [obj];
	  }
	}

	function each(obj, iterator, context) {
	  if (Array.isArray(obj)) {
	    return eachArry(obj, iterator, context);
	  } else {
	    return eachObj(obj, iterator, context);
	  }
	}

	function eachObj(obj, iterator, context) {
	  var ret = undefined;
	  var hasOwn = Object.prototype.hasOwnProperty;
	  /* eslint prefer-const:0 */ // some weird eslint bug?
	  for (var key in obj) {
	    if (hasOwn.call(obj, key)) {
	      ret = iterator.call(context, obj[key], key, obj);
	      if (ret === false) {
	        return ret;
	      }
	    }
	  }
	  return true;
	}

	function eachArry(obj, iterator, context) {
	  var ret = undefined;
	  var length = obj.length;
	  for (var i = 0; i < length; i++) {
	    ret = iterator.call(context, obj[i], i, obj);
	    if (ret === false) {
	      return ret;
	    }
	  }
	  return true;
	}

	function isError(obj) {
	  return obj instanceof Error;
	}

	function list(arry, join, finalJoin) {
	  arry = arrayify(arry);
	  var copy = arry.slice();
	  var last = copy.pop();
	  if (copy.length === 1) {
	    join = ' ';
	  }
	  return copy.join(join) + ('' + (copy.length ? join + finalJoin : '') + last);
	}

	function getError(name, location, checkerType) {
	  if (typeof checkerType === 'function') {
	    checkerType = checkerType({ short: true });
	  }
	  var stringType = typeof checkerType !== 'object' ? checkerType : stringify(checkerType);
	  return new Error(nAtL(name, location) + ' must be ' + t(stringType));
	}

	function nAtL(name, location) {
	  var tName = t(name || 'value');
	  var tLocation = !location ? '' : ' at ' + t(location);
	  return '' + tName + tLocation;
	}

	function t(thing) {
	  return '`' + thing + '`';
	}

	function undef(thing) {
	  return typeof thing === 'undefined';
	}

	/**
	 * This will set up the checker with all of the defaults that most checkers want like required by default and an
	 * optional version
	 *
	 * @param {Function} checker - the checker to setup with properties
	 * @param {Object} properties - properties to add to the checker
	 * @param {boolean} disabled - when set to true, this will set the checker to a no-op function
	 * @returns {Function} checker - the setup checker
	 */
	function setupChecker(checker, properties, disabled) { // eslint-disable-line
	  /* eslint complexity:[2, 9] */
	  if (disabled) {
	    // swap out the checker for its own copy of noop
	    checker = getNoop();
	    checker.isNoop = true;
	  }

	  if (typeof checker.type === 'string') {
	    checker.shortType = checker.type;
	  }

	  // assign all properties given
	  each(properties, function (prop, name) {
	    return checker[name] = prop;
	  });

	  if (!checker.displayName) {
	    checker.displayName = 'apiCheck ' + t(checker.shortType || checker.type || checker.name) + ' type checker';
	  }

	  if (!checker.notRequired) {
	    checker = getRequiredVersion(checker, disabled);
	  }

	  if (!checker.notNullable) {
	    addNullable(checker, disabled);
	  }

	  if (!checker.notOptional) {
	    addOptional(checker, disabled);
	  }

	  return checker;
	}

	function getRequiredVersion(checker, disabled) {
	  var requiredChecker = disabled ? getNoop() : function requiredChecker(val, name, location, obj) {
	    if (undef(val) && !checker.isOptional) {
	      var tLocation = location ? ' in ' + t(location) : '';
	      var type = getCheckerDisplay(checker, { short: true });
	      var stringType = typeof type !== 'object' ? type : stringify(type);
	      return new Error('Required ' + t(name) + ' not specified' + tLocation + '. Must be ' + t(stringType));
	    } else {
	      return checker(val, name, location, obj);
	    }
	  };
	  copyProps(checker, requiredChecker);
	  requiredChecker.originalChecker = checker;
	  return requiredChecker;
	}

	function addOptional(checker, disabled) {
	  var optionalCheck = disabled ? getNoop() : function optionalCheck(val, name, location, obj) {
	    if (!undef(val)) {
	      return checker(val, name, location, obj);
	    }
	  };
	  // inherit all properties on the original checker
	  copyProps(checker, optionalCheck);

	  optionalCheck.isOptional = true;
	  optionalCheck.displayName = checker.displayName + ' (optional)';
	  optionalCheck.originalChecker = checker;

	  // the magic line that allows you to add .optional to the end of the checkers
	  checker.optional = optionalCheck;

	  fixType(checker, checker.optional);
	}

	function addNullable(checker, disabled) {
	  var nullableCheck = disabled ? getNoop() : function nullableCheck(val, name, location, obj) {
	    if (val !== null) {
	      return checker(val, name, location, obj);
	    }
	  };
	  // inherit all properties on the original checker
	  copyProps(checker, nullableCheck);

	  nullableCheck.isNullable = true;
	  nullableCheck.displayName = checker.displayName + ' (nullable)';
	  nullableCheck.originalChecker = checker;

	  // the magic line that allows you to add .nullable to the end of the checkers
	  checker.nullable = nullableCheck;

	  fixType(checker, checker.nullable);
	  if (!checker.notOptional) {
	    addOptional(checker.nullable, disabled);
	  }
	}

	function fixType(checker, checkerCopy) {
	  // fix type, because it's not a straight copy...
	  // the reason is we need to specify type.__apiCheckData.optional as true for the terse/verbose option.
	  // we also want to add "(optional)" to the types with a string
	  if (typeof checkerCopy.type === 'object') {
	    checkerCopy.type = copy(checkerCopy.type); // make our own copy of this
	  } else if (typeof checkerCopy.type === 'function') {
	      checkerCopy.type = function () {
	        return checker.type.apply(checker, arguments);
	      };
	    } else {
	      checkerCopy.type += ' (optional)';
	      return;
	    }
	  checkerCopy.type.__apiCheckData = copy(checker.type.__apiCheckData) || {}; // and this
	  checkerCopy.type.__apiCheckData.optional = true;
	}

	// UTILS

	function copyProps(src, dest) {
	  each(Object.keys(src), function (key) {
	    return dest[key] = src[key];
	  });
	}

	function noop() {}

	function getNoop() {
	  /* eslint no-shadow:0 */
	  /* istanbul ignore next */
	  return function noop() {};
	}

/***/ },
/* 4 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';

	var stringify = __webpack_require__(2);

	var _require = __webpack_require__(3);

	var typeOf = _require.typeOf;
	var each = _require.each;
	var copy = _require.copy;
	var getCheckerDisplay = _require.getCheckerDisplay;
	var isError = _require.isError;
	var arrayify = _require.arrayify;
	var list = _require.list;
	var getError = _require.getError;
	var nAtL = _require.nAtL;
	var t = _require.t;
	var checkerHelpers = _require.checkerHelpers;
	var undef = _require.undef;
	var setupChecker = checkerHelpers.setupChecker;

	var checkers = module.exports = getCheckers();
	module.exports.getCheckers = getCheckers;

	function getCheckers(disabled) {
	  return {
	    array: typeOfCheckGetter('Array'),
	    bool: typeOfCheckGetter('Boolean'),
	    number: typeOfCheckGetter('Number'),
	    string: typeOfCheckGetter('String'),
	    func: funcCheckGetter(),
	    object: objectCheckGetter(),

	    emptyObject: emptyObjectCheckGetter(),

	    instanceOf: instanceCheckGetter,
	    oneOf: oneOfCheckGetter,
	    oneOfType: oneOfTypeCheckGetter,

	    arrayOf: arrayOfCheckGetter,
	    objectOf: objectOfCheckGetter,
	    typeOrArrayOf: typeOrArrayOfCheckGetter,

	    range: rangeCheckGetter,
	    lessThan: lessThanCheckGetter,
	    greaterThan: greaterThanCheckGetter,

	    shape: getShapeCheckGetter(),
	    args: argumentsCheckerGetter(),

	    any: anyCheckGetter(),
	    'null': nullCheckGetter()

	  };

	  function typeOfCheckGetter(type) {
	    var lType = type.toLowerCase();
	    return setupChecker(function typeOfCheckerDefinition(val, name, location) {
	      if (typeOf(val) !== lType) {
	        return getError(name, location, type);
	      }
	    }, { type: type }, disabled);
	  }

	  function funcCheckGetter() {
	    var type = 'Function';
	    var functionChecker = setupChecker(function functionCheckerDefinition(val, name, location) {
	      if (typeOf(val) !== 'function') {
	        return getError(name, location, type);
	      }
	    }, { type: type }, disabled);

	    functionChecker.withProperties = function getWithPropertiesChecker(properties) {
	      var apiError = checkers.objectOf(checkers.func)(properties, 'properties', 'apiCheck.func.withProperties');
	      if (isError(apiError)) {
	        throw apiError;
	      }
	      var shapeChecker = checkers.shape(properties, true);
	      shapeChecker.type.__apiCheckData.type = 'func.withProperties';

	      return setupChecker(function functionWithPropertiesChecker(val, name, location) {
	        var notFunction = checkers.func(val, name, location);
	        if (isError(notFunction)) {
	          return notFunction;
	        }
	        return shapeChecker(val, name, location);
	      }, { type: shapeChecker.type, shortType: 'func.withProperties' }, disabled);
	    };
	    return functionChecker;
	  }

	  function objectCheckGetter() {
	    var type = 'Object';
	    var nullType = 'Object (null ok)';
	    var objectNullOkChecker = setupChecker(function objectNullOkCheckerDefinition(val, name, location) {
	      if (typeOf(val) !== 'object') {
	        return getError(name, location, nullType);
	      }
	    }, { type: nullType }, disabled);

	    var objectChecker = setupChecker(function objectCheckerDefinition(val, name, location) {
	      if (val === null || isError(objectNullOkChecker(val, name, location))) {
	        return getError(name, location, objectChecker.type);
	      }
	    }, { type: type, nullOk: objectNullOkChecker }, disabled);

	    return objectChecker;
	  }

	  function instanceCheckGetter(classToCheck) {
	    return setupChecker(function instanceCheckerDefinition(val, name, location) {
	      if (!(val instanceof classToCheck)) {
	        return getError(name, location, classToCheck.name);
	      }
	    }, { type: classToCheck.name }, disabled);
	  }

	  function oneOfCheckGetter(enums) {
	    var type = {
	      __apiCheckData: { optional: false, type: 'enum' },
	      'enum': enums
	    };
	    var shortType = 'oneOf[' + enums.map(function (enm) {
	      return stringify(enm);
	    }).join(', ') + ']';
	    return setupChecker(function oneOfCheckerDefinition(val, name, location) {
	      if (!enums.some(function (enm) {
	        return enm === val;
	      })) {
	        return getError(name, location, shortType);
	      }
	    }, { type: type, shortType: shortType }, disabled);
	  }

	  function oneOfTypeCheckGetter(typeCheckers) {
	    var checkersDisplay = typeCheckers.map(function (checker) {
	      return getCheckerDisplay(checker, { short: true });
	    });
	    var shortType = 'oneOfType[' + checkersDisplay.join(', ') + ']';
	    function type(options) {
	      if (options && options.short) {
	        return shortType;
	      }
	      return typeCheckers.map(function (checker) {
	        return getCheckerDisplay(checker, options);
	      });
	    }
	    type.__apiCheckData = { optional: false, type: 'oneOfType' };
	    return setupChecker(function oneOfTypeCheckerDefinition(val, name, location) {
	      if (!typeCheckers.some(function (checker) {
	        return !isError(checker(val, name, location));
	      })) {
	        return getError(name, location, shortType);
	      }
	    }, { type: type, shortType: shortType }, disabled);
	  }

	  function arrayOfCheckGetter(checker) {
	    var shortCheckerDisplay = getCheckerDisplay(checker, { short: true });
	    var shortType = 'arrayOf[' + shortCheckerDisplay + ']';

	    function type(options) {
	      if (options && options.short) {
	        return shortType;
	      }
	      return getCheckerDisplay(checker, options);
	    }
	    type.__apiCheckData = { optional: false, type: 'arrayOf' };

	    return setupChecker(function arrayOfCheckerDefinition(val, name, location) {
	      if (isError(checkers.array(val)) || !val.every(function (item) {
	        return !isError(checker(item));
	      })) {
	        return getError(name, location, shortType);
	      }
	    }, { type: type, shortType: shortType }, disabled);
	  }

	  function objectOfCheckGetter(checker) {
	    var checkerDisplay = getCheckerDisplay(checker, { short: true });
	    var shortType = 'objectOf[' + checkerDisplay + ']';

	    function type(options) {
	      if (options && options.short) {
	        return shortType;
	      }
	      return getCheckerDisplay(checker, options);
	    }
	    type.__apiCheckData = { optional: false, type: 'objectOf' };

	    return setupChecker(function objectOfCheckerDefinition(val, name, location) {
	      var notObject = checkers.object(val, name, location);
	      if (isError(notObject)) {
	        return notObject;
	      }
	      var allTypesSuccess = each(val, function (item, key) {
	        if (isError(checker(item, key, name))) {
	          return false;
	        }
	      });
	      if (!allTypesSuccess) {
	        return getError(name, location, shortType);
	      }
	    }, { type: type, shortType: shortType }, disabled);
	  }

	  function typeOrArrayOfCheckGetter(checker) {
	    var checkerDisplay = getCheckerDisplay(checker, { short: true });
	    var shortType = 'typeOrArrayOf[' + checkerDisplay + ']';

	    function type(options) {
	      if (options && options.short) {
	        return shortType;
	      }
	      return getCheckerDisplay(checker, options);
	    }

	    type.__apiCheckData = { optional: false, type: 'typeOrArrayOf' };
	    return setupChecker(function typeOrArrayOfDefinition(val, name, location, obj) {
	      if (isError(checkers.oneOfType([checker, checkers.arrayOf(checker)])(val, name, location, obj))) {
	        return getError(name, location, shortType);
	      }
	    }, { type: type, shortType: shortType }, disabled);
	  }

	  function getShapeCheckGetter() {
	    function shapeCheckGetter(shape, nonObject) {
	      var shapeTypes = {};
	      each(shape, function (checker, prop) {
	        shapeTypes[prop] = getCheckerDisplay(checker);
	      });
	      function type() {
	        var options = arguments.length <= 0 || arguments[0] === undefined ? {} : arguments[0];

	        var ret = {};
	        var terse = options.terse;
	        var obj = options.obj;
	        var addHelpers = options.addHelpers;

	        var parentRequired = options.required;
	        each(shape, function (checker, prop) {
	          /* eslint complexity:[2, 6] */
	          var specified = obj && obj.hasOwnProperty(prop);
	          var required = undef(parentRequired) ? !checker.isOptional : parentRequired;
	          if (!terse || (specified || !checker.isOptional)) {
	            ret[prop] = getCheckerDisplay(checker, { terse: terse, obj: obj && obj[prop], required: required, addHelpers: addHelpers });
	          }
	          if (addHelpers) {
	            modifyTypeDisplayToHelpOut(ret, prop, specified, checker, required);
	          }
	        });
	        return ret;

	        function modifyTypeDisplayToHelpOut(theRet, prop, specified, checker, required) {
	          if (!specified && required && !checker.isOptional) {
	            var item = 'ITEM';
	            if (checker.type && checker.type.__apiCheckData) {
	              item = checker.type.__apiCheckData.type.toUpperCase();
	            }
	            addHelper('missing', 'MISSING THIS ' + item, ' <-- YOU ARE MISSING THIS');
	          } else if (specified) {
	            var error = checker(obj[prop], prop, null, obj);
	            if (isError(error)) {
	              addHelper('error', 'THIS IS THE PROBLEM: ' + error.message, ' <-- THIS IS THE PROBLEM: ' + error.message);
	            }
	          }

	          function addHelper(property, objectMessage, stringMessage) {
	            if (typeof theRet[prop] === 'string') {
	              theRet[prop] += stringMessage;
	            } else {
	              theRet[prop].__apiCheckData[property] = objectMessage;
	            }
	          }
	        }
	      }

	      type.__apiCheckData = { strict: false, optional: false, type: 'shape' };
	      var shapeChecker = setupChecker(function shapeCheckerDefinition(val, name, location) {
	        /* eslint complexity:[2, 6] */
	        var isObject = !nonObject && checkers.object(val, name, location);
	        if (isError(isObject)) {
	          return isObject;
	        }
	        var shapePropError = undefined;
	        location = location ? location + (name ? '/' : '') : '';
	        name = name || '';
	        each(shape, function (checker, prop) {
	          if (val.hasOwnProperty(prop) || !checker.isOptional) {
	            shapePropError = checker(val[prop], prop, '' + location + name, val);
	            return !isError(shapePropError);
	          }
	        });
	        if (isError(shapePropError)) {
	          return shapePropError;
	        }
	      }, { type: type, shortType: 'shape' }, disabled);

	      function strictType() {
	        return type.apply(undefined, arguments);
	      }

	      strictType.__apiCheckData = copy(shapeChecker.type.__apiCheckData);
	      strictType.__apiCheckData.strict = true;
	      shapeChecker.strict = setupChecker(function strictShapeCheckerDefinition(val, name, location) {
	        var shapeError = shapeChecker(val, name, location);
	        if (isError(shapeError)) {
	          return shapeError;
	        }
	        var allowedProperties = Object.keys(shape);
	        var extraProps = Object.keys(val).filter(function (prop) {
	          return allowedProperties.indexOf(prop) === -1;
	        });
	        if (extraProps.length) {
	          return new Error(nAtL(name, location) + ' cannot have extra properties: ' + t(extraProps.join('`, `')) + '.' + ('It is limited to ' + t(allowedProperties.join('`, `'))));
	        }
	      }, { type: strictType, shortType: 'strict shape' }, disabled);

	      return shapeChecker;
	    }

	    shapeCheckGetter.ifNot = function ifNot(otherProps, propChecker) {
	      if (!Array.isArray(otherProps)) {
	        otherProps = [otherProps];
	      }
	      var description = undefined;
	      if (otherProps.length === 1) {
	        description = 'specified only if ' + otherProps[0] + ' is not specified';
	      } else {
	        description = 'specified only if none of the following are specified: [' + list(otherProps, ', ', 'and ') + ']';
	      }
	      var shortType = 'ifNot[' + otherProps.join(', ') + ']';
	      var type = getTypeForShapeChild(propChecker, description, shortType);
	      return setupChecker(function ifNotChecker(prop, propName, location, obj) {
	        var propExists = obj && obj.hasOwnProperty(propName);
	        var otherPropsExist = otherProps.some(function (otherProp) {
	          return obj && obj.hasOwnProperty(otherProp);
	        });
	        if (propExists === otherPropsExist) {
	          return getError(propName, location, type);
	        } else if (propExists) {
	          return propChecker(prop, propName, location, obj);
	        }
	      }, { notRequired: true, type: type, shortType: shortType }, disabled);
	    };

	    shapeCheckGetter.onlyIf = function onlyIf(otherProps, propChecker) {
	      otherProps = arrayify(otherProps);
	      var description = undefined;
	      if (otherProps.length === 1) {
	        description = 'specified only if ' + otherProps[0] + ' is also specified';
	      } else {
	        description = 'specified only if all of the following are specified: [' + list(otherProps, ', ', 'and ') + ']';
	      }
	      var shortType = 'onlyIf[' + otherProps.join(', ') + ']';
	      var type = getTypeForShapeChild(propChecker, description, shortType);
	      return setupChecker(function onlyIfCheckerDefinition(prop, propName, location, obj) {
	        var othersPresent = otherProps.every(function (property) {
	          return obj.hasOwnProperty(property);
	        });
	        if (!othersPresent) {
	          return getError(propName, location, type);
	        } else {
	          return propChecker(prop, propName, location, obj);
	        }
	      }, { type: type, shortType: shortType }, disabled);
	    };

	    shapeCheckGetter.requiredIfNot = function shapeRequiredIfNot(otherProps, propChecker) {
	      if (!Array.isArray(otherProps)) {
	        otherProps = [otherProps];
	      }
	      return getRequiredIfNotChecker(false, otherProps, propChecker);
	    };

	    shapeCheckGetter.requiredIfNot.all = function shapeRequiredIfNotAll(otherProps, propChecker) {
	      if (!Array.isArray(otherProps)) {
	        throw new Error('requiredIfNot.all must be passed an array');
	      }
	      return getRequiredIfNotChecker(true, otherProps, propChecker);
	    };

	    function getRequiredIfNotChecker(all, otherProps, propChecker) {
	      var props = t(otherProps.join(', '));
	      var ifProps = 'if ' + (all ? 'all of' : 'at least one of');
	      var description = 'specified ' + ifProps + ' these are not specified: ' + props + ' (otherwise it\'s optional)';
	      var shortType = 'requiredIfNot' + (all ? '.all' : '') + '[' + otherProps.join(', ') + '}]';
	      var type = getTypeForShapeChild(propChecker, description, shortType);
	      return setupChecker(function shapeRequiredIfNotDefinition(prop, propName, location, obj) {
	        var propExists = obj && obj.hasOwnProperty(propName);
	        var iteration = all ? 'every' : 'some';
	        var otherPropsExist = otherProps[iteration](function (otherProp) {
	          return obj && obj.hasOwnProperty(otherProp);
	        });
	        if (!otherPropsExist && !propExists) {
	          return getError(propName, location, type);
	        } else if (propExists) {
	          return propChecker(prop, propName, location, obj);
	        }
	      }, { type: type, notRequired: true }, disabled);
	    }

	    return shapeCheckGetter;

	    function getTypeForShapeChild(propChecker, description, shortType) {
	      function type(options) {
	        if (options && options.short) {
	          return shortType;
	        }
	        return getCheckerDisplay(propChecker);
	      }
	      type.__apiCheckData = { optional: false, type: 'ifNot', description: description };
	      return type;
	    }
	  }

	  function argumentsCheckerGetter() {
	    var type = 'function arguments';
	    return setupChecker(function argsCheckerDefinition(val, name, location) {
	      if (Array.isArray(val) || isError(checkers.object(val)) || isError(checkers.number(val.length))) {
	        return getError(name, location, type);
	      }
	    }, { type: type }, disabled);
	  }

	  function anyCheckGetter() {
	    return setupChecker(function anyCheckerDefinition() {
	      // don't do anything
	    }, { type: 'any' }, disabled);
	  }

	  function nullCheckGetter() {
	    var type = 'null';
	    return setupChecker(function nullChecker(val, name, location) {
	      if (val !== null) {
	        return getError(name, location, type);
	      }
	    }, { type: type }, disabled);
	  }

	  function rangeCheckGetter(min, max) {
	    var type = 'Range (' + min + ' - ' + max + ')';
	    return setupChecker(function rangeChecker(val, name, location) {
	      if (typeof val !== 'number' || val < min || val > max) {
	        return getError(name, location, type);
	      }
	    }, { type: type }, disabled);
	  }

	  function lessThanCheckGetter(min) {
	    var type = 'lessThan[' + min + ']';
	    return setupChecker(function lessThanChecker(val, name, location) {
	      if (typeof val !== 'number' || val > min) {
	        return getError(name, location, type);
	      }
	    }, { type: type }, disabled);
	  }

	  function greaterThanCheckGetter(max) {
	    var type = 'greaterThan[' + max + ']';
	    return setupChecker(function greaterThanChecker(val, name, location) {
	      if (typeof val !== 'number' || val < max) {
	        return getError(name, location, type);
	      }
	    }, { type: type }, disabled);
	  }

	  function emptyObjectCheckGetter() {
	    var type = 'empty object';
	    return setupChecker(function emptyObjectChecker(val, name, location) {
	      if (typeOf(val) !== 'object' || val === null || Object.keys(val).length) {
	        return getError(name, location, type);
	      }
	    }, { type: type }, disabled);
	  }
	}

/***/ }
/******/ ])
});
;
/*!
* angular-formly JavaScript Library v8.4.1
*
* @license MIT (http://license.angular-formly.com)
*
* built with ♥ by Astrism <astrisms@gmail.com>, Kent C. Dodds <kent@doddsfamily.us>
* (ó ì_í)=óò=(ì_í ò)
*/
(function webpackUniversalModuleDefinition(root, factory) {
	if (typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("angular"), require("api-check"));
	else if (typeof define === 'function' && define.amd)
		define(["angular", "api-check"], factory);
	else if (typeof exports === 'object')
		exports["ngFormly"] = factory(require("angular"), require("api-check"));
	else
		root["ngFormly"] = factory(root["angular"], root["apiCheck"]);
})(this, function (__WEBPACK_EXTERNAL_MODULE_3__, __WEBPACK_EXTERNAL_MODULE_5__) {
	return /******/ (function (modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};

/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {

/******/ 		// Check if module is in cache
/******/ 		if (installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;

/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
				/******/
};

/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;

/******/ 		// Return the exports of the module
/******/ 		return module.exports;
			/******/
}


/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;

/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;

/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";

/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
		/******/
})
/************************************************************************/
/******/([
/* 0 */
/***/ function (module, exports, __webpack_require__) {

				'use strict';

				Object.defineProperty(exports, '__esModule', {
					value: true
				});

				function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

				var _indexCommon = __webpack_require__(1);

				var _indexCommon2 = _interopRequireDefault(_indexCommon);

				exports['default'] = _indexCommon2['default'];
				module.exports = exports['default'];

				/***/
},
/* 1 */
/***/ function (module, exports, __webpack_require__) {   // eslint-disable-line

				'use strict';

				Object.defineProperty(exports, '__esModule', {
					value: true
				});

				function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

				var _angularFix = __webpack_require__(2);

				var _angularFix2 = _interopRequireDefault(_angularFix);

				var _providersFormlyApiCheck = __webpack_require__(4);

				var _providersFormlyApiCheck2 = _interopRequireDefault(_providersFormlyApiCheck);

				var _otherDocsBaseUrl = __webpack_require__(6);

				var _otherDocsBaseUrl2 = _interopRequireDefault(_otherDocsBaseUrl);

				var _providersFormlyUsability = __webpack_require__(7);

				var _providersFormlyUsability2 = _interopRequireDefault(_providersFormlyUsability);

				var _providersFormlyConfig = __webpack_require__(8);

				var _providersFormlyConfig2 = _interopRequireDefault(_providersFormlyConfig);

				var _providersFormlyValidationMessages = __webpack_require__(10);

				var _providersFormlyValidationMessages2 = _interopRequireDefault(_providersFormlyValidationMessages);

				var _servicesFormlyUtil = __webpack_require__(11);

				var _servicesFormlyUtil2 = _interopRequireDefault(_servicesFormlyUtil);

				var _servicesFormlyWarn = __webpack_require__(12);

				var _servicesFormlyWarn2 = _interopRequireDefault(_servicesFormlyWarn);

				var _directivesFormlyCustomValidation = __webpack_require__(13);

				var _directivesFormlyCustomValidation2 = _interopRequireDefault(_directivesFormlyCustomValidation);

				var _directivesFormlyField = __webpack_require__(14);

				var _directivesFormlyField2 = _interopRequireDefault(_directivesFormlyField);

				var _directivesFormlyFocus = __webpack_require__(15);

				var _directivesFormlyFocus2 = _interopRequireDefault(_directivesFormlyFocus);

				var _directivesFormlyForm = __webpack_require__(16);

				var _directivesFormlyForm2 = _interopRequireDefault(_directivesFormlyForm);

				var _directivesFormlyFormController = __webpack_require__(17);

				var _directivesFormlyFormController2 = _interopRequireDefault(_directivesFormlyFormController);

				var _runFormlyNgModelAttrsManipulator = __webpack_require__(18);

				var _runFormlyNgModelAttrsManipulator2 = _interopRequireDefault(_runFormlyNgModelAttrsManipulator);

				var _runFormlyCustomTags = __webpack_require__(19);

				var _runFormlyCustomTags2 = _interopRequireDefault(_runFormlyCustomTags);

				var ngModuleName = 'formly';

				exports['default'] = ngModuleName;

				var ngModule = _angularFix2['default'].module(ngModuleName, []);

				ngModule.constant('formlyApiCheck', _providersFormlyApiCheck2['default']);
				ngModule.constant('formlyErrorAndWarningsUrlPrefix', _otherDocsBaseUrl2['default']);
				ngModule.constant('formlyVersion', ("8.4.1")); // <-- webpack variable

				ngModule.provider('formlyUsability', _providersFormlyUsability2['default']);
				ngModule.provider('formlyConfig', _providersFormlyConfig2['default']);

				ngModule.factory('formlyValidationMessages', _providersFormlyValidationMessages2['default']);
				ngModule.factory('formlyUtil', _servicesFormlyUtil2['default']);
				ngModule.factory('formlyWarn', _servicesFormlyWarn2['default']);

				ngModule.directive('formlyCustomValidation', _directivesFormlyCustomValidation2['default']);
				ngModule.directive('formlyField', _directivesFormlyField2['default']);
				ngModule.directive('formlyFocus', _directivesFormlyFocus2['default']);
				ngModule.directive('formlyForm', _directivesFormlyForm2['default']);
				ngModule.controller('FormlyFormController', _directivesFormlyFormController2['default']);

				ngModule.run(_runFormlyNgModelAttrsManipulator2['default']);
				ngModule.run(_runFormlyCustomTags2['default']);
				module.exports = exports['default'];

				/***/
},
/* 2 */
/***/ function (module, exports, __webpack_require__) {

				// some versions of angular don't export the angular module properly,
				// so we get it from window in this case.
				'use strict';

				Object.defineProperty(exports, '__esModule', {
					value: true
				});
				var angular = __webpack_require__(3);

				/* istanbul ignore next */
				if (!angular.version) {
					angular = window.angular;
				}
				exports['default'] = angular;
				module.exports = exports['default'];

				/***/
},
/* 3 */
/***/ function (module, exports) {

				module.exports = __WEBPACK_EXTERNAL_MODULE_3__;

				/***/
},
/* 4 */
/***/ function (module, exports, __webpack_require__) {

				'use strict';

				Object.defineProperty(exports, '__esModule', {
					value: true
				});

				function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

				var _angularFix = __webpack_require__(2);

				var _angularFix2 = _interopRequireDefault(_angularFix);

				var _apiCheck = __webpack_require__(5);

				var _apiCheck2 = _interopRequireDefault(_apiCheck);

				var apiCheck = (0, _apiCheck2['default'])({
					output: {
						prefix: 'angular-formly:',
						docsBaseUrl: __webpack_require__(6)
					}
				});

				function shapeRequiredIfNot(otherProps, propChecker) {
					if (!_angularFix2['default'].isArray(otherProps)) {
						otherProps = [otherProps];
					}
					var type = 'specified if these are not specified: `' + otherProps.join(', ') + '` (otherwise it\'s optional)';

					function shapeRequiredIfNotDefinition(prop, propName, location, obj) {
						var propExists = obj && obj.hasOwnProperty(propName);
						var otherPropsExist = otherProps.some(function (otherProp) {
							return obj && obj.hasOwnProperty(otherProp);
						});
						if (!otherPropsExist && !propExists) {
							return apiCheck.utils.getError(propName, location, type);
						} else if (propExists) {
							return propChecker(prop, propName, location, obj);
						}
					}

					shapeRequiredIfNotDefinition.type = type;
					return apiCheck.utils.checkerHelpers.setupChecker(shapeRequiredIfNotDefinition);
				}

				var formlyExpression = apiCheck.oneOfType([apiCheck.string, apiCheck.func]);
				var specifyWrapperType = apiCheck.typeOrArrayOf(apiCheck.string).nullable;

				var apiCheckProperty = apiCheck.func;

				var apiCheckInstanceProperty = apiCheck.shape.onlyIf('apiCheck', apiCheck.func.withProperties({
					warn: apiCheck.func,
					'throw': apiCheck.func,
					shape: apiCheck.func
				}));

				var apiCheckFunctionProperty = apiCheck.shape.onlyIf('apiCheck', apiCheck.oneOf(['throw', 'warn']));

				var formlyWrapperType = apiCheck.shape({
					name: shapeRequiredIfNot('types', apiCheck.string).optional,
					template: apiCheck.shape.ifNot('templateUrl', apiCheck.string).optional,
					templateUrl: apiCheck.shape.ifNot('template', apiCheck.string).optional,
					types: apiCheck.typeOrArrayOf(apiCheck.string).optional,
					overwriteOk: apiCheck.bool.optional,
					apiCheck: apiCheckProperty.optional,
					apiCheckInstance: apiCheckInstanceProperty.optional,
					apiCheckFunction: apiCheckFunctionProperty.optional,
					apiCheckOptions: apiCheck.object.optional
				}).strict;

				var expressionProperties = apiCheck.objectOf(apiCheck.oneOfType([formlyExpression, apiCheck.shape({
					expression: formlyExpression,
					message: formlyExpression.optional
				}).strict]));

				var modelChecker = apiCheck.oneOfType([apiCheck.string, apiCheck.object]);

				var templateManipulators = apiCheck.shape({
					preWrapper: apiCheck.arrayOf(apiCheck.func).nullable.optional,
					postWrapper: apiCheck.arrayOf(apiCheck.func).nullable.optional
				}).strict.nullable;

				var validatorChecker = apiCheck.objectOf(apiCheck.oneOfType([formlyExpression, apiCheck.shape({
					expression: formlyExpression,
					message: formlyExpression.optional
				}).strict]));

				var watcherChecker = apiCheck.typeOrArrayOf(apiCheck.shape({
					expression: formlyExpression.optional,
					listener: formlyExpression.optional,
					runFieldExpressions: apiCheck.bool.optional
				}));

				var fieldOptionsApiShape = {
					$$hashKey: apiCheck.any.optional,
					type: apiCheck.shape.ifNot(['template', 'templateUrl'], apiCheck.string).optional,
					template: apiCheck.shape.ifNot(['type', 'templateUrl'], apiCheck.oneOfType([apiCheck.string, apiCheck.func])).optional,
					templateUrl: apiCheck.shape.ifNot(['type', 'template'], apiCheck.oneOfType([apiCheck.string, apiCheck.func])).optional,
					key: apiCheck.oneOfType([apiCheck.string, apiCheck.number]).optional,
					model: modelChecker.optional,
					originalModel: modelChecker.optional,
					className: apiCheck.string.optional,
					id: apiCheck.string.optional,
					name: apiCheck.string.optional,
					expressionProperties: expressionProperties.optional,
					extras: apiCheck.shape({
						validateOnModelChange: apiCheck.bool.optional,
						skipNgModelAttrsManipulator: apiCheck.oneOfType([apiCheck.string, apiCheck.bool]).optional
					}).strict.optional,
					data: apiCheck.object.optional,
					templateOptions: apiCheck.object.optional,
					wrapper: specifyWrapperType.optional,
					modelOptions: apiCheck.shape({
						updateOn: apiCheck.string.optional,
						debounce: apiCheck.oneOfType([apiCheck.objectOf(apiCheck.number), apiCheck.number]).optional,
						allowInvalid: apiCheck.bool.optional,
						getterSetter: apiCheck.bool.optional,
						timezone: apiCheck.string.optional
					}).optional,
					watcher: watcherChecker.optional,
					validators: validatorChecker.optional,
					asyncValidators: validatorChecker.optional,
					parsers: apiCheck.arrayOf(formlyExpression).optional,
					formatters: apiCheck.arrayOf(formlyExpression).optional,
					noFormControl: apiCheck.bool.optional,
					hide: apiCheck.bool.optional,
					hideExpression: formlyExpression.optional,
					ngModelElAttrs: apiCheck.objectOf(apiCheck.string).optional,
					ngModelAttrs: apiCheck.objectOf(apiCheck.shape({
						statement: apiCheck.shape.ifNot(['value', 'attribute', 'bound', 'boolean'], apiCheck.any).optional,
						value: apiCheck.shape.ifNot('statement', apiCheck.any).optional,
						attribute: apiCheck.shape.ifNot('statement', apiCheck.any).optional,
						bound: apiCheck.shape.ifNot('statement', apiCheck.any).optional,
						boolean: apiCheck.shape.ifNot('statement', apiCheck.any).optional
					}).strict).optional,
					elementAttributes: apiCheck.objectOf(apiCheck.string).optional,
					optionsTypes: apiCheck.typeOrArrayOf(apiCheck.string).optional,
					link: apiCheck.func.optional,
					controller: apiCheck.oneOfType([apiCheck.string, apiCheck.func, apiCheck.array]).optional,
					validation: apiCheck.shape({
						show: apiCheck.bool.nullable.optional,
						messages: apiCheck.objectOf(formlyExpression).optional,
						errorExistsAndShouldBeVisible: apiCheck.bool.optional
					}).optional,
					formControl: apiCheck.typeOrArrayOf(apiCheck.object).optional,
					value: apiCheck.func.optional,
					runExpressions: apiCheck.func.optional,
					templateManipulators: templateManipulators.optional,
					resetModel: apiCheck.func.optional,
					updateInitialValue: apiCheck.func.optional,
					initialValue: apiCheck.any.optional,
					defaultValue: apiCheck.any.optional
				};

				var formlyFieldOptions = apiCheck.shape(fieldOptionsApiShape).strict;

				var formOptionsApi = apiCheck.shape({
					formState: apiCheck.object.optional,
					resetModel: apiCheck.func.optional,
					updateInitialValue: apiCheck.func.optional,
					removeChromeAutoComplete: apiCheck.bool.optional,
					parseKeyArrays: apiCheck.bool.optional,
					templateManipulators: templateManipulators.optional,
					manualModelWatcher: apiCheck.oneOfType([apiCheck.bool, apiCheck.func]).optional,
					watchAllExpressions: apiCheck.bool.optional,
					wrapper: specifyWrapperType.optional,
					fieldTransform: apiCheck.oneOfType([apiCheck.func, apiCheck.array]).optional,
					data: apiCheck.object.optional
				}).strict;

				var fieldGroup = apiCheck.shape({
					$$hashKey: apiCheck.any.optional,
					key: apiCheck.oneOfType([apiCheck.string, apiCheck.number]).optional,
					// danger. Nested field groups wont get api-checked...
					fieldGroup: apiCheck.arrayOf(apiCheck.oneOfType([formlyFieldOptions, apiCheck.object])),
					className: apiCheck.string.optional,
					options: formOptionsApi.optional,
					templateOptions: apiCheck.object.optional,
					wrapper: specifyWrapperType.optional,
					watcher: watcherChecker.optional,
					hide: apiCheck.bool.optional,
					hideExpression: formlyExpression.optional,
					data: apiCheck.object.optional,
					model: modelChecker.optional,
					form: apiCheck.object.optional,
					elementAttributes: apiCheck.objectOf(apiCheck.string).optional
				}).strict;

				var typeOptionsDefaultOptions = _angularFix2['default'].copy(fieldOptionsApiShape);
				typeOptionsDefaultOptions.key = apiCheck.string.optional;

				var formlyTypeOptions = apiCheck.shape({
					name: apiCheck.string,
					template: apiCheck.shape.ifNot('templateUrl', apiCheck.oneOfType([apiCheck.string, apiCheck.func])).optional,
					templateUrl: apiCheck.shape.ifNot('template', apiCheck.oneOfType([apiCheck.string, apiCheck.func])).optional,
					controller: apiCheck.oneOfType([apiCheck.func, apiCheck.string, apiCheck.array]).optional,
					link: apiCheck.func.optional,
					defaultOptions: apiCheck.oneOfType([apiCheck.func, apiCheck.shape(typeOptionsDefaultOptions)]).optional,
					'extends': apiCheck.string.optional,
					wrapper: specifyWrapperType.optional,
					data: apiCheck.object.optional,
					apiCheck: apiCheckProperty.optional,
					apiCheckInstance: apiCheckInstanceProperty.optional,
					apiCheckFunction: apiCheckFunctionProperty.optional,
					apiCheckOptions: apiCheck.object.optional,
					overwriteOk: apiCheck.bool.optional
				}).strict;

				_angularFix2['default'].extend(apiCheck, {
					formlyTypeOptions: formlyTypeOptions, formlyFieldOptions: formlyFieldOptions, formlyExpression: formlyExpression, formlyWrapperType: formlyWrapperType, fieldGroup: fieldGroup, formOptionsApi: formOptionsApi
				});

				exports['default'] = apiCheck;
				module.exports = exports['default'];

				/***/
},
/* 5 */
/***/ function (module, exports) {

				module.exports = __WEBPACK_EXTERNAL_MODULE_5__;

				/***/
},
/* 6 */
/***/ function (module, exports, __webpack_require__) {

				"use strict";

				Object.defineProperty(exports, "__esModule", {
					value: true
				});
				exports["default"] = "https://github.com/formly-js/angular-formly/blob/" + ("8.4.1") + "/other/ERRORS_AND_WARNINGS.md#";
				module.exports = exports["default"];

				/***/
},
/* 7 */
/***/ function (module, exports, __webpack_require__) {

				'use strict';

				formlyUsability.$inject = ["formlyApiCheck", "formlyErrorAndWarningsUrlPrefix"];
				Object.defineProperty(exports, '__esModule', {
					value: true
				});

				function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

				var _angularFix = __webpack_require__(2);

				var _angularFix2 = _interopRequireDefault(_angularFix);

				exports['default'] = formlyUsability;

				// @ngInject
				function formlyUsability(formlyApiCheck, formlyErrorAndWarningsUrlPrefix) {
					var _this = this;

					_angularFix2['default'].extend(this, {
						getFormlyError: getFormlyError,
						getFieldError: getFieldError,
						checkWrapper: checkWrapper,
						checkWrapperTemplate: checkWrapperTemplate,
						getErrorMessage: getErrorMessage,
						$get: function $get() {
							return _this;
						}
					});

					function getFieldError(errorInfoSlug, message, field) {
						if (arguments.length < 3) {
							field = message;
							message = errorInfoSlug;
							errorInfoSlug = null;
						}
						return new Error(getErrorMessage(errorInfoSlug, message) + (' Field definition: ' + _angularFix2['default'].toJson(field)));
					}

					function getFormlyError(errorInfoSlug, message) {
						if (!message) {
							message = errorInfoSlug;
							errorInfoSlug = null;
						}
						return new Error(getErrorMessage(errorInfoSlug, message));
					}

					function getErrorMessage(errorInfoSlug, message) {
						var url = '';
						if (errorInfoSlug !== null) {
							url = '' + formlyErrorAndWarningsUrlPrefix + errorInfoSlug;
						}
						return 'Formly Error: ' + message + '. ' + url;
					}

					function checkWrapper(wrapper) {
						formlyApiCheck['throw'](formlyApiCheck.formlyWrapperType, wrapper, {
							prefix: 'formlyConfig.setWrapper',
							urlSuffix: 'setwrapper-validation-failed'
						});
					}

					function checkWrapperTemplate(template, additionalInfo) {
						var formlyTransclude = '<formly-transclude></formly-transclude>';
						if (template.indexOf(formlyTransclude) === -1) {
							throw getFormlyError('Template wrapper templates must use "' + formlyTransclude + '" somewhere in them. ' + ('This one does not have "<formly-transclude></formly-transclude>" in it: ' + template) + '\n' + ('Additional information: ' + JSON.stringify(additionalInfo)));
						}
					}
				}
				module.exports = exports['default'];

				/***/
},
/* 8 */
/***/ function (module, exports, __webpack_require__) {

				'use strict';

				formlyConfig.$inject = ["formlyUsabilityProvider", "formlyErrorAndWarningsUrlPrefix", "formlyApiCheck"];
				Object.defineProperty(exports, '__esModule', {
					value: true
				});

				function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

				function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) arr2[i] = arr[i]; return arr2; } else { return Array.from(arr); } }

				var _angularFix = __webpack_require__(2);

				var _angularFix2 = _interopRequireDefault(_angularFix);

				var _otherUtils = __webpack_require__(9);

				var _otherUtils2 = _interopRequireDefault(_otherUtils);

				exports['default'] = formlyConfig;

				// @ngInject
				function formlyConfig(formlyUsabilityProvider, formlyErrorAndWarningsUrlPrefix, formlyApiCheck) {
					var _this2 = this;

					var typeMap = {};
					var templateWrappersMap = {};
					var defaultWrapperName = 'default';
					var _this = this;
					var getError = formlyUsabilityProvider.getFormlyError;

					_angularFix2['default'].extend(this, {
						setType: setType,
						getType: getType,
						getTypes: getTypes,
						getTypeHeritage: getTypeHeritage,
						setWrapper: setWrapper,
						getWrapper: getWrapper,
						getWrapperByType: getWrapperByType,
						removeWrapperByName: removeWrapperByName,
						removeWrappersForType: removeWrappersForType,
						disableWarnings: false,
						extras: {
							disableNgModelAttrsManipulator: false,
							fieldTransform: [],
							ngModelAttrsManipulatorPreferUnbound: false,
							removeChromeAutoComplete: false,
							parseKeyArrays: false,
							defaultHideDirective: 'ng-if',
							getFieldId: null
						},
						templateManipulators: {
							preWrapper: [],
							postWrapper: []
						},
						$get: function $get() {
							return _this2;
						}
					});

					function setType(options) {
						if (_angularFix2['default'].isArray(options)) {
							var _ret = (function () {
								var allTypes = [];
								_angularFix2['default'].forEach(options, function (item) {
									allTypes.push(setType(item));
								});
								return {
									v: allTypes
								};
							})();

							if (typeof _ret === 'object') return _ret.v;
						} else if (_angularFix2['default'].isObject(options)) {
							checkType(options);
							if (options['extends']) {
								extendTypeOptions(options);
							}
							typeMap[options.name] = options;
							return typeMap[options.name];
						} else {
							throw getError('You must provide an object or array for setType. You provided: ' + JSON.stringify(arguments));
						}
					}

					function checkType(options) {
						formlyApiCheck['throw'](formlyApiCheck.formlyTypeOptions, options, {
							prefix: 'formlyConfig.setType',
							url: 'settype-validation-failed'
						});
						if (!options.overwriteOk) {
							checkOverwrite(options.name, typeMap, options, 'types');
						} else {
							options.overwriteOk = undefined;
						}
					}

					function extendTypeOptions(options) {
						var extendsType = getType(options['extends'], true, options);
						extendTypeControllerFunction(options, extendsType);
						extendTypeLinkFunction(options, extendsType);
						extendTypeDefaultOptions(options, extendsType);
						_otherUtils2['default'].reverseDeepMerge(options, extendsType);
						extendTemplate(options, extendsType);
					}

					function extendTemplate(options, extendsType) {
						if (options.template && extendsType.templateUrl) {
							delete options.templateUrl;
						} else if (options.templateUrl && extendsType.template) {
							delete options.template;
						}
					}

					function extendTypeControllerFunction(options, extendsType) {
						var extendsCtrl = extendsType.controller;
						if (!_angularFix2['default'].isDefined(extendsCtrl)) {
							return;
						}
						var optionsCtrl = options.controller;
						if (_angularFix2['default'].isDefined(optionsCtrl)) {
							options.controller = function ($scope, $controller) {
								$controller(extendsCtrl, { $scope: $scope });
								$controller(optionsCtrl, { $scope: $scope });
							};
							options.controller.$inject = ['$scope', '$controller'];
						} else {
							options.controller = extendsCtrl;
						}
					}

					function extendTypeLinkFunction(options, extendsType) {
						var extendsFn = extendsType.link;
						if (!_angularFix2['default'].isDefined(extendsFn)) {
							return;
						}
						var optionsFn = options.link;
						if (_angularFix2['default'].isDefined(optionsFn)) {
							options.link = function () {
								extendsFn.apply(undefined, arguments);
								optionsFn.apply(undefined, arguments);
							};
						} else {
							options.link = extendsFn;
						}
					}

					function extendTypeDefaultOptions(options, extendsType) {
						var extendsDO = extendsType.defaultOptions;
						if (!_angularFix2['default'].isDefined(extendsDO)) {
							return;
						}
						var optionsDO = options.defaultOptions || {};
						var optionsDOIsFn = _angularFix2['default'].isFunction(optionsDO);
						var extendsDOIsFn = _angularFix2['default'].isFunction(extendsDO);
						if (extendsDOIsFn) {
							options.defaultOptions = function defaultOptions(opts, scope) {
								var extendsDefaultOptions = extendsDO(opts, scope);
								var mergedDefaultOptions = {};
								_otherUtils2['default'].reverseDeepMerge(mergedDefaultOptions, opts, extendsDefaultOptions);
								var extenderOptionsDefaultOptions = optionsDO;
								if (optionsDOIsFn) {
									extenderOptionsDefaultOptions = extenderOptionsDefaultOptions(mergedDefaultOptions, scope);
								}
								_otherUtils2['default'].reverseDeepMerge(extenderOptionsDefaultOptions, extendsDefaultOptions);
								return extenderOptionsDefaultOptions;
							};
						} else if (optionsDOIsFn) {
							options.defaultOptions = function defaultOptions(opts, scope) {
								var newDefaultOptions = {};
								_otherUtils2['default'].reverseDeepMerge(newDefaultOptions, opts, extendsDO);
								return optionsDO(newDefaultOptions, scope);
							};
						}
					}

					function getType(name, throwError, errorContext) {
						if (!name) {
							return undefined;
						}
						var type = typeMap[name];
						if (!type && throwError === true) {
							throw getError('There is no type by the name of "' + name + '": ' + JSON.stringify(errorContext));
						} else {
							return type;
						}
					}

					function getTypes() {
						return typeMap;
					}

					function getTypeHeritage(parent) {
						var heritage = [];
						var type = parent;
						if (_angularFix2['default'].isString(type)) {
							type = getType(parent);
						}
						parent = type['extends'];
						while (parent) {
							type = getType(parent);
							heritage.push(type);
							parent = type['extends'];
						}
						return heritage;
					}

					function setWrapper(_x, _x2) {
						var _again = true;

						_function: while (_again) {
							var options = _x,
								name = _x2;
							_again = false;

							if (_angularFix2['default'].isArray(options)) {
								return options.map(function (wrapperOptions) {
									return setWrapper(wrapperOptions);
								});
							} else if (_angularFix2['default'].isObject(options)) {
								options.types = getOptionsTypes(options);
								options.name = getOptionsName(options, name);
								checkWrapperAPI(options);
								templateWrappersMap[options.name] = options;
								return options;
							} else if (_angularFix2['default'].isString(options)) {
								_x = {
									template: options,
									name: name
								};
								_x2 = undefined;
								_again = true;
								continue _function;
							}
						}
					}

					function getOptionsTypes(options) {
						if (_angularFix2['default'].isString(options.types)) {
							return [options.types];
						}
						if (!_angularFix2['default'].isDefined(options.types)) {
							return [];
						} else {
							return options.types;
						}
					}

					function getOptionsName(options, name) {
						return options.name || name || options.types.join(' ') || defaultWrapperName;
					}

					function checkWrapperAPI(options) {
						formlyUsabilityProvider.checkWrapper(options);
						if (options.template) {
							formlyUsabilityProvider.checkWrapperTemplate(options.template, options);
						}
						if (!options.overwriteOk) {
							checkOverwrite(options.name, templateWrappersMap, options, 'templateWrappers');
						} else {
							delete options.overwriteOk;
						}
						checkWrapperTypes(options);
					}

					function checkWrapperTypes(options) {
						var shouldThrow = !_angularFix2['default'].isArray(options.types) || !options.types.every(_angularFix2['default'].isString);
						if (shouldThrow) {
							throw getError('Attempted to create a template wrapper with types that is not a string or an array of strings');
						}
					}

					function checkOverwrite(property, object, newValue, objectName) {
						if (object.hasOwnProperty(property)) {
							warn('overwriting-types-or-wrappers', ['Attempting to overwrite ' + property + ' on ' + objectName + ' which is currently', JSON.stringify(object[property]) + ' with ' + JSON.stringify(newValue), 'To supress this warning, specify the property "overwriteOk: true"'].join(' '));
						}
					}

					function getWrapper(name) {
						return templateWrappersMap[name || defaultWrapperName];
					}

					function getWrapperByType(type) {
						/* eslint prefer-const:0 */
						var wrappers = [];
						for (var _name in templateWrappersMap) {
							if (templateWrappersMap.hasOwnProperty(_name)) {
								if (templateWrappersMap[_name].types && templateWrappersMap[_name].types.indexOf(type) !== -1) {
									wrappers.push(templateWrappersMap[_name]);
								}
							}
						}
						return wrappers;
					}

					function removeWrapperByName(name) {
						var wrapper = templateWrappersMap[name];
						delete templateWrappersMap[name];
						return wrapper;
					}

					function removeWrappersForType(type) {
						var wrappers = getWrapperByType(type);
						if (!wrappers) {
							return undefined;
						}
						if (!_angularFix2['default'].isArray(wrappers)) {
							return removeWrapperByName(wrappers.name);
						} else {
							wrappers.forEach(function (wrapper) {
								return removeWrapperByName(wrapper.name);
							});
							return wrappers;
						}
					}

					function warn() {
						if (!_this.disableWarnings && console.warn) {
							/* eslint no-console:0 */
							var args = Array.prototype.slice.call(arguments);
							var warnInfoSlug = args.shift();
							args.unshift('Formly Warning:');
							args.push('' + formlyErrorAndWarningsUrlPrefix + warnInfoSlug);
							console.warn.apply(console, _toConsumableArray(args));
						}
					}
				}
				module.exports = exports['default'];

				/***/
},
/* 9 */
/***/ function (module, exports, __webpack_require__) {

				'use strict';

				Object.defineProperty(exports, '__esModule', {
					value: true
				});

				function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

				var _angularFix = __webpack_require__(2);

				var _angularFix2 = _interopRequireDefault(_angularFix);

				exports['default'] = {
					containsSelector: containsSelector, containsSpecialChar: containsSpecialChar, formlyEval: formlyEval, getFieldId: getFieldId, reverseDeepMerge: reverseDeepMerge, findByNodeName: findByNodeName,
					arrayify: arrayify, extendFunction: extendFunction, extendArray: extendArray, startsWith: startsWith, contains: contains
				};

				function containsSelector(string) {
					return containsSpecialChar(string, '.') || containsSpecialChar(string, '[') && containsSpecialChar(string, ']');
				}

				function containsSpecialChar(a, b) {
					if (!a || !a.indexOf) {
						return false;
					}
					return a.indexOf(b) !== -1;
				}

				function formlyEval(scope, expression, $modelValue, $viewValue, extraLocals) {
					if (_angularFix2['default'].isFunction(expression)) {
						return expression($viewValue, $modelValue, scope, extraLocals);
					} else {
						return scope.$eval(expression, _angularFix2['default'].extend({ $viewValue: $viewValue, $modelValue: $modelValue }, extraLocals));
					}
				}

				function getFieldId(formId, options, index) {
					if (options.id) {
						return options.id;
					}
					var type = options.type;
					if (!type && options.template) {
						type = 'template';
					} else if (!type && options.templateUrl) {
						type = 'templateUrl';
					}

					return [formId, type, options.key, index].join('_');
				}

				function reverseDeepMerge(dest) {
					_angularFix2['default'].forEach(arguments, function (src, index) {
						if (!index) {
							return;
						}
						_angularFix2['default'].forEach(src, function (val, prop) {
							if (!_angularFix2['default'].isDefined(dest[prop])) {
								dest[prop] = _angularFix2['default'].copy(val);
							} else if (objAndSameType(dest[prop], val)) {
								reverseDeepMerge(dest[prop], val);
							}
						});
					});
					return dest;
				}

				function objAndSameType(obj1, obj2) {
					return _angularFix2['default'].isObject(obj1) && _angularFix2['default'].isObject(obj2) && Object.getPrototypeOf(obj1) === Object.getPrototypeOf(obj2);
				}

				// recurse down a node tree to find a node with matching nodeName, for custom tags jQuery.find doesn't work in IE8
				function findByNodeName(el, nodeName) {
					if (!el.prop) {
						// not a jQuery or jqLite object -> wrap it
						el = _angularFix2['default'].element(el);
					}

					if (el.prop('nodeName') === nodeName.toUpperCase()) {
						return el;
					}

					var c = el.children();
					for (var i = 0; c && i < c.length; i++) {
						var node = findByNodeName(c[i], nodeName);
						if (node) {
							return node;
						}
					}
				}

				function arrayify(obj) {
					if (obj && !_angularFix2['default'].isArray(obj)) {
						obj = [obj];
					} else if (!obj) {
						obj = [];
					}
					return obj;
				}

				function extendFunction() {
					for (var _len = arguments.length, fns = Array(_len), _key = 0; _key < _len; _key++) {
						fns[_key] = arguments[_key];
					}

					return function extendedFunction() {
						var args = arguments;
						fns.forEach(function (fn) {
							return fn.apply(null, args);
						});
					};
				}

				function extendArray(primary, secondary, property) {
					if (property) {
						primary = primary[property];
						secondary = secondary[property];
					}
					if (secondary && primary) {
						_angularFix2['default'].forEach(secondary, function (item) {
							if (primary.indexOf(item) === -1) {
								primary.push(item);
							}
						});
						return primary;
					} else if (secondary) {
						return secondary;
					} else {
						return primary;
					}
				}

				function startsWith(str, search) {
					if (_angularFix2['default'].isString(str) && _angularFix2['default'].isString(search)) {
						return str.length >= search.length && str.substring(0, search.length) === search;
					} else {
						return false;
					}
				}

				function contains(str, search) {
					if (_angularFix2['default'].isString(str) && _angularFix2['default'].isString(search)) {
						return str.length >= search.length && str.indexOf(search) !== -1;
					} else {
						return false;
					}
				}
				module.exports = exports['default'];

				/***/
},
/* 10 */
/***/ function (module, exports) {

				'use strict';

				Object.defineProperty(exports, '__esModule', {
					value: true
				});
				exports['default'] = formlyValidationMessages;

				// @ngInject
				function formlyValidationMessages() {

					var validationMessages = {
						addTemplateOptionValueMessage: addTemplateOptionValueMessage,
						addStringMessage: addStringMessage,
						messages: {}
					};

					return validationMessages;

					function addTemplateOptionValueMessage(name, prop, prefix, suffix, alternate) {
						validationMessages.messages[name] = templateOptionValue(prop, prefix, suffix, alternate);
					}

					function addStringMessage(name, string) {
						validationMessages.messages[name] = function () {
							return string;
						};
					}

					function templateOptionValue(prop, prefix, suffix, alternate) {
						return function getValidationMessage(viewValue, modelValue, scope) {
							if (typeof scope.options.templateOptions[prop] !== 'undefined') {
								return prefix + ' ' + scope.options.templateOptions[prop] + ' ' + suffix;
							} else {
								return alternate;
							}
						};
					}
				}
				module.exports = exports['default'];

				/***/
},
/* 11 */
/***/ function (module, exports, __webpack_require__) {

				'use strict';

				Object.defineProperty(exports, '__esModule', {
					value: true
				});

				function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

				var _otherUtils = __webpack_require__(9);

				var _otherUtils2 = _interopRequireDefault(_otherUtils);

				exports['default'] = formlyUtil;

				// @ngInject
				function formlyUtil() {
					return _otherUtils2['default'];
				}
				module.exports = exports['default'];

				/***/
},
/* 12 */
/***/ function (module, exports) {

				'use strict';

				formlyWarn.$inject = ["formlyConfig", "formlyErrorAndWarningsUrlPrefix", "$log"];
				Object.defineProperty(exports, '__esModule', {
					value: true
				});

				function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) arr2[i] = arr[i]; return arr2; } else { return Array.from(arr); } }

				exports['default'] = formlyWarn;

				// @ngInject
				function formlyWarn(formlyConfig, formlyErrorAndWarningsUrlPrefix, $log) {
					return function warn() {
						if (!formlyConfig.disableWarnings) {
							var args = Array.prototype.slice.call(arguments);
							var warnInfoSlug = args.shift();
							args.unshift('Formly Warning:');
							args.push('' + formlyErrorAndWarningsUrlPrefix + warnInfoSlug);
							$log.warn.apply($log, _toConsumableArray(args));
						}
					};
				}
				module.exports = exports['default'];

				/***/
},
/* 13 */
/***/ function (module, exports, __webpack_require__) {

				'use strict';

				formlyCustomValidation.$inject = ["formlyUtil"];
				Object.defineProperty(exports, '__esModule', {
					value: true
				});

				function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

				var _angularFix = __webpack_require__(2);

				var _angularFix2 = _interopRequireDefault(_angularFix);

				exports['default'] = formlyCustomValidation;

				// @ngInject
				function formlyCustomValidation(formlyUtil) {
					return {
						restrict: 'A',
						require: 'ngModel',
						link: function formlyCustomValidationLink(scope, el, attrs, ctrl) {
							var opts = scope.options;
							opts.validation.messages = opts.validation.messages || {};
							_angularFix2['default'].forEach(opts.validation.messages, function (message, key) {
								opts.validation.messages[key] = function () {
									return formlyUtil.formlyEval(scope, message, ctrl.$modelValue, ctrl.$viewValue);
								};
							});

							var useNewValidatorsApi = ctrl.hasOwnProperty('$validators') && !attrs.hasOwnProperty('useParsers');
							_angularFix2['default'].forEach(opts.validators, _angularFix2['default'].bind(null, addValidatorToPipeline, false));
							_angularFix2['default'].forEach(opts.asyncValidators, _angularFix2['default'].bind(null, addValidatorToPipeline, true));

							function addValidatorToPipeline(isAsync, validator, name) {
								setupMessage(validator, name);
								validator = _angularFix2['default'].isObject(validator) ? validator.expression : validator;
								if (useNewValidatorsApi) {
									setupWithValidators(validator, name, isAsync);
								} else {
									setupWithParsers(validator, name, isAsync);
								}
							}

							function setupMessage(validator, name) {
								var message = validator.message;
								if (message) {
									opts.validation.messages[name] = function () {
										return formlyUtil.formlyEval(scope, message, ctrl.$modelValue, ctrl.$viewValue);
									};
								}
							}

							function setupWithValidators(validator, name, isAsync) {
								var validatorCollection = isAsync ? '$asyncValidators' : '$validators';

								ctrl[validatorCollection][name] = function evalValidity(modelValue, viewValue) {
									return formlyUtil.formlyEval(scope, validator, modelValue, viewValue);
								};
							}

							function setupWithParsers(validator, name, isAsync) {
								var inFlightValidator = undefined;
								ctrl.$parsers.unshift(function evalValidityOfParser(viewValue) {
									var isValid = formlyUtil.formlyEval(scope, validator, ctrl.$modelValue, viewValue);
									if (isAsync) {
										ctrl.$pending = ctrl.$pending || {};
										ctrl.$pending[name] = true;
										inFlightValidator = isValid;
										isValid.then(function () {
											if (inFlightValidator === isValid) {
												ctrl.$setValidity(name, true);
											}
										})['catch'](function () {
											if (inFlightValidator === isValid) {
												ctrl.$setValidity(name, false);
											}
										})['finally'](function () {
											var $pending = ctrl.$pending || {};
											if (Object.keys($pending).length === 1) {
												delete ctrl.$pending;
											} else {
												delete ctrl.$pending[name];
											}
										});
									} else {
										ctrl.$setValidity(name, isValid);
									}
									return viewValue;
								});
							}
						}
					};
				}
				module.exports = exports['default'];

				/***/
},
/* 14 */
/***/ function (module, exports, __webpack_require__) {

				'use strict';

				formlyField.$inject = ["$http", "$q", "$compile", "$templateCache", "$interpolate", "formlyConfig", "formlyApiCheck", "formlyUtil", "formlyUsability", "formlyWarn"];
				Object.defineProperty(exports, '__esModule', {
					value: true
				});

				function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

				function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) arr2[i] = arr[i]; return arr2; } else { return Array.from(arr); } }

				var _angularFix = __webpack_require__(2);

				var _angularFix2 = _interopRequireDefault(_angularFix);

				var _apiCheck = __webpack_require__(5);

				var _apiCheck2 = _interopRequireDefault(_apiCheck);

				exports['default'] = formlyField;

				/**
				 * @ngdoc directive
				 * @name formlyField
				 * @restrict AE
				 */
				// @ngInject
				function formlyField($http, $q, $compile, $templateCache, $interpolate, formlyConfig, formlyApiCheck, formlyUtil, formlyUsability, formlyWarn) {
					FormlyFieldController.$inject = ["$scope", "$timeout", "$parse", "$controller", "formlyValidationMessages"];
					var arrayify = formlyUtil.arrayify;

					return {
						restrict: 'AE',
						transclude: true,
						require: '?^formlyForm',
						scope: {
							options: '=',
							model: '=',
							originalModel: '=?',
							formId: '@', // TODO remove formId in a breaking release
							index: '=?',
							fields: '=?',
							formState: '=?',
							formOptions: '=?',
							form: '=?'
						},
						// TODO require form in a breaking release
						controller: FormlyFieldController,
						link: fieldLink
					};

					// @ngInject
					function FormlyFieldController($scope, $timeout, $parse, $controller, formlyValidationMessages) {
						/* eslint max-statements:[2, 37] */
						if ($scope.options.fieldGroup) {
							setupFieldGroup();
							return;
						}

						var fieldType = getFieldType($scope.options);
						simplifyLife($scope.options);
						mergeFieldOptionsWithTypeDefaults($scope.options, fieldType);
						extendOptionsWithDefaults($scope.options, $scope.index);
						checkApi($scope.options);
						// set field id to link labels and fields

						// initalization
						setFieldIdAndName();
						setDefaultValue();
						setInitialValue();
						runExpressions();
						watchExpressions();
						addValidationMessages($scope.options);
						invokeControllers($scope, $scope.options, fieldType);

						// function definitions
						function runExpressions() {
							var deferred = $q.defer();
							// must run on next tick to make sure that the current value is correct.
							$timeout(function runExpressionsOnNextTick() {
								var promises = [];
								var field = $scope.options;
								var currentValue = valueGetterSetter();
								_angularFix2['default'].forEach(field.expressionProperties, function runExpression(expression, prop) {
									var setter = $parse(prop).assign;
									var promise = $q.when(formlyUtil.formlyEval($scope, expression, currentValue, currentValue)).then(function setFieldValue(value) {
										setter(field, value);
									});
									promises.push(promise);
								});
								$q.all(promises).then(function () {
									deferred.resolve();
								});
							}, 0, false);
							return deferred.promise;
						}

						function watchExpressions() {
							if ($scope.formOptions.watchAllExpressions) {
								(function () {
									var field = $scope.options;
									var currentValue = valueGetterSetter();
									_angularFix2['default'].forEach(field.expressionProperties, function watchExpression(expression, prop) {
										var setter = $parse(prop).assign;
										$scope.$watch(function expressionPropertyWatcher() {
											return formlyUtil.formlyEval($scope, expression, currentValue, currentValue);
										}, function expressionPropertyListener(value) {
											setter(field, value);
										}, true);
									});
								})();
							}
						}

						function valueGetterSetter(newVal) {
							if (!$scope.model || !$scope.options.key) {
								return undefined;
							}
							if (_angularFix2['default'].isDefined(newVal)) {
								parseSet($scope.options.key, $scope.model, newVal);
							}
							return parseGet($scope.options.key, $scope.model);
						}

						function shouldNotUseParseKey(key) {
							return _angularFix2['default'].isNumber(key) || !formlyUtil.containsSelector(key);
						}

						function keyContainsArrays(key) {
							return (/\[\d{1,}\]/.test(key)
							);
						}

						function deepAssign(obj, prop, value) {
							if (_angularFix2['default'].isString(prop)) {
								prop = prop.replace(/\[(\w+)\]/g, '.$1').split('.');
							}

							if (prop.length > 1) {
								var e = prop.shift();
								obj[e] = obj[e] || isNaN(prop[0]) ? {} : [];
								deepAssign(obj[e], prop, value);
							} else {
								obj[prop[0]] = value;
							}
						}

						function parseSet(key, model, newVal) {
							// If either of these are null/undefined then just return undefined
							if (!key && key !== 0 || !model) {
								return;
							}
							// If we are working with a number then $parse wont work, default back to the old way for now
							if (shouldNotUseParseKey(key)) {
								// TODO: Fix this so we can get several levels instead of just one with properties that are numeric
								model[key] = newVal;
							} else if (formlyConfig.extras.parseKeyArrays && keyContainsArrays(key)) {
								deepAssign($scope.model, key, newVal);
							} else {
								var setter = $parse($scope.options.key).assign;
								if (setter) {
									setter($scope.model, newVal);
								}
							}
						}

						function parseGet(key, model) {
							// If either of these are null/undefined then just return undefined
							if (!key && key !== 0 || !model) {
								return undefined;
							}

							// If we are working with a number then $parse wont work, default back to the old way for now
							if (shouldNotUseParseKey(key)) {
								// TODO: Fix this so we can get several levels instead of just one with properties that are numeric
								return model[key];
							} else {
								return $parse(key)(model);
							}
						}

						function simplifyLife(options) {
							// add a few empty objects (if they don't already exist) so you don't have to undefined check everywhere
							formlyUtil.reverseDeepMerge(options, {
								originalModel: options.model,
								extras: {},
								data: {},
								templateOptions: {},
								validation: {}
							});
							// create $scope.to so template authors can reference to instead of $scope.options.templateOptions
							$scope.to = $scope.options.templateOptions;
							$scope.formOptions = $scope.formOptions || {};
						}

						function setFieldIdAndName() {
							if (_angularFix2['default'].isFunction(formlyConfig.extras.getFieldId)) {
								$scope.id = formlyConfig.extras.getFieldId($scope.options, $scope.model, $scope);
							} else {
								var formName = $scope.form && $scope.form.$name || $scope.formId;
								$scope.id = formlyUtil.getFieldId(formName, $scope.options, $scope.index);
							}
							$scope.options.id = $scope.id;
							$scope.name = $scope.options.name || $scope.options.id;
							$scope.options.name = $scope.name;
						}

						function setDefaultValue() {
							if (_angularFix2['default'].isDefined($scope.options.defaultValue) && !_angularFix2['default'].isDefined(parseGet($scope.options.key, $scope.model))) {
								parseSet($scope.options.key, $scope.model, $scope.options.defaultValue);
							}
						}

						function setInitialValue() {
							$scope.options.initialValue = $scope.model && parseGet($scope.options.key, $scope.model);
						}

						function mergeFieldOptionsWithTypeDefaults(options, type) {
							if (type) {
								mergeOptions(options, type.defaultOptions);
							}
							var properOrder = arrayify(options.optionsTypes).reverse(); // so the right things are overridden
							_angularFix2['default'].forEach(properOrder, function (typeName) {
								mergeOptions(options, formlyConfig.getType(typeName, true, options).defaultOptions);
							});
						}

						function mergeOptions(options, extraOptions) {
							if (extraOptions) {
								if (_angularFix2['default'].isFunction(extraOptions)) {
									extraOptions = extraOptions(options, $scope);
								}
								formlyUtil.reverseDeepMerge(options, extraOptions);
							}
						}

						function extendOptionsWithDefaults(options, index) {
							var key = options.key || index || 0;
							_angularFix2['default'].extend(options, {
								// attach the key in case the formly-field directive is used directly
								key: key,
								value: options.value || valueGetterSetter,
								runExpressions: runExpressions,
								resetModel: resetModel,
								updateInitialValue: updateInitialValue
							});
						}

						function resetModel() {
							parseSet($scope.options.key, $scope.model, $scope.options.initialValue);
							if ($scope.options.formControl) {
								if (_angularFix2['default'].isArray($scope.options.formControl)) {
									_angularFix2['default'].forEach($scope.options.formControl, function (formControl) {
										resetFormControl(formControl, true);
									});
								} else {
									resetFormControl($scope.options.formControl);
								}
							}
							if ($scope.form) {
								$scope.form.$setUntouched && $scope.form.$setUntouched();
								$scope.form.$setPristine();
							}
						}

						function resetFormControl(formControl, isMultiNgModel) {
							if (!isMultiNgModel) {
								formControl.$setViewValue(parseGet($scope.options.key, $scope.model));
							}

							formControl.$render();
							formControl.$setUntouched && formControl.$setUntouched();
							formControl.$setPristine();

							// To prevent breaking change requiring a digest to reset $viewModel
							if (!$scope.$root.$$phase) {
								$scope.$digest();
							}
						}

						function updateInitialValue() {
							$scope.options.initialValue = parseGet($scope.options.key, $scope.model);
						}

						function addValidationMessages(options) {
							options.validation.messages = options.validation.messages || {};
							_angularFix2['default'].forEach(formlyValidationMessages.messages, function createFunctionForMessage(expression, name) {
								if (!options.validation.messages[name]) {
									options.validation.messages[name] = function evaluateMessage(viewValue, modelValue, scope) {
										return formlyUtil.formlyEval(scope, expression, modelValue, viewValue);
									};
								}
							});
						}

						function invokeControllers(scope) {
							var options = arguments.length <= 1 || arguments[1] === undefined ? {} : arguments[1];
							var type = arguments.length <= 2 || arguments[2] === undefined ? {} : arguments[2];

							_angularFix2['default'].forEach([type.controller, options.controller], function (controller) {
								if (controller) {
									$controller(controller, { $scope: scope });
								}
							});
						}

						function setupFieldGroup() {
							$scope.options.options = $scope.options.options || {};
							$scope.options.options.formState = $scope.formState;
							$scope.to = $scope.options.templateOptions;
						}
					}

					// link function
					function fieldLink(scope, el, attrs, formlyFormCtrl) {
						if (scope.options.fieldGroup) {
							setFieldGroupTemplate();
							return;
						}

						// watch the field model (if exists) if there is no parent formly-form directive (that would watch it instead)
						if (!formlyFormCtrl && scope.options.model) {
							scope.$watch('options.model', function () {
								return scope.options.runExpressions();
							}, true);
						}

						addAttributes();
						addClasses();

						var type = getFieldType(scope.options);
						var args = arguments;
						var thusly = this;
						var fieldCount = 0;
						var fieldManipulators = getManipulators(scope.options, scope.formOptions);
						getFieldTemplate(scope.options).then(runManipulators(fieldManipulators.preWrapper)).then(transcludeInWrappers(scope.options, scope.formOptions)).then(runManipulators(fieldManipulators.postWrapper)).then(setElementTemplate).then(watchFormControl).then(callLinkFunctions)['catch'](function (error) {
							formlyWarn('there-was-a-problem-setting-the-template-for-this-field', 'There was a problem setting the template for this field ', scope.options, error);
						});

						function setFieldGroupTemplate() {
							checkFieldGroupApi(scope.options);
							el.addClass('formly-field-group');
							var extraAttributes = '';
							if (scope.options.elementAttributes) {
								extraAttributes = Object.keys(scope.options.elementAttributes).map(function (key) {
									return key + '="' + scope.options.elementAttributes[key] + '"';
								}).join(' ');
							}
							var modelValue = 'model';
							scope.options.form = scope.form;
							if (scope.options.key) {
								modelValue = 'model[\'' + scope.options.key + '\']';
							}
							getTemplate('\n          <formly-form model="' + modelValue + '"\n                       fields="options.fieldGroup"\n                       options="options.options"\n                       form="options.form"\n                       class="' + scope.options.className + '"\n                       ' + extraAttributes + '\n                       is-field-group>\n          </formly-form>\n        ').then(transcludeInWrappers(scope.options, scope.formOptions)).then(setElementTemplate);
						}

						function addAttributes() {
							if (scope.options.elementAttributes) {
								el.attr(scope.options.elementAttributes);
							}
						}

						function addClasses() {
							if (scope.options.className) {
								el.addClass(scope.options.className);
							}
							if (scope.options.type) {
								el.addClass('formly-field-' + scope.options.type);
							}
						}

						function setElementTemplate(templateString) {
							el.html(asHtml(templateString));
							$compile(el.contents())(scope);
							return templateString;
						}

						function watchFormControl(templateString) {
							var stopWatchingShowError = _angularFix2['default'].noop;
							if (scope.options.noFormControl) {
								return;
							}
							var templateEl = _angularFix2['default'].element('<div>' + templateString + '</div>');
							var ngModelNodes = templateEl[0].querySelectorAll('[ng-model],[data-ng-model]');

							if (ngModelNodes.length) {
								_angularFix2['default'].forEach(ngModelNodes, function (ngModelNode) {
									fieldCount++;
									watchFieldNameOrExistence(ngModelNode.getAttribute('name'));
								});
							}

							function watchFieldNameOrExistence(name) {
								var nameExpressionRegex = /\{\{(.*?)}}/;
								var nameExpression = nameExpressionRegex.exec(name);
								if (nameExpression) {
									name = $interpolate(name)(scope);
								}
								watchFieldExistence(name);
							}

							function watchFieldExistence(name) {
								scope.$watch('form["' + name + '"]', function formControlChange(formControl) {
									if (formControl) {
										if (fieldCount > 1) {
											if (!scope.options.formControl) {
												scope.options.formControl = [];
											}
											scope.options.formControl.push(formControl);
										} else {
											scope.options.formControl = formControl;
										}
										scope.fc = scope.options.formControl; // shortcut for template authors
										stopWatchingShowError();
										addShowMessagesWatcher();
										addParsers();
										addFormatters();
									}
								});
							}

							function addShowMessagesWatcher() {
								stopWatchingShowError = scope.$watch(function watchShowValidationChange() {
									var customExpression = formlyConfig.extras.errorExistsAndShouldBeVisibleExpression;
									var options = scope.options;
									var formControls = arrayify(scope.fc);
									if (!formControls.some(function (fc) {
										return fc.$invalid;
									})) {
										return false;
									} else if (typeof options.validation.show === 'boolean') {
										return options.validation.show;
									} else if (customExpression) {
										return formControls.some(function (fc) {
											return formlyUtil.formlyEval(scope, customExpression, fc.$modelValue, fc.$viewValue);
										});
									} else {
										return formControls.some(function (fc) {
											var noTouchedButDirty = _angularFix2['default'].isUndefined(fc.$touched) && fc.$dirty;
											return fc.$touched || noTouchedButDirty;
										});
									}
								}, function onShowValidationChange(show) {
									scope.options.validation.errorExistsAndShouldBeVisible = show;
									scope.showError = show; // shortcut for template authors
								});
							}

							function addParsers() {
								setParsersOrFormatters('parsers');
							}

							function addFormatters() {
								setParsersOrFormatters('formatters');
								var ctrl = scope.fc;
								var formWasPristine = scope.form.$pristine;
								if (scope.options.formatters) {
									(function () {
										var value = ctrl.$modelValue;
										ctrl.$formatters.forEach(function (formatter) {
											value = formatter(value);
										});

										ctrl.$setViewValue(value);
										ctrl.$render();
										ctrl.$setPristine();
										if (formWasPristine) {
											scope.form.$setPristine();
										}
									})();
								}
							}

							function setParsersOrFormatters(which) {
								var originalThingProp = 'originalParser';
								if (which === 'formatters') {
									originalThingProp = 'originalFormatter';
								}

								// init with type's parsers
								var things = getThingsFromType(type);

								// get optionsTypes things
								things = formlyUtil.extendArray(things, getThingsFromOptionsTypes(scope.options.optionsTypes));

								// get field's things
								things = formlyUtil.extendArray(things, scope.options[which]);

								// convert things into formlyExpression things
								_angularFix2['default'].forEach(things, function (thing, index) {
									things[index] = getFormlyExpressionThing(thing);
								});

								var ngModelCtrls = scope.fc;
								if (!_angularFix2['default'].isArray(ngModelCtrls)) {
									ngModelCtrls = [ngModelCtrls];
								}

								_angularFix2['default'].forEach(ngModelCtrls, function (ngModelCtrl) {
									var _ngModelCtrl;

									ngModelCtrl['$' + which] = (_ngModelCtrl = ngModelCtrl['$' + which]).concat.apply(_ngModelCtrl, _toConsumableArray(things));
								});

								function getThingsFromType(theType) {
									if (!theType) {
										return [];
									}
									if (_angularFix2['default'].isString(theType)) {
										theType = formlyConfig.getType(theType, true, scope.options);
									}
									var typeThings = [];

									// get things from parent
									if (theType['extends']) {
										typeThings = formlyUtil.extendArray(typeThings, getThingsFromType(theType['extends']));
									}

									// get own type's things
									typeThings = formlyUtil.extendArray(typeThings, getDefaultOptionsProperty(theType, which, []));

									// get things from optionsTypes
									typeThings = formlyUtil.extendArray(typeThings, getThingsFromOptionsTypes(getDefaultOptionsOptionsTypes(theType)));

									return typeThings;
								}

								function getThingsFromOptionsTypes() {
									var optionsTypes = arguments.length <= 0 || arguments[0] === undefined ? [] : arguments[0];

									var optionsTypesThings = [];
									_angularFix2['default'].forEach(_angularFix2['default'].copy(arrayify(optionsTypes)).reverse(), function (optionsTypeName) {
										optionsTypesThings = formlyUtil.extendArray(optionsTypesThings, getThingsFromType(optionsTypeName));
									});
									return optionsTypesThings;
								}

								function getFormlyExpressionThing(thing) {
									formlyExpressionParserOrFormatterFunction[originalThingProp] = thing;
									return formlyExpressionParserOrFormatterFunction;

									function formlyExpressionParserOrFormatterFunction($viewValue) {
										var $modelValue = scope.options.value();
										return formlyUtil.formlyEval(scope, thing, $modelValue, $viewValue);
									}
								}
							}
						}

						function callLinkFunctions() {
							if (type && type.link) {
								type.link.apply(thusly, args);
							}
							if (scope.options.link) {
								scope.options.link.apply(thusly, args);
							}
						}

						function runManipulators(manipulators) {
							return function runManipulatorsOnTemplate(templateToManipulate) {
								var chain = $q.when(templateToManipulate);
								_angularFix2['default'].forEach(manipulators, function (manipulator) {
									chain = chain.then(function (template) {
										return $q.when(manipulator(template, scope.options, scope)).then(function (newTemplate) {
											return _angularFix2['default'].isString(newTemplate) ? newTemplate : asHtml(newTemplate);
										});
									});
								});
								return chain;
							};
						}
					}

					// sort-of stateless util functions
					function asHtml(el) {
						var wrapper = _angularFix2['default'].element('<a></a>');
						return wrapper.append(el).html();
					}

					function getFieldType(options) {
						return options.type && formlyConfig.getType(options.type);
					}

					function getManipulators(options, formOptions) {
						var preWrapper = [];
						var postWrapper = [];
						addManipulators(options.templateManipulators);
						addManipulators(formOptions.templateManipulators);
						addManipulators(formlyConfig.templateManipulators);
						return { preWrapper: preWrapper, postWrapper: postWrapper };

						function addManipulators(manipulators) {
							/* eslint-disable */ // it doesn't understand this :-(

							var _ref = manipulators || {};

							var _ref$preWrapper = _ref.preWrapper;
							var pre = _ref$preWrapper === undefined ? [] : _ref$preWrapper;
							var _ref$postWrapper = _ref.postWrapper;
							var post = _ref$postWrapper === undefined ? [] : _ref$postWrapper;

							preWrapper = preWrapper.concat(pre);
							postWrapper = postWrapper.concat(post);
							/* eslint-enable */
						}
					}

					function getFieldTemplate(options) {
						function fromOptionsOrType(key, fieldType) {
							if (_angularFix2['default'].isDefined(options[key])) {
								return options[key];
							} else if (fieldType && _angularFix2['default'].isDefined(fieldType[key])) {
								return fieldType[key];
							}
						}

						var type = formlyConfig.getType(options.type, true, options);
						var template = fromOptionsOrType('template', type);
						var templateUrl = fromOptionsOrType('templateUrl', type);
						if (_angularFix2['default'].isUndefined(template) && !templateUrl) {
							throw formlyUsability.getFieldError('type-type-has-no-template', 'Type \'' + options.type + '\' has no template. On element:', options);
						}

						return getTemplate(templateUrl || template, _angularFix2['default'].isUndefined(template), options);
					}

					function getTemplate(template, isUrl, options) {
						var templatePromise = undefined;
						if (_angularFix2['default'].isFunction(template)) {
							templatePromise = $q.when(template(options));
						} else {
							templatePromise = $q.when(template);
						}

						if (!isUrl) {
							return templatePromise;
						} else {
							var _ret3 = (function () {
								var httpOptions = { cache: $templateCache };
								return {
									v: templatePromise.then(function (url) {
										return $http.get(url, httpOptions);
									}).then(function (response) {
										return response.data;
									})['catch'](function handleErrorGettingATemplate(error) {
										formlyWarn('problem-loading-template-for-templateurl', 'Problem loading template for ' + template, error);
									})
								};
							})();

							if (typeof _ret3 === 'object') return _ret3.v;
						}
					}

					function transcludeInWrappers(options, formOptions) {
						var wrapper = getWrapperOption(options, formOptions);

						return function transcludeTemplate(template) {
							if (!wrapper.length) {
								return $q.when(template);
							}

							wrapper.forEach(function (aWrapper) {
								formlyUsability.checkWrapper(aWrapper, options);
								runApiCheck(aWrapper, options);
							});
							var promises = wrapper.map(function (w) {
								return getTemplate(w.template || w.templateUrl, !w.template);
							});
							return $q.all(promises).then(function (wrappersTemplates) {
								wrappersTemplates.forEach(function (wrapperTemplate, index) {
									formlyUsability.checkWrapperTemplate(wrapperTemplate, wrapper[index]);
								});
								wrappersTemplates.reverse(); // wrapper 0 is wrapped in wrapper 1 and so on...
								var totalWrapper = wrappersTemplates.shift();
								wrappersTemplates.forEach(function (wrapperTemplate) {
									totalWrapper = doTransclusion(totalWrapper, wrapperTemplate);
								});
								return doTransclusion(totalWrapper, template);
							});
						};
					}

					function doTransclusion(wrapper, template) {
						var superWrapper = _angularFix2['default'].element('<a></a>'); // this allows people not have to have a single root in wrappers
						superWrapper.append(wrapper);
						var transcludeEl = superWrapper.find('formly-transclude');
						if (!transcludeEl.length) {
							// try it using our custom find function
							transcludeEl = formlyUtil.findByNodeName(superWrapper, 'formly-transclude');
						}
						transcludeEl.replaceWith(template);
						return superWrapper.html();
					}

					function getWrapperOption(options, formOptions) {
						/* eslint complexity:[2, 6] */
						var wrapper = options.wrapper;
						// explicit null means no wrapper
						if (wrapper === null) {
							return [];
						}

						// nothing specified means use the default wrapper for the type
						if (!wrapper) {
							// get all wrappers that specify they apply to this type
							wrapper = arrayify(formlyConfig.getWrapperByType(options.type));
						} else {
							wrapper = arrayify(wrapper).map(formlyConfig.getWrapper);
						}

						// get all wrappers for that the type specified that it uses.
						var type = formlyConfig.getType(options.type, true, options);
						if (type && type.wrapper) {
							var typeWrappers = arrayify(type.wrapper).map(formlyConfig.getWrapper);
							wrapper = wrapper.concat(typeWrappers);
						}

						// add form wrappers
						if (formOptions.wrapper) {
							var formWrappers = arrayify(formOptions.wrapper).map(formlyConfig.getWrapper);
							wrapper = wrapper.concat(formWrappers);
						}

						// add the default wrapper last
						var defaultWrapper = formlyConfig.getWrapper();
						if (defaultWrapper) {
							wrapper.push(defaultWrapper);
						}
						return wrapper;
					}

					function checkApi(options) {
						formlyApiCheck['throw'](formlyApiCheck.formlyFieldOptions, options, {
							prefix: 'formly-field directive',
							url: 'formly-field-directive-validation-failed'
						});
						// validate with the type
						var type = options.type && formlyConfig.getType(options.type);
						if (type) {
							runApiCheck(type, options, true);
						}
						if (options.expressionProperties && options.expressionProperties.hide) {
							formlyWarn('dont-use-expressionproperties.hide-use-hideexpression-instead', 'You have specified `hide` in `expressionProperties`. Use `hideExpression` instead', options);
						}
					}

					function checkFieldGroupApi(options) {
						formlyApiCheck['throw'](formlyApiCheck.fieldGroup, options, {
							prefix: 'formly-field directive',
							url: 'formly-field-directive-validation-failed'
						});
					}

					function runApiCheck(_ref2, options, forType) {
						var apiCheck = _ref2.apiCheck;
						var apiCheckInstance = _ref2.apiCheckInstance;
						var apiCheckFunction = _ref2.apiCheckFunction;
						var apiCheckOptions = _ref2.apiCheckOptions;

						runApiCheckForType(apiCheck, apiCheckInstance, apiCheckFunction, apiCheckOptions, options);
						if (forType && options.type) {
							_angularFix2['default'].forEach(formlyConfig.getTypeHeritage(options.type), function (type) {
								runApiCheckForType(type.apiCheck, type.apiCheckInstance, type.apiCheckFunction, type.apiCheckOptions, options);
							});
						}
					}

					function runApiCheckForType(apiCheck, apiCheckInstance, apiCheckFunction, apiCheckOptions, options) {
						/* eslint complexity:[2, 9] */
						if (!apiCheck) {
							return;
						}
						var instance = apiCheckInstance || formlyConfig.extras.apiCheckInstance || formlyApiCheck;
						if (instance.config.disabled || _apiCheck2['default'].globalConfig.disabled) {
							return;
						}
						var fn = apiCheckFunction || 'warn';
						// this is the new API
						var checkerObjects = apiCheck(instance);
						_angularFix2['default'].forEach(checkerObjects, function (shape, name) {
							var checker = instance.shape(shape);
							var checkOptions = _angularFix2['default'].extend({
								prefix: 'formly-field type ' + options.type + ' for property ' + name,
								url: formlyApiCheck.config.output.docsBaseUrl + 'formly-field-type-apicheck-failed'
							}, apiCheckOptions);
							instance[fn](checker, options[name], checkOptions);
						});
					}
				}

				// Stateless util functions
				function getDefaultOptionsOptionsTypes(type) {
					return getDefaultOptionsProperty(type, 'optionsTypes', []);
				}

				function getDefaultOptionsProperty(type, prop, defaultValue) {
					return type.defaultOptions && type.defaultOptions[prop] || defaultValue;
				}
				module.exports = exports['default'];

				/***/
},
/* 15 */
/***/ function (module, exports) {

				'use strict';

				formlyFocus.$inject = ["$timeout", "$document"];
				Object.defineProperty(exports, '__esModule', {
					value: true
				});
				exports['default'] = formlyFocus;

				// @ngInject
				function formlyFocus($timeout, $document) {
					return {
						restrict: 'A',
						link: function formlyFocusLink(scope, element, attrs) {
							var previousEl = null;
							var el = element[0];
							var doc = $document[0];
							attrs.$observe('formlyFocus', function respondToFocusExpressionChange(value) {
								/* eslint no-bitwise:0 */ // I know what I'm doing. I promise...
								if (value === 'true') {
									$timeout(function setElementFocus() {
										previousEl = doc.activeElement;
										el.focus();
									}, ~ ~attrs.focusWait);
								} else if (value === 'false') {
									if (doc.activeElement === el) {
										el.blur();
										if (attrs.hasOwnProperty('refocus') && previousEl) {
											previousEl.focus();
										}
									}
								}
							});
						}
					};
				}
				module.exports = exports['default'];

				/***/
},
/* 16 */
/***/ function (module, exports, __webpack_require__) {

				'use strict';

				formlyForm.$inject = ["formlyUsability", "formlyWarn", "$parse", "formlyConfig", "$interpolate"];
				Object.defineProperty(exports, '__esModule', {
					value: true
				});

				function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

				var _angularFix = __webpack_require__(2);

				var _angularFix2 = _interopRequireDefault(_angularFix);

				exports['default'] = formlyForm;

				/**
				 * @ngdoc directive
				 * @name formlyForm
				 * @restrict AE
				 */
				// @ngInject
				function formlyForm(formlyUsability, formlyWarn, $parse, formlyConfig, $interpolate) {
					var currentFormId = 1;
					return {
						restrict: 'AE',
						template: formlyFormGetTemplate,
						replace: true,
						transclude: true,
						scope: {
							fields: '=',
							model: '=',
							form: '=?',
							options: '=?'
						},
						controller: 'FormlyFormController',
						link: formlyFormLink
					};

					function formlyFormGetTemplate(el, attrs) {
						var rootEl = getRootEl();
						var fieldRootEl = getFieldRootEl();
						var formId = 'formly_' + currentFormId++;
						var parentFormAttributes = '';
						if (attrs.hasOwnProperty('isFieldGroup') && el.parent().parent().hasClass('formly')) {
							parentFormAttributes = copyAttributes(el.parent().parent()[0].attributes);
						}
						return '\n        <' + rootEl + ' class="formly"\n                 name="' + getFormName() + '"\n                 role="form" ' + parentFormAttributes + '>\n          <' + fieldRootEl + ' formly-field\n               ng-repeat="field in fields ' + getTrackBy() + '"\n               ' + getHideDirective() + '="!field.hide"\n               class="formly-field"\n               options="field"\n               model="field.model || model"\n               original-model="model"\n               fields="fields"\n               form="theFormlyForm"\n               form-id="' + getFormName() + '"\n               form-state="options.formState"\n               form-options="options"\n               index="$index">\n          </' + fieldRootEl + '>\n          <div ng-transclude class="' + getTranscludeClass() + '"></div>\n        </' + rootEl + '>\n      ';

						function getRootEl() {
							return attrs.rootEl || 'ng-form';
						}

						function getFieldRootEl() {
							return attrs.fieldRootEl || 'div';
						}

						function getHideDirective() {
							return attrs.hideDirective || formlyConfig.extras.defaultHideDirective || 'ng-if';
						}

						function getTrackBy() {
							if (!attrs.trackBy) {
								return '';
							} else {
								return 'track by ' + attrs.trackBy;
							}
						}

						function getFormName() {
							var formName = formId;
							var bindName = attrs.bindName;
							if (bindName) {
								if (_angularFix2['default'].version.minor < 3) {
									throw formlyUsability.getFormlyError('bind-name attribute on formly-form not allowed in < angular 1.3');
								}
								// we can do a one-time binding here because we know we're in 1.3.x territory
								formName = $interpolate.startSymbol() + '::\'formly_\' + ' + bindName + $interpolate.endSymbol();
							}
							return formName;
						}

						function getTranscludeClass() {
							return attrs.transcludeClass || '';
						}

						function copyAttributes(attributes) {
							var excluded = ['model', 'form', 'fields', 'options', 'name', 'role', 'class', 'data-model', 'data-form', 'data-fields', 'data-options', 'data-name'];
							var arrayAttrs = [];
							_angularFix2['default'].forEach(attributes, function (_ref) {
								var nodeName = _ref.nodeName;
								var value = _ref.value;

								if (nodeName !== 'undefined' && excluded.indexOf(nodeName) === -1) {
									arrayAttrs.push(toKebabCase(nodeName) + '="' + value + '"');
								}
							});
							return arrayAttrs.join(' ');
						}
					}

					function formlyFormLink(scope, el, attrs) {
						setFormController();
						fixChromeAutocomplete();

						function setFormController() {
							var formId = attrs.name;
							scope.formId = formId;
							scope.theFormlyForm = scope[formId];
							if (attrs.form) {
								var getter = $parse(attrs.form);
								var setter = getter.assign;
								var parentForm = getter(scope.$parent);
								if (parentForm) {
									scope.theFormlyForm = parentForm;
									if (scope[formId]) {
										scope.theFormlyForm.$removeControl(scope[formId]);
									}

									// this next line is probably one of the more dangerous things that angular-formly does to improve the
									// API for angular-formly forms. It ensures that the NgModelControllers inside of formly-form will be
									// attached to the form that is passed to formly-form rather than the one that formly-form creates
									// this is necessary because it's confusing to have a step between the form you pass in
									// and the fields in that form. It also is because angular doesn't propagate properties like $submitted down
									// to children forms :-( This line was added to solve this issue:
									// https://github.com/formly-js/angular-formly/issues/287
									// luckily, this is how the formController has been accessed by the NgModelController since angular 1.0.0
									// so I expect it will remain this way for the life of angular 1.x
									el.removeData('$formController');
								} else {
									setter(scope.$parent, scope[formId]);
								}
							}
							if (!scope.theFormlyForm && !formlyConfig.disableWarnings) {
								/* eslint no-console:0 */
								formlyWarn('formly-form-has-no-formcontroller', 'Your formly-form does not have a `form` property. Many functions of the form (like validation) may not work', el, scope);
							}
						}

						/*
						 * chrome autocomplete lameness
						 * see https://code.google.com/p/chromium/issues/detail?id=468153#c14
						 * ლ(ಠ益ಠლ)   (╯°□°)╯︵ ┻━┻    (◞‸◟；)
						 */
						function fixChromeAutocomplete() {
							var global = formlyConfig.extras.removeChromeAutoComplete === true;
							var offInstance = scope.options && scope.options.removeChromeAutoComplete === false;
							var onInstance = scope.options && scope.options.removeChromeAutoComplete === true;
							if (global && !offInstance || onInstance) {
								var input = document.createElement('input');
								input.setAttribute('autocomplete', 'address-level4');
								input.setAttribute('hidden', 'true');
								el[0].appendChild(input);
							}
						}
					}

					// stateless util functions
					function toKebabCase(string) {
						if (string) {
							return string.replace(/([A-Z])/g, function ($1) {
								return '-' + $1.toLowerCase();
							});
						} else {
							return '';
						}
					}
				}
				module.exports = exports['default'];

				/***/
},
/* 17 */
/***/ function (module, exports, __webpack_require__) {

				'use strict';

				FormlyFormController.$inject = ["formlyUsability", "formlyWarn", "formlyConfig", "$parse", "$scope", "formlyApiCheck", "formlyUtil"];
				Object.defineProperty(exports, '__esModule', {
					value: true
				});
				var _slice = Array.prototype.slice;
				exports['default'] = FormlyFormController;

				function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

				function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) arr2[i] = arr[i]; return arr2; } else { return Array.from(arr); } }

				var _angularFix = __webpack_require__(2);

				var _angularFix2 = _interopRequireDefault(_angularFix);

				function isFieldGroup(field) {
					return field && !!field.fieldGroup;
				}

				// @ngInject

				function FormlyFormController(formlyUsability, formlyWarn, formlyConfig, $parse, $scope, formlyApiCheck, formlyUtil) {

					setupOptions();
					$scope.model = $scope.model || {};
					setupFields();

					// watch the model and evaluate watch expressions that depend on it.
					if (!$scope.options.manualModelWatcher) {
						$scope.$watch('model', onModelOrFormStateChange, true);
					} else if (_angularFix2['default'].isFunction($scope.options.manualModelWatcher)) {
						$scope.$watch($scope.options.manualModelWatcher, onModelOrFormStateChange, true);
					}

					if ($scope.options.formState) {
						$scope.$watch('options.formState', onModelOrFormStateChange, true);
					}

					function onModelOrFormStateChange() {
						_angularFix2['default'].forEach($scope.fields, runFieldExpressionProperties);
					}

					function validateFormControl(formControl, promise) {
						var validate = formControl.$validate;
						if (promise) {
							promise.then(function () {
								return validate.apply(formControl);
							});
						} else {
							validate();
						}
					}

					function runFieldExpressionProperties(field, index) {
						var model = field.model || $scope.model;
						var promise = field.runExpressions && field.runExpressions();
						if (field.hideExpression) {
							// can't use hide with expressionProperties reliably
							var val = model[field.key];
							field.hide = evalCloseToFormlyExpression(field.hideExpression, val, field, index, { model: model });
						}
						if (field.extras && field.extras.validateOnModelChange && field.formControl) {
							if (_angularFix2['default'].isArray(field.formControl)) {
								_angularFix2['default'].forEach(field.formControl, function (formControl) {
									validateFormControl(formControl, promise);
								});
							} else {
								validateFormControl(field.formControl, promise);
							}
						}
					}

					function setupFields() {
						$scope.fields = $scope.fields || [];

						checkDeprecatedOptions($scope.options);

						var fieldTransforms = $scope.options.fieldTransform || formlyConfig.extras.fieldTransform;

						if (!_angularFix2['default'].isArray(fieldTransforms)) {
							fieldTransforms = [fieldTransforms];
						}

						_angularFix2['default'].forEach(fieldTransforms, function transformFields(fieldTransform) {
							if (fieldTransform) {
								$scope.fields = fieldTransform($scope.fields, $scope.model, $scope.options, $scope.form);
								if (!$scope.fields) {
									throw formlyUsability.getFormlyError('fieldTransform must return an array of fields');
								}
							}
						});

						setupModels();

						if ($scope.options.watchAllExpressions) {
							_angularFix2['default'].forEach($scope.fields, setupHideExpressionWatcher);
						}

						_angularFix2['default'].forEach($scope.fields, attachKey); // attaches a key based on the index if a key isn't specified
						_angularFix2['default'].forEach($scope.fields, setupWatchers); // setup watchers for all fields
					}

					function checkDeprecatedOptions(options) {
						if (formlyConfig.extras.fieldTransform && _angularFix2['default'].isFunction(formlyConfig.extras.fieldTransform)) {
							formlyWarn('fieldtransform-as-a-function-deprecated', 'fieldTransform as a function has been deprecated.', 'Attempted for formlyConfig.extras: ' + formlyConfig.extras.fieldTransform.name, formlyConfig.extras);
						} else if (options.fieldTransform && _angularFix2['default'].isFunction(options.fieldTransform)) {
							formlyWarn('fieldtransform-as-a-function-deprecated', 'fieldTransform as a function has been deprecated.', 'Attempted for form', options);
						}
					}

					function setupOptions() {
						formlyApiCheck['throw']([formlyApiCheck.formOptionsApi.optional], [$scope.options], { prefix: 'formly-form options check' });
						$scope.options = $scope.options || {};
						$scope.options.formState = $scope.options.formState || {};

						_angularFix2['default'].extend($scope.options, {
							updateInitialValue: updateInitialValue,
							resetModel: resetModel
						});
					}

					function updateInitialValue() {
						_angularFix2['default'].forEach($scope.fields, function (field) {
							if (isFieldGroup(field) && field.options) {
								field.options.updateInitialValue();
							} else {
								field.updateInitialValue();
							}
						});
					}

					function resetModel() {
						_angularFix2['default'].forEach($scope.fields, function (field) {
							if (isFieldGroup(field) && field.options) {
								field.options.resetModel();
							} else if (field.resetModel) {
								field.resetModel();
							}
						});
					}

					function setupModels() {
						// a set of field models that are already watched (the $scope.model will have its own watcher)
						var watchedModels = [$scope.model];
						// we will not set up automatic model watchers if manual mode is set
						var manualModelWatcher = $scope.options.manualModelWatcher;

						if ($scope.options.formState) {
							// $scope.options.formState will have its own watcher
							watchedModels.push($scope.options.formState);
						}

						_angularFix2['default'].forEach($scope.fields, function (field) {
							var isNewModel = initModel(field);

							if (field.model && isNewModel && watchedModels.indexOf(field.model) === -1 && !manualModelWatcher) {
								$scope.$watch(function () {
									return field.model;
								}, onModelOrFormStateChange, true);
								watchedModels.push(field.model);
							}
						});
					}

					function setupHideExpressionWatcher(field, index) {
						if (field.hideExpression) {
							(function () {
								// can't use hide with expressionProperties reliably
								var model = field.model || $scope.model;
								$scope.$watch(function hideExpressionWatcher() {
									var val = model[field.key];
									return evalCloseToFormlyExpression(field.hideExpression, val, field, index, { model: model });
								}, function (hide) {
									return field.hide = hide;
								}, true);
							})();
						}
					}

					function initModel(field) {
						var isNewModel = true;

						if (_angularFix2['default'].isString(field.model)) {
							(function () {
								var expression = field.model;

								isNewModel = !referencesCurrentlyWatchedModel(expression);

								field.model = resolveStringModel(expression);

								$scope.$watch(function () {
									return resolveStringModel(expression);
								}, function (model) {
									return field.model = model;
								});
							})();
						}

						return isNewModel;

						function resolveStringModel(expression) {
							var index = $scope.fields.indexOf(field);
							var model = evalCloseToFormlyExpression(expression, undefined, field, index, { model: $scope.model });

							if (!model) {
								throw formlyUsability.getFieldError('field-model-must-be-initialized', 'Field model must be initialized. When specifying a model as a string for a field, the result of the' + ' expression must have been initialized ahead of time.', field);
							}

							return model;
						}
					}

					function referencesCurrentlyWatchedModel(expression) {
						return ['model', 'formState'].some(function (item) {
							return formlyUtil.startsWith(expression, item + '.') || formlyUtil.startsWith(expression, item + '[');
						});
					}

					function attachKey(field, index) {
						if (!isFieldGroup(field)) {
							field.key = field.key || index || 0;
						}
					}

					function setupWatchers(field, index) {
						if (!_angularFix2['default'].isDefined(field.watcher)) {
							return;
						}
						var watchers = field.watcher;
						if (!_angularFix2['default'].isArray(watchers)) {
							watchers = [watchers];
						}
						_angularFix2['default'].forEach(watchers, function setupWatcher(watcher) {
							if (!_angularFix2['default'].isDefined(watcher.listener) && !watcher.runFieldExpressions) {
								throw formlyUsability.getFieldError('all-field-watchers-must-have-a-listener', 'All field watchers must have a listener', field);
							}
							var watchExpression = getWatchExpression(watcher, field, index);
							var watchListener = getWatchListener(watcher, field, index);

							var type = watcher.type || '$watch';
							watcher.stopWatching = $scope[type](watchExpression, watchListener, watcher.watchDeep);
						});
					}

					function getWatchExpression(watcher, field, index) {
						var watchExpression = undefined;
						if (!_angularFix2['default'].isUndefined(watcher.expression)) {
							watchExpression = watcher.expression;
						} else if (field.key) {
							watchExpression = 'model[\'' + field.key.toString().split('.').join('\'][\'') + '\']';
						}
						if (_angularFix2['default'].isFunction(watchExpression)) {
							(function () {
								// wrap the field's watch expression so we can call it with the field as the first arg
								// and the stop function as the last arg as a helper
								var originalExpression = watchExpression;
								watchExpression = function formlyWatchExpression() {
									var args = modifyArgs.apply(undefined, [watcher, index].concat(_slice.call(arguments)));
									return originalExpression.apply(undefined, _toConsumableArray(args));
								};
								watchExpression.displayName = 'Formly Watch Expression for field for ' + field.key;
							})();
						} else if (field.model) {
							watchExpression = $parse(watchExpression).bind(null, $scope, { model: field.model });
						}
						return watchExpression;
					}

					function getWatchListener(watcher, field, index) {
						var watchListener = watcher.listener;
						if (_angularFix2['default'].isFunction(watchListener) || watcher.runFieldExpressions) {
							(function () {
								// wrap the field's watch listener so we can call it with the field as the first arg
								// and the stop function as the last arg as a helper
								var originalListener = watchListener;
								watchListener = function formlyWatchListener() {
									var value = undefined;
									if (originalListener) {
										var args = modifyArgs.apply(undefined, [watcher, index].concat(_slice.call(arguments)));
										value = originalListener.apply(undefined, _toConsumableArray(args));
									}
									if (watcher.runFieldExpressions) {
										runFieldExpressionProperties(field, index);
									}
									return value;
								};
								watchListener.displayName = 'Formly Watch Listener for field for ' + field.key;
							})();
						}
						return watchListener;
					}

					function modifyArgs(watcher, index) {
						for (var _len = arguments.length, originalArgs = Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++) {
							originalArgs[_key - 2] = arguments[_key];
						}

						return [$scope.fields[index]].concat(originalArgs, [watcher.stopWatching]);
					}

					function evalCloseToFormlyExpression(expression, val, field, index) {
						var extraLocals = arguments.length <= 4 || arguments[4] === undefined ? {} : arguments[4];

						extraLocals = _angularFix2['default'].extend(getFormlyFieldLikeLocals(field, index), extraLocals);
						return formlyUtil.formlyEval($scope, expression, val, val, extraLocals);
					}

					function getFormlyFieldLikeLocals(field, index) {
						// this makes it closer to what a regular formlyExpression would be
						return {
							model: field.model,
							options: field,
							index: index,
							formState: $scope.options.formState,
							originalModel: $scope.model,
							formOptions: $scope.options,
							formId: $scope.formId
						};
					}
				}

				module.exports = exports['default'];

				/***/
},
/* 18 */
/***/ function (module, exports, __webpack_require__) {

				'use strict';

				addFormlyNgModelAttrsManipulator.$inject = ["formlyConfig", "$interpolate"];
				Object.defineProperty(exports, '__esModule', {
					value: true
				});

				function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

				var _angularFix = __webpack_require__(2);

				var _angularFix2 = _interopRequireDefault(_angularFix);

				var _otherUtils = __webpack_require__(9);

				exports['default'] = addFormlyNgModelAttrsManipulator;

				// @ngInject
				function addFormlyNgModelAttrsManipulator(formlyConfig, $interpolate) {
					if (formlyConfig.extras.disableNgModelAttrsManipulator) {
						return;
					}
					formlyConfig.templateManipulators.preWrapper.push(ngModelAttrsManipulator);

					function ngModelAttrsManipulator(template, options, scope) {
						var node = document.createElement('div');
						var skip = options.extras && options.extras.skipNgModelAttrsManipulator;
						if (skip === true) {
							return template;
						}
						node.innerHTML = template;

						var modelNodes = getNgModelNodes(node, skip);
						if (!modelNodes || !modelNodes.length) {
							return template;
						}

						addIfNotPresent(modelNodes, 'id', scope.id);
						addIfNotPresent(modelNodes, 'name', scope.name || scope.id);

						addValidation();
						alterNgModelAttr();
						addModelOptions();
						addTemplateOptionsAttrs();
						addNgModelElAttrs();

						return node.innerHTML;

						function addValidation() {
							if (_angularFix2['default'].isDefined(options.validators) || _angularFix2['default'].isDefined(options.validation.messages)) {
								addIfNotPresent(modelNodes, 'formly-custom-validation', '');
							}
						}

						function alterNgModelAttr() {
							if (isPropertyAccessor(options.key)) {
								addRegardlessOfPresence(modelNodes, 'ng-model', 'model.' + options.key);
							}
						}

						function addModelOptions() {
							if (_angularFix2['default'].isDefined(options.modelOptions)) {
								addIfNotPresent(modelNodes, 'ng-model-options', 'options.modelOptions');
								if (options.modelOptions.getterSetter) {
									addRegardlessOfPresence(modelNodes, 'ng-model', 'options.value');
								}
							}
						}

						function addTemplateOptionsAttrs() {
							if (!options.templateOptions && !options.expressionProperties) {
								// no need to run these if there are no templateOptions or expressionProperties
								return;
							}
							var to = options.templateOptions || {};
							var ep = options.expressionProperties || {};

							var ngModelAttributes = getBuiltInAttributes();

							// extend with the user's specifications winning
							_angularFix2['default'].extend(ngModelAttributes, options.ngModelAttrs);

							// Feel free to make this more simple :-)
							_angularFix2['default'].forEach(ngModelAttributes, function (val, name) {
								/* eslint complexity:[2, 14] */
								var attrVal = undefined,
									attrName = undefined;
								var ref = 'options.templateOptions[\'' + name + '\']';
								var toVal = to[name];
								var epVal = getEpValue(ep, name);

								var inTo = _angularFix2['default'].isDefined(toVal);
								var inEp = _angularFix2['default'].isDefined(epVal);
								if (val.value) {
									// I realize this looks backwards, but it's right, trust me...
									attrName = val.value;
									attrVal = name;
								} else if (val.statement && inTo) {
									attrName = val.statement;
									if (_angularFix2['default'].isString(to[name])) {
										attrVal = '$eval(' + ref + ')';
									} else if (_angularFix2['default'].isFunction(to[name])) {
										attrVal = ref + '(model[options.key], options, this, $event)';
									} else {
										throw new Error('options.templateOptions.' + name + ' must be a string or function: ' + JSON.stringify(options));
									}
								} else if (val.bound && inEp) {
									attrName = val.bound;
									attrVal = ref;
								} else if ((val.attribute || val.boolean) && inEp) {
									attrName = val.attribute || val.boolean;
									attrVal = '' + $interpolate.startSymbol() + ref + $interpolate.endSymbol();
								} else if (val.attribute && inTo) {
									attrName = val.attribute;
									attrVal = toVal;
								} else if (val.boolean) {
									if (inTo && !inEp && toVal) {
										attrName = val.boolean;
										attrVal = true;
									} else {
										/* eslint no-empty:0 */
										// empty to illustrate that a boolean will not be added via val.bound
										// if you want it added via val.bound, then put it in expressionProperties
									}
								} else if (val.bound && inTo) {
									attrName = val.bound;
									attrVal = ref;
								}

								if (_angularFix2['default'].isDefined(attrName) && _angularFix2['default'].isDefined(attrVal)) {
									addIfNotPresent(modelNodes, attrName, attrVal);
								}
							});
						}

						function addNgModelElAttrs() {
							_angularFix2['default'].forEach(options.ngModelElAttrs, function (val, name) {
								addRegardlessOfPresence(modelNodes, name, val);
							});
						}
					}

					// Utility functions
					function getNgModelNodes(node, skip) {
						var selectorNot = _angularFix2['default'].isString(skip) ? ':not(' + skip + ')' : '';
						var skipNot = ':not([formly-skip-ng-model-attrs-manipulator])';
						var query = '[ng-model]' + selectorNot + skipNot + ', [data-ng-model]' + selectorNot + skipNot;
						try {
							return node.querySelectorAll(query);
						} catch (e) {
							//this code is needed for IE8, as it does not support the CSS3 ':not' selector
							//it should be removed when IE8 support is dropped
							return getNgModelNodesFallback(node, skip);
						}
					}

					function getNgModelNodesFallback(node, skip) {
						var allNgModelNodes = node.querySelectorAll('[ng-model], [data-ng-model]');
						var matchingNgModelNodes = [];

						//make sure this array is compatible with NodeList type by adding an 'item' function
						matchingNgModelNodes.item = function (i) {
							return this[i];
						};

						for (var i = 0; i < allNgModelNodes.length; i++) {
							var ngModelNode = allNgModelNodes[i];
							if (!ngModelNode.hasAttribute('formly-skip-ng-model-attrs-manipulator') && !(_angularFix2['default'].isString(skip) && nodeMatches(ngModelNode, skip))) {
								matchingNgModelNodes.push(ngModelNode);
							}
						}

						return matchingNgModelNodes;
					}

					function nodeMatches(node, selector) {
						var div = document.createElement('div');
						div.innerHTML = node.outerHTML;
						return div.querySelector(selector);
					}

					function getBuiltInAttributes() {
						var ngModelAttributes = {
							focus: {
								attribute: 'formly-focus'
							}
						};
						var boundOnly = [];
						var bothBooleanAndBound = ['required', 'disabled'];
						var bothAttributeAndBound = ['pattern', 'minlength'];
						var statementOnly = ['change', 'keydown', 'keyup', 'keypress', 'click', 'focus', 'blur'];
						var attributeOnly = ['placeholder', 'min', 'max', 'step', 'tabindex', 'type'];
						if (formlyConfig.extras.ngModelAttrsManipulatorPreferUnbound) {
							bothAttributeAndBound.push('maxlength');
						} else {
							boundOnly.push('maxlength');
						}

						_angularFix2['default'].forEach(boundOnly, function (item) {
							ngModelAttributes[item] = { bound: 'ng-' + item };
						});

						_angularFix2['default'].forEach(bothBooleanAndBound, function (item) {
							ngModelAttributes[item] = { boolean: item, bound: 'ng-' + item };
						});

						_angularFix2['default'].forEach(bothAttributeAndBound, function (item) {
							ngModelAttributes[item] = { attribute: item, bound: 'ng-' + item };
						});

						_angularFix2['default'].forEach(statementOnly, function (item) {
							var propName = 'on' + item.substr(0, 1).toUpperCase() + item.substr(1);
							ngModelAttributes[propName] = { statement: 'ng-' + item };
						});

						_angularFix2['default'].forEach(attributeOnly, function (item) {
							ngModelAttributes[item] = { attribute: item };
						});
						return ngModelAttributes;
					}

					function getEpValue(ep, name) {
						return ep['templateOptions.' + name] || ep['templateOptions[\'' + name + '\']'] || ep['templateOptions["' + name + '"]'];
					}

					function addIfNotPresent(nodes, attr, val) {
						_angularFix2['default'].forEach(nodes, function (node) {
							if (!node.getAttribute(attr)) {
								node.setAttribute(attr, val);
							}
						});
					}

					function addRegardlessOfPresence(nodes, attr, val) {
						_angularFix2['default'].forEach(nodes, function (node) {
							node.setAttribute(attr, val);
						});
					}

					function isPropertyAccessor(key) {
						return (0, _otherUtils.contains)(key, '.') || (0, _otherUtils.contains)(key, '[') && (0, _otherUtils.contains)(key, ']');
					}
				}
				module.exports = exports['default'];

				/***/
},
/* 19 */
/***/ function (module, exports, __webpack_require__) {

				'use strict';

				addCustomTags.$inject = ["$document"];
				Object.defineProperty(exports, '__esModule', {
					value: true
				});

				function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

				var _angularFix = __webpack_require__(2);

				var _angularFix2 = _interopRequireDefault(_angularFix);

				exports['default'] = addCustomTags;

				// @ngInject
				function addCustomTags($document) {
					// IE8 check ->
					// https://msdn.microsoft.com/en-us/library/cc196988(v=vs.85).aspx
					if ($document && $document.documentMode < 9) {
						(function () {
							var document = $document.get(0);
							// add the custom elements that we need for formly
							var customElements = ['formly-field', 'formly-form'];
							_angularFix2['default'].forEach(customElements, function (el) {
								document.createElement(el);
							});
						})();
					}
				}
				module.exports = exports['default'];

				/***/
}
/******/])
});
;
//! angular-formly-templates-bootstrap version 6.5.1 built with ♥ by Astrism <astrisms@gmail.com>, Kent C. Dodds <kent@doddsfamily.us> (ó ì_í)=óò=(ì_í ò)

(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("angular"), require("angular-formly"), require("api-check"));
	else if(typeof define === 'function' && define.amd)
		define(["angular", "angular-formly", "api-check"], factory);
	else if(typeof exports === 'object')
		exports["ngFormlyTemplatesBootstrap"] = factory(require("angular"), require("angular-formly"), require("api-check"));
	else
		root["ngFormlyTemplatesBootstrap"] = factory(root["angular"], root["ngFormly"], root["apiCheck"]);
})(this, function(__WEBPACK_EXTERNAL_MODULE_3__, __WEBPACK_EXTERNAL_MODULE_4__, __WEBPACK_EXTERNAL_MODULE_5__) {
return /******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};

/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {

/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;

/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};

/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;

/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}


/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;

/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;

/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";

/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';

	module.exports = __webpack_require__(1);

/***/ },
/* 1 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';

	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	var ngModuleName = 'formlyBootstrap';
	var angular = __webpack_require__(2);
	var ngModule = angular.module(ngModuleName, [__webpack_require__(4)]);
	ngModule.constant('formlyBootstrapApiCheck', __webpack_require__(5)({
	  output: {
	    prefix: 'angular-formly-bootstrap'
	  }
	}));
	ngModule.constant('formlyBootstrapVersion', ("6.5.1"));

	__webpack_require__(6)(ngModule);
	__webpack_require__(9)(ngModule);
	__webpack_require__(19)(ngModule);

	exports['default'] = ngModuleName;
	module.exports = exports['default'];

/***/ },
/* 2 */
/***/ function(module, exports, __webpack_require__) {

	// some versions of angular don't export the angular module properly,
	// so we get it from window in this case.
	'use strict';

	var angular = __webpack_require__(3);
	if (!angular.version) {
	  angular = window.angular;
	}
	module.exports = angular;

/***/ },
/* 3 */
/***/ function(module, exports) {

	module.exports = __WEBPACK_EXTERNAL_MODULE_3__;

/***/ },
/* 4 */
/***/ function(module, exports) {

	module.exports = __WEBPACK_EXTERNAL_MODULE_4__;

/***/ },
/* 5 */
/***/ function(module, exports) {

	module.exports = __WEBPACK_EXTERNAL_MODULE_5__;

/***/ },
/* 6 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';

	Object.defineProperty(exports, '__esModule', {
	  value: true
	});

	exports['default'] = function (ngModule) {
	  ngModule.config(addWrappers);

	  function addWrappers(formlyConfigProvider) {
	    formlyConfigProvider.setWrapper([{
	      name: 'bootstrapLabel',
	      template: __webpack_require__(7),
	      apiCheck: function apiCheck(check) {
	        return {
	          templateOptions: {
	            label: check.string.optional,
	            required: check.bool.optional,
	            labelSrOnly: check.bool.optional
	          }
	        };
	      }
	    }, { name: 'bootstrapHasError', template: __webpack_require__(8) }]);
	  }
	  addWrappers.$inject = ["formlyConfigProvider"];
	};

	module.exports = exports['default'];

/***/ },
/* 7 */
/***/ function(module, exports) {

	module.exports = "<div>\n  <label for=\"{{id}}\" class=\"control-label {{to.labelSrOnly ? 'sr-only' : ''}}\" ng-if=\"to.label\">\n    {{to.label}}\n    {{to.required ? '*' : ''}}\n  </label>\n  <formly-transclude></formly-transclude>\n</div>\n"

/***/ },
/* 8 */
/***/ function(module, exports) {

	module.exports = "<div class=\"form-group\" ng-class=\"{'has-error': showError}\">\n  <formly-transclude></formly-transclude>\n</div>\n"

/***/ },
/* 9 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';

	Object.defineProperty(exports, '__esModule', {
	  value: true
	});

	exports['default'] = function (ngModule) {
	  __webpack_require__(10)(ngModule);
	  __webpack_require__(12)(ngModule);
	  __webpack_require__(14)(ngModule);
	  __webpack_require__(15)(ngModule);
	  __webpack_require__(17)(ngModule);
	  __webpack_require__(18)(ngModule);
	};

	module.exports = exports['default'];

/***/ },
/* 10 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';

	Object.defineProperty(exports, '__esModule', {
	  value: true
	});

	exports['default'] = function (ngModule) {
	  ngModule.config(addCheckboxType);

	  function addCheckboxType(formlyConfigProvider) {
	    formlyConfigProvider.setType({
	      name: 'checkbox',
	      template: __webpack_require__(11),
	      wrapper: ['bootstrapHasError'],
	      apiCheck: function apiCheck(check) {
	        return {
	          templateOptions: {
	            label: check.string
	          }
	        };
	      }
	    });
	  }
	  addCheckboxType.$inject = ["formlyConfigProvider"];
	};

	module.exports = exports['default'];

/***/ },
/* 11 */
/***/ function(module, exports) {

	module.exports = "<div class=\"checkbox\">\n\t<label>\n\t\t<input type=\"checkbox\"\n           class=\"formly-field-checkbox\"\n\t\t       ng-model=\"model[options.key]\">\n\t\t{{to.label}}\n\t\t{{to.required ? '*' : ''}}\n\t</label>\n</div>\n"

/***/ },
/* 12 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';

	Object.defineProperty(exports, '__esModule', {
	  value: true
	});

	exports['default'] = function (ngModule) {
	  ngModule.config(addCheckboxType);

	  function addCheckboxType(formlyConfigProvider) {
	    formlyConfigProvider.setType({
	      name: 'multiCheckbox',
	      template: __webpack_require__(13),
	      wrapper: ['bootstrapLabel', 'bootstrapHasError'],
	      apiCheck: function apiCheck(check) {
	        return {
	          templateOptions: {
	            options: check.arrayOf(check.object),
	            labelProp: check.string.optional,
	            valueProp: check.string.optional
	          }
	        };
	      },
	      defaultOptions: {
	        noFormControl: false,
	        ngModelAttrs: {
	          required: {
	            attribute: '',
	            bound: ''
	          }
	        }
	      },
	      controller: /* @ngInject */["$scope", function controller($scope) {
	        var to = $scope.to;
	        var opts = $scope.options;
	        $scope.multiCheckbox = {
	          checked: [],
	          change: setModel
	        };

	        // initialize the checkboxes check property
	        $scope.$watch('model', function modelWatcher(newModelValue) {
	          var modelValue, valueProp;

	          if (Object.keys(newModelValue).length) {
	            modelValue = newModelValue[opts.key];

	            $scope.$watch('to.options', function optionsWatcher(newOptionsValues) {
	              if (newOptionsValues && Array.isArray(newOptionsValues) && Array.isArray(modelValue)) {
	                valueProp = to.valueProp || 'value';
	                for (var index = 0; index < newOptionsValues.length; index++) {
	                  $scope.multiCheckbox.checked[index] = modelValue.indexOf(newOptionsValues[index][valueProp]) !== -1;
	                }
	              }
	            });
	          }
	        }, true);

	        function checkValidity(expressionValue) {
	          var valid;

	          if ($scope.to.required) {
	            valid = angular.isArray($scope.model[opts.key]) && $scope.model[opts.key].length > 0 && expressionValue;

	            $scope.fc.$setValidity('required', valid);
	          }
	        }

	        function setModel() {
	          $scope.model[opts.key] = [];
	          angular.forEach($scope.multiCheckbox.checked, function (checkbox, index) {
	            if (checkbox) {
	              $scope.model[opts.key].push(to.options[index][to.valueProp || 'value']);
	            }
	          });

	          // Must make sure we mark as touched because only the last checkbox due to a bug in angular.
	          $scope.fc.$setTouched();
	          checkValidity(true);

	          if ($scope.to.onChange) {
	            $scope.to.onChange();
	          }
	        }

	        if (opts.expressionProperties && opts.expressionProperties['templateOptions.required']) {
	          $scope.$watch(function () {
	            return $scope.to.required;
	          }, function (newValue) {
	            checkValidity(newValue);
	          });
	        }

	        if ($scope.to.required) {
	          var unwatchFormControl = $scope.$watch('fc', function (newValue) {
	            if (!newValue) {
	              return;
	            }
	            checkValidity(true);
	            unwatchFormControl();
	          });
	        }
	      }]
	    });
	  }
	  addCheckboxType.$inject = ["formlyConfigProvider"];
	};

	module.exports = exports['default'];

/***/ },
/* 13 */
/***/ function(module, exports) {

	module.exports = "<div class=\"radio-group\">\n  <div ng-repeat=\"(key, option) in to.options\" class=\"checkbox\">\n    <label>\n      <input type=\"checkbox\"\n             id=\"{{id + '_'+ $index}}\"\n             ng-model=\"multiCheckbox.checked[$index]\"\n             ng-change=\"multiCheckbox.change()\">\n      {{option[to.labelProp || 'name']}}\n    </label>\n  </div>\n</div>\n"

/***/ },
/* 14 */
/***/ function(module, exports) {

	'use strict';

	Object.defineProperty(exports, '__esModule', {
	  value: true
	});

	exports['default'] = function (ngModule) {
	  ngModule.config(addInputType);

	  function addInputType(formlyConfigProvider) {
	    formlyConfigProvider.setType({
	      name: 'input',
	      template: '<input class="form-control" ng-model="model[options.key]">',
	      wrapper: ['bootstrapLabel', 'bootstrapHasError']
	    });
	  }
	  addInputType.$inject = ["formlyConfigProvider"];
	};

	module.exports = exports['default'];

/***/ },
/* 15 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';

	Object.defineProperty(exports, '__esModule', {
	  value: true
	});

	exports['default'] = function (ngModule) {
	  ngModule.config(addRadioType);

	  function addRadioType(formlyConfigProvider) {
	    formlyConfigProvider.setType({
	      name: 'radio',
	      template: __webpack_require__(16),
	      wrapper: ['bootstrapLabel', 'bootstrapHasError'],
	      defaultOptions: {
	        noFormControl: false
	      },
	      apiCheck: function apiCheck(check) {
	        return {
	          templateOptions: {
	            options: check.arrayOf(check.object),
	            labelProp: check.string.optional,
	            valueProp: check.string.optional,
	            inline: check.bool.optional
	          }
	        };
	      }
	    });
	  }
	  addRadioType.$inject = ["formlyConfigProvider"];
	};

	module.exports = exports['default'];

/***/ },
/* 16 */
/***/ function(module, exports) {

	module.exports = "<div class=\"radio-group\">\n  <div ng-repeat=\"(key, option) in to.options\" ng-class=\"{ 'radio': !to.inline, 'radio-inline': to.inline }\">\n    <label>\n      <input type=\"radio\"\n             id=\"{{id + '_'+ $index}}\"\n             tabindex=\"0\"\n             ng-value=\"option[to.valueProp || 'value']\"\n             ng-model=\"model[options.key]\">\n      {{option[to.labelProp || 'name']}}\n    </label>\n  </div>\n</div>\n"

/***/ },
/* 17 */
/***/ function(module, exports) {

	'use strict';

	Object.defineProperty(exports, '__esModule', {
	  value: true
	});

	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

	exports['default'] = function (ngModule) {
	  ngModule.config(addSelectType);

	  var template = '<select class="form-control" ng-model="model[options.key]">\n      <option ng-hide="to.notNull" value="">{{to.nullDisplay}}</option>\n  </select>';

	  function addSelectType(formlyConfigProvider) {
	    formlyConfigProvider.setType({
	      name: 'select',
	      template: template,
	      wrapper: ['bootstrapLabel', 'bootstrapHasError'],
	      defaultOptions: function defaultOptions(options) {
	        /* jshint maxlen:195 */
	        var ngOptions = options.templateOptions.ngOptions || 'option[to.valueProp || \'value\'] as option[to.labelProp || \'name\'] group by option[to.groupProp || \'group\'] for option in to.options';
	        return {
	          ngModelAttrs: _defineProperty({}, ngOptions, {
	            value: options.templateOptions.optionsAttr || 'ng-options'
	          })
	        };
	      },
	      apiCheck: function apiCheck(check) {
	        return {
	          templateOptions: {
	            options: check.arrayOf(check.object),
	            optionsAttr: check.string.optional,
	            labelProp: check.string.optional,
	            valueProp: check.string.optional,
	            groupProp: check.string.optional,
	            notNull: check.bool.optional,
	            nullDisplay: check.string.optional
	          }
	        };
	      }
	    });
	  }
	  addSelectType.$inject = ["formlyConfigProvider"];
	};

	module.exports = exports['default'];

/***/ },
/* 18 */
/***/ function(module, exports) {

	'use strict';

	Object.defineProperty(exports, '__esModule', {
	  value: true
	});

	exports['default'] = function (ngModule) {
	  ngModule.config(addTextareaType);

	  function addTextareaType(formlyConfigProvider) {
	    formlyConfigProvider.setType({
	      name: 'textarea',
	      template: '<textarea class="form-control" ng-model="model[options.key]"></textarea>',
	      wrapper: ['bootstrapLabel', 'bootstrapHasError'],
	      defaultOptions: {
	        ngModelAttrs: {
	          rows: { attribute: 'rows' },
	          cols: { attribute: 'cols' }
	        }
	      },
	      apiCheck: function apiCheck(check) {
	        return {
	          templateOptions: {
	            rows: check.number.optional,
	            cols: check.number.optional
	          }
	        };
	      }
	    });
	  }
	  addTextareaType.$inject = ["formlyConfigProvider"];
	};

	module.exports = exports['default'];

/***/ },
/* 19 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';

	Object.defineProperty(exports, '__esModule', {
	  value: true
	});

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

	var _addons = __webpack_require__(20);

	var _addons2 = _interopRequireDefault(_addons);

	var _description = __webpack_require__(22);

	var _description2 = _interopRequireDefault(_description);

	exports['default'] = function (ngModule) {
	  (0, _addons2['default'])(ngModule);
	  (0, _description2['default'])(ngModule);
	};

	module.exports = exports['default'];

/***/ },
/* 20 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';

	Object.defineProperty(exports, '__esModule', {
	  value: true
	});

	exports['default'] = function (ngModule) {
	  ngModule.run(addAddonsManipulator);

	  function addAddonsManipulator(formlyConfig, formlyBootstrapApiCheck) {
	    var addonTemplate = __webpack_require__(21);
	    var addonChecker = formlyBootstrapApiCheck.shape({
	      'class': formlyBootstrapApiCheck.string.optional,
	      text: formlyBootstrapApiCheck.string.optional,
	      onClick: formlyBootstrapApiCheck.func.optional
	    }).strict.optional;
	    var api = formlyBootstrapApiCheck.shape({
	      templateOptions: formlyBootstrapApiCheck.shape({
	        addonLeft: addonChecker,
	        addonRight: addonChecker
	      })
	    });
	    formlyConfig.templateManipulators.preWrapper.push(function (template, options) {
	      if (!options.templateOptions.addonLeft && !options.templateOptions.addonRight) {
	        return template;
	      }
	      formlyBootstrapApiCheck.warn([api], [options]);
	      return addonTemplate.replace('<formly-transclude></formly-transclude>', template);
	    });
	  }
	  addAddonsManipulator.$inject = ["formlyConfig", "formlyBootstrapApiCheck"];
	};

	module.exports = exports['default'];

/***/ },
/* 21 */
/***/ function(module, exports) {

	module.exports = "<div ng-class=\"{'input-group': to.addonLeft || to.addonRight}\">\n    <div class=\"input-group-addon\"\n         ng-if=\"to.addonLeft\"\n         ng-style=\"{cursor: to.addonLeft.onClick ? 'pointer' : 'inherit'}\"\n         ng-click=\"to.addonLeft.onClick(options, this, $event)\">\n        <i class=\"{{to.addonLeft.class}}\" ng-if=\"to.addonLeft.class\"></i>\n        <span ng-if=\"to.addonLeft.text\">{{to.addonLeft.text}}</span>\n    </div>\n    <formly-transclude></formly-transclude>\n    <div class=\"input-group-addon\"\n         ng-if=\"to.addonRight\"\n         ng-style=\"{cursor: to.addonRight.onClick ? 'pointer' : 'inherit'}\"\n         ng-click=\"to.addonRight.onClick(options, this, $event)\">\n        <i class=\"{{to.addonRight.class}}\" ng-if=\"to.addonRight.class\"></i>\n        <span ng-if=\"to.addonRight.text\">{{to.addonRight.text}}</span>\n    </div>\n</div>\n"

/***/ },
/* 22 */
/***/ function(module, exports) {

	'use strict';

	Object.defineProperty(exports, '__esModule', {
	  value: true
	});

	exports['default'] = function (ngModule) {
	  ngModule.run(addDescriptionManipulator);

	  function addDescriptionManipulator(formlyConfig) {
	    formlyConfig.templateManipulators.preWrapper.push(function ariaDescribedBy(template, options, scope) {
	      if (angular.isDefined(options.templateOptions.description)) {
	        var el = document.createElement('div');
	        el.appendChild(angular.element(template)[0]);
	        el.appendChild(angular.element('<p id="' + scope.id + '_description"' + 'class="help-block"' + 'ng-if="to.description">' + '{{to.description}}' + '</p>')[0]);
	        var modelEls = angular.element(el.querySelectorAll('[ng-model]'));
	        if (modelEls) {
	          modelEls.attr('aria-describedby', scope.id + '_description');
	        }
	        return el.innerHTML;
	      } else {
	        return template;
	      }
	    });
	  }
	  addDescriptionManipulator.$inject = ["formlyConfig"];
	};

	module.exports = exports['default'];

/***/ }
/******/ ])
});
;
/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function () {
  'use strict';

  var angular = window.angular
  angular.module('Vibzer.components', [
    'ui.router',
    'Vibzer.components.users',
    'Vibzer.components.machines.trends',
    'Vibzer.components.hierarchy',
    'Vibzer.components.organization',
    'Vibzer.components.machines',
    'Vibzer.components.graphs',
    'Vibzer.components.users.userDetails',
    'Vibzer.components.customer',
    'Vibzer.components.customerActions',
    'Vibzer.components.machineReport',
    'Vibzer.components.distributor'
  ])
    .config(routeConfig);

  /** @ngInject */
  function routeConfig ($stateProvider, $urlRouterProvider) {
    $urlRouterProvider.otherwise('/login');
    $stateProvider
      .state('login', {
        url: '/login',
        templateUrl: 'app/components/login/login.html',
        controller: 'LoginCtrl'
      })
      .state('machines', {
        url: '/machines?:sort&order&searchText&currentPage&machineData',
        title: 'Machines',
        templateUrl: 'app/components/machines/machines.html',
        controller: 'MachinesCtrl',
        reloadOnSearch: false,
        hide: false,
        data: {
          requiresLogin: true
        },
        resolve: {
          data: function () { return {} }
        },
        sidebarMeta: {
          icon: 'icon-motor',
          order: 100
        }
      })
      .state('customers', {
        url: '/customers?:filterId&sort&order&searchText&currentPage&salesRep',
        title: 'Customers',
        templateUrl: 'app/components/customers/customers.html',
        controller: 'CustomerCtrl',
        hide: true,
        reloadOnSearch: false,
        data: {
          requiresLogin: true
        },
        sidebarMeta: {
          icon: 'fa fa-user',
          order: 100
        }
      })
      .state('distributors', {
        url: '/distributors?:filterId&sort&order&searchText&currentPage',
        title: 'Distributors',
        templateUrl: 'app/components/distributor/distributors.html',
        controller: 'DistributorCtrl',
        hide: true,
        reloadOnSearch: false,
        data: {
          requiresLogin: true
        }
      })
      .state('users', {
        url: '/users?:sort&order&searchText&currentPage&filterId',
        title: 'Users',
        templateUrl: 'app/components/users/users.html',
        controller: 'UsersCtrl',
        hide: false,
        reloadOnSearch: false,
        data: {
          requiresLogin: true
        },
        sidebarMeta: {
          icon: 'fa fa-user',
          order: 250
        }
      })
      .state('organization', {
        url: '/organization?:organizationId&currentPage&navigation&sort&order&searchText',
        title: 'Organization',
        templateUrl: 'app/components/organization/organization.html',
        controller: 'OrganizationCtrl',
        hide: false,
        reloadOnSearch: false,
        data: {
          requiresLogin: true
        },
        sidebarMeta: {
          icon: 'fa fa-sitemap',
          order: 350
        },
        resolve: {
          hierarchyData: ['HierarchyService', 'CustomerService', '$rootScope', '$stateParams', 'toastr', '$q', function (HierarchyService, CustomerService, $rootScope, $stateParams, toastr, $q) {
            return getHierarchyData(HierarchyService, CustomerService, $rootScope, $stateParams, toastr, $q, 'edit')
          }]
        }
      })
      .state('hierarchy', {
        url: '/hierarchy?:hierarchyId&currentPage&navigation&sort&order&searchText',
        title: 'Org Structure',
        templateUrl: 'app/components/hierarchy/hierarchy.html',
        controller: 'HierarchyCtrl',
        hide: false,
        reloadOnSearch: false,
        data: {
          requiresLogin: true
        },
        sidebarMeta: {
          icon: 'fa fa-sitemap',
          order: 200
        },
        resolve: {
          hierarchyData: ['HierarchyService', 'CustomerService', '$rootScope', '$stateParams', 'toastr', '$q', function (HierarchyService, CustomerService, $rootScope, $stateParams, toastr, $q) {
            return getHierarchyData(HierarchyService, CustomerService, $rootScope, $stateParams, toastr, $q, 'edit')
          }]
        }
      })
      .state('licenses', {
        url: '/licenses?:customerId&tab&searchText&issuedBy&handheldDevicePage&analysisPage&fixedDevicePage&subscriptionPage',
        templateUrl: 'app/components/Licenses/licenses.html',
        controller: 'LicensesCtrl',
        title: 'Licenses',
        reloadOnSearch: false,
        data: {
          requiresLogin: true
        },
        sidebarMeta: {
          icon: 'fa fa-key',
          order: 300
        },
        resolve: {
          customerData: ['CustomerService', '$rootScope', '$stateParams', 'toastr', '$q', function (CustomerService, $rootScope, $stateParams, toastr, $q) {
            return getCustomerData(CustomerService, $rootScope, $stateParams, toastr, $q)
          }]
        }
      })
      .state('licensesFromCustomer', {
        url: '/customer/:customerId/licenses?tab&searchText&issuedBy&handheldDevicePage&analysisPage&fixedDevicePage&subscriptionPage',
        templateUrl: 'app/components/Licenses/licenses.html',
        controller: 'LicensesCtrl',
        title: 'Licenses',
        reloadOnSearch: false,
        data: {
          requiresLogin: true
        },
        sidebarMeta: {
          icon: 'fa fa-key',
          order: 300
        },
        resolve: {
          customerData: ['CustomerService', '$rootScope', '$stateParams', 'toastr', '$q', function (CustomerService, $rootScope, $stateParams, toastr, $q) {
            return getCustomerData(CustomerService, $rootScope, $stateParams, toastr, $q)
          }]
        }
      })
      .state('dashboard', {
        url: '/dashboard',
        templateUrl: 'app/components/dashboard/dashboard.html',
        controller: 'DashboardCtrl',
        title: 'Dashboard',
        data: {
          requiresLogin: true
        },
        sidebarMeta: {
          icon: 'icon-view-dashboard',
          order: 50
        },
        resolve: {
          userData: ['$rootScope', function ($rootScope) {
            return $rootScope.user
          }]
        }
      })
      .state('androidDashboard', {
        url: '/mobile/dashboard?tkn&id',
        templateUrl: 'app/components/dashboard/dashboard.html',
        controller: 'DashboardCtrl',
        title: 'Dashboard',
        data: {
          requiresLogin: false
        },
        sidebarMeta: {
          icon: 'ion-android-home',
          order: 0
        },
        resolve: {
          userData: ['UserService', '$rootScope', '$stateParams', 'toastr', '$q', '$cookies', function (UserService, $rootScope, $stateParams, toastr, $q, $cookies) {
            $cookies.put('authToken', $stateParams.tkn)
            $cookies.putObject('vcUser', { _id: $stateParams.id })
            var user = UserService.resource.getDetails({ additionalInfo: true })
            return user.$promise.then(function (res) {
              $rootScope.user = res
              $cookies.putObject('vcUser', res)
              return UserService.getAllPermissionsOfUser(res._id, null, null, function (data) {
                return data
              })
            })
          }]
        }
      })
      .state('routes', {
        url: '/routes?:sort&order&searchText&currentPage&routeFilters',
        title: 'Routes',
        templateUrl: 'app/components/commonHTMLs/list.html',
        controller: 'RoutesCtrl',
        data: {
          requiresLogin: true
        },
        sidebarMeta: {
          icon: 'fa fa-road',
          order: 150
        }
      })
      .state('compositeMachines', {
        url: '/compositeMachines?:sort&order&searchText&currentPage&compositeData',
        title: 'Composite Machines',
        templateUrl: 'app/components/commonHTMLs/list.html',
        controller: 'CompositeMachinesCtrl',
        reloadOnSearch: false,
        hide: false,
        data: {
          requiresLogin: true
        },
        resolve: {
          compositeMachineData: function () { return {} }
        },
        sidebarMeta: {
          icon: 'icon-composite',
          order: 200
        }
      })
      .state('devices', {
        url: '/devices?:currentPage&type&state&searchText&deviceData',
        title: 'Devices',
        templateUrl: 'app/components/devices/devices.html',
        controller: 'DevicesCtrl',
        reloadOnSearch: false,
        hide: false,
        data: {
          requiresLogin: true
        },
        resolve: {
          devicesData: function () { return {} }
        },
        sidebarMeta: {
          icon: 'icon-device_icon',
          order: 200
        }
      })
      .state('allDevices', {
        url: '/allDevices?:currentPage&type&state&searchText&deviceData',
        title: 'Devices',
        templateUrl: 'app/components/devices/allDeviceList.html',
        controller: 'AllDevicesCtrl',
        reloadOnSearch: false,
        hide: false,
        data: {
          requiresLogin: true
        },
        resolve: {
          devicesData: function () { return {} }
        },
        sidebarMeta: {
          icon: 'icon-device_icon',
          order: 200
        }
      })
      .state('loginAsCustomer', {
        url: '/loginAsCustomer',
        title: 'Login As Customer',
        controller: 'DemoCustomerDetailsCtrl',
        reloadOnSearch: false,
        hide: false,
        data: {
          requiresLogin: true
        },
        resolve: {},
        sidebarMeta: {
          icon: 'fa fa-sign-in',
          order: 600
        }
      })
      .state('rpb', {
        url: '/rpb',
        title: 'Download Rpb',
        templateUrl: 'app/components/rpb/downloadRpb.html',
        controller: 'DownloadRpbCtrl',
        hide: false,
        data: {
          requiresLogin: true
        },
        resolve: {},
        sidebarMeta: {
          icon: 'fa fa-download',
          order: 400
        }
      })
      .state('regenerateReport', {
        url: '/regenerateReports',
        templateUrl: 'app/components/utils/regenerateReport.html',
        controller: 'regenerateReportCtrl',
        hide: true,
        data: {
          requiresLogin: true
        }
      })
      .state('addUser', {
        url: '/users/add',
        templateUrl: 'app/components/users/userDetails/userDetails.html',
        controller: 'UserDetailsCtrl',
        reloadOnSearch: false,
        data: {
          requiresLogin: true
        },
        resolve: {
          userData: function () {
          }
        }
      })
      .state('viewUser', {
        url: '/users/view/:userId/?sort&order&searchText&currentPage&filterId&rolesPage&tab',
        templateUrl: 'app/components/users/userDetails/userDetails.html',
        controller: 'UserDetailsCtrl',
        data: {
          requiresLogin: true
        },
        reloadOnSearch: false,
        resolve: {
          userData: ['UserService', '$stateParams', 'toastr', '$q', function (UserService, $stateParams, toastr, $q) {
            var userData = getUserDetails($stateParams, UserService, toastr, $q, 'viewDetails')
            return userData
          }]
        }
      })
      .state('editUser', {
        url: '/users/edit/:userId/?sort&order&searchText&currentPage&filterId&rolesPage&tab',
        templateUrl: 'app/components/users/userDetails/userDetails.html',
        controller: 'UserDetailsCtrl',
        data: {
          requiresLogin: true
        },
        reloadOnSearch: false,
        resolve: {
          userData: ['UserService', '$stateParams', 'toastr', '$q', function (UserService, $stateParams, toastr, $q) {
            var userData = getUserDetails($stateParams, UserService, toastr, $q, 'editUser')
            return userData
          }]
        }
      })
      .state('changePassword', {
        url: '/changePassword/:_id',
        templateUrl: 'app/components/changePassword/changePassword.html',
        controller: 'ChangePasswordCtrl'
      })
      .state('report', {
        url: '/report/:sessionId?id&tkn',
        templateUrl: 'app/components/report/machineReportPage.html',
        controller: 'MachineReportCtrl',
        resolve: {
          reportData: ['UserService', '$stateParams', 'toastr', '$q', function (UserService, $stateParams, toastr, $q) {
            var userData = getUserDetails($stateParams, UserService, toastr, $q, 'editUser')
            return userData
          }]
        }
      })
      .state('profile', {
        url: '/profile/?page',
        templateUrl: 'app/components/profilePage/profile.html',
        controller: 'ProfileCtrl',
        reloadOnSearch: false,
        data: {
          requiresLogin: true
        }
      })
      .state('viewUserSetting', {
        url: '/UserSetting/view',
        templateUrl: 'app/components/users/setting/userSetting.html',
        controller: 'UserSettingCtrl',
        reloadOnSearch: false,
        data: {
          requiresLogin: true
        }
      })
      .state('editUserSetting', {
        url: '/UserSetting/edit',
        templateUrl: 'app/components/users/setting/userSetting.html',
        controller: 'UserSettingCtrl',
        reloadOnSearch: false,
        data: {
          requiresLogin: true
        }
      })
      .state('addLicense', {
        url: '/customers/addLicense/:customerId?filterId&sort&order&searchText&currentPage&salesRep&devicePage',
        templateUrl: 'app/components/Licenses/LicenseDetails/addLicense.html',
        controller: 'AddLicenseCtrl',
        reloadOnSearch: false,
        data: {
          requiresLogin: true
        },
        resolve: {
          customerData: ['CustomerService', '$rootScope', '$stateParams', 'toastr', '$q', function (CustomerService, $rootScope, $stateParams, toastr, $q) {
            return getCustomerData(CustomerService, $rootScope, $stateParams, toastr, $q)
          }]
        }
      })
      .state('routeMachines', {
        url: '/routes/:routeId/machines/?sort&order&searchText&routePage&machineData&routeFilters',
        templateUrl: 'app/components/machines/machines.html',
        controller: 'MachinesCtrl',
        reloadOnSearch: false,
        data: {
          requiresLogin: true
        },
        resolve: {
          data: ['RouteService', '$rootScope', '$stateParams', 'toastr', '$q', function (RouteService, $rootScope, $stateParams, toastr, $q) {
            return getRouteData(RouteService, $rootScope, $stateParams, toastr, $q)
          }]
        }
      })
      .state('addRoute', {
        url: '/routes/add',
        templateUrl: 'app/components/routes/routeDetails/routeDetails.html',
        controller: 'RouteDetailsCtrl',
        data: {
          requiresLogin: true
        },
        reloadOnSearch: false,
        resolve: {
          routeData: function () {}
        }
      })
      .state('viewRoute', {
        url: '/routes/view/:routeId?tab&routeFilters',
        templateUrl: 'app/components/routes/routeDetails/routeDetails.html',
        controller: 'RouteDetailsCtrl',
        data: {
          requiresLogin: true
        },
        reloadOnSearch: false,
        resolve: {
          routeData: ['RouteService', '$rootScope', '$stateParams', 'toastr', '$q', function (RouteService, $rootScope, $stateParams, toastr, $q) {
            return getRouteData(RouteService, $rootScope, $stateParams, toastr, $q, 'viewDetails')
          }]
        }
      })
      .state('editRoute', {
        url: '/routes/edit/:routeId?tab&routeFilters',
        templateUrl: 'app/components/routes/routeDetails/routeDetails.html',
        controller: 'RouteDetailsCtrl',
        data: {
          requiresLogin: true
        },
        reloadOnSearch: false,
        resolve: {
          routeData: ['RouteService', '$rootScope', '$stateParams', 'toastr', '$q', function (RouteService, $rootScope, $stateParams, toastr, $q) {
            return getRouteData(RouteService, $rootScope, $stateParams, toastr, $q, 'editRoute')
          }]
        }
      })
      .state('machinesFromComposite', {
        url: '/composites/:compositeId/machines/?sort&order&searchText&page&machineData&compositeData',
        templateUrl: 'app/components/machines/machines.html',
        controller: 'MachinesCtrl',
        reloadOnSearch: false,
        data: {
          requiresLogin: true
        },
        resolve: {
          data: ['CompositeService', '$rootScope', '$stateParams', 'toastr', '$q', function (CompositeService, $rootScope, $stateParams, toastr, $q) {
            return getCompositeMachineData(CompositeService, $rootScope, $stateParams, toastr, $q)
          }]
        }
      })
      .state('addComposite', {
        url: '/composites/add',
        templateUrl: 'app/components/compositeMachines/compositeMachineDetails.html',
        controller: 'CompositeMachineDetailsCtrl',
        data: {
          requiresLogin: true
        },
        reloadOnSearch: false,
        resolve: {
          compositeMachineData: function () {}
        }
      })
      .state('viewComposite', {
        url: '/composites/view/:compositeId?compositeData',
        templateUrl: 'app/components/compositeMachines/compositeMachineDetails.html',
        controller: 'CompositeMachineDetailsCtrl',
        data: {
          requiresLogin: true
        },
        reloadOnSearch: false,
        resolve: {
          compositeMachineData: ['CompositeService', '$rootScope', '$stateParams', 'toastr', '$q', function (CompositeService, $rootScope, $stateParams, toastr, $q) {
            return getCompositeMachineData(CompositeService, $rootScope, $stateParams, toastr, $q, 'viewDetails')
          }]
        }
      })
      .state('editComposite', {
        url: '/composites/edit/:compositeId?compositeData',
        templateUrl: 'app/components/compositeMachines/compositeMachineDetails.html',
        controller: 'CompositeMachineDetailsCtrl',
        data: {
          requiresLogin: true
        },
        reloadOnSearch: false,
        resolve: {
          compositeMachineData: ['CompositeService', '$rootScope', '$stateParams', 'toastr', '$q', function (CompositeService, $rootScope, $stateParams, toastr, $q) {
            return getCompositeMachineData(CompositeService, $rootScope, $stateParams, toastr, $q, 'editComposite')
          }]
        }
      })
  }

  function getUserDetails ($stateParams, UserService, toastr, $q, param) {
    if ($stateParams.userId) {
      var queryParams = {
        _id: $stateParams.userId,
        roleInfo: 1
      }
      var userDetails = UserService.resource.getUserById(queryParams)
      return userDetails.$promise.then(function (res) {
        userDetails = res
        userDetails[param] = 1
        return userDetails
      }, function (err) {
        toastr.error('Fail to load data! Please try again later.')
        return $q.reject()
      })
    }
  }

  function getHierarchyData (HierarchyService, CustomerService, $rootScope, $stateParams, toastr, $q, param) {
    if ($stateParams.hierarchyId) {
      var queryParams = {
        _id: $stateParams.hierarchyId
      }
      var hierarchyData = HierarchyService.resource.getById(queryParams)
      return hierarchyData.$promise.then(function (res) {
        hierarchyData = res
        if (param) {
          hierarchyData[param] = true
        }
        if ($rootScope.user.customer.hierarchyType.length === 0) {
          var customerData = CustomerService.resource.getById({ _id: $rootScope.user.customerIds[0] })
          return customerData.$promise.then(function (customerInfo) {
            $rootScope.user.customer.hierarchyType = customerInfo.hierarchyType
            return hierarchyData
          }, function (err) {
            toastr.error(err.data.msg)
            return $q.reject()
          })
        } else {
          return hierarchyData
        }
      }, function (err) {
        toastr.error(err.data.msg)
        return $q.reject()
      })
    } else if ($rootScope.user.customer.hierarchyType.length === 0) {
      var customerData = CustomerService.resource.getById({ _id: $rootScope.user.customerIds[0] })
      return customerData.$promise.then(function (customerInfo) {
        $rootScope.user.customer.hierarchyType = customerInfo.hierarchyType
        return undefined
      }, function (err) {
        toastr.error(err.data.msg)
        return $q.reject()
      })
    }
  }

  function getCustomerData (CustomerService, $rootScope, $stateParams, toastr, $q, param) {
    if ($stateParams.customerId) {
      var queryParams = {
        _id: $stateParams.customerId
      }
      var customerDetails = CustomerService.resource.getById(queryParams)
      return customerDetails.$promise.then(function (res) {
        customerDetails = res
        return customerDetails
      }, function (err) {
        toastr.error('Fail to load data! Please try again later.')
        return $q.reject()
      })
    }
  }

  // get route details
  function getRouteData (RouteService, $rootScope, $stateParams, toastr, $q, param) {
    if ($stateParams.routeId) {
      var queryParams = {
        _id: $stateParams.routeId
      }
      queryParams.options = { populate: [{ path: 'ownerIds', select: '_id firstName lastName email' }, { path: 'userIds', select: '_id firstName lastName email' }] }
      var routeDetails = RouteService.resource.getRoute(queryParams)
      return routeDetails.$promise.then(function (res) {
        routeDetails = res
        routeDetails[param] = 1
        return routeDetails
      }, function (err) {
        toastr.error(err.data.msg)
        return $q.reject()
      })
    }
  }

  // get composite machine details
  function getCompositeMachineData (CompositeService, $rootScope, $stateParams, toastr, $q, param) {
    if ($stateParams.compositeId) {
      var queryParams = {
        _id: $stateParams.compositeId
      }
      queryParams.options = { populate: [{ path: 'ownerIds', select: '_id firstName lastName email' }, { path: 'userIds', select: '_id firstName lastName email' }] }
      var compositeMachineDetails = CompositeService.resource.getById(queryParams)
      return compositeMachineDetails.$promise.then(function (res) {
        compositeMachineDetails = res
        compositeMachineDetails[param] = 1
        return compositeMachineDetails
      }, function (err) {
        toastr.error(err.data.msg)
        return $q.reject()
      })
    }
  }
})();

/**
 * @author v.lugovsky
 * created on 15.12.2015
 */
(function () {
  'use strict';

  angular.module('Vibzer.theme', [
      'toastr',
      'textAngular',
      'Vibzer.theme.components',
      'Vibzer.theme.inputs'
  ]);

})();

(function () {
  'use strict';
  
  angular.module('Vibzer.components.customer', [
    'ui.router',
    'dndLists'
  ])
    .config(routeConfig);
  
  /** @ngInject */
  function routeConfig($stateProvider) {
    // $stateProvider
    //   .state('addCustomer', {
    //     url: '/addCustomer/',
    //     templateUrl: 'app/components/customers/modals/addCustomer.html',
    //     controller: 'AddCustomer',
    //     data: {
    //       requiresLogin: true
    //     },
    //     resolve: {
    //     }
    //   })
  }
  
})();
  
(function () {
  angular.module('Vibzer.components.distributor', [
    'ui.router'
  ])
    .config(routeConfig);

  /** @ngInject */
  function routeConfig ($stateProvider) {}
})();

(function () {
  'use strict';

  angular.module('Vibzer.components.graphs', [
  ]).config(routeConfig);

  function routeConfig ($stateProvider) {
    $stateProvider
      .state('trends', {
        url: '/machines/trends/:mId?machineData',
        templateUrl: 'app/components/graphs/trendsByfaults/trends.html',
        controller: 'TrendsCtrl',
        title: 'Trends',
        data: {
          requiresLogin: true
        },
        resolve: {
          machineData: ['MachineService', '$stateParams', 'toastr', '$q', getMachine]
        }
      })
      .state('conditionWiseTrend', {
        url: '/machines/conditionTrend/:mId?machineData',
        templateUrl: 'app/components/graphs/trendByCondition/trendByCondition.html',
        controller: 'ConditionWiseTrendCtrl',
        title: 'Trends',
        data: {
          requiresLogin: true
        },
        resolve: {
          machineData: ['MachineService', '$stateParams', 'toastr', '$q', getMachine]
        }
      })
      .state('androidConditionWiseTrend', {
        url: '/mobile/conditionTrend/:mId?tkn&id',
        templateUrl: 'app/components/graphs/trendByCondition/trendByCondition.html',
        controller: 'ConditionWiseTrendCtrl',
        title: 'Trends',
        data: {
          requiresLogin: false
        },
        resolve: {
          machineData: ['MachineService', '$stateParams', 'toastr', '$q', '$cookies', getMachine]
        }
      })
  }

  function getMachine (MachineService, $stateParams, toastr, $q, $cookies) {
    if ($stateParams.mId) {
      var queryParams = {
        _id: $stateParams.mId
      }
      if ($stateParams.tkn && $cookies) {
        $cookies.put('authToken', $stateParams.tkn)
      }
      queryParams.options = { populate: [{ path: 'parentId', select: '_id name' }, { path: 'machineTypeId', select: '_id name displayName' }] }
      var machineData = MachineService.resource.getMachine(queryParams)
      return machineData.$promise.then(function (res) {
        return res
      }, function (err) {
        toastr.error(err.data.msg)
        return $q.reject()
      })
    } else {
      $q.reject()
    }
  }
})();
(function () {
  'use strict';

  angular.module('Vibzer.components.hierarchy', [
    'ui.router',
    'dndLists'
  ])
    .config(routeConfig);

  /** @ngInject */
  function routeConfig($stateProvider) {
    $stateProvider
      .state('customerAdmin', {
        url: '/customers/adminList?:customerId&filterId&sort&order&searchText&currentPage&adminPage&salesRep',
        templateUrl: 'app/components/customers/actions/customerAdminList.html',
        controller: 'CustomerAdminListCtrl',
        data: {
          requiresLogin: true
        },
        resolve: {
          customerData: ['CustomerService', '$stateParams', 'toastr', '$q', function (CustomerService, $stateParams, toastr, $q) {
            if ($stateParams.customerId) {
              return getCustomerData(CustomerService, $stateParams, toastr, $q, 'view')
            }
          }]
        }
      })
      .state('viewCustomerAdmin', {
        url: '/customers/adminList/adminDetails?:userId&customerId&filterId&sort&order&searchText&currentPage$salesRep',
        templateUrl: 'app/components/customers/actions/customerAdminDetails.html',
        controller: 'CustomerAdminViewCtrl',
        data: {
          requiresLogin: true
        },
        resolve: {
          userData: ['UserService', '$stateParams', 'toastr', '$q', function (UserService, $stateParams, toastr, $q) {
            if ($stateParams.userId) {
              return getUserDetails($stateParams, UserService, toastr, $q, 'view')
            }
          }]
        }
      })
      .state('addCustomer', {
        url: '/addCustomer/?currentPage&sort&order&searchText',
        templateUrl: 'app/components/customers/modals/addCustomer.html',
        controller: 'AddCustomer',
        data: {
          requiresLogin: true
        },
        resolve: {
          customerData: function () {}
        }
      })
      .state('viewCustomer', {
        url: '/viewCustomer?customerId&currentPage&sort&order&searchText&filterId&tab&salesRep',
        templateUrl: 'app/components/customers/modals/addCustomer.html',
        controller: 'AddCustomer',
        data: {
          requiresLogin: true
        },
        resolve: {
          customerData: ['CustomerService', '$stateParams', 'toastr', '$q', function (CustomerService, $stateParams, toastr, $q) {
            if ($stateParams.customerId) {
              return getCustomerData(CustomerService, $stateParams, toastr, $q, 'view')
            }
          }]
        }
      })
      .state('editCustomer', {
        url: '/editCustomer?customerId&currentPage&sort&order&searchText&filterId&tab&salesRep',
        templateUrl: 'app/components/customers/modals/addCustomer.html',
        controller: 'AddCustomer',
        data: {
          requiresLogin: true
        },
        resolve: {
          customerData: ['CustomerService', '$stateParams', 'toastr', '$q', function (CustomerService, $stateParams, toastr, $q) {
            if ($stateParams.customerId) {
              return getCustomerData(CustomerService, $stateParams, toastr, $q, 'edit')
            }
          }]
        }
      })
      .state('addHierarchyLevel', {
        url: '/addHierarchyLevels/',
        templateUrl: 'app/components/hierarchy/adminHierarchy/adminHierarchy.html',
        controller: 'AddHierarchyLevelCtrl',
        data: {
          requiresLogin: true
        },
        resolve: {
          customerData: ['CustomerService', '$stateParams', 'toastr', '$q', function (CustomerService, $stateParams, toastr, $q) {
            if ($stateParams.customerId) {
              return getCustomerData(CustomerService, $stateParams, toastr, $q, 'view')
            }
          }]
        }
      })
      .state('addHierarchy', {
        url: '/hierarchy/add/:hierarchyId?navigation&page&sort&order',
        templateUrl: 'app/components/hierarchy/modals/addTopLevelHierarchy.html',
        controller: 'AddHierarchy',
        data: {
          requiresLogin: true
        },
        resolve: {
          hierarchyData: ['HierarchyService', 'CustomerService', '$rootScope', '$stateParams', 'toastr', '$q', function (HierarchyService, CustomerService, $rootScope, $stateParams, toastr, $q) {
            return getHierarchyData(HierarchyService, CustomerService, $rootScope, $stateParams, toastr, $q, 'add')
          }]
        }
      })
      .state('viewHierarchy', {
        url: '/hierarchy/view/:hierarchyId?tab&page&parentHierarchyId&navigation&sort&order&canEdit',
        templateUrl: 'app/components/hierarchy/modals/addTopLevelHierarchy.html',
        controller: 'AddHierarchy',
        data: {
          requiresLogin: true
        },
        resolve: {
          hierarchyData: ['HierarchyService', 'CustomerService', '$rootScope', '$stateParams', 'toastr', '$q', function (HierarchyService, CustomerService, $rootScope, $stateParams, toastr, $q) {
            return getHierarchyData(HierarchyService, CustomerService, $rootScope, $stateParams, toastr, $q, 'view')
          }]
        }
      })
      .state('editHierarchy', {
        url: '/hierarchy/edit/:hierarchyId?tab&page&parentHierarchyId&navigation&sort&order',
        templateUrl: 'app/components/hierarchy/modals/addTopLevelHierarchy.html',
        controller: 'AddHierarchy',
        data: {
          requiresLogin: true
        },
        resolve: {
          hierarchyData: ['HierarchyService', 'CustomerService', '$rootScope', '$stateParams', 'toastr', '$q', function (HierarchyService, CustomerService, $rootScope, $stateParams, toastr, $q) {
            return getHierarchyData(HierarchyService, CustomerService, $rootScope, $stateParams, toastr, $q, 'edit')
          }]
        }
      })
      .state('addDistributor', {
        url: '/addDistributor/?currentPage&sort&order&searchText',
        templateUrl: 'app/components/distributor/modals/distributorDetail.html',
        controller: 'DistributorDetailCtrl',
        data: {
          requiresLogin: true
        },
        resolve: {
          distributorData: function () { }
        }
      })
      .state('viewDistributor', {
        url: '/viewDistributor?distributorId&currentPage&sort&order&searchText&filterId&tab&salesRep',
        templateUrl: 'app/components/distributor/modals/distributorDetail.html',
        controller: 'DistributorDetailCtrl',
        data: {
          requiresLogin: true
        },
        resolve: {
          distributorData: ['DistributorService', '$stateParams', 'toastr', '$q', function (DistributorService, $stateParams, toastr, $q) {
            if ($stateParams.distributorId) {
              return getDistributorData(DistributorService, $stateParams, toastr, $q, 'view')
            }
          }]
        }
      })
      .state('editDistributor', {
        url: '/editDistributor?distributorId&currentPage&sort&order&searchText&filterId&tab&salesRep',
        templateUrl: 'app/components/distributor/modals/distributorDetail.html',
        controller: 'DistributorDetailCtrl',
        data: {
          requiresLogin: true
        },
        resolve: {
          distributorData: ['DistributorService', '$stateParams', 'toastr', '$q', function (DistributorService, $stateParams, toastr, $q) {
            if ($stateParams.distributorId) {
              return getDistributorData(DistributorService, $stateParams, toastr, $q, 'edit')
            }
          }]
        }
      })

    function getDistributorData (DistributorService, $stateParams, toastr, $q, param) {
      if ($stateParams.distributorId) {
        var distributorData = DistributorService.resource.getById({
          _id: $stateParams.distributorId
        })
        return distributorData.$promise.then(function (res) {
          distributorData = res
          if (param) {
            distributorData[param] = true
          }
          return distributorData
        }, function (err) {
          toastr.error(err)
          return $q.reject()
        })
      }
    }

    function getHierarchyData (HierarchyService, CustomerService, $rootScope, $stateParams, toastr, $q, param) {
      if ($stateParams.hierarchyId) {
        var queryParams = {
          _id: $stateParams.hierarchyId
        }
        var hierarchyData = HierarchyService.resource.getById(queryParams)
        return hierarchyData.$promise.then(function (res) {
          hierarchyData = res
          if (param) {
            hierarchyData[param] = true
          }
          if ($rootScope.user.customer.hierarchyType.length === 0) {
            var customerData = CustomerService.resource.getById({ _id: $rootScope.user.customerIds[0] })
            return customerData.$promise.then(function (customerInfo) {
              $rootScope.user.customer.hierarchyType = customerInfo.hierarchyType
              return hierarchyData
            }, function (err) {
              toastr.error(err.data.msg)
              return $q.reject()
            })
          } else {
            return hierarchyData
          }
        }, function (err) {
          toastr.error(err.data.msg)
          return $q.reject()
        })
      } else if ($rootScope.user.customer.hierarchyType.length === 0) {
        var customerData = CustomerService.resource.getById({ _id: $rootScope.user.customerIds[0] })
        return customerData.$promise.then(function (customerInfo) {
          $rootScope.user.customer.hierarchyType = customerInfo.hierarchyType
          return undefined
        }, function (err) {
          toastr.error(err.data.msg)
          return $q.reject()
        })
      }
    }

    function getCustomerData (CustomerService, $stateParams, toastr, $q, param) {
      if ($stateParams.customerId) {
        var queryParams = {
          _id: $stateParams.customerId
        }
        var customerData = CustomerService.resource.getById(queryParams)
        return customerData.$promise.then(function (res) {
          customerData = res
          if (param) {
            customerData[param] = true
          }
          return customerData
        }, function (err) {
          toastr.error(err)
          return $q.reject()
        })
      }
    }

    function getUserDetails ($stateParams, UserService, toastr, $q, param) {
      if ($stateParams.userId) {
        var queryParams = {
          _id: $stateParams.userId
        }
        var userDetails = UserService.resource.getUserById(queryParams)
        return userDetails.$promise.then(function (res) {
          userDetails = res
          userDetails[param] = 1
          return userDetails
        }, function (err) {
          toastr.error(err.data.msg)
          return $q.reject()
        })
      }
    }

  }

})();

(function () {
  'use strict';
  var angular = window.angular
  angular.module('Vibzer.components.machines', [
    'ui.router',
    'dndLists',
    'Vibzer.components.machines.sessions',
    'Vibzer.components.machines.machineDetails',
    'Vibzer.components.machines.alerts',
  ])
    .config(routeConfig);

  /** @ngInject */
  function routeConfig ($stateProvider) {
    $stateProvider
      .state('sessions', {
        url: '/machines/sessions/:machineId?machineData',
        templateUrl: 'app/components/machines/reviews/review.html',
        controller: 'ReviewCtrl',
        data: {
          requiresLogin: true
        },
        resolve: {
          machineData: ['MachineService', '$stateParams', 'toastr', '$q', function (MachineService, $stateParams, toastr, $q) {
            if ($stateParams.machineId) {
              var queryParams = {
                _id: $stateParams.machineId
              }
              queryParams.options = { populate: [{ path: 'parentId', select: '_id name' }, { path: 'machineTypeId', select: '_id name displayName' }] }
              var machineData = MachineService.resource.getMachine(queryParams)
              return machineData.$promise.then(function (res) {
                return res
              }, function (err) {
                toastr.error('Fail to load data! Please try again later.')
                return $q.reject(err)
              })
            }
          }]
        }
      })
      .state('calibration', {
        url: '/machines/sessions/:sessionId/calibrate/:machineId?machineData',
        templateUrl: 'app/components/machines/reviews/calibration.html',
        controller: 'CalibrationCtrl',
        data: {
          requiresLogin: true
        },
        resolve: {
          machineData: ['$stateParams', '$q', function ($stateParams, $q) {
            // Use machineData from sessions page (passed via stateParams) - same as Spectrum/Wave pages
            if ($stateParams.machineData) {
              try {
                var parsedData = typeof $stateParams.machineData === 'string' 
                  ? JSON.parse($stateParams.machineData) 
                  : $stateParams.machineData
                // Validate it has the required structure
                if (parsedData && parsedData._id) {
                  return $q.resolve(parsedData)
                }
              } catch (e) {
                // If parsing fails, fall through to minimal object
              }
            }
            // Fallback: create minimal object if no machineData passed
            if ($stateParams.machineId) {
              return $q.resolve({
                _id: $stateParams.machineId,
                machineTypeId: { name: 'point' },
                meta: {}
              })
            }
            return $q.resolve(null)
          }]
        }
      })
      .state('calibrationFromRoute', {
        url: '/routes/:routeId/machines/sessions/:sessionId/calibrate/:machineId?machineData&routeFilters',
        templateUrl: 'app/components/machines/reviews/calibration.html',
        controller: 'CalibrationCtrl',
        data: {
          requiresLogin: true
        },
        resolve: {
          machineData: ['MachineService', '$stateParams', 'toastr', '$q', function (MachineService, $stateParams, toastr, $q) {
            var machineData = getMachineDetails(MachineService, $stateParams, toastr, $q)
            return machineData
          }]
        }
      })
      .state('calibrationFromComposite', {
        url: '/composites/:compositeId/machines/sessions/:sessionId/calibrate/:machineId?machineData&compositeData',
        templateUrl: 'app/components/machines/reviews/calibration.html',
        controller: 'CalibrationCtrl',
        data: {
          requiresLogin: true
        },
        resolve: {
          machineData: ['MachineService', '$stateParams', 'toastr', '$q', function (MachineService, $stateParams, toastr, $q) {
            var machineData = getMachineDetails(MachineService, $stateParams, toastr, $q)
            return machineData
          }]
        }
      })
      .state('addMachine', {
        url: '/machines/add',
        templateUrl: 'app/components/machines/machineDetails/machineDetails.html',
        controller: 'MachineDetailsCtrl',
        data: {
          requiresLogin: true
        },
        reloadOnSearch: false,
        resolve: {
          machineData: function () {}
        }
      })
      .state('alerts', {
        url: '/machines/alerts/:machineId?currentPage&machineData',
        templateUrl: 'app/components/machines/alerts/machineAlerts.html',
        controller: 'MachineAlertsCtrl',
        data: {
          requiresLogin: true
        },
        resolve: {
          machineData: ['MachineService', '$stateParams', 'toastr', '$q', function (MachineService, $stateParams, toastr, $q) {
            if ($stateParams.machineId) {
              var queryParams = {
                _id: $stateParams.machineId,
                options: { populate: [{ path: 'parentId', select: '_id name' }, { path: 'machineTypeId', select: '_id name displayName' }] }
              }
              var machineData = MachineService.resource.getMachine(queryParams)
              return machineData.$promise.then(function (res) {
                return res
              }, function (err) {
                toastr.error('Fail to load data! Please try again later.')
                return $q.reject(err)
              })
            }
          }]
        }
      })
      .state('viewMachine', {
        url: '/machines/view/:machineId/?tab&machineData',
        templateUrl: 'app/components/machines/machineDetails/machineDetails.html',
        controller: 'MachineDetailsCtrl',
        data: {
          requiresLogin: true
        },
        reloadOnSearch: false,
        resolve: {
          machineData: ['MachineService', '$stateParams', 'toastr', '$q', function (MachineService, $stateParams, toastr, $q) {
            var machineData = getMachineDetails(MachineService, $stateParams, toastr, $q, 'viewDetails')
            return machineData
          }]
        }
      })
      .state('editMachine', {
        url: '/machines/edit/:machineId/?tab&machineData',
        templateUrl: 'app/components/machines/machineDetails/machineDetails.html',
        controller: 'MachineDetailsCtrl',
        data: {
          requiresLogin: true
        },
        reloadOnSearch: false,
        resolve: {
          machineData: ['MachineService', '$stateParams', 'toastr', '$q', function (MachineService, $stateParams, toastr, $q) {
            var machineData = getMachineDetails(MachineService, $stateParams, toastr, $q, 'editMachine')
            return machineData
          }]
        }
      })
      .state('viewMachineFromRoute', {
        url: '/routes/:routeId/machines/view/:machineId/?tab&machineData&routeFilters',
        templateUrl: 'app/components/machines/machineDetails/machineDetails.html',
        controller: 'MachineDetailsCtrl',
        data: {
          requiresLogin: true
        },
        reloadOnSearch: false,
        resolve: {
          machineData: ['MachineService', '$stateParams', 'toastr', '$q', function (MachineService, $stateParams, toastr, $q) {
            var machineData = getMachineDetails(MachineService, $stateParams, toastr, $q, 'viewDetails')
            return machineData
          }]
        }
      })
      .state('editMachineFromRoute', {
        url: '/routes/:routeId/machines/edit/:machineId/?tab&machineData&routeFilters',
        templateUrl: 'app/components/machines/machineDetails/machineDetails.html',
        controller: 'MachineDetailsCtrl',
        data: {
          requiresLogin: true
        },
        reloadOnSearch: false,
        resolve: {
          machineData: ['MachineService', '$stateParams', 'toastr', '$q', function (MachineService, $stateParams, toastr, $q) {
            var machineData = getMachineDetails(MachineService, $stateParams, toastr, $q, 'editMachine')
            return machineData
          }]
        }
      })
      .state('viewMachineFromComposite', {
        url: '/composites/:compositeId/machines/view/:machineId/?tab&machineData&compositeData',
        templateUrl: 'app/components/machines/machineDetails/machineDetails.html',
        controller: 'MachineDetailsCtrl',
        data: {
          requiresLogin: true
        },
        reloadOnSearch: false,
        resolve: {
          machineData: ['MachineService', '$stateParams', 'toastr', '$q', function (MachineService, $stateParams, toastr, $q) {
            var machineData = getMachineDetails(MachineService, $stateParams, toastr, $q, 'viewDetails')
            return machineData
          }]
        }
      })
      .state('editMachineFromComposite', {
        url: '/composites/:compositeId/machines/edit/:machineId/?tab&machineData&compositeData',
        templateUrl: 'app/components/machines/machineDetails/machineDetails.html',
        controller: 'MachineDetailsCtrl',
        data: {
          requiresLogin: true
        },
        reloadOnSearch: false,
        resolve: {
          machineData: ['MachineService', '$stateParams', 'toastr', '$q', function (MachineService, $stateParams, toastr, $q) {
            var machineData = getMachineDetails(MachineService, $stateParams, toastr, $q, 'editMachine')
            return machineData
          }]
        }
      })
      .state('monitoredMachineTrend', {
        url: '/machines/monitoredMachine/trend/:machineId/?machineData',
        templateUrl: 'app/components/machines/trends/monitoredMachineTrend.html',
        controller: 'MonitoredMachineTrendCtrl',
        data: {
          requiresLogin: true
        },
        reloadOnSearch: false,
        resolve: {
          machineData: ['MachineService', '$stateParams', 'toastr', '$q', function (MachineService, $stateParams, toastr, $q) {
            var machineData = getMachineDetails(MachineService, $stateParams, toastr, $q)
            return machineData
          }]
        }
      })
      .state('sessionsFromRoute', {
        url: '/routes/:routeId/machines/sessions/:machineId?machineData&routeFilters',
        templateUrl: 'app/components/machines/reviews/review.html',
        controller: 'ReviewCtrl',
        data: {
          requiresLogin: true
        },
        resolve: {
          machineData: ['MachineService', '$stateParams', 'toastr', '$q', function (MachineService, $stateParams, toastr, $q) {
            var machineData = getMachineDetails(MachineService, $stateParams, toastr, $q)
            return machineData
          }]
        }
      })
      .state('alertsFromRoute', {
        url: '/routes/:routeId/machines/alerts/:machineId?currentPage&machineData&routeFilters',
        templateUrl: 'app/components/machines/alerts/machineAlerts.html',
        controller: 'MachineAlertsCtrl',
        data: {
          requiresLogin: true
        },
        resolve: {
          machineData: ['MachineService', '$stateParams', 'toastr', '$q', function (MachineService, $stateParams, toastr, $q) {
            var machineData = getMachineDetails(MachineService, $stateParams, toastr, $q)
            return machineData
          }]
        }
      })
      .state('monitoredMachineTrendFromRoute', {
        url: '/routes/:routeId/machines/monitoredMachine/trend/:machineId/?machineData&routeFilters',
        templateUrl: 'app/components/machines/trends/monitoredMachineTrend.html',
        controller: 'MonitoredMachineTrendCtrl',
        data: {
          requiresLogin: true
        },
        reloadOnSearch: false,
        resolve: {
          machineData: ['MachineService', '$stateParams', 'toastr', '$q', function (MachineService, $stateParams, toastr, $q) {
            var machineData = getMachineDetails(MachineService, $stateParams, toastr, $q)
            return machineData
          }]
        }
      })
      .state('conditionWiseTrendFromRoute', {
        url: '/routes/:routeId/machines/conditionTrend/trend/:machineId/?machineData&routeFilters',
        templateUrl: 'app/components/graphs/trendByCondition/trendByCondition.html',
        controller: 'ConditionWiseTrendCtrl',
        title: 'Trends',
        data: {
          requiresLogin: true
        },
        resolve: {
          machineData: ['MachineService', '$stateParams', 'toastr', '$q', getMachineDetails]
        }
      })
      .state('sessionsFromComposite', {
        url: '/composites/:compositeId/machines/sessions/:machineId?machineData&compositeData',
        templateUrl: 'app/components/machines/reviews/review.html',
        controller: 'ReviewCtrl',
        data: {
          requiresLogin: true
        },
        resolve: {
          machineData: ['MachineService', '$stateParams', 'toastr', '$q', function (MachineService, $stateParams, toastr, $q) {
            var machineData = getMachineDetails(MachineService, $stateParams, toastr, $q)
            return machineData
          }]
        }
      })
      .state('alertsFromComposite', {
        url: '/composites/:compositeId/machines/alerts/:machineId?currentPage&machineData&compositeData',
        templateUrl: 'app/components/machines/alerts/machineAlerts.html',
        controller: 'MachineAlertsCtrl',
        data: {
          requiresLogin: true
        },
        resolve: {
          machineData: ['MachineService', '$stateParams', 'toastr', '$q', function (MachineService, $stateParams, toastr, $q) {
            var machineData = getMachineDetails(MachineService, $stateParams, toastr, $q)
            return machineData
          }]
        }
      })
      .state('monitoredMachineTrendFromComposite', {
        url: '/composites/:compositeId/machines/monitoredMachine/trend/:machineId/?machineData&routeFilters',
        templateUrl: 'app/components/machines/trends/monitoredMachineTrend.html',
        controller: 'MonitoredMachineTrendCtrl',
        data: {
          requiresLogin: true
        },
        reloadOnSearch: false,
        resolve: {
          machineData: ['MachineService', '$stateParams', 'toastr', '$q', function (MachineService, $stateParams, toastr, $q) {
            var machineData = getMachineDetails(MachineService, $stateParams, toastr, $q)
            return machineData
          }]
        }
      })
      .state('conditionWiseTrendFromComposite', {
        url: '/composites/:compositeId/machines/conditionTrend/trend/:machineId/?machineData&compositeData',
        templateUrl: 'app/components/graphs/trendByCondition/trendByCondition.html',
        controller: 'ConditionWiseTrendCtrl',
        title: 'Trends',
        data: {
          requiresLogin: true
        },
        resolve: {
          machineData: ['MachineService', '$stateParams', 'toastr', '$q', getMachineDetails]
        }
      })
      .state('sessionsForComposite', {
        url: '/composites/:compositeId/sessions/:machineId?compositeData',
        templateUrl: 'app/components/machines/reviews/review.html',
        controller: 'ReviewCtrl',
        data: {
          requiresLogin: true
        },
        resolve: {
          machineData: ['MachineService', '$stateParams', 'toastr', '$q', function (MachineService, $stateParams, toastr, $q) {
            var machineData = getMachineDetails(MachineService, $stateParams, toastr, $q, 'forComposite')
            return machineData
          }]
        }
      })
      .state('monitoredMachineTrendForComposite', {
        url: '/composites/:compositeId/monitoredMachine/trend/:machineId?compositeData',
        templateUrl: 'app/components/machines/trends/monitoredMachineTrend.html',
        controller: 'MonitoredMachineTrendCtrl',
        data: {
          requiresLogin: true
        },
        reloadOnSearch: false,
        resolve: {
          machineData: ['MachineService', '$stateParams', 'toastr', '$q', function (MachineService, $stateParams, toastr, $q) {
            var machineData = getMachineDetails(MachineService, $stateParams, toastr, $q, 'forComposite')
            return machineData
          }]
        }
      })
      .state('conditionWiseTrendForComposite', {
        url: '/composites/:compositeId/conditionTrend/:machineId?compositeData',
        templateUrl: 'app/components/graphs/trendByCondition/trendByCondition.html',
        controller: 'ConditionWiseTrendCtrl',
        data: {
          requiresLogin: true
        },
        resolve: {
          machineData: ['MachineService', '$stateParams', 'toastr', '$q', function (MachineService, $stateParams, toastr, $q) {
            var machineData = getMachineDetails(MachineService, $stateParams, toastr, $q, 'forComposite')
            return machineData
          }]
        }
      })

    function getMachineDetails (MachineService, $stateParams, toastr, $q, param) {
      if ($stateParams.machineId) {
        var queryParams = {
          _id: $stateParams.machineId
        }
        queryParams.options = { populate: [{ path: 'parentId', select: '_id name' }, { path: 'machineTypeId', select: '_id name displayName points fields' }, { path: 'owner', select: '_id firstName lastName email' }] }
        var machineDetails = MachineService.resource.getMachine(queryParams)
        return machineDetails.$promise.then(function (res) {
          machineDetails = res
          machineDetails[param] = 1
          return machineDetails
        }, function (err) {
          toastr.error('Fail to load data! Please try again later.')
          return $q.reject(err)
        })
      }
    }
  }
})();

(function () {
  'use strict';

  angular.module('Vibzer.components.manage', [
    'ui.router',
    'Vibzer.components.manage.customers',
    'Vibzer.components.manage.settings',
    'Vibzer.components.manage.settings.addHierarchyStructure',
    'Vibzer.components.manage.settings.AddTaxCtrl'
  ])
    .config(routeConfig);

  /** @ngInject */
  function routeConfig($stateProvider, $urlRouterProvider) {
    $stateProvider
      .state('manage', {
        url: '/manage',
        template: '<ui-view  autoscroll="true" autoscroll-body-top></ui-view>',
        // abstract: true,
        title: 'Manage',
        data: {
          requiresLogin: true
        },
        sidebarMeta: {
          icon: 'ion-grid',
          order: 300
        }
      })
      .state('manage.customers', {
        url: '/customers',
        templateUrl: 'app/components/manage/customers/customers.html',
        title: 'Customers',
        controller: 'CustomersCtrl',
        data: {
          requiresLogin: true
        },
        sidebarMeta: {
          order: 100
        },
      })
      .state('manage.settings', {
        url: '/settings',
        templateUrl: 'app/components/manage/settings/settings.html',
        title: 'Settings',
        controller: 'SettingsCtrl',
        data: {
          requiresLogin: true
        },
        sidebarMeta: {
          order: 100
        }
      })
      .state('manage.editHierarchyStructure', {
        url: '/hierarchyStructure',
        templateUrl: 'app/components/manage/settings/Hierarchy_Structure/addHierarchyStructure.html',
        title: 'Org Structure',
        controller: 'HierarchyStructureCtrl',
        data: {
          requiresLogin: true
        }
      })
  }
})();

(function () {
  'use strict';

  angular.module('Vibzer.components.organization', [
    'ui.router',
    'dndLists'
  ])
  .config(function(){
    $.jstree.defaults.core.themes.url = true;
    $.jstree.defaults.core.themes.dir = "assets/img/theme/vendor/jstree/dist/themes";
  });
})();

(function () {
    'use strict';

    angular.module('Vibzer.components.machineReport', [])
})();

(function () {
    'use strict';

    angular.module('Vibzer.components.users', [
    ])
})();
/**
 * @author v.lugovksy
 * created on 16.12.2015
 */
/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('Vibzer.theme.components', []);

})();

/**
 * @author v.lugovsky
 * created on 10.12.2016
 */
(function () {
  'use strict';

  angular.module('Vibzer.theme.inputs', []);

})();

(function () {
  'use strict';
  
  angular.module('Vibzer.components.customerActions', [
    'ui.router',
    'dndLists'
  ])
    .config(routeConfig);
  
  /** @ngInject */
  function routeConfig($stateProvider) {
    // $stateProvider
    //   .state('addCustomer', {
    //     url: '/addCustomer/',
    //     templateUrl: 'app/components/customers/modals/addCustomer.html',
    //     controller: 'AddCustomer',
    //     data: {
    //       requiresLogin: true
    //     },
    //     resolve: {
    //     }
    //   })
  }
  
})();
  
(function () {
  'use strict';

  angular.module('Vibzer.components.machines.machineDetails', [])
})();

(function () {
  'use strict';

  angular.module('Vibzer.components.machines.sessions', [
    'Vibzer.components'
  ])
  
})();

(function () {
    'use strict';
    angular.module('Vibzer.components.machines.trends', [])
  })();
  
(function () {
  'use strict';

  angular.module('Vibzer.components.manage.settings', [
    'ui.router'
  ])
    .config(routeConfig);

  /** @ngInject */
  function routeConfig($stateProvider) {
  }
})();

(function () {
    'use strict';
  
    angular.module('Vibzer.components.machines.alerts', [])
    
  })();
  
(function () {
  'use strict';

  angular.module('Vibzer.components.users.userDetails', [])

})();

(function () {
    'use strict';

    angular.module('Vibzer.components.manage.settings.addHierarchyStructure', [
    ])
    
})();

'use strict';
var angular = window.angular
var _ = window._
var app = angular.module('Vibzer', [
  'ngAnimate',
  'ui.bootstrap',
  'ui.sortable',
  'ui.router',
  'ngTouch',
  'toastr',
  'smart-table',
  'xeditable',
  'ngSlimScroll',
  'ngJsTree',
  'angularRipple',
  'uiSwitch',
  'angular-dygraphs',
  'ngResource',
  'ngCookies',
  'nvd3',
  'vcRecaptcha',
  'Vibzer.theme',
  'Vibzer.components',
  'formly',
  'formlyBootstrap',
  'ngFileSaver'
]).constant('constants', constant);

/* formly form control */
app.run(function (formlyConfig) {
  formlyConfig.disableWarnings = true
  // ui-select custom template
  formlyConfig.setType({
    name: 'ui-select',
    templateUrl: 'app/components/formly_types/uiSelect.html',
    controller: ['$scope', function ($scope) { }
    ]
  })
  // input custom template
  formlyConfig.setType({
    name: 'input',
    templateUrl: 'app/components/formly_types/inputTemplate.html'
  })

  // input field validation
  formlyConfig.setWrapper([
    {
      template: [
        '<div class="formly-template-wrapper form-group"',
        'ng-class="{\'has-error\': options.validation.errorExistsAndShouldBeVisible}">',
        '<formly-transclude></formly-transclude>',
        '<div class="validation"',
        'ng-if="options.validation.errorExistsAndShouldBeVisible"',
        'ng-messages="options.formControl.$error">',
        '<div ng-message="{{::name}}" ng-repeat="(name, message) in ::options.validation.messages">',
        '{{message(options.formControl.$viewValue, options.formControl.$modelValue, this)}}',
        '</div>',
        '</div>',
        '</div>'
      ].join(' ')
    }
  ])

  formlyConfig.extras.errorExistsAndShouldBeVisibleExpression = 'fc.$dirty || fc.$touched || form.$submitted'
})
/* formly form control end */

app.config(interceptorConfig)
//   /** @ngInject */
function interceptorConfig ($httpProvider, $qProvider) {
  // For handling error
  $httpProvider.interceptors.push('errorInterceptor')
  // to fix unhandled rejection error
  // $qProvider.errorOnUnhandledRejections(false)
  // to solve IE problem
  $httpProvider.defaults.cache = false
  if (!$httpProvider.defaults.headers.get) {
    $httpProvider.defaults.headers.get = {}
  }
  // disable IE ajax request caching
  $httpProvider.defaults.headers.get['If-Modified-Since'] = '0'

  // disable all console logs
  // console.log = function () {}

  $httpProvider.interceptors.push(['$rootScope', '$cookies', function ($rootScope, $cookies) {
    return {
      'request': function (config) {
        if (angular.isDefined($cookies.get('authToken'))) {
          var authToken = $cookies.get('authToken')
          config.headers['token'] = authToken
        }
        // if ($rootScope.user && $rootScope.user.customers && $rootScope.user.customers.length > 0) {
        //   config.headers['customerId'] = $rootScope.user.customerId
        // }
        return config
      }
    }
  }])
}

app.run(runConfig)
/** @ngInject */
function runConfig ($state, $rootScope, $stateParams, $cookies, $log, $uibModalStack, UserService) {
  // Expose current state
  $rootScope.$state = $state
  $rootScope.$stateParams = $stateParams

  $rootScope.authToken = $cookies.get('authToken')
  $rootScope.authToken = $cookies.get('authToken')
  $rootScope.user = $cookies.getObject('vcUser')

  $rootScope.$on('$stateChangeStart', function (event, toState, toParams, fromState, fromParams, options) {
    if (angular.isDefined($cookies.get('authToken'))) {
      // If page is refreshed, 'fromState.abstract' returns true. 'showOrHideSidebarMenu' event is fired for sidebar menu.
      if (fromState.abstract && $rootScope.user) {
        $rootScope.$broadcast('showOrHideSidebarMenu')
      }
      // Following if-else block is used to prevent distributor user from accessing customer states and vice-versa
      if ($rootScope.user && !_.isEmpty($rootScope.user.customerIds)) {
        if (toState.name === 'customers' || toState.name === 'addCustomer' || toState.name === 'viewCustomer' || toState.name === 'editCustomer') {
          event.preventDefault()
        }
        if (toState.name === 'machines' && !($rootScope.user.permission.canViewMachines || $rootScope.user.permission.canViewOwnedMachines)) {
          event.preventDefault()
        }
        if (toState.name === 'addMachine' && !$rootScope.user.permission.addMachine) {
          event.preventDefault()
        }
        if (toState.name === 'editMachine' && !$rootScope.user.permission.editMachine) {
          event.preventDefault()
        }
        if ((toState.name === 'alerts' || toState.name === 'sessions') && !($rootScope.user.permission.canViewMachines || $rootScope.user.permission.canViewOwnedMachines)) {
          event.preventDefault()
        }
      } else if ($rootScope.user && !_.isEmpty($rootScope.user.distributorIds)) {
        if (toState.name === 'machines' || toState.name === 'organization' || toState.name === 'addHierarchyLevel') {
          event.preventDefault()
        }
        if (toState.name === 'users' && !$rootScope.user.permission.addDistributorUser) {
          event.preventDefault()
        }
      }
      if (!(_.includes(['login', 'changePassword'], toState.name)) && !$rootScope.user) {
        UserService.resource.getDetails({}, function (res) {
          $rootScope.user = res
        }, function (err) {
          $log.error(err)
        })
      }
      if (_.includes(['allDevices', 'distributors', 'addDistributor', 'editDistributor', 'viewDistributor'], toState.name) && !$rootScope.user.vibzerAdmin) {
        event.preventDefault()
      }
      // Restrict calibration routes to users with vibrationAnalyst permission
      if (_.includes(['calibration', 'calibrationFromRoute', 'calibrationFromComposite'], toState.name) && !$rootScope.user.vibrationAnalyst) {
        event.preventDefault()
      }
      // Initially Restricted calibration to only regular sessions page (not routes or composites)
      if (_.includes(['calibrationFromRoute', 'calibrationFromComposite'], toState.name)) {
        event.preventDefault()
      }
    }

    var loggedInUser = UserService.checkLoggedInUser()
    if (loggedInUser && ((toState.name === 'login') || ($rootScope.user && $rootScope.user.activeCustomer && toState.name === 'unauthorizedCustomer'))) {
      event.preventDefault()
      if (!fromState.name) {
        if ($rootScope.user.customer && _.isEmpty($rootScope.user.customer.hierarchyType)) {
          $state.go('addHierarchyLevel')
        } else {
          $state.go('dashboard')
        }
      }
      return
    }
    if (loggedInUser && (fromState.name === 'unauthorizedCustomer')) {
      event.preventDefault()
      return
    }

    var isAuthenticationRequired = toState.data && toState.data.requiresLogin && !loggedInUser

    if (isAuthenticationRequired && toState.name !== 'unauthorizedCustomer') {
      event.preventDefault()
      $state.go('login', { toState: toState })
    }
  })
  $rootScope.$on('$stateChangeSuccess', function (event, toState, toParams, fromState, fromParams, options) {
    $rootScope.showNavBar = !_.includes(['login', 'changePassword', 'report', 'androidDashboard', 'androidConditionWiseTrend'], $state.current.name)
    $rootScope.showSideBar = !_.includes(['login', 'changePassword', 'addHierarchyLevel', 'report', 'androidDashboard', 'androidConditionWiseTrend'], $state.current.name)
    $rootScope.noTopPadding = _.includes(['report', 'androidConditionWiseTrend', 'androidDashboard'], $state.current.name)
    $rootScope.whiteBackground = _.includes(['report', 'androidConditionWiseTrend', 'androidDashboard'], $state.current.name)
    $rootScope.showVibzerBody = _.includes(['login', 'changePassword'], $state.current.name)
    $rootScope.noVerticalScroll = _.includes(['sessions', 'androidConditionWiseTrend'], $state.current.name)
    if (toState && toState.name === 'profile') {
      if ($rootScope.user && _.isEmpty($rootScope.user.distributorIds) && _.isEmpty($rootScope.user.customer.hierarchyType)) {
        $rootScope.showSideBar = false
      }
    }
  })
  $rootScope.$on('$locationChangeStart', handleLocationChange)

  function handleLocationChange () {
    $uibModalStack.dismissAll()
  }

  document.onmouseover = function () {
    window.innerDocClick = true
  }

  document.onmouseout = function () {
    window.innerDocClick = false
  }

};

(function () {
  'use strict';

  // Robust manual bootstrap for legacy AngularJS app.
  // Polls for window.angular and the 'Vibzer' module before calling bootstrap.
  // This prevents race conditions where boot.js executes before the
  // concatenated app bundle has defined the module.
  function tryBootstrap() {
    var maxAttempts = 200; // ~200 * 50ms = 10s timeout
    var intervalMs = 50;
    var attempts = 0;

    function log() {
      if (window && window.console && window.console.info) {
        try {
          window.console.info.apply(window.console, arguments);
        } catch (e) {
          // ignore
        }
      }
    }

    function canBootstrap() {
      if (!window || !window.angular) return false;
      // Check whether the module exists without throwing
      try {
        // angular.module(name) throws an error if the module doesn't exist
        window.angular.module('Vibzer');
        return true;
      } catch (e) {
        return false;
      }
    }

    function doBootstrap() {
      try {
        if (document.querySelector('[ng-app]')) {
          // ng-app still present — avoid double bootstrap.
          log('boot.js: ng-app detected in DOM; skipping manual bootstrap.');
          return;
        }
        log('boot.js: Found Angular and Vibzer module — bootstrapping now.');
        window.angular.bootstrap(document, ['Vibzer']);
      } catch (err) {
        // If bootstrap fails, log it; do not throw.
        console.error('boot.js: Manual bootstrap failed:', err);
      }
    }

    function tick() {
      attempts++;
      if (canBootstrap()) {
        doBootstrap();
        return;
      }

      if (attempts >= maxAttempts) {
        // Timeout reached; log helpful diagnostics for debugging.
        try {
          var hasAngular = !!(window && window.angular);
          var vibzerDefined = false;
          if (hasAngular) {
            try { window.angular.module('Vibzer'); vibzerDefined = true; } catch (_) { vibzerDefined = false; }
          }
          console.error('boot.js: Timeout waiting for Angular/Vibzer module. attempts=' + attempts + ', hasAngular=' + hasAngular + ', vibzerDefined=' + vibzerDefined);
        } catch (e) {
          console.error('boot.js: Timeout and diagnostics failed', e);
        }
        return;
      }

      setTimeout(tick, intervalMs);
    }

    // Start polling when DOM ready; if already ready, start immediately.
    if (document.readyState === 'complete' || document.readyState === 'interactive') {
      tick();
    } else {
      document.addEventListener('DOMContentLoaded', tick);
    }
  }

  // Expose bootstrap for debugging and tests
  window.__vibzerBootstrap = tryBootstrap;

  // Auto-start the polling/bootstrap routine.
  tryBootstrap();
})();

/**
 * dygraph directive for AngularJS
 *
 * Author: Chris Jackson
 *
 * License: MIT
 */
// var angular = require('angular')
// var moment = require('moment')
(function () {
  'use strict';

  angular.module('angular-dygraphs', [
    'ngSanitize'
  ])
    .directive('ngDygraphs', ['$window', '$sce', function ($window, $sce) {
      return {
        restrict: 'E',
        scope: { // Isolate scope
          data: '=',
          options: '=',
          legend: '=?'
        },
        template: function (scope, element, attrs) {
          return '<div class="ng-dygraphs">' + // Outer div to hold the whole directive
            '<div class="graph"></div>' + // Div for graph
            '<div class="legend" ng-if="LegendEnabled">' + // Div for legend
            '<div class="series-container">' + // Div for series
            '<div class="{{legendColumnContainer}}">' +
            '<div ng-repeat="series in legendSeries" class="{{legendColumn}}">' +
            '<a ng-click="selectSeries(series)" style="vertical-align:middle">' +
            '<span style="vertical-align: middle;" ng-bind-html="seriesLine(series)"></span>' +
            '<span ng-style="seriesStyle(series)">{{series.label}}</span>' +
            '</a>' +
            '</div>' + // Repeat
            '</div>' +
            '</div>' + // Series Div
            '</div>' + // Legend Div
            '<div class="dypopover"></div>' +
            '</div>'
        }, // Outer div
        link: function (scope, element, attrs) {
          scope.LegendEnabled = true
          scope.legendColumn = scope.options.legendColumn || 'col-md-4 col-lg-4 col-sm-4 col-xs-4'
          scope.legendColumnContainer = scope.options.legendColumnContainer || 'row'
          var parent = element.parent()
          var mainDiv = element.children()[0]
          var chartDiv = window.$(mainDiv).children()[0]
          // var legendDiv = window.$(mainDiv).children()[1]
          var popover = element.find('.dypopover')

          var popoverWidth = 0
          var popoverHeight = 0
          var chartArea
          var popoverPos = false
          var graph = new window.Dygraph(chartDiv, scope.data, scope.options)
          window.dygraphApi = {
            updateOptions: graph.updateOptions,
            resize: resize
          }
          scope.$watch('options.showPopover', function (newVal, oldVal) {
            if (newVal) {
              scope.customHighlightCallback = scope.options.highlightCallback
              scope.customUnhighlightCallback = scope.options.unhighlightCallback
              scope.options.highlightCallback = scope.highlightCallback
              scope.options.unhighlightCallback = scope.unhighlightCallback
            } else {
              scope.customHighlightCallback ? scope.options.highlightCallback = scope.customHighlightCallback : null
              scope.customUnhighlightCallback ? scope.options.customUnhighlightCallback = scope.customUnhighlightCallback : null
            }
            graph.updateOptions(scope.options)
          })
          scope.$watch('data', function () {
            var options = scope.options
            if (options === undefined) {
              options = {}
            }
            options.file = scope.data
            options.showPopover ? options.highlightCallback = scope.highlightCallback : null
            options.showPopover ? options.unhighlightCallback = scope.unhighlightCallback : null
            if (options.showPopover === undefined) {
              options.showPopover = true
            }

            if (scope.legend !== undefined) {
              options.labelsDivWidth = 0
            }
            graph.updateOptions(options)
            graph.resetZoom()

            resize()
          }, true)

          scope.$watch('legend', function () {
            // Clear the legend
            var colors = graph.getColors()
            //   var labels = graph.getLabels()
            if (colors.length === 0) {
              colors = ['rgb(64,128,0)', 'rgb(64,0,128)', 'rgb(0,128,128)']
            }
            scope.legendSeries = {}

            if (scope.legend !== undefined && scope.legend.dateFormat === undefined) {
              scope.legend.dateFormat = 'MMMM Do YYYY, h:mm:ss a'
            }

            // If we want our own legend, then create it
            if (scope.legend !== undefined && scope.legend.series !== undefined) {
              var cnt = 0
              for (var key in scope.legend.series) {
                scope.legendSeries[key] = {}
                scope.legendSeries[key].color = colors[cnt]
                scope.legendSeries[key].label = scope.legend.series[key].label
                scope.legendSeries[key].format = scope.legend.series[key].format
                scope.legendSeries[key].visible = true
                scope.legendSeries[key].column = cnt

                cnt++
              }
            }

            resize()
          })

          scope.$watch('options', function (newOptions) {
            graph.updateOptions(newOptions)
            resize()
          }, true)

          scope.highlightCallback = function (event, x, points, row) {
            if (!scope.options.showPopover) {
              return
            }
            var html = "<table><tr><th colspan='2'>"

            if (scope.options.labelType === 'date') {
              html += '<strong>' + scope.options.xlabel + ': <strong>' + moment(x).format(scope.legend.dateFormat)
            } else if (typeof moment === 'function' && scope.legend !== undefined) {
              html += '<strong>' + scope.options.xlabel + ': <strong>' + (scope.options.xValueFormat && scope.options.xValueFormat === 'date' ? moment(x).format(scope.legend.dateFormat) : x)
            } else {
              html += '<strong>' + scope.options.xlabel + ': <strong>' + x
            }
            html += '</th></tr>'

            angular.forEach(points, function (point) {
              var color
              var label
              var value
              if (scope.legendSeries[point.name] !== undefined) {
                label = scope.legendSeries[point.name].label
                color = "style='color:" + scope.legendSeries[point.name].color + ";'"
                if (scope.legendSeries[point.name].format) {
                  value = point.yval.toFixed(scope.legendSeries[point.name].format)
                } else {
                  value = point.yval
                }
              } else {
                label = point.name
                color = ''
              }
              html += '<tr ' + color + '><td>' + label + '</td>' + '<td>' + value + '</td></tr>'
            })
            html += '</table>'
            popover.html(html)
            popover.show()
            var table = popover.find('table')
            popoverWidth = table.outerWidth(true)
            popoverHeight = table.outerHeight(true)

            // Provide some hysterises to the popup position to stop it flicking back and forward
            if (points[0].x < 0.4) {
              popoverPos = false
            } else if (points[0].x > 0.6) {
              popoverPos = true
            }
            if (popoverPos === true) {
              x = event.pageX - popoverWidth - 20
            } else {
              x = event.pageX + 20
            }
            popover.width(popoverWidth)
            popover.height(popoverHeight)
            popover.animate({ left: x + 'px', top: (event.pageY - (popoverHeight / 2)) + 'px' }, 20)
          }

          scope.unhighlightCallback = function (event, a, b) {
            if (!scope.options.showPopover) {
              popover.hide()
              return
            }
            // Check if the cursor is still within the chart area
            // If so, ignore this event.
            // This stops flickering if we get an even when the mouse covers the popover
            if (event.pageX > chartArea.left && event.pageX < chartArea.right && event.pageY > chartArea.top && event.pageY < chartArea.bottom) {
              var x
              if (popoverPos === true) {
                x = event.pageX - popoverWidth - 20
              } else {
                x = event.pageX + 20
              }
              popover.animate({ left: x + 'px' }, 10)
              return
            }
            popover.hide()
          }

          scope.seriesLine = function (series) {
            return $sce.trustAsHtml('<input style="margin-right:10px" type="checkbox" ' + (series.visible ? 'checked' : '') + '/>')
          }

          scope.seriesStyle = function (series) {
            if (series.visible) {
              return { color: series.color, 'cursor': 'pointer' }
            }
            return { 'cursor': 'pointer' }
          }

          scope.selectSeries = function (series) {
            // console.log('Change series', series)
            series.visible = !series.visible
            graph.setVisibility(series.column, series.visible)
          }

          resize()

          var w = angular.element($window)
          w.bind('resize', function () {
            resize()
          })

          function resize() {
            var maxWidth = 0
            element.find('div.series').each(function () {
              var itemWidth = window.$(this).width()
              maxWidth = Math.max(maxWidth, itemWidth)
            })
            element.find('div.series').each(function () { })

            var legendHeight = element.find('div.legend').outerHeight(true)
            graph.resize(parent.width(), parent.height() - legendHeight)
            chartArea = window.$(chartDiv).offset()
            chartArea.bottom = chartArea.top + parent.height() - legendHeight
            chartArea.right = chartArea.left + parent.width()
          }
        }
      }
    }])

})();

(function () {
  /**
 * Checklist-model
 * AngularJS directive for list of checkboxes
 * https://github.com/vitalets/checklist-model
 * License: MIT http://opensource.org/licenses/MIT
 */
  var angular = window.angular

  angular.module('Vibzer').directive('checklistModel', ['$parse', '$compile', function ($parse, $compile) {
    // contains
    function contains(arr, item, comparator) {
      if (angular.isArray(arr)) {
        for (var i = arr.length; i--;) {
          if (comparator(arr[i], item)) {
            return true
          }
        }
      }
      return false
    }

    // add
    function add(arr, item, comparator) {
      arr = angular.isArray(arr) ? arr : []
      if (!contains(arr, item, comparator)) {
        arr.push(item)
      }
      return arr
    }

    // remove
    function remove(arr, item, comparator) {
      if (angular.isArray(arr)) {
        for (var i = arr.length; i--;) {
          if (comparator(arr[i], item)) {
            arr.splice(i, 1)
            break
          }
        }
      }
      return arr
    }

    // http://stackoverflow.com/a/19228302/1458162
    function postLinkFn(scope, elem, attrs) {
      // exclude recursion, but still keep the model
      var checklistModel = attrs.checklistModel
      attrs.$set('checklistModel', null)
      // compile with `ng-model` pointing to `checked`
      $compile(elem)(scope)
      attrs.$set('checklistModel', checklistModel)

      // getter for original model
      var checklistModelGetter = $parse(checklistModel)
      var checklistChange = $parse(attrs.checklistChange)
      var checklistBeforeChange = $parse(attrs.checklistBeforeChange)
      var ngModelGetter = $parse(attrs.ngModel)

      var comparator = angular.equals

      if (attrs.hasOwnProperty('checklistComparator')) {
        if (attrs.checklistComparator[0] === '.') {
          var comparatorExpression = attrs.checklistComparator.substring(1)
          comparator = function (a, b) {
            return a[comparatorExpression] === b[comparatorExpression]
          }
        } else {
          comparator = $parse(attrs.checklistComparator)(scope.$parent)
        }
      }

      // watch UI checked change
      scope.$watch(attrs.ngModel, function (newValue, oldValue) {
        if (newValue === oldValue) {
          return
        }

        if (checklistBeforeChange && (checklistBeforeChange(scope) === false)) {
          ngModelGetter.assign(scope, contains(checklistModelGetter(scope.$parent), getChecklistValue(), comparator))
          return
        }

        setValueInChecklistModel(getChecklistValue(), newValue)

        if (checklistChange) {
          checklistChange(scope)
        }
      })

      // watches for value change of checklistValue
      scope.$watch(getChecklistValue, function (newValue, oldValue) {
        if (newValue !== oldValue && angular.isDefined(oldValue) && scope[attrs.ngModel] === true) {
          var current = checklistModelGetter(scope.$parent)
          checklistModelGetter.assign(scope.$parent, remove(current, oldValue, comparator))
          checklistModelGetter.assign(scope.$parent, add(current, newValue, comparator))
        }
      }, true)

      function getChecklistValue() {
        return attrs.checklistValue ? $parse(attrs.checklistValue)(scope.$parent) : attrs.value
      }

      function setValueInChecklistModel(value, checked) {
        var current = checklistModelGetter(scope.$parent)
        if (angular.isFunction(checklistModelGetter.assign)) {
          if (checked === true) {
            checklistModelGetter.assign(scope.$parent, add(current, value, comparator))
          } else {
            checklistModelGetter.assign(scope.$parent, remove(current, value, comparator))
          }
        }
      }

      // declare one function to be used for both $watch functions
      function setChecked(newArr, oldArr) {
        if (checklistBeforeChange && (checklistBeforeChange(scope) === false)) {
          setValueInChecklistModel(getChecklistValue(), ngModelGetter(scope))
          return
        }
        ngModelGetter.assign(scope, contains(newArr, getChecklistValue(), comparator))
      }

      // watch original model change
      // use the faster $watchCollection method if it's available
      if (angular.isFunction(scope.$parent.$watchCollection)) {
        scope.$parent.$watchCollection(checklistModel, setChecked)
      } else {
        scope.$parent.$watch(checklistModel, setChecked, true)
      }
    }

    return {
      restrict: 'A',
      priority: 1000,
      terminal: true,
      scope: true,
      compile: function (tElement, tAttrs) {
        if (!tAttrs.checklistValue && !tAttrs.value) {
          // throw 'You should provide `value` or `checklist-value`.'
          throw new MyException('You should provide `value` or `checklist-value`.')
        }

        // by default ngModel is 'checked', so we set it if not specified
        if (!tAttrs.ngModel) {
          // local scope var storing individual checkbox model
          tAttrs.$set('ngModel', 'checked')
        }

        return postLinkFn
      }
    }

    function MyException(message) {
      this.name = 'MyException'
      this.message = message
    }
  }])

})();
!function (a, i) { "use strict"; "object" == typeof module && module.exports ? module.exports = i(require("moment")) : "function" == typeof define && define.amd ? define(["moment"], i) : i(a.moment) }(this, function (A) { "use strict"; var i, c = {}, n = {}, s = {}, u = {}; A && "string" == typeof A.version || N("Moment Timezone requires Moment.js. See https://momentjs.com/timezone/docs/#/use-it/browser/"); var a = A.version.split("."), e = +a[0], r = +a[1]; function t(a) { return 96 < a ? a - 87 : 64 < a ? a - 29 : a - 48 } function o(a) { var i = 0, e = a.split("."), r = e[0], o = e[1] || "", A = 1, c = 0, n = 1; for (45 === a.charCodeAt(0) && (n = -(i = 1)); i < r.length; i++)c = 60 * c + t(r.charCodeAt(i)); for (i = 0; i < o.length; i++)A /= 60, c += t(o.charCodeAt(i)) * A; return c * n } function m(a) { for (var i = 0; i < a.length; i++)a[i] = o(a[i]) } function f(a, i) { var e, r = []; for (e = 0; e < i.length; e++)r[e] = a[i[e]]; return r } function l(a) { var i = a.split("|"), e = i[2].split(" "), r = i[3].split(""), o = i[4].split(" "); return m(e), m(r), m(o), function (a, i) { for (var e = 0; e < i; e++)a[e] = Math.round((a[e - 1] || 0) + 6e4 * a[e]); a[i - 1] = 1 / 0 }(o, r.length), { name: i[0], abbrs: f(i[1].split(" "), r), offsets: f(e, r), untils: o, population: 0 | i[5] } } function p(a) { a && this._set(l(a)) } function b(a) { var i = a.toTimeString(), e = i.match(/\([a-z ]+\)/i); "GMT" === (e = e && e[0] ? (e = e[0].match(/[A-Z]/g)) ? e.join("") : void 0 : (e = i.match(/[A-Z]{3,5}/g)) ? e[0] : void 0) && (e = void 0), this.at = +a, this.abbr = e, this.offset = a.getTimezoneOffset() } function M(a) { this.zone = a, this.offsetScore = 0, this.abbrScore = 0 } function d(a, i) { for (var e, r; r = 6e4 * ((i.at - a.at) / 12e4 | 0);)(e = new b(new Date(a.at + r))).offset === a.offset ? a = e : i = e; return a } function h(a, i) { return a.offsetScore !== i.offsetScore ? a.offsetScore - i.offsetScore : a.abbrScore !== i.abbrScore ? a.abbrScore - i.abbrScore : i.zone.population - a.zone.population } function z(a, i) { var e, r; for (m(i), e = 0; e < i.length; e++)r = i[e], u[r] = u[r] || {}, u[r][a] = !0 } function E() { try { var a = Intl.DateTimeFormat().resolvedOptions().timeZone; if (a && 3 < a.length) { var i = s[g(a)]; if (i) return i; N("Moment Timezone found " + a + " from the Intl api, but did not have that data loaded.") } } catch (a) { } var e, r, o, A = function () { var a, i, e, r = (new Date).getFullYear() - 2, o = new b(new Date(r, 0, 1)), A = [o]; for (e = 1; e < 48; e++)(i = new b(new Date(r, e, 1))).offset !== o.offset && (a = d(o, i), A.push(a), A.push(new b(new Date(a.at + 6e4)))), o = i; for (e = 0; e < 4; e++)A.push(new b(new Date(r + e, 0, 1))), A.push(new b(new Date(r + e, 6, 1))); return A }(), c = A.length, n = function (a) { var i, e, r, o = a.length, A = {}, c = []; for (i = 0; i < o; i++)for (e in r = u[a[i].offset] || {}) r.hasOwnProperty(e) && (A[e] = !0); for (i in A) A.hasOwnProperty(i) && c.push(s[i]); return c }(A), t = []; for (r = 0; r < n.length; r++) { for (e = new M(P(n[r]), c), o = 0; o < c; o++)e.scoreOffsetAt(A[o]); t.push(e) } return t.sort(h), 0 < t.length ? t[0].zone.name : void 0 } function g(a) { return (a || "").toLowerCase().replace(/\//g, "_") } function T(a) { var i, e, r, o; for ("string" == typeof a && (a = [a]), i = 0; i < a.length; i++)o = g(e = (r = a[i].split("|"))[0]), c[o] = a[i], s[o] = e, z(o, r[2].split(" ")) } function P(a, i) { a = g(a); var e, r = c[a]; return r instanceof p ? r : "string" == typeof r ? (r = new p(r), c[a] = r) : n[a] && i !== P && (e = P(n[a], P)) ? ((r = c[a] = new p)._set(e), r.name = s[a], r) : null } function S(a) { var i, e, r, o; for ("string" == typeof a && (a = [a]), i = 0; i < a.length; i++)r = g((e = a[i].split("|"))[0]), o = g(e[1]), n[r] = o, s[r] = e[0], n[o] = r, s[o] = e[1] } function _(a) { T(a.zones), S(a.links), C.dataVersion = a.version } function k(a) { var i = "X" === a._f || "x" === a._f; return !(!a._a || void 0 !== a._tzm || i) } function N(a) { "undefined" != typeof console && "function" == typeof console.error && console.error(a) } function C(a) { var i = Array.prototype.slice.call(arguments, 0, -1), e = arguments[arguments.length - 1], r = P(e), o = A.utc.apply(null, i); return r && !A.isMoment(a) && k(o) && o.add(r.parse(o), "minutes"), o.tz(e), o } (e < 2 || 2 === e && r < 6) && N("Moment Timezone requires Moment.js >= 2.6.0. You are using Moment.js " + A.version + ". See momentjs.com"), p.prototype = { _set: function (a) { this.name = a.name, this.abbrs = a.abbrs, this.untils = a.untils, this.offsets = a.offsets, this.population = a.population }, _index: function (a) { var i, e = +a, r = this.untils; for (i = 0; i < r.length; i++)if (e < r[i]) return i }, parse: function (a) { var i, e, r, o, A = +a, c = this.offsets, n = this.untils, t = n.length - 1; for (o = 0; o < t; o++)if (i = c[o], e = c[o + 1], r = c[o ? o - 1 : o], i < e && C.moveAmbiguousForward ? i = e : r < i && C.moveInvalidForward && (i = r), A < n[o] - 6e4 * i) return c[o]; return c[t] }, abbr: function (a) { return this.abbrs[this._index(a)] }, offset: function (a) { return N("zone.offset has been deprecated in favor of zone.utcOffset"), this.offsets[this._index(a)] }, utcOffset: function (a) { return this.offsets[this._index(a)] } }, M.prototype.scoreOffsetAt = function (a) { this.offsetScore += Math.abs(this.zone.utcOffset(a.at) - a.offset), this.zone.abbr(a.at).replace(/[^A-Z]/g, "") !== a.abbr && this.abbrScore++ }, C.version = "0.5.23", C.dataVersion = "", C._zones = c, C._links = n, C._names = s, C.add = T, C.link = S, C.load = _, C.zone = P, C.zoneExists = function a(i) { return a.didShowError || (a.didShowError = !0, N("moment.tz.zoneExists('" + i + "') has been deprecated in favor of !moment.tz.zone('" + i + "')")), !!P(i) }, C.guess = function (a) { return i && !a || (i = E()), i }, C.names = function () { var a, i = []; for (a in s) s.hasOwnProperty(a) && (c[a] || c[n[a]]) && s[a] && i.push(s[a]); return i.sort() }, C.Zone = p, C.unpack = l, C.unpackBase60 = o, C.needsOffset = k, C.moveInvalidForward = !0, C.moveAmbiguousForward = !1; var B, O = A.fn; function G(a) { return function () { return this._z ? this._z.abbr(this) : a.call(this) } } A.tz = C, A.defaultZone = null, A.updateOffset = function (a, i) { var e, r = A.defaultZone; void 0 === a._z && (r && k(a) && !a._isUTC && (a._d = A.utc(a._a)._d, a.utc().add(r.parse(a), "minutes")), a._z = r), a._z && (e = a._z.utcOffset(a), Math.abs(e) < 16 && (e /= 60), void 0 !== a.utcOffset ? a.utcOffset(-e, i) : a.zone(e, i)) }, O.tz = function (a, i) { if (a) { if ("string" != typeof a) throw new Error("Time zone name must be a string, got " + a + " [" + typeof a + "]"); return this._z = P(a), this._z ? A.updateOffset(this, i) : N("Moment Timezone has no data for " + a + ". See http://momentjs.com/timezone/docs/#/data-loading/."), this } if (this._z) return this._z.name }, O.zoneName = G(O.zoneName), O.zoneAbbr = G(O.zoneAbbr), O.utc = (B = O.utc, function () { return this._z = null, B.apply(this, arguments) }), A.tz.setDefault = function (a) { return (e < 2 || 2 === e && r < 9) && N("Moment Timezone setDefault() requires Moment.js >= 2.9.0. You are using Moment.js " + A.version + "."), A.defaultZone = a ? P(a) : null, A }; var D = A.momentProperties; return "[object Array]" === Object.prototype.toString.call(D) ? (D.push("_z"), D.push("_a")) : D && (D._z = null), _({ version: "2018g", zones: ["Africa/Abidjan|GMT|0|0||48e5", "Africa/Nairobi|EAT|-30|0||47e5", "Africa/Algiers|CET|-10|0||26e5", "Africa/Lagos|WAT|-10|0||17e6", "Africa/Maputo|CAT|-20|0||26e5", "Africa/Cairo|EET EEST|-20 -30|01010|1M2m0 gL0 e10 mn0|15e6", "Africa/Casablanca|+00 +01|0 -10|0101010101010101010101010101|1H3C0 wM0 co0 go0 1o00 s00 dA0 vc0 11A0 A00 e00 y00 11A0 uM0 e00 Dc0 11A0 s00 e00 IM0 WM0 mo0 gM0 LA0 WM0 jA0 e00|32e5", "Europe/Paris|CET CEST|-10 -20|01010101010101010101010|1GNB0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0|11e6", "Africa/Johannesburg|SAST|-20|0||84e5", "Africa/Khartoum|EAT CAT|-30 -20|01|1Usl0|51e5", "Africa/Sao_Tome|GMT WAT|0 -10|01|1UQN0", "Africa/Tripoli|EET CET CEST|-20 -10 -20|0120|1IlA0 TA0 1o00|11e5", "Africa/Windhoek|CAT WAT|-20 -10|0101010101010|1GQo0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0|32e4", "America/Adak|HST HDT|a0 90|01010101010101010101010|1GIc0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0|326", "America/Anchorage|AKST AKDT|90 80|01010101010101010101010|1GIb0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0|30e4", "America/Santo_Domingo|AST|40|0||29e5", "America/Araguaina|-03 -02|30 20|010|1IdD0 Lz0|14e4", "America/Fortaleza|-03|30|0||34e5", "America/Asuncion|-03 -04|30 40|01010101010101010101010|1GTf0 1cN0 17b0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0|28e5", "America/Panama|EST|50|0||15e5", "America/Mexico_City|CST CDT|60 50|01010101010101010101010|1GQw0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0|20e6", "America/Bahia|-02 -03|20 30|01|1GCq0|27e5", "America/Managua|CST|60|0||22e5", "America/La_Paz|-04|40|0||19e5", "America/Lima|-05|50|0||11e6", "America/Denver|MST MDT|70 60|01010101010101010101010|1GI90 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0|26e5", "America/Campo_Grande|-03 -04|30 40|01010101010101010101010|1GCr0 1zd0 Lz0 1C10 Lz0 1C10 On0 1zd0 On0 1zd0 On0 1zd0 On0 1HB0 FX0 1HB0 FX0 1HB0 IL0 1HB0 FX0 1HB0|77e4", "America/Cancun|CST CDT EST|60 50 50|01010102|1GQw0 1nX0 14p0 1lb0 14p0 1lb0 Dd0|63e4", "America/Caracas|-0430 -04|4u 40|01|1QMT0|29e5", "America/Chicago|CST CDT|60 50|01010101010101010101010|1GI80 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0|92e5", "America/Chihuahua|MST MDT|70 60|01010101010101010101010|1GQx0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0|81e4", "America/Phoenix|MST|70|0||42e5", "America/Los_Angeles|PST PDT|80 70|01010101010101010101010|1GIa0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0|15e6", "America/New_York|EST EDT|50 40|01010101010101010101010|1GI70 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0|21e6", "America/Rio_Branco|-04 -05|40 50|01|1KLE0|31e4", "America/Fort_Nelson|PST PDT MST|80 70 70|01010102|1GIa0 1zb0 Op0 1zb0 Op0 1zb0 Op0|39e2", "America/Halifax|AST ADT|40 30|01010101010101010101010|1GI60 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0|39e4", "America/Godthab|-03 -02|30 20|01010101010101010101010|1GNB0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0|17e3", "America/Grand_Turk|EST EDT AST|50 40 40|0101010121010101010|1GI70 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 5Ip0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0|37e2", "America/Havana|CST CDT|50 40|01010101010101010101010|1GQt0 1qM0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0|21e5", "America/Metlakatla|PST AKST AKDT|80 90 80|0121212121212121|1PAa0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0|14e2", "America/Miquelon|-03 -02|30 20|01010101010101010101010|1GI50 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0|61e2", "America/Montevideo|-02 -03|20 30|01010101|1GI40 1o10 11z0 1o10 11z0 1o10 11z0|17e5", "America/Noronha|-02|20|0||30e2", "America/Port-au-Prince|EST EDT|50 40|010101010101010101010|1GI70 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 3iN0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0|23e5", "Antarctica/Palmer|-03 -04|30 40|010101010|1H3D0 Op0 1zb0 Rd0 1wn0 Rd0 46n0 Ap0|40", "America/Santiago|-03 -04|30 40|010101010101010101010|1H3D0 Op0 1zb0 Rd0 1wn0 Rd0 46n0 Ap0 1Nb0 Ap0 1Nb0 Ap0 1zb0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0|62e5", "America/Sao_Paulo|-02 -03|20 30|01010101010101010101010|1GCq0 1zd0 Lz0 1C10 Lz0 1C10 On0 1zd0 On0 1zd0 On0 1zd0 On0 1HB0 FX0 1HB0 FX0 1HB0 IL0 1HB0 FX0 1HB0|20e6", "Atlantic/Azores|-01 +00|10 0|01010101010101010101010|1GNB0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0|25e4", "America/St_Johns|NST NDT|3u 2u|01010101010101010101010|1GI5u 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0|11e4", "Antarctica/Casey|+11 +08|-b0 -80|0101|1GAF0 blz0 3m10|10", "Antarctica/Davis|+05 +07|-50 -70|01|1GAI0|70", "Pacific/Port_Moresby|+10|-a0|0||25e4", "Pacific/Guadalcanal|+11|-b0|0||11e4", "Asia/Tashkent|+05|-50|0||23e5", "Pacific/Auckland|NZDT NZST|-d0 -c0|01010101010101010101010|1GQe0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00|14e5", "Asia/Baghdad|+03|-30|0||66e5", "Antarctica/Troll|+00 +02|0 -20|01010101010101010101010|1GNB0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0|40", "Asia/Dhaka|+06|-60|0||16e6", "Asia/Amman|EET EEST|-20 -30|010101010101010101010|1GPy0 4bX0 Dd0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 11A0 1o00|25e5", "Asia/Kamchatka|+12|-c0|0||18e4", "Asia/Baku|+04 +05|-40 -50|010101010|1GNA0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|27e5", "Asia/Bangkok|+07|-70|0||15e6", "Asia/Barnaul|+07 +06|-70 -60|010|1N7v0 3rd0", "Asia/Beirut|EET EEST|-20 -30|01010101010101010101010|1GNy0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0|22e5", "Asia/Kuala_Lumpur|+08|-80|0||71e5", "Asia/Kolkata|IST|-5u|0||15e6", "Asia/Chita|+10 +08 +09|-a0 -80 -90|012|1N7s0 3re0|33e4", "Asia/Ulaanbaatar|+08 +09|-80 -90|01010|1O8G0 1cJ0 1cP0 1cJ0|12e5", "Asia/Shanghai|CST|-80|0||23e6", "Asia/Colombo|+0530|-5u|0||22e5", "Asia/Damascus|EET EEST|-20 -30|01010101010101010101010|1GPy0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0|26e5", "Asia/Dili|+09|-90|0||19e4", "Asia/Dubai|+04|-40|0||39e5", "Asia/Famagusta|EET EEST +03|-20 -30 -30|0101010101201010101010|1GNB0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 15U0 2Ks0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0", "Asia/Gaza|EET EEST|-20 -30|01010101010101010101010|1GPy0 1a00 1fA0 1cL0 1cN0 1nX0 1210 1nz0 1220 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1qL0 WN0 1qL0 WN0 1qL0|18e5", "Asia/Hong_Kong|HKT|-80|0||73e5", "Asia/Hovd|+07 +08|-70 -80|01010|1O8H0 1cJ0 1cP0 1cJ0|81e3", "Asia/Irkutsk|+09 +08|-90 -80|01|1N7t0|60e4", "Europe/Istanbul|EET EEST +03|-20 -30 -30|01010101012|1GNB0 1qM0 11A0 1o00 1200 1nA0 11A0 1tA0 U00 15w0|13e6", "Asia/Jakarta|WIB|-70|0||31e6", "Asia/Jayapura|WIT|-90|0||26e4", "Asia/Jerusalem|IST IDT|-20 -30|01010101010101010101010|1GPA0 1aL0 1eN0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0|81e4", "Asia/Kabul|+0430|-4u|0||46e5", "Asia/Karachi|PKT|-50|0||24e6", "Asia/Kathmandu|+0545|-5J|0||12e5", "Asia/Yakutsk|+10 +09|-a0 -90|01|1N7s0|28e4", "Asia/Krasnoyarsk|+08 +07|-80 -70|01|1N7u0|10e5", "Asia/Magadan|+12 +10 +11|-c0 -a0 -b0|012|1N7q0 3Cq0|95e3", "Asia/Makassar|WITA|-80|0||15e5", "Asia/Manila|PST|-80|0||24e6", "Europe/Athens|EET EEST|-20 -30|01010101010101010101010|1GNB0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0|35e5", "Asia/Novosibirsk|+07 +06|-70 -60|010|1N7v0 4eN0|15e5", "Asia/Omsk|+07 +06|-70 -60|01|1N7v0|12e5", "Asia/Pyongyang|KST KST|-90 -8u|010|1P4D0 6BA0|29e5", "Asia/Rangoon|+0630|-6u|0||48e5", "Asia/Sakhalin|+11 +10|-b0 -a0|010|1N7r0 3rd0|58e4", "Asia/Seoul|KST|-90|0||23e6", "Asia/Srednekolymsk|+12 +11|-c0 -b0|01|1N7q0|35e2", "Asia/Tehran|+0330 +0430|-3u -4u|01010101010101010101010|1GLUu 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 1cp0 1dz0|14e6", "Asia/Tokyo|JST|-90|0||38e6", "Asia/Tomsk|+07 +06|-70 -60|010|1N7v0 3Qp0|10e5", "Asia/Vladivostok|+11 +10|-b0 -a0|01|1N7r0|60e4", "Asia/Yekaterinburg|+06 +05|-60 -50|01|1N7w0|14e5", "Europe/Lisbon|WET WEST|0 -10|01010101010101010101010|1GNB0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0|27e5", "Atlantic/Cape_Verde|-01|10|0||50e4", "Australia/Sydney|AEDT AEST|-b0 -a0|01010101010101010101010|1GQg0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0|40e5", "Australia/Adelaide|ACDT ACST|-au -9u|01010101010101010101010|1GQgu 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0|11e5", "Australia/Brisbane|AEST|-a0|0||20e5", "Australia/Darwin|ACST|-9u|0||12e4", "Australia/Eucla|+0845|-8J|0||368", "Australia/Lord_Howe|+11 +1030|-b0 -au|01010101010101010101010|1GQf0 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu|347", "Australia/Perth|AWST|-80|0||18e5", "Pacific/Easter|-05 -06|50 60|010101010101010101010|1H3D0 Op0 1zb0 Rd0 1wn0 Rd0 46n0 Ap0 1Nb0 Ap0 1Nb0 Ap0 1zb0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0|30e2", "Europe/Dublin|GMT IST|0 -10|01010101010101010101010|1GNB0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0|12e5", "Etc/GMT-1|+01|-10|0|", "Pacific/Fakaofo|+13|-d0|0||483", "Pacific/Kiritimati|+14|-e0|0||51e2", "Etc/GMT-2|+02|-20|0|", "Pacific/Tahiti|-10|a0|0||18e4", "Pacific/Niue|-11|b0|0||12e2", "Etc/GMT+12|-12|c0|0|", "Pacific/Galapagos|-06|60|0||25e3", "Etc/GMT+7|-07|70|0|", "Pacific/Pitcairn|-08|80|0||56", "Pacific/Gambier|-09|90|0||125", "Etc/UCT|UCT|0|0|", "Etc/UTC|UTC|0|0|", "Europe/Ulyanovsk|+04 +03|-40 -30|010|1N7y0 3rd0|13e5", "Europe/London|GMT BST|0 -10|01010101010101010101010|1GNB0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0|10e6", "Europe/Chisinau|EET EEST|-20 -30|01010101010101010101010|1GNA0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0|67e4", "Europe/Kaliningrad|+03 EET|-30 -20|01|1N7z0|44e4", "Europe/Kirov|+04 +03|-40 -30|01|1N7y0|48e4", "Europe/Moscow|MSK MSK|-40 -30|01|1N7y0|16e6", "Europe/Saratov|+04 +03|-40 -30|010|1N7y0 5810", "Europe/Simferopol|EET EEST MSK MSK|-20 -30 -40 -30|0101023|1GNB0 1qM0 11A0 1o00 11z0 1nW0|33e4", "Europe/Volgograd|+04 +03|-40 -30|010|1N7y0 9Jd0|10e5", "Pacific/Honolulu|HST|a0|0||37e4", "MET|MET MEST|-10 -20|01010101010101010101010|1GNB0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0", "Pacific/Chatham|+1345 +1245|-dJ -cJ|01010101010101010101010|1GQe0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00|600", "Pacific/Apia|+14 +13|-e0 -d0|01010101010101010101010|1GQe0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00|37e3", "Pacific/Bougainville|+10 +11|-a0 -b0|01|1NwE0|18e4", "Pacific/Fiji|+13 +12|-d0 -c0|01010101010101010101010|1Goe0 1Nc0 Ao0 1Q00 xz0 1SN0 uM0 1SM0 uM0 1VA0 s00 1VA0 s00 1VA0 s00 1VA0 uM0 1SM0 uM0 1VA0 s00 1VA0|88e4", "Pacific/Guam|ChST|-a0|0||17e4", "Pacific/Marquesas|-0930|9u|0||86e2", "Pacific/Pago_Pago|SST|b0|0||37e2", "Pacific/Norfolk|+1130 +11|-bu -b0|01|1PoCu|25e4", "Pacific/Tongatapu|+13 +14|-d0 -e0|010|1S4d0 s00|75e3"], links: ["Africa/Abidjan|Africa/Accra", "Africa/Abidjan|Africa/Bamako", "Africa/Abidjan|Africa/Banjul", "Africa/Abidjan|Africa/Bissau", "Africa/Abidjan|Africa/Conakry", "Africa/Abidjan|Africa/Dakar", "Africa/Abidjan|Africa/Freetown", "Africa/Abidjan|Africa/Lome", "Africa/Abidjan|Africa/Monrovia", "Africa/Abidjan|Africa/Nouakchott", "Africa/Abidjan|Africa/Ouagadougou", "Africa/Abidjan|Africa/Timbuktu", "Africa/Abidjan|America/Danmarkshavn", "Africa/Abidjan|Atlantic/Reykjavik", "Africa/Abidjan|Atlantic/St_Helena", "Africa/Abidjan|Etc/GMT", "Africa/Abidjan|Etc/GMT+0", "Africa/Abidjan|Etc/GMT-0", "Africa/Abidjan|Etc/GMT0", "Africa/Abidjan|Etc/Greenwich", "Africa/Abidjan|GMT", "Africa/Abidjan|GMT+0", "Africa/Abidjan|GMT-0", "Africa/Abidjan|GMT0", "Africa/Abidjan|Greenwich", "Africa/Abidjan|Iceland", "Africa/Algiers|Africa/Tunis", "Africa/Cairo|Egypt", "Africa/Casablanca|Africa/El_Aaiun", "Africa/Johannesburg|Africa/Maseru", "Africa/Johannesburg|Africa/Mbabane", "Africa/Lagos|Africa/Bangui", "Africa/Lagos|Africa/Brazzaville", "Africa/Lagos|Africa/Douala", "Africa/Lagos|Africa/Kinshasa", "Africa/Lagos|Africa/Libreville", "Africa/Lagos|Africa/Luanda", "Africa/Lagos|Africa/Malabo", "Africa/Lagos|Africa/Ndjamena", "Africa/Lagos|Africa/Niamey", "Africa/Lagos|Africa/Porto-Novo", "Africa/Maputo|Africa/Blantyre", "Africa/Maputo|Africa/Bujumbura", "Africa/Maputo|Africa/Gaborone", "Africa/Maputo|Africa/Harare", "Africa/Maputo|Africa/Kigali", "Africa/Maputo|Africa/Lubumbashi", "Africa/Maputo|Africa/Lusaka", "Africa/Nairobi|Africa/Addis_Ababa", "Africa/Nairobi|Africa/Asmara", "Africa/Nairobi|Africa/Asmera", "Africa/Nairobi|Africa/Dar_es_Salaam", "Africa/Nairobi|Africa/Djibouti", "Africa/Nairobi|Africa/Juba", "Africa/Nairobi|Africa/Kampala", "Africa/Nairobi|Africa/Mogadishu", "Africa/Nairobi|Indian/Antananarivo", "Africa/Nairobi|Indian/Comoro", "Africa/Nairobi|Indian/Mayotte", "Africa/Tripoli|Libya", "America/Adak|America/Atka", "America/Adak|US/Aleutian", "America/Anchorage|America/Juneau", "America/Anchorage|America/Nome", "America/Anchorage|America/Sitka", "America/Anchorage|America/Yakutat", "America/Anchorage|US/Alaska", "America/Campo_Grande|America/Cuiaba", "America/Chicago|America/Indiana/Knox", "America/Chicago|America/Indiana/Tell_City", "America/Chicago|America/Knox_IN", "America/Chicago|America/Matamoros", "America/Chicago|America/Menominee", "America/Chicago|America/North_Dakota/Beulah", "America/Chicago|America/North_Dakota/Center", "America/Chicago|America/North_Dakota/New_Salem", "America/Chicago|America/Rainy_River", "America/Chicago|America/Rankin_Inlet", "America/Chicago|America/Resolute", "America/Chicago|America/Winnipeg", "America/Chicago|CST6CDT", "America/Chicago|Canada/Central", "America/Chicago|US/Central", "America/Chicago|US/Indiana-Starke", "America/Chihuahua|America/Mazatlan", "America/Chihuahua|Mexico/BajaSur", "America/Denver|America/Boise", "America/Denver|America/Cambridge_Bay", "America/Denver|America/Edmonton", "America/Denver|America/Inuvik", "America/Denver|America/Ojinaga", "America/Denver|America/Shiprock", "America/Denver|America/Yellowknife", "America/Denver|Canada/Mountain", "America/Denver|MST7MDT", "America/Denver|Navajo", "America/Denver|US/Mountain", "America/Fortaleza|America/Argentina/Buenos_Aires", "America/Fortaleza|America/Argentina/Catamarca", "America/Fortaleza|America/Argentina/ComodRivadavia", "America/Fortaleza|America/Argentina/Cordoba", "America/Fortaleza|America/Argentina/Jujuy", "America/Fortaleza|America/Argentina/La_Rioja", "America/Fortaleza|America/Argentina/Mendoza", "America/Fortaleza|America/Argentina/Rio_Gallegos", "America/Fortaleza|America/Argentina/Salta", "America/Fortaleza|America/Argentina/San_Juan", "America/Fortaleza|America/Argentina/San_Luis", "America/Fortaleza|America/Argentina/Tucuman", "America/Fortaleza|America/Argentina/Ushuaia", "America/Fortaleza|America/Belem", "America/Fortaleza|America/Buenos_Aires", "America/Fortaleza|America/Catamarca", "America/Fortaleza|America/Cayenne", "America/Fortaleza|America/Cordoba", "America/Fortaleza|America/Jujuy", "America/Fortaleza|America/Maceio", "America/Fortaleza|America/Mendoza", "America/Fortaleza|America/Paramaribo", "America/Fortaleza|America/Recife", "America/Fortaleza|America/Rosario", "America/Fortaleza|America/Santarem", "America/Fortaleza|Antarctica/Rothera", "America/Fortaleza|Atlantic/Stanley", "America/Fortaleza|Etc/GMT+3", "America/Halifax|America/Glace_Bay", "America/Halifax|America/Goose_Bay", "America/Halifax|America/Moncton", "America/Halifax|America/Thule", "America/Halifax|Atlantic/Bermuda", "America/Halifax|Canada/Atlantic", "America/Havana|Cuba", "America/La_Paz|America/Boa_Vista", "America/La_Paz|America/Guyana", "America/La_Paz|America/Manaus", "America/La_Paz|America/Porto_Velho", "America/La_Paz|Brazil/West", "America/La_Paz|Etc/GMT+4", "America/Lima|America/Bogota", "America/Lima|America/Guayaquil", "America/Lima|Etc/GMT+5", "America/Los_Angeles|America/Dawson", "America/Los_Angeles|America/Ensenada", "America/Los_Angeles|America/Santa_Isabel", "America/Los_Angeles|America/Tijuana", "America/Los_Angeles|America/Vancouver", "America/Los_Angeles|America/Whitehorse", "America/Los_Angeles|Canada/Pacific", "America/Los_Angeles|Canada/Yukon", "America/Los_Angeles|Mexico/BajaNorte", "America/Los_Angeles|PST8PDT", "America/Los_Angeles|US/Pacific", "America/Los_Angeles|US/Pacific-New", "America/Managua|America/Belize", "America/Managua|America/Costa_Rica", "America/Managua|America/El_Salvador", "America/Managua|America/Guatemala", "America/Managua|America/Regina", "America/Managua|America/Swift_Current", "America/Managua|America/Tegucigalpa", "America/Managua|Canada/Saskatchewan", "America/Mexico_City|America/Bahia_Banderas", "America/Mexico_City|America/Merida", "America/Mexico_City|America/Monterrey", "America/Mexico_City|Mexico/General", "America/New_York|America/Detroit", "America/New_York|America/Fort_Wayne", "America/New_York|America/Indiana/Indianapolis", "America/New_York|America/Indiana/Marengo", "America/New_York|America/Indiana/Petersburg", "America/New_York|America/Indiana/Vevay", "America/New_York|America/Indiana/Vincennes", "America/New_York|America/Indiana/Winamac", "America/New_York|America/Indianapolis", "America/New_York|America/Iqaluit", "America/New_York|America/Kentucky/Louisville", "America/New_York|America/Kentucky/Monticello", "America/New_York|America/Louisville", "America/New_York|America/Montreal", "America/New_York|America/Nassau", "America/New_York|America/Nipigon", "America/New_York|America/Pangnirtung", "America/New_York|America/Thunder_Bay", "America/New_York|America/Toronto", "America/New_York|Canada/Eastern", "America/New_York|EST5EDT", "America/New_York|US/East-Indiana", "America/New_York|US/Eastern", "America/New_York|US/Michigan", "America/Noronha|Atlantic/South_Georgia", "America/Noronha|Brazil/DeNoronha", "America/Noronha|Etc/GMT+2", "America/Panama|America/Atikokan", "America/Panama|America/Cayman", "America/Panama|America/Coral_Harbour", "America/Panama|America/Jamaica", "America/Panama|EST", "America/Panama|Jamaica", "America/Phoenix|America/Creston", "America/Phoenix|America/Dawson_Creek", "America/Phoenix|America/Hermosillo", "America/Phoenix|MST", "America/Phoenix|US/Arizona", "America/Rio_Branco|America/Eirunepe", "America/Rio_Branco|America/Porto_Acre", "America/Rio_Branco|Brazil/Acre", "America/Santiago|Chile/Continental", "America/Santo_Domingo|America/Anguilla", "America/Santo_Domingo|America/Antigua", "America/Santo_Domingo|America/Aruba", "America/Santo_Domingo|America/Barbados", "America/Santo_Domingo|America/Blanc-Sablon", "America/Santo_Domingo|America/Curacao", "America/Santo_Domingo|America/Dominica", "America/Santo_Domingo|America/Grenada", "America/Santo_Domingo|America/Guadeloupe", "America/Santo_Domingo|America/Kralendijk", "America/Santo_Domingo|America/Lower_Princes", "America/Santo_Domingo|America/Marigot", "America/Santo_Domingo|America/Martinique", "America/Santo_Domingo|America/Montserrat", "America/Santo_Domingo|America/Port_of_Spain", "America/Santo_Domingo|America/Puerto_Rico", "America/Santo_Domingo|America/St_Barthelemy", "America/Santo_Domingo|America/St_Kitts", "America/Santo_Domingo|America/St_Lucia", "America/Santo_Domingo|America/St_Thomas", "America/Santo_Domingo|America/St_Vincent", "America/Santo_Domingo|America/Tortola", "America/Santo_Domingo|America/Virgin", "America/Sao_Paulo|Brazil/East", "America/St_Johns|Canada/Newfoundland", "Antarctica/Palmer|America/Punta_Arenas", "Asia/Baghdad|Antarctica/Syowa", "Asia/Baghdad|Asia/Aden", "Asia/Baghdad|Asia/Bahrain", "Asia/Baghdad|Asia/Kuwait", "Asia/Baghdad|Asia/Qatar", "Asia/Baghdad|Asia/Riyadh", "Asia/Baghdad|Etc/GMT-3", "Asia/Baghdad|Europe/Minsk", "Asia/Bangkok|Asia/Ho_Chi_Minh", "Asia/Bangkok|Asia/Novokuznetsk", "Asia/Bangkok|Asia/Phnom_Penh", "Asia/Bangkok|Asia/Saigon", "Asia/Bangkok|Asia/Vientiane", "Asia/Bangkok|Etc/GMT-7", "Asia/Bangkok|Indian/Christmas", "Asia/Dhaka|Antarctica/Vostok", "Asia/Dhaka|Asia/Almaty", "Asia/Dhaka|Asia/Bishkek", "Asia/Dhaka|Asia/Dacca", "Asia/Dhaka|Asia/Kashgar", "Asia/Dhaka|Asia/Qyzylorda", "Asia/Dhaka|Asia/Thimbu", "Asia/Dhaka|Asia/Thimphu", "Asia/Dhaka|Asia/Urumqi", "Asia/Dhaka|Etc/GMT-6", "Asia/Dhaka|Indian/Chagos", "Asia/Dili|Etc/GMT-9", "Asia/Dili|Pacific/Palau", "Asia/Dubai|Asia/Muscat", "Asia/Dubai|Asia/Tbilisi", "Asia/Dubai|Asia/Yerevan", "Asia/Dubai|Etc/GMT-4", "Asia/Dubai|Europe/Samara", "Asia/Dubai|Indian/Mahe", "Asia/Dubai|Indian/Mauritius", "Asia/Dubai|Indian/Reunion", "Asia/Gaza|Asia/Hebron", "Asia/Hong_Kong|Hongkong", "Asia/Jakarta|Asia/Pontianak", "Asia/Jerusalem|Asia/Tel_Aviv", "Asia/Jerusalem|Israel", "Asia/Kamchatka|Asia/Anadyr", "Asia/Kamchatka|Etc/GMT-12", "Asia/Kamchatka|Kwajalein", "Asia/Kamchatka|Pacific/Funafuti", "Asia/Kamchatka|Pacific/Kwajalein", "Asia/Kamchatka|Pacific/Majuro", "Asia/Kamchatka|Pacific/Nauru", "Asia/Kamchatka|Pacific/Tarawa", "Asia/Kamchatka|Pacific/Wake", "Asia/Kamchatka|Pacific/Wallis", "Asia/Kathmandu|Asia/Katmandu", "Asia/Kolkata|Asia/Calcutta", "Asia/Kuala_Lumpur|Asia/Brunei", "Asia/Kuala_Lumpur|Asia/Kuching", "Asia/Kuala_Lumpur|Asia/Singapore", "Asia/Kuala_Lumpur|Etc/GMT-8", "Asia/Kuala_Lumpur|Singapore", "Asia/Makassar|Asia/Ujung_Pandang", "Asia/Rangoon|Asia/Yangon", "Asia/Rangoon|Indian/Cocos", "Asia/Seoul|ROK", "Asia/Shanghai|Asia/Chongqing", "Asia/Shanghai|Asia/Chungking", "Asia/Shanghai|Asia/Harbin", "Asia/Shanghai|Asia/Macao", "Asia/Shanghai|Asia/Macau", "Asia/Shanghai|Asia/Taipei", "Asia/Shanghai|PRC", "Asia/Shanghai|ROC", "Asia/Tashkent|Antarctica/Mawson", "Asia/Tashkent|Asia/Aqtau", "Asia/Tashkent|Asia/Aqtobe", "Asia/Tashkent|Asia/Ashgabat", "Asia/Tashkent|Asia/Ashkhabad", "Asia/Tashkent|Asia/Atyrau", "Asia/Tashkent|Asia/Dushanbe", "Asia/Tashkent|Asia/Oral", "Asia/Tashkent|Asia/Samarkand", "Asia/Tashkent|Etc/GMT-5", "Asia/Tashkent|Indian/Kerguelen", "Asia/Tashkent|Indian/Maldives", "Asia/Tehran|Iran", "Asia/Tokyo|Japan", "Asia/Ulaanbaatar|Asia/Choibalsan", "Asia/Ulaanbaatar|Asia/Ulan_Bator", "Asia/Vladivostok|Asia/Ust-Nera", "Asia/Yakutsk|Asia/Khandyga", "Atlantic/Azores|America/Scoresbysund", "Atlantic/Cape_Verde|Etc/GMT+1", "Australia/Adelaide|Australia/Broken_Hill", "Australia/Adelaide|Australia/South", "Australia/Adelaide|Australia/Yancowinna", "Australia/Brisbane|Australia/Lindeman", "Australia/Brisbane|Australia/Queensland", "Australia/Darwin|Australia/North", "Australia/Lord_Howe|Australia/LHI", "Australia/Perth|Australia/West", "Australia/Sydney|Australia/ACT", "Australia/Sydney|Australia/Canberra", "Australia/Sydney|Australia/Currie", "Australia/Sydney|Australia/Hobart", "Australia/Sydney|Australia/Melbourne", "Australia/Sydney|Australia/NSW", "Australia/Sydney|Australia/Tasmania", "Australia/Sydney|Australia/Victoria", "Etc/UCT|UCT", "Etc/UTC|Etc/Universal", "Etc/UTC|Etc/Zulu", "Etc/UTC|UTC", "Etc/UTC|Universal", "Etc/UTC|Zulu", "Europe/Athens|Asia/Nicosia", "Europe/Athens|EET", "Europe/Athens|Europe/Bucharest", "Europe/Athens|Europe/Helsinki", "Europe/Athens|Europe/Kiev", "Europe/Athens|Europe/Mariehamn", "Europe/Athens|Europe/Nicosia", "Europe/Athens|Europe/Riga", "Europe/Athens|Europe/Sofia", "Europe/Athens|Europe/Tallinn", "Europe/Athens|Europe/Uzhgorod", "Europe/Athens|Europe/Vilnius", "Europe/Athens|Europe/Zaporozhye", "Europe/Chisinau|Europe/Tiraspol", "Europe/Dublin|Eire", "Europe/Istanbul|Asia/Istanbul", "Europe/Istanbul|Turkey", "Europe/Lisbon|Atlantic/Canary", "Europe/Lisbon|Atlantic/Faeroe", "Europe/Lisbon|Atlantic/Faroe", "Europe/Lisbon|Atlantic/Madeira", "Europe/Lisbon|Portugal", "Europe/Lisbon|WET", "Europe/London|Europe/Belfast", "Europe/London|Europe/Guernsey", "Europe/London|Europe/Isle_of_Man", "Europe/London|Europe/Jersey", "Europe/London|GB", "Europe/London|GB-Eire", "Europe/Moscow|W-SU", "Europe/Paris|Africa/Ceuta", "Europe/Paris|Arctic/Longyearbyen", "Europe/Paris|Atlantic/Jan_Mayen", "Europe/Paris|CET", "Europe/Paris|Europe/Amsterdam", "Europe/Paris|Europe/Andorra", "Europe/Paris|Europe/Belgrade", "Europe/Paris|Europe/Berlin", "Europe/Paris|Europe/Bratislava", "Europe/Paris|Europe/Brussels", "Europe/Paris|Europe/Budapest", "Europe/Paris|Europe/Busingen", "Europe/Paris|Europe/Copenhagen", "Europe/Paris|Europe/Gibraltar", "Europe/Paris|Europe/Ljubljana", "Europe/Paris|Europe/Luxembourg", "Europe/Paris|Europe/Madrid", "Europe/Paris|Europe/Malta", "Europe/Paris|Europe/Monaco", "Europe/Paris|Europe/Oslo", "Europe/Paris|Europe/Podgorica", "Europe/Paris|Europe/Prague", "Europe/Paris|Europe/Rome", "Europe/Paris|Europe/San_Marino", "Europe/Paris|Europe/Sarajevo", "Europe/Paris|Europe/Skopje", "Europe/Paris|Europe/Stockholm", "Europe/Paris|Europe/Tirane", "Europe/Paris|Europe/Vaduz", "Europe/Paris|Europe/Vatican", "Europe/Paris|Europe/Vienna", "Europe/Paris|Europe/Warsaw", "Europe/Paris|Europe/Zagreb", "Europe/Paris|Europe/Zurich", "Europe/Paris|Poland", "Europe/Ulyanovsk|Europe/Astrakhan", "Pacific/Auckland|Antarctica/McMurdo", "Pacific/Auckland|Antarctica/South_Pole", "Pacific/Auckland|NZ", "Pacific/Chatham|NZ-CHAT", "Pacific/Easter|Chile/EasterIsland", "Pacific/Fakaofo|Etc/GMT-13", "Pacific/Fakaofo|Pacific/Enderbury", "Pacific/Galapagos|Etc/GMT+6", "Pacific/Gambier|Etc/GMT+9", "Pacific/Guadalcanal|Antarctica/Macquarie", "Pacific/Guadalcanal|Etc/GMT-11", "Pacific/Guadalcanal|Pacific/Efate", "Pacific/Guadalcanal|Pacific/Kosrae", "Pacific/Guadalcanal|Pacific/Noumea", "Pacific/Guadalcanal|Pacific/Pohnpei", "Pacific/Guadalcanal|Pacific/Ponape", "Pacific/Guam|Pacific/Saipan", "Pacific/Honolulu|HST", "Pacific/Honolulu|Pacific/Johnston", "Pacific/Honolulu|US/Hawaii", "Pacific/Kiritimati|Etc/GMT-14", "Pacific/Niue|Etc/GMT+11", "Pacific/Pago_Pago|Pacific/Midway", "Pacific/Pago_Pago|Pacific/Samoa", "Pacific/Pago_Pago|US/Samoa", "Pacific/Pitcairn|Etc/GMT+8", "Pacific/Port_Moresby|Antarctica/DumontDUrville", "Pacific/Port_Moresby|Etc/GMT-10", "Pacific/Port_Moresby|Pacific/Chuuk", "Pacific/Port_Moresby|Pacific/Truk", "Pacific/Port_Moresby|Pacific/Yap", "Pacific/Tahiti|Etc/GMT+10", "Pacific/Tahiti|Pacific/Rarotonga"] }), A });
(function () {
  'use strict';

  angular.module('Vibzer')
    .value('THROTTLE_MILLISECONDS', null)
    .directive('infiniteScroll', infiniteScroll)

  /** @ngInject */
  function infiniteScroll($rootScope, $window, $interval, THROTTLE_MILLISECONDS) {
    return {
      scope: {
        infiniteScroll: '&',
        infiniteScrollContainer: '=',
        infiniteScrollDistance: '=',
        infiniteScrollDisabled: '=',
        infiniteScrollUseDocumentBottom: '=',
        infiniteScrollListenForEvent: '@'
      },
      link: function (scope, elem, attrs) {
        var changeContainer, checkWhenEnabled, container, handleInfiniteScrollContainer, handleInfiniteScrollDisabled, handleInfiniteScrollDistance, handleInfiniteScrollUseDocumentBottom, handler, height, immediateCheck, offsetTop, pageYOffset, scrollDistance, scrollEnabled, throttle, unregisterEventListener, useDocumentBottom, windowElement
        windowElement = angular.element($window)
        scrollDistance = null
        scrollEnabled = null
        checkWhenEnabled = null
        container = null
        immediateCheck = true
        useDocumentBottom = false
        unregisterEventListener = null
        height = function (elem) {
          elem = elem[0] || elem
          if (isNaN(elem.offsetHeight)) {
            return elem.document.documentElement.clientHeight
          } else {
            return elem.offsetHeight
          }
        }
        offsetTop = function (elem) {
          if (!elem[0].getBoundingClientRect || elem.css('none')) {
            return
          }
          return elem[0].getBoundingClientRect().top + pageYOffset(elem)
        }
        pageYOffset = function (elem) {
          elem = elem[0] || elem
          if (isNaN(window.pageYOffset)) {
            return elem.document.documentElement.scrollTop
          } else {
            return elem.ownerDocument.defaultView.pageYOffset
          }
        }
        handler = function () {
          var containerBottom, containerTopOffset, elementBottom, remaining, shouldScroll
          if (container === windowElement) {
            containerBottom = height(container) + pageYOffset(container[0].document.documentElement)
            elementBottom = offsetTop(elem) + height(elem)
          } else {
            containerBottom = height(container)
            containerTopOffset = 0
            if (offsetTop(container) !== void 0) {
              containerTopOffset = offsetTop(container)
            }
            elementBottom = offsetTop(elem) - containerTopOffset + height(elem)
          }
          if (useDocumentBottom) {
            elementBottom = height((elem[0].ownerDocument || elem[0].document).documentElement)
          }
          remaining = elementBottom - containerBottom
          shouldScroll = remaining <= height(container) * scrollDistance + 1
          if (shouldScroll) {
            checkWhenEnabled = true
            if (scrollEnabled) {
              if (scope.$$phase || $rootScope.$$phase) {
                return scope.infiniteScroll()
              } else {
                return scope.$apply(scope.infiniteScroll)
              }
            }
          } else {
            return checkWhenEnabled = false // eslint-disable-line 
          }
        }
        throttle = function (func, wait) {
          var later, previous, timeout
          timeout = null
          previous = 0
          later = function () {
            var context // eslint-disable-line 
            previous = new Date().getTime()
            $interval.cancel(timeout)
            timeout = null
            func.call()
            return context = null // eslint-disable-line 
          }
          return function () {
            var now, remaining
            now = new Date().getTime()
            remaining = wait - (now - previous)
            if (remaining <= 0) {
              clearTimeout(timeout)
              $interval.cancel(timeout)
              timeout = null
              previous = now
              return func.call()
            } else {
              if (!timeout) {
                return timeout = $interval(later, remaining, 1) // eslint-disable-line 
              }
            }
          }
        }
        if (THROTTLE_MILLISECONDS != null) {
          handler = throttle(handler, THROTTLE_MILLISECONDS)
        }
        scope.$on('$destroy', function () {
          container.unbind('scroll', handler)
          if (unregisterEventListener != null) {
            unregisterEventListener()
            return unregisterEventListener = null // eslint-disable-line 
          }
        })
        handleInfiniteScrollDistance = function (v) {
          return scrollDistance = parseFloat(v) || 0 // eslint-disable-line 
        }
        scope.$watch('infiniteScrollDistance', handleInfiniteScrollDistance)
        handleInfiniteScrollDistance(scope.infiniteScrollDistance)
        handleInfiniteScrollDisabled = function (v) {
          scrollEnabled = !v
          if (scrollEnabled && checkWhenEnabled) {
            checkWhenEnabled = false
            return handler()
          }
        }
        scope.$watch('infiniteScrollDisabled', handleInfiniteScrollDisabled)
        handleInfiniteScrollDisabled(scope.infiniteScrollDisabled)
        handleInfiniteScrollUseDocumentBottom = function (v) {
          return useDocumentBottom = v // eslint-disable-line 
        }
        scope.$watch('infiniteScrollUseDocumentBottom', handleInfiniteScrollUseDocumentBottom)
        handleInfiniteScrollUseDocumentBottom(scope.infiniteScrollUseDocumentBottom)
        changeContainer = function (newContainer) {
          if (container != null) {
            container.unbind('scroll', handler)
          }
          container = newContainer
          if (newContainer != null) {
            return container.bind('scroll', handler)
          }
        }
        changeContainer(windowElement)
        if (scope.infiniteScrollListenForEvent) {
          unregisterEventListener = $rootScope.$on(scope.infiniteScrollListenForEvent, handler)
        }
        handleInfiniteScrollContainer = function (newContainer) {
          if ((newContainer == null) || newContainer.length === 0) {
            return
          }
          if (newContainer instanceof HTMLElement) { // eslint-disable-line 
            newContainer = angular.element(newContainer)
          } else if (typeof newContainer.append === 'function') {
            newContainer = angular.element(newContainer[newContainer.length - 1])
          } else if (typeof newContainer === 'string') {
            newContainer = angular.element(document.querySelector(newContainer))
          }
          if (newContainer != null) {
            return changeContainer(newContainer)
          } else {
            throw new Exception('invalid infinite-scroll-container attribute.') // eslint-disable-line 
          }
        }
        scope.$watch('infiniteScrollContainer', handleInfiniteScrollContainer)
        handleInfiniteScrollContainer(scope.infiniteScrollContainer || [])
        if (attrs.infiniteScrollParent != null) {
          changeContainer(angular.element(elem.parent()))
        }
        if (attrs.infiniteScrollImmediateCheck != null) {
          immediateCheck = scope.$eval(attrs.infiniteScrollImmediateCheck)
        }
        return $interval((function () { // eslint-disable-line 
          if (immediateCheck) {
            return handler()
          }
        }), 0, 1)
      }
    }
  }
})();

/**
 * Created by k.danovsky on 13.05.2016.
 */

(function () {
  'use strict';

  angular.module('Vibzer.theme')
    .config(config);

  /** @ngInject */
  function config(baConfigProvider, colorHelper, $provide) {
    $provide.decorator('$uiViewScroll', uiViewScrollDecorator);
    //baConfigProvider.changeTheme({blur: true});
    //
    //baConfigProvider.changeColors({
    //  default: 'rgba(#000000, 0.2)',
    //  defaultText: '#ffffff',
    //  dashboard: {
    //    white: '#ffffff',
    //  },
    //});
  }

  /** @ngInject */
  function uiViewScrollDecorator($delegate, $anchorScroll, baUtil) {
    return function (uiViewElement) {
      if (baUtil.hasAttr(uiViewElement, "autoscroll-body-top")) {
        $anchorScroll();
      } else {
        $delegate(uiViewElement);
      }
    };
  }
})();

/**
 * Created by k.danovsky on 13.05.2016.
 */

(function () {
  'use strict';

  var basic = {
    default: '#ffffff',
    defaultText: '#666666',
    border: '#dddddd',
    borderDark: '#aaaaaa',
  };

  // main functional color scheme
  var colorScheme = {
    primary: '#209e91',
    info: '#2dacd1',
    success: '#90b900',
    warning: '#dfb81c',
    danger: '#e85656',
  };

  // dashboard colors for charts
  var dashboardColors = {
    blueStone: '#005562',
    surfieGreen: '#0e8174',
    silverTree: '#6eba8c',
    gossip: '#b9f2a1',
    white: '#10c4b5',
  };

  angular.module('Vibzer.theme')
    .provider('baConfig', configProvider);

  /** @ngInject */
  function configProvider(colorHelper) {
    var conf = {
      theme: {
        blur: false,
      },
      colors: {
        default: basic.default,
        defaultText: basic.defaultText,
        border: basic.border,
        borderDark: basic.borderDark,

        primary: colorScheme.primary,
        info: colorScheme.info,
        success: colorScheme.success,
        warning: colorScheme.warning,
        danger: colorScheme.danger,

        primaryLight: colorHelper.tint(colorScheme.primary, 30),
        infoLight: colorHelper.tint(colorScheme.info, 30),
        successLight: colorHelper.tint(colorScheme.success, 30),
        warningLight: colorHelper.tint(colorScheme.warning, 30),
        dangerLight: colorHelper.tint(colorScheme.danger, 30),

        primaryDark: colorHelper.shade(colorScheme.primary, 15),
        infoDark: colorHelper.shade(colorScheme.info, 15),
        successDark: colorHelper.shade(colorScheme.success, 15),
        warningDark: colorHelper.shade(colorScheme.warning, 15),
        dangerDark: colorHelper.shade(colorScheme.danger, 15),

        dashboard: {
          blueStone: dashboardColors.blueStone,
          surfieGreen: dashboardColors.surfieGreen,
          silverTree: dashboardColors.silverTree,
          gossip: dashboardColors.gossip,
          white: dashboardColors.white,
        },
      }
    };

    conf.changeTheme = function(theme) {
      angular.merge(conf.theme, theme)
    };

    conf.changeColors = function(colors) {
      angular.merge(conf.colors, colors)
    };

    conf.$get = function () {
      delete conf.$get;
      return conf;
    };
    return conf;
  }
})();

/**
 * @author v.lugovsky
 * created on 15.12.2015
 */
(function () {
  'use strict';

  var IMAGES_ROOT = 'assets/img/';

  angular.module('Vibzer.theme')
    .constant('layoutSizes', {
      resWidthCollapseSidebar: 1200,
      resWidthHideSidebar: 500
    })
    .constant('layoutPaths', {
      images: {
        root: IMAGES_ROOT,
        profile: IMAGES_ROOT + 'app/profile/',
        amMap: 'assets/img/theme/vendor/ammap//dist/ammap/images/',
        amChart: 'assets/img/theme/vendor/amcharts/dist/amcharts/images/'
      }
    })
    .constant('colorHelper', {
      tint: function(color, weight) {
        return mix('#ffffff', color, weight);
      },
      shade: function(color, weight) {
        return mix('#000000', color, weight);
      },
    });

  function shade(color, weight) {
    return mix('#000000', color, weight);
  }

  function tint(color, weight) {
    return mix('#ffffff', color, weight);
  }

  //SASS mix function
  function mix(color1, color2, weight) {
    // convert a decimal value to hex
    function d2h(d) {
      return d.toString(16);
    }
    // convert a hex value to decimal
    function h2d(h) {
      return parseInt(h, 16);
    }

    var result = "#";
    for(var i = 1; i < 7; i += 2) {
      var color1Part = h2d(color1.substr(i, 2));
      var color2Part = h2d(color2.substr(i, 2));
      var resultPart = d2h(Math.floor(color2Part + (color1Part - color2Part) * (weight / 100.0)));
      result += ('0' + resultPart).slice(-2);
    }
    return result;
  }
})();

/**
 * @author v.lugovksy
 * created on 15.12.2015
 */
(function () {
  'use strict';

  angular.module('Vibzer.theme')
    .run(themeRun);

  /** @ngInject */
  function themeRun($timeout, $rootScope, layoutPaths, preloader, $q, baSidebarService, themeLayoutSettings) {
    var theme = themeLayoutSettings;
    if (theme.blur) {
      if (theme.mobile) {
        whatToWait.unshift(preloader.loadImg(layoutPaths.images.root + 'blur-bg-mobile.jpg'));
      } else {
        whatToWait.unshift(preloader.loadImg(layoutPaths.images.root + 'blur-bg.jpg'));
        whatToWait.unshift(preloader.loadImg(layoutPaths.images.root + 'blur-bg-blurred.jpg'));
      }
    }
    $rootScope.$baSidebarService = baSidebarService;
  }

})();
/**
 * Created by k.danovsky on 12.05.2016.
 */

(function () {
  'use strict';

  angular.module('Vibzer.theme')
    .service('themeLayoutSettings', themeLayoutSettings);

  /** @ngInject */
  function themeLayoutSettings(baConfig) {
    var isMobile = (/android|webos|iphone|ipad|ipod|blackberry|windows phone/).test(navigator.userAgent.toLowerCase());
    var mobileClass = isMobile ? 'mobile' : '';
    var blurClass = baConfig.theme.blur ? 'blur-theme' : '';
    angular.element(document.body).addClass(mobileClass).addClass(blurClass);

    return {
      blur: baConfig.theme.blur,
      mobile: isMobile,
    }
  }

})();
(function () {
  'use strict'
  var angular = window.angular
  var _ = window._
  var moment = window.moment
  angular.module('Vibzer.components')
    .controller('LicensesCtrl', LicensesCtrl)

  /* Handles licenses page control for customer and distributor
  */
  // @NgInject
  function LicensesCtrl ($scope, $location, $stateParams, $rootScope, $uibModal, toastr, UserService, PurchaseService, LicenseService, customerData, constants) {
    $scope.breadCrumbList = ['Licenses']
    $scope.activeTab = $stateParams.tab ? parseInt($stateParams.tab) : 0 // by default first tab will be active tab
    $scope.user = $rootScope.user
    $scope.customerData = customerData
    // check whether current logged in user is distributor user
    if ($scope.user && $scope.user.distributorIds && $scope.user.distributorIds.length) {
      $scope.isDistributorSuperAdmin = $scope.user.permission.addDistributorUser
      $scope.isSalesRep = !$scope.isDistributorSuperAdmin && !$scope.user.permission.addDistributorUser
    }

    // check whether current logged in user is customer user
    if ($stateParams.customerId && $scope.customerData) {
      $scope.forCustomer = true
      var breadcrumbItem = 'Licenses for ' + $scope.customerData.name
      $scope.breadCrumbList = [breadcrumbItem]
    }
    $scope.dateFormat = constants.dateFormats.licensesTableDateFormat
    $scope.limit = 10
    $scope.uibPage = {
      handheldDevicePage: 1,
      analysisPage: 1,
      fixedDevicePage: 1,
      subscriptionPage: 1
    }
    $scope.searchText = $stateParams.searchText || ''
    $scope.selected = {}

    // In case of distributor superadmin login, get salesRep list to filter customer by license issued by
    if ($scope.isDistributorSuperAdmin) {
      var queryParams = {
        customerId: $scope.user.distributorIds[0],
        distributorId: $scope.user.distributorIds[0],
        limit: 999,
        filters: { status: 'active' }
      }
      UserService.resource.getAllUsersOfCustomer(queryParams, function (res) {
        $scope.allSalesRep = res.users
        $scope.allSalesRep.unshift({ firstName: 'All' })
        $scope.selected.issuedBy = $scope.allSalesRep[0]
      }, function (err) {
        toastr.error(err.data)
      })
    }

    // reload licenses/devices after page changed
    $scope.pageChanged = function (tab, currentPage) {
      if (tab === 0) {
        $location.search('handheldDevicePage', $scope.uibPage.handheldDevicePage)
        getAllPurchasedHandheldDevices()
      } else if (tab === 1) {
        $location.search('analysisPage', $scope.uibPage.analysisPage)
        getAllAssessmentLicenses()
      } else if (tab === 2) {
        $location.search('fixedDevicePage', $scope.uibPage.fixedDevicePage)
        getAllPurchasedFixedDevices()
      } else {
        $location.search('subscriptionPage', $scope.uibPage.subscriptionPage)
        getAllMonitoringLicenses()
      }
    }

    // on tab select fetch licenses.devices
    $scope.tabSelect = function (tab) {
      $scope.uibPage = {
        handheldDevicePage: 1,
        analysisPage: 1,
        fixedDevicePage: 1,
        subscriptionPage: 1
      }
      $scope.pageChanged(tab)
    }

    // get licenses/devices by customer
    $scope.searchCustomer = function (searchText) {
      if (searchText !== undefined) {
        $scope.uibPage = {
          handheldDevicePage: 1,
          analysisPage: 1,
          fixedDevicePage: 1,
          subscriptionPage: 1
        }
        $location.search('handheldDevicePage', $scope.uibPage.handheldDevicePage)
        $location.search('analysisPage', $scope.uibPage.analysisPage)
        $location.search('fixedDevicePage', $scope.uibPage.fixedDevicePage)
        $location.search('subscriptionPage', $scope.uibPage.subscriptionPage)

        $scope.searchText = searchText
        $location.search('searchText', searchText)
        getAllPurchasedHandheldDevices()
        getAllAssessmentLicenses()
        getAllPurchasedFixedDevices()
        getAllMonitoringLicenses()
      }
    }
    // Filter customer licenses list by salesRep
    $scope.getCustomersByIssuedBy = function (issuedBy) {
      $location.search('issuedBy', issuedBy._id)
      $scope.searchCustomer('')
    }
    /* Get all purchased devices of customer */
    function getAllPurchasedHandheldDevices () {
      $scope.busy = true
      var queryParams = {
        customerId: $stateParams.customerId ? $stateParams.customerId : $scope.user.customerIds && $scope.user.customerIds.length ? $scope.user.customerIds[0] : null,
        createdBy: $scope.selected.issuedBy && $scope.selected.issuedBy._id ? $scope.selected.issuedBy._id : null,
        type: constants.deviceTypes[0].id,
        page: null,
        sort: {
          createdOn: -1,
          startDate: -1
        },
        filters: {},
        limit: $scope.limit
      }
      if ($scope.user && $scope.user.distributorIds && $scope.user.distributorIds.length) {
        queryParams.distributorId = $scope.user.distributorIds[0]
      }
      queryParams.page = $scope.uibPage.handheldDevicePage || 1
      if ($scope.searchText) {
        queryParams.customerName = ($location.search().searchText && $location.search().searchText !== '' ? $scope.searchText : '')
        // queryParams.filters.name = {
        //   internalName: 'name',
        //   value: ($location.search().searchText && $location.search().searchText !== '' ? $scope.searchText : ''),
        //   type: 'regex',
        //   regexOptions: 'i'
        // }
      }

      _.assign(queryParams.filters, $scope.filter)
      PurchaseService.resource.getAllPurchasedDevices(queryParams, function (res) {
        $scope.allHandheldDevices = res.result
        $scope.totalHandheldDevices = res.total
        $scope.busy = false
      }, function (err) {
        $scope.busy = false
        toastr.error(err.data.msg)
      })
    }

    /* Get all purchased devices of customer */
    function getAllPurchasedFixedDevices () {
      $scope.busy = true
      var queryParams = {
        customerId: $stateParams.customerId ? $stateParams.customerId : $scope.user.customerIds && $scope.user.customerIds.length ? $scope.user.customerIds[0] : null,
        createdBy: $scope.selected.issuedBy && $scope.selected.issuedBy._id ? $scope.selected.issuedBy._id : null,
        type: constants.deviceTypes[1].id,
        page: null,
        sort: {
          createdOn: -1,
          startDate: -1
        },
        filters: {},
        limit: $scope.limit
      }
      if ($scope.user && $scope.user.distributorIds && $scope.user.distributorIds.length) {
        queryParams.distributorId = $scope.user.distributorIds[0]
      }
      queryParams.page = $scope.uibPage.fixedDevicePage || 1
      if ($scope.searchText) {
        queryParams.customerName = ($location.search().searchText && $location.search().searchText !== '' ? $scope.searchText : '')
        // queryParams.filters.name = {
        //   internalName: 'name',
        //   value: ($location.search().searchText && $location.search().searchText !== '' ? $scope.searchText : ''),
        //   type: 'regex',
        //   regexOptions: 'i'
        // }
      }

      _.assign(queryParams.filters, $scope.filter)
      PurchaseService.resource.getAllPurchasedDevices(queryParams, function (res) {
        $scope.allFixedDevices = res.result
        $scope.totalFixedDevices = res.total
        $scope.busy = false
      }, function (err) {
        $scope.busy = false
        toastr.error(err.data.msg)
      })
    }

    /* Get all monitoring licenses of customer */
    function getAllAssessmentLicenses () {
      $scope.busy = true
      var queryParams = {
        customerId: $stateParams.customerId ? $stateParams.customerId : $scope.user.customerIds && $scope.user.customerIds.length ? $scope.user.customerIds[0] : null,
        createdBy: $scope.selected.issuedBy && $scope.selected.issuedBy._id ? $scope.selected.issuedBy._id : null,
        type: constants.licenseTypes[0].id,
        page: null,
        sort: {
          createdOn: -1,
          startDate: -1
        },
        filters: {},
        limit: $scope.limit
      }
      if ($scope.user && $scope.user.distributorIds && $scope.user.distributorIds.length) {
        queryParams.distributorId = $scope.user.distributorIds[0]
      }
      queryParams.page = $scope.uibPage.analysisPage || 1
      if ($scope.searchText) {
        queryParams.customerName = ($location.search().searchText && $location.search().searchText !== '' ? $scope.searchText : '')
        // queryParams.filters.name = {
        //   internalName: 'name',
        //   value: ($location.search().searchText && $location.search().searchText !== '' ? $scope.searchText : ''),
        //   type: 'regex',
        //   regexOptions: 'i'
        // }
      }

      _.assign(queryParams.filters, $scope.filter)
      LicenseService.resource.getAllCustomerLicenses(queryParams, function (res) {
        $scope.allAssessmentLicenses = _.map(res.result, function (license) {
          license.expired = moment(license.expiryDate).diff(moment()) < 0
          return license
        })
        $scope.totalAssessmentLicenses = res.total
        $scope.busy = false
      }, function (err) {
        $scope.busy = false
        toastr.error(err.data.msg)
      })
    }
    /* Renew order of customer */
    $scope.renewOrder = function (itm) {
      var modalInstance = $uibModal.open({
        templateUrl: 'app/components/Licenses/renewLicense/renewLicense.html',
        controller: 'RenewLicenseCtrl',
        size: 'lg',
        resolve: {
          licenseData: itm
        }
      })
      modalInstance.result.then(function (result) {
        getAllMonitoringLicenses()
      })
    }

    /* Get all monitoring licenses of customer */
    function getAllMonitoringLicenses () {
      $scope.busy = true
      var queryParams = {
        customerId: $stateParams.customerId ? $stateParams.customerId : $scope.user.customerIds && $scope.user.customerIds.length ? $scope.user.customerIds[0] : null,
        createdBy: $scope.selected.issuedBy && $scope.selected.issuedBy._id ? $scope.selected.issuedBy._id : null,
        type: constants.licenseTypes[1].id,
        page: null,
        sort: {
          createdOn: -1,
          startDate: -1
        },
        filters: {},
        limit: $scope.limit
      }
      if ($scope.user && $scope.user.distributorIds && $scope.user.distributorIds.length) {
        queryParams.distributorId = $scope.user.distributorIds[0]
      }
      queryParams.page = $scope.uibPage.subscriptionPage || 1
      if ($scope.searchText) {
        queryParams.customerName = ($location.search().searchText && $location.search().searchText !== '' ? $scope.searchText : '')
        // queryParams.filters.name = {
        //   internalName: 'name',
        //   value: ($location.search().searchText && $location.search().searchText !== '' ? $scope.searchText : ''),
        //   type: 'regex',
        //   regexOptions: 'i'
        // }
      }

      _.assign(queryParams.filters, $scope.filter)
      LicenseService.resource.getAllCustomerLicenses(queryParams, function (res) {
        $scope.allMonitoringLicenses = _.map(res.result, function (license) {
          license.expired = moment(license.expiryDate).diff(moment()) < 0
          license.isExpiring = moment(license.expiryDate).isBefore(moment().startOf('day')) || moment(license.expiryDate).diff(moment(), 'months', true) <= 3
          if(license.isExpiring) {
            console.log(license.orderId)
          }
          return license
        })
        $scope.totalMonitoringLicenses = res.total
        $scope.busy = false
      }, function (err) {
        $scope.busy = false
        toastr.error(err.data.msg)
      })
    }
  }
})();
/**
 * @author v.lugovksy
 * created on 16.12.2015
 */
(function () {
  'use strict';
  var angular = window.angular
  angular.module('Vibzer.theme.components')
    .directive('notification', notificationDirectiveCtrl);

  /** @ngInject */
  function notificationDirectiveCtrl () {
    return {
      restrict: 'E',
      templateUrl: 'app/components/Notification/notification.html',
      controller: 'NotificationCtrl'
    };
  }
})();

(function () {
  'use strict';

  var angular = window.angular
  var moment = window.moment
  var _ = window._
  angular.module('Vibzer.theme.components')
    .controller('NotificationCtrl', NotificationCtrl);

  /*
    Show notifications and view or clear notifications control.
  */
  /** @ngInject */
  function NotificationCtrl ($rootScope, $scope, $uibModal, $cookies, constants, NotificationService) {
    $scope.user = $cookies.getObject('vcUser')
    $scope.userNotifications = []
    $scope.page = 1
    $scope.limit = 4

    $scope.showNotifications = function () {
      $scope.show = true
    }

    /*
      Get user notifications
    */
    $scope.getAllNotifications = function (moreNotification) {
      if (!$scope.user || ($scope.user && !$scope.user._id)) {
        return
      }
      if (moreNotification && typeof moreNotification === 'string') {
        $scope.page++
      }
      var queryParams = {
        userId: $scope.user._id,
        options: {
          page: $scope.page,
          limit: $scope.limit
        }
      }
      NotificationService.resource.getNotifications(queryParams, function (res) {
        $scope.unreadNotification = res.unreadCount || 0
        res.result = _.map(res.result, function (notification) {
          notification.fromNow = moment(notification.createdOn).fromNow()
          notification.icon = notification.machineTypeId ? _.find(constants.typesOfMachine, { name: notification.machineTypeId.name }).icon : 'fa fa-bell'
          return notification
        })
        // Handles load more notifications.
        $scope.userNotifications = moreNotification && typeof moreNotification === 'string' ? $scope.userNotifications.concat(res.result) : res.result
      })
    }

    // clear all notifications
    $scope.clearNotifications = function () {
      $scope.page = 1
      $scope.unreadNotification = null
      $scope.userNotifications = []
    }
    $rootScope.$on('getNotifications', $scope.getAllNotifications)
    $scope.user ? $scope.getAllNotifications() : void 0

    // broadcast event to clear notifications
    $rootScope.$on('clearNotifications', $scope.clearNotifications)

    // Open view or clear notification dialog
    $scope.viewOrClearNotifications = function (notification, action) {
      if (!notification) {
        $scope.notify = false
        return
      }
      notification.action = action
      var modalInstance = $uibModal.open({
        templateUrl: 'app/components/Notification/modals/notificationDialog.html',
        controller: 'DialogNotificationCtrl',
        resolve: {
          notification: notification
        }
      })
      modalInstance.result.then(function (viewed) {
        if (notification.status === 'pending' && viewed) { // read notification
          $scope.unreadNotification--
          var match = _.find($scope.userNotifications, { _id: notification._id })
          match ? match.status = 'read' : null
        } else if (action === 'clear') { // clear notification
          $scope.page = 1
          $scope.getAllNotifications()
        }
      }, function () { })
    }
  }
})();
(function () {
  'use strict'
  angular.module('Vibzer.components')
    .controller('ChangePasswordCtrl', ChangePasswordCtrl)

  // @NgInject
  function ChangePasswordCtrl($scope, $stateParams, $cookies, $state, toastr, vcRecaptchaService, UserService) {
    !$cookies.getObject('vcUser') ? $state.go('login') : null
    $scope.user = {}
    $scope = UserService.recaptchaInit($scope)
    $scope.showUniqePassword = false
    $scope.user.username = $cookies.getObject('vcUser').username
    if ($scope.user && $cookies.getObject('vcUser')._id !== $stateParams._id) {
      UserService.clearCookies()
      $state.go('login')
    }
    $scope.changePassword = function () {
      if ($scope.user.newPassword !== $scope.user.repeatPassword) {
        $scope.showUniqePassword = true
      } else {
        $scope.user.response = $scope.response
        UserService.resource.changePassword($scope.user, function (res) {
          toastr.success('Password updated successfully!')
          $state.go('login')
        }, function () {
          toastr.error('Password update unsuccessful. Contact Administrator!')
          vcRecaptchaService.reload($scope.widgetId)
        })
      }
    }
    $scope.cancel = function () {
      UserService.clearCookies()
      $state.go('login')
    }
  }
})();
(function () {
  'use strict'
  var angular = window.angular
  var _ = window._

  angular.module('Vibzer')
    .controller('CompositeMachineDetailsCtrl', CompositeMachineDetailsCtrl)
  /*
    Handles Add/Update/Delete composite machine
  */
  function CompositeMachineDetailsCtrl ($scope, $rootScope, $stateParams, $uibModal, $state, $location, toastr, HierarchyService, MachineService, PermissionService, UtilService, CompositeService, UserService, compositeMachineData, constants) {
    $scope.user = $rootScope.user // current logged in user
    $scope.webAppTexts = constants.webAppTexts
    $scope.compositeData = compositeMachineData
    $scope.breadCrumbList = [$scope.webAppTexts.breadcrumbs.addComposite]
    $scope.model = {}
    $scope.addForm = true
    $scope.viewForm = false
    $scope.editForm = false
    var machines = []
    $scope.usersForOwner = []
    $scope.lowestLevelList = []
    $scope.machines = [
      { listName: $scope.webAppTexts.headings.avaliableMachines, items: [], dragging: false, disable: true, addItem: false },
      { listName: $scope.webAppTexts.headings.assignedMachines, items: [], dragging: false, removeItem: true }
    ]
    $scope.usersToAssign = []

    // in case of engineer adding machine by default the one who creates composite machine will be the owner
    if ($scope.user.permission.canViewOwnedMachines) {
      $scope.model.owner = {
        _id: $scope.user._id,
        firstName: $scope.user.firstName,
        lastName: $scope.user.lastName
      }
    } else {
      $scope.model.owner = null
    }

    // only manager can change owner
    $scope.canChangeOwner = $scope.user.permission.canViewMachines

    // generate placeholder for select lowest hierarchical level
    $scope.selectLevelPlaceholder = UtilService.generateMsg($scope.webAppTexts.placeholder.selectLevel, { level: $scope.user.customer.hierarchyType[$scope.user.customer.hierarchyType.length - 1].name })

    // get machines to add machines in composite machine
    $scope.getMachines = function (level) {
      $scope.busy = true
      var queryParams = {
        customerId: $scope.user.customerIds[0],
        parentId: $scope.model.selectedLevel ? $scope.model.selectedLevel._id : void 0,
        assignToComposite: true,
        sort: { createdOn: -1 },
        page: 1,
        limit: 99999,
        options: { populate: [{ path: 'owner', select: '_id firstName lastName email' }] }
      }

      MachineService.resource.getAllMachines(queryParams, function (res) {
        machines = angular.copy(res.result)
        $scope.machines[0].items = _.map(angular.copy(res.result), function (machine) {
          machine.icon = _.find(constants.typesOfMachine, { name: machine.machineType.name }).icon
          return machine
        })

        if ($scope.editForm) { // remove assigned machines from avaliables machines
          _.remove($scope.machines[0].items, function (machine) {
            return _.includes($scope.compositeData.machineIds, machine._id)
          })
        }
        // get users to change owner of composite machine
        if ($scope.addForm) {
          $scope.getUsersToAssign()
          getUsersForOwner(level)
        }
      }, function (err) {
        toastr.error(err.data.msg)
      })
    }

    /* Initial machine details for view and edit machine */
    $scope.initCompositeData = function () {
      if ($scope.compositeData && !$scope.compositeData.addComposite) {
        if ($scope.compositeData.viewDetails) { // view composite machine details
          $scope.addForm = false
          $scope.viewForm = true
          $scope.breadCrumbList = [$scope.compositeData.name]
        }
        if ($scope.compositeData.editComposite) { // edit composite machine details
          $scope.addForm = false
          $scope.editForm = true
          var breadcrumbItem = $scope.webAppTexts.breadcrumbs.editComposite + ' : ' + $scope.compositeData.name
          $scope.breadCrumbList = [breadcrumbItem]
        }
        $scope.model = _.pick($scope.compositeData, ['name', 'description', 'userIds'])
        $scope.model.owner = $scope.compositeData.ownerIds[0]
      }
    }
    $scope.initCompositeData()

    /* Get customer's lowest hierarchy level list to get machines */
    HierarchyService.resource.getLowestHierarchies({ customerId: $scope.user.customerIds[0], select: 'name _id' }, function (res) {
      $scope.lowestLevelList = res.hierarchies
      $scope.model.selectedLevel = $scope.lowestLevelList[0]
      if ($scope.addForm) { // add composite machne
        $scope.getMachines()
      } else { // get already assigned machines (view/edit form)
        $scope.busy = true
        var queryParams = {
          customerId: $scope.user.customerIds[0],
          compositeId: $stateParams.compositeId,
          page: 1,
          sort: { createdOn: -1 },
          filters: {},
          limit: 99999,
          options: { populate: [{ path: 'owner', select: '_id firstName lastName email' }] }
        }
        // get already assigned machines
        MachineService.resource.getAllMachines(queryParams, function (res) {
          $scope.machines[1].items = _.map(angular.copy(res.result), function (machine) {
            machine.icon = _.find(constants.typesOfMachine, { name: machine.machineType.name }).icon
            return machine
          })
          if (res.result && res.result.length) { // get hierarchy level
            $scope.model.selectedLevel = res.result[0].ancestors[res.result[0].ancestors.length - 1]
            $scope.getUsersToAssign()
            getUsersForOwner()
          } else { // if all machines deleted then dont show avaliable machines
            $scope.model.selectedLevel = null
            $scope.machines[0].items = []
          }
          $scope.getMachines()
          if ($scope.viewForm) { // chech edit/delete composite machine permissions
            checkPermissions()
          }
        }, function (err) {
          toastr.error(err.data.msg)
        })
      }
    })

    // get users to change composite machine owner
    function getUsersForOwner (level) {
      var data = {
        permissions: ['canViewOwnedMachines'],
        permissionType: 'name',
        resource: $scope.model.selectedLevel._id,
        options: { populate: [{ path: 'userId', select: '_id firstName lastName email' }], type: 'any' }
      }

      UserService.resource.getLevelUsersBasedOnPermissions(data, function (res) {
        $scope.usersForOwner = _.map(_.uniqBy(res.users, 'userId._id'), function (user) { return user.userId })
        level && $scope.user.permission.canViewMachines ? $scope.model.owner = null : void 0
      })
    }
    // get users to assign
    $scope.getUsersToAssign = function () {
      // $scope.model.userIds = []
      var data = {
        permissions: ['canViewMachines', 'canViewOwnedMachines', 'analyzeMachine'],
        permissionType: 'name',
        resource: _.map($scope.lowestLevelList, function (itm) {return itm._id}), // _.uniq(_.map(machines, function (machine) { return machine.ancestors[machine.ancestors.length - 1]._id })),
        options: { populate: [{ path: 'userId', select: '_id firstName lastName email' }], type: 'any' }
      }

      UserService.resource.getLevelUsersBasedOnPermissions(data, function (res) {
        $scope.usersToAssign = _.map(_.uniqBy(res.users, 'userId._id'), function (user) { return user.userId })
        _.remove($scope.usersToAssign, { _id: $scope.model.owner._id }) // remove owner from list
      })
    }

    // check edit/delete permissions (Manager of lowest hierarchical item and owner can edit/delete composite machine)
    function checkPermissions () {
      var data = {
        userId: $scope.user._id,
        permissions: ['canViewMachines', 'editComposite', 'deleteComposite'],
        resourceIds: _.uniq(_.map($scope.machines[1].items, function (machine) { return machine.ancestors[machine.ancestors.length - 1]._id })),
        resourceType: constants.resourceTypes[1].internalName,
        resourceCheck: 'any'
      }
      PermissionService.resource.hasPermission(data, function (res) {
        $scope.canEdit = res.hasPermission || _.some($scope.compositeData.ownerIds, _.pick($scope.user, ['_id', 'firstName', 'lastName', 'email'])) // can edit composite machine
        $scope.canDelete = res.hasPermission || _.some($scope.compositeData.ownerIds, _.pick($scope.user, ['_id', 'firstName', 'lastName', 'email'])) // can composite machine
      })
    }

    // angular drag drop list

    // drag array of object
    $scope.getSelectedItemsIncluding = function (list, item) {
      item.selected = true
      return list.items.filter(function (item) { return item.selected })
    }

    // set the list into dragging state
    $scope.onDragstart = function (list, event) {
      list.dragging = true
    }

    // Insert dragged item in list
    $scope.onDrop = function (list, items, index) {
      angular.forEach(items, function (item) { item.selected = false })
      list.items = list.items.slice(0, index)
        .concat(items)
        .concat(list.items.slice(index))
      return true
    }

    // Remove dragged item from list
    $scope.onMoved = function (list) {
      list.items = list.items.filter(function (item) { return !item.selected })
    }

    // Remove machine from selected list and push it in unassigned machine list
    $scope.removeMachineFromList = function (machine) {
      _.remove($scope.machines[1].items, { _id: machine._id })
      machine.selected = false
      $scope.machines[0].items.unshift(machine)
    }

    // edit composite machine
    $scope.editComposite = function () {
      $state.go('editComposite', { compositeId: $stateParams.compositeId, compositeData: $stateParams.compositeData })
    }

    // delete composite machine
    $scope.deleteComposite = function () {
      var items
      items = function () {
        return {
          buttons: {
            yes: $scope.webAppTexts.buttons.confirm,
            no: $scope.webAppTexts.buttons.cancel
          },
          message: UtilService.generateMsg($scope.webAppTexts.popupMessages.deleteComposite, { machine: $scope.model.name }),
          title: '<i class="fa fa-trash-o" aria-hidden="true"></i> ' + $scope.webAppTexts.headings.deleteComposite
        }
      }
      var modalInstance = $uibModal.open({
        templateUrl: 'app/components/confirmationDialog/confirmationDialog.html',
        controller: 'AllConfirmationDialogCtrl',
        resolve: {
          items: items
        }
      })

      modalInstance.result.then(function (result) {
        CompositeService.resource.deleteComposite({ _id: $scope.compositeData._id }, function (res) {
          if (_.findIndex(res, { isActive: false })) {
            toastr.success(constants.toastrMessages.success.deleteComposite)
            $state.go('compositeMachines', { compositeData: $stateParams.compositeData })
          } else {
            toastr.error($scope.webAppTexts.errorMessages.failedToDelete)
          }
        }, function (err) {
          toastr.error(err.data.msg)
        })
      }, function () { })
    }

    // add/update composite machine
    $scope.save = function () {
      if ($scope.model.basicInfoForm.$invalid || ($scope.machines && !$scope.machines[1].items.length)) {
        $scope.machineRequired = $scope.machines && !$scope.machines[1].items.length
        return
      }
      var data = _.pick($scope.model, ['name', 'description', 'userIds'])
      data.customerId = $scope.user.customerIds[0]
      data.parentId = $scope.model.selectedLevel._id
      data.ownerIds = [$scope.model.owner]
      data.userIds = _.map(data.userIds, function (user) {
        return user._id
      })
      data.machineIds = _.map($scope.machines[1].items, function (machine) {
        return machine._id
      })
      // add composite machine
      if ($scope.addForm) {
        CompositeService.resource.addComposite({ data: data }, function (res) {
          toastr.success(constants.toastrMessages.success.addComposite)
          $state.go('compositeMachines')
        }, function (err) {
          toastr.error(err.data.msg)
        })
      } else if ($scope.editForm) { // edit composite machine
        data._id = $stateParams.compositeId
        data.removedUserIds = _.map(_.differenceBy($scope.compositeData.userIds, $scope.model.userIds, '_id'), function (itm) { return itm._id })
        data.userIds = _.map(_.differenceBy($scope.model.userIds, $scope.compositeData.userIds, '_id'), function (itm) { return itm._id })
        CompositeService.resource.updateComposite({ data: data }, function (res) {
          toastr.success(constants.toastrMessages.success.updateComposite)
          $state.go('viewComposite', { compositeId: $stateParams.compositeId, compositeData: $stateParams.compositeData })
        }, function (err) {
          toastr.error(err.data.msg)
        })
      }
    }
    /* Breadcrumb click handler redirects to routes page */
    $scope.breadCrumbClickHandler = function (itm) {
      $state.go('compositeMachines')
    }

    // back button click handler
    $scope.back = function () {
      if ($scope.editForm) {
        $state.go('viewComposite', { compositeId: $stateParams.compositeId, compositeData: $stateParams.compositeData })
      } else {
        $state.go('compositeMachines', { compositeData: $stateParams.compositeData })
      }
    }
  }
})();

(function () {
  'use strict';

  var angular = window.angular
  var _ = window._
  angular.module('Vibzer.components')
    .controller('CompositeMachinesCtrl', CompositeMachinesCtrl);

  // Composite Machines list controller
  /** @ngInject */
  function CompositeMachinesCtrl ($scope, $rootScope, $state, toastr, $stateParams, $location, constants, CompositeService, PermissionService) {
    $scope.webAppTexts = constants.webAppTexts
    $scope.dateFormat = constants.dateFormats.default
    $scope.user = $rootScope.user
    $scope.breadCrumbList = [$scope.webAppTexts.breadcrumbs.compositeMachineList]
    $scope.forComposite = true
    $scope.dateFormat = constants.dateFormats.default
    $scope.limit = 10
    $scope.uibPage = { page: 1 }
    $scope.selected = {}
    $scope.list = []

    $scope.searchPlaceholder = $scope.webAppTexts.placeholder.searchComposite
    $scope.addTooltip = $scope.webAppTexts.tooltips.addComposite
    $scope.viewTooltip = $scope.webAppTexts.tooltips.viewComposite

    // set filter options
    $scope.uibPage.page = $stateParams.page ? $stateParams.page : $stateParams.compositeData ? JSON.parse($stateParams.compositeData).page : 1
    $scope.sort = $stateParams.compositeData && JSON.parse($stateParams.compositeData).sort.name ? JSON.parse($stateParams.compositeData).sort.name : 'createdOn'
    $scope.order = $stateParams.compositeData && JSON.parse($stateParams.compositeData).sort.order ? JSON.parse($stateParams.compositeData).sort.order : -1
    $scope.searchText = $stateParams.searchText || ''

    $scope.sortBy = angular.copy(constants.sortBy)
    $scope.orderBy = angular.copy(constants.orderBy)

    // dsort-order
    $scope.selected.sort = _.find($scope.sortBy, { internalName: $scope.sort }).id
    $scope.selected.order = _.find($scope.orderBy, { internalName: $scope.order }).id
    $scope.compositeData = $stateParams.compositeData ? JSON.parse($stateParams.compositeData) : {
      page: 1,
      filter: {},
      sort: {}
    }

    // check add composite machine permission (Manager of lowest hierarchical item and engineer can add composite machine)
    var data = {
      userId: $scope.user._id,
      permissions: ['canViewMachines', 'addComposite'],
      resourceType: constants.resourceTypes[1].internalName,
      hierarchyTypeIds: $scope.user.customer.hierarchyType[$scope.user.customer.hierarchyType.length - 1]._id
    }
    PermissionService.resource.hasPermission(data, function (res) {
      $scope.canAdd = res.hasPermission || ($rootScope.user.permission.canViewOwnedMachines && $rootScope.user.permission.addComposite)
    })

    /* This function is used to handle sorting. It invokes after changing
         sort or order and updates stateParams and calls pageChanged() to get updated composite machines list.
      */
    $scope.setSorting = function (type, sort) {
      if (type === 'sort') {
        $scope.sort = _.find($scope.sortBy, { id: sort }).internalName
        $scope.compositeData.sort.name = $scope.sort
        $location.search('compositeData', JSON.stringify($scope.compositeData))
      } else {
        $scope.order = _.find($scope.orderBy, { id: sort }).internalName
        $scope.compositeData.sort.order = $scope.order
        $location.search('compositeData', JSON.stringify($scope.compositeData))
      }
      $scope.uibPage.page = 1
      $scope.pageChanged(1)
    }

    /* This function invokes after page or sort or order changes and sets
         currentPage in URL and calls getAllCompositeMachines() to get updated composite machines list.
      */
    $scope.pageChanged = function (page) {
      $scope.compositeData.page = $scope.uibPage.page
      $location.search('page', $scope.uibPage.page)
      getAllCompositeMachines()
    }

    /* Search composite machine in list. */
    $scope.search = function (searchText) {
      $scope.uibPage.page = 1
      $location.search('page', $scope.uibPage.page)
      $scope.searchText = searchText
      $location.search('searchText', searchText)
      getAllCompositeMachines()
    }
    // get all routes
    function getAllCompositeMachines () {
      $scope.busy = true
      var queryParams = {
        customerId: $scope.user.customerIds[0],
        page: null,
        sort: {},
        filters: {},
        limit: $scope.limit,
        options: { populate: [{ path: 'report.machineIds', select: '_id lastReadingType createdOn monitoredOnline permanent portable' }] }
      }
      queryParams.page = $scope.uibPage.page || 1
      queryParams.sort[$scope.sort] = $scope.order
      if ($scope.searchText) {
        queryParams.filters.name = {
          internalName: 'name',
          value: ($location.search().searchText && $location.search().searchText !== '' ? $scope.searchText : ''),
          type: 'regex',
          regexOptions: 'i'
        }
      }
      _.assign(queryParams.filters, $scope.filter)
      CompositeService.resource.getAll(queryParams, function (res) {
        $scope.list = _.map(res.result, function (machine) {
          if (machine.report && machine.report.machineIds.length && (machine.report.condition || machine.report.condition === 0)) {
            machine.report = _.assign(machine.report, _.find(constants.machineStates, { id: machine.report.condition }))
            machine.lastReadingType = machine.report.machineIds.length === 1 ? _.find(constants.readingTypes, { id: machine.report.machineIds[0].lastReadingType }) : void 0
            /* TODO REMOVE */
            // machine.report.machineIds = _.sortBy(machine.report.machineIds, 'createdOn')
            // if (machine.report.machineIds[0].lastReadingType) {
            //   machine.report.createdOn = machine.report.machineIds[0].lastReadingType === 1 ? machine.report.machineIds[0].portable.createdOn : machine.report.machineIds[0].permanent.createdOn
            // }
          } else {
            machine.report.color = '#00000'
          }
          return machine
        })
        $scope.totalItems = res.totalCount
        $scope.busy = false
      }, function (err) {
        $scope.busy = false
        toastr.error(err.data.msg)
      })
    }

    getAllCompositeMachines()

    // get all machines of composie machine
    $scope.getMachines = function (machine) {
      $state.go('machinesFromComposite', { compositeId: machine._id, compositeData: JSON.stringify($scope.compositeData) })
    }
    // rediract to add route
    $scope.add = function () {
      $state.go('addComposite')
    }

    // redirect to view composite info
    $scope.viewDetails = function (machine) {
      $state.go('viewComposite', { compositeId: machine._id, compositeData: JSON.stringify($scope.compositeData) })
    }

    // show sessions
    $scope.showSessions = function (machine) {
      $state.go('sessionsForComposite', { compositeId: machine._id, machineId: machine.report.machineIds[0]._id, compositeData: JSON.stringify($scope.compositeData) })
    }

    // show trend for composite machine
    $scope.showTrend = function (machine) {
      if (machine.report.machineIds[0].monitoredOnline) {
        $state.go('monitoredMachineTrendForComposite', { compositeId: machine._id, machineId: machine.report.machineIds[0]._id, compositeData: JSON.stringify($scope.compositeData) })
      } else {
        $state.go('conditionWiseTrendForComposite', { compositeId: machine._id, machineId: machine.report.machineIds[0]._id, compositeData: JSON.stringify($scope.compositeData) })
      }
    }
  }
})();
(function () {
  'use strict'
  angular.module('Vibzer.components')
    .controller('AllConfirmationDialogCtrl', AllConfirmationDialogCtrl);

  // @NgInject
  function AllConfirmationDialogCtrl($scope, $uibModalInstance, $sce, items) {
    $scope.dialogMessage = $sce.trustAsHtml(items.message)
    $scope.modalHeaderClass = items.showActiveWindow ? 'bg-primary' : 'bg-danger'
    var dialogTitle = $sce.trustAsHtml(items.title)
    if (items.type && items.type === 'reject') {
      $scope.showDelete = true
      $scope.dialogTitle = $sce.trustAsHtml('<strong>Denied!</strong>')
    } else {
      $scope.showDelete = false
      $scope.dialogTitle = dialogTitle ? dialogTitle : $sce.trustAsHtml('<strong>Confirm</strong>')
    }
    $scope.dialogButtons = [
      {
        id: 0,
        displayName: _.get(items, 'buttons.no') || 'Close',
        internalName: 'close',
        classes: (function (classes) {
          classes = 'btn pull-left btn-cancel'
          return classes
        })(_.get(items, 'classes.no')),
        onClickHandler: function () {
          return $scope.closeModal()
        },
        visibilityHandler: (function () {
          return !($scope.showDelete)
        })()
      },
      {
        id: 1,
        displayName: _.get(items, 'buttons.yes') || 'Ok',
        internalName: 'yes',
        classes: (function (classes) {
          classes = items.showActiveWindow ? 'btn pull-right btn-primary' : 'btn pull-right btn-remove '
          return classes
        })(_.get(items, 'classes.yes')),
        onClickHandler: function () {
          return $scope.showDelete ? $scope.closeModal() : $scope.confirm()
        },
        visibilityHandler: true
      }
    ]

    $scope.confirm = function () {
      $uibModalInstance.close()
    }

    $scope.closeModal = function () {
      $uibModalInstance.dismiss()
    }
  }
})();
(function () {
  'use strict'
  angular.module('Vibzer.components')
    .controller('UserConfirmationDialogCtrl', UserConfirmationDialogCtrl);

  // @NgInject
  function UserConfirmationDialogCtrl($scope, $uibModalInstance, $sce, items) {
    var user = items.user
    /* Set bg-primary default class for modal-header. */
    $scope.modalHeaderClass = 'bg-primary'

    /* Set dialog title with header class */
    $scope.dialogTitle = (function () {
      if (items.reset) {
        return $sce.trustAsHtml('<i class="fa fa-unlock-alt" aria-hidden="true"></i> Reset Password')
      }
      if (items.removeRole) {
        $scope.modalHeaderClass = 'bg-danger'
        return $sce.trustAsHtml('<i aria-hidden="true"></i> Remove Role')
      } else if (items.customer) {
        var customer = items.customer
        if (customer.isActive === true) {
          $scope.modalHeaderClass = 'bg-danger'
          return $sce.trustAsHtml('<i aria-hidden="true"></i> Deactivate Customer')
        } else {
          return $sce.trustAsHtml('<i class="fa fa-check" aria-hidden="true"></i> Activate Customer')
        }
      } else {
        if (user.status === 'active') {
          $scope.modalHeaderClass = 'bg-danger'
          return $sce.trustAsHtml('<i aria-hidden="true"></i> Deactivate User')
        } else {
          return $sce.trustAsHtml('<i class="fa fa-check" aria-hidden="true"></i> Activate User')
        }
      }
    })()

    /* Set dialog message to display. */
    $scope.dialogMessage = (function () {
      if (items.reset) {
        return $sce.trustAsHtml('Are you sure you want to reset password for user <strong>' + user.firstName + ' ' + user.lastName + '</strong>\?')
      }
      if (items.removeRole) {
        return $sce.trustAsHtml('Are you sure you want to remove <strong>' + user.role + '</strong> role' + ' of ' + '<strong>' + user.fullName + '</strong >' + ' for unit ' + '<strong>' + user.resource + '</strong >' + ' Once you confirm you cannot revert it later?')
      } else if (items.customer) {
        var customer = items.customer
        if (customer.isActive === true) {
          return $sce.trustAsHtml('Are you sure you want to deactivate customer <strong>' + customer.name + '</strong>?')
        } else {
          return $sce.trustAsHtml('Are you sure you want to activate customer <strong>' + customer.name + '</strong>?')
        }
      } else {
        if (user.status === 'active') {
          return $sce.trustAsHtml('Are you sure you want to deactivate user <strong>' + user.firstName + ' ' + user.lastName + '</strong>?')
        } else {
          return $sce.trustAsHtml('Are you sure you want to activate user <strong>' + user.firstName + ' ' + user.lastName + '</strong>?')
        }
      }
    })()
    $scope.showDelete = false

    /* Dialog footer buttons control. Sets label, classes and click handler for dialog buttons */
    $scope.dialogButtons = [
      {
        id: 0,
        displayName: 'Cancel',
        internalName: 'close',
        classes: (function () {
          var classes = 'btn pull-left btn-cancel'
          return classes
        })(),
        onClickHandler: function () {
          return $scope.closeModal()
        },
        visibilityHandler: true
      },
      {
        id: 1,
        displayName: 'Confirm',
        internalName: 'yes',
        classes: (function () {
          var classes = 'btn  pull-right'
          if (items.customer && items.customer.isActive === true) {
            classes += ' btn-remove'
          } else if (items.customer && items.customer.isActive === false) {
            classes += ' btn-primary'
          } else if ((user.status === 'active' && !items.reset) || items.removeRole) {
            classes += ' btn-remove'
          } else {
            classes += ' btn-primary'
          }
          return classes
        })(),
        onClickHandler: function () {
          return $scope.confirm()
        },
        visibilityHandler: true
      }
    ]
    $scope.confirm = function () {
      if (user) {
        $uibModalInstance.close(user)
      } else {
        $uibModalInstance.close(items.customer)
      }
    }
    $scope.closeModal = function () {
      $uibModalInstance.dismiss()
    }
  }
})();
(function () {
  'use strict';
  var angular = window.angular
  var _ = window._
  angular.module('Vibzer.components.customer', ['ui.select'])
    .controller('CustomerCtrl', CustomerCtrl);
  function CustomerCtrl ($scope, $state, $stateParams, $rootScope, $uibModal, $location, $cookies, CustomerService, toastr, UserService, constants) {
    $scope.webAppTexts = constants.webAppTexts
    $scope.breadCrumbList = [$scope.webAppTexts.breadcrumbs.customersList]
    $scope.user = $cookies.getObject('vcUser')
    $scope.dateFormat = constants.dateFormats.licensesTableDateFormat
    $scope.customerNameClass = $scope.user.permission.addDistributorUser ? 'col-sm-2' : 'col-sm-2'
    $scope.filter = { $or: [{ isActive: true }, { isActive: false }] }
    $scope.limit = 10
    $scope.uibPage = {
      currentPage: 1
    }

    $scope.customerCount = {
      active: 0,
      inactive: 0
    }

    /* Used to handle breadcrumb state after redirecting to another state. */
    $scope.uibPage.currentPage = $stateParams.currentPage ? $stateParams.currentPage : 1
    $scope.sort = $stateParams.sort ? $stateParams.sort : 'createdOn'
    $scope.order = $stateParams.order ? $stateParams.order : -1
    $scope.searchText = $stateParams.searchText || ''

    var queryParams = {
      customerId: $scope.user.distributorIds[0],
      distributorId: $scope.user.distributorIds[0],
      limit: 999,
      filters: { status: 'active' }
    }
    UserService.resource.getAllUsersOfCustomer(queryParams, function (res) {
      $scope.users = res.users
      $scope.users.unshift({ id: 'All', firstName: 'All' })
      $scope.users.selected = $stateParams.salesRep ? _.find($scope.users, { _id: $stateParams.salesRep }).id : $scope.users[0].id
      $scope.salesRepId = $stateParams.salesRep
      $scope.showFilter = true
    }, function (err) {
      toastr.error(err.data)
    })

    $scope.sortBy = [
      {
        type: 'sort',
        internalName: 'name',
        displayName: 'Customer Name'
      },
      {
        type: 'sort',
        internalName: 'createdOn',
        displayName: 'Created'
      }
    ]
    $scope.orderBy = [{
      type: 'order',
      internalName: 1,
      displayName: 'Ascending'
    },
    {
      type: 'order',
      internalName: -1,
      displayName: 'Descending'
    }]
    $scope.sortBy.selected = _.find($scope.sortBy, { internalName: $scope.sort })
    $scope.orderBy.selected = _.find($scope.orderBy, { internalName: parseInt($scope.order) })

    /* This function is used to handle sorting. It invokes after changing
       sort or order and updates stateParams and calls pageChanged() to get updated user list.
    */
    $scope.setSorting = function (sort) {
      if (sort.type === 'sort') {
        $scope.sort = sort.internalName
        $location.search('sort', sort.internalName)
      } else {
        $scope.order = sort.internalName
        $location.search('order', sort.internalName)
      }
      $scope.uibPage.currentPage = 1
      $scope.pageChanged(1)
    }

    /* This function invokes after page or sort or order changes and sets
       currentPage in URL and calls getAllCustomers() to get updated user list.
    */
    $scope.pageChanged = function (currentPage) {
      $location.search('currentPage', $scope.uibPage.currentPage)
      getAllCustomers()
    }

    /* Search customer in customers list. */
    $scope.searchCustomer = function (searchText) {
      if (searchText !== undefined) {
        $scope.uibPage.currentPage = 1
        $location.search('currentPage', $scope.uibPage.currentPage)
        $scope.searchText = searchText
        $location.search('searchText', searchText)
        getAllCustomers()
      }
    }

    /* This block handles active, deactive and all customers tab. */
    $scope.filterValues = [
      {
        id: 0,
        internalName: 'active',
        displayName: 'Active',
        count: function () {
          return $scope.customerCount.active
        },
        isFilterActive: true,
        onClickHandler: toggleFilter,
        filterQuery: {
          $or: [{ isActive: true }, { isActive: false }]
        }
      },
      {
        id: 1,
        internalName: 'inactive',
        displayName: 'Deactive',
        count: function () {
          return $scope.customerCount.inactive
        },
        isFilterActive: false,
        onClickHandler: toggleFilter,
        filterQuery: {
          $or: [{ isActive: false }]
        }
      },
      {
        id: 2,
        internalName: 'all',
        displayName: 'All',
        count: function () {
          return $scope.customerCount.active + $scope.customerCount.inactive
        },
        isFilterActive: false,
        onClickHandler: toggleFilter,
        filterQuery: {
          $or: [{ isActive: true }, { isActive: false }]
        }
      }
    ]
    $scope.totalItems = $scope.filterValues[0].count()

    /* This function invokes after tab changes and updates user list as per current tab. */
    function toggleFilter (filter, page) {
      $scope.uibPage.currentPage = page || 1
      $location.search('currentPage', $scope.uibPage.currentPage)
      _.each($scope.filterValues, function (object) {
        object.isFilterActive = false
      })
      $scope.filterValues[filter.id].isFilterActive = true
      $scope.filter = filter.filterQuery
      $location.search('filterId', filter.id)
      getAllCustomers()
    }

    /* If stateParams contains filterId this block calls toggleFilter() and updates user list. */
    if ($stateParams.filterId) {
      var filter = _.filter($scope.filterValues, { id: parseInt($stateParams.filterId) })[0]
      toggleFilter(filter, $stateParams.currentPage)
    } else {
      getAllCustomers()
    }

    /* This function is used to get customers. It gives all customers, with active, deactive customer count. */
    function getAllCustomers () {
      $scope.busy = true
      var queryParams = {
        page: null,
        sort: {},
        filters: {},
        limit: $scope.limit,
        requireCustomerCount: true
      }
      queryParams.page = $scope.uibPage.currentPage || 1
      queryParams.distributorId = $rootScope.user.distributorIds[0]
      queryParams.sort[$scope.sort] = $scope.order
      if ($scope.searchText) {
        queryParams.filters.name = {
          internalName: 'name',
          value: ($location.search().searchText && $location.search().searchText !== '' ? $scope.searchText : ''),
          type: 'regex',
          regexOptions: 'i'
        }
      }
      if ($scope.salesRepId || $stateParams.salesRep) {
        queryParams.salesRep = $scope.salesRepId || $stateParams.salesRep
      }
      _.assign(queryParams.filters, $scope.filter)

      CustomerService.resource.getAll(queryParams, function (res) {
        if ($scope.user && $scope.user.tempCache && $scope.user.tempCache.customerIds && $scope.user.tempCache.customerIds.length) {
          $scope.customerList = _.map(res.customers, function (itm) {
            itm.disable = _.includes($scope.user.tempCache.customerIds, itm._id)
            return itm
          })
        } else {
          $scope.customerList = res.customers
        }
        $scope.totalItems = res.total
        $scope.customerCount = res.customerCount
        $scope.busy = false
      }, function (err) {
        $scope.busy = false
        toastr.error(err.data.msg)
      })
    }

    /* Add customer button click handler clears existing data and redirects to addCustomer page. */
    $scope.addCustomer = function () {
      $state.go('addCustomer', { tab: 0 })
    }

    /* View customer details button click handler clears existing data and redirects to customer details page. */
    $scope.viewCustomerDetails = function (customer) {
      $state.go('viewCustomer', { customerId: customer._id, currentPage: $scope.uibPage.currentPage, sort: $scope.sort, order: $scope.order, searchText: $scope.searchText, filterId: $stateParams.filterId, salesRep: $stateParams.salesRep })
    }

    /* Activate and deactivate button click handler asks for confirmation and then activate or deactivate user once confirm. */
    $scope.activateOrDeactivate = function (customer) {
      var modalInstance = $uibModal.open({
        templateUrl: 'app/components/confirmationDialog/confirmationDialog.html',
        controller: 'UserConfirmationDialogCtrl',
        backdrop: true,
        resolve: {
          items: function () {
            return {
              customer: customer
            }
          }
        }
      })

      modalInstance.result.then(function (result) {
        if (result.isActive === true) {
          var customerData = {
            _id: result._id,
            status: false
          }
        } else {
          customerData = {
            _id: result._id,
            status: true
          }
        }
        CustomerService.resource.activateOrDeactivate(customerData, function (res) {
          getAllCustomers()
          if (res.isActive) {
            toastr.success(constants.toastrMessages.success.activateCustomer)
          } else {
            toastr.success(constants.toastrMessages.success.deactivateCustomer)
          }
        }, function (err) {
          toastr.error(err.data.msg)
        })
      }, function () { })
    }

    /* Manage customer admin click handler */
    $scope.manageCustomerAdmins = function (customer) {
      var stateParams = $stateParams
      stateParams.customerId = customer._id
      $state.go('customerAdmin', stateParams)
    }

    /* Search customers by sales rep. */
    $scope.getCustomersBySalesRep = function (salesRepId) {
      if (salesRepId !== 'All') {
        $scope.salesRepId = salesRepId
        $location.search('salesRep', $scope.salesRepId)
      } else {
        $scope.salesRepId = undefined
        $stateParams.salesRep = undefined
        $location.search('salesRep', undefined)
      }
      $scope.uibPage.currentPage = 1
      getAllCustomers()
    }

    /* Manage customer license click handler */
    $scope.viewLicenses = function (customer, licenseTab) {
      $state.go('licensesFromCustomer', { customerId: customer._id, tab: licenseTab })
    }
    /* Add license for customer */
    $scope.addLicense = function (customer) {
      var stateParams = $stateParams
      stateParams.customerId = customer._id
      $state.go('addLicense', stateParams)
    }
  }
})();
(function () {
  'use strict'
  var angular = window.angular
  var _ = window._
  var moment = window.moment
  angular.module('Vibzer.components')
    .controller('DashboardCtrl', DashboardCtrl)
  function DashboardCtrl($scope, $stateParams, $rootScope, $uibModal, $cookies, LicenseService, HierarchyService, ReportService, CustomerService, MachineService, UserService, toastr, constants) {
    $scope.webAppTexts = constants.webAppTexts
    $scope.breadCrumbList = ['Dashboard']
    $scope.user = $cookies.getObject('vcUser')
    $scope.selected = {}
    $scope.graphList = []
    $scope.colorsOfMultiBarGraph = ['#1f77B4', '#98DF8A', '#FF7F0E', '#FFBB78', '#AEC7E8']
    $scope.machineConditions = angular.copy(constants.machineStates)
    $scope.dateFormat = constants.dateFormats.default
    $scope.limit = 5

    var discreteBarChartData = {
      reportLabel: 'Condition',
      sizeY: 1,
      showTable: false,
      forMachine: false,
      options: {
        chart: {
          height: 300,
          type: 'discreteBarChart',
          valueFormat: function (d) {
            return d
          },
          // margin: {
          //   top: 40,
          //   right: 20,
          //   bottom: 50,
          //   left: 55
          // },
          margin: {
            top: 30,
            right: 20,
            bottom: 70,
            left: 130
          },
          groupSpacing: 0.1,
          x: function (d) { return d.label },
          y: function (d) { return d.value },
          showValues: true,
          duration: 500,
          xAxis: {
            axisLabel: 'Machine Conditions'
          },
          xRange: [20, 400, 1260, 1580, 1800],
          yAxis: {
            axisLabel: '# Machines',
            axisLabelDistance: -10,
            tickFormat: function (d) {
              if (d % 1 === 0) {
                return d
              }
            }
          }
        }
      }
    }

    var multiBarHorizontalChart = {
      reportLabel: 'Condition',
      sizeY: 1,
      options: {
        chart: {
          type: 'multiBarHorizontalChart',
          showLegend: false,
          valueFormat: function (d) {
            return d
          },
          height: 300,
          // margin: {
          //   top: 40,
          //   right: 20,
          //   bottom: 50,
          //   left: 55
          // },
          margin: {
            top: 30,
            right: 20,
            bottom: 50,
            left: 130
          },
          groupSpacing: 0.5,
          x: function (d) { return d.label },
          y: function (d) { return d.value },
          showValues: true,
          showControls: false,
          staggerLabels: true,
          duration: 500,
          xAxis: {
            // axisLabel: 'Sales Rep',
            rotateLabels: -45
          },
          xRange: [20, 400, 1260, 1580, 1800],
          yAxis: {
            axisLabel: '# Customers',
            axisLabelDistance: -10,
            tickFormat: function (d) {
              if (d % 1 === 0) {
                return d
              }
            }
          }
        }
      }
    }

    var multiBarChartData = {
      reportLabel: 'Condition',
      sizeY: 1,
      options: {
        chart: {
          height: 500,
          type: 'multiBarChart',
          margin: {
            top: 45,
            right: 20,
            bottom: 110,
            left: 45
          },
          duration: 400,
          grouped: true,
          showYAxis: true,
          showXAxis: true,
          showControls: false,
          reduceXTicks: false,
          color: function (d) {
            return d.color
          },
          groupSpacing: 0.7,
          x: function (d) { return d.x },
          y: function (d) {
            return d.y
          },
          xAxis: {
            axisLabel: undefined,
            axisLabelDistance: 5,
            tickFormat: function (d) {
              return d
            }
          },
          yAxis: {
            axisLabel: '# Machine Conditions',
            axisLabelDistance: 5,
            tickFormat: function (d) {
              if (d % 1 === 0 && d >= 0) {
                return d
              }
            }
          },
          legend: {
            legendPosition: 'bottom'
          },
          callback: function () {
            d3.selectAll('rect.nv-bar')
              .style('fill', function (d, i) {
                if (d.color) {
                  return d.color
                }
              })
          }
        }
      }
    }

    // This function initializes customer dashboard
    function customerDashboard() {
      if (!$scope.user || !$scope.user.customer || !$scope.user.customer.hierarchyType) {
        console.error('customerDashboard: Missing customer hierarchyType');
        return;
      }
      $scope.topLevelLabel = $scope.user.customer.hierarchyType[0]
        ? $scope.user.customer.hierarchyType[0].name
        : null;
      $scope.topLevelPlaceholder = $scope.topLevelLabel
        ? 'Select ' + $scope.topLevelLabel
        : '';
      $scope.middleLevelLabel = $scope.user.customer.hierarchyType[1]
        ? $scope.user.customer.hierarchyType[1].name
        : null;
      $scope.middleLevelPlaceholder = $scope.middleLevelLabel
        ? 'Select ' + $scope.middleLevelLabel
        : '';
      $scope.lowerLevelLabel = $scope.user.customer.hierarchyType[2]
        ? $scope.user.customer.hierarchyType[2].name
        : null;
      $scope.lowerLevelPlaceholder = $scope.lowerLevelLabel
        ? 'Select ' + $scope.lowerLevelLabel
        : '';
      $scope.getResourceList('topLevel', null)
    }

    function getMachineDetails() {
      var queryParams = {
        customerId: (
          $scope.user &&
          Array.isArray($scope.user.customerIds) &&
          $scope.user.customerIds.length > 0
        )
          ? $scope.user.customerIds[0]
          : null,
        page: null,
        sort: {},
        filters: {},
        limit: 9999999
      }
      queryParams.page = 1
      queryParams.sort['createdOn'] = -1
      if ($scope.topLevelList && $scope.topLevelList.length) {
        queryParams.resourceId = $scope.selected.lowerLevel ? $scope.selected.lowerLevel._id : $scope.selected.middleLevel ? $scope.selected.middleLevel._id : $scope.selected.topLevel ? $scope.selected.topLevel._id : null
      }
      _.assign(queryParams.filters, $scope.filter)

      MachineService.resource.getAllMachines(queryParams, function (res) {
        $scope.machinesData = res.result
        if ($scope.isShowUserRolesGraph) {
          graphForUserRoles()
        }
        getDataForMachinesByConditionGraph(res.result)
        getDataForTopLevelMachinesByConditionGraph()
        if (!$scope.role.companyLevelManager) {
          getDataForMiddleLevelMachinesByConditionGraph($scope.topLevelList[0])
        }
        if ($scope.role.middleLevelManager) {
          // getDataForLowerLevelMachinesByConditionGraph($scope.middleLevelList[0])
          if (Array.isArray($scope.middleLevelList) && $scope.middleLevelList.length > 0) {
            getDataForLowerLevelMachinesByConditionGraph($scope.middleLevelList[0]);
          } 

        }
      }, function (err) {
        toastr.error(err.data.msg)
      })
    }
    // This function is used to get hierarchies assigned to user.
    $scope.getResourceList = function (level, parentId, stateParams, graphName, selectedHierarchy) {
      // Following if block is used for when user selects 'All Plants', 'All Area' like options.
      if (parentId && (_.includes(parentId, 'All'))) {
        if (graphName === 'Machines by Condition') {
          if (level === 'lowerLevel') {
            getDataForMachinesByConditionGraph($scope.machinesData, selectedHierarchy.topLevel)
          } else if (level === 'lastLevel') {
            getDataForMachinesByConditionGraph($scope.machinesData, selectedHierarchy.middleLevel)
          } else {
            getDataForMachinesByConditionGraph($scope.machinesData)
          }
        } else if (graphName) {
          if (level === 'topLevel') {
            getDataForTopLevelMachinesByConditionGraph()
          } else if (level === 'middleLevel') {
            getDataForTopLevelMachinesByConditionGraph()
          } else {
            if ($scope.role && ($scope.role.topLevelManager || $scope.role.companyLevelManager)) {
              getDataForMiddleLevelMachinesByConditionGraph(selectedHierarchy.topLevel)
            } else if ($scope.role && $scope.role.middleLevelManager) {
              getDataForLowerLevelMachinesByConditionGraph(selectedHierarchy.topLevel)
            }
          }
        } else {
          getMachineDetails()
        }
        return
      }
      var queryParams = {
        customerId: $scope.user.customerIds[0]
      }
      if (parentId) {
        queryParams.parentId = parentId
      }
      HierarchyService.resource.getAll(queryParams, function (res) {
        if (level === 'middleLevel') {
          $scope.lowerLevelList = []
          //  hierarchyLevel = $scope.user.customer.hierarchyType[1] ? $scope.user.customer.hierarchyType[1].name : undefined
        }
        if (level === 'lowerLevel') {
          // $scope.selected.lowerLevel = null
          // hierarchyLevel = $scope.user.customer.hierarchyType[2] ? $scope.user.customer.hierarchyType[2].name : undefined
        }
        $scope[level + 'List'] = res.result
        if (graphName === 'Machines by Condition') {
          if (level === 'middleLevel') {
            if ($scope.hierarchyLength === 1) {
              getDataForMachinesByConditionGraph($scope.machinesData, selectedHierarchy.topLevel)
            } else if ($scope.hierarchyLength === 2) {
              if ($scope.middleLevelList.length > 1) {
                $scope.middleLevelList.unshift({ _id: 'All', name: 'All' })
              }
              getDataForMachinesByConditionGraph($scope.machinesData, selectedHierarchy.topLevel)
            } else {
              if ($scope.middleLevelList.length > 1) {
                $scope.middleLevelList.unshift({ _id: 'All', name: 'All' })
              }
              getDataForMachinesByConditionGraph($scope.machinesData, selectedHierarchy.topLevel)
            }
          } else if (level === 'lowerLevel') {
            if ($scope.hierarchyLength === 2) {
              getDataForMachinesByConditionGraph($scope.machinesData, selectedHierarchy.middleLevel)
            } else if ($scope.hierarchyLength === 3) {
              if (res.result.length > 1) {
                $scope.lowerLevelList.unshift({ _id: 'All', name: 'All' })
              }
              getDataForMachinesByConditionGraph($scope.machinesData, selectedHierarchy.middleLevel)
            }
          } else {
            getDataForMachinesByConditionGraph($scope.machinesData, selectedHierarchy.lowerLevel)
          }
          return
        } else if (graphName && level === 'middleLevel') {
          if ($scope.hierarchyLength === 3) {
            if (res.result.length > 1) {
              $scope.middleLevelList.unshift({ _id: 'All', name: 'All' })
            }
            if ($scope.role && ($scope.role.topLevelManager || $scope.role.companyLevelManager)) {
              getDataForMiddleLevelMachinesByConditionGraph(selectedHierarchy.topLevel)
            } else if ($scope.role && $scope.role.middleLevelManager) {
              getDataForLowerLevelMachinesByConditionGraph($scope.middleLevelList.length === 1 ? $scope.middleLevelList[0] : selectedHierarchy.topLevel)
            }
          } else if ($scope.hierarchyLength === 2) {
            getDataForMiddleLevelMachinesByConditionGraph(selectedHierarchy.topLevel)
          } else {
            getDataForTopLevelMachinesByConditionGraph(selectedHierarchy.topLevel)
          }
          return
        } else if (graphName && level === 'lowerLevel') {
          getDataForLowerLevelMachinesByConditionGraph(selectedHierarchy.middleLevel)
        }
        if (level === 'topLevel') {
          if (res.result.length > 1 && $scope.role.companyLevelManager) {
            $scope.topLevelList.unshift({ _id: 'All', name: 'All' })
          }
          if ($scope.hierarchyLength >= 2 && res.result.length > 0) {
            $scope.getResourceList('middleLevel', res.result[0]._id)
            return
          }
        } else if (level === 'middleLevel') {
          if (res.result.length > 1) {
            $scope.middleLevelList.unshift({ _id: 'All', name: 'All' })
          }
          if ($scope.hierarchyLength === 3 && res.result.length > 0) {
            $scope.getResourceList('lowerLevel', res.result[0]._id)
            return
          }
        } else if (level === 'lowerLevel') {
          if (res.result.length > 1) {
            $scope.lowerLevelList.unshift({ _id: 'All', name: 'All' })
          }
        }
        if ($scope.hierarchyLength === 1 && $scope.topLevelList && !$scope.machinesData) {
          getMachineDetails()
        } else if ($scope.hierarchyLength === 2 && $scope.topLevelList && $scope.middleLevelList && !$scope.machinesData) {
          getMachineDetails()
        } else if ($scope.hierarchyLength === 3 && $scope.topLevelList && $scope.middleLevelList && $scope.lowerLevelList && !$scope.machinesData) {
          getMachineDetails()
        }
      }, function (err) {
        toastr.error(err.data.msg)
      })
    }

    $scope.init = function () {
      // get graph data for customer
      if ($scope.user && !_.isEmpty($scope.user.customerIds) && ($scope.user.permission.canViewMachines || $scope.user.permission.canViewOwnedMachines)) {
        $scope.hierarchyLength = $scope.user.customer.hierarchyType.length
        constants.machineStates[1].displayName = 'Learning'
        UserService.resource.getAllPermissionsOfUser({ _id: $rootScope.user._id }, function (res) {
          $scope.role = {}
          $scope.isShowUserRolesGraph = _.find(res.result, function (item) {
            return (item.role === 'Manager' || item.role === 'Admin')
          })
          _.each(res.result, function (item) {
            _.each(item.resources, function (resource) {
              if (resource.type === 'company' && item.role === 'Manager') {
                $scope.role.companyLevelManager = true
              } else if (resource.type === 'hierarchy' && item.role === 'Manager') {
                var hierarchy = _.find($scope.user.customer.hierarchyType, { _id: resource.hierarchyTypeId })
                if (hierarchy) {
                  if (hierarchy.level === 1) {
                    $scope.role.topLevelManager = true
                  } else if (hierarchy.level === 2) {
                    $scope.role.middleLevelManager = true
                  } else {
                    $scope.role.lowerLevelManager = true
                  }
                }
              }
            })
          })
          customerDashboard()
        }, function (err) {
          toastr.error(err.data.msg)
        })
      } else if ($scope.user && !_.isEmpty($scope.user.distributorIds)) {
        $scope.isDistributorUser = true
        $scope.timeList = constants.dashboard
        // $scope.timeList[0].selected = true
        var query = {
          page: null,
          sort: {},
          filters: {},
          limit: 999,
          requireCustomerCount: true
        }
        query.distributorId = $rootScope.user.distributorIds[0]
        if ($scope.user.permission.addDistributorUser) {
          CustomerService.resource.getAll(query, function (res) {
            // For customer count by sales rep graph data.
            var salesRepCustomerInfo = _.filter(res.customers, function (item) {
              return item.salesRep
            })
            var customerCountBySalesRepGraph = [{
              // key: 'Customers by Sales Rep',
              color: '#1f77b4',
              values: []
            }]
            var filteredData = _.groupBy(salesRepCustomerInfo, 'salesRep._id')
            // To iterate property of filteredData json object.
            for (var key in filteredData) {
              if (filteredData.hasOwnProperty(key)) {
                var customerList = filteredData[key]
                var salesRepInfo = {
                  label: customerList[0].salesRep.firstName + ' ' + customerList[0].salesRep.lastName,
                  value: customerList.length,
                  salesRepId: key
                }
                customerCountBySalesRepGraph[0].values.push(salesRepInfo)
              }
            }
            var listItem = angular.copy(multiBarHorizontalChart)
            // listItem.options.chart.height = (customerCountBySalesRepGraph[0].values.length + 1) * 50
            listItem.options.chart.height = 500
            listItem.name = 'Customers by Sales Rep'
            listItem.limit = 10
            listItem.forSalesRep = true
            listItem.options.chart.multibar = {
              dispatch: {
                elementClick: function (e) {
                  $scope.showCustomersTable(e, listItem.name)
                }
              }
            }
            listItem.uibPage = {
              currentPage: 1
            }
            listItem.data = [{
              key: 'Customers by Sales Rep',
              values: customerCountBySalesRepGraph[0].values
            }]
            listItem.showDropDown = false
            $scope.graphList.push(listItem)
            getLicenseInfo()
          }, function (err) {
            toastr.error(err.data.msg)
          })
        } else {
          getLicenseInfo()
        }
      }
      if ($scope.user && !_.isEmpty($scope.user.customerIds) && ($scope.user.permission && $scope.user.permission.addUser)) {
        graphForUserRoles()
      }
    }
    $scope.init()
    // Distributor User related dashboard functions
    $scope.getDuration = function (graphName, duration) {
      if (graphName === 'Licenses Sale') {
        getLicenseInfo(duration)
      } else if (graphName === 'Subscriptions Sale') {
        getLicenseKitsInfo(2, duration)
      } else if (graphName === 'Analyses Sale') {
        getLicenseKitsInfo(1, duration)
      }
    }

    // This function is used to show user count by roles i.e. plant admin, area manager, engineer, technician
    function graphForUserRoles() {
      var userCountByRoles = []
      // Following loop is used to add labels on X-axis i.e. Plant Admin,  Area Admin, Engineer, Technician etc.
      _.each($scope.user.customer.hierarchyType, function (item, index) {
        var adminRole = {
          label: item.name + ' ' + constants.roles[0].name,
          value: 0,
          hierarchyTypeId: item._id,
          role: constants.roles[0].name
        }
        userCountByRoles.push(adminRole)
        var managerRole = {
          label: item.name + ' ' + constants.roles[1].name,
          value: 0,
          hierarchyTypeId: item._id,
          role: constants.roles[1].name
        }
        userCountByRoles.push(managerRole)
        if (index === $scope.user.customer.hierarchyType.length - 1) {
          var engineerRole = {
            label: constants.roles[2].name,
            value: 0,
            hierarchyTypeId: item._id,
            role: constants.roles[2].name
          }
          userCountByRoles.push(engineerRole)
        }
      })
      var technicianRole = {
        label: constants.roles[3].name,
        value: 0,
        role: constants.roles[3].name
      }
      userCountByRoles.push(technicianRole)
      var queryParams = {
        customerId: $scope.user.customerIds[0],
        page: null,
        sort: {},
        filters: {},
        limit: 9999999,
        requireUserCount: true
      }
      UserService.resource.getAllUsersOfCustomer(queryParams, function (res) {
        var userRoles = res.users
        var queryParam = {
          _id: $scope.user._id,
          limit: 999999
        }
        // To get Role Information of login user
        UserService.resource.getUserRolesWithResource(queryParam, function (resp) {
          var logInUserRoles = {
            roleInfo: resp.result
          }
          userRoles.push(logInUserRoles)
          _.each(userRoles, function (item) {
            var uniqueRoles = []
            uniqueRoles = _.uniqBy(item.roleInfo, function (role) {
              return [role.hierarchyTypeId, role.role].join()
            });
            _.each(uniqueRoles, function (roleDetails) {
              if (roleDetails.resourceType === constants.resourceTypes[1].internalName) {
                var hierarchyLevel = _.findIndex($scope.user.customer.hierarchyType, { _id: roleDetails.hierarchyTypeId })
                if (hierarchyLevel > -1) {
                  var hierarchyName = $scope.user.customer.hierarchyType[hierarchyLevel].name
                  var labelOnXAxis = roleDetails.role !== constants.roles[2].name ? hierarchyName + ' ' + roleDetails.role : roleDetails.role
                  var indexOnXAxis = _.findIndex(userCountByRoles, { label: labelOnXAxis })
                  if (indexOnXAxis > -1) {
                    userCountByRoles[indexOnXAxis].value = userCountByRoles[indexOnXAxis].value + 1
                  }
                }
              } else if (roleDetails.resourceType === constants.resourceTypes[2].internalName) {
                var indexOfTechnician = _.findIndex(userCountByRoles, { label: constants.roles[3].name })
                if (indexOfTechnician > -1) {
                  userCountByRoles[indexOfTechnician].value = userCountByRoles[indexOfTechnician].value + 1
                }
              }
            })
          })
          var listItem = angular.copy(discreteBarChartData)
          listItem.options.chart.xAxis.axisLabel = undefined
          listItem.options.chart.yAxis.axisLabel = '# ' + $scope.webAppTexts.labels.users
          // show table on element click
          listItem.options.chart.discretebar = {
            dispatch: {
              elementClick: function (e) {
                $scope.showUsersTable(e, listItem.name)
              }
            }
          }
          listItem.data = [{
            key: $scope.webAppTexts.labels.userDetails,
            values: userCountByRoles
          }]
          if (!_.isEmpty(listItem.data)) {
            if (listItem.data[0].values && listItem.data[0].values.length >= 4) {
              listItem.options.chart.xAxis.rotateLabels = -30
            }
          }
          listItem.options.chart.groupSpacing = 0.5
          listItem.mobileOptions = generateMobileOptionsForCharts(listItem.options)
          listItem.name = $scope.webAppTexts.labels.userDetails
          listItem.forUser = true
          listItem.limit = 5
          listItem.uibPage = {
            currentPage: 1
          }
          if (!_.find($scope.graphList, { name: $scope.webAppTexts.labels.userDetails })) {
            $scope.graphList.unshift(listItem)
          }
        }, function (err) {
          toastr.error(err.data.msg)
        })
      }, function (err) {
        toastr.error(err.data.msg)
      })
    }

    function getLicenseInfo(duration) {
      var initialDuration = !duration ? $scope.timeList[0].value : undefined
      var queryParam = {
        page: null,
        sort: {},
        filters: {},
        limit: 999,
        requireCustomerCount: true
      }
      queryParam.distributorId = $rootScope.user.distributorIds[0]
      if (!$scope.user.permission.addDistributorUser) {
        queryParam.filters = { '$or': [{ 'isActive': true }, { 'isActive': false }] }
      }
      if (initialDuration || duration) {
        var monthsToSubtract = initialDuration || duration
        queryParam.createdDate = moment().subtract(monthsToSubtract, 'months').date(1).toISOString()
      }
      CustomerService.resource.getAll(queryParam, function (res) {
        var analysisCount = 0
        var fixedDeviceCount = 0
        var handheldDeviceCount = 0
        var subscriptionCount = 0
        _.each(res.customers, function (item) {
          if (!_.isEmpty(item.licenseInfo)) {
            if (item.licenseInfo.fixedDevices) {
              fixedDeviceCount += item.licenseInfo.fixedDevices
            }
            if (item.licenseInfo.totalSubscriptions) {
              subscriptionCount += item.licenseInfo.totalSubscriptions
            }
            if (item.licenseInfo.handheldDevices) {
              handheldDeviceCount += item.licenseInfo.handheldDevices
            }
            if (item.licenseInfo.totalAnalysis) {
              analysisCount += item.licenseInfo.totalAnalysis
            }
          }
        })
        var licenseInfo = [{
          key: 'Licenses Sale',
          color: '#1f77b4',
          values: [
            {
              label: 'Handheld Devices',
              value: handheldDeviceCount
            },
            {
              label: 'Analyses',
              value: analysisCount
            },
            {
              label: 'Fixed Devices',
              value: fixedDeviceCount
            },
            {
              label: 'Subscriptions',
              value: subscriptionCount
            }
          ]
        }]
        var maxValue = _.maxBy(licenseInfo[0].values, 'value').value
        var listItem = angular.copy(discreteBarChartData)
        listItem.mobileOptions = generateMobileOptionsForCharts(listItem.options)
        listItem.options.chart.groupSpacing = 2.5
        // listItem.options.chart.height = maxValue * 5
        listItem.options.chart.xAxis.axisLabel = undefined
        listItem.options.chart.yAxis.axisLabel = '# Licenses'
        listItem.name = 'Licenses Sale'
        listItem.data = [{
          key: 'Licenses Sale',
          values: licenseInfo[0].values
        }]
        listItem.showDropDown = true
        var index = _.findIndex($scope.graphList, { name: 'Licenses Sale' })
        if (index > -1) {
          listItem.duration = duration
          $scope.graphList[index] = listItem
        } else {
          listItem.duration = initialDuration
          $scope.graphList.push(listItem)
        }
        if (!duration) {
          getLicenseKitsInfo()
        }
      }, function (err) {
        toastr.error(err.data.msg)
      })
    }

    // Function is used to get all licenses assigned to distributor.
    function getLicensesAssignedToDistributor(licenseType, duration) {
      var queryParams = {
        distributorId: $scope.user.distributorIds[0]
      }
      LicenseService.resource.getLicensesAssignToDistributor(queryParams, function (res) {
        var allLicenseInfo = _.groupBy(res.result, 'type')
        $scope.packNames = []
        $scope.kitNames = []
        // To iterate property of filteredData json object.
        for (var key in allLicenseInfo) {
          // check also if property is not inherited from prototype
          if (allLicenseInfo.hasOwnProperty(key)) {
            _.each(allLicenseInfo[key], function (item) {
              if (item.type === 1) {
                $scope.packNames.push(item.name)
              } else if (item.type === 2) {
                $scope.kitNames.push(item.name)
              }
            })
          }
        }
        getLicenseKitsInfo(licenseType, duration)
      })
    }

    // Function to add 0 value for unsold kit or pack. i.e. 5-pack - 0 count in graph
    function addLicensesOfZeroCount(graphValues, soldLicenseNames, type) {
      var packList = type === 1 ? $scope.packNames : $scope.kitNames
      if (graphValues.length === 0) {
        _.each(packList, function (item) {
          graphValues.push({ label: item, value: 0 })
        })
      } else {
        var unSoldPacks = _.difference(packList, soldLicenseNames)
        _.each(unSoldPacks, function (item) {
          graphValues.push({ label: item, value: 0 })
        })
      }
      // Following conditions are used to sort label names in ascending order.
      // if (type === 1) {
      //   graphValues = _.sortBy(graphValues, [function (item) { return parseInt(item.label.charAt(0)) }])
      // } else {
      //   graphValues = _.sortBy(graphValues, [function (item) { return parseInt(item.label.charAt(item.label.length - 1)) }])
      // }
    }

    // Functions to show 'Analyses Sale' and  'Subscriptions Sale' graph.
    function getLicenseKitsInfo(licenseType, duration) {
      if (!$scope.packNames || !$scope.kitNames) {
        getLicensesAssignedToDistributor(licenseType, duration)
        return
      }
      var initialDuration = !duration ? $scope.timeList[0].value : undefined
      var previousMonth = initialDuration || duration
      var requestParams = {
        type: licenseType,
        distributorId: $scope.user.distributorIds[0],
        lastDate: previousMonth ? moment().subtract(previousMonth, 'months').date(1).toISOString() : undefined
      }
      ReportService.resource.getLicenseDetails(requestParams, function (res) {
        var licenseData = _.groupBy(res.result, function (item) {
          if (item._id) {
            return item._id.type
          }
        })
        var kitData = []
        var packData = []
        // To iterate property of filteredData json object.
        for (var key in licenseData) {
          // check also if property is not inherited from prototype
          if (licenseData.hasOwnProperty(key)) {
            // Sort pack and kit license data. key 1 for pack license data and key 2 for kit license data
            if (parseInt(key) === 1) {
              packData = licenseData[key]
            } else {
              kitData = licenseData[key]
            }
          }
        }
        if (!licenseType || licenseType === 1) {
          var licensePackInfo = [{
            key: 'Analyses Sale',
            color: '#1f77b4',
            values: []
          }]
          var soldPackNames = []
          _.each(packData, function (item) {
            var licensePack = {
              label: item.name,
              value: item.totalCount
            }
            soldPackNames.push(item.name)
            licensePackInfo[0].values.push(licensePack)
          })
          addLicensesOfZeroCount(licensePackInfo[0].values, soldPackNames, 1)
          var listItem = angular.copy(discreteBarChartData)
          listItem.mobileOptions = generateMobileOptionsForCharts(listItem.options)
          // var maxValue = licensePackInfo[0].values.length
          // listItem.options.chart.width = parseInt((maxValue * 85 * 4) / 3)
          listItem.options.chart.xAxis.axisLabel = undefined
          listItem.options.chart.yAxis.axisLabel = '# Packs'
          listItem.name = 'Analyses Sale'
          // Sort according to name
          licensePackInfo[0].values = _.sortBy(licensePackInfo[0].values, [function (item) {
            return parseInt(item.label.substr(0, item.label.indexOf('-')))
          }])
          listItem.data = [{
            key: 'Analyses Sale',
            values: licensePackInfo[0].values
          }]
          listItem.showDropDown = true
          var index = _.findIndex($scope.graphList, { name: 'Analyses Sale' })
          if (!_.isEmpty(listItem.data)) {
            if (listItem.data[0].values && listItem.data[0].values.length >= 5) {
              // listItem.options.chart.staggerLabels = true
              listItem.options.chart.xAxis.rotateLabels = -45
            }
          }
          if (index > -1) {
            listItem.duration = duration
            $scope.graphList[index] = listItem
          } else {
            listItem.duration = initialDuration
            $scope.graphList.push(listItem)
          }
        }
        if (!licenseType || licenseType === 2) {
          var licenseKitInfo = [{
            key: 'Subscriptions Sale',
            color: '#1f77b4',
            values: []
          }]
          var soldKitNames = []
          _.each(kitData, function (item) {
            var licenseKit = {
              label: item.name,
              value: item.totalCount
            }
            soldKitNames.push(item.name)
            licenseKitInfo[0].values.push(licenseKit)
          })
          addLicensesOfZeroCount(licenseKitInfo[0].values, soldKitNames, 2)
          var listItem2 = angular.copy(discreteBarChartData)
         // var maxValue = _.maxBy(licenseKitInfo[0].values, 'value').value
          // listItem.options.chart.height = maxValue * 5
          listItem2.options.chart.xAxis.axisLabel = undefined
          listItem2.options.chart.yAxis.axisLabel = '# Kits'
          // Sort according to name
          licenseKitInfo[0].values = _.sortBy(licenseKitInfo[0].values, [function (item) {
            return parseInt(item.label.substr(item.label.indexOf('-') + 1))
          }])
          listItem2.name = 'Subscriptions Sale'
          listItem2.data = [{
            key: 'Subscriptions Sale',
            values: licenseKitInfo[0].values
          }]
          if (_.isEmpty(listItem2.data[0].values)) {
            listItem2.data.values = undefined
          }
          listItem2.showDropDown = true
          var itemIndex = _.findIndex($scope.graphList, { name: 'Subscriptions Sale' })
          if (!_.isEmpty(listItem2.data)) {
            if (listItem2.data[0].values && listItem2.data[0].values.length >= 5) {
              // listItem.options.chart.staggerLabels = true
              listItem2.options.chart.xAxis.rotateLabels = -35
            }
          }
          listItem2.mobileOptions = generateMobileOptionsForCharts(listItem2.options)
          if (itemIndex > -1) {
            listItem2.duration = duration
            $scope.graphList[index] = listItem2
          } else {
            listItem2.duration = initialDuration
            $scope.graphList.push(listItem2)
          }
        }
      }, function (err) {
        toastr.error(err.data.msg)
      })
    }
    // Customer user related dashboard function
    function getDataForMachinesByConditionGraph(allMachines, hierarchy) {
      var machineCountByCondition = [
        { label: 'Alert', value: 0, id: 3 },
        { label: 'Warning', value: 0, id: 2 },
        { label: 'Acceptable', value: 0, id: 1 },
        { label: 'Learning', value: 0, id: 0 },
        { label: 'Unknown', value: 0, id: -1 }
      ]
      var listItem = angular.copy(discreteBarChartData)
      listItem.options.chart.xAxis.axisLabel = undefined
      // show table on element click
      listItem.options.chart.discretebar = {
        dispatch: {
          elementClick: function (e) {
            $scope.showMachinesTable(e, 'Machines by Condition')
          }
        }
      }
      listItem.mobileOptions = generateMobileOptionsForCharts(listItem.options)
      listItem.name = 'Machines by Condition'
      listItem.forMachine = true
      listItem.limit = 5
      listItem.uibPage = {
        currentPage: 1
      }
      listItem.data = [{
        key: 'Machines by Condition Bar Chart',
        values: machineCountByCondition
      }]
      if ($scope.hierarchyLength === 3) {
        listItem.showLowerLevel = true
        listItem.showMiddleLevel = true
        listItem.showTopLevel = true
        hierarchy = !hierarchy && $scope.topLevelList ? $scope.topLevelList[0] : hierarchy
      } else if ($scope.hierarchyLength === 2) {
        listItem.showMiddleLevel = true
        listItem.showTopLevel = true
        hierarchy = !hierarchy && $scope.topLevelList ? $scope.topLevelList[0] : hierarchy
      } else {
        listItem.showTopLevel = true
        hierarchy = !hierarchy && $scope.topLevelList ? $scope.topLevelList[0] : hierarchy
      }
      if (hierarchy && !(_.includes(hierarchy._id, 'All'))) {
        var machinesInHierarchy = []
        _.each(allMachines, function (item) {
          var hierarchyExist = _.find(item.ancestors, { '_id': hierarchy._id })
          if (hierarchyExist) {
            machinesInHierarchy.push(item)
          }
        })
        allMachines = machinesInHierarchy
      } else {
        // allMachines = []
        // machineCountByCondition = []
      }
      _.map(_.groupBy(allMachines, 'condition'), function (value, key) {
        var condition = _.find(constants.machineStates, { id: parseInt(key) }).displayName
        _.filter(machineCountByCondition, function (itm) {
          itm.label === condition ? itm.value = value.length : null
        })
      })
      listItem.data.values = machineCountByCondition
      var index = _.findIndex($scope.graphList, { name: 'Machines by Condition' })
      if (index > -1) {
        listItem.selected = $scope.graphList[index].selected
        if (hierarchy && !(_.includes(hierarchy._id, 'All'))) {
          if (hierarchy.ancestors.length === 2) {
            listItem.selected.lowerLevel = hierarchy
            listItem.selected.middleLevel = _.find($scope.middleLevelList, { _id: hierarchy.ancestors[1] })
          } else if (hierarchy.ancestors.length === 1) {
            listItem.selected.lowerLevel = !_.isEmpty($scope.lowerLevelList) ? $scope.lowerLevelList[0] : undefined
            listItem.selected.middleLevel = hierarchy
          } else {
            // listItem.selected.lowerLevel = !_.isEmpty($scope.lowerLevelList) ? $scope.lowerLevelList[0] : undefined
            listItem.selected.lowerLevel = undefined
            listItem.selected.middleLevel = !_.isEmpty($scope.middleLevelList) ? $scope.middleLevelList[0] : undefined
            listItem.selected.topLevel = hierarchy
          }
        } else {
          if (_.isEmpty($scope.middleLevelList)) {
            listItem.selected.middleLevel = undefined
            listItem.selected.lowerLevel = undefined
          } else if (_.isEmpty($scope.lowerLevelList)) {
            listItem.selected.middleLevel = $scope.middleLevelList[0]
            listItem.selected.lowerLevel = undefined
          }
        }
        $scope.graphList[index] = listItem
      } else {
        listItem.selected = {
          topLevel: $scope.topLevelList[0] || undefined,
          middleLevel: $scope.hierarchyLength > 1 && $scope.middleLevelList ? $scope.middleLevelList[0] : undefined,
          lowerLevel: $scope.hierarchyLength > 2 && $scope.lowerLevelList ? $scope.lowerLevelList[0] : undefined
        }
        $scope.graphList.push(listItem)
      }
    }

    /* Generate graph data for all machines from top hierarchy level */
    function getDataForTopLevelMachinesByConditionGraph(hierarchy) {
      if ($scope.role && ($scope.role.companyLevelManager || $scope.role.topLevelManager)) {
        var allMachines = $scope.machinesData
        var TopLevelMachineCountByCondition = []
        var filteredMachines = []
        if (hierarchy) {
          var machinesInHierarchy = []
          _.each(allMachines, function (item) {
            var hierarchyExist = _.find(item.ancestors, { '_id': hierarchy._id })
            if (hierarchyExist) {
              machinesInHierarchy.push(item)
            }
          })
          filteredMachines = machinesInHierarchy
          filteredMachines = _.groupBy(filteredMachines, 'ancestors[0]._id')
        } else {
          filteredMachines = _.groupBy(allMachines, 'ancestors[0]._id')
        }
        var colorIndex = 0
        _.map(filteredMachines, function (value, key) {
          var unitName
          var json = {
            values: []
          }
          _.forEach(value, function (itm) {
            unitName = _.find(itm.ancestors, { _id: key }).name
          })
          var color = colorIndex < $scope.colorsOfMultiBarGraph.length ? $scope.colorsOfMultiBarGraph[colorIndex++] : $scope.colorsOfMultiBarGraph[0]
          _.map(_.groupBy(value, 'condition'), function (value, innerKey) {
            var condition = _.find(constants.machineStates, { id: parseInt(innerKey) })
            json.key = unitName
            json.color = color
            json.values.push({
              x: condition.displayName,
              y: value.length,
              conditionId: parseInt(innerKey),
              levelId: key
            })
            TopLevelMachineCountByCondition.push(json)
          })
        })
        TopLevelMachineCountByCondition = _.uniq(TopLevelMachineCountByCondition)
        addMachineStatesOfZeroCount(TopLevelMachineCountByCondition)
        var listItem = angular.copy(multiBarChartData)
        listItem.name = 'Machine Condition by ' + $scope.user.customer.hierarchyType[0].name
        listItem.limit = 8
        listItem.forMachine = true
        listItem.hierarchyName = $scope.user.customer.hierarchyType[0].name
        listItem.options.chart.multibar = {
          dispatch: {
            elementClick: function (e) {
              $scope.showMachinesTable(e, listItem.name)
            }
          }
        }
        listItem.uibPage = {
          currentPage: 1
        }
        listItem.data = TopLevelMachineCountByCondition
        hierarchyVisible(listItem, true)
        if (listItem && listItem.data.length > 0) {
          setYAxisRange(listItem)
          if ($scope.topLevelList && $scope.topLevelList.length - listItem.data.length > 1) {
            addHierarchyOfNoMachine(listItem, 'top')
          }
          listItem.data[0].values = _.sortBy(listItem.data[0].values, function (element) {
            var rank = {
              'Unknown': 5,
              'Learning': 4,
              'Acceptable': 3,
              'Alert': 1,
              'Warning': 2
            }
            return rank[element.x]
          })
        } else if (listItem && _.isEmpty(listItem.data)) {
          addMachinesDataForEmptyHierarchy(listItem, hierarchy)
        }
        var graphIndex = _.findIndex($scope.graphList, function (item) {
          return _.includes(item.name, 'Machine Condition by')
        })
        if (graphIndex > -1) {
          listItem.selected = {
            topLevel: hierarchy || $scope.topLevelList[0],
            middleLevel: $scope.middleLevelList[0]
          }
          $scope.graphList[graphIndex] = listItem
        } else {
          listItem.selected = {
            topLevel: $scope.topLevelList[0]
          }
          $scope.graphList.push(listItem)
        }
      }
    }

    // Function used to decides which drop down to show for Machine Condition by hierarchy graph.
    function hierarchyVisible(listItem, showMiddleLevel) {
      listItem.showLowerLevel = false
      listItem.showMiddleLevel = false
      listItem.showTopLevel = true
      if ($scope.hierarchyLength === 3) {
        listItem.showMiddleLevel = showMiddleLevel
      }
    }

    /* Generate graph data for all machines from middle hierarchy level */
    function getDataForMiddleLevelMachinesByConditionGraph(hierarchy) {
      if ($scope.role && ($scope.role.topLevelManager || $scope.role.companyLevelManager)) {
        var allMachines = $scope.machinesData
        var MiddleLevelMachineCountByCondition = []
        var filteredMachines = []
        if (hierarchy) {
          var machinesInHierarchy = []
          _.each(allMachines, function (item) {
            var hierarchyExist = _.find(item.ancestors, { '_id': hierarchy._id })
            if (hierarchyExist) {
              machinesInHierarchy.push(item)
            }
          })
          filteredMachines = machinesInHierarchy
          filteredMachines = _.groupBy(filteredMachines, 'ancestors[1]._id')
        } else {
          filteredMachines = _.groupBy(allMachines, 'ancestors[1]._id')
        }
        var colorIndex = 0
        _.map(filteredMachines, function (value, key) {
          var unitName
          var json = {
            values: []
          }
          _.forEach(value, function (itm) {
            unitName = _.find(itm.ancestors, { _id: key }).name
          })
          var color = colorIndex < $scope.colorsOfMultiBarGraph.length ? $scope.colorsOfMultiBarGraph[colorIndex++] : $scope.colorsOfMultiBarGraph[0]
          _.map(_.groupBy(value, 'condition'), function (value, innerKey) {
            var condition = _.find(constants.machineStates, { id: parseInt(innerKey) }).displayName
            json.key = unitName
            json.color = color
            json.values.push({
              x: condition,
              y: value.length,
              conditionId: parseInt(innerKey),
              levelId: key
            })
            MiddleLevelMachineCountByCondition.push(json)
          })
        })
        MiddleLevelMachineCountByCondition = _.uniq(MiddleLevelMachineCountByCondition)
        addMachineStatesOfZeroCount(MiddleLevelMachineCountByCondition)
        _.each(constants.machineStates, function (item) {
          _.each(MiddleLevelMachineCountByCondition, function (chartData) {
            var index = _.findIndex(chartData.values, { x: item.displayName })
            if (index === -1) {
              chartData.values.push({ x: item.displayName, y: 0 })
            }
          })
        })
        var listItem = angular.copy(multiBarChartData)
        listItem.name = 'Machine Condition by ' + $scope.user.customer.hierarchyType[1].name
        listItem.limit = 8
        listItem.forMachine = true
        listItem.hierarchyName = $scope.user.customer.hierarchyType[1].name
        listItem.options.chart.multibar = {
          dispatch: {
            elementClick: function (e) {
              $scope.showMachinesTable(e, listItem.name)
            }
          }
        }
        listItem.uibPage = {
          currentPage: 1
        }
        listItem.data = MiddleLevelMachineCountByCondition
        hierarchyVisible(listItem, true)
        var graphIndex = _.findIndex($scope.graphList, function (item) {
          return _.includes(item.name, 'Machine Condition by')
        })
        if (listItem && listItem.data.length > 0) {
          setYAxisRange(listItem)
          if ($scope.middleLevelList && $scope.middleLevelList.length - listItem.data.length > 1) {
            addHierarchyOfNoMachine(listItem, 'middle')
          }
          listItem.data[0].values = _.sortBy(listItem.data[0].values, function (element) {
            var rank = {
              'Unknown': 5,
              'Learning': 4,
              'Acceptable': 3,
              'Alert': 1,
              'Warning': 2
            }
            return rank[element.x]
          })
        } else if (listItem && _.isEmpty(listItem.data)) {
          addMachinesDataForEmptyHierarchy(listItem, hierarchy)
        }
        if (graphIndex > -1) {
          listItem.selected = {
            topLevel: hierarchy,
            middleLevel: hierarchy.ancestors && hierarchy.ancestors.length === 0 ? $scope.middleLevelList[0] : undefined
          }
          $scope.graphList[graphIndex] = listItem
        } else {
          listItem.selected = {
            topLevel: $scope.topLevelList[0] || undefined,
            middleLevel: $scope.hierarchyLength > 1 && $scope.middleLevelList ? $scope.middleLevelList[0] : undefined
          }
          $scope.graphList.push(listItem)
        }
      }
    }

    /* Generate graph data for all machines from lower hierarchy level */
    function getDataForLowerLevelMachinesByConditionGraph(hierarchy) {
      if ($scope.role && ($scope.role.topLevelManager || $scope.role.companyLevelManager || $scope.role.middleLevelManager)) {
        var allMachines = $scope.machinesData
        var LowerLevelMachineCountByCondition = []
        var filteredMachines = []
        if ($scope.hierarchyLength === 3) {
          hierarchy = !hierarchy && $scope.middleLevelList ? $scope.middleLevelList[0] : hierarchy
        }
        if (hierarchy && !(_.includes(hierarchy._id, 'All'))) {
          var machinesInHierarchy = []
          _.each(allMachines, function (item) {
            var hierarchyExist = _.find(item.ancestors, { '_id': hierarchy._id })
            if (hierarchyExist) {
              machinesInHierarchy.push(item)
            }
          })
          filteredMachines = machinesInHierarchy
          filteredMachines = _.groupBy(filteredMachines, 'ancestors[2]._id')
        } else {
          filteredMachines = _.groupBy(allMachines, 'ancestors[2]._id')
          // filteredMachines = []
        }
        var colorIndex = 0
        _.map(filteredMachines, function (value, key) {
          var unitName
          var json = {
            values: []
          }
          _.forEach(value, function (itm) {
            unitName = _.find(itm.ancestors, { _id: key }).name
          })
          var color = colorIndex < $scope.colorsOfMultiBarGraph.length ? $scope.colorsOfMultiBarGraph[colorIndex++] : $scope.colorsOfMultiBarGraph[0]
          _.map(_.groupBy(value, 'condition'), function (value, innerKey) {
            var condition = _.find(constants.machineStates, { id: parseInt(innerKey) }).displayName
            json.key = unitName
            json.color = color
            json.values.push({
              x: condition,
              y: value.length,
              conditionId: parseInt(innerKey),
              levelId: key
            })
            LowerLevelMachineCountByCondition.push(json)
          })
        })
        LowerLevelMachineCountByCondition = _.uniq(LowerLevelMachineCountByCondition)
        addMachineStatesOfZeroCount(LowerLevelMachineCountByCondition)
        var listItem = angular.copy(multiBarChartData)
        listItem.name = 'Machine Condition by ' + $scope.user.customer.hierarchyType[2].name
        listItem.limit = 8
        listItem.forMachine = true
        listItem.hierarchyName = $scope.user.customer.hierarchyType[2].name
        listItem.options.chart.multibar = {
          dispatch: {
            elementClick: function (e) {
              $scope.showMachinesTable(e, listItem.name)
            }
          }
        }
        listItem.uibPage = {
          currentPage: 1
        }
        listItem.data = LowerLevelMachineCountByCondition
        hierarchyVisible(listItem, true)
        var graphIndex = _.findIndex($scope.graphList, function (item) {
          return _.includes(item.name, 'Machine Condition by')
        })
        if (listItem && listItem.data.length > 0) {
          setYAxisRange(listItem)
          if ($scope.lowerLevelList && $scope.lowerLevelList.length - listItem.data.length > 1) {
            addHierarchyOfNoMachine(listItem)
          }
          listItem.data[0].values = _.sortBy(listItem.data[0].values, function (element) {
            var rank = {
              'Unknown': 5,
              'Learning': 4,
              'Acceptable': 3,
              'Alert': 1,
              'Warning': 2
            }
            return rank[element.x]
          })
        } else if (listItem && _.isEmpty(listItem.data)) {
          addMachinesDataForEmptyHierarchy(listItem, hierarchy)
        }
        if (graphIndex > -1) {
          listItem.selected = $scope.graphList[graphIndex].selected
          if (hierarchy && !(_.includes(hierarchy._id, 'All'))) {
            if (hierarchy.ancestors.length === 1) {
              listItem.selected.middleLevel = hierarchy
              listItem.selected.topLevel = _.find($scope.topLevelList, { _id: hierarchy.ancestors[0] })
            } else if (hierarchy.ancestors.length === 0) {
              listItem.selected.middleLevel = $scope.middleLevelList[0]
            }
          } else if (_.isEmpty($scope.middleLevelList)) {
            listItem.selected.middleLevel = $scope.middleLevelList[0]
          }
          $scope.graphList[graphIndex] = listItem
        } else {
          listItem.selected = {
            topLevel: $scope.topLevelList[0] || undefined,
            middleLevel: $scope.middleLevelList ? $scope.middleLevelList[0] : undefined
          }
          $scope.graphList.push(listItem)
        }
      }
    }

    // Function to set Y-axis range for multi bar graph data.
    function setYAxisRange(listItem) {
      var maxCounts = []
      _.each(listItem.data, function (item) {
        var maxCount = _.maxBy(item.values, function (value) { return value.y })
        maxCounts.push(maxCount.y)
      })
      listItem.options.chart.forceY = [0, _.max(maxCounts)]
    }

    // Function to show zero values if hierarchy is empty
    function addMachinesDataForEmptyHierarchy(listItem, hierarchy) {
      var values = []
      _.each(constants.machineStates, function (item) {
        var json = {
          x: item.displayName,
          y: 0,
          key: hierarchy.name
        }
        values.push(json)
      })
      listItem.data[0] = {
        color: $scope.colorsOfMultiBarGraph[0],
        key: hierarchy.name,
        values: values
      }
      listItem.options.chart.forceY = [0, 5]
    }

    function addMachineStatesOfZeroCount(machinesArray) {
      _.each(constants.machineStates, function (item) {
        _.each(machinesArray, function (chartData) {
          var index = _.findIndex(chartData.values, { x: item.displayName })
          if (index === -1) {
            chartData.values.push({ x: item.displayName, y: 0 })
          }
        })
      })
    }

    // If some hierarchy in list does not contain machines then to show zero count for that hierarchies.
    function addHierarchyOfNoMachine(listItem, level) {
      var hierarchyList = level === 'top' ? $scope.topLevelList : level === 'middle' ? $scope.middleLevelList : $scope.lowerLevelList
      var colorIndex = listItem.data.length - 1
      _.each(hierarchyList, function (item, index) {
        if (item.name === 'All' && index === 0) {
          return true
        }
        var hierarchyWithMachine = _.find(listItem.data, { key: item.name })
        if (!hierarchyWithMachine) {
          var values = []
          _.each(constants.machineStates, function (item) {
            var stateZero = {
              x: item.displayName,
              y: 0,
              key: item.name
            }
            values.push(stateZero)
          })
          var machineData = {
            key: item.name,
            color: (colorIndex + 1) < $scope.colorsOfMultiBarGraph.length ? $scope.colorsOfMultiBarGraph[++colorIndex] : $scope.colorsOfMultiBarGraph[0],
            values: values
          }
          listItem.data.push(machineData)
        }
      })
    }
    var manageCookies = function (action) {
      if (action === 'add') {
        $cookies.put('userId', $stateParams.id)
        $cookies.put('authToken', $stateParams.tkn)
        $cookies.putObject('vcUser', { _id: $stateParams.id })
        $rootScope.authToken = $stateParams.tkn || $cookies.get('authToken')
      } else {
        window.angular.forEach($cookies.getAll(), function (v, k) {
          $cookies.remove(k)
        })
      }
    }
    window.onbeforeunload = function () {
      if ($stateParams.tkn && $stateParams.id) {
        manageCookies()
      }
    }
    var generateMobileOptionsForCharts = function (options) {
      var mobileOptions = angular.copy(options)
      if (options.chart.type === 'discreteBarChart') {
        mobileOptions.chart.margin.left = 60
        mobileOptions.chart.margin.bottom = 100
        mobileOptions.chart.xAxis.rotateLabels = -45
        mobileOptions.chart.xRange = null
      }
      return angular.copy(mobileOptions)
    }

    // show table on click
    $scope.showMachinesTable = function (selected, graphName) {
      var hierarchyDepth = $scope.user.customer.hierarchyType.length
      // find index of selected fraph in graph list
      var listIndex = _.findIndex($scope.graphList, { name: graphName })
      var graphItem = $scope.graphList[listIndex]
      // common params
      var queryParams = {
        customerId: $scope.user.customerIds[0],
        page: null,
        sort: {
          createdOn: -1
        },
        filters: {},
        limit: $scope.graphList[listIndex].limit
      }

      // reset page number
      if (selected) {
        $scope.graphList[listIndex].uibPage.currentPage = 1
      }
      // for machine by condition graph
      if (graphName === 'Machines by Condition') {
        if (selected) {
          $scope.graphList[listIndex].selectedCondition = selected.data.id
          $scope.graphList[listIndex].conditionName = selected.data.label
        }
        if ($scope.topLevelList && $scope.topLevelList.length) {
          queryParams.resourceId = graphItem.selected.lowerLevel ? graphItem.selected.lowerLevel._id : graphItem.selected.middleLevel ? graphItem.selected.middleLevel._id : graphItem.selected.topLevel ? graphItem.selected.topLevel._id : null
        }
        // for all levels
        if (queryParams.resourceId === 'All') {
          // get machine for specifed level
          queryParams.resourceId = hierarchyDepth > 2 ? graphItem.selected.middleLevel._id : hierarchyDepth === 2 ? graphItem.selected.topLevel._id : graphItem.selected.topLevel._id
          // for get all machines from all middle levels
          if (hierarchyDepth > 2 && queryParams.resourceId === 'All') {
            queryParams.resourceId = graphItem.selected.topLevel._id
          }
          // get all machines fro all top levels
          queryParams.resourceId === 'All' ? queryParams = _.omit(queryParams, ['resourceId']) : void 0
        }
        _.assign(queryParams.filters, $scope.filter)
      } else {
        // for machine conditions by level
        if (selected) {
          $scope.graphList[listIndex].selectedLevel = selected.data.levelId
          $scope.graphList[listIndex].selectedCondition = selected.data.conditionId
          $scope.graphList[listIndex].conditionName = selected.data.x
          $scope.graphList[listIndex].levelName = selected.data.key
        }
        queryParams.resourceId = graphItem.selectedLevel
      }

      // get all machines with specified query params
      queryParams.page = selected ? 1 : $scope.graphList[listIndex].uibPage.currentPage
      queryParams.conditions = [$scope.graphList[listIndex].selectedCondition]
      MachineService.resource.getAllMachines(queryParams, function (res) {
        $scope.graphList[listIndex].tableData = _.map(res.result, function (machine) {
          machine.icon = _.find(constants.typesOfMachine, { name: machine.machineType.name }).icon
          return machine
        })
        // assign it to specific chart
        $scope.graphList[listIndex].totalItems = res.totalCount
        res.result && res.result.length ? $scope.graphList[listIndex].showTable = true : void 0
        setTimeout(function () {
          window.dispatchEvent(new Event('resize')); // resize
        }, 50);
      }, function (err) {
        toastr.error(err.data.msg)
      })
    }

    //Show user details table
    $scope.showUsersTable = function (selected, graphName) {
      // find index of selected fraph in graph list
      var listIndex = _.findIndex($scope.graphList, { name: graphName })
      if (selected) {
        $scope.graphList[listIndex].selectedHierarchyTypeId = selected.data.hierarchyTypeId ? selected.data.hierarchyTypeId : null
        $scope.graphList[listIndex].selectedRole = selected.data.role
        $scope.graphList[listIndex].uibPage.currentPage = 1
        $scope.graphList[listIndex].roleName = selected.data.label
      }
      var params = {
        hierarchyTypeId: $scope.graphList[listIndex].selectedHierarchyTypeId,
        role: $scope.graphList[listIndex].selectedRole,
        options: {
          customerId: $scope.user.customerIds[0],
          populate: [{ path: 'userId', select: '_id firstName lastName email' }],
          page: $scope.graphList[listIndex].uibPage.currentPage,
          limit: $scope.graphList[listIndex].limit
        }
      }
      UserService.resource.getUsersByRole(params, function (res) {
        $scope.graphList[listIndex].tableData = _.map(_.uniqBy(res.users, 'userId._id'), function (user) { return user.userId })
        $scope.graphList[listIndex].totalItems = res.totalCount
        $scope.graphList[listIndex].tableData && $scope.graphList[listIndex].tableData.length ? $scope.graphList[listIndex].showTable = true : void 0
        setTimeout(function () {
          window.dispatchEvent(new Event('resize')); // resize
        }, 50);
      }, function (err) {
        toastr.error(err.data.msg)
      })
    }

    // show customers table
    $scope.showCustomersTable = function (selected, graphName) {
      // find index of selected fraph in graph list
      var listIndex = _.findIndex($scope.graphList, { name: graphName })
      if (selected) {
        $scope.graphList[listIndex].selectedSalesRepId = selected.data.salesRepId
        $scope.graphList[listIndex].uibPage.currentPage = 1
        $scope.graphList[listIndex].salesRepName = selected.data.label
      }
      var queryParams = {
        salesRep: $scope.graphList[listIndex].selectedSalesRepId,
        distributorId: $rootScope.user.distributorIds[0],
        sort: { createdOn: -1 },
        page: $scope.graphList[listIndex].uibPage.currentPage,
        limit: $scope.graphList[listIndex].limit
      }
      CustomerService.resource.getAll(queryParams, function (res) {
        if (res && res.customers && res.customers.length) {
          $scope.graphList[listIndex].tableData = res.customers
          $scope.graphList[listIndex].totalItems = res.total
          $scope.graphList[listIndex].showTable = true
          setTimeout(function () {
            window.dispatchEvent(new Event('resize')); // resize
          }, 50);
        } else {
          $scope.graphList[listIndex].showTable = false
        }
      }, function (err) {
        toastr.error(err.data.msg)
      })
    }

    // handle page change event
    $scope.pageChanged = function (currentPage, graphName, forMachine, forUser, forSalesRep) {
      var listIndex = _.findIndex($scope.graphList, { name: graphName })
      $scope.graphList[listIndex].uibPage.currentPage = currentPage
      if (forMachine) {
        $scope.showMachinesTable(null, graphName)
      }
      if (forUser) {
        $scope.showUsersTable(null, graphName)
      }
      if (forSalesRep) {
        $scope.showCustomersTable(null, graphName)
      }
    }

    // show machine report
    $scope.showReport = function (machine) {
      var modalInstance = $uibModal.open({
        templateUrl: 'app/components/machines/reviews/modals/viewReport.html',
        backdrop: true,
        controller: 'ViewReportCtrl',
        resolve: {
          reportData: {
            machineType: machine.machineType.name,
            machineId: machine._id
          }
        }
      })
      modalInstance.result.then(function (result) {
      })
    }
  }
})();

(function () {
  'use strict'
  var angular = window.angular
  angular.module('Vibzer.components')
    .controller('AddDemoCustomerCtrl', AddDemoCustomerCtrl);

  // @NgInject
  function AddDemoCustomerCtrl ($scope, $cookies, $uibModalInstance, toastr, constants, CustomerService) {
    $scope.webAppTexts = constants.webAppTexts
    $scope.user = $cookies.getObject('vcUser')
    $scope.model = {}
    $scope.initialHierarchyData = [
      {
        level: 1,
        name: undefined
      },
      {
        level: 2,
        name: undefined
      },
      {
        level: 3,
        name: undefined
      }
    ]

    $scope.model.hierarchyData = angular.copy($scope.initialHierarchyData)
    $scope.hierarchyLevels = angular.copy(constants.defaultHierarchyLevels)
    /*
     Set level name to default values when user changes hierarchy level drop down.
   */
    $scope.levelChanged = function () {
      if ($scope.model.level > 0) {
        $scope.model.hierarchyData = angular.copy($scope.initialHierarchyData)
      }
    }

    // disable save button
    $scope.saveDisabled = function () {
      if (!$scope.model.customerName || !$scope.model.level) {
        return true
      }
      for (var index = 0; index < $scope.model.level; index++) {
        if (!$scope.model.hierarchyData[index].name) {
          return true
        }
      }
      return false
    }

    // create demo customer
    $scope.createCustomer = function () {
      var hierarchy = []
      for (var index = 0; index < $scope.model.level; index++) {
        hierarchy.push($scope.model.hierarchyData[index])
      }
      var data = {
        customer: {
          name: $scope.model.customerName,
          hierarchyType: hierarchy,
          distributorId: $scope.user.distributorIds[0]
        },
        salesRepId: $scope.user._id,
        forSalesRep: true
      }
      CustomerService.resource.add(data, function (res) {
        toastr.success(constants.toastrMessages.success.addCustomer)
        var user = $cookies.getObject('vcUser')
        // save data in tempCache to implement login as customer functionality
        user.tempCache = {
          customerIds: [res._id],
          customer: _.pick(res, ['_id', 'name', 'isActive', 'hierarchyType']),
          distributorIds: angular.copy($scope.user.distributorIds),
          distributor: angular.copy($scope.user.distributor),
          loggedInAs: 'distributor'
        }
        $cookies.putObject('vcUser', user)
        $uibModalInstance.close($scope.model)
      }, function (err) {
        toastr.error(err.data.msg)
      })
    }

    $scope.closeModal = function () {
      $uibModalInstance.dismiss()
    }
  }
})();
(function () {
  'use strict';

  var angular = window.angular
  var _ = window._
  angular.module('Vibzer.components')
    .controller('DemoCustomerDetailsCtrl', DemoCustomerDetailsCtrl);

  // Add demo customer controller
  /** @ngInject */
  function DemoCustomerDetailsCtrl ($scope, $rootScope, $state, $cookies, UserService, toastr, $stateParams, constants, CustomerService, $uibModal) {
    $scope.cookie = $cookies.getObject('vcUser')

    $scope.init = function () {
      $scope.user = $cookies.getObject('vcUser')
      var permissionToCheck = []
      if ($scope.user && $scope.user.tempCache) {
        if ($scope.user.tempCache.loggedInAs === 'distributor') {
          if (!$scope.user.tempCache.customer.isActive) {
            toastr.error(constants.webAppTexts.errorMessages.deactiveCustomerAccount)
            setTimeout(function () {
              $state.go('customers', { searchText: $scope.user.tempCache.customer.name })
            }, 50)
            return
          } else {
            permissionToCheck = ['canViewMachines', 'addMachine', 'editMachine', 'canViewOwnedMachines', 'viewRoutes', 'addRoute', 'editRoute', 'deleteRoute', 'viewComposites', 'addComposite', 'analyzeMachine']
            $scope.user.tempCache.loggedInAs = 'customer'
            $scope.user.distributorIds = []
            delete $scope.user.distributor
            $scope.user.customerIds = angular.copy($scope.user.tempCache.customerIds)
            $scope.user.customer = angular.copy($scope.user.tempCache.customer)
            $scope.user.customerName = $scope.user.customer.name
          }
        } else {
          permissionToCheck = ['addDistributorUser', 'addCustomer']
          $scope.user.tempCache.loggedInAs = 'distributor'
          $scope.user.customerIds = []
          delete $scope.user.customer
          delete $scope.user.customerName
          $scope.user.distributorIds = angular.copy($scope.user.tempCache.distributorIds)
          $scope.user.distributor = angular.copy($scope.user.tempCache.distributor)
        }

        UserService.resource.getAllPermissionsOfUser({ _id: $rootScope.user._id }, function (res) {
          var permissions = []
          $scope.user.permission = {}
          if (res.result && res.result.length > 0) {
            _.each(res.result, function (item) {
              permissions = _.concat(permissions, item.permissionIds)
            })
            permissions = _.uniqBy(permissions, '_id')
          }
          _.each(permissions, function (item) {
            if (_.includes(permissionToCheck, item.name)) {
              $scope.user.permission[item.name] = true
            }
          })
          $cookies.putObject('vcUser', $scope.user)
          $rootScope.user = angular.copy($scope.user)
          $rootScope.$broadcast('showOrHideSidebarMenu')
          $state.go('dashboard')
        })
      }
    }

    // open dialog box for user details
    if ($scope.cookie && !$scope.cookie.tempCache) {
      setTimeout(function () {
        var modalInstance = $uibModal.open({
          templateUrl: 'app/components/demoCustomer/addDemoCustomer.html',
          controller: 'AddDemoCustomerCtrl',
          backdrop: true,
          resolve: {}
        })
        modalInstance.result.then(function (customer) {
          $scope.init()
        }, function () { })
      }, 100)
    } else if ($scope.cookie && $scope.cookie.tempCache && $scope.cookie.tempCache.customerIds && $scope.cookie.tempCache.customerIds.length && $scope.user.tempCache.loggedInAs === 'distributor') {
      CustomerService.resource.getById({ _id: $scope.cookie.tempCache.customer._id }, function (res) {
        $scope.cookie.tempCache.customer = _.assign($scope.cookie.customer, _.pick(res, ['_id', 'name', 'hierarchyType', 'address', 'isActive']))
        if ($scope.cookie.customer) {
          $scope.cookie.customer = $scope.cookie.tempCache.customer
        }
        $rootScope.user = angular.copy($scope.cookie)
        $cookies.putObject('vcUser', $scope.cookie)
        $scope.init()
      })
    } else {
      $scope.init()
    }
  }
})();
(function () {
  'use strict'
  var angular = window.angular
  var _ = window._
  angular.module('Vibzer.components').controller('AllDevicesCtrl', AllDevicesCtrl)
  function AllDevicesCtrl($scope, $stateParams, $uibModal, $rootScope, $location, $cookies, HierarchyService, DeviceService, DistributorService, constants, UtilService, toastr) {
    $scope.webAppTexts = constants.webAppTexts
    $scope.breadCrumbList = [$scope.webAppTexts.breadcrumbs.deviceList]
    $scope.user = $cookies.getObject('vcUser')
    $scope.selected = {}
    $scope.distributors = [{ _id: '#', name: 'All' }]
    $scope.limit = 10
    $scope.uibPage = {
      currentPage: 1
    }

    $scope.init = function () {
      $scope.getAllDistributors()
      $scope.uibPage.currentPage = $stateParams.currentPage ? $stateParams.currentPage : ($scope.uibPage.currentPage || 1)
      $scope.deviceTypes = angular.copy(constants.deviceTypes)
      $scope.deviceTypes.unshift({ id: 0, internalName: 'all', displayName: 'All' })
      $scope.deviceStates = angular.copy(constants.deviceStates)
      $scope.deviceStates.unshift({ id: '#', internalName: 'all', displayName: 'All' })
      $scope.deviceStates.push({ id: '$', internalName: 'unConfigured', displayName: 'Not Configured' })
      $scope.selected.type = $scope.deviceTypes[0].id
      getAllDevices()
    }

    $scope.getDeviceType = function (type) {
      $location.search('type', type)
      $scope.pageChanged(1)
    }

    // get devices by serial number
    $scope.searchDevice = function (searchText) {
      if (searchText !== undefined) {
        $scope.uibPage.currentPage = 1
      }
      $scope.searchText = searchText
      $location.search('searchText', searchText)
      getAllDevices()
    }

    function getAllDevices(resourceId) {
      $scope.busy = true
      var queryParams = {
        forSuperAdmin: true,
        page: null,
        limit: $scope.limit,
        filters: {}
      }
      if ($scope.searchText) {
        queryParams.filters.serialNumber = {
          internalName: 'serialNumber',
          value: ($location.search().searchText && $location.search().searchText !== '' ? $scope.searchText : ''),
          type: 'regex',
          regexOptions: 'i'
        }
      }
      if ($scope.selected.distributor && $scope.selected.distributor !== '#') {
        queryParams.distributorId = $scope.selected.distributor
        queryParams.for = 'distributor'
      }
      $scope.selected.type ? queryParams.filters.type = $scope.selected.type : void 0
      queryParams.page = $scope.uibPage.currentPage || 1
      queryParams.populate = [{ path: 'customerId', select: 'name' }, { path: 'distributorId', select: 'name' }]
      DeviceService.resource.getDevices(queryParams, function (res) {
        $scope.devices = _.map(res.devices, function (device) {
          device.typeName = _.find(constants.deviceTypes, { id: device.type }).displayName
          device.isHandheld = device.type === 1
          return device
        })
        $scope.totalItems = res.total
        $scope.busy = false
      }, function (err) {
        console.log(err)
        $scope.busy = false
      })
    }

    $scope.manageDevice = function (action, device) {
      var message
      var templateUrl = 'app/components/devices/modals/manageDeviceDialog.html'
      var controller = 'ManageDeviceDialogCtrl'
      if (action === 'delete') {
        templateUrl = 'app/components/confirmationDialog/confirmationDialog.html'
        controller = 'AllConfirmationDialogCtrl'
        var properties = device
        message = UtilService.generateMsg($scope.webAppTexts.popupMessages[action + 'Device'], properties)
      }
      var modalOptions = {
        templateUrl: templateUrl,
        controller: controller,
        resolve: {
          items: {
            message: message,
            title: '<i aria-hidden="true"></i> ' + $scope.webAppTexts.headings[action + 'Device'],
            deviceData: device || {}
          }
        }
      }
      if (action !== 'delete') {
        modalOptions.size = 'lg'  // Add/Edit device modal only; delete confirmation keeps default size
      }
      var modalInstance = $uibModal.open(modalOptions)

      modalInstance.result.then(function (result) {
        var data = result
        if (action === 'delete') {
          data = { _id: device._id }
        }
        var deviceData = DeviceService.resource[action + 'Device'](data)
        deviceData.$promise.then(function (res) {
          $scope.pageChanged(1)
          toastr.success(constants.toastrMessages.success[action + 'Device'])
        }, function (err) {
          toastr.error(err.data.msg)
        })
      }, function () { })
    }

    $scope.pageChanged = function (currentPage) {
      if (currentPage) {
        $scope.uibPage.currentPage = currentPage
      }
      $location.search('currentPage', $scope.uibPage.currentPage)
      getAllDevices()
    }

    $scope.getAllDistributors = function () {
      DistributorService.resource.getAllDistributors({ select: 'name' }, function (res) {
        $scope.distributors = res.data
        $scope.distributors.unshift({ _id: '#', name: 'All' })
      }, function (err) {
        toastr.error(err.data.msg)
      })
    }
    $scope.init()
  }
})();

(function () {
    'use strict'
    var angular = window.angular
    var _ = window._
    var moment = window.moment
    angular.module('Vibzer.components')
        .controller('DevicesCtrl', DevicesCtrl)
    function DevicesCtrl($scope, $stateParams, $uibModal, $rootScope, $location, $cookies, HierarchyService, DeviceService, UserService, constants, UtilService, toastr) {
        $scope.webAppTexts = constants.webAppTexts
        $scope.breadCrumbList = [$scope.webAppTexts.breadcrumbs.deviceList]
        $scope.user = $cookies.getObject('vcUser')
        $scope.isDistributorUser = $scope.user && (($scope.user.tempCache && $scope.user.tempCache.distributorIds && $scope.user.tempCache.distributorIds.length && $scope.user.tempCache.loggedInAs === 'distributor') || ($scope.user.distributorIds && $scope.user.distributorIds.length))
        !$scope.isDistributorUser ? $scope.allLevel = $rootScope.user.customer.hierarchyType : void 0
        $scope.selected = {}
        $scope.limit = 10
        $scope.uibPage = {
            currentPage: 1
        }

        $scope.init = function () {
          $scope.uibPage.currentPage = $stateParams.currentPage ? $stateParams.currentPage : ($scope.uibPage.currentPage || 1)
          $scope.stateParams = $stateParams.deviceData ? JSON.parse($stateParams.deviceData) : null
          $scope.deviceTypes = angular.copy(constants.deviceTypes)
            $scope.deviceTypes.unshift({ id: 0, internalName: 'all', displayName: 'All' })
            $scope.deviceStates = angular.copy(constants.deviceStates)
            $scope.deviceStates.unshift({ id: '#', internalName: 'all', displayName: 'All' })
            $scope.deviceStates.push({ id: '$', internalName: 'unConfigured', displayName: 'Not Configured' })
            $scope.selected.type = $scope.deviceTypes[0].id
            $scope.selected.state = $scope.deviceStates[0].id
            getAllDevices()
        }

        $scope.getLevels = function (parentId, level, currentPage) {
            $scope.uibPage.currentPage = currentPage ? currentPage : $scope.uibPage.currentPage
            $scope.devices = []
            if (parentId !== 'All') {
                var queryParams = {
                    customerId: $scope.user.customerIds[0]
                }
                if (parentId) {
                    queryParams.parentId = parentId
                }
                HierarchyService.resource.getAll(queryParams, function (res) {
                    $scope.totalItems = res.totalCount == 0 ? 0 : $scope.totalItems
                    if (level == 1) {
                        $scope.plantList = res.result
                        if ($scope.plantList.length > 1 && ($scope.role && $scope.role.companyLevelManager))
                            $scope.plantList.unshift({ _id: 'All', name: 'All' })
                        var selectedPlant = $scope.stateParams ? _.find($scope.plantList, { _id: $scope.stateParams.topLevel }) : null
                        if ($scope.stateParams && selectedPlant) {
                            $scope.selected.plant = selectedPlant
                        } else
                            $scope.selected.plant = $scope.plantList[0]
                        if ($scope.selected.plant) {
                            $scope.getLevels($scope.selected.plant._id, 2)
                            if ($scope.selected.plant._id == 'All')
                                getAllDevices()
                        } else
                            $scope.devices = []
                    } else if (level == 2) {
                        if ($scope.allLevel.length == 2 || $scope.allLevel.length == 3) {
                            $scope.areaList = res.result
                            if ($scope.areaList.length > 1)
                                $scope.areaList.unshift({ _id: 'All', name: 'All' })
                            if ($scope.selected.plant._id == 'All') {
                                $scope.areaList = []
                                $scope.selected.area = null
                            } else {
                                var selectedArea = $scope.stateParams ? _.find($scope.areaList, { _id: $scope.stateParams.middleLevel }) : null
                                if ($scope.stateParams && selectedArea) {
                                    $scope.selected.area = selectedArea
                                } else
                                    $scope.selected.area = $scope.areaList[0]
                                if ($scope.selected.area) {
                                    if ($scope.allLevel.length == 3) {
                                        $scope.getLevels($scope.selected.area._id, 3)
                                    }
                                    if ($scope.selected.area._id == 'All')
                                        getAllDevices($scope.selected.plant._id)
                                    else {
                                        getAllDevices($scope.selected.area._id)
                                    }
                                } else if ($scope.selected.plant && $scope.selected.plant._id)
                                    getAllDevices($scope.selected.plant._id)
                                else
                                    $scope.devices = []
                                $scope.selected.section = null;
                                $scope.sectionList = []
                            }
                        } else {
                            getAllDevices($scope.selected.plant._id)
                        }
                    } else if (level == 3) {
                        if ($scope.allLevel.length == 3) {
                            $scope.sectionList = res.result
                            if ($scope.sectionList.length > 1)
                                $scope.sectionList.unshift({ _id: 'All', name: 'All' })
                            if ($scope.selected.area._id == 'All') {
                                $scope.sectionList = []
                                $scope.selected.section = null
                            } else {
                                var selectedSection = $scope.stateParams ? _.find($scope.sectionList, { _id: $scope.stateParams.lowerLevel }) : null
                                if ($scope.stateParams && selectedSection) {
                                    $scope.selected.section = selectedSection
                                } else
                                    $scope.selected.section = $scope.sectionList[0]
                                if ($scope.selected.section) {
                                    if ($scope.selected.section._id == 'All')
                                        getAllDevices($scope.selected.area._id)
                                    else {
                                        getAllDevices($scope.selected.section._id)
                                    }
                                } else if ($scope.selected.area && $scope.selected.area._id)
                                    getAllDevices($scope.selected.area._id)
                                else
                                    $scope.devices = []
                            }
                        } else {
                            getAllDevices($scope.selected.area._id)
                        }
                    } else {
                        getAllDevices($scope.selected.section._id)
                    }
                    getDeviceData()
                })
            } else {
                if (level == 2) {
                    if ($scope.selected.plant._id == 'All')
                        getAllDevices()
                    else {
                        getAllDevices($scope.selected.plant._id)
                    }
                    $scope.areaList = []
                    $scope.selected.area = null
                    $scope.sectionList = []
                    $scope.selected.section = null
                } else if (level == 3) {
                    if ($scope.selected.area._id == 'All')
                        getAllDevices($scope.selected.plant._id)
                    else {
                        getAllDevices($scope.selected.area._id)
                    }
                    $scope.sectionList = []
                    $scope.selected.section = null
                } else {
                    getAllDevices($scope.selected.area._id)
                }
                getDeviceData()
            }
        }

        function getDeviceData() {
            $scope.deviceData = {
                topLevel: $scope.selected.plant ? $scope.selected.plant._id : null,
                middleLevel: $scope.selected.area ? $scope.selected.area._id : null,
                lowerLevel: $scope.selected.section ? $scope.selected.section._id : null,
            }
            $location.search('deviceData', JSON.stringify($scope.deviceData))
        }

        $scope.getDeviceType = function(type) {
            $location.search('type', type)
            $scope.pageChanged(1)
        }

        $scope.getDeviceState = function (state) {
            $location.search('state', state)
            $scope.pageChanged(1)
        }

    // get devices by serial number
    $scope.searchDevice = function (searchText) {
        if (searchText !== undefined) {
          $scope.uibPage.currentPage = 1
        }
        $scope.searchText = searchText
        $location.search('searchText', searchText)
        getAllDevices()
    }

        function getAllDevices(resourceId) {
            $scope.busy = true
            var queryParams = {
                page: null,
                limit: $scope.limit,
                filters: {}
            }
            if ($scope.searchText) {
                queryParams.filters.serialNumber = {
                  internalName: 'serialNumber',
                  value: ($location.search().searchText && $location.search().searchText !== '' ? $scope.searchText : ''),
                  type: 'regex',
                  regexOptions: 'i'
                }
            }
            if ($scope.isDistributorUser) {
                queryParams.distributorId = $scope.user.distributorIds[0]
                queryParams.for = 'distributor'
            } else {
                queryParams.for = 'customer'
                queryParams.customerId = $scope.user.customerIds[0]
            }
            $scope.selected.type ? queryParams.filters.type = $scope.selected.type : void 0
            $scope.selected.state && $scope.selected.state !== '#' ? queryParams.state = $scope.selected.state : void 0
            queryParams.page = $scope.uibPage.currentPage || 1
            queryParams.populate = [{ path: 'customerId', select: 'name' }]
            DeviceService.resource.getDevices(queryParams, function (res) {
                $scope.devices = _.map(res.devices, function (device) {
                    device.typeName = _.find(constants.deviceTypes, { id: device.type }).displayName
                    device.isHandheld = device.type === 1
                    return device
                })
            $scope.totalItems = res.total
            $scope.busy = false
            }, function (err) {
                $scope.busy = false
            })
        }

        $scope.init()

        $scope.detachDevice = function (device) {
            var message = $scope.webAppTexts.popupMessages.detachDevice
            var properties = {
                name: device.deviceId,
                machineName: device.machineName
            }
            message = UtilService.generateMsg(message, properties)
            var items = function () {
                return {
                    message: message,
                    title: '<i aria-hidden="true"></i> ' + $scope.webAppTexts.headings.detachDevice + ' ' + device.deviceId
                }
            }
            var modalInstance = $uibModal.open({
                templateUrl: 'app/components/devices/modals/deviceDetachDialog.html',
                controller: 'DeviceDetachDialogCtrl',
                resolve: {
                    items: items
                }
            })

            modalInstance.result.then(function (result) {
                var data = {
                    machineId: device.machineId,
                    pointId: device.pointId,
                    deviceMacId: device.deviceId,
                    machineType: device.machineType,
                    reason: result.reason,
                    comment: result.commentText
                }
                DeviceService.resource.detachDevice(data, function (res) {
                    $location.search('currentPage', $scope.uibPage.currentPage)
                    $scope.stateParams = $stateParams.deviceData ? JSON.parse($stateParams.deviceData) : null
                    $scope.getLevels(null, 1, $scope.uibPage.currentPage)
                    toastr.success(constants.toastrMessages.success.detachDevice)
                }, function (err) {
                    toastr.error(err.data.msg)
                })
            }, function () { })
        }

        $scope.pageChanged = function (currentPage) {
            if(currentPage) {
              $scope.uibPage.currentPage = currentPage
            }
            $location.search('currentPage', $scope.uibPage.currentPage)
            $scope.stateParams = $stateParams.deviceData ? JSON.parse($stateParams.deviceData) : null
            getAllDevices()
        }
    }
})();

(function () {
  var angular = window.angular
  var _ = window._
  angular.module('Vibzer.components.distributor', ['ui.select'])
    .controller('DistributorCtrl', DistributorCtrl)
  function DistributorCtrl($scope, $state, $stateParams, $uibModal, $location, $cookies, DistributorService, toastr, UserService, constants) {
    $scope.webAppTexts = constants.webAppTexts
    $scope.breadCrumbList = [$scope.webAppTexts.breadcrumbs.distributorsList]
    $scope.user = $cookies.getObject('vcUser')
    $scope.dateFormat = constants.dateFormats.licensesTableDateFormat
    $scope.distributorNameClass = $scope.user.permission.addDistributorUser ? 'col-sm-2' : 'col-sm-2'
    $scope.filter = { $or: [{ isActive: true }, { isActive: false }] }
    $scope.limit = 10
    $scope.uibPage = {
      currentPage: 1
    }

    $scope.distributorCount = {
      active: 0,
      inactive: 0
    }

    /* Used to handle breadcrumb state after redirecting to another state. */
    $scope.uibPage.currentPage = $stateParams.currentPage ? $stateParams.currentPage : 1
    $scope.sort = $stateParams.sort ? $stateParams.sort : 'createdOn'
    $scope.order = $stateParams.order ? $stateParams.order : -1
    $scope.searchText = $stateParams.searchText || ''

    $scope.sortBy = [
      {
        type: 'sort',
        internalName: 'name',
        displayName: 'Distributor Name'
      },
      {
        type: 'sort',
        internalName: 'createdOn',
        displayName: 'Created'
      }
    ]
    $scope.orderBy = [{
      type: 'order',
      internalName: 1,
      displayName: 'Ascending'
    },
    {
      type: 'order',
      internalName: -1,
      displayName: 'Descending'
    }]
    $scope.sortBy.selected = _.find($scope.sortBy, { internalName: $scope.sort })
    $scope.orderBy.selected = _.find($scope.orderBy, { internalName: parseInt($scope.order) })

    /* This function is used to handle sorting. It invokes after changing
       sort or order and updates stateParams and calls pageChanged() to get updated user list.
    */
    $scope.setSorting = function (sort) {
      if (sort.type === 'sort') {
        $scope.sort = sort.internalName
        $location.search('sort', sort.internalName)
      } else {
        $scope.order = sort.internalName
        $location.search('order', sort.internalName)
      }
      $scope.uibPage.currentPage = 1
      $scope.pageChanged(1)
    }

    /* This function invokes after page or sort or order changes and sets
       currentPage in URL and calls getAllDistributors() to get updated user list.
    */
    $scope.pageChanged = function (currentPage) {
      $location.search('currentPage', $scope.uibPage.currentPage)
      getAllDistributors()
    }

    /* Search distributors */
    $scope.searchDistributor = function (searchText) {
      if (searchText !== undefined) {
        $scope.uibPage.currentPage = 1
        $location.search('currentPage', $scope.uibPage.currentPage)
        $scope.searchText = searchText
        $location.search('searchText', searchText)
        getAllDistributors()
      }
    }

    /* This block handles active, deactive and all distributor tab. */
    $scope.filterValues = [
      {
        id: 0,
        internalName: 'active',
        displayName: 'Active',
        count: function () {
          return $scope.distributorCount.active
        },
        isFilterActive: true,
        onClickHandler: toggleFilter,
        filterQuery: {
          $or: [{ isActive: true }, { isActive: false }]
        }
      },
      {
        id: 1,
        internalName: 'inactive',
        displayName: 'Deactive',
        count: function () {
          return $scope.distributorCount.inactive
        },
        isFilterActive: false,
        onClickHandler: toggleFilter,
        filterQuery: {
          $or: [{ isActive: false }]
        }
      },
      {
        id: 2,
        internalName: 'all',
        displayName: 'All',
        count: function () {
          return $scope.distributorCount.active + $scope.distributorCount.inactive
        },
        isFilterActive: false,
        onClickHandler: toggleFilter,
        filterQuery: {
          $or: [{ isActive: true }, { isActive: false }]
        }
      }
    ]
    $scope.totalItems = $scope.filterValues[0].count()

    /* This function invokes after tab changes and updates user list as per current tab. */
    function toggleFilter(filter, page) {
      $scope.uibPage.currentPage = page || 1
      $location.search('currentPage', $scope.uibPage.currentPage)
      _.each($scope.filterValues, function (object) {
        object.isFilterActive = false
      })
      $scope.filterValues[filter.id].isFilterActive = true
      $scope.filter = filter.filterQuery
      $location.search('filterId', filter.id)
      getAllDistributors()
    }

    /* If stateParams contains filterId this block calls toggleFilter() and updates user list. */
    if ($stateParams.filterId) {
      var filter = _.filter($scope.filterValues, { id: parseInt($stateParams.filterId) })[0]
      toggleFilter(filter, $stateParams.currentPage)
    } else {
      getAllDistributors()
    }

    /* This function is used to get distributor. It gives all distributors, with active, deactive distributor count. */
    function getAllDistributors() {
      $scope.busy = true
      var queryParams = {
        page: null,
        sort: {},
        filters: {},
        limit: $scope.limit,
        requireDistributorCount: true
      }
      queryParams.page = $scope.uibPage.currentPage || 1
      queryParams.sort[$scope.sort] = $scope.order
      if ($scope.searchText) {
        queryParams.filters.name = {
          internalName: 'name',
          value: ($location.search().searchText && $location.search().searchText !== '' ? $scope.searchText : ''),
          type: 'regex',
          regexOptions: 'i'
        }
      }
      _.assign(queryParams.filters, $scope.filter)

      DistributorService.resource.getAllDistributors(queryParams, function (res) {
        $scope.distributorList = res.data
        $scope.totalItems = res.total
        $scope.distributorCount = res.distributorCount
        $scope.busy = false
      }, function (err) {
        $scope.busy = false
        toastr.error(err.data.msg)
      })
    }

    /* Add distributor button click handler clears existing data and redirects to addDistributor page. */
    $scope.addDistributor = function () {
      $state.go('addDistributor', { tab: 0 })
    }

    /* View distributor details button click handler clears existing data and redirects to distributor details page. */
    $scope.viewDistributorDetails = function (distributor) {
      $state.go('viewDistributor', { distributorId: distributor._id, currentPage: $scope.uibPage.currentPage, sort: $scope.sort, order: $scope.order, searchText: $scope.searchText, filterId: $stateParams.filterId })
    }

    /* Activate and deactivate button click handler asks for confirmation and then activate or deactivate user once confirm. */
    $scope.activateOrDeactivate = function (distributor) {
      var modalInstance = $uibModal.open({
        templateUrl: 'app/components/confirmationDialog/confirmationDialog.html',
        controller: 'UserConfirmationDialogCtrl',
        backdrop: true,
        resolve: {
          items: function () {
            return {
              distributor: distributor
            }
          }
        }
      })

      modalInstance.result.then(function (result) {
        if (result.isActive === true) {
          var distributorData = {
            _id: result._id,
            status: false
          }
        } else {
          distributorData = {
            _id: result._id,
            status: true
          }
        }
        DistributorService.resource.activateOrDeactivate(distributorData, function (res) {
          getAllDistributors()
          if (res.isActive) {
            toastr.success(constants.toastrMessages.success.activateDistributor)
          } else {
            toastr.success(constants.toastrMessages.success.deactivateDistributor)
          }
        }, function (err) {
          toastr.error(err.data.msg)
        })
      }, function () { })
    }

    /* Manage distributor admin click handler */
    $scope.manageDistributorAdmins = function (distributor) {
      var stateParams = $stateParams
      stateParams.distributorId = distributor._id
      $state.go('distributorAdmin', stateParams)
    }

    $scope.addAdmin = function (distributor, adminIfo) {
      !adminIfo ? adminIfo = {} : void 0
      //   $state.go('addCustomerAdmin', { tab: 0 })
      var modalInstance = $uibModal.open({
        templateUrl: 'app/components/distributor/actions/addAdminForm.html',
        controller: 'AdminFormCtrl',
        backdrop: true,
        resolve: {
          adminIfo: adminIfo
        }
      })

      modalInstance.result.then(function (result) {
        result.distributorIds = [distributor._id]
        DistributorService.resource.addDistributorAdmin(result, function (data) {
          toastr.success(constants.toastrMessages.success.addAdminUser)
        }, function (err) {
          if (err && err.data && typeof err.data === 'string') {
            toastr.error(err.data)
          } else {
            toastr.error($scope.webAppTexts.errorMessages.addAdminUser)
          }
          console.log(err)
          $scope.addAdmin(distributor, result)
        })
      }, function () { })
    }
  }
})();
(function () {
  'use strict'
  var angular = window.angular
  angular.module('Vibzer.components.hierarchy')
    .controller('HierarchyCtrl', HierarchyCtrl)

  function HierarchyCtrl($scope, $window, $rootScope, $state, $stateParams, $uibModal, $location, HierarchyService, toastr, constants, RouteCtrlService, hierarchyData) {

    $scope.init = function () {
      _.each($rootScope.user.customer.hierarchyType, function (item, index) {
        if ($rootScope.user.customer.hierarchyType.length === 1) {
          $scope.hierarchyStructure = item.name
          return false
        }
        if (index === 0) {
          $scope.hierarchyStructure = item.name + '/'
        } else if (index === ($rootScope.user.customer.hierarchyType.length - 1)) {
          $scope.hierarchyStructure += item.name
        } else {
          $scope.hierarchyStructure += (item.name + '/')
        }
      })
      $scope.currentLevel = $scope.getLevelByHierarchyId(hierarchyData)
      $scope.levelName = _.find($rootScope.user.customer.hierarchyType, ['level', $scope.currentLevel.level]).name
      $scope.breadCrumbList = $stateParams.navigation ? JSON.parse(decodeURIComponent($stateParams.navigation)) : [{ name: $scope.levelName, level: 1 }]
      $scope.uibPage = {
        currentPage: $stateParams.currentPage ? parseInt($stateParams.currentPage) : 1
      }
      if ($scope.breadCrumbList.length === 1) {
        $scope.selectedItem = undefined
      } else if ($stateParams.hierarchyId && $rootScope.user.customer.hierarchyType.length > 1) {
        $scope.selectedItem = { '_id': $stateParams.hierarchyId }
      } else if ($stateParams.navigation && JSON.parse(decodeURIComponent($stateParams.navigation)).length > 1) {
        // This case is to load controller after delete operation is performed at level 1 or level 2.
        var lastItemInBreadcrumb = JSON.parse(decodeURIComponent($stateParams.navigation))[JSON.parse(decodeURIComponent($stateParams.navigation)).length - 1]
        $scope.selectedItem = { '_id': lastItemInBreadcrumb._id }
      } else {
        $scope.selectedItem = undefined
      }
    }

    $scope.allLevel = $rootScope.user.customer.hierarchyType
    /* To get hierarchical level details of hierarchy by using hierarchyTypeId */
    $scope.getLevelByHierarchyId = function (hierarchyData) {
      if (hierarchyData && hierarchyData.hierarchyTypeId) {
        return _.find($rootScope.user.customer.hierarchyType, ['_id', hierarchyData.hierarchyTypeId])
      }
      return _.find($rootScope.user.customer.hierarchyType, ['level', 1])
    }
    $scope.init()
    $scope.limit = 10

    /* To get sublevel hierarchy list of selected hierarchy level. */
    $scope.getSubLevelData = function () {
      var queryParams = {
        customerId: $scope.user.customerIds[0],
        page: $scope.uibPage.currentPage || 1,
        sort: { 'createdOn': -1 },
        filters: {},
        limit: $scope.limit
      }
      queryParams.sort[$scope.sort] = $scope.order
      if ($scope.searchText) {
        queryParams.filters.name = {
          internalName: 'name',
          value: ($location.search().searchText && $location.search().searchText !== '' ? $scope.searchText : ''),
          type: 'regex',
          regexOptions: 'i'
        }
      }
      if ($scope.selectedItem) {
        $location.search('hierarchyId', $scope.selectedItem._id)
        queryParams.parentId = $scope.selectedItem._id
        $scope.busy = true
        $scope.levelName = _.find($rootScope.user.customer.hierarchyType, ['level', $scope.currentLevel.level]).name
        HierarchyService.resource.getAll(queryParams, function (res) {
          $scope.levelData = []
          $scope.levelData = res.result
          $scope.totalItems = res.totalCount
          $scope.canAdd = res.canAdd
          $scope.canEdit = res.canAdd
          // Following condition is used for if page other than first contains only one hierarchy and if it is deleted
          if ($scope.levelData.length === 0 && res.totalCount > 0) {
            $scope.uibPage.currentPage = $scope.uibPage.currentPage - 1
            $scope.getSubLevelData()
          }
          $scope.busy = false
        }, function (err) {
          toastr.error(err.data.msg)
          $scope.busy = false
        })
      } else {
        $scope.busy = true
        HierarchyService.resource.getAll(queryParams, function (res) {
          $scope.levelData = []
          $scope.levelData = res.result
          $scope.totalItems = res.totalCount
          $scope.busy = false
          $scope.canAdd = res.canAdd
          $scope.canEdit = res.canAdd
          // Following condition is used for if page other than first contains only one hierarchy and if it is deleted
          if ($scope.levelData.length === 0 && res.totalCount > 0) {
            $scope.uibPage.currentPage = $scope.uibPage.currentPage - 1
            $scope.getSubLevelData()
          }
        }, function (err) {
          toastr.error(err.data.msg)
          $scope.busy = false
        })
      }
    }

    /* This block handles breadcrumb click event and navigate to respective hierarchical level. */
    $scope.breadCrumbClick = function (item) {
      if (item._id) {
        $scope.selectedItem = item
        $scope.currentLevel = _.find($scope.allLevel, ['level', item.level])
        $location.search('currentPage', $scope.uibPage.currentPage)
        $scope.breadCrumbList = _.filter($scope.breadCrumbList, function (breadCrumb) {
          if (breadCrumb.level <= item.level) {
            return breadCrumb
          }
        })
      } else {
        $scope.selectedItem = undefined
        $location.url($location.path())
        $scope.currentLevel = _.find($scope.allLevel, ['level', 1])
        $scope.levelName = _.find($rootScope.user.customer.hierarchyType, ['level', $scope.currentLevel.level]).name
        $scope.breadCrumbList = [{ name: $scope.levelName, level: 1 }]
      }
      $location.search('navigation', encodeURIComponent(JSON.stringify($scope.breadCrumbList)))
      $scope.uibPage.currentPage = 1
      $scope.getSubLevelData()
    }

    /* This block updates currentLevel, breadCrumbList and call to 'getSubLevelData' method to get children. */
    $scope.checkLevel = function (levelData) {
      $scope.uibPage.currentPage = 1
      $scope.currentLevel = $scope.getLevelByHierarchyId(levelData)
      $scope.currentLevel = _.find($rootScope.user.customer.hierarchyType, ['level', ($scope.currentLevel.level + 1)])
      $scope.breadCrumbList.push({ name: levelData.name, _id: levelData._id, level: $scope.currentLevel.level })
      $location.search('navigation', encodeURIComponent(JSON.stringify($scope.breadCrumbList)))
      $scope.getSubLevelData()
    }

    /* It redirects to add or view form depending on user action. */
    $scope.addOrViewHierarchy = function (operation, hierarchy) {
      if (hierarchy) {
        $scope.selectedItem = hierarchy
      }
      if (operation === 'add') {
        $state.go('addHierarchy', { hierarchyId: $scope.selectedItem ? $scope.selectedItem['_id'] : null, navigation: encodeURIComponent(JSON.stringify($scope.breadCrumbList)), page: $scope.uibPage.currentPage, sort: $scope.sort, order: $scope.order, tab: 0 })
      } else if (operation === 'view') {
        $state.go('viewHierarchy', { hierarchyId: $scope.selectedItem['_id'], page: $scope.uibPage.currentPage, navigation: encodeURIComponent(JSON.stringify($scope.breadCrumbList)), parentHierarchyId: $stateParams.hierarchyId, sort: $scope.sort, order: $scope.order, tab: 0, canEdit: $scope.canEdit })
      }
    }

    /*
      This function invokes after page or sort or order changes and sets
      currentPage in URL and calls getSubLevelData() to get get hierarchy list.
    */
    $scope.pageChanged = function (currentPage) {
      $location.search('currentPage', $scope.uibPage.currentPage)
      $scope.getSubLevelData()
    }

    /* View hierarchy details function to redirect to sub-hierarchy list or view hierarchy details depending on level. */
    $scope.viewHierarchyDetails = function (hierarchyDetails) {
      var hierarchyLevel = $scope.getLevelByHierarchyId(hierarchyDetails)
      if (hierarchyLevel.level !== $scope.allLevel.length) {
        $scope.selectedItem = hierarchyDetails
        $scope.checkLevel(hierarchyDetails)
      }
    }

    /*
      Handles browser back button event.
    */
    window.onhashchange = function (event) {
      if (!window.innerDocClick && $state.current.name === 'hierarchy') {
        $scope.init()
        $scope.getSubLevelData()
        $scope.$apply()
      }
    }
    $scope.currentLevel = _.find($rootScope.user.customer.hierarchyType, {'level': $scope.breadCrumbList[$scope.breadCrumbList.length - 1].level})
    $scope.getSubLevelData()
  }
})();

(function () {
  'use strict'
  var angular = window.angular
  var _ = window._
  angular.module('Vibzer.components')
    .controller('LoginCtrl', loginCtrl)

  // @NgInject
  function loginCtrl ($scope, $rootScope, $state, $cookies, toastr, constants, UserService, PermissionService, vcRecaptchaService) {
    $rootScope.user = {}
    $scope = UserService.recaptchaInit($scope)
    if (window.localStorage.toastr) {
      var toastrData = JSON.parse(window.localStorage.toastr)
      if (toastrData && toastrData.type) {
        toastr[toastrData.type](toastrData.msg)
        delete window.localStorage.toastr
      }
    }
    $scope.user = {}
    $scope.wrongPassword = false
    $scope.isForgetPassword = false
    $scope.forgotPasswordError = null
    $scope.reqSend = false

    /* Login user if valid username and password is entered otherwise display error block. If user is logging for first time then redirect to change password page. Set cookies after successful user log in. */
    $scope.login = function () {
      $scope.loginError = null
      $scope.wrongPassword = false
      if ($scope.reqSend) {
        return
      }
      $scope.reqSend = true
      UserService.resource.login($scope.user, function (res) {
        $scope.reqSend = false
        if (!res.token && res.user.status === 'active') {
          $rootScope.user = res.user
          redirect($rootScope.$stateParams, res)
        } else {
          $cookies.put('authToken', res.token)
          if (res.user.customerIds && res.user.customerIds.length && res.user.distributorIds && res.user.distributorIds.length) {
            res.user.tempCache = {
              customerIds: angular.copy(res.user.customerIds),
              customer: angular.copy(res.user.customer),
              distributorIds: angular.copy(res.user.distributorIds),
              distributor: angular.copy(res.user.distributor),
              loggedInAs: 'distributor'
            }
            delete res.user.customerIds
            delete res.user.customerName
            delete res.user.customer
            delete res.user.customerName
          }
          PermissionService.resource.hasPermission({ permissions: ['addCustomer', 'addUser'], permissionCheck: 'any' }, function (result) {
            if (result && result.hasPermission) {
              if (res.user && res.user.status !== 'active') {
                $scope.wrongPassword = true
                toastr.error(constants.toastrMessages.invalid.access)
                $state.go('login')
              } else {
                $rootScope.user = res.user
                redirect($rootScope.$stateParams, res)
              }
            } else {
              UserService.logout()
              toastr.error(constants.toastrMessages.invalid.access)
              $state.go('login')
            }
          })
        }
      }, function (err) {
        $scope.reqSend = false
        $scope.wrongPassword = true
        if (err.data && err.data.status === 'deactive') {
          toastr.error(constants.toastrMessages.invalid.access)
          $state.go('login')
        } else {
          $scope.loginError = err.data.msg
        }
      })
    }

    /* After successful loggging of user redirect to default state or change passsword or unauthroizedCustomer state depends on condition. */
    function redirect (stateParams, res) {
      if (!$rootScope.user.activeCustomer && !$rootScope.user.activeDistributor) {
        $state.go('unauthorizedCustomer')
      } else {
        $rootScope.authToken = res.token
        $rootScope.customerName = res.user.customerName
        $cookies.put('userId', res.user._id)
        $cookies.put('authToken', res.token)
        $cookies.putObject('vcUser', _.omit(res.user, ['created', 'modified', 'registrationIds']))
        $cookies.put('customerName', res.user.customerName)
        $cookies.put('environment', res.user.environment)
        UserService.resource.getAppConfig().$promise.then(function (config) {
          try {
              window.localStorage.setItem('appConfig', JSON.stringify(config))
          } catch (e) {}
        })
        if ($rootScope.user.isPasswordGenerated) {
          $state.go('changePassword', { _id: $rootScope.user._id })
        } else if (window.localStorage.savedUrl) {
          var url = window.localStorage.savedUrl
          delete window.localStorage.savedUrl
          // window.location.href(url)
          window.open(url, '_self')
        } else if ($rootScope.user && $rootScope.user.customerIds && $rootScope.user.customerIds.length) {
          $rootScope.$broadcast('getNotifications')
          $rootScope.user.permission = {}
          $cookies.putObject('vcUser', _.omit($rootScope.user, ['created', 'modified', 'registrationIds']))
          $rootScope.$broadcast('showOrHideSidebarMenu')
          if ($rootScope.user.customer && !$rootScope.user.customer.hierarchyType.length) {
            UserService.resource.getAllPermissionsOfUser({ _id: $rootScope.user._id }, function (res) {
              var companyLevelAdmin = false
              _.each(res.result, function (item) {
                var companyType = _.find(item.resources, { type: 'company' })
                if (companyType) {
                  var hasPermissions = _.find(item.permissionIds, { name: 'updateCustomer' })
                  if (hasPermissions) {
                    companyLevelAdmin = true
                  }
                }
              })
              if (companyLevelAdmin) {
                $state.go('addHierarchyLevel')
              } else {
                toastr.error(constants.toastrMessages.invalid.superAdmin)
                UserService.logout()
                $state.go('login')
              }
            }, function (err) {
              toastr.error(err.data.msg)
            })
          } else {
            $rootScope.$broadcast('getNotifications')
            var permissionToCheck = ['addUser', 'canViewMachines', 'addMachine', 'editMachine', 'canViewOwnedMachines', 'viewRoutes', 'addRoute', 'editRoute', 'deleteRoute', 'viewComposites', 'addComposite', 'analyzeMachine']
            UserService.resource.getAllPermissionsOfUser({ _id: $rootScope.user._id, permission: 'addDistributorUser' }, function (res) {
              $rootScope.user.permission = {}
              var permissions = []
              if (res.result && res.result.length > 0) {
                _.each(res.result, function (item) {
                  permissions = _.concat(permissions, item.permissionIds)
                })
                permissions = _.uniqBy(permissions, '_id')
              }
              _.each(permissions, function (item) {
                if (_.includes(permissionToCheck, item.name)) {
                  $rootScope.user.permission[item.name] = true
                }
              })
              $cookies.putObject('vcUser', _.omit($rootScope.user, ['created', 'modified', 'registrationIds']))
              $rootScope.$broadcast('showOrHideSidebarMenu')
              var toState = (stateParams && stateParams.toState && stateParams.toState.name) ? stateParams.toState.name : 'dashboard'
              $state.go(toState)
            }, function (err) {
              toastr.error(err.data.msg)
            })

            // var toState = (stateParams && stateParams.toState && stateParams.toState.name) || (_.isEmpty($rootScope.user.distributorIds) ? 'machines' : 'customers')
            // $state.go(toState)
          }
        } else {
          $rootScope.$broadcast('getNotifications')
          permissionToCheck = ['addDistributorUser', 'addCustomer']
          UserService.resource.getAllPermissionsOfUser({ _id: $rootScope.user._id }, function (res) {
            $rootScope.user.permission = {}
            var permissions = []
            if (res.result && res.result.length > 0) {
              _.each(res.result, function (item) {
                permissions = _.concat(permissions, item.permissionIds)
              })
              permissions = _.uniqBy(permissions, '_id')
            }
            _.each(permissions, function (item) {
              if (_.includes(permissionToCheck, item.name)) {
                $rootScope.user.permission[item.name] = true
              }
            })
            $cookies.putObject('vcUser', _.omit($rootScope.user, ['created', 'modified', 'registrationIds']))
            $rootScope.$broadcast('showOrHideSidebarMenu')
            var toState = (stateParams && stateParams.toState && stateParams.toState.name) ? stateParams.toState.name : 'dashboard'
            $state.go(toState)
          }, function (err) {
            toastr.error(err.data.msg)
          })
        }
      }
    }

    /* Forget password button click handler used to hide Log in UI and show forget password UI. */
    $scope.forgotPassword = function () {
      $scope.loginError = null
      $scope.user.username = null
      $scope.isForgetPassword = true
    }

    /* Reset password button click handler used to send reset password mail to user. */
    $scope.resetPassword = function () {
      $scope.forgotPasswordError = null
      $scope.user.response = $scope.response
      $scope.user.resetByAdmin = true
      UserService.resource.resetPassword($scope.user, function (res) {
        if (res.generatedPassword) {
          toastr.success(constants.toastrMessages.success.resetPassword)
          $scope.cancel()
        }
      }, function (err) {
        $scope.forgotPasswordError = err.data.msg
        vcRecaptchaService.reload($scope.widgetId)
        if (err.data.msg === 'Invalid username') {
          toastr.pop({ type: 'warning', title: constants.toastrMsg.invalid.username, showCloseButton: true })
        }
        $scope.resetPasswordError = constants.failToResetPassword
      })
    }

    /* Canncel button click handler */
    $scope.cancel = function () {
      $scope.user.username = null
      $scope.user.password = null
      $scope.isForgetPassword = false
      $scope.forgotPasswordError = null
    }
  }
})();
(function () {
  'use strict';
  var angular = window.angular
  var _ = window._
  var $ = window.$
  angular.module('Vibzer.components.machines')
    .controller('MachinesCtrl', MachinesCtrl);

  /*
    Handles machines list page.
  */
  /** @ngInject */
  function MachinesCtrl ($scope, $cookies, $state, $location, $stateParams, $uibModal, MachineService, MachineTypeService, HierarchyService, PermissionService, UtilService, constants, data) {
    $scope.webAppTexts = constants.webAppTexts
    $scope.breadCrumbList = [$scope.webAppTexts.breadcrumbs.machineList]
    $scope.dateFormat = constants.dateFormats.default
    $scope.user = $cookies.getObject('vcUser')
    $scope.showFilter = false
    $scope.machineConditions = _.cloneDeep(_.filter(angular.copy(constants.machineStates), function (cd) { return cd.id }))
    $scope.selectedMachineTypes = []
    $scope.selectedMachineConditions = []
    $scope.canAdd = true
    $scope.limit = 10
    $scope.uibPage = {
      currentPage: 1
    }

    // for machines from specific route
    if ($stateParams.routeId && data) {
      $scope.forRoute = true
      $scope.canAdd = false
      $scope.breadCrumbList = [$scope.webAppTexts.breadcrumbs.routeList, data.name]
    }

    // for machines from specific route
    if ($stateParams.compositeId && data) {
      $scope.forComposite = true
      $scope.canAdd = false
      $scope.breadCrumbList = [$scope.webAppTexts.breadcrumbs.compositeMachineList, data.name]
    }

    /* This block maintains breadcrumb after redirectiong to other states. */
    if ($stateParams.machineData && JSON.parse($stateParams.machineData).filter.condition) {
      $scope.selectedMachineConditions = JSON.parse($stateParams.machineData).filter.condition
      _.each($scope.machineConditions, function (item) {
        item['selected'] = _.includes($scope.selectedMachineConditions, item['id'])
      })
    }
    if ($stateParams.machineData && JSON.parse($stateParams.machineData).filter.showFilter) {
      $scope.showFilter = true
    }
    $scope.uibPage.currentPage = $stateParams.currentPage ? $stateParams.currentPage : $stateParams.machineData ? JSON.parse($stateParams.machineData).page : 1
    $scope.sort = $stateParams.machineData && JSON.parse($stateParams.machineData).sort.name ? JSON.parse($stateParams.machineData).sort.name : 'createdOn'
    $scope.order = $stateParams.machineData && JSON.parse($stateParams.machineData).sort.order ? JSON.parse($stateParams.machineData).sort.order : -1
    $scope.searchText = $stateParams.searchText || ''

    $scope.sortBy = angular.copy(constants.sortBy)
    $scope.orderBy = angular.copy(constants.orderBy)

    $scope.sortBy.selected = _.find($scope.sortBy, { internalName: $scope.sort }).id
    $scope.orderBy.selected = _.find($scope.orderBy, { internalName: $scope.order }).id
    $scope.machineData = $stateParams.machineData ? JSON.parse($stateParams.machineData) : {
      page: 1,
      filter: {},
      sort: {}
    }

    /*
       This function is used to get all machine types. If stateParams
       contains machine type then push it in selectedMachineTypes and update machie list.
    */
    MachineTypeService.resource.getAllMachineTypes({}, function (res) {
      $scope.allMachineTypes = res.result
      if ($stateParams.machineData && JSON.parse($stateParams.machineData).filter.type) {
        $scope.selectedMachineTypes = JSON.parse($stateParams.machineData).filter.type
        _.each($scope.allMachineTypes, function (item) {
          item['selected'] = _.includes($scope.selectedMachineTypes, item['_id'])
        })
        getAllMachines()
      }
    })

    /* Handles filter visibility. Hide filter by default. */
    $(document).ready(function () {
      $('[data-toggle=offcanvas]').click(function () {
        if (_.includes($('.row-offcanvas')[0].classList, 'active')) {
          $scope.showFilter = true
        } else {
          $scope.showFilter = false
        }
        if ($scope.machineData.filter) {
          $scope.machineData.filter.showFilter = $scope.showFilter
        }
        $scope.$apply()
      })
    })

    /* This function is used to handle sorting. It invokes after changing
       sort or order and updates stateParams and calls pageChanged() to get updated machine list.
    */
    $scope.setSorting = function (type, sort) {
      if (type === 'sort') {
        $scope.sort = _.find($scope.sortBy, { id: sort }).internalName
        $scope.machineData.sort.name = $scope.sort
        $location.search('machineData', JSON.stringify($scope.machineData))
      } else {
        $scope.order = _.find($scope.orderBy, { id: sort }).internalName
        $scope.machineData.sort.order = $scope.order
        $location.search('machineData', JSON.stringify($scope.machineData))
      }
      $scope.uibPage.currentPage = 1
      $scope.pageChanged(1)
    }

    /* This function invokes after page or sort or order changes and sets
       currentPage in URL and calls getAllMachines() to get updated machine list.
    */
    $scope.pageChanged = function (currentPage) {
      $scope.machineData.page = $scope.uibPage.currentPage
      $location.search('currentPage', $scope.uibPage.currentPage)
      getAllMachines()
    }

    /* Search machines in machine list. */
    $scope.searchMachine = function (searchText) {
      $scope.uibPage.currentPage = 1
      $location.search('currentPage', $scope.uibPage.currentPage)
      $scope.searchText = searchText
      $location.search('searchText', searchText)
      getAllMachines()
    }

    /* Filter machines by hierarchy item control */
    $scope.selected = {}
    $scope.hierarchyLength = $scope.user.customer.hierarchyType.length
    $scope.topLevelLabel = $scope.user.customer.hierarchyType[0].name
    $scope.topLevelPlaceholder = UtilService.generateMsg($scope.webAppTexts.placeholder.selectLevel, { level: $scope.topLevelLabel.toLowerCase() })
    $scope.middleLevelLabel = $scope.user.customer.hierarchyType[1] ? $scope.user.customer.hierarchyType[1].name : null
    $scope.middleLevelPlaceholder = $scope.middleLevelLabel ? UtilService.generateMsg($scope.webAppTexts.placeholder.selectLevel, { level: $scope.middleLevelLabel.toLowerCase() }) : null
    $scope.lowerLevelLabel = $scope.user.customer.hierarchyType[2] ? $scope.user.customer.hierarchyType[2].name : null
    $scope.lowerLevelPlaceholder = $scope.lowerLevelLabel ? UtilService.generateMsg($scope.webAppTexts.placeholder.selectLevel, { level: $scope.lowerLevelLabel.toLowerCase() }) : null

    // get hierarchical item list
    $scope.getResourceList = function (level, parentId, stateParams) {
      var queryParams = {
        customerId: $scope.user.customerIds[0]
      }
      if (parentId) {
        queryParams.parentId = parentId
      }
      HierarchyService.resource.getAll(queryParams, function (res) {
        if (level === 'middleLevel') {
          $scope.selected.middleLevel = null
          $scope.lowerLevelList = []
          $scope.selected.lowerLevel = null
        }
        if (level === 'lowerLevel') {
          $scope.selected.lowerLevel = null
        }
        $scope[level + 'List'] = res.result
        if (stateParams) {
          var selectedLevels = JSON.parse($stateParams.machineData).filter.selectedLevels
          $scope.selected[level] = _.find($scope[level + 'List'], { _id: selectedLevels[level] })
        } else if (res.result.length === 1) {
          $scope.selected[level] = res.result[0]
        }
        if (level === 'topLevel') {
          if ($scope.hierarchyLength >= 2 && $scope.selected.topLevel) {
            $scope.getResourceList('middleLevel', $scope.selected.topLevel._id, stateParams)
          }
        } else if (level === 'middleLevel') {
          if ($scope.hierarchyLength === 3 && $scope.selected.middleLevel) {
            $scope.getResourceList('lowerLevel', $scope.selected.middleLevel._id, stateParams)
          }
        }
        if (stateParams) {
          getAllMachines()
        }
      })
    }
    if ($stateParams.machineData) {
      var machineData = JSON.parse($stateParams.machineData)
      if (machineData.filter.selectedLevels) {
        $scope.getResourceList('topLevel', null, true)
      }
    } else {
      $scope.getResourceList('topLevel', null)
    }

    getAllMachines()

    /* This function is used to get machines. It gives all machines with total count. */
    function getAllMachines () {
      $scope.busy = true
      var queryParams = {
        customerId: $scope.user.customerIds[0],
        page: null,
        sort: {},
        filters: {},
        limit: $scope.limit
      }
      queryParams.page = $scope.uibPage.currentPage || 1
      queryParams.sort[$scope.sort] = $scope.order
      if ($scope.selectedMachineTypes.length) {
        queryParams.types = $scope.selectedMachineTypes
      }
      if ($scope.selectedMachineConditions.length) {
        queryParams.conditions = $scope.selectedMachineConditions
      }
      if ($scope.searchText) {
        queryParams.filters.name = {
          internalName: 'name',
          value: ($location.search().searchText && $location.search().searchText !== '' ? $scope.searchText : ''),
          type: 'regex',
          regexOptions: 'i'
        }
      }
      if ($scope.topLevelList && $scope.topLevelList.length) {
        queryParams.resourceId = $scope.selected.lowerLevel ? $scope.selected.lowerLevel._id : $scope.selected.middleLevel ? $scope.selected.middleLevel._id : $scope.selected.topLevel ? $scope.selected.topLevel._id : null
      }
      if ($stateParams.routeId) {
        queryParams.routeId = $stateParams.routeId
        queryParams.sort = null
      }
      if ($stateParams.compositeId) {
        queryParams.compositeId = $stateParams.compositeId
      }
      _.assign(queryParams.filters, $scope.filter)

      MachineService.resource.getAllMachines(queryParams, function (res) {
        $scope.machines = _.map(res.result, function (machine) {
          machine.icon = _.find(constants.typesOfMachine, { name: machine.machineType.name }).icon
          if (machine.monitoredOnline) {
            $scope.isFixedMachine = true
            machine.state = machine.state ? machine.state.displayName : null
          }
          if (machine.condition || machine.condition === 0) {
            machine.vibrationInfo = _.assign(machine.vibrationInfo, _.find(constants.machineStates, { id: machine.condition }))
            machine.lastReadingType = _.find(constants.readingTypes, { id: machine.lastReadingType })
          } else {
            machine.vibrationInfo.color = '#00000'
          }
          return machine
        })
        $scope.totalItems = res.totalCount
        $scope.busy = false
        $scope.$$postDigest(function () {
          window.scrollTo(0, 0)
        })
      }, function (err) {
        $scope.busy = false
      })
    }

    /* This function is used to get filtered machines after filtering by type or condition or both. */
    $scope.getFilterMachines = function (reset) {
      if (reset) {
        _.each($scope.allMachineTypes, function (itm) { itm.selected = false })
        _.each($scope.machineConditions, function (itm) { itm.selected = false })
        $scope.selected = {}
        $scope.hideFilter()
        $scope.selectedMachineTypes = []
        $scope.selectedMachineConditions = []
        $scope.machineData.filter = {}
      } else {
        $scope.machineData.filter = {
          type: $scope.selectedMachineTypes,
          condition: $scope.selectedMachineConditions,
          showFilter: true,
          selectedLevels: {
            topLevel: $scope.selected.topLevel ? $scope.selected.topLevel._id : null,
            middleLevel: $scope.selected.middleLevel ? $scope.selected.middleLevel._id : null,
            lowerLevel: $scope.selected.lowerLevel ? $scope.selected.lowerLevel._id : null
          }
        }
        $scope.uibPage.currentPage = 1
      }
      $location.search('machineData', JSON.stringify($scope.machineData))
      $scope.pageChanged(1)
    }

    /* This function is used to get selected machine types for filtering machines by type. */
    $scope.getMachineType = function (type) {
      if (type.selected && _.indexOf($scope.selectedMachineTypes, type.id) < 0) {
        $scope.selectedMachineTypes.push(type._id)
      } else {
        _.pull($scope.selectedMachineTypes, type._id)
      }
    }

    /* This function is used to get selected machine conditions for filtering machines by condition. */
    $scope.getMachineCondition = function (condition) {
      if (condition.selected && _.indexOf($scope.selectedMachineConditions, condition.id) < 0) {
        $scope.selectedMachineConditions.push(condition.id)
      } else {
        _.pull($scope.selectedMachineConditions, condition.id)
      }
    }

    /* This functions hides filter */
    $scope.hideFilter = function () {
      $scope.showFilter = false
      $scope.machineData.filter.showFilter = false
    }

    /* If more than two devices are attached to machine then show dialog for displaying all devices.
    */
    $scope.showAllDevices = function (machine) {
      var modalInstance = $uibModal.open({
        templateUrl: 'app/components/machines/modals/allDevicesDialog.html',
        controller: 'AllDevicesCtrl',
        resolve: {
          machineData: machine
        },
        size: 'sm'
      })

      modalInstance.result.then(function (result) {
      }, function () { })
    }

    /* Disable filter button until machine type or condition is not selected. */
    $scope.showFilterVisibility = function () {
      return !($scope.selectedMachineTypes.length || $scope.selectedMachineConditions.length || $scope.selected.topLevel || $scope.selected.middleLevel || $scope.selected.lowerLevel)
    }

    /* Alert button click handler redirects to alerts page. */
    $scope.showAlerts = function (machine) {
      if ($scope.forRoute) { // if machines from route
        $state.go('alertsFromRoute', { routeId: $stateParams.routeId, machineId: machine._id, machineData: JSON.stringify($scope.machineData), routeFilters: $stateParams.routeFilters })
      } else if ($scope.forComposite) { // if machines from composite
        $state.go('alertsFromComposite', { compositeId: $stateParams.compositeId, machineId: machine._id, machineData: JSON.stringify($scope.machineData), compositeData: $stateParams.compositeData })
      } else {
        $state.go('alerts', { machineId: machine._id, machineData: JSON.stringify($scope.machineData) })
      }
    }

    /* Sessions button click handler redirects to sessions page. */
    $scope.showSessions = function (machine) {
      if ($scope.forRoute) { // if machines from route
        $state.go('sessionsFromRoute', { customerId: $scope.user.customerIds[0], routeId: $stateParams.routeId, machineId: machine._id, machineData: JSON.stringify($scope.machineData), routeFilters: $stateParams.routeFilters })
      } else if ($scope.forComposite) { // if machines from composite
        $state.go('sessionsFromComposite', { customerId: $scope.user.customerIds[0], compositeId: $stateParams.compositeId, machineId: machine._id, machineData: JSON.stringify($scope.machineData), compositeData: $stateParams.compositeData })
      } else {
        $state.go('sessions', { customerId: $scope.user.customerIds[0], machineId: machine._id, machineData: JSON.stringify($scope.machineData) })
      }
    }

    /* Trends button click handler redirects to trends page. */
    $scope.showTrends = function (machine) {
      $state.go('trends', { mId: machine._id, machineData: JSON.stringify($scope.machineData) })
    }

    /* View machine details button click handler redirects to view machine details page. */
    $scope.viewMachineDetails = function (machine) {
      if ($scope.forRoute) { // if machines from route
        $state.go('viewMachineFromRoute', { routeId: $stateParams.routeId, machineId: machine._id, machineData: JSON.stringify($scope.machineData), routeFilters: $stateParams.routeFilters })
      } else if ($stateParams.compositeId) {
        $state.go('viewMachineFromComposite', { compositeId: $stateParams.compositeId, machineId: machine._id, machineData: JSON.stringify($scope.machineData), compositeData: $stateParams.compositeData })
      } else {
        $state.go('viewMachine', { machineId: machine._id, machineData: JSON.stringify($scope.machineData) })
      }
    }

    /* Add machine button click handler redirects to add machine page. */
    $scope.addMachine = function () {
      $state.go('addMachine')
    }

    /* Breadcrumb click handler redirects to routes page */
    $scope.breadCrumbClickHandler = function (state) {
      if (state === 'Routes') {
        $state.go('routes', { routeFilters: $stateParams.routeFilters })
      } else {
        $state.go('compositeMachines', { compositeData: $stateParams.compositeData })
      }
    }

    /* Navigate to show trends for monitored machine. */
    $scope.showTrendsForMonitoredMachine = function (machine) {
      if ($scope.forRoute) { // if machines from route
        $state.go('monitoredMachineTrendFromRoute', { routeId: $stateParams.routeId, machineId: machine._id, machineData: JSON.stringify($scope.machineData), routeFilters: $stateParams.routeFilters })
      } else if ($scope.forComposite) { // if machines from composite
        $state.go('monitoredMachineTrendFromComposite', { compositeId: $stateParams.compositeId, machineId: machine._id, machineData: JSON.stringify($scope.machineData), compositeData: $stateParams.compositeData })
      } else {
        $state.go('monitoredMachineTrend', { machineId: machine._id, machineData: JSON.stringify($scope.machineData) })
      }
    }

    /* Navigate to show trends for un-monitored machine. */
    $scope.showTrendsForNonMonitoredMachine = function (machine) {
      if ($scope.forRoute) { // if machines from route
        $state.go('conditionWiseTrendFromRoute', { routeId: $stateParams.routeId, machineId: machine._id, machineData: JSON.stringify($scope.machineData), routeFilters: $stateParams.routeFilters })
      } else if ($scope.forComposite) { // if machines from composite
        $state.go('conditionWiseTrendFromComposite', { compositeId: $stateParams.compositeId, machineId: machine._id, machineData: JSON.stringify($scope.machineData), compositeData: $stateParams.compositeData })
      } else {
        $state.go('conditionWiseTrend', { mId: machine._id, machineData: JSON.stringify($scope.machineData) })
      }
    }
  }
})();

(function () {
  'use strict'
  var angular = window.angular
  angular.module('Vibzer.components.organization')
    .controller('OrganizationCtrl', OrganizationCtrl)

  function OrganizationCtrl ($scope, $rootScope, $cookies, $uibModal, HierarchyService, toastr, constants, $timeout, RoleService, PermissionService, UtilService, CustomerService, DistributorService, UserService) {
    $scope.webAppTexts = constants.webAppTexts
    $scope.user = $cookies.getObject('vcUser')
    $scope.ignoreChanges = false;
    $scope.tree = {};
    $scope.hierarchy = {};
    $scope.hierarchy.meta = {};
    $scope.currentAddress = {};
    $scope.languages = ['English', 'Spanish']
    $scope.lineFreq = [{ label: '50 Hz', value: 50 }, { label: '60 Hz', value: 60 }, { label: 'Other', value: -1 }]
    $scope.tree.treeInstance = {};
    $scope.isDisabledAdd = true;
    $scope.isDisabledEdit = true;
    $scope.selectedItem = undefined;
    $scope.selectedState = {
      isDisabledEdit: true,
      isDisabledAdd: true
    };
    $scope.selected = {}
    $scope.allLevel = $rootScope.user.customer.hierarchyType;
    $scope.isPlantLevel = $scope.allLevel.length == 1 ? true : false;
    $scope.isAreaLevel = ($scope.allLevel.length == 3 || $scope.allLevel.length == 2) ? true : false;
    $scope.isSectionLevel = $scope.allLevel.length == 3 ? true : false;
    $scope.basicConfig = {
      core: {
        multiple: false,
        animation: true,
        check_callback: true,
        worker: false
      },
      'types': {
        'organization': {
          'icon': 'fa fa-sitemap'
        },
        'plant': {
          'icon': 'icon-plant'
        },
        'area': {
          'icon': 'icon-area'
        },
        'section': {
          'icon': 'icon-area'
        }
      },
      'plugins': ['types', 'themes', 'ui'],
      'version': 1
    };
    $scope.treeData = [];

    $scope.init = function () {
      // get updated information of customer and store it in cookies
      CustomerService.resource.getById({_id: $scope.user.customer._id}, function(res) {
        var user = $scope.user
        user.customer = _.assign($scope.user.customer, _.assign($scope.user.customer, _.pick(res, ['_id', 'name', 'hierarchyType', 'name', 'address'])))
        $scope.user.tempCache ? user.tempCache.customer = _.assign($scope.user.tempCache.customer, _.assign($scope.user.tempCache.customer, _.pick(res, ['_id', 'name', 'hierarchyType', 'name', 'address']))) : void 0
        $rootScope.user.customer = angular.copy(user.customer)
        $cookies.putObject('vcUser', user)

        _.each($rootScope.user.customer.hierarchyType, function (item, index) {
          if ($rootScope.user.customer.hierarchyType.length === 1) {
            $scope.hierarchyStructure = item.name
            return false
          }
          if (index === 0) {
            $scope.hierarchyStructure = item.name + '/'
          } else if (index === ($rootScope.user.customer.hierarchyType.length - 1)) {
            $scope.hierarchyStructure += item.name
          } else {
            $scope.hierarchyStructure += (item.name + '/')
          }
        });
        var queryParams = {
          userId: $scope.user._id,
          customerId: $scope.user.customerIds[0]
        }
        RoleService.resource.getTopLevelRoleOfUser(queryParams, function (res) {
          var topLevelRoleOfUser = res
          $scope.isCompanyLevelUser = topLevelRoleOfUser.type === constants.resourceTypes[0].internalName
          if ($scope.isCompanyLevelUser) {
            $scope.isAddPlantPermission = true;
            $scope.isAddAreaPermission = $scope.isAreaLevel;
            $scope.isAddSectionPermission = $scope.isSectionLevel;
            getDefaultData();
          } else {
            $scope.isAddPlantPermission = false;
            getDefaultData();
          }
        })
      })
    }

    $scope.init()

    function getDefaultData() {
      $scope.treeData.push({
        id: $scope.user.customerIds[0],
        parent: '#',
        type: 'organization',
        text: $scope.user.customerName,
        state: {
          opened: true,
          selected: false,
          isDisabledEdit: true,
          isDisabledAdd: !$scope.isAddPlantPermission,
          nextLevel: $scope.allLevel[0]
        }
      });
      var queryParams = {
        customerId: $scope.user.customerIds[0],
        page: 1,
        sort: { 'createdOn': -1 },
        filters: {},
        limit: 2999
      }
      HierarchyService.resource.getAll(queryParams, function (res) {
        if (res.result && res.result.length) {
          _.forEach(res.result, function (item) {
            mapTreeData($scope.user.customerIds[0], item, 'plant', !$scope.isAddAreaPermission, !res.canEdit, $scope.allLevel[0], $scope.isAreaLevel ? $scope.allLevel[1] : null);
            if ($scope.isAreaLevel) {
              var areaLevelQueryParams = {
                customerId: $scope.user.customerIds[0],
                page: 1,
                sort: { 'createdOn': -1 },
                filters: {},
                limit: 2999,
                parentId: item._id
              }
              HierarchyService.resource.getAll(areaLevelQueryParams, function (areaLevelResponse) {
                if (areaLevelResponse.result && areaLevelResponse.result.length) {
                  _.forEach(areaLevelResponse.result, function (areaLevelItem) {
                    mapTreeData(item._id, areaLevelItem, 'area', !$scope.isAddSectionPermission, !areaLevelResponse.canEdit, $scope.allLevel[1], $scope.isSectionLevel ? $scope.allLevel[2] : null)
                    if ($scope.isSectionLevel) {
                      var sectionQueryParams = {
                        customerId: $scope.user.customerIds[0],
                        page: 1,
                        sort: { 'createdOn': -1 },
                        filters: {},
                        limit: 2999,
                        parentId: areaLevelItem._id
                      }
                      HierarchyService.resource.getAll(sectionQueryParams, function (sectionLevelResponse) {
                        if (sectionLevelResponse.result && sectionLevelResponse.result.length) {
                          $scope.showTree = true;
                          _.forEach(sectionLevelResponse.result, function (sectionLevelItem) {
                            mapTreeData(areaLevelItem._id, sectionLevelItem, 'section', true, !sectionLevelResponse.canEdit, $scope.allLevel[2])
                            $scope.showTree = true;
                          })
                        } else
                          $scope.showTree = true;
                      })
                    } else
                      $scope.showTree = true;
                  })
                } else
                  $scope.showTree = true;
              })
            } else
              $scope.showTree = true;
          })
        } else
          $scope.showTree = true;
      });
    }

    function mapTreeData(parentId, item, levelIcon, isDisabledAdd, isDisabledEdit, currentLevel, nextLevel) {
      $scope.treeData.push({
        id: item._id,
        parent: parentId,
        type: levelIcon,
        text: item.name,
        state: {
          opened: true,
          isDisabledEdit: isDisabledEdit,
          isDisabledAdd: isDisabledAdd,
          currentLevel: currentLevel,
          nextLevel: nextLevel
        }
      });
    }

    $scope.readyCB = function () {
      $timeout(function () {
        $scope.ignoreChanges = false;
      });
    };

    $scope.selectNode = function () {
      $scope.organizationTree = this.organizationTree
      if ($scope.isOrganizationAdded) {
        $scope.selectedItem = $scope.treeData[0];
        $scope.isOrganizationAdded = false
      } else
        $scope.selectedItem = this.organizationTree.jstree(true)._model.data[this.organizationTree.jstree(true).get_selected()[0]]
      $scope.isAddForm = false;
      $scope.isEditForm = false;
      $scope.hierarchy = {};
      $scope.selectedState = $scope.selectedItem.state;
      $scope.currentLevel = $scope.selectedState.currentLevel ? _.find($scope.allLevel, { level: $scope.selectedState.currentLevel.level }) : {};
      $scope.nextLevel = $scope.selectedState.nextLevel ? _.find($scope.allLevel, { level: $scope.selectedState.nextLevel.level }) : {};
      var resourceIds = _.filter(_.cloneDeep($scope.selectedItem.parents), function (item) {
        return item !== '#';
      });
      resourceIds.push($scope.selectedItem.id);
      if (!$scope.isCompanyLevelUser) {
        var permissionParamsForSection = {
          userId: $scope.user._id,
          permissions: ['addHierarchy'],
          resourceType: constants.resourceTypes[1].internalName,
          resourceIds: resourceIds,
          resourceCheck: 'any'
        }
        PermissionService.resource.hasPermission(permissionParamsForSection, function (permissionResult) {
          $scope.selectedState.isDisabledAdd = ($scope.currentLevel && $scope.currentLevel.level === $scope.allLevel.length) ? true : !permissionResult.hasPermission
        });
      }
      var node = _.find($scope.treeData, { id: $scope.selectedItem.id })
      if (node && node.id !== $scope.user.customerIds[0]) {
        var queryParams = {
          _id: $scope.selectedItem.id
        }
        HierarchyService.resource.getById(queryParams, function (res) {
          $scope.selectedItemData = res;
        })
      }
    };

    $scope.applyModelChanges = function () {
      return !$scope.ignoreChanges;
    };

    $scope.addOrganization = function (isEditForm) {
      $scope.getAllRoles()
      $scope.isAddForm = !isEditForm;
      $scope.isEditForm = isEditForm;
      if ($scope.isAddForm) {
        $scope.hierarchy = {};
      }
      if (($scope.isAddForm && $scope.nextLevel.level === 1) || ($scope.isEditForm && $scope.currentLevel.level === 1)) {
        $scope.hierarchy = !_.isEmpty($rootScope.hierarchy) ? $rootScope.hierarchy : {}
      }
      if (_.isEmpty($scope.hierarchy)) {
        $scope.hierarchy = {}
        $scope.hierarchy.meta = {
          address: {
            sameAsCompanyAddress: false
          }
        }
        $rootScope.user.customer && $rootScope.user.customer.address ? $scope.hierarchy.meta.address = $rootScope.user.customer.address : void 0
        $rootScope.user.customer && $rootScope.user.customer.address ? $scope.hierarchy.meta.address.sameAsCompanyAddress = true : void 0
        $scope.hierarchy.meta.language = 'English'
        $scope.hierarchy.meta.line_frequency = $scope.lineFreq[1].value
      }
      if ($scope.isEditForm) {
        $scope.hierarchy = $scope.selectedItemData
        $scope.updatedOrgName = $scope.hierarchy.name
        $scope.currentAddress = ($scope.hierarchy.meta && !$scope.hierarchy.meta.address.sameAsCompanyAddress) ? $scope.hierarchy.meta.address : {};
        var hierarchyData = $scope.selectedItemData;
        if ($scope.currentLevel.level === 1) {
          $scope.hierarchy.meta.language = !_.isEmpty($rootScope.hierarchy) ? $rootScope.hierarchy.meta.language : hierarchyData.meta.language
          var customLineFrequency = $scope.hierarchy.customLineFrequency || $scope.hierarchy.meta.line_frequency
          $scope.hierarchy.meta.line_frequency = _.find($scope.lineFreq, ['value', $scope.hierarchy.meta.line_frequency]) ? $scope.hierarchy.meta.line_frequency : -1
          $scope.hierarchy.customLineFrequency = $scope.hierarchy.meta.line_frequency === -1 ? customLineFrequency : null
        }
      }
      if (($scope.isAddForm && $scope.selectedState.nextLevel.level === $scope.allLevel[0].level) || ($scope.isEditForm && $scope.selectedState.currentLevel.level === $scope.allLevel[0].level)) {
        $scope.isFirstLevel = true;
      } else {
        $scope.isFirstLevel = false;
      }
      getUserCountry()
    }

    /* Show or hide address form on selection of 'Same as company address' field */
    $scope.changingAddressType = function (labelClick) {
      if (labelClick) {
        $scope.hierarchy.meta.address.sameAsCompanyAddress = !$scope.hierarchy.meta.address.sameAsCompanyAddress
      }
      var sameAsCompanyAddress = $scope.hierarchy.meta.address.sameAsCompanyAddress
      $scope.hierarchy.meta.address = {}
      if (sameAsCompanyAddress) {
        $scope.hierarchy.meta.address = $rootScope.user.customer.address
      } else {
        $scope.hierarchy.meta.address = $scope.currentAddress
      }
      $scope.hierarchy.meta.address.sameAsCompanyAddress = sameAsCompanyAddress
      getUserCountry()
    }

    /* Disable save button until all fields are not filled */
    $scope.saveButtonVisibility = function () {
      if (($scope.isEditForm && $scope.currentLevel.level == 1) || ($scope.isAddForm && $scope.nextLevel.level == 1)) {
        if ($scope.hierarchy.meta) {
          var isLineFrequencyReqired = ($scope.hierarchy.meta && $scope.hierarchy.meta.line_frequency == -1) ? $scope.hierarchy.customLineFrequency : $scope.hierarchy.meta.line_frequency;
          var isLanguageRequired = $scope.hierarchy.meta.language;
          if ($scope.hierarchy.meta.address) {
            var isAddressRequired = $scope.hierarchy.basicInfoForm.$valid
          }
        }
        return !($scope.hierarchy.name && isLineFrequencyReqired && isLanguageRequired && isAddressRequired)
      } else
        return $scope.hierarchy.basicInfoForm.$invalid// !($scope.hierarchy && $scope.hierarchy.name)
    }

    /* Check whether motor RPM is selected or not If not or if it is less than 300 display error block */
    $scope.$watch('hierarchy.customLineFrequency', function (newValue, oldValue) {
      if (parseInt($scope.hierarchy.customLineFrequency) || parseInt($scope.hierarchy.customLineFrequency) === 0) {
        if (parseInt($scope.hierarchy.customLineFrequency) > 200 || parseInt($scope.hierarchy.customLineFrequency) < 1) {
          $scope.customLineFrequencyRequired = true
        } else {
          $scope.customLineFrequencyRequired = false
        }
      } else {
        $scope.customLineFrequencyRequired = false
      }
    }, true)

    /* To save or update hierarchy details */
    $scope.save = function () {
      var companyAddress = $rootScope.user.customer.address;
      var saveData = _.pick($scope.hierarchy, ['name', 'description', 'meta'])
      saveData['customerId'] = $rootScope.user.customerIds[0]
      saveData['hierarchyTypeId'] = $scope.isEditForm ? $scope.currentLevel._id : $scope.nextLevel._id;

      var level = $scope.isEditForm ? $scope.currentLevel.level : $scope.nextLevel.level
      if (level === 1) {
        if ($scope.hierarchy.meta.address.sameAsCompanyAddress) {
          saveData.meta.address.country = companyAddress.country
          saveData.meta.address.state = companyAddress.state
          saveData.meta.address.city = companyAddress.city
          saveData.meta.address.streetAddress = companyAddress.streetAddress
          saveData.meta.address.pinCode = companyAddress.pinCode
          saveData.meta.address.email = companyAddress.email
          saveData.meta.address.phone = companyAddress.phone
        }
        if (saveData.meta.line_frequency === -1) {
          saveData.meta.line_frequency = parseInt($scope.hierarchy.customLineFrequency)
        }
        delete saveData.customLineFrequency
      }
      var assignUser = {}
      if ($scope.selected.assignUser) {
        assignUser = {
          userInfo: _.pick($scope.selected.userInfo, ['_id', 'firstName', 'lastName', 'email', 'phone']),
          role: $scope.selected.role
        }
      }

      if ($scope.isEditForm) {
        if ($scope.currentLevel && $scope.currentLevel.level >= 2) {
          saveData = _.omit(saveData, ['meta'])
        }
        saveData['_id'] = $scope.selectedItem.id;
        HierarchyService.resource.update({ data: saveData, assignUser: assignUser }, function (res) {
          var message = constants.toastrMessages.success.updateHierarchy
          var properties = {
            Hierarchy: $scope.currentLevel.name
          }
          _.map(properties, function (value, prop) {
            var regex = new RegExp('{' + prop + '}', 'g')
            message = message.replace(regex, value)
          })
          toastr.success(message)
          $scope.isEditForm = false;
          var selectedItem = $scope.organizationTree.jstree(true)._model.data[$scope.organizationTree.jstree(true).get_selected()[0]]
          var index = _.findIndex($scope.treeData, { id: selectedItem.id });
          $scope.treeData[index].text = res.name
          refreshTree($scope.treeData);
          $scope.selected = {}
        }, function (err) {
          toastr.error(err.data.msg)
        })
      } else {
        if ($scope.currentLevel && $scope.currentLevel.level >= 1) {
          saveData.parentId = $scope.selectedItem.id;
          saveData = _.omit(saveData, ['meta'])
        }
        HierarchyService.resource.addHierarchy({ data: saveData, assignUser: assignUser }, function (res) {
          $scope.isOrganizationAdded = true;
          var message = constants.toastrMessages.success.addHierarchy
          $scope.ignoreChanges = true;
          deSelectAllNodes();
          var levelIcon = $scope.nextLevel.level === 1 ? 'plant' : $scope.nextLevel.level === 2 ? 'area' : 'section';
          $scope.treeData.unshift({
            id: res._id,
            parent: res.parentId ? res.parentId : $scope.user.customerIds[0],
            text: res.name,
            type: levelIcon,
            state: {
              selected: true,
              isDisabledEdit: false,
              isDisabledAdd: $scope.nextLevel.level === 1 ? !$scope.isAddAreaPermission : $scope.nextLevel.level === 2 ? !$scope.isAddSectionPermission : true,
              currentLevel: $scope.nextLevel,
              nextLevel: $scope.allLevel[$scope.nextLevel.level] ? $scope.allLevel[$scope.nextLevel.level] : null
            }
          });
          refreshTree($scope.treeData);
          var properties = {
            Hierarchy: $scope.currentLevel.name
          }
          _.map(properties, function (value, prop) {
            var regex = new RegExp('{' + prop + '}', 'g')
            message = message.replace(regex, value)
          })
          toastr.success(message)
          $scope.basicConfig.version++;
          $scope.hierarchy = {};
          $scope.isAddForm = false;
          $scope.selected = {}
        }, function (err) {
          toastr.error(err.data.msg)
        })
      }
    }

    /* Control for delete confirmation dialog. Allow to delete selected hierarchical level. After delete redirect to hierarchical list page. */
    $scope.deleteHierarchy = function () {
      var items
      var message = ''
      var properties = {}
      var queryParams = {
        _id: $scope.selectedItem.id
      }
      HierarchyService.resource.getById(queryParams, function (res) {
        var hierarchyData = res;
        // for lowest hierarchical level check machines available or not
        if (hierarchyData.hierarchyTypeId === $rootScope.user.customer.hierarchyType[$rootScope.user.customer.hierarchyType.length - 1]._id) {
          var machinesInHierarchy = false
          var queryParams = {
            hierarchyId: hierarchyData._id,
            customerId: $rootScope.user.customer._id
          }
          HierarchyService.resource.getMachineCountInHierarchy(queryParams, function (res) {
            // if both machines and users ara available
            if (res.machineCount && hierarchyData.roleData && hierarchyData.roleData.length) {
              message = constants.webAppTexts.popupMessages.deleteHierarchyWithMachinesAndUsers
              machinesInHierarchy = true
            } else if (res.machineCount) { // if only machines avaliable
              message = constants.webAppTexts.popupMessages.deleteLowestHierarchyWithMachines
              machinesInHierarchy = true
            } else if (hierarchyData.roleData && hierarchyData.roleData.length) { // only users are avaliable
              message = constants.webAppTexts.popupMessages.deleteHierarchyWithUsers
              machinesInHierarchy = true
            } else { // no machine and user avaliable
              message = constants.webAppTexts.popupMessages.deleteHierarchy
            }
            // if (machinesInHierarchy) { // generate msg
            properties = {
              level: $scope.currentLevel.name,
              name: hierarchyData.name
            }
            message = UtilService.generateMsg(message, properties)
            // }
            // check whether can delete hierarchy or not
            deleteHierarchyItem(items, machinesInHierarchy, message, hierarchyData)
          }, function (err) {
            toastr.error(err.data.msg)
          })
        } else {
          var subLevelData
          // get sublevel count
          queryParams = {
            customerId: $scope.user.customerIds[0],
            page: 1,
            sort: { 'createdOn': -1 },
            filters: {},
            limit: $scope.limit,
            parentId: hierarchyData._id
          }
          HierarchyService.resource.getAll(queryParams, function (res) {
            // if both sub-levels and users are available
            if (res.totalCount && hierarchyData.roleData && hierarchyData.roleData.length) {
              message = constants.webAppTexts.popupMessages.deleteHierarchyWithSubLevelsAndUsers
              subLevelData = true
            } else if (res.totalCount) { // only sub-levels are available
              message = constants.webAppTexts.popupMessages.deleteHierarchyWithSubLevels
              subLevelData = true
            } else if (hierarchyData.roleData && hierarchyData.roleData.length) { // only users are available
              message = constants.webAppTexts.popupMessages.deleteHierarchyWithUsers
              subLevelData = true
            } else { // no sub-levels and user available
              message = constants.webAppTexts.popupMessages.deleteHierarchy
            }
            // if (subLevelData) { // generate msg
            var unitName = _.find($scope.user.customer.hierarchyType, { level: $scope.currentLevel.level + 1 })
            properties = {
              level: $scope.currentLevel.name,
              name: hierarchyData.name,
              unit: unitName ? unitName.name.toLowerCase() : null
            }
            message = UtilService.generateMsg(message, properties)
            // }
            // check whether can delete hierarchy
            deleteHierarchyItem(items, subLevelData, message, hierarchyData)
          }, function (err) {
            toastr.error(err.data.msg)
          })
        }
      })
    }

    // delete hierarchical item if no sub-levels and roles are available
    function deleteHierarchyItem(items, subLevelData, message, hierarchyData) {
      if (subLevelData) {
        items = function () {
          return {
            type: 'reject',
            message: message
          }
        }
      } else {
        items = function () {
          return {
            buttons: {
              yes: subLevelData ? 'Ok' : 'Confirm',
              no: 'Cancel'
            },
            message: message,
            title: 'Delete ' + hierarchyData.name
          }
        }
      }
      var modalInstance = $uibModal.open({
        templateUrl: 'app/components/confirmationDialog/confirmationDialog.html',
        controller: 'AllConfirmationDialogCtrl',
        resolve: {
          items: items
        }
      })
      modalInstance.result.then(function (result) {
        // delete if no sub-level data or users are available
        if (!subLevelData) {
          HierarchyService.resource.deleteById({ id: hierarchyData._id, customerId: $rootScope.user.customer._id }, function (res) {
            if (_.findIndex(res, { isActive: false })) {
              deSelectAllNodes();
              var selectedItem = $scope.organizationTree.jstree(true)._model.data[$scope.organizationTree.jstree(true).get_selected()[0]]
              var parentNode = selectedItem.parent ? $scope.organizationTree.jstree(true)._model.data[selectedItem.parent] : $scope.treeData[0];
              $scope.treeData.splice(_.findIndex($scope.treeData, { id: selectedItem.id }), 1);

              var message = constants.toastrMessages.success.deleteHierarchy
              var properties = {
                Hierarchy: $scope.currentLevel.name
              }
              _.map(properties, function (value, prop) {
                var regex = new RegExp('{' + prop + '}', 'g')
                message = message.replace(regex, value)
              })
              toastr.success(message);
              if (parentNode.state) {
                parentNode.state.selected = true;
              }
              refreshTree($scope.treeData);
              $scope.selectedItem = parentNode
              $scope.selectedState = $scope.selectedItem.state;
            } else {
              toastr.error('Failed to delete')
            }
          }, function (err) {
            toastr.error(err.data.msg)
          })
        }
      }, function () { })
    }

    function refreshTree(newData) {
      $scope.organizationTree.jstree(true).settings.core.data = newData;
      $scope.organizationTree.jstree(true).refresh();
    }

    function deSelectAllNodes() {
      _.map($scope.treeData, function (item) {
        if (item.state.selected) {
          item.state.selected = false;
        }
      });
    }

    $scope.cancel = function () {
      $scope.isAddForm = false;
      $scope.isEditForm = false;
      $scope.hierarchy = {};
      $scope.selected = {}
    }

    function getUserCountry() {
      // Ensure hierarchy structure safely exists
      $scope.hierarchy = $scope.hierarchy || {};
      $scope.hierarchy.meta = $scope.hierarchy.meta || {};
      $scope.hierarchy.meta.address = $scope.hierarchy.meta.address || {};
      if (($scope.isAddForm || $scope.isEditForm) && !($scope.hierarchy.meta && $scope.hierarchy.meta.address && $scope.hierarchy.meta.address.country)) {
        window.$.getJSON('https://ipwhois.app/json/', function (data) {
          if (data) {
            !($scope.hierarchy.meta && $scope.hierarchy.meta.address) ? $scope.hierarchy.meta.address = {
              country: data.country
            } : $scope.hierarchy.meta.address.country = data.country
            $scope.$apply()
          }
        }, function (err) {
          console.log(err)
        })
      }
    }
    $scope.$watch('selected.assignUser', function (newV, oldV) {
      $scope.getAllRoles()
    }, true)
    $scope.$watch('selected.userType', function (newV, oldV) {
      if (newV === '2') {
        delete $scope.selected.userInfo
        $scope.getAllUsers()
      } else {
        $scope.selected.userInfo = {}
      }
    }, true)
    $scope.getAllRoles = function (level) {
      var queryParams = {
        userId: $scope.user._id,
        customerId: $scope.user.customerIds[0]
      }
      RoleService.resource.getTopLevelRoleOfUser(queryParams, function (res) {
        $scope.isCompanyLevelUser = res.type === constants.resourceTypes[0].internalName
        $scope.roles = _.find(_.cloneDeep(constants.roles), { level: res.roleLevel }).assignRoleTo
        var data = {
          userId: $scope.user._id,
          permissions: ['canViewMachines', 'canViewOwnedMachines'],
          permissionCheck: 'any',
          withResources: true
        }
        PermissionService.resource.hasPermission(data, function (permissionResult) {
          if (!permissionResult.hasPermission)
            _.remove($scope.roles, { id: 4 })
          if($scope.nextLevel && $scope.allLevel && $scope.allLevel[$scope.allLevel.length - 1].level !== $scope.nextLevel.level) {
            _.remove($scope.roles, function (itm) {
              return itm.id === 3 || itm.id === 4
            })
          }
          if ($scope.roles && $scope.roles.length) {
            $scope.selected.role = $scope.roles[0]
          }
        });
      })
    }

    // get all users of customer
    $scope.getAllUsers = function () {
      var queryParams = {
        customerId: $scope.user.customerIds[0],
        page: 1,
        sort: { firstName: 1 },
        filters: { $or: [{ status: 'active' }] },
        limit: 9999
      }
      UserService.resource.getAllUsersOfCustomer(queryParams, function (res) {
        $scope.allUsers = res.users
      })
    }

    DistributorService.resource.allCountries(function (res) {
      $scope.allCountries = res.countries
      getUserCountry()
    }, function () { })

  }
})();

(function () {
  'use strict'
  var angular = window.angular
  var _ = window._
  angular.module('Vibzer.components')
    .controller('ProfileCtrl', profileCtrl)

  // User profile page controller. Handles view/edit profile and change password
  // @NgInject
  function profileCtrl ($scope, $rootScope, $uibModal, $cookies, $location, constants, UserService) {
    $scope.user = $cookies.getObject('vcUser')
    $scope.webAppTexts = constants.webAppTexts
    $scope.breadCrumbList = ['User Profile']
    $scope.viewProfile = true
    $scope.limit = 10
    $scope.uibPage = {
      page: 1
    }

    $scope.pageChanged = function (page) {
      $location.search('page', $scope.uibPage.page)
      getRoles()
    }
    /* Get roles of user with resources */
    function getRoles () {
      $scope.busy = true
      var queryParams = {
        _id: $scope.user._id,
        limit: $scope.limit
      }
      queryParams.page = $scope.uibPage.page || 1
      UserService.resource.getUserRolesWithResource(queryParams, function (res) {
        $scope.roleInfo = res.result
        $scope.roleInfo = _.filter($scope.roleInfo, function (role) {
          // Following if-else block used to distinguish customer and distributor
          if ($rootScope.user && $rootScope.user.customerIds && $rootScope.user.customerIds.length > 0) {
            if (role.resourceType === constants.resourceTypes[0].internalName) {
              role.resource = { name: constants.resourceTypes[0].displayName, _id: $scope.user.customerIds[0] }
              return role
            } else if (_.some(role.resource, _.isEmpty)) {
              return role
            }
          } else {
            if (role.resourceType === constants.resourceTypes[0].internalName) {
              role.role = role.role === constants.distributorRoles[0].internalName ? constants.distributorRoles[0].name : role.role
              return role
            } else if (_.some(role.resource, _.isEmpty)) {
              return role
            }
          }
        })
        $scope.totalItems = res.totalItems
        $scope.busy = false
      })
    }

    getRoles()

    $scope.changePassword = function () {
      var modalInstance = $uibModal.open({
        templateUrl: 'app/components/profilePage/modals/changePasswordDialog.html',
        controller: 'ChangePasswordDialogCtrl',
        resolve: {}
      })
      modalInstance.result.then(function () {}, function () { })
    }
  }
})();
(function () {
  'use strict'
  var _ = window._
  var angular = window.angular
  angular.module('Vibzer.components.machineReport')
    .controller('MachineReportCtrl', MachineReportCtrl)

  // @NgInject
  function MachineReportCtrl ($scope, $rootScope, $state, $stateParams, $cookies, UserService, ReportService, constants) {
    $scope.notLoggedInUser = true
    $scope.greenAnimate = false
    $scope.redAnimate = false
    $scope.loadReport = true
    $scope.takenOnStyle = {
      'margin-top': '5px'
    }
    $scope.comments = []
    /* Push comment in comments array and save it in database */
    $scope.addComment = function () {
      if ($scope.pending) {
        return
      }
      $scope.pending = true
      var data = {
        requireUserInfo: true,
        machineId: $scope.machineInfo._id,
        sessionId: $stateParams.sessionId,
        comment: {
          message: $scope.reportComment
        }
      }
      ReportService.resource.addComment(data, function (res) {
        $scope.pending = false
        $scope.comments.push({ message: $scope.reportComment, uploadedBy: res.comments[res.comments.length - 1].uploadedBy })
        $scope.reportComment = ''
      }, function () {
        $scope.pending = false
      })
    }
    setTimeout(function () {
      if ($stateParams.tkn) {
        $cookies.put('authToken', $stateParams.tkn)
      }
      $scope.$apply()
    }, 500)

    var manageCookies = function (action) {
      if (action === 'add') {
        if ($stateParams.id) {
          $cookies.put('userId', $stateParams.id)
          $cookies.putObject('vcUser', { _id: $stateParams.id })
        }
        if ($stateParams.tkn) {
          $cookies.put('authToken', $stateParams.tkn)
        }
        $rootScope.authToken = $stateParams.tkn || $cookies.get('authToken')
      } else {
        window.angular.forEach($cookies.getAll(), function (v, k) {
          $cookies.remove(k)
        })
      }
    }
    // manageCookies()
    if ($stateParams.tkn && $stateParams.id) {
      manageCookies('add')
    }
    $scope.notLoggedInUser = UserService.checkLoggedInUser()
    $scope.dateFormat = constants.dateFormats.default
    ReportService.resource.getCurrentAndLastReport({ sessionId: $stateParams.sessionId, machineDataRequire: true, requireAllData: 'forReport', reportIndexRequire: true }, function (res) {
      $scope.reportData = res
      $scope.comments = res.comments ? res.comments : void 0
      res.createdBy && res.createdBy.firstName ? $scope.takenBy = 'Captured by: ' + res.createdBy.firstName + ' ' + res.createdBy.lastName : void 0
      $scope.currentReportExpSysVersion = res.expertSystemVersion || '3.0.0'
      if (_.includes(['EEEEE1', 'EEEEE2'], res.machineState)) {
        $scope.greenAnimate = true
      } else if (res.contamination) {
        $scope.redAnimate = true
        var condition = _.find(constants.machineConditions, { state: res.machineState })
        $scope.importantNote = condition.note
      }
      $scope.machineInfo = res.machineData
      $scope.noLastReport = _.isEmpty(res.lastReport)
      $scope.reportProperties = ReportService.generateReportData(res.statistical, res.lastReport, constants, $scope.machineInfo.machineType + 'Report')
      if ($scope.machineInfo.machineType !== 'machine') {
        $scope.webReportPage = true
        $scope.showScheduleInfo = true
        var sortedReport = $scope.reportProperties.slice(0, $scope.reportProperties.length - 1)
        sortedReport = _.sortBy(sortedReport, 'Current').reverse()
        var firstIndex = _.findIndex(sortedReport, { 'recLength': 0 })
        sortedReport.splice(firstIndex, 0, $scope.reportProperties[$scope.reportProperties.length - 1])
        $scope.reportProperties = sortedReport
      }
      $scope.machineInfo.machineType = _.find(constants.typesOfMachine, { name: $scope.machineInfo.machineType }).displayName
      $scope.loadReport = false
    }, function (err) {
      $scope.loadReport = false
      console.log(err)
    })

    $scope.toggleShowExcellent = function () {
      $scope.showExcellent = !$scope.showExcellent
    }
    $scope.showEnergyCalc = function () {
      return $scope.reportData && $scope.reportData.report && $scope.reportData.report.finalSeverity > 1 && $scope.machineInfo.customer && $scope.machineInfo.customer.showEnergyCalculation
    }
    $scope.isFinalSeverity = function (index, checkBelow) {
      return $scope.reportProperties[index].severityName === constants.motorReportPropertiesSequence[5].severityName || (index + 1 < $scope.reportProperties.length && $scope.reportProperties[index + 1].severityName === constants.motorReportPropertiesSequence[5].severityName && checkBelow)
    }

    window.onbeforeunload = function () {
      manageCookies()
    }

    $scope.showUpdateSchedule = false
    $rootScope.$on('$stateChangeStart', function (event, toState, toParams, fromState, fromParams, options) {
      if ($scope.notLoggedInUser) {
        var cookies = $cookies.getAll()
        angular.forEach(cookies, function (v, k) {
          $cookies.remove(k)
        })
      }
    })
  }
})();
(function () {
  'use strict';
  var angular = window.angular
  var _ = window._
  angular.module('Vibzer.components')
    .controller('RoutesCtrl', RoutesCtrl);

  // Route list controller
  /** @ngInject */
  function RoutesCtrl ($scope, $rootScope, $state, toastr, $stateParams, $location, constants, RouteService, PermissionService) {
    $scope.webAppTexts = constants.webAppTexts
    $scope.breadCrumbList = [$scope.webAppTexts.breadcrumbs.routeList]
    $scope.forRoute = true
    $scope.dateFormat = constants.dateFormats.default
    $scope.limit = 10
    $scope.uibPage = {
      page: 1
    }
    $scope.selected = {}
    $scope.list = []
    $scope.searchPlaceholder = $scope.webAppTexts.placeholder.searchRoute
    $scope.addTooltip = $scope.webAppTexts.tooltips.addRoute
    $scope.viewTooltip = $scope.webAppTexts.tooltips.viewRoute

    // set filter options
    $scope.uibPage.page = $stateParams.page ? $stateParams.page : $stateParams.routeFilters ? JSON.parse($stateParams.routeFilters).page : 1
    $scope.sort = $stateParams.routeFilters && JSON.parse($stateParams.routeFilters).sort.name ? JSON.parse($stateParams.routeFilters).sort.name : 'createdOn'
    $scope.order = $stateParams.routeFilters && JSON.parse($stateParams.routeFilters).sort.order ? JSON.parse($stateParams.routeFilters).sort.order : -1
    $scope.searchText = $stateParams.searchText || ''

    $scope.sortBy = angular.copy(constants.sortBy)
    $scope.orderBy = angular.copy(constants.orderBy)

    // dsort-order
    $scope.selected.sort = _.find($scope.sortBy, { internalName: $scope.sort }).id
    $scope.selected.order = _.find($scope.orderBy, { internalName: $scope.order }).id
    $scope.routeFilters = $stateParams.routeFilters ? JSON.parse($stateParams.routeFilters) : {
      page: 1,
      filter: {},
      sort: {}
    }

    // check add route permission (Manager of lowest hierarchical item and engineer can add route)
    var data = {
      userId: $scope.user._id,
      permissions: ['canViewMachines', 'addRoute'],
      resourceType: constants.resourceTypes[1].internalName,
      hierarchyTypeIds: $scope.user.customer.hierarchyType[$scope.user.customer.hierarchyType.length - 1]._id
    }
    PermissionService.resource.hasPermission(data, function (res) {
      $scope.canAdd = res.hasPermission || ($rootScope.user.permission.canViewOwnedMachines && $rootScope.user.permission.addRoute)
    })

    /* This function is used to handle sorting. It invokes after changing
       sort or order and updates stateParams and calls pageChanged() to get updated route list.
    */
    $scope.setSorting = function (type, sort) {
      if (type === 'sort') {
        $scope.sort = _.find($scope.sortBy, { id: sort }).internalName
        $scope.routeFilters.sort.name = $scope.sort
        $location.search('routeFilters', JSON.stringify($scope.routeFilters))
      } else {
        $scope.order = _.find($scope.orderBy, { id: sort }).internalName
        $scope.routeFilters.sort.order = $scope.order
        $location.search('routeFilters', JSON.stringify($scope.routeFilters))
      }
      $scope.uibPage.page = 1
      $scope.pageChanged(1)
    }

    /* This function invokes after page or sort or order changes and sets
       currentPage in URL and calls getAllRoutes() to get updated route list.
    */
    $scope.pageChanged = function (page) {
      $scope.routeFilters.page = $scope.uibPage.page
      $location.search('page', $scope.uibPage.page)
      getAllRoutes()
    }

    /* Search route in route list. */
    $scope.search = function (searchText) {
      $scope.uibPage.page = 1
      $location.search('page', $scope.uibPage.page)
      $scope.searchText = searchText
      $location.search('searchText', searchText)
      getAllRoutes()
    }
    // get all routes
    function getAllRoutes () {
      $scope.busy = true
      var queryParams = {
        customerId: $scope.user.customerIds[0],
        page: null,
        sort: {},
        filters: {},
        limit: $scope.limit
      }
      queryParams.page = $scope.uibPage.page || 1
      queryParams.sort[$scope.sort] = $scope.order
      if ($scope.searchText) {
        queryParams.filters.name = {
          internalName: 'name',
          value: ($location.search().searchText && $location.search().searchText !== '' ? $scope.searchText : ''),
          type: 'regex',
          regexOptions: 'i'
        }
      }
      _.assign(queryParams.filters, $scope.filter)
      RouteService.resource.getAll(queryParams, function (res) {
        $scope.list = _.map(res.result, function (itm) {
          itm.userIds ? itm.ownerIds = itm.ownerIds.concat(itm.userIds) : void 0
          return itm
        })
        $scope.totalItems = res.totalCount
        $scope.busy = false
      }, function (err) {
        toastr.error(err.data.msg)
      })
    }

    getAllRoutes()

    // get all machines of rourte
    $scope.getMachines = function (route) {
      $state.go('routeMachines', { routeId: route._id, routeFilters: JSON.stringify($scope.routeFilters) })
    }

    // rediract to add route
    $scope.add = function () {
      $state.go('addRoute')
    }

    // redirect to view route info
    $scope.viewDetails = function (route) {
      $state.go('viewRoute', { routeId: route._id, routeFilters: JSON.stringify($scope.routeFilters) })
    }
  }
})();

(function () {
  'use strict';
  var angular = window.angular
  var _ = window._
  var moment = window.moment
  var $ = window.$
  angular.module('Vibzer.components').controller('DownloadRpbCtrl', DownloadRpbCtrl)
  function DownloadRpbCtrl($scope, $state, $location, $stateParams, $uibModal, ReportService, RouteService, CompositeService, $cookies, constants, DistributorService, CustomerService, MachineService, toastr, FileSaver) {
    $scope.machineData = {}
    // var machineData = {}
    $scope.distributors = []
    $scope.customers = []
    $scope.machines = []
    $scope.webAppTexts = constants.webAppTexts
    // var lastReadingType = _.find(constants.readingTypes, { id: machineData.lastReadingType })
    // var condition = _.find(constants.machineStates, { id: lastReadingType ? machineData[lastReadingType.internalName].condition : -1 })
    // if (condition) {
    //   $scope.machineData.condition = condition.color
    // }
    // $scope.dateFormat = constants.dateFormats.default
    // $scope.isMonitoringMachine = false
    $scope.page = 1
    $scope.limit = 10
    $scope.sessions = []
    $scope.selected = {}
    $scope.user = $cookies.getObject('vcUser')
    // $scope.machineData.machineTypeId.name === 'machine' ? $scope.isMonitoringMachine = true : $scope.isMonitoringMachine = false
    // $scope.machineData.icon = _.find(constants.typesOfMachine, { name: $scope.machineData.machineTypeId.name }).icon
    // // get all reading types
    // $scope.readingTypes = angular.copy(constants.readingTypes)
    // $scope.readingTypes.unshift({ id: 0, internalName: 'all', displayName: 'All' })
    // $scope.selected.readingType = $scope.readingTypes[0].id
    // /* Get all machine conditions */
    // $scope.machineConditions = angular.copy(_.filter(constants.machineStates, function (state) { return state.id > 0 }))
    // $scope.machineConditions.unshift({ id: 0, name: 'all', displayName: 'All' })
    // $scope.machineConditions = _.filter($scope.machineConditions, function (condition) {
    //   if (condition.name === 'all') {
    //     condition.displayName = condition.displayName.concat(' conditions')
    //   } else {
    //     condition.displayName = condition.displayName.concat(' condition')
    //   }
    //   return condition
    // })
    // $scope.condition = {}
    // $scope.selected.condition = $scope.machineConditions[0]

    // dynamic breadcrumbs
    $scope.breadCrumbList = [$scope.webAppTexts.breadcrumbs.machineList, $scope.webAppTexts.breadcrumbs.sessions]
    // get route data
    if ($stateParams.routeId) {
      RouteService.resource.getRoute({ _id: $stateParams.routeId }, function (res) {
        $scope.routeData = res
        $scope.breadCrumbList = [$scope.webAppTexts.breadcrumbs.routeList, $scope.routeData.name, $scope.webAppTexts.breadcrumbs.sessions]
      })
    }

    // get composite machine data
    if ($stateParams.compositeId) {
      CompositeService.resource.getById({ _id: $stateParams.compositeId }, function (res) {
        $scope.compositeData = res
        if ($scope.machineData.forComposite) {
          $scope.breadCrumbList = [$scope.webAppTexts.breadcrumbs.compositeMachineList, $scope.webAppTexts.breadcrumbs.sessions]
        } else {
          $scope.breadCrumbList = [$scope.webAppTexts.breadcrumbs.compositeMachineList, $scope.compositeData.name, $scope.webAppTexts.breadcrumbs.sessions]
        }
      })
    }

    $scope.format = 'MM-dd-yyyy'
    $scope.startDateOptions = {
      dateDisabled: false,
      formatYear: 'yy',
      maxDate: new Date(2100, 1, 1),
      minDate: new Date(2000, 1, 1),
      startingDay: 1
    }

    $scope.endDateOptions = angular.copy($scope.startDateOptions)
    $scope.isStartDateOpened = false
    $scope.isEndDateOpened = false

    $scope.selectStartDate = function () {
      $scope.isStartDateOpened = true
    }

    $scope.selectEndDate = function () {
      $scope.isEndDateOpened = true
    }

    /* This function  invokes after selecting start or end session date and updates session list. */
    $scope.dateSelected = function (type) {
      $location.search('startSessionDate', null)
      $location.search('endSessionDate', null)
      if (type === 'end' && $scope.endSessionDate) {
        $scope.endSessionDate.setHours(23, 59, 59, 999)
      } else {
        $scope.endDateOptions.minDate = $scope.startSessionDate
      }
      $scope.page = 1
      $scope.sessions = []
      $scope.getSessions()
    }

    /* This function invokes after selecting machine condition and updates session list as per condition. */
    $scope.conditionSelected = function () {
      $scope.page = 1
      $scope.sessions = []
      $scope.getSessions()
    }

    /* This function invokes after selecting reading type and updates session list as per selected reading type. */
    $scope.readingTypeSelected = function (readingType) {
      $scope.page = 1
      $scope.sessions = []
      $scope.getSessions()
    }
    /* Get sessions of machine. */
    $scope.getSessions = function () {
      if ($scope.page > $scope.totalPages || $scope.page === 0 || !($scope.selected && $scope.selected.distributorId && $scope.selected.customerId && $scope.selected.machineId)) {
        return
      }
      $scope.busy = true
      var queryParams = {
        customerId: $scope.selected.customerId,
        machineId: $scope.selected.machineId,
        limit: $scope.limit || 10,
        page: $scope.page || 1
      }

      if ($scope.selected.condition && $scope.selected.condition.name !== 'all') {
        queryParams.condition = $scope.selected.condition.id
      }
      if ($scope.selected.readingType && $scope.selected.readingType !== 0) {
        queryParams.readingType = $scope.selected.readingType
      }
      if ($scope.startSessionDate || $scope.endSessionDate) {
        queryParams.dates = {}
        if ($scope.startSessionDate) {
          queryParams.dates.fromDate = $scope.startSessionDate.toISOString()
          $location.search('startSessionDate', $scope.startSessionDate.toISOString())
        }
        if ($scope.endSessionDate) {
          queryParams.dates.toDate = $scope.endSessionDate.toISOString()
          $location.search('endSessionDate', $scope.endSessionDate.toISOString())
        }
      }

      ReportService.resource.getAllMachineSessions({ stringifyData: JSON.stringify(queryParams) }, function (res) {
        $scope.sessions = $scope.sessions.concat(_.map(res.result, function (session, index) {
          session.name = 'S- ' + moment(session.createdOn).format('MM-DD-YY HH:mm:ss') // 'Session ' + (index + 1)
          session.readingType = _.find(constants.readingTypes, { id: session.readingType })
          var machineCondition = _.filter(constants.machineStates, { id: session.condition })[0]
          if (machineCondition) {
            session.color = machineCondition.color
          }
          session.icon = $scope.machineData.icon
          session.viewReport = true
          if (session.isTestReading) {
            session.comment = $scope.webAppTexts.notes.noTestReadingReport
            session.typeText = $scope.webAppTexts.labels.testReading
          } else if (!session.hasReport) {
            session.comment = $scope.webAppTexts.notes.failToGenerateReport
            // session.typeText = $scope.webAppTexts.labels.reportError
          }
          return session
        }))
        $scope.totalPages = res.totalPages
        $scope.page = $scope.page + 1
        $scope.busy = false
        $scope.$emit('list:filtered')
      }, function (err) {
        $scope.busy = false
        $scope.page = 0
        console.log(err)
      })
    }

    /* Redirects to machines page. */
    $scope.breadCrumbClickHandler = function (itm) {
      if ($stateParams.compositeId && $scope.machineData.forComposite) {
        $state.go('compositeMachines', { compositeData: $stateParams.compositeData })
      } else if ($stateParams.routeId && itm === $scope.webAppTexts.breadcrumbs.routeList) {
        $state.go('routes', { routeFilters: $stateParams.routeFilters })
      } else if ($stateParams.routeId && itm === $scope.routeData.name) {
        $state.go('routeMachines', { routeId: $stateParams.routeId, machineData: $stateParams.machineData, routeFilters: $stateParams.routeFilters })
      } else if ($stateParams.compositeId && itm === $scope.webAppTexts.breadcrumbs.compositeMachineList) {
        $state.go('compositeMachines', { compositeData: $stateParams.compositeData })
      } else if ($stateParams.compositeId && itm === $scope.compositeData.name) {
        $state.go('machinesFromComposite', { compositeId: $stateParams.compositeId, machineData: $stateParams.machineData, compositeData: $stateParams.compositeData })
      } else {
        $state.go('machines', { machineData: $stateParams.machineData })
      }
    }

    /* This block handles modal opening for all charts. */
    $scope.openingChart = function (chart, sessionId, sessionName, readingType) {
      var templateUrl = 'app/components/machines/reviews/modals/charts.html'
      if (chart === 'wave') {
        var controller = 'WaveChartCtrl'
      } else if (chart === 'spectrum') {
        controller = 'SpectrumChartCtrl'
      } else if (chart === 'rawData') {
        templateUrl = 'app/components/machines/reviews/modals/rawDataChart.html'
        controller = 'RawChartCtrl'
      }
      var modalInstance = $uibModal.open({
        templateUrl: templateUrl,
        backdrop: true,
        controller: controller,
        resolve: {
          machineData: function () {
            return _.assign($scope.machineData, {
              chartType: chart,
              sessionId: sessionId,
              sessionName: sessionName,
              readingType: readingType.id
            })
          }
        },
        size: 'xt-lg'
      })
      modalInstance.result.then(function (result) {
      })
    }

    /* Open view report dialog */
    $scope.viewReportOfSession = function (sessionId, sessionName) {
      var modalInstance = $uibModal.open({
        templateUrl: 'app/components/machines/reviews/modals/viewReport.html',
        backdrop: true,
        controller: 'ViewReportCtrl',
        resolve: {
          reportData: {
            machineType: $scope.machineData.machineTypeId.name,
            sessionId: sessionId,
            sessionName: sessionName
          }
        }
      })
      modalInstance.result.then(function (result) {
      })
    }

    /* To view criteria wise analysis */
    $scope.viewCriteriaAnalysis = function (session) {
      $uibModal.open({
        templateUrl: 'app/components/machines/reviews/modals/viewCriteriaAnalysis.html',
        backdrop: true,
        controller: 'ViewCriteriaAnalysisCtrl',
        size: 'xt-lg',
        resolve: {
          reportData: angular.copy(_.assign(session, {
            machineId: $scope.machineData._id,
            machineName: $scope.machineData.name,
            machineType: $scope.machineData.machineTypeId.name,
            meta: $scope.machineData.meta
          }))
        }
      })
    }

    $scope.getAllDistributors = function () {
      DistributorService.resource.getAllDistributors({ select: 'name', for: 'downloadRpb' }, function (res) {
        if (res && res.data && res.data.length) {
          $scope.distributors = res.data
        } else {
          toastr.info(constants.toastrMessages.notFound.distributor)
        }
      }, function (err) {
        toastr.error(err.data.msg)
      })
    }
    $scope.getAllDistributors()
    /* This function is used to get customers. It gives all customers, with active, deactive customer count. */
    $scope.getAllCustomers = function () {
      $scope.busy = true
      CustomerService.resource.getAll({
        limit: 99999,
        page: 1,
        for: 'downloadRpb',
        distributorId: $scope.selected.distributorId
      }, function (res) {
        if (res && res.customers && res.customers.length) {
          $scope.customers = res.customers
        } else {
          toastr.info(constants.toastrMessages.notFound.customer)
        }
        $scope.busy = false
      }, function (err) {
        $scope.busy = false
        toastr.error(err.data.msg)
      })
    }

    /* This function is used to get machines. It gives all machines with total count. */
    $scope.getAllMachines = function () {
      $scope.busy = true
      var queryParams = {
        customerId: $scope.selected.customerId,
        page: 1,
        for: 'downloadRpb',
        limit: 99999
      }
      MachineService.resource.getAllMachines(queryParams, function (res) {
        if (res.result && res.result.length) {
          $scope.machines = _.map(res.result, function (machine) {
            machine.icon = _.find(constants.typesOfMachine, { name: machine.machineType.name }).icon
            return machine
          })
        } else {
          toastr.info(constants.toastrMessages.notFound.machine)
        }
        $scope.busy = false
      }, function (err) {
        $scope.busy = false
      })
    }

    $scope.exportRpb = function (session) {
      var session = _.find($scope.sessions, { sessionId: session.sessionId })
      session.busy = true
      ReportService.resource.downloadRpb({ machineId: $scope.selected.machineId, sessionId: session.sessionId, checkRpbPath: session.path }, function (res, header) {
        var file = JSON.stringify(res, null, 2)
        var blob = new window.Blob([file], { type: 'application/json' })
        FileSaver.saveAs(blob, header('vbz-filename'))
        session.busy = false
      }, function (err) {
        session.busy = false
        toastr.warning(err.data.msg)
      })
    }

    $scope.selectedProperty = function (prop) {
      $scope.sessions = []
      $scope.page = 1
      $scope.totalPages = undefined
      if (prop === 'distributor') {
        $scope.customers = []
        $scope.machines = []
        delete $scope.selected.customerId
        delete $scope.selected.machineId
        $scope.getAllCustomers()
      } else if (prop === 'customer') {
        $scope.machines = []
        delete $scope.selected.machineId
        $scope.getAllMachines()
      } else if (prop === 'machine') {
        $scope.machineData = _.find($scope.machines, { _id: $scope.selected.machineId })
        $scope.machineData.machineTypeId = $scope.machineData.machineType
        $scope.isMonitoringMachine = $scope.machineData.machineTypeId.name === 'machine'
        $scope.getSessions()
      }
    }
  }
})();
(function () {
  'use strict';
  var angular = window.angular
  var _ = window._
  angular.module('Vibzer.components')
    .factory('FormlyFormService', FormlyFormService);

  /*
    Parse and evaluate formly form fields
  */
  /** @ngInject */
  function FormlyFormService () {
    /* parse and evaluate every expression from expression keys */
    var parseAndEvaluateFormlyFormObject = function (form) {
      var expressionKeys = ['validators', 'asyncValidators', 'expressionProperties', 'className', 'watcher', 'templateOptions']
      _.each(form, function (obj, key) {
        _.map(expressionKeys, function (expressionKey) {
          if (obj.hasOwnProperty(expressionKey)) {
            evaluateExpression(expressionKey, obj)
          }
        })
      })
      return form
    }

    /* Evaluate expression by expression key */
    var evaluateExpression = function (key, formObject) {
      switch (key) {
        case 'validators':
          _.each(formObject[key], function (obj, key) {
            obj.expression = new Function('return ' + obj.expression)() // eslint-disable-line
          })
          break
        case 'asyncValidators':
          _.each(formObject[key], function (obj, key) {
            obj.expression = new Function('return ' + obj.expression)() // eslint-disable-line
          })
          break
        case 'expressionProperties':
          if (_.isArray(formObject[key])) {
            var expressions = formObject[key]
            formObject[key] = {}
            _.map(expressions, function (expression) {
              var pair = expression.split(':')
              formObject[key][pair[0].trim()] = pair[1].trim()
            })
          }
          break
        case 'className':
          if (formObject[key] === 'row' && formObject.hasOwnProperty('fieldGroup')) {
            evaluateRow(formObject['fieldGroup'])
          }
          break
        case 'watcher':
          if (formObject[key].hasOwnProperty('expression')) {
            formObject[key].expression = new Function('return ' + formObject[key].expression)() // eslint-disable-line
          }

          if (formObject[key].hasOwnProperty('listener')) {
            formObject[key].listener = new Function('return ' + formObject[key].listener)() // eslint-disable-line
          }
          break
        default:
          break
      }
      return formObject
    }
    /* evaluate fieldgroup field of form */
    function evaluateRow (fieldGroup) {
      _.map(fieldGroup, function (value) {
        if (value.hasOwnProperty('expressionProperties')) {
          evaluateExpression('expressionProperties', value)
        }
        if (value.hasOwnProperty('watcher')) {
          evaluateExpression('watcher', value)
        }
        if (value.hasOwnProperty('validators')) {
          evaluateExpression('validators', value)
        }
        if (value.hasOwnProperty('asyncValidators')) {
          evaluateExpression('asyncValidators', value)
        }
        if (value.hasOwnProperty('fieldGroup')) {
          evaluateRow(value['fieldGroup'])
        }
      })
    }
    return {
      parseAndEvaluateFormlyFormObject: parseAndEvaluateFormlyFormObject
    }
  }
})();
/**
 * @author n.poltoratsky
 * created on 27.06.2016
 */
(function () {
  'use strict';
  
  angular.module('Vibzer.components')
    .factory('CompositeService', CompositeService)
  
  /** @ngInject */
  function CompositeService ($resource) {
    var url = '/api/:action/:subAction'
    var resource = $resource(url, { filters: '@filters', page: '@page', limit: '@limit', fields: '@fields', sort: '@sort', plantId: '@plantId', areaId: '@areaId', id: '@id', stringifyData: '@stringifyData' }, {
      getAll: {
        method: 'GET',
        params: { 'action': 'composite', 'subAction': 'getAll' },
        headers: { 'Content-Type': 'application/json' }
      },
      getById: {
        method: 'GET',
        params: { 'action': 'composite', 'subAction': 'getById' },
        headers: { 'Content-Type': 'application/json' }
      },
      addComposite: {
        method: 'POST',
        params: { 'action': 'composite', 'subAction': 'add' },
        headers: { 'Content-Type': 'application/json' }
      },
      updateComposite: {
        method: 'PUT',
        params: { 'action': 'composite', 'subAction': 'update' },
        headers: { 'Content-Type': 'application/json' }
      },
      deleteComposite: {
        method: 'PUT',
        params: { 'action': 'composite', 'subAction': 'delete' },
        headers: { 'Content-Type': 'application/json' }
      }
    })
    return {
      resource: resource
    }
  }
  
})();
  
/**
 * @author n.poltoratsky
 * created on 27.06.2016
 */
(function () {
  'use strict';

  angular.module('Vibzer.components')
    .factory('CustomerService', customerService)

  /** @ngInject */
  function customerService ($resource) {
    var url = '/api/:action/:subAction/:subAction1/:customer/:customerId'

    var resource = $resource(url, { filters: '@filters', page: '@page', limit: '@limit', fields: '@fields', sort: '@sort', plantId: '@plantId', areaId: '@areaId', id: '@id', stringifyData: '@stringifyData' }, {
      getMsg: {
        method: 'GET',
        params: { 'action': 'customer', 'subAction': 'sendMeMsg' },
        headers: { 'Content-Type': 'application/json' }
      },
      update: {
        method: 'PUT',
        params: { 'action': 'customer', 'subAction': 'update' },
        headers: { 'Content-Type': 'application/json' }
      },
      add: {
        method: 'POST',
        params: { 'action': 'customer', 'subAction': 'add' },
        headers: { 'Content-Type': 'application/json' }
      },
      getAll: {
        method: 'GET',
        params: { 'action': 'customer', 'subAction': 'getAll' },
        headers: { 'Content-Type': 'application/json' }
      },
      getById: {
        method: 'GET',
        params: { 'action': 'customer', 'subAction': 'getById' },
        headers: { 'Content-Type': 'application/json' }
      },
      activateOrDeactivate: {
        method: 'PUT',
        params: { 'action': 'customer', 'subAction': 'activateOrDeactivate' },
        headers: { 'Content-Type': 'application/json' }
      },
      removeById: {
        method: 'DELETE',
        params: { 'action': 'customer', 'subAction': 'removeById' },
        headers: { 'Content-Type': 'application/json' }
      },
      getCustomerAdminsByCustomerId: {
        method: 'GET',
        params: { 'action': 'customer', 'subAction': 'getCustomerAdminsByCustomerId' },
        headers: { 'Content-Type': 'application/json' }
      }
    })
    return {
      resource: resource
    }
  }

})();

(function () {
  'use strict';
  var angular = window.angular
  angular.module('Vibzer.components')
    .factory('DeviceService', deviceService);

  /** @ngInject */
  function deviceService ($resource) {
    var url = '/api/:action/:subAction'

    var resource = $resource(url, {}, {
      getDevices: {
        method: 'GET',
        params: { 'action': 'device', 'subAction': 'getAccessibleDevices' },
        headers: { 'Content-Type': 'application/json' }
      },
      addDevice: {
        method: 'POST',
        params: { 'action': 'device', 'subAction': 'add' },
        headers: { 'Content-Type': 'application/json' }
      },
      updateDevice: {
        method: 'PUT',
        params: { 'action': 'device', 'subAction': 'update' },
        headers: { 'Content-Type': 'application/json' }
      },
      deleteDevice: {
        method: 'PUT',
        params: { 'action': 'device', 'subAction': 'delete' },
        headers: { 'Content-Type': 'application/json' }
      },
      detachDevice: {
        method: 'PUT',
        params: { 'action': 'device', 'subAction': 'remove' },
        headers: { 'Content-Type': 'application/json' }
      },
      getAllTimezones: {
        method: 'GET',
        params: { 'action': 'device', 'subAction': 'getAllTimezones' },
        headers: { 'Content-Type': 'application/json' }
      },
      getByMacId: {
        method: 'GET',
        params: { 'action': 'device', 'subAction': 'getByMacId' },
        headers: { 'Content-Type': 'application/json' }
      },
      updateCalibrationConstants: {
        method: 'PUT',
        params: { 'action': 'device', 'subAction': 'updateCalibrationConstants' },
        headers: { 'Content-Type': 'application/json' }
      }
    })
    return {
      resource: resource
    }
  }
})();
(function () {
  'use strict';

  angular.module('Vibzer.components')
    .factory('DistributorService', distributorService);

  /** @ngInject */
  function distributorService ($resource) {
    var url = '/api/:action/:subAction'

    var resource = $resource(url, {}, {
      getAllDistributors: {
        method: 'GET',
        params: { 'action': 'distributor', 'subAction': 'getAll' },
        headers: { 'Content-Type': 'application/json' }
      },
      add: {
        method: 'POST',
        params: { 'action': 'distributor', 'subAction': 'add' },
        headers: { 'Content-Type': 'application/json' }
      },
      addDistributorAdmin: {
        method: 'POST',
        params: { 'action': 'distributor', 'subAction': 'addDistributorAdmin' },
        headers: { 'Content-Type': 'application/json' }
      },
      update: {
        method: 'PUT',
        params: { 'action': 'distributor', 'subAction': 'update' },
        headers: { 'Content-Type': 'application/json' }
      },
      getById: {
        method: 'GET',
        params: { 'action': 'distributor', 'subAction': 'getById' },
        headers: { 'Content-Type': 'application/json' }
      },
      allCountries: {
        method: 'GET',
        params: { 'action': 'distributor', 'subAction': 'allCountries' },
        headers: { 'Content-Type': 'application/json' }
      }
    })
    return {
      resource: resource
    }
  }
})();
(function () {
  'use strict';

  angular.module('Vibzer.components')
    .factory('EventLogService', eventLogService);

  /** @ngInject */
  function eventLogService ($resource) {
    var url = '/api/:action/:subAction'

    var resource = $resource(url, {}, {
      getAllMachinesAlerts: {
        method: 'GET',
        params: { 'action': 'eventLog', 'subAction': 'machineLogs' },
        headers: { 'Content-Type': 'application/json' }
      }
    })
    return {
      resource: resource
    }
  }
})();
(function () {
  'use strict';

  angular.module('Vibzer.components.machines')
    .factory('GraphService', GraphService);
  function GraphService($timeout) {
    var customCharts = {
      lineChart: {
        options: {
          chart: {
            type: 'lineChart',
            height: 350,
            margin: {
              top: 10,
              right: 40,
              bottom: 40,
              left: 80
            },
            x: function (d) { return d.x },
            y: function (d) { return d.y },
            forceY: [0.5, 5.5],
            reduceXTicks: false,
            useVoronoi: true,
            useInteractiveGuideline: true
          }
        }
      }
    }

    var graphInitialization = function ($scope, requireCharts) {
      if (requireCharts) {
        _.forEach(requireCharts, function (chart) {
          $scope[chart] = customCharts[chart]
        })
      }
      $scope.gridsterOptions = {
        margins: [10, 10],
        columns: 3,
        swapping: true,
        floating: true,
        mobileModeEnabled: true,
        draggable: {
          handle: 'h3'
        },
        resizable: {
          enabled: true,
          handles: ['n', 'e', 's', 'w', 'ne', 'se', 'sw', 'nw'],
          start: function (event, $element, widget) { }, // optional callback fired when resize is started
          resize: function (event, $element, widget) { // optional callback fired when item is resized,
            if (widget.chart.api) widget.chart.api.update()
          },
          stop: function (event, $element, widget) { // optional callback fired when item is finished resizing
            $timeout(function () {
              if (widget.chart.api) widget.chart.api.update()
            }, 400)
          }
        }
      }
      /* We want to manually handle `window.resize` event in each directive. So that we emulate `resize` event using $broadcast method and internally subscribe to this event in each directive. Define event handler */
      $scope.events = {
        resize: function (e, scope) {
          $timeout(function () {
            scope.api.update()
          }, 200)
        }
      }
      angular.element(window).on('resize', function (e) {
        $scope.$broadcast('resize')
      })

      $scope.config = {
        visible: false
      }
      $timeout(function () {
        $scope.config.visible = true
      }, 200)

      return $scope
    }
    return {
      graphInitialization: graphInitialization
    }
  }
})();
(function () {
  'use strict';

  angular.module('Vibzer.components')
    .factory('HierarchyService', HierarchyService);

  /** @ngInject */
  function HierarchyService($resource) {
    var url = '/api/:action/:subAction'

    var resource = $resource(url, {}, {
      getLowestHierarchies: {
        method: 'GET',
        params: { 'action': 'hierarchy', 'subAction': 'lowest' },
        headers: { 'Content-Type': 'application/json' }
      },
      getHierarchiesToAssign: {
        method: 'GET',
        params: { 'action': 'hierarchy', 'subAction': 'getHierarchiesToAssign' },
        headers: { 'Content-Type': 'application/json' }
      },
      getAll: {
        method: 'GET',
        params: { 'action': 'hierarchy', 'subAction': 'getAll' },
        headers: { 'Content-Type': 'application/json' }
      },
      getById: {
        method: 'GET',
        params: { 'action': 'hierarchy', 'subAction': 'getById' },
        headers: { 'Content-Type': 'application/json' }
      },
      addHierarchy: {
        method: 'POST',
        params: { 'action': 'hierarchy', 'subAction': 'add' },
        headers: { 'Content-Type': 'application/json' }
      },
      update: {
        method: 'PUT',
        params: { 'action': 'hierarchy', 'subAction': 'update' },
        headers: { 'Content-Type': 'application/json' }
      },
      deleteById: {
        method: 'DELETE',
        params: { 'action': 'hierarchy', 'subAction': 'delete' },
        headers: { 'Content-Type': 'application/json' }
      },
      getMachineCountInHierarchy: {
        method: 'GET',
        params: { 'action': 'hierarchy', 'subAction': 'getMachineCount' },
        headers: { 'Content-Type': 'application/json' }
      }
    })
    return {
      resource: resource
    }
  }
})();
/**
 * @author n.poltoratsky
 * created on 27.06.2016
 */
(function () {
  'use strict';

  angular.module('Vibzer')
    .factory('errorInterceptor', errorInterceptor)

  /** @ngInject */
  function errorInterceptor($q, $injector) {
    var preventFurtherRequests = false

    return {
      request: function (config) {
        if (preventFurtherRequests) {
          return
        }

        return config || $q.when(config)
      },
      requestError: function (request) {
        return $q.reject(request)
      },
      response: function (response) {
        return response || $q.when(response)
      },
      responseError: function (response) {
        if (response && response.status === 401 && !_.includes(['login', 'changePassword', 'unauthorizedCustomer', 'machineReport', 'motorReport', 'pumpReport', 'fanReport', 'machineTrend', 'androidDashboardReport', ''], $injector.get('$state').current.name)) {
          if (response.data && response.data.msg === 'Invalid token') {
            $injector.get('UserService').clearCookies()
            $injector.get('$state').go('login')
            $injector.get('toastr').error('Access denied! Please re-login Or contact administrator')
          } else {
            $injector.get('toastr').error('Unauthorized!')
          }
        }
        if (response && response.status === 500) {
          preventFurtherRequests = true
        }

        return $q.reject(response)
      }
    }
  }
})();

(function () {
  window.angular.module('Vibzer.components')
    .factory('LicenseService', licenseService)

  /** @ngInject */
  function licenseService($resource) {
    var url = '/api/:action/:subAction'

    var resource = $resource(url, {}, {
      getAllCustomerLicenses: {
        method: 'GET',
        params: { 'action': 'license', 'subAction': 'customersLicenses' },
        headers: { 'Content-Type': 'application/json' }
      },
      getLicenseTypes: {
        method: 'GET',
        params: { 'action': 'license', 'subAction': 'types' },
        headers: { 'Content-Type': 'application/json' }
      },
      getLicensesAssignToDistributor: {
        method: 'GET',
        params: { 'action': 'license', 'subAction': 'assignedToDistributor' },
        headers: { 'Content-Type': 'application/json' }
      },
      assignLicenseToCustomer: {
        method: 'POST',
        params: { 'action': 'license', 'subAction': 'assign' },
        headers: { 'Content-Type': 'application/json' }
      },
      renew: {
        method: 'PUT',
        params: { 'action': 'license', 'subAction': 'renew' },
        headers: { 'Content-Type': 'application/json' }
      }
    })
    return {
      resource: resource
    }
  }
})();
(function () {
  'use strict'
  var angular = window.angular
  angular.module('Vibzer.components')
    .factory('MachineService', MachineService)
  var _ = window._
  var moment = window.moment
  /** @ngInject */
  function MachineService ($resource) {
    var url = '/api/:action/:subAction'

    var resource = $resource(url, {}, {
      getAllMachines: {
        method: 'GET',
        params: { 'action': 'machine', 'subAction': 'getAllMachinesWithLatestCondition' },
        headers: { 'Content-Type': 'application/json' }
      },
      getMachine: {
        method: 'GET',
        params: { 'action': 'machine', 'subAction': 'getMachine' },
        headers: { 'Content-Type': 'application/json' }
      },
      addMachine: {
        method: 'POST',
        params: { 'action': 'machine', 'subAction': 'add' },
        headers: { 'Content-Type': 'application/json' }
      },
      editMachine: {
        method: 'PUT',
        params: { 'action': 'machine', 'subAction': 'update' },
        headers: { 'Content-Type': 'application/json' }
      },
      deleteMachine: {
        method: 'PUT',
        params: { 'action': 'machine', 'subAction': 'delete' },
        headers: { 'Content-Type': 'application/json' }
      },
      duplicateMachine: {
        method: 'POST',
        params: { 'action': 'machine', 'subAction': 'duplicate' },
        headers: { 'Content-Type': 'application/json' }
      },
      regenerateReport: {
        method: 'POST',
        params: { 'action': 'util', 'subAction': 'regenerateReports' },
        headers: { 'Content-Type': 'application/json' }
      }
    })

    var initialMonitoringSchedule = {
      days: {
        allOperatingDays: true,
        specificDaysInWeek: []
      },
      hours: {
        specificHoursOfTheDay: [],
        everyMinutesOfOperatingHours: '5'
      }
    }
    var initialSchedule = {
      version: '1.0.0',
      operating: {
        days: {
          allDays: true,
          specificDaysInWeek: []
        },
        hours: {
          twentyFourHours: true,
          specificHoursOfTheDay: []
        }
      },
      normal: angular.copy(initialMonitoringSchedule),
      warning: angular.copy(initialMonitoringSchedule),
      alert: angular.copy(initialMonitoringSchedule)
    }

    initialSchedule.normal.hours.onceDayAt = {
      hour: '1',
      minutes: '0'
    }
    initialSchedule.warning.sameAsOperating = true
    initialSchedule.warning.sameAsNormal = true
    initialSchedule.alert.sameAsWarning = true

    var initialDistributionList = [
      {
        id: 1,
        name: 'Engineer',
        portable: {
          normal: true,
          warning: true,
          alert: true
        },
        permanent: {
          warning: true,
          alert: true,
          frequency: {
            instant: true,
            digest: true
          }
        }
      },
      {
        id: 2,
        name: 'Manager',
        portable: {
          normal: false,
          warning: true,
          alert: true
        },
        permanent: {
          warning: true,
          alert: true,
          frequency: {
            instant: true,
            digest: true
          }
        }
      }
    ]

    var createScheduleJson = function (scheduleType, schedule) {
      var formattedSchedule = angular.copy(initialSchedule[scheduleType])
      if (scheduleType === 'operating') {
        formattedSchedule.hours.twentyFourHours = schedule.hours.twentyFourHours
      }
      if (scheduleType === 'normal') {
        formattedSchedule.hours.onceDayAt = {
          hour: 0, minutes: 0
        }
        formattedSchedule.hours.everyMinutesOfOperatingHours = 0
        formattedSchedule.sameAsOperating = schedule.sameAsOperating
      }
      if (scheduleType === 'warning') {
        formattedSchedule.sameAsNormal = schedule.sameAsNormal
        formattedSchedule.hours.everyMinutesOfOperatingHours = 0
      }
      if (scheduleType === 'alert') {
        formattedSchedule.sameAsWarning = schedule.sameAsWarning
        formattedSchedule.hours.everyMinutesOfOperatingHours = 0
      }
      if (!(scheduleType === 'warning' && schedule.sameAsNormal) && !(scheduleType === 'alert' && schedule.sameAsWarning)) {
        formattedSchedule.days = angular.copy(schedule.days)
        if (schedule.scheduleTime === 1) {
          if (scheduleType === 'normal') {
            formattedSchedule.hours.onceDayAt = angular.copy(schedule.hours.onceDayAt)
          }
        } else if (schedule.scheduleTime === 2) {
          formattedSchedule.hours.specificHoursOfTheDay = angular.copy(schedule.hours.specificHoursOfTheDay)
        } else {
          formattedSchedule.hours.everyMinutesOfOperatingHours = angular.copy(schedule.hours.everyMinutesOfOperatingHours)
        }
      }
      return formattedSchedule
    }

    var learningModeDaysCalculation = function (data, learningCount, minDays, maxDays) {
      var estimatedDays = 0
      var scheduleCountInWeek = 0
      var startCount = false
      var countDays = function () {
        _.map(['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday', 'Sunday'], function (day) {
          if (!startCount) {
            startCount = data.days.specificDaysInWeek[0] === day
          }
          if (startCount && _.includes(data.days.specificDaysInWeek, day)) {
            scheduleCountInWeek += oneDayCount
          }
          if (startCount && (scheduleCountInWeek < learningCount || (scheduleCountInWeek - oneDayCount) < learningCount)) {
            estimatedDays++
          }
        })
        if (scheduleCountInWeek < learningCount) {
          countDays()
        }
      }
      var oneDayCount = !data.hours.twentyFourHours ? data.hours.specificHoursOfTheDay.length : 24
      if (!oneDayCount) {
        return 0
      }
      if (data.days.allDays) {
        estimatedDays = learningCount / oneDayCount
      } else if (data.days.specificDaysInWeek.length) {
        data.days.specificDaysInWeek = _.map(_.sortBy(_.map(data.days.specificDaysInWeek, function (day) {
          return parseInt(moment().day(day).format('d'))
        })), function (day) {
          return moment().day(day).format('dddd')
        })
        countDays()
      }
      if (minDays && estimatedDays < minDays) {
        estimatedDays = minDays
      } else if (maxDays && estimatedDays > maxDays) {
        estimatedDays = maxDays
      }
      return Math.round(estimatedDays)
    }
    return {
      resource: resource,
      initialDistributionList: initialDistributionList,
      initialSchedule: initialSchedule,
      learningModeDaysCalculation: learningModeDaysCalculation,
      createJSON: createScheduleJson
    }
  }
})();
(function () {
    'use strict';

    angular.module('Vibzer.components')
        .factory('MachineTypeService', MachineTypeService);

    /** @ngInject */
    function MachineTypeService($resource) {
        var url = '/api/:action/:subAction'

        var resource = $resource(url, {}, {
            getAllMachineTypes: {
                method: 'GET',
                params: { 'action': 'machineType', 'subAction': 'getAll' },
                headers: { 'Content-Type': 'application/json' }
            }
        })
        return {
            resource: resource
        }
    }
})();
(function () {
  'use strict';

  angular.module('Vibzer.components')
    .factory('NotificationService', notificationService);

  /** @ngInject */
  function notificationService ($resource) {
    var url = '/api/:action/:subAction'

    var resource = $resource(url, {}, {
      getNotifications: {
        method: 'GET',
        params: { 'action': 'notification', 'subAction': 'getUserNotifications' },
        headers: { 'Content-Type': 'application/json' }
      },
      readNotification: {
        method: 'PUT',
        params: { 'action': 'notification', 'subAction': 'readNotification' },
        headers: { 'Content-Type': 'application/json' }
      },
      removeNotification: {
        method: 'PUT',
        params: { 'action': 'notification', 'subAction': 'removeNotification' },
        headers: { 'Content-Type': 'application/json' }
      }
    })
    return {
      resource: resource
    }
  }
})();
/**
 * @author n.poltoratsky
 * created on 27.06.2016
 */
(function () {
  'use strict';

  angular.module('Vibzer.components')
    .factory('PermissionService', PermissionService)

  /** @ngInject */
  function PermissionService ($resource) {
    var url = '/api/:action/:subAction'

    var resource = $resource(url, { filters: '@filters', page: '@page', limit: '@limit', fields: '@fields', sort: '@sort', plantId: '@plantId', areaId: '@areaId', id: '@id', stringifyData: '@stringifyData' }, {
      hasPermission: {
        method: 'GET',
        params: { 'action': 'permission', 'subAction': 'hasPermission' },
        headers: { 'Content-Type': 'application/json' }
      }
    })
    return {
      resource: resource
    }
  }

})();

(function () {
  window.angular.module('Vibzer.components')
    .factory('PurchaseService', purchaseService)

  /** @ngInject */
  function purchaseService($resource) {
    var url = '/api/:action/:subAction'

    var resource = $resource(url, {}, {
      getAllPurchasedDevices: {
        method: 'GET',
        params: { 'action': 'purchase', 'subAction': 'devices' },
        headers: { 'Content-Type': 'application/json' }
      }
    })
    return {
      resource: resource
    }
  }
})();
(function () {
  window.angular.module('Vibzer.components')
    .factory('ReadingService', readingService)

  /** @ngInject */
  function readingService($resource) {
    var url = '/api/:action/:subAction'

    var resource = $resource(url, {}, {
      processedVibrationDataOfPoint: {
        method: 'GET',
        params: { 'action': 'reading', 'subAction': 'processedVibrationDataOfPoint' },
        headers: { 'Content-Type': 'application/json' }
      },
      getVibrationDataForGraph: {
        method: 'GET',
        params: { 'action': 'reading', 'subAction': 'getVibrationDataForGraph' },
        headers: { 'Content-Type': 'application/json' }
      },
      getCalibrationData: {
        method: 'GET',
        params: { 'action': 'reading', 'subAction': 'getCalibrationData' },
        headers: { 'Content-Type': 'application/json' }
      }
    })
    return {
      resource: resource
    }
  }
})();
/**
 * @author n.poltoratsky
 * created on 27.06.2016
 */
(function () {
    'use strict';

    angular.module('Vibzer.components.machines')
        .factory('ReportCtrlService', ReportCtrlService);

    /** @ngInject */
    function ReportCtrlService($state, $uibModal) {
        var getAvgStdAndIsoReport = function (machineData) {
            if (machineData.type !== 'machine') {
                return {
                    contamination: false,
                    created: "2018-08-10T15:50:53.564Z",
                    customer: {
                        _id: "5a0abdb0dd4fba19dc560df9",
                        name: "RTPL"
                    },
                    daysToTest: 90,
                    isPerfectReport: false,
                    isoReport: {
                        bearingRecommendations: [],
                        bearingSeverity: 1,
                        unbalanceRecommendations: [],
                        unbalanceSeverity: 1,
                        misalignmentRecommendations: [],
                        misalignmentSeverity: 1,
                        operationRecommendations: [],
                        operationSeverity: 1,
                        finalRecommendations: [
                            "The Motor is in dangerous condition.Must be taken out of operation and repaired immediately.",
                            "ATTENTION: IT IS POSSIBLE THAT THE REAL ROTATION SPEED IS DIFFERENT TO THE ONE REGISTERED. IF THIS WAS THE CASE, THE DIAGNOSTIC IS INVALID.",
                            "VERIFY AND REGISTER THE ACTUAL ROTATION SPEED AND TEST IT AGAIN.",
                            "Is this a critical motor? Stop and repair it immediately!",
                            "There were high vibrations at low frequencies. Was the collector well fixated? Check the foundation of the motor!",

                        ],
                        finalSeverity: 5,
                    },
                    lastReport: {
                        bearingRecommendations: [],
                        bearingSeverity: 1,
                        unbalanceRecommendations: [],
                        unbalanceSeverity: 1,
                        misalignmentRecommendations: [],
                        misalignmentSeverity: 1,
                        operationRecommendations: [],
                        operationSeverity: 1,
                        finalRecommendations: [
                            "The Motor is in dangerous condition.Must be taken out of operation and repaired immediately.",
                            "ATTENTION: IT IS POSSIBLE THAT THE REAL ROTATION SPEED IS DIFFERENT TO THE ONE REGISTERED. IF THIS WAS THE CASE, THE DIAGNOSTIC IS INVALID.",
                            "VERIFY AND REGISTER THE ACTUAL ROTATION SPEED AND TEST IT AGAIN.",
                            "Is this a critical motor? Stop and repair it immediately!",
                            "There were high vibrations at low frequencies. Was the collector well fixated? Check the foundation of the motor!",

                        ],
                    },
                    machine: {
                        _id: "5b6978e56de675002d2c308e",
                        machineId: machineData.name,
                        type: machineData.type
                    },
                    machineId: "5b6978e56de675002d2c308e",
                    machineIsoState: "EEEEE1",
                    machineState: "EEEEE1",
                    report: {
                        bearingRecommendations: [],
                        bearingSeverity: 1,
                        unbalanceRecommendations: [],
                        unbalanceSeverity: 1,
                        misalignmentRecommendations: [],
                        misalignmentSeverity: 1,
                        operationRecommendations: [],
                        operationSeverity: 1,
                        finalRecommendations: [
                            "The Motor is in dangerous condition.Must be taken out of operation and repaired immediately.",
                            "ATTENTION: IT IS POSSIBLE THAT THE REAL ROTATION SPEED IS DIFFERENT TO THE ONE REGISTERED. IF THIS WAS THE CASE, THE DIAGNOSTIC IS INVALID.",
                            "VERIFY AND REGISTER THE ACTUAL ROTATION SPEED AND TEST IT AGAIN.",
                            "Is this a critical motor? Stop and repair it immediately!",
                            "There were high vibrations at low frequencies. Was the collector well fixated? Check the foundation of the motor!",

                        ],
                        finalSeverity: 1
                    },
                    vibzerExSysVersion: "2.1"
                }
            } else {
                return {
                    contamination: false,
                    created: "2018-08-17T13:15:37.143Z",
                    customer: { _id: "59267ec1d275010a6524158d", name: "Raykor" },
                    isoReport: {
                        shockSeverity: 1,
                        shockSeverityRecommendations: [
                            "The measured point shows low impact levels, indicating good condition.",
                            "Measure this point again in 3 to 6 months."],
                        vibrationSeverity: 3,
                        vibrationSeverityRecommendations: [
                            "The measured point shows above average vibration levels, indicating some developing problem.",
                            "Measure this point again in 1 month or less."]
                    },
                    lastReport: {
                        shockSeverity: 3,
                        shockSeverityRecommendations: [
                            "The measured point shows above average shock levels, indicating some developing problem.",
                            "Measure this point again in 1 month or less."],
                        vibrationSeverity: 1,
                        vibrationSeverityRecommendations: [
                            "The measured point shows low vibration levels, indicating good condition.",
                            "Measure this point again in 3 to 6 months."]
                    },
                    machine: {
                        _id: "5b76c0fa90a973001092adab",
                        machineId: machineData.name,
                        type: machineData.type,
                    },
                    machineId: machineData.name,
                    machineIsoState: "EEEEE3",
                    machineState: "EEEEE3",
                    report: {
                        shockSeverity: 3,
                        shockSeverityRecommendations: [
                            "The measured point shows above average shock levels, indicating some developing problem.",
                            "Measure this point again in 1 month or less."],
                        vibrationSeverity: 1,
                        vibrationSeverityRecommendations: [
                            "The measured point shows low vibration levels, indicating good condition.",
                            "Measure this point again in 3 to 6 months."]
                    },
                    vibzerExSysVersion: "2.1"
                }
            }
        }

        var getCurrentAndLastProcessedReport = function (machineData) {
            if (machineData.type !== 'machine') {
                return {
                    contamination: false,
                    created: "2018-09-03T09:09:11.925Z",
                    customer: { _id: "59267ec1d275010a6524158d", name: "Raykor" },
                    uploader: {
                        firstName: "Admin",
                        lastName: "Test",
                        _id: "5ab4da79bbe566001647276a",
                        userActions: []
                    },
                    daysToTest: 0,
                    isPerfectReport: false,
                    lastReport: {
                        bearingRecommendations: [],
                        bearingSeverity: 1,
                        unbalanceRecommendations: [],
                        unbalanceSeverity: 1,
                        misalignmentRecommendations: [],
                        misalignmentSeverity: 1,
                        operationRecommendations: [],
                        operationSeverity: 1,
                        finalRecommendations: [
                            "Vibration levels are low, which indicates excellent condition.",
                            "Is this a critical motor? Test it again in three months."],
                        finalSeverity: 1,
                    },
                    machine: {
                        _id: "5b8cf9b8145c0700165be195",
                        machineId: machineData.machineName,
                        type: machineData.type,
                        measuringFrequency: {
                            type: 'month',
                            count: 1,
                            nextScheduleOn: "2018-10-13"
                        }
                    },
                    machineId: "5b8cf9b8145c0700165be195",
                    machineState: "EEEEE5",
                    report: {
                        bearingRecommendations: [
                            "The roller bearing of the coupling end is loose in its housing.",
                            "There is a resonance affecting the motor at the coupling end.",
                            "Contact your vibration analyst.",
                            "Inspect the tolerances of the housing for the roller bearing in the coupling end."],
                        bearingSeverity: 5,
                        finalRecommendations: [
                            "Is this a critical motor? Test it again in three months.",
                            "There were high vibrations at low frequencies. Was the collector well fixated? Check the foundation of the motor!"],
                        finalSeverity: 5,
                        misalignmentRecommendations: ["There is a dangerous misalignment.", "Align the machine or verify bearing alignment."],
                        misalignmentSeverity: 5,
                        operationRecommendations: [],
                        operationSeverity: 1,
                        unbalanceRecommendations: ["Verify the motor shaft, it could be bowed."],
                        unbalanceSeverity: 5,
                    },
                    vibzerExSysVersion: "1.1"
                }
            } else {
                return {
                    contamination: false,
                    created: "2018-08-17T13:15:37.143Z",
                    customer: { _id: "59267ec1d275010a6524158d", name: "Raykor" },
                    uploader: {
                        firstName: "Admin",
                        lastName: "Test",
                        _id: "5ab4da79bbe566001647276a",
                        userActions: []
                    },
                    lastReport: {
                        shockSeverity: 3,
                        shockSeverityRecommendations: [
                            "The measured point shows above average shock levels, indicating some developing problem.",
                            "Measure this point again in 1 month or less."],
                        vibrationSeverity: 1,
                        vibrationSeverityRecommendations: ["The measured point shows low vibration levels, indicating good condition.",
                            "Measure this point again in 3 to 6 months."]
                    },
                    machine: {
                        _id: "5b76c0fa90a973001092adab",
                        machineId: machineData.machineName,
                        type: machineData.type
                    },
                    machineId: machineData.machineName,
                    machineState: "EEEEE3",
                    report: {
                        shockSeverity: 3,
                        shockSeverityRecommendations: [
                            "The measured point shows above average shock levels, indicating some developing problem.",
                            "Measure this point again in 1 month or less."],
                        vibrationSeverity: 5,
                        vibrationSeverityRecommendations: [
                            "The measured point has very high vibration levels, indicating severe damage. Check the measured point immediately for parts or structural damage.",
                            "It is urgent to measure this point again and solve the problem."],
                    },
                    vibzerExSysVersion: "1.1"
                }
            }
        }

        var generateReportData = function (currentReport, lastReport, constants, reportType) {
            var properties = []
            reportType === 'machineReport' ? properties = constants.machineReportPropertiesSequence : properties = constants.motorReportPropertiesSequence
            return _.pull(_.map(properties, function (property) {
                if (!currentReport[property.severityName]) {
                    return null
                }
                lastReport[property.severityName] <= 0 ? lastReport[property.severityName] = 1 : null
                currentReport[property.severityName] <= 0 ? currentReport[property.severityName] = 1 : null
                var json = {
                    severityName: property.severityName,
                    currentSeverity: currentReport[property.severityName]
                }
                json.label = property.severityName === constants.motorReportPropertiesSequence[5].severityName ? 'General Observations & Recommendations' : (property.changeName || property.displayName)
                json.prev = Math.round(((((lastReport[property.severityName] - 1) || 0)) * 100) / 4)
                json.Current = Math.round(((((currentReport[property.severityName] - 1) || 0)) * 100) / 4)
                json.prev > 75 ? json.prev = json.prev - 6 : (json.prev < 25 ? json.prev = json.prev : null)
                json.Current > 75 ? json.Current = json.Current - 6 : (json.Current < 25 ? json.Current = json.Current : null)
                if (currentReport[property.recommendationName].length) {
                    json.recommendation = currentReport[property.recommendationName]
                    json.recLength = (currentReport[property.recommendationName] ? currentReport[property.recommendationName].length : null)
                } else {
                    json.recommendation = [] // 'No action required.'
                    json.recLength = 0
                }
                return json
            }), null)
        }

        return {
            getAvgStdAndIsoReport: getAvgStdAndIsoReport,
            getCurrentAndLastProcessedReport: getCurrentAndLastProcessedReport,
            generateReportData: generateReportData
        }
    }
})();
(function () {
  'use strict';

  angular.module('Vibzer.components')
    .factory('ReportService', ReportService);

  /** @ngInject */
  function ReportService($resource) {
    var url = '/api/:action/:subAction/:subAction2'

    var resource = $resource(url, {}, {
      getAllMachineSessions: {
        method: 'GET',
        params: { 'action': 'report', 'subAction': 'allMachineSession' },
        headers: { 'Content-Type': 'application/json' }
      },
      getOverallVibrationTrendData: {
        method: 'GET',
        params: { 'action': 'report', 'subAction': 'getOverallVibrationTrendData' },
        headers: { 'Content-Type': 'application/json' }
      },
      faultSpecificCondition: {
        method: 'GET',
        params: { 'action': 'report', 'subAction': 'trend', 'subAction2': 'faultSpecificCondition' },
        headers: { 'Content-Type': 'application/json' }
      },
      getCurrentAndLastReport: {
        method: 'GET',
        params: { 'action': 'report', 'subAction': 'getCurrentAndLastReportBySessionId' },
        headers: { 'Content-Type': 'application/json' }
      },
      addComment: {
        method: 'PUT',
        params: { 'action': 'report', 'subAction': 'commentForSession' },
        headers: { 'Content-Type': 'application/json' }
      },
      criteriaWiseAnalysis: {
        method: 'GET',
        params: { 'action': 'report', 'subAction': 'criteriaWiseAnalysis' },
        headers: { 'Content-Type': 'application/json' }
      },
      getLicenseDetails: {
        method: 'GET',
        params: { 'action': 'report', 'subAction': 'licenses' },
        headers: { 'Content-Type': 'application/json' }
      },
      getFaultSpecificTrendData: {
        method: 'GET',
        params: { 'action': 'report', 'subAction': 'trend', 'subAction2': 'faultSpecific' },
        headers: { 'Content-Type': 'application/json' }
      },
      getCrestFactorData: {
        method: 'GET',
        params: { 'action': 'report', 'subAction': 'trend', 'subAction2': 'crestFactor' },
        headers: { 'Content-Type': 'application/json' }
      },
      getOverallVibrationData: {
        method: 'GET',
        params: { 'action': 'report', 'subAction': 'trend', 'subAction2': 'overallVibration' },
        headers: { 'Content-Type': 'application/json' }
      },
      downloadRpb: {
        method: 'GET',
        params: { 'action': 'rpb', 'subAction': 'download' },
        headers: { 'Content-Type': 'application/json' }
      }
    })

    function getValuesOfCurrentPoint ($scope, point, xToFixed, yToFixed) {
      var values = {
        xValue: point[0].xval.toFixed(xToFixed || 2),
        yValues: _.map(point, function (pt) {
          return {
            label: $scope.graph.legend.series[pt.name].label,
            yVal: (Number.isInteger(pt.yval) ? pt.yval : pt.yval.toFixed(yToFixed || 2))
          }
        })
      }
      $scope.graph.options.xValueFormat === 'date' ? values.xValue = moment(new Date(point[0].xval)).format('MMMM Do YYYY, h:mm:ss a') : void 0
      $scope.$apply(function () {
        $scope.graph.currentValues = values
      })
    }

    function resetValuesOfCurrentPoint ($scope) {
      if (!$scope.graph.currentValues) return
      $scope.graph.currentValues.xValue = ''
      $scope.graph.currentValues.yValues = _.map($scope.graph.currentValues.yValues, function (pt) {
        pt.yVal = ''
        return pt
      })
    }

    var generateReportData = function (currentReport, lastReport, constants, reportType) {
      var properties = []
      reportType === 'machineReport' ? properties = constants.machineReportPropertiesSequence : properties = constants.motorReportPropertiesSequence
      return _.pull(_.map(properties, function (property) {
        if (!currentReport[property.severityName]) {
          return null
        }
        lastReport[property.severityName] <= 0 ? lastReport[property.severityName] = 1 : null
        currentReport[property.severityName] <= 0 ? currentReport[property.severityName] = 1 : null
        var json = {
          severityName: property.severityName,
          currentSeverity: currentReport[property.severityName]
        }
        json.label = property.severityName === constants.motorReportPropertiesSequence[5].severityName ? 'General Observations & Recommendations' : (property.changeName || property.displayName)
        json.prev = Math.round(((((lastReport[property.severityName] - 1) || 0)) * 100) / 4)
        json.Current = Math.round(((((currentReport[property.severityName] - 1) || 0)) * 100) / 4)
        json.prev > 75 ? json.prev = json.prev - 6 : (json.prev < 25 ? json.prev = json.prev : null)
        json.Current > 75 ? json.Current = json.Current - 6 : (json.Current < 25 ? json.Current = json.Current : null)
        if (currentReport[property.recommendationName].length) {
          json.recommendation = currentReport[property.recommendationName]
          json.recLength = (currentReport[property.recommendationName] ? currentReport[property.recommendationName].length : null)
        } else {
          json.recommendation = [] // 'No action required.'
          json.recLength = 0
        }
        return json
      }), null)
    }
    var setChartModelHeight = function () {
      window.$('#dgf').height(window.$('#graphContent').height() - window.$('#vData').height() - window.$('.modal-header').height() - 70)
      setTimeout(function () {
        if (window.dygraphApi && typeof window.dygraphApi.resize === 'function') {
          window.dygraphApi.resize()
        }
      }, 200)
    }

    var expandShrinkModel = function (expandModel) {
      if (expandModel) {
        window.$('.modal-xt-lg').addClass('modal-xt-lg-expand')
        window.$('.modal-header').addClass('modal-header-expand')
        window.$('.modal-content').addClass('modal-content-expand')
      } else {
        window.$('.modal-xt-lg').removeClass('modal-xt-lg-expand')
        window.$('.modal-header').removeClass('modal-header-expand')
        window.$('.modal-content').removeClass('modal-content-expand')
      }
      setChartModelHeight()
    }

    return {
      resource: resource,
      getValuesOfCurrentPoint: getValuesOfCurrentPoint,
      resetValuesOfCurrentPoint: resetValuesOfCurrentPoint,
      generateReportData: generateReportData,
      setChartModelHeight: setChartModelHeight,
      expandShrinkModel: expandShrinkModel
    }
  }
})();
(function () {
  'use strict'
  var angular = window.angular
  angular.module('Vibzer.components')
    .factory('RoleService', RoleService)

  /** @ngInject */
  function RoleService ($resource) {
    var url = '/api/:action/:subAction'

    var resource = $resource(url, {}, {
      getTopLevelRoleOfUser: {
        method: 'GET',
        params: { 'action': 'role', 'subAction': 'getTopLevelRoleOfUser' },
        headers: { 'Content-Type': 'application/json' }
      }
    })

    return {
      resource: resource
    }
  }
})();
(function () {
  'use strict';

  angular.module('Vibzer.components.machines')
    .factory('RouteCtrlService', RouteCtrlService);

  function RouteCtrlService($state, $uibModal) {
    var getRoutes = function () {
      return [{
        _id: 1,
        name: 'Route1',
        description: 'test',
        owner: [{
          _id: 1,
          name: 'manager'
        }],
        schedule: {
          type: 'month',
          count: 2
        },
        machines: [{
          _id: 1,
          name: 'machine1',
          level: 'plant/area/section',
          icon: 'icon-motor',
          vibrationInfo: {
            sessionId: '5ba780450123cd2',
            condition: 'Dangerous condition',
            created: '27/sept/2018 02:39pm',
            color: '#c0352e'
          }
        },
        {
          _id: 2,
          name: 'machine2',
          level: 'plant/area/section',
          icon: 'icon-motor',
          vibrationInfo: {
            sessionId: '5ba780450123cd2',
            condition: 'Passable condition',
            created: '27/sept/2018 02:39pm',
            color: '#fcb040'
          }
        }
        ]
      },
      {
        _id: 2,
        name: 'Route2',
        description: 'test',
        owner: {
          _id: 2,
          name: 'supervisor'
        },
        schedule: {
          type: 'month',
          count: 2
        },
        machines: [{
          _id: 1,
          name: 'machine1',
          level: 'plant/area/section',
          icon: 'icon-motor',
          vibrationInfo: {
            sessionId: '5ba780450123cd2',
            condition: 'Dangerous condition',
            created: '27/sept/2018 02:39pm',
            color: '#c0352e'
          }
        }]
      },
      {
        _id: 3,
        name: 'Route3',
        description: 'test',
        owner: {
          _id: 2,
          name: 'supervisor'
        },
        schedule: {
          type: 'month',
          count: 2
        },
        machines: [{
          _id: 1,
          name: 'machine1',
          level: 'plant/area/section',
          icon: 'icon-motor',
          vibrationInfo: {
            sessionId: '5ba780450123cd2',
            condition: 'Dangerous condition',
            created: '27/sept/2018 02:39pm',
            color: '#c0352e'
          }
        }]
      },
      {
        _id: 4,
        name: 'Route4',
        description: 'test',
        owner: {
          _id: 2,
          name: 'supervisor'
        },
        schedule: {
          type: 'month',
          count: 4
        },
        machines: [{
          _id: 1,
          name: 'machine1',
          level: 'plant/area/section',
          icon: 'icon-motor',
          vibrationInfo: {
            sessionId: '5ba780450123cd2',
            condition: 'Dangerous condition',
            created: '27/sept/2018 02:39pm',
            color: '#c0352e'
          }
        }]
      },
      {
        _id: 5,
        name: 'Route5',
        description: 'test',
        owner: {
          _id: 2,
          name: 'supervisor'
        },
        schedule: {
          type: 'month',
          count: 1
        },
        machines: [{
          _id: 1,
          name: 'machine1',
          level: 'plant/area/section',
          icon: 'icon-motor',
          vibrationInfo: {
            sessionId: '5ba780450123cd2',
            condition: 'Dangerous condition',
            created: '27/sept/2018 02:39pm',
            color: '#c0352e'
          }
        }]
      }]
    }
    var addRoute = function () {
      var modalInstance = $uibModal.open({
        templateUrl: 'app/components/machines/modals/addRoute.html',
        controller: 'AddRouteCtrl',
        resolve: {
          data: {}
        }
      });
      modalInstance.result.then(function (result) {
      })
    }

    var editRoute = function (route) {
      var modalInstance = $uibModal.open({
        templateUrl: 'app/components/machines/modals/addRoute.html',
        controller: 'AddRouteCtrl',
        resolve: {
          data: route
        }
      });
      modalInstance.result.then(function (result) {
      })
    }

    var deleteRoute = function (data) {
      var modalInstance = $uibModal.open({
        templateUrl: 'app/components/machines/modals/deleteConfirmation.html',
        controller: 'DeleteConfirmationCtrl',
        resolve: {
          resolveData: {
            label: data.name
          }
        }
      });
      modalInstance.result.then(function (result) {
      })
    }

    return {
      getRoutes: getRoutes,
      addRoute: addRoute,
      editRoute: editRoute,
      deleteRoute: deleteRoute
    }
  }
})();
/**
 * @author n.poltoratsky
 * created on 27.06.2016
 */
(function () {
  'use strict';

  angular.module('Vibzer.components')
    .factory('RouteService', RouteService)

  /** @ngInject */
  function RouteService ($resource) {
    var url = '/api/:action/:subAction'

    var resource = $resource(url, { filters: '@filters', page: '@page', limit: '@limit', fields: '@fields', sort: '@sort', plantId: '@plantId', areaId: '@areaId', id: '@id', stringifyData: '@stringifyData' }, {
      getAll: {
        method: 'GET',
        params: { 'action': 'route', 'subAction': 'getAll' },
        headers: { 'Content-Type': 'application/json' }
      },
      getRoute: {
        method: 'GET',
        params: { 'action': 'route', 'subAction': 'getById' },
        headers: { 'Content-Type': 'application/json' }
      },
      addRoute: {
        method: 'POST',
        params: { 'action': 'route', 'subAction': 'add' },
        headers: { 'Content-Type': 'application/json' }
      },
      updateRoute: {
        method: 'PUT',
        params: { 'action': 'route', 'subAction': 'update' },
        headers: { 'Content-Type': 'application/json' }
      },
      deleteRoute: {
        method: 'PUT',
        params: { 'action': 'route', 'subAction': 'delete' },
        headers: { 'Content-Type': 'application/json' }
      }
    })
    return {
      resource: resource
    }
  }

})();

/**
 * @author n.poltoratsky
 * created on 27.06.2016
 */
(function () {
  'use strict';
  var angular = window.angular
  angular.module('Vibzer.components')
    .factory('SystemSettingService', systemSettingService)

  /** @ngInject */
  function systemSettingService ($resource) {
    var url = '/api/:action/:subAction'

    var resource = $resource(url, {}, {
      getSetting: {
        method: 'GET',
        params: { 'action': 'systemSetting', 'subAction': 'get' },
        headers: { 'Content-Type': 'application/json' }
      }
    })
    return {
      resource: resource
    }
  }
})();

/**
 * @author n.poltoratsky
 * created on 27.06.2016
 */
(function () {
  'use strict';
  var _ = window._
  angular.module('Vibzer.components')
    .factory('UserService', userService)

  /** @ngInject */
  function userService ($rootScope, $cookies, $window, $stateParams, $resource, constants, vcRecaptchaService) {
    var url = '/api/:action/:subAction/:_id/:customerId'

    var resource = $resource(url, { _id: '@_id', customerId: '@customerId' }, {
      login: {
        method: 'POST',
        params: { 'action': 'user', 'subAction': 'login' },
        headers: { 'Content-Type': 'application/json' }
      },
      getAppConfig: {
        method: 'GET',
        url: '/api/user/getAppConfig',
        headers: { 'Content-Type': 'application/json' }
      },
      logout: {
        method: 'POST',
        params: { 'action': 'user', 'subAction': 'logout' },
        headers: { 'Content-Type': 'application/json' }
      },
      getDetails: {
        method: 'GET',
        params: { 'action': 'user', 'subAction': 'getDetails' },
        headers: { 'Content-Type': 'application/json' }
      },
      getUserById: {
        method: 'GET',
        params: { 'action': 'user', 'subAction': 'getUserById' },
        headers: { 'Content-Type': 'application/json' }
      },
      changePassword: {
        method: 'PUT',
        params: { 'action': 'user', 'subAction': 'changePassword' },
        headers: { 'Content-Type': 'application/json' }
      },
      resetPassword: {
        method: 'PUT',
        params: { 'action': 'user', 'subAction': 'resetPassword' },
        headers: { 'Content-Type': 'application/json' }
      },
      addUser: {
        method: 'POST',
        params: { 'action': 'user', 'subAction': 'add' },
        headers: { 'Content-Type': 'application/json' }
      },
      getUserRolesWithResource: {
        method: 'GET',
        params: { 'action': 'user', 'subAction': 'getUserRolesWithResource' },
        headers: { 'Content-Type': 'application/json' }
      },
      updateUser: {
        method: 'PUT',
        params: { 'action': 'user', 'subAction': 'update' },
        headers: { 'Content-Type': 'application/json' }
      },
      assignRoles: {
        method: 'POST',
        params: { 'action': 'user', 'subAction': 'assignRole' },
        headers: { 'Content-Type': 'application/json' }
      },
      removeRole: {
        method: 'PUT',
        params: { 'action': 'user', 'subAction': 'removeRole' },
        headers: { 'Content-Type': 'application/json' }
      },
      activateOrDeactivateUser: {
        method: 'PUT',
        params: { 'action': 'user', 'subAction': 'activateOrDeactivateUser' },
        headers: { 'Content-Type': 'application/json' }
      },
      getAllUsersOfCustomer: {
        method: 'GET',
        params: { 'action': 'user', 'subAction': 'getAllUsersOfCustomer' },
        headers: { 'Content-Type': 'application/json' }
      },
      getAllPermissionsOfUser: {
        method: 'GET',
        params: { 'action': 'user', 'subAction': 'roles' },
      },
      getLevelUserWithRole: {
        method: 'GET',
        params: { 'action': 'user', 'subAction': 'getLevelUserWithRole' },
        headers: { 'Content-Type': 'application/json' }
      },
      getAllUsersForDistributionList: {
        method: 'GET',
        params: { 'action': 'user', 'subAction': 'getAllUsersForDistributionList' },
        headers: { 'Content-Type': 'application/json' }
      },
      checkUserPermission: {
        method: 'GET',
        params: { 'action': 'user', 'subAction': 'checkUserPermission' },
        headers: { 'Content-Type': 'application/json' }
      },
      getLevelUsersBasedOnPermissions: {
        method: 'GET',
        params: { 'action': 'user', 'subAction': 'getLevelUsersBasedOnPermissions' },
        headers: { 'Content-Type': 'application/json' }
      },
      getUsersByRole: {
        method: 'GET',
        params: { 'action': 'user', 'subAction': 'getUsersByRole' },
        headers: { 'Content-Type': 'application/json' }
      }
    })
    var checkLoggedInUser = function () {
      var userId = $cookies.get('userId')
      var token = $cookies.get('authToken')
      return (userId && token && true)
    }
    var getLoggedInUser = function () {
      if (checkLoggedInUser()) return $rootScope.user
    }

    var getUserDisplayName = function () {
      var displayName = null
      if ($rootScope.user && $rootScope.user.firstName && $rootScope.user.lastName) {
        displayName = $rootScope.user.firstName + ' ' + $rootScope.user.lastName
      } else if ($rootScope.user && $rootScope.user.username) {
        displayName = $rootScope.user.username
      }
      return displayName
    }

    var hasPermission = function (newPermission, option) {
      if (!newPermission) {
        return false
      }
      var checkOption = option || 'all'
      if (_.isString(newPermission)) {
        var permission = newPermission.split(',') || []
      } else {
        permission = newPermission || []
      }
      if (!$rootScope.user) {
        $rootScope.user = $cookies.getObject('vcUser')
      }
      if (!_.get($rootScope.user, 'permissions')) {
        return false
      }
      var userPermissions = _.map($rootScope.user.permissions, 'name')
      var matchedPermissions = _.intersection(permission, userPermissions)
      if (checkOption === 'all') {
        return (matchedPermissions.length === permission.length)
      }
      if (checkOption === 'any') {
        return matchedPermissions.length > 0
      }
    }

    var reloadUserPermission = function (userId) {
      var permissionToCheck = ['canViewMachines', 'addUser', 'addMachine', 'editMachine', 'canViewOwnedMachines', 'viewRoutes', 'addRoute', 'editRoute', 'deleteRoute', 'viewComposites', 'addComposite', 'analyzeMachine', 'addDistributorUser', 'addCustomer']
      resource.getAllPermissionsOfUser({ _id: userId }, function (res) {
        var permissions = []
        var user = $cookies.getObject('vcUser')
        user.permission = {}
        if (res.result && res.result.length > 0) {
          _.each(res.result, function (item) {
            permissions = _.concat(permissions, item.permissionIds)
          })
          permissions = _.uniqBy(permissions, '_id')
        }
        _.each(permissions, function (item) {
          if (_.includes(permissionToCheck, item.name)) {
            user.permission[item.name] = true
          }
        })
        $cookies.putObject('vcUser', user)
        $rootScope.user = angular.copy(user)
        $rootScope.$broadcast('showOrHideSidebarMenu')
      })
    }

    var recaptchaInit = function ($scope) {
      $scope.model = {
        key: '6Lff4TsUAAAAANazfBWukmoA5uTZuZcvy84c0Ahk'
      }
      $scope.setResponse = function (response) {
        $scope.response = response
      }
      $scope.setWidgetId = function (widgetId) {
        $scope.widgetId = widgetId
      }
      $scope.cbExpiration = function () {
        vcRecaptchaService.reload($scope.widgetId)
        $scope.response = null
      }
      return $scope
    }

    var manageCookies = function (action) {
      if (action === 'add') {
        $cookies.put('userId', $stateParams.id)
        $cookies.put('authToken', $stateParams.tkn)
        var userInfo = { _id: $stateParams.id }
        $stateParams.cId ? userInfo.customers = [$stateParams.cId] : void 0
        $cookies.putObject('vcUser', userInfo)
        $rootScope.user = userInfo
        $rootScope.authToken = $stateParams.tkn || $cookies.get('authToken')
      } else {
        window.angular.forEach($cookies.getAll(), function (v, k) {
          $cookies.remove(k)
        })
      }
    }

    var clearCookies = function () {
      manageCookies('clear')
      window.localStorage.clear()
      delete $rootScope.user
      delete $rootScope.authToken
    }

    var logout = function () {
      resource.logout({}, function () {}, function (err) {
        console.log(err)
      })
      clearCookies()
    }

    var basicInfo
    var roleInfo
    var setBasicInfo = function (data) {
      basicInfo = data
    }

    var getBasicInfo = function () {
      return basicInfo
    }

    var setRoles = function (data) {
      roleInfo = data
    }

    var getRoles = function () {
      return roleInfo
    }

    var clearFields = function () {
      basicInfo = {}
      roleInfo = []
    }

    var createRolesJson = function (roleInfo) {
      var roleData = []
      var resource
      _.map(roleInfo, function (itm) {
        var role
        if (itm.role === constants.roles[3].name) {
          role = _.find(roleData, function (item) {
            if (item.role === itm.role && itm.parentId === item.resources[0].parentId) {
              return item
            }
          })
        } else {
          role = _.find(roleData, { role: itm.role })
        }
        if (role) {
          role.resources = role.resources || []
          resource = _.find(role.resources, { hierarchyTypeId: itm.hierarchyTypeId })
          if (resource) {
            resource.ids = resource.ids || []
            resource.ids.push(itm.resource._id)
          } else {
            resource = {
              ids: [itm.resource._id],
              type: itm.type
            }
            itm.hierarchyTypeId ? resource.hierarchyTypeId = itm.hierarchyTypeId : void 0
            itm.parentId ? resource.parentId = itm.parentId : void 0
            role.resources.push(resource)
          }
        } else {
          resource = {
            ids: [itm.resource._id],
            type: itm.type
          }
          itm.hierarchyTypeId ? resource.hierarchyTypeId = itm.hierarchyTypeId : void 0
          itm.parentId ? resource.parentId = itm.parentId : void 0
          roleData.push({
            role: itm.role,
            resources: [resource]
          })
        }
      })
      return roleData
    }

    var getAllPermissionsOfUser = function (userId, permissions, permissionToCheck, cb) {
      var query = { _id: $rootScope.user._id }
      if (permissions) {
        query.permission = permissions
      }
      var user = resource.getAllPermissionsOfUser(query)
      return user.$promise.then(function (res) {
        if (!$rootScope.user) {
          $rootScope.user = { _id: userId }
        }
        $rootScope.user.permission = {}
        if (res.result && res.result.length > 0) {
          _.each(res.result, function (item) {
            if (item.permissionIds && item.permissionIds.length) {
              _.each(item.permissionIds, function (item) {
                $rootScope.user.permission[item.name] = true
              })
            }
          })
        }
        $cookies.putObject('vcUser', _.omit($rootScope.user, ['created', 'modified', 'registrationIds']))
        return cb($rootScope.user)
      })
    }
    return {
      resource: resource,
      checkLoggedInUser: checkLoggedInUser,
      getLoggedInUser: getLoggedInUser,
      getUserDisplayName: getUserDisplayName,
      hasPermission: hasPermission,
      recaptchaInit: recaptchaInit,
      manageCookies: manageCookies,
      setBasicInfo: setBasicInfo,
      getBasicInfo: getBasicInfo,
      setRoles: setRoles,
      getRoles: getRoles,
      clearFields: clearFields,
      createRolesJson: createRolesJson,
      clearCookies: clearCookies,
      logout: logout,
      getAllPermissionsOfUser: getAllPermissionsOfUser,
      reloadUserPermission: reloadUserPermission
    }
  }
})();

(function () {
  'use strict'
  var angular = window.angular
  angular.module('Vibzer.components')
    .factory('UtilService', UtilService)
  var _ = window._
  /** @ngInject */
  function UtilService () {
    // generate dynamic message
    var generateMsg = function (message, properties) {
      _.map(properties, function (value, prop) {
        var regex = new RegExp('{' + prop + '}', 'g')
        message = message.replace(regex, value)
      })
      return message
    }

    var convertMMToInch = function (mmValue, decimalPlaces) {
      var inchValue
      if(_.isArray(mmValue)) {
        inchValue = _.map(mmValue, function(value) {
          return parseFloat((value/25.4).toFixed(decimalPlaces));
        })
      } else {
       inchValue = parseFloat((mmValue/25.4).toFixed(decimalPlaces));
      }
      return inchValue
    }
    return {
      generateMsg: generateMsg,
      convertMMToInch :convertMMToInch
    }
  }
})();
(function () {
  'use strict';
  var angular = window.angular
  var _ = window._
  angular.module('Vibzer.components.users', ['ui.select'])
    .controller('UsersCtrl', UsersCtrl);
  function UsersCtrl ($scope, $state, $stateParams, $uibModal, $location, $cookies, toastr, UserService, constants) {
    $scope.webAppTexts = constants.webAppTexts
    $scope.breadCrumbList = [$scope.webAppTexts.breadcrumbs.userList]
    $scope.user = $cookies.getObject('vcUser')
    $scope.filter = { status: 'active' }
    $scope.limit = 10
    $scope.uibPage = {
      currentPage: 1
    }

    $scope.userCount = {
      active: 0,
      inactive: 0
    }

    // check whether logged in user is distributor user or customer user
    if ($scope.user && $scope.user.distributorIds && $scope.user.distributorIds.length) {
      $scope.isDistributorSuperAdmin = $scope.user.permission.addDistributorUser
      $scope.isSalesRep = !$scope.isDistributorSuperAdmin && !$scope.user.permission.addDistributorUser
    }
    /* Used to handle breadcrumb state after redirecting to another state. */
    $scope.uibPage.currentPage = $stateParams.currentPage ? $stateParams.currentPage : 1
    $scope.sort = $stateParams.sort ? $stateParams.sort : 'created'
    $scope.order = $stateParams.order ? $stateParams.order : -1
    $scope.searchText = $stateParams.searchText || ''

    $scope.sortBy = angular.copy(constants.sortByForUser)
    $scope.orderBy = angular.copy(constants.orderBy)

    $scope.sortBy.selected = _.find($scope.sortBy, { internalName: $scope.sort })
    $scope.orderBy.selected = _.find($scope.orderBy, { internalName: parseInt($scope.order) })

    /* This function is used to handle sorting. It invokes after changing
       sort or order and updates stateParams and calls pageChanged() to get updated user list.
    */
    $scope.setSorting = function (sort) {
      if (sort.type === 'sort') {
        $scope.sort = sort.internalName
        $location.search('sort', sort.internalName)
      } else {
        $scope.order = sort.internalName
        $location.search('order', sort.internalName)
      }
      $scope.uibPage.currentPage = 1
      $scope.pageChanged(1)
    }

    /* This function invokes after page or sort or order changes and sets
       currentPage in URL and calls getAllUsersOfCustomer() to get updated user list.
    */
    $scope.pageChanged = function (currentPage) {
      $location.search('currentPage', $scope.uibPage.currentPage)
      getAllUsersOfCustomer()
    }

    /* Search users in user list. */
    $scope.searchUser = function (searchText) {
      if (searchText !== undefined) {
        $scope.uibPage.currentPage = 1
        $location.search('currentPage', $scope.uibPage.currentPage)
        $scope.searchText = searchText
        $location.search('searchText', searchText)
        getAllUsersOfCustomer()
      }
    }

    /* This block handles active, deactive and all users tab. */
    $scope.filterValues = [
      {
        id: 0,
        internalName: 'active',
        displayName: 'Active',
        count: function () {
          return $scope.userCount.active
        },
        isFilterActive: true,
        onClickHandler: toggleFilter,
        filterQuery: { status: 'active' }
      },
      {
        id: 1,
        internalName: 'inactive',
        displayName: 'Inactive',
        count: function () {
          return $scope.userCount.inactive
        },
        isFilterActive: false,
        onClickHandler: toggleFilter,
        filterQuery: { status: 'inactive' }
      },
      {
        id: 2,
        internalName: 'all',
        displayName: 'All',
        count: function () {
          return $scope.userCount.active + $scope.userCount.inactive
        },
        isFilterActive: false,
        onClickHandler: toggleFilter
      }
    ]
    $scope.totalItems = $scope.filterValues[0].count()

    /* This function invokes after tab changes and updates user list as per current tab. */
    function toggleFilter (filter, page) {
      $scope.uibPage.currentPage = page || 1
      $location.search('currentPage', $scope.uibPage.currentPage)
      _.each($scope.filterValues, function (object) {
        object.isFilterActive = false
      })
      $scope.filterValues[filter.id].isFilterActive = true
      $scope.filter = filter.filterQuery
      $location.search('filterId', filter.id)
      getAllUsersOfCustomer()
    }

    /* If stateParams contains filterId this block calls toggleFilter() and updates user list. */
    if ($stateParams.filterId) {
      var filter = _.filter($scope.filterValues, { id: parseInt($stateParams.filterId) })[0]
      toggleFilter(filter, $stateParams.currentPage)
    } else {
      getAllUsersOfCustomer()
    }

    /* This function is used to get users. It gives all users, with active, deactive user count. */
    function getAllUsersOfCustomer () {
      $scope.busy = true
      var queryParams = {
        customerId: $scope.user.customerIds && $scope.user.customerIds.length ? $scope.user.customerIds[0] : $scope.user.distributorIds[0],
        page: null,
        sort: {},
        filters: {},
        limit: $scope.limit,
        requireUserCount: true,
        self: true
      }
      if ($scope.user.distributorIds && $scope.user.distributorIds.length > 0) {
        queryParams['distributorId'] = $scope.user.distributorIds[0]
      }
      queryParams.page = $scope.uibPage.currentPage || 1
      queryParams.sort[$scope.sort] = $scope.order
      if ($scope.searchText) {
        queryParams.filters.firstName = {
          internalName: 'firstName',
          value: ($location.search().searchText && $location.search().searchText !== '' ? $scope.searchText : ''),
          type: 'regex',
          regexOptions: 'i'
        }
      }

      _.assign(queryParams.filters, $scope.filter)

      UserService.resource.getAllUsersOfCustomer(queryParams, function (res) {
        $scope.allUsersOfCustomer = res.users
        _.map($scope.allUsersOfCustomer, function (user) {
          user.disable = $scope.user._id === user._id
          user.roleInfo = _.filter(user.roleInfo, function (role) {
            // Following if-else block used to distinguish customer and distributor
            if ($scope.user && $scope.user.customerIds && $scope.user.customerIds.length > 0) {
              if (role.resourceType === constants.resourceTypes[0].internalName) {
                role.resource = { name: constants.resourceTypes[0].displayName, _id: $scope.user.customerIds[0] }
                return role
              } else if (_.some(role.resource, _.isEmpty)) {
                return role
              }
            } else {
              if (role.resourceType === constants.resourceTypes[0].internalName) {
                role.role = role.role === constants.distributorRoles[0].internalName ? constants.distributorRoles[0].name : role.role
                return role
              }
            }
          })
          return user
        })
        $scope.totalItems = res.total
        $scope.userCount = res.userCount
        $scope.busy = false
      }, function (err) {
        $scope.busy = false
      })
    }

    /* Add user button click handler clears existing data and redirects to addUser page. */
    $scope.addUser = function () {
      UserService.clearFields()
      $state.go('addUser')
    }

    /* View user details button click handler clears existing data and redirects to user details page. */
    $scope.viewUserDetails = function (user) {
      UserService.clearFields()
      $stateParams.userId = user._id
      $state.go('viewUser', $stateParams)
    }

    /* Reset password button click handler asks for confirmation and sends reset password link to user once confirm. */
    $scope.resetPassword = function (user) {
      if (!user) {
        return
      }
      var modalInstance = $uibModal.open({
        templateUrl: 'app/components/confirmationDialog/confirmationDialog.html',
        controller: 'UserConfirmationDialogCtrl',
        backdrop: true,
        resolve: {
          items: function () {
            return {
              user: user,
              reset: true
            }
          }
        }
      })

      modalInstance.result.then(function (result) {
        var userData = {
          'username': user.username,
          'email': user.email,
          'resetByAdmin': true
        }
        UserService.resource.resetPassword(userData, function (res) {
          if (res.generatedPassword) {
            toastr.success(constants.toastrMessages.success.resetPassword)
          }
          getAllUsersOfCustomer()
        }, function (err) {
          toastr.error(err.data.msg)
        })
      }, function () { })
    }

    /* Activate and deactivate button click handler asks for confirmation and then activate or deactivate user once confirm. */
    $scope.activateOrDeactivate = function (user) {
      if (!user._id) {
        return
      }
      var modalInstance = $uibModal.open({
        templateUrl: 'app/components/confirmationDialog/confirmationDialog.html',
        controller: 'UserConfirmationDialogCtrl',
        backdrop: true,
        resolve: {
          items: function () {
            return {
              user: user
            }
          }
        }
      })

      modalInstance.result.then(function (result) {
        if (result.status === 'active') {
          var userData = {
            _id: result._id,
            status: 'inactive'
          }
        } else {
          userData = {
            _id: result._id,
            status: 'active'
          }
        }
        UserService.resource.activateOrDeactivateUser(userData, function (res) {
          if ($scope.allUsersOfCustomer.length === 1 && $scope.uibPage.currentPage > 1) {
            $scope.uibPage.currentPage = $scope.uibPage.currentPage - 1
            $location.search('currentPage', $scope.uibPage.currentPage)
          }
          getAllUsersOfCustomer()
          if (res.status === 'active') {
            toastr.success(constants.toastrMessages.success.activateUser)
          } else {
            toastr.success(constants.toastrMessages.success.deactivateUser)
          }
        }, function (err) {
          toastr.error(err.data.msg)
        })
      }, function () { })
    }
  }
})();
(function () {
  'use strict';
  var angular = window.angular
  var _ = window._
  var moment = window.moment
  angular.module('Vibzer.components').controller('regenerateReportCtrl', regenerateReportCtrl)
  function regenerateReportCtrl ($scope, $state, $location, $stateParams, $uibModal, ReportService, RouteService, CompositeService, $cookies, constants, DistributorService, CustomerService, MachineService, toastr, FileSaver) {
    $scope.machineData = {}
    $scope.distributors = []
    $scope.customers = []
    $scope.fromMachines = []
    $scope.toMachines = []
    $scope.webAppTexts = constants.webAppTexts

    $scope.page = 1
    $scope.limit = 10
    $scope.sessions = []
    $scope.selected = {}
    $scope.user = $cookies.getObject('vcUser')
    // dynamic breadcrumbs
    $scope.breadCrumbList = [$scope.webAppTexts.breadcrumbs.regenerateReport]
    // get route data
    $scope.format = 'MM-dd-yyyy'
    $scope.startDateOptions = {
      dateDisabled: false,
      formatYear: 'yy',
      maxDate: new Date(2100, 1, 1),
      minDate: new Date(2000, 1, 1),
      startingDay: 1
    }

    $scope.endDateOptions = angular.copy($scope.startDateOptions)
    $scope.isStartDateOpened = false
    $scope.isEndDateOpened = false

    $scope.selectStartDate = function () {
      $scope.isStartDateOpened = true
    }

    $scope.selectEndDate = function () {
      $scope.isEndDateOpened = true
    }

    /* This function  invokes after selecting start or end session date and updates session list. */
    $scope.dateSelected = function (type) {
      $location.search('startSessionDate', null)
      $location.search('endSessionDate', null)
      if (type === 'end' && $scope.endSessionDate) {
        $scope.endSessionDate.setHours(23, 59, 59, 999)
      } else {
        $scope.endDateOptions.minDate = $scope.startSessionDate
      }
      $scope.page = 1
      $scope.sessions = []
      $scope.getSessions()
    }

    /* This function invokes after selecting machine condition and updates session list as per condition. */
    $scope.conditionSelected = function () {
      $scope.page = 1
      $scope.sessions = []
      $scope.getSessions()
    }

    /* This function invokes after selecting reading type and updates session list as per selected reading type. */
    $scope.readingTypeSelected = function (readingType) {
      $scope.page = 1
      $scope.sessions = []
      $scope.getSessions()
    }
    /* Get sessions of machine. */
    $scope.getSessions = function () {
      if ($scope.page > $scope.totalPages || $scope.page === 0 || !($scope.selected && $scope.selected.distributorId && $scope.selected.customerId && $scope.selected.fromMachineId)) {
        return
      }
      $scope.busy = true
      var queryParams = {
        customerId: $scope.selected.customerId,
        machineId: $scope.selected.fromMachineId,
        limit: $scope.limit || 10,
        page: $scope.page || 1
      }

      if ($scope.selected.condition && $scope.selected.condition.name !== 'all') {
        queryParams.condition = $scope.selected.condition.id
      }
      if ($scope.selected.readingType && $scope.selected.readingType !== 0) {
        queryParams.readingType = $scope.selected.readingType
      }
      if ($scope.startSessionDate || $scope.endSessionDate) {
        queryParams.dates = {}
        if ($scope.startSessionDate) {
          queryParams.dates.fromDate = $scope.startSessionDate.toISOString()
          $location.search('startSessionDate', $scope.startSessionDate.toISOString())
        }
        if ($scope.endSessionDate) {
          queryParams.dates.toDate = $scope.endSessionDate.toISOString()
          $location.search('endSessionDate', $scope.endSessionDate.toISOString())
        }
      }

      ReportService.resource.getAllMachineSessions({ stringifyData: JSON.stringify(queryParams) }, function (res) {
        if (res.result && !res.result.length) {
          toastr.info('Sessions not found for this machine')
        }
        $scope.sessions = $scope.sessions.concat(_.map(res.result, function (session, index) {
          session.name = 'S- ' + moment(session.createdOn).format('MM-DD-YY HH:mm:ss') // 'Session ' + (index + 1)
          session.readingType = _.find(constants.readingTypes, { id: session.readingType })
          var machineCondition = _.filter(constants.machineStates, { id: session.condition })[0]
          if (machineCondition) {
            session.color = machineCondition.color
          }
          session.icon = $scope.machineData.icon
          session.viewReport = true
          if (session.isTestReading) {
            session.comment = $scope.webAppTexts.notes.noTestReadingReport
            session.typeText = $scope.webAppTexts.labels.testReading
          } else if (!session.hasReport) {
            session.comment = $scope.webAppTexts.notes.failToGenerateReport
            // session.typeText = $scope.webAppTexts.labels.reportError
          }
          return session
        }))
        $scope.totalPages = res.totalPages
        $scope.page = $scope.page + 1
        $scope.busy = false
        $scope.$emit('list:filtered')
      }, function (err) {
        $scope.busy = false
        $scope.page = 0
        console.log(err)
      })
    }

    /* Redirects to machines page. */
    $scope.breadCrumbClickHandler = function (itm) {
      if ($stateParams.compositeId && $scope.machineData.forComposite) {
        $state.go('compositeMachines', { compositeData: $stateParams.compositeData })
      } else if ($stateParams.routeId && itm === $scope.webAppTexts.breadcrumbs.routeList) {
        $state.go('routes', { routeFilters: $stateParams.routeFilters })
      } else if ($stateParams.routeId && itm === $scope.routeData.name) {
        $state.go('routeMachines', { routeId: $stateParams.routeId, machineData: $stateParams.machineData, routeFilters: $stateParams.routeFilters })
      } else if ($stateParams.compositeId && itm === $scope.webAppTexts.breadcrumbs.compositeMachineList) {
        $state.go('compositeMachines', { compositeData: $stateParams.compositeData })
      } else if ($stateParams.compositeId && itm === $scope.compositeData.name) {
        $state.go('machinesFromComposite', { compositeId: $stateParams.compositeId, machineData: $stateParams.machineData, compositeData: $stateParams.compositeData })
      } else {
        $state.go('machines', { machineData: $stateParams.machineData })
      }
    }

    /* This block handles modal opening for all charts. */
    $scope.openingChart = function (chart, sessionId, sessionName, readingType) {
      var templateUrl = 'app/components/machines/reviews/modals/charts.html'
      if (chart === 'wave') {
        var controller = 'WaveChartCtrl'
      } else if (chart === 'spectrum') {
        controller = 'SpectrumChartCtrl'
      } else if (chart === 'rawData') {
        templateUrl = 'app/components/machines/reviews/modals/rawDataChart.html'
        controller = 'RawChartCtrl'
      }
      var modalInstance = $uibModal.open({
        templateUrl: templateUrl,
        backdrop: true,
        controller: controller,
        resolve: {
          machineData: function () {
            return _.assign($scope.machineData, {
              chartType: chart,
              sessionId: sessionId,
              sessionName: sessionName,
              readingType: readingType.id
            })
          }
        },
        size: 'xt-lg'
      })
      modalInstance.result.then(function (result) {
      })
    }

    /* Open view report dialog */
    $scope.viewReportOfSession = function (sessionId, sessionName) {
      var modalInstance = $uibModal.open({
        templateUrl: 'app/components/machines/reviews/modals/viewReport.html',
        backdrop: true,
        controller: 'ViewReportCtrl',
        resolve: {
          reportData: {
            machineType: $scope.machineData.machineTypeId.name,
            sessionId: sessionId,
            sessionName: sessionName
          }
        }
      })
      modalInstance.result.then(function (result) {
      })
    }

    /* To view criteria wise analysis */
    $scope.viewCriteriaAnalysis = function (session) {
      $uibModal.open({
        templateUrl: 'app/components/machines/reviews/modals/viewCriteriaAnalysis.html',
        backdrop: true,
        controller: 'ViewCriteriaAnalysisCtrl',
        size: 'xt-lg',
        resolve: {
          reportData: angular.copy(_.assign(session, {
            machineId: $scope.machineData._id,
            machineName: $scope.machineData.name,
            machineType: $scope.machineData.machineTypeId.name,
            meta: $scope.machineData.meta
          }))
        }
      })
    }

    $scope.getAllDistributors = function () {
      DistributorService.resource.getAllDistributors({ select: 'name', for: 'downloadRpb' }, function (res) {
        if (res && res.data && res.data.length) {
          $scope.distributors = res.data
        } else {
          toastr.info(constants.toastrMessages.notFound.distributor)
        }
      }, function (err) {
        toastr.error(err.data.msg)
      })
    }
    $scope.getAllDistributors()
    /* This function is used to get customers. It gives all customers, with active, deactive customer count. */
    $scope.getAllCustomers = function () {
      $scope.busy = true
      CustomerService.resource.getAll({
        limit: 99999,
        page: 1,
        for: 'downloadRpb',
        distributorId: $scope.selected.distributorId
      }, function (res) {
        if (res && res.customers && res.customers.length) {
          $scope.customers = res.customers
        } else {
          toastr.info(constants.toastrMessages.notFound.customer)
        }
        $scope.busy = false
      }, function (err) {
        $scope.busy = false
        toastr.error(err.data.msg)
      })
    }

    /* This function is used to get machines. It gives all machines with total count. */
    $scope.getAllMachines = function () {
      $scope.busy = true
      var queryParams = {
        customerId: $scope.selected.customerId,
        page: 1,
        sort: { createdOn: -1 },
        for: 'downloadRpb',
        limit: 99999
      }
      MachineService.resource.getAllMachines(queryParams, function (res) {
        if (res.result && res.result.length) {
          $scope.fromMachines = _.map(res.result, function (machine) {
            machine.icon = _.find(constants.typesOfMachine, { name: machine.machineType.name }).icon
            return machine
          })
        } else {
          toastr.info(constants.toastrMessages.notFound.machine)
        }
        $scope.busy = false
      }, function (err) {
        $scope.busy = false
      })
    }

    $scope.selectedProperty = function (prop) {
      $scope.sessions = []
      $scope.page = 1
      $scope.totalPages = undefined
      if (prop === 'distributor') {
        $scope.customers = []
        $scope.fromMachines = []
        $scope.toMachines = []
        delete $scope.selected.customerId
        delete $scope.selected.fromMachineId
        delete $scope.selected.toMachineId
        $scope.getAllCustomers()
      } else if (prop === 'customer') {
        $scope.fromMachines = []
        $scope.toMachines = []
        delete $scope.selected.fromMachineId
        delete $scope.selected.toMachineId
        $scope.getAllMachines()
      } else if (prop === 'fromMachine') {
        $scope.toMachines = []
        delete $scope.selected.toMachineId
        $scope.machineData = _.find($scope.fromMachines, { _id: $scope.selected.fromMachineId })
        $scope.machineData.machineTypeId = $scope.machineData.machineType
        $scope.isMonitoringMachine = $scope.machineData.machineTypeId.name === 'machine'
        $scope.getSessions()
        // $scope.toMachines = angular.copy($scope.fromMachines)
        $scope.toMachines = _.filter($scope.fromMachines, function (itm) {
          return itm.machineType._id === $scope.machineData.machineType._id &&
           itm.meta.size.unit === $scope.machineData.meta.size.unit &&
           itm.meta.size.value === $scope.machineData.meta.size.value &&
           itm.meta.motorRpm === $scope.machineData.meta.motorRpm &&
           itm._id !== $scope.machineData._id
        })
        if ($scope.toMachines && !$scope.toMachines.length) {
          toastr.warning('Please create duplicate machine of this machine')
        }
      } else if (prop === 'toMachine') {

      }
    }

    $scope.regenerateReports = function () {
      MachineService.resource.regenerateReport({
        fromMachineId: $scope.selected.fromMachineId,
        toMachineId: $scope.selected.toMachineId,
        toMachineMacId: 'DD:DD:DD:DD:DD:DD',
        sessionInterval: 4,
        removeSessions: $scope.selected.sessions
      }, function (res) {
        toastr.success(res.msg)
      }, function (error) {
        toastr.success(error.data.msg)
      })
    }
  }
})();
/**
 * @author v.lugovksy
 * created on 15.12.2015
 */
(function () {
  'use strict';

  angular.module('Vibzer.theme.components')
      .config(toastrLibConfig);

  /** @ngInject */
  function toastrLibConfig(toastrConfig) {
    angular.extend(toastrConfig, {
      closeButton: true,
      closeHtml: '<button>&times;</button>',
      timeOut: 5000,
      autoDismiss: false,
      containerId: 'toast-container',
      maxOpened: 0,
      newestOnTop: true,
      positionClass: 'toast-top-right',
      preventDuplicates: false,
      preventOpenDuplicates: false,
      target: 'body'
    });
  }
})();
/**
 * Change top "Daily Downloads", "Active Users" values with animation effect
 */
(function () {
  'use strict';

  angular.module('Vibzer.theme')
      .directive('animatedChange', animatedChange);

  /** @ngInject */
  function animatedChange($timeout) {
    return {
      link: function (scope, element) {
        $timeout(function () {
          var newValue = element.attr('new-value');
          var oldvalue = parseInt(element.html());

          function changeValue(val) {
            $timeout(function () {
              element.html(val);
            }, 30);
          }

          if (newValue > oldvalue) {
            for (var i = oldvalue; i <= newValue; i++) {
              changeValue(i);
            }
          } else {
            for (var j = oldvalue; j >= newValue; j--) {
              changeValue(j);
            }
          }
          $timeout(function () {
            element.next().find('i').addClass('show-arr');
          }, 500);
        }, 3500);
      }
    };
  }

})();
/**
 * Auto expand textarea field
 */
(function () {
  'use strict';

  angular.module('Vibzer.theme')
      .directive('autoExpand', autoExpand);

  /** @ngInject */
  function autoExpand() {
    return {
      restrict: 'A',
      link: function ($scope, elem) {
        elem.bind('keydown', function ($event) {
          var element = $event.target;
          $(element).height(0);
          var height = $(element)[0].scrollHeight;
          height = (height < 16) ? 16 : height;
          $(element).height(height);
        });

        // Expand the textarea as soon as it is added to the DOM
        setTimeout(function () {
          var element = elem;
          $(element).height(0);
          var height = $(element)[0].scrollHeight;
          height = (height < 16) ? 16 : height;
          $(element).height(height);
        }, 0)
      }
    };
  }

})();
(function () {
  'use strict';

  angular.module('Vibzer.theme')
      .directive('autoFocus', autoFocus);

  /** @ngInject */
  function autoFocus($timeout, $parse) {
    return {
      link: function (scope, element, attrs) {
        var model = $parse(attrs.autoFocus);
        scope.$watch(model, function (value) {
          if (value === true) {
            $timeout(function () {
              element[0].focus();
              element[0].select();
            });
          }
        });
        element.bind('blur', function () {
          scope.$apply(model.assign(scope, false));
        });
      }
    };
  }

})();
/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('Vibzer.theme')
      .directive('includeWithScope', includeWithScope);

  /** @ngInject */
  function includeWithScope() {
    return {
      restrict: 'AE',
      templateUrl: function(ele, attrs) {
        return attrs.includeWithScope;
      }
    };
  }

})();

/**
 * @author a.demeshko
 * created on 22.12.2015
 */
(function () {
  'use strict';

  angular.module('Vibzer.theme')
    .directive('ionSlider', ionSlider);

  /** @ngInject */
  function ionSlider($timeout) {
    return {
      restrict: 'EA',
      template: '<div></div>',
      replace: true,
      scope: {
        min: '=',
        max: '=',
        type: '@',
        prefix: '@',
        maxPostfix: '@',
        prettify: '=',
        prettifySeparator: '@',
        grid: '=',
        gridMargin: '@',
        postfix: '@',
        step: '@',
        hideMinMax: '@',
        hideFromTo: '@',
        from: '=',
        to: '=',
        disable: '=',
        onChange: '=',
        onFinish: '=',
        values: '=',
        timeout: '@'
      },
      link: function ($scope, $element) {
            $element.ionRangeSlider({
              min: $scope.min,
              max: $scope.max,
              type: $scope.type,
              prefix: $scope.prefix,
              maxPostfix: $scope.maxPostfix,
              prettify_enabled: $scope.prettify,
              prettify_separator: $scope.prettifySeparator,
              grid: $scope.grid,
              gridMargin: $scope.gridMargin,
              postfix: $scope.postfix,
              step: $scope.step,
              hideMinMax: $scope.hideMinMax,
              hideFromTo: $scope.hideFromTo,
              from: $scope.from,
              to: $scope.to,
              disable: $scope.disable,
              onChange: $scope.onChange,
              onFinish: $scope.onFinish,
              values: $scope.values
            });

            $scope.$watch('min', function (value) {
              $timeout(function () {
                $element.data("ionRangeSlider").update({min: value});
              });
            }, true);
            $scope.$watch('max', function (value) {
              $timeout(function () {
                $element.data("ionRangeSlider").update({max: value});
              });
            });
            $scope.$watch('from', function (value) {
              $timeout(function () {
                $element.data("ionRangeSlider").update({from: value});
              });
            });
            $scope.$watch('to', function (value) {
              $timeout(function () {
                $element.data("ionRangeSlider").update({to: value});
              });
            });
            $scope.$watch('disable', function (value) {
              $timeout(function () {
                $element.data("ionRangeSlider").update({disable: value});
              });
            });
      }
    };
  }

})();
(function () {
  'use strict';

  angular.module('Vibzer.theme')
      .directive('ngFileSelect', ngFileSelect);

  /** @ngInject */
  function ngFileSelect() {
    return {
      link: function ($scope, el) {
        el.bind('change', function (e) {
          $scope.file = (e.srcElement || e.target).files[0];
          $scope.getFile();
        })
      }
    }
  }

})();
(function () {
  'use strict';

  angular.module('Vibzer.theme')
      .directive('scrollPosition', scrollPosition);

  /** @ngInject */
  function scrollPosition() {
    return {
      scope: {
        scrollPosition: '=',
        maxHeight: '='
      },
      link: function (scope) {
        $(window).on('scroll', function() {
          var scrollTop = $(window).scrollTop() > scope.maxHeight;
          if (scrollTop !== scope.prevScrollTop) {
            scope.$apply(function() {
              scope.scrollPosition = scrollTop;
            });
          }
          scope.prevScrollTop = scrollTop;
        });
      }
    };
  }

})();
(function () {
  'use strict';

  angular.module('Vibzer.theme')
      .directive('trackWidth', trackWidth);

  /** @ngInject */
  function trackWidth() {
    return {
      scope: {
        trackWidth: '=',
        minWidth: '=',
      },
      link: function (scope, element) {
        scope.trackWidth = $(element).width() < scope.minWidth;
        scope.prevTrackWidth = scope.trackWidth;

        $(window).resize(function() {
          var trackWidth = $(element).width() < scope.minWidth;
          if (trackWidth !== scope.prevTrackWidth) {
            scope.$apply(function() {
              scope.trackWidth = trackWidth;
            });
          }
          scope.prevTrackWidth = trackWidth;
        });
      }
    };
  }

})();
/**
 * Animated load block
 */
(function () {
  'use strict';

  angular.module('Vibzer.theme')
      .directive('zoomIn', zoomIn);

  /** @ngInject */
  function zoomIn($timeout, $rootScope) {
    return {
      restrict: 'A',
      link: function ($scope, elem) {
        var delay = 1000;

        if ($rootScope.$pageFinishedLoading) {
          delay = 100;
        }

        $timeout(function () {
          elem.removeClass('full-invisible');
          elem.addClass('animated zoomIn');
        }, delay);
      }
    };
  }

})();
/**
 * @author n.poltoratsky
 * created on 27.06.2016
 */
(function () {
    'use strict';

    angular.module('Vibzer.theme')
        .factory('baProgressModal', baProgressModal);

    /** @ngInject */
    function baProgressModal($uibModal) {
        var methods = {};
        var progress = 0;
        var max = 100;
        var opened = false;

        return {
            setProgress: function (value) {
                if (value > max) {
                    throw Error('Progress can\'t be greater than max');
                }
                progress = value;
            },
            getProgress: function () {
                return progress;
            },
            open: function() {
                if (!opened) {
                    methods = $uibModal.open({
                        animation: true,
                        templateUrl: 'app/components/ui/modals/progressModal/progressModal.html',
                        size: 'sm',
                        keyboard: false,
                        backdrop: 'static'
                    });
                    opened = true;
                } else {
                    throw Error('Progress modal opened now');
                }

            },
            close: function() {
                if (opened) {
                    methods.close();
                    opened = false;
                } else {
                    throw Error('Progress modal is not active');
                }

            }
        };
    }

})();
/**
 * @author v.lugovsky
 * created on 03.05.2016
 */
(function () {
  'use strict';

  angular.module('Vibzer.theme')
      .service('baUtil', baUtil);

  /** @ngInject */
  function baUtil() {

    this.isDescendant = function(parent, child) {
      var node = child.parentNode;
      while (node != null) {
        if (node == parent) {
          return true;
        }
        node = node.parentNode;
      }
      return false;
    };

    this.hexToRGB = function(hex, alpha) {
      var r = parseInt( hex.slice(1,3), 16 );
      var g = parseInt( hex.slice(3,5), 16 );
      var b = parseInt( hex.slice(5,7), 16 );
      return 'rgba(' + r + ', ' + g + ', ' + b + ', ' + alpha + ')';
    };

    this.hasAttr = function (elem, attrName) {
      var attr = $(elem).attr(attrName);
      return (typeof attr !== typeof undefined && attr !== false);
    }
  }
})();

/**
 * @author v.lugovksy
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('Vibzer.theme')
      .service('fileReader', fileReader);

  /** @ngInject */
  function fileReader($q) {
    var onLoad = function(reader, deferred, scope) {
      return function () {
        scope.$apply(function () {
          deferred.resolve(reader.result);
        });
      };
    };

    var onError = function (reader, deferred, scope) {
      return function () {
        scope.$apply(function () {
          deferred.reject(reader.result);
        });
      };
    };

    var onProgress = function(reader, scope) {
      return function (event) {
        scope.$broadcast('fileProgress',
            {
              total: event.total,
              loaded: event.loaded
            });
      };
    };

    var getReader = function(deferred, scope) {
      var reader = new FileReader();
      reader.onload = onLoad(reader, deferred, scope);
      reader.onerror = onError(reader, deferred, scope);
      reader.onprogress = onProgress(reader, scope);
      return reader;
    };

    var readAsDataURL = function (file, scope) {
      var deferred = $q.defer();

      var reader = getReader(deferred, scope);
      reader.readAsDataURL(file);

      return deferred.promise;
    };

    return {
      readAsDataUrl: readAsDataURL
    };
  }
})();
/**
 * @author a.demeshko
 * created on 3/1/16
 */
(function () {
  'use strict';

  angular.module('Vibzer.theme')
    .service('preloader', preloader);

  /** @ngInject */
  function preloader($q) {
    return {
      loadImg: function (src) {
        var d = $q.defer();
        var img = new Image();
        img.src = src;
        img.onload = function(){
          d.resolve();
        };
        return d.promise;
      }
    }
  }

})();
/**
 * @author a.demeshko
 * created on 12/21/15
 */
(function () {
  'use strict';

  angular.module('Vibzer.theme')
    .service('stopableInterval', stopableInterval);

  /** @ngInject */
  function stopableInterval($window) {
    return {
      start: function (interval, calback, time) {
        function startInterval() {
          return interval(calback, time);
        }

        var i = startInterval();

        angular.element($window).bind('focus', function () {
          if (i) interval.cancel(i);
          i = startInterval();
        });

        angular.element($window).bind('blur', function () {
          if (i) interval.cancel(i);
        });
      }
    }
  }

})();
(function () {
  'use strict';
  var angular = window.angular
  var _ = window._
  var moment = window.moment
  angular.module('Vibzer.components')
    .controller('RenewLicenseCtrl', RenewLicenseCtrl);
  /*
    Controller for add license for customer
  */
  function RenewLicenseCtrl ($scope, $filter, toastr, licenseData, LicenseService, $uibModalInstance, constants) {
    $scope.license = licenseData
    $scope.dateFormat = constants.dateFormats.default
    $scope.webAppTexts = constants.webAppTexts

    var generateExpiryDate = function (startDate, validity) {
      return validity.unit === 0 ? moment(startDate).add(10, 'years') : moment(startDate).add(validity.length, _.filter(constants.licenseValidityUnits, { unit: validity.unit })[0].name + 's')
    }

    if (moment($scope.license.expiryDate).isBefore(moment().startOf('day'))) {
      $scope.license.newActivationDate = $filter('date')(new Date(moment().startOf('day')).toISOString(), $scope.dateFormat)
      $scope.license.newExpiryDate = $filter('date')(new Date(generateExpiryDate(moment().startOf('day'), licenseData.licenseInfo.validity)).toISOString(), $scope.dateFormat)
    } else {
      $scope.license.newActivationDate = $filter('date')($scope.license.startDate, $scope.dateFormat)
      $scope.license.newExpiryDate = $filter('date')(new Date(generateExpiryDate(moment($scope.license.expiryDate).startOf('day'), licenseData.licenseInfo.validity)).toISOString(), $scope.dateFormat)
    }
    $scope.renewLicense = {
      orderId: licenseData.orderId,
      customerId: licenseData.customerId
    }
    $scope.confirm = function () {
      LicenseService.resource.renew($scope.renewLicense, function (res) {
        toastr.success(constants.toastrMessages.success.renewLicense)
        $uibModalInstance.close()
      }, function (err) {
        if (err.data && err.data.msg) {
          toastr.error(err.data.msg)
        }
      })
    }

    $scope.close = function () {
      $uibModalInstance.dismiss()
    }
  }
})();
(function () {
  'use strict'
  var angular = window.angular
  angular.module('Vibzer.theme.components')
    .controller('DialogNotificationCtrl', DialogNotificationCtrl);
  /*
  View or clear notification dialog control
  */
  // @NgInject
  function DialogNotificationCtrl ($scope, $uibModalInstance, $sce, $cookies, notification, constants, NotificationService) {
    $scope.user = $cookies.getObject('vcUser')
    $scope.dateFormat = constants.dateFormats.default
    $scope.notification = notification
    $scope.clearAll = {
      value: '0'
    }

    // Update status of notification as read.
    $scope.confirm = function () {
      NotificationService.resource.readNotification({ _id: notification._id }, function (res) {
        $uibModalInstance.close(res)
      })
    }

    // Get dialog title
    if ($scope.notification.action === 'clear') {
      $scope.modalHeaderClass = 'bg-danger'
      $scope.title = $sce.trustAsHtml('<i aria-hidden="true"></i><strong>&nbsp;&nbsp;Clear All Notification(s)<strong>')
      $scope.showClear = true
    } else {
      $scope.modalHeaderClass = 'bg-info'
      $scope.title = $sce.trustAsHtml('<i class="fa fa-bell-o" aria-hidden="true"></i><strong>&nbsp;&nbsp;Notification</strong>')
      $scope.showClear = false
    }

    // Clear notification
    $scope.clear = function (clearAll) {
      var data = {
        userId: $scope.user._id,
        removeAll: parseInt($scope.clearAll.value)
      }
      NotificationService.resource.removeNotification(data, function (res) {
        $uibModalInstance.close()
      })
    }
  }
})();
(function () {
  'use strict';
  var angular = window.angular
  var _ = window._
  var moment = window.moment
  angular.module('Vibzer.components')
    .controller('AddLicenseCtrl', AddLicenseCtrl);
  /*
    Controller for add license for customer
  */
  function AddLicenseCtrl ($scope, $state, $rootScope, $stateParams, $location, toastr, customerData, LicenseService, UserService, DeviceService, constants) {
    $scope.webAppTexts = constants.webAppTexts
    $scope.breadCrumbList = [$scope.webAppTexts.breadcrumbs.addLicenses]
    $scope.customerData = customerData
    $scope.user = $rootScope.user
    $scope.licenseTypes = constants.licenseTypes
    $scope.model = {}
    $scope.licenseInfo = []
    $scope.dateFormat = constants.dateFormats.licensesTableDateFormat
    $scope.licenseAdded = false
    $scope.salesRep = []
    $scope.model.selectedDevices = []
    $scope.devices = []
    $scope.deviceRequired = false
    $scope.limit = 4
    $scope.uibPage = {
        devicePage: 1
    }

    // Date picker control
    $scope.format = 'MMM dd, yyyy'
    $scope.startDateOptions = {
      dateDisabled: false,
      formatYear: 'yy',
      maxDate: new Date(2100, 1, 1),
      minDate: moment().toDate(),
      startingDay: 1
    }
    $scope.model.startDate = moment().toDate()
    $scope.isStartDateOpened = false

    $scope.selectStartDate = function () {
      $scope.isStartDateOpened = true
    }

    // get sales rep for customer
    var data = {
      permissions: ['addCustomer', 'updateCustomer', 'deleteCustomer', 'removeCustomer', 'addUser'],
      permissionType: 'name',
      resource: $stateParams.customerId,
      options: { populate: [{ path: 'userId', select: '_id firstName lastName' }] }
    }

    UserService.resource.getLevelUsersBasedOnPermissions(data, function (res) {
      $scope.salesRep = res.users
    })
    // check whether current logged in user is distributor superadmin or salesrep
    if ($scope.user && $scope.user.distributorIds.length) {
      $scope.isSalesRep = !$scope.user.permission.addDistributorUser
    }

    // get license types by distributor
    LicenseService.resource.getLicenseTypes({ distributorId: $scope.user.distributorIds[0] }, function (res) {
      $scope.licenseTypes = res.result
    })

    $scope.pageChanged = function (devicePage) {
      $location.search('devicePage', $scope.uibPage.devicePage)
      getDevices()
    }

    // get available devices
    function getDevices () {
      $scope.busy = true
      var queryParams = {
          distributorId: $scope.user.distributorIds[0],
          unassigned: true,
          for: 'distributor',
          filters: {
            type: $scope.model.licenseType.deviceType
          },
          page: $scope.uibPage.devicePage ? $scope.uibPage.devicePage : 1 ,
          limit: $scope.limit
      }
      // skip already added devices
      var selectedDevices = []
      if ($scope.licenseInfo && $scope.licenseInfo.length) {
        _.each($scope.licenseInfo, function(license) {
          selectedDevices = selectedDevices.concat(license.selectedDevices)
        })
        if(selectedDevices.length) {
          _.assign(queryParams.filters, {_id: {$nin: selectedDevices}})
        }
      }
      DeviceService.resource.getDevices(queryParams, function (res) {
        $scope.devices = res.devices
        // select already added devices
        if ($scope.model.selectedDevices && $scope.model.selectedDevices.length) {
          _.map($scope.devices, function(device) {
            _.map($scope.model.selectedDevices, function(selectedDevice) {
              if(device._id === selectedDevice._id && selectedDevice.selected) {
                device.selected = true
              }
            })
            return device
          })
        }
        $scope.totalItems = res.total
        $scope.busy = false
        }, function (err) {
        $scope.busy = false
    })
    }
    // get licenses by license type
    $scope.onSelectLicenseType = function (licenseType) {
      $scope.isDeviceType = licenseType.id === 3 || licenseType.id === 4
      $scope.model = _.omit($scope.model, ['license', 'quantity', 'productCode'])
      var queryParams = {
        distributorId: $scope.user.distributorIds[0],
        type: licenseType.id
      }
      LicenseService.resource.getLicensesAssignToDistributor(queryParams, function (res) {
        $scope.allLicenses = res.result
        if ($scope.isDeviceType) {
          $scope.uibPage.devicePage = 1
          $location.search('devicePage', $scope.uibPage.devicePage)
          $scope.model.license = $scope.allLicenses ? $scope.allLicenses[0] : null
          $scope.model.productCode = $scope.model.license.productCode
          getDevices()
        }
      })
    }

    // reset part no and quantity field
    $scope.onSelectLicense = function (license) {
      $scope.model = _.omit($scope.model, ['quantity'])
      $scope.model.productCode = license.productCode
    }

    // get selected devices
    $scope.getSelectedDevices = function (device) {
      if(_.find($scope.model.selectedDevices, { _id: device._id })) {
        _.remove($scope.model.selectedDevices, { _id: device._id })
      } else {
        $scope.model.selectedDevices.push(device)
      }
      $scope.deviceRequired = !$scope.model.selectedDevices.length
    }

    // add license in license table
    $scope.addLicense = function () {
      if ($scope.isDeviceType) {
        $scope.model.selectedDevices = _.map($scope.model.selectedDevices, '_id')
        $scope.deviceRequired = !$scope.model.selectedDevices.length
      }
      if ((!$scope.isDeviceType && $scope.model.quantity >= 1 && $scope.model.quantity <= 999) || ($scope.isDeviceType && !$scope.deviceRequired)) {
        $scope.licenseInfo.push($scope.model)
        setTimeout(function () {
          $scope.model = {
            startDate: moment().toDate(),
            selectedDevices: []
          }
          $scope.uibPage.devicePage = 1
          $location.search('devicePage', $scope.uibPage.devicePage)
          $scope.isDeviceType = false
          $scope.licenseForm.$setPristine()
          $scope.$apply()
        }, 50)
      }
    }

    // remove license
    $scope.removeLicense = function (license) {
      _.pull($scope.licenseInfo, license)
      $scope.model = {
        startDate: moment().toDate(),
        selectedDevices: []
      }
      $scope.uibPage.devicePage = 1
      $location.search('devicePage', $scope.uibPage.devicePage)
      $scope.isDeviceType = false
    }

    // go back to customer list page
    $scope.back = function () {
      $state.go('customers', $stateParams)
    }

    // add licenses in database
    $scope.save = function () {
      var data = []
      _.filter($scope.licenseInfo, function (itm) {
        itm.customerId = $stateParams.customerId
        itm.type = itm.licenseType.id
        itm.masterLicenseId = itm.license._id
        itm.startDate = itm.startDate.toDateString()
        itm.licenseType.deviceType ? itm.deviceIds = itm.selectedDevices : null
        data.push(_.omit(itm, ['licenseType', 'license', 'productCode', 'selectedDevices']))
      })
      LicenseService.resource.assignLicenseToCustomer({ licenses: data }, function (res) {
        toastr.success(constants.toastrMessages.success.assignLicense)
        $state.go('customers', $stateParams)
      }, function (err) {
        toastr.error(err.data.msg)
      })
    }
  }
})();
(function () {
  'use strict'
  angular.module('Vibzer.components')
    .controller('AddAdminFormCtrl', AddAdminFormCtrl);
  
  // @NgInject
  function AddAdminFormCtrl($scope, $uibModalInstance, toastr, UserService, items, constants) {
    var customer = items.customer
    $scope.webAppTexts = constants.webAppTexts
    /* Set bg-primary default class for modal-header. */
    $scope.modalHeaderClass = 'bg-primary'

    /* Save form details */
    $scope.save = function () {
      var userData = $scope.customer.admin
      userData['customerIds'] = [customer._id]
      var roleData = {
        role: constants.roles[0].name,
        resources:  {
          ids: [customer._id],
          type: constants.resourceTypes[0].internalName
        }
      }
      userData['roleData'] = [roleData]
      UserService.resource.addUser(userData, function (resp) {
        var message = constants.toastrMessages.success.addUser
        toastr.success(message)
        $uibModalInstance.close(true)
      }, function (err) {
        toastr.error(err.data.msg)
      })
    }

    /* Close popup dialog box */
    $scope.close = function () {
      $uibModalInstance.dismiss()
    }

    /* Enable or disable save button on condition of required fields */
    $scope.validateForm = function () {
      if ($scope.customer.userInfoForm.firstName.$valid && $scope.customer.userInfoForm.lastName.$valid &&
        $scope.customer.userInfoForm.phone.$valid && $scope.customer.userInfoForm.email.$valid) {
        return false
      }
      return true
    }
  }
})();
(function () {
  'use strict';
  var angular = window.angular
  var _ = window._
  angular.module('Vibzer.components')
    .controller('CustomerAdminViewCtrl', CustomerAdminViewCtrl);
  function CustomerAdminViewCtrl ($scope, $state, $stateParams, $rootScope, $uibModal, $location, $cookies, UserService, userData, toastr, constants) {
    $scope.breadCrumbList = [userData.firstName + ' ' + userData.lastName]
    $scope.userData = userData

    /* View user details button click handler clears existing data and redirects to user details page. */
    $scope.goBack = function () {
      $state.go('customerAdmin', $stateParams)
    }
  }
})();
(function () {
  'use strict';
  var angular = window.angular
  var _ = window._
  angular.module('Vibzer.components.customerActions', ['ui.select'])
    .controller('CustomerAdminListCtrl', CustomerAdminListCtrl);
  function CustomerAdminListCtrl ($scope, $state, $stateParams, $uibModal, $location, $cookies, CustomerService, customerData, toastr, constants) {
    $scope.webAppTexts = constants.webAppTexts
    $scope.breadCrumbList = [customerData.name + ' ' + $scope.webAppTexts.breadcrumbs.admins]
    $scope.user = $cookies.getObject('vcUser')
    // $scope.filter = { $or: [{ isActive: 'true' }] }
    $scope.limit = 10
    $scope.uibPage = {
      currentPage: 1
    }

    /* Used to handle breadcrumb state after redirecting to another state. */
    $scope.uibPage.currentPage = $stateParams.adminPage ? $stateParams.adminPage : 1
    $scope.sort = $stateParams.sort ? $stateParams.sort : 'created'
    $scope.order = $stateParams.order ? $stateParams.order : -1
    $scope.searchText = $stateParams.searchText || ''

    $scope.sortBy = angular.copy(constants.sortByForUser)
    $scope.orderBy = angular.copy(constants.orderBy)

    $scope.sortBy.selected = _.find($scope.sortBy, { internalName: $scope.sort })
    $scope.orderBy.selected = _.find($scope.orderBy, { internalName: parseInt($scope.order) })

    /* This function is used to handle sorting. It invokes after changing
         sort or order and updates stateParams and calls pageChanged() to get updated user list.
      */
    $scope.setSorting = function (sort) {
      if (sort.type === 'sort') {
        $scope.sort = sort.internalName
        $location.search('sort', sort.internalName)
      } else {
        $scope.order = sort.internalName
        $location.search('order', sort.internalName)
      }
      $scope.uibPage.currentPage = 1
      $scope.pageChanged(1)
    }

    /* This function invokes after page or sort or order changes and sets
         currentPage in URL and calls getAllAdmin() to get updated user list.
      */
    $scope.pageChanged = function (currentPage) {
      $location.search('adminPage', $scope.uibPage.currentPage)
      getAllAdmin()
    }

    /* Search users in user list. */
    $scope.searchAdmin = function (searchText) {
      if (searchText !== undefined) {
        $scope.uibPage.currentPage = 1
        $location.search('adminPage', $scope.uibPage.currentPage)
        $scope.searchText = searchText
        $location.search('searchText', searchText)
        getAllAdmin()
      }
    }

    /* This function is used to get customers. It gives all customers, with active, deactive customer count. */
    function getAllAdmin () {
      $scope.busy = true
      var queryParams = {
        _id: $stateParams.customerId,
        // isActive: true,
        page: null,
        sort: {},
        filters: {},
        limit: $scope.limit
        // requireCustomerCount: true
      }
      queryParams.page = $scope.uibPage.currentPage || 1
      // queryParams.distributorId = $rootScope.user.distributorIds[0]
      queryParams.sort[$scope.sort] = $scope.order
      if ($scope.searchText) {
        queryParams.filters.firstName = {
          internalName: 'firstName',
          value: ($location.search().searchText && $location.search().searchText !== '' ? $scope.searchText : ''),
          type: 'regex',
          regexOptions: 'i'
        }
      }
      CustomerService.resource.getCustomerAdminsByCustomerId(queryParams, function (res) {
        $scope.adminList = res.users
        $scope.totalItems = res.total
        $scope.customerCount = res.customerCount
        $scope.busy = false
      }, function (err) {
        toastr.error(err.data.msg)
        $scope.busy = false
        $scope.adminList = []
      })
    }

    /* Add user button click handler clears existing data and redirects to addCustomer page. */
    $scope.addAdmin = function () {
    //   $state.go('addCustomerAdmin', { tab: 0 })
      var modalInstance = $uibModal.open({
        templateUrl: 'app/components/customers/actions/addCustomerAdminForm.html',
        controller: 'AddAdminFormCtrl',
        backdrop: true,
        resolve: {
          items: function () {
            return {
              customer: customerData
            }
          }
        }
      })

      modalInstance.result.then(function (result) {
        if (result) {
          getAllAdmin()
        }
      }, function () { })
    }

    /* Navigate to customers list page. */
    $scope.goBack = function () {
      $state.go('customers', $stateParams)
    }

    getAllAdmin()
  }
})();
(function () {
  'use strict'
  var angular = window.angular
  angular.module('Vibzer.components.customer')
    .controller('AddCustomer', AddCustomer);

  function AddCustomer ($rootScope, $scope, $state, $cookies, $stateParams, $uibModal, $location, UserService, CustomerService, customerData, toastr, constants, DistributorService) {
    $scope.addForm = true
    $scope.salesRep = {}
    $scope.user = $cookies.getObject('vcUser')
    $scope.customer = $rootScope.customer ? $rootScope.customer : {}
    $scope.info = $scope.customer
    $scope.tabNum = $stateParams.tab ? parseInt($stateParams.tab) : 0
    $scope.roles = [
      {
        _id: 0,
        name: 'Admin'
      },
      {
        _id: 1,
        name: 'Billing Admin'
      }
    ]
    $scope.breadCrumbList = ['Add Customer']
    $scope.allCountries = []
    /* Initiate customer detail for view and edit customer */
    $scope.initCustomerData = function () {
      $scope.addForm = true
      if (customerData && (customerData.edit || customerData.view)) {
        $scope.addForm = false
        if (customerData.edit) {
          $scope.breadCrumbList = ['Edit Customer : ' + customerData.name]
          $scope.editForm = true
          $scope.viewDetails = false
        }
        if (customerData.view) {
          $scope.breadCrumbList = [customerData.name]
          $scope.viewDetails = true
          $scope.editForm = false
          $scope.viewForm = true
        }
        $scope.customer = $rootScope.customer ? $rootScope.customer : customerData
        $scope.info = $scope.customer
      }
    }

    DistributorService.resource.allCountries(function (res) {
      $scope.allCountries = res.countries
      getUserCountry()
    }, function () { })
    $scope.initCustomerData()

    /* Get user list to assign select sales rep. */
    if ($scope.user.permission.addDistributorUser) {
      var queryParams = {
        customerId: $scope.user.distributorIds[0],
        distributorId: $scope.user.distributorIds[0],
        limit: 999,
        filters: { status: 'active' }
      }
      UserService.resource.getAllUsersOfCustomer(queryParams, function (res) {
        $scope.users = res.users
        $scope.showUsers = true
      }, function (err) {
        toastr.error(err.data.msg)
      })
    }

    /* Set current tab number in URL after changing the tab. */
    $scope.tabChange = function (tabNum) {
      $location.search('tab', tabNum)
    }

    /*
     Save form data before moving to another tab. Also
     handles browser back button event.
   */
    $scope.$on('$stateChangeStart', function (event, toState, toParams, fromState, fromParams, options) {
      if (toState.name === fromState.name && $stateParams.tab) {
        $rootScope.customer = angular.copy($scope.customer)
      } else {
        delete $rootScope['customer']
      }
    })
    /* Back button click handler. If current state is edit customer redirect to view customer details otherwise redirect to customer list page. */
    $scope.goBack = function () {
      if ($scope.editForm) {
        $state.go('viewCustomer', $stateParams)
      } else {
        $state.go('customers', $stateParams)
      }
    }

    /* Edit button click handler redirects to edit form page. */
    $scope.editCustomer = function () {
      $state.go('editCustomer', $stateParams)
    }

    /* Validation basic information form wizard to check whether all information is entered or not. */
    $scope.validateBasicInfoForm = function () {
      $scope.customer.addressForm.$submitted = false
      $scope.customer.basicInfoForm.$submitted = false
      if (!$scope.viewDetails) {
        if ($scope.customer.basicInfoForm.name.$error.required) {
          $scope.customer.basicInfoForm.$submitted = true
          return false
        } else {
          return true
        }
      }
      return true
    }

    /* Validation user information form wizard to check whether all information is entered or not. */
    $scope.validateUserInfoForm = function () {
      $scope.verifyEmailField()
      $scope.customer.userInfoForm.$submitted = false
      if (!$scope.viewDetails) {
        if ($scope.verifyEmailAddress) {
          return false
        }
        if ($scope.customer.userInfoForm.firstName.$error.required || $scope.customer.userInfoForm.lastName.$error.required ||
          $scope.customer.userInfoForm.email.$error.required || $scope.customer.userInfoForm.phone.$error.required || $scope.customer.userInfoForm.phone.$error.pattern) {
          $scope.customer.userInfoForm.$submitted = true
          return false
        } else {
          return true
        }
      }
      return true
    }

    /* Validation address form wizard to check whether all information is entered or not. */
    $scope.validateAddressForm = function () {
      if ($scope.customer.addressForm.country.$invalid || $scope.customer.addressForm.state.$invalid || $scope.customer.addressForm.addressLine1.$invalid || $scope.customer.addressForm.addressLine2.$invalid ||
        $scope.customer.addressForm.city.$invalid || $scope.customer.addressForm.emailId.$invalid || $scope.customer.addressForm.pinCode.$invalid || $scope.customer.addressForm.phone.$invalid) {
        $scope.customer.addressForm.$submitted = true
        return false
      }
      return true
    }

    /* To save or update hierarchy details */
    $scope.save = function () {
      var customer = _.pick($scope.customer, ['name', 'description', 'address'])
      if ($scope.editForm) {
        customer['_id'] = customerData['_id']
        var data = {
          customer: customer
        }
        CustomerService.resource.update(data, function (res) {
          toastr.success(constants.toastrMessages.success.updateCustomer)
          $state.go('viewCustomer', $stateParams)
        }, function (err) {
          toastr.error(err.data.msg)
        })
      } else {
        customer['distributorId'] = $rootScope.user.distributorIds[0]
        var admin = _.omit($scope.customer.admin, ['verifyEmail'])
        CustomerService.resource.add({ customer: customer, admin: admin, salesRepId: $scope.salesRep.id }, function (res) {
          toastr.success(constants.toastrMessages.success.addCustomer)
          $state.go('customers', $stateParams)
        }, function (err) {
          toastr.error(err.data.msg)
        })
      }
    }

    /* Verify email address entered is correct in user form wizard. */
    $scope.verifyEmailField = function () {
      if ($scope.customer.admin && $scope.customer.admin.email) {
        $scope.verifyEmailAddress = !($scope.customer.admin.email === $scope.customer.admin.verifyEmail)
      }
    }

    function getUserCountry () {
      if (($scope.addForm || $scope.editForm) && !($scope.customer.address && $scope.customer.address.country)) {
        window.$.getJSON('https://ipwhois.app/json/', function (data) {
          if (data) {
            !$scope.customer.address ? $scope.customer.address = {
              country: data.country
            } : $scope.customer.address.country = data.country
          }
        })
      }
    }
  }
})();
(function () {
    'use strict'
    angular.module('Vibzer.components')
      .controller('DeviceDetachDialogCtrl', DeviceDetachDialogCtrl);
  
    // @NgInject
    function DeviceDetachDialogCtrl($scope, $uibModalInstance, $sce, items, constants) {
      $scope.webAppTexts = constants.webAppTexts
      $scope.dialogMessage = $sce.trustAsHtml(items.message)
      $scope.dialogTitle = $sce.trustAsHtml(items.title)
  
      $scope.confirm = function () {
          var res = {
              reason: $scope.reason.value,
              commentText: $scope.commentText
          }
        $uibModalInstance.close(res)
      }
  
      $scope.closeModal = function () {
        $uibModalInstance.dismiss()
      }
    }
  })();
(function () {
  'use strict'
  angular.module('Vibzer.components')
    .controller('ManageDeviceDialogCtrl', ManageDeviceDialogCtrl);

  function defaultAxisCalibration() {
    var def = { physicalConversionConstant: null, ordinateToOrigin: null, rawToPhysicalDevidationFactor: null }
    return { x: angular.copy(def), y: angular.copy(def), z: angular.copy(def) }
  }

  // @NgInject
  function ManageDeviceDialogCtrl($scope, $uibModalInstance, $sce, items, constants, DistributorService, toastr) {
    $scope.webAppTexts = constants.webAppTexts
    $scope.dialogMessage = $sce.trustAsHtml(items.message)
    $scope.dialogTitle = $sce.trustAsHtml(items.title)
    if(items.deviceData && items.deviceData._id) {
      $scope.device = _.pick(items.deviceData, ['_id', 'deviceMacId', 'type', 'distributorId', 'serialNumber', 'calibartionConstants'])
    } else {
      $scope.device = { calibartionConstants: defaultAxisCalibration() }
      try {
        var stored = JSON.parse(window.localStorage.getItem('appConfig'))
        var cal = stored && (stored.calibartionConstants)
        if (cal && cal.x && cal.y && cal.z) $scope.device.calibartionConstants = angular.copy(cal)
      } catch (e) {}
    }
    $scope.selected = {}
    $scope.deviceTypes = angular.copy(constants.deviceTypes)
    $scope.distributors = []
    $scope.calibrationAxes = constants.calibrationAxes
    $scope.save = function () {
      $scope.deviceInfoForm.$submitted = true
      if (!$scope.deviceInfoForm.$valid) {
        toastr.error('Please fill all required fields')
        return
      }
      if (!$scope.device.calibartionConstants) $scope.device.calibartionConstants = defaultAxisCalibration()
      $uibModalInstance.close($scope.device)
    }
    items.deviceData && items.deviceData.type ? $scope.selected.type = items.deviceData.type : void 0
    $scope.getAllDistributors = function () {
      DistributorService.resource.getAllDistributors({ select: 'name' }, function (res) {
        $scope.distributors = res.data
        items.deviceData && items.deviceData.distributorId ? $scope.device.distributorId = items.deviceData.distributorId._id : void 0
      }, function (err) {
        toastr.error(err.data.msg)
      })
    }
    $scope.getAllDistributors()
    $scope.close = function () {
      $uibModalInstance.dismiss()
    }
  }
})();
(function () {
  'use strict'
  angular.module('Vibzer.components')
    .controller('AdminFormCtrl', adminFormCtrl);
  
  // @NgInject
  function adminFormCtrl ($scope, $uibModalInstance, toastr, UserService, adminIfo, constants) {
    $scope.webAppTexts = constants.webAppTexts
    /* Set bg-primary default class for modal-header. */
    $scope.modalHeaderClass = 'bg-primary'
    $scope.adminInfo = adminIfo || {}
    /* Save form details */
    $scope.save = function () {
      $uibModalInstance.close($scope.adminInfo)
    }

    /* Close popup dialog box */
    $scope.close = function () {
      $uibModalInstance.dismiss()
    }

    /* Enable or disable save button on condition of required fields */
    $scope.validateForm = function () {
      if ($scope.userInfoForm.firstName.$valid && $scope.userInfoForm.lastName.$valid &&
        $scope.userInfoForm.phone.$valid && $scope.userInfoForm.email.$valid) {
        return false
      }
      return true
    }
  }
})();
(function () {
  'use strict'
  var angular = window.angular
  angular.module('Vibzer.components.distributor')
    .controller('DistributorDetailCtrl', distributorDetailCtrl);

  function distributorDetailCtrl ($rootScope, $scope, $state, $cookies, $stateParams, $location, UserService, DeviceService, DistributorService, distributorData, toastr, constants) {
    $scope.webAppTexts = constants.webAppTexts
    $scope.user = $cookies.getObject('vcUser')
    $scope.tabNum = $stateParams.tab ? parseInt($stateParams.tab) : 0
    $scope.roles = [
      {
        _id: 0,
        name: 'Admin'
      }
    ]
    $scope.breadCrumbList = [$scope.webAppTexts.breadcrumbs.addDistributor]
    /* Initiate distributor detail for view and edit distributor */
    $scope.init = function () {
      $scope.addForm = true
      if (distributorData && (distributorData.edit || distributorData.view)) {
        $scope.addForm = false
        if (distributorData.edit) {
          $scope.breadCrumbList = [$scope.webAppTexts.breadcrumbs.editDistributor + ': ' + distributorData.name]
          $scope.editForm = true
          $scope.viewDetails = false
        }
        if (distributorData.view) {
          $scope.breadCrumbList = [distributorData.name]
          $scope.viewDetails = true
          $scope.editForm = false
          $scope.viewForm = true
        }
        $scope.distributor = distributorData
      } else {
        $scope.distributor = {}
      }
      $scope.info = $scope.distributor
      $scope.getAllTimezones()
    }

    /* Set current tab number in URL after changing the tab. */
    $scope.tabChange = function (tabNum) {
      $location.search('tab', tabNum)
    }
    /*
     Save form data before moving to another tab. Also
     handles browser back button event.
   */
    $scope.$on('$stateChangeStart', function (event, toState, toParams, fromState, fromParams, options) {
      if (toState.name === fromState.name && $stateParams.tab) {
        $rootScope.distributor = angular.copy($scope.distributor)
      } else {
        delete $rootScope['distributor']
      }
    })
    /* Back button click handler. If current state is edit distributor redirect to view distributor details otherwise redirect to distributor list page. */
    $scope.goBack = function () {
      if ($scope.editForm) {
        $state.go('viewDistributor', $stateParams)
      } else {
        $state.go('distributors', $stateParams)
      }
    }

    /* Edit button click handler redirects to edit form page. */
    $scope.editDistributor = function () {
      $state.go('editDistributor', $stateParams)
    }

    /* Validation basic information form wizard to check whether all information is entered or not. */
    $scope.validateBasicInfoForm = function () {
      $scope.distributor.addressForm.$submitted = false
      $scope.distributor.basicInfoForm.$submitted = false
      if (!$scope.viewDetails) {
        if ($scope.distributor.basicInfoForm.name.$error.required) {
          $scope.distributor.basicInfoForm.$submitted = true
          return false
        } else {
          return true
        }
      }
      return true
    }

    /* Validation user information form wizard to check whether all information is entered or not. */
    $scope.validateUserInfoForm = function () {
      $scope.verifyEmailField()
      $scope.distributor.userInfoForm.$submitted = false
      if (!$scope.viewDetails) {
        if ($scope.verifyEmailAddress) {
          return false
        }
        if ($scope.distributor.userInfoForm.firstName.$error.required || $scope.distributor.userInfoForm.lastName.$error.required ||
          $scope.distributor.userInfoForm.email.$error.required || $scope.distributor.userInfoForm.phone.$error.required || $scope.distributor.userInfoForm.phone.$error.pattern) {
          $scope.distributor.userInfoForm.$submitted = true
          return false
        } else {
          return true
        }
      }
      return true
    }

    /* Validation address form wizard to check whether all information is entered or not. */
    $scope.validateAddressForm = function () {
      if ($scope.distributor.addressForm.country.$invalid || $scope.distributor.addressForm.state.$invalid || $scope.distributor.addressForm.addressLine1.$invalid || $scope.distributor.addressForm.addressLine2.$invalid ||
        $scope.distributor.addressForm.city.$invalid || $scope.distributor.addressForm.emailId.$invalid || $scope.distributor.addressForm.pinCode.$invalid || $scope.distributor.addressForm.phone.$invalid) {
        $scope.distributor.addressForm.$submitted = true
        return false
      }
      return true
    }

    /* To save or update hierarchy details */
    $scope.save = function () {
      var distributor = {
        data: _.pick($scope.distributor, ['name', 'description', 'address'])
      }
      distributor.data.timezone = $scope.distributor.timezone ? $scope.distributor.timezone.utc[0] : 'Asia/Kolkata'
      if ($scope.editForm) {
        distributor.data._id = distributorData._id
        DistributorService.resource.update(distributor, function (res) {
          toastr.success(constants.toastrMessages.success.updateDistributor)
          $state.go('viewDistributor', $stateParams)
        }, function (err) {
          toastr.error(err.data.msg)
        })
      } else {
        distributor.admin = _.omit($scope.distributor.admin, ['verifyEmail'])
        DistributorService.resource.add(distributor, function (res) {
          toastr.success(constants.toastrMessages.success.addDistributor)
          $state.go('distributors', $stateParams)
        }, function (err) {
          toastr.error(err.data.msg)
        })
      }
    }

    // get all timezones. Populate browser's timezone by default
    $scope.getAllTimezones = function () {
      DeviceService.resource.getAllTimezones(function (res) {
        $scope.timezoneList = res.timezones
        var currentZone = $scope.distributor && $scope.distributor.timezone ? $scope.distributor.timezone : moment.tz.guess()
        _.filter($scope.timezoneList, function (zone) {
          if (_.includes(zone.utc, currentZone)) {
            $scope.distributor.timezone = zone
          }
        })
      })
    }

    /* Verify email address entered is correct in user form wizard. */
    $scope.verifyEmailField = function () {
      if ($scope.distributor.admin && $scope.distributor.admin.email) {
        $scope.verifyEmailAddress = !($scope.distributor.admin.email === $scope.distributor.admin.verifyEmail)
      }
    }
    $scope.init()
  }
})();
(function () {
  'use strict'
  var angular = window.angular
  var _ = window._
  angular.module('Vibzer.components.graphs')
    .controller('ConditionWiseTrendCtrl', ConditionWiseTrendCtrl)

  function ConditionWiseTrendCtrl ($scope, $state, $stateParams, $cookies, toastr, GraphService, ReportService, RouteService, CompositeService, machineData, constants, UserService) {
    $scope.machineData = machineData
    $scope.webAppTexts = constants.webAppTexts
    $scope.icon = _.find(constants.typesOfMachine, {
      name: machineData.machineTypeId.name
    }).icon
    $scope.nvd = {}
    $scope = GraphService.graphInitialization($scope, ['lineChart'])
    if ($stateParams.tkn && $stateParams.id) {
      setTimeout(function () {
        $cookies.put('authToken', $stateParams.tkn)
        $scope.$apply()
      }, 500)
      $scope.mobileView = true
      $scope.trendChart = $scope.lineChart
      if (!UserService.checkLoggedInUser() && $stateParams.tkn && $stateParams.id) {
        UserService.manageCookies('add')
      } else {
        $scope.notLoggedInUser = false
      }
      $scope.trendChart.options.chart = _.assign($scope.trendChart.options.chart, {
        useInteractiveGuideline: false,
        useVoronoi: false,
        height: 290,
        margin: {
          top: 10,
          right: 0,
          bottom: 40,
          left: 80
        },
        legend: {
          rightAlign: false
        },
        xAxis: {
          showMaxMin: false,
          axisLabel: 'Analysis Date',
          tickFormat: function (d) {
            return d >= 0 && d % 1 === 0 && $scope.dates[Math.round(d)] ? window.d3.time.format('%d %b %y %I:%M %p')(new Date($scope.dates[Math.round(d)])) : ''
          },
          rotateLabels: 15
        },
        legendPosition: 'bottom',
        yAxis: {
          showMaxMin: false,
          axisLabel: '',
          tickFormat: function (d) {
            var currentCondition = _.filter(constants.machineConditions, { id: d })[0]
            if (currentCondition) {
              return currentCondition.condition.replace(' condition', '')
            }
          },
          ticks: 5,
          axisLabelDistance: 10
        },
        zoom: {
          enabled: true,
          scaleExtent: [1, 20],
          useFixedDomain: false,
          useNiceScale: true,
          horizontalOff: false,
          verticalOff: true,
          unzoomEventType: 'dblclick.zoom'
        }
      })
    } else {
      // dynamic breadcrumbs
      $scope.breadCrumbList = [$scope.webAppTexts.breadcrumbs.machineList, $scope.webAppTexts.breadcrumbs.trends]
      // get route data
      if ($stateParams.routeId) {
        RouteService.resource.getRoute({ _id: $stateParams.routeId }, function (res) {
          $scope.routeData = res
          $scope.breadCrumbList = [$scope.webAppTexts.breadcrumbs.routeList, $scope.routeData.name, $scope.webAppTexts.breadcrumbs.trends]
        })
      }

      // get composite machine data
      if ($stateParams.compositeId) {
        CompositeService.resource.getById({ _id: $stateParams.compositeId }, function (res) {
          $scope.compositeData = res
          if ($scope.machineData.forComposite) {
            $scope.breadCrumbList = [$scope.webAppTexts.breadcrumbs.compositeMachineList, $scope.webAppTexts.breadcrumbs.trends]
          } else {
            $scope.breadCrumbList = [$scope.webAppTexts.breadcrumbs.compositeMachineList, $scope.compositeData.name, $scope.webAppTexts.breadcrumbs.trends]
          }
        })
      }
      $scope.trendChart = {
        name: 'Trend Chart',
        reportLabel: 'Condition',
        options: {
          chart: {
            type: 'lineChart',
            height: 450,
            margin: {
              top: 10,
              right: 40,
              bottom: 40,
              left: 80
            },
            x: function (d) { return d.x },
            y: function (d) { return d.y },
            forceY: [0.5, 5.5],
            reduceXTicks: false,
            useVoronoi: true,
            useInteractiveGuideline: true,
            xAxis: {
              showMaxMin: false,
              axisLabel: 'Analysis Date',
              tickFormat: function (d) {
                return d >= 0 && d % 1 === 0 && $scope.dates[Math.round(d)] ? window.d3.time.format('%d %b %y %I:%M %p')(new Date($scope.dates[Math.round(d)])) : '' // d >= 0 && $scope.dates[Math.round(d)] ? window.d3.time.format('%d %b %y %I:%M %p')(new Date($scope.dates[Math.round(d)])) : ''
              },
              ticks: 3
            },
            yAxis: {
              showMaxMin: false,
              axisLabel: 'Condition',
              tickFormat: function (d) {
                var currentCondition = _.filter(constants.machineConditions, { id: d })[0]
                if (currentCondition) {
                  return currentCondition.condition.replace(' condition', '')
                }
              },
              ticks: 5,
              axisLabelDistance: 10
            },
            zoom: {
              enabled: true,
              scaleExtent: [1, 20],
              useFixedDomain: false,
              useNiceScale: true,
              horizontalOff: false,
              verticalOff: true,
              unzoomEventType: 'dblclick.zoom'
            }
          },
          title: {
            enable: true,
            html: '<strong>' + _.capitalize(machineData.machineTypeId.name) + ': </strong>' + machineData.name
          }
        }
      }
    }

    var getMachineTrendReport = function () {
      var params = {
        machineId: machineData._id
      }
      ReportService.resource.faultSpecificCondition(params, function (res) {
        $scope.trendChart.data = res.result
        $scope.dates = res.dates
      }, function (err) {
        toastr.error('Fail to load report.')
        console.log(err)
      })
    }

    machineData._id ? getMachineTrendReport() : void 0

    $scope.$on('$destroy', function () {
      window.d3.selectAll('.nvtooltip').remove()
    })

    /* Redirects to machines page. */
    $scope.breadCrumbClickHandler = function (itm) {
      if ($stateParams.compositeId && $scope.machineData.forComposite) {
        $state.go('compositeMachines', { compositeData: $stateParams.compositeData })
      } else if ($stateParams.routeId && itm === $scope.webAppTexts.breadcrumbs.routeList) {
        $state.go('routes', { routeFilters: $stateParams.routeFilters })
      } else if ($stateParams.routeId && itm === $scope.routeData.name) {
        $state.go('routeMachines', { routeId: $stateParams.routeId, machineData: $stateParams.machineData, routeFilters: $stateParams.routeFilters })
      } else if ($stateParams.compositeId && itm === $scope.webAppTexts.breadcrumbs.compositeMachineList) {
        $state.go('compositeMachines', { compositeData: $stateParams.compositeData })
      } else if ($stateParams.compositeId && itm === $scope.compositeData.name) {
        $state.go('machinesFromComposite', { compositeId: $stateParams.compositeId, machineData: $stateParams.machineData, compositeData: $stateParams.compositeData })
      } else {
        $state.go('machines', { machineData: $stateParams.machineData })
      }
    }
  }
})();
(function () {
  'use strict'
  var angular = window.angular
  var moment = window.moment
  var _ = window._
  angular.module('Vibzer.components.graphs')
    .controller('TrendsCtrl', TrendsCtrl)

  function TrendsCtrl($scope, $state, $stateParams, GraphService, ReportService, machineData, constants) {
    $scope.breadCrumbList = ['Machines', 'Overall Trend']
    $scope.dateFormat = constants.dateFormats.default
    $scope.breadCrumbClickHandler = function (state) {
      $state.go('machines', { machineData: $stateParams.machineData })
    }
    $scope.overallTrend = {}
    $scope.isMonMachine = machineData.machineTypeId.name === 'machine'
    if (machineData.meta && machineData.meta.points) {
      $scope.selected = {
        point: machineData.meta.points[0]
      }
    }
    var hasUserLimits = machineData && machineData.monitoredOnline && machineData.analysisConfiguration && machineData.analysisConfiguration.permanent.type === 1
    $scope.machineData = machineData
    $scope.icon = _.find(constants.typesOfMachine, {
      name: $scope.machineData.machineTypeId.name
    }).icon
    $scope = GraphService.graphInitialization($scope, ['lineChart'])
    $scope.trendChart = angular.copy($scope.lineChart)
    $scope.trendFaults = angular.copy(constants.trendWithFaults)

    $scope.getOrClearCustomSessions = function (type, limit) {
      if (type === 'clear') {
        $scope.sessionLimit = null
      }
      if (!$scope.sessionLimit && type === 'get') {
        return ''
      } else {
        $scope.initTrend()
      }
    }
    $scope.trendChart.options.chart = _.assign(_.omit($scope.trendChart.options.chart, 'forceY'), {
      useInteractiveGuideline: false,
      lines: {},
      useVoronoi: true,
      height: 320,
      margin: {
        top: 10,
        right: 20,
        bottom: 80,
        left: 90
      },
      xAxis: {
        showMaxMin: false,
        axisLabel: 'Time',
        ticks: 10,
        tickFormat: function (d) {
          // return d >= 0 && d % 1 === 0 && $scope.dates[Math.round(d)] ? window.d3.time.format('%d %b %y %I:%M %p')(new Date($scope.dates[Math.round(d)])) : ''
          return window.d3.time.format('%d %b %y %I:%M %p')(new Date(d))
        },
        axisLabelDistance: -10
      },
      forceY: [0],
      showXAxis: true,
      yAxis: {
        ticks: 5,
        showMaxMin: false,
        axisLabel: 'Severity [mm/s RMS]'
      },
      legend: {
        rightAlign: false
      },
      pointSize: function (d) {
        return d.pointSize || 50
      },
      showLegend: false,
      tooltips: true,
      zoom: {
        enabled: false,
        scaleExtent: [1, 20],
        useFixedDomain: false,
        useNiceScale: true,
        horizontalOff: false,
        verticalOff: true,
        unzoomEventType: 'dblclick.zoom'
      }
    })
    $scope.$on('scroll', function () {
      window.d3.selectAll('.nvtooltip').remove()
    })

    function getGraphFormatData(array) {
      return _.map(array, function (rms, index) {
        return {
          x: $scope.dates[index],
          y: rms
        }
      })
    }

    function getAvgStdData(stdDev, data) {
      return _.map(new Array($scope.dates.length), function (itm, index) {
        return {
          x: $scope.dates[index],
          y: data.average + (stdDev * data.std),
          pointSize: 0.1
        }
      })
    }

    function getWarningAndAlertValues(type, data) {
      return _.map(new Array($scope.dates.length), function (itm, index) {
        return {
          x: $scope.dates[index],
          y: data[type],
          pointSize: 0.1
        }
      })
    }

    $scope.filterValues = angular.copy(constants.trendByFaultsForMonitoring)

    function getFaultValuesForMonitoringPoint(filter) {
      var params = {
        machineId: machineData._id,
        created: new Date(),
        monitoringPointName: machineData.dataCollectors[machineData.dataCollectors.length - 1].monitoringPointName,
        dataCollectorId: machineData.dataCollectors[machineData.dataCollectors.length - 1]._id
      }
      $scope.sessionLimit ? params.limit = $scope.sessionLimit : void 0
      filter.trendChart = angular.copy($scope.trendChart)
      GraphService.resource.getMonitoringReportGraph(params, function (res) {
        filter.isFilterActive = true
        $scope.type = filter.internalName
        $scope.trendChart.options.chart.yAxis.axisLabel = filter.yLabel
        generateGraph(filter, createStdAvgChartData(filter.internalName, res))
      })
    }

    $scope.ignoreChange = function () {
      $scope.initTrend()
    }

    function createStdAvgChartData(type, data) {
      if (type === 'severity') {
        var maxAvg = _.max([data.avgAndStdData.avgSeverity.x, data.avgAndStdData.avgSeverity.y, data.avgAndStdData.avgSeverity.z])
        var maxStd = _.max([data.avgAndStdData.stdDeviationSeverity.x, data.avgAndStdData.stdDeviationSeverity.y, data.avgAndStdData.stdDeviationSeverity.z])
      } else {
        maxAvg = _.max([data.avgAndStdData.avgCrestFactor.x, data.avgAndStdData.avgCrestFactor.y, data.avgAndStdData.avgCrestFactor.z])
        maxStd = _.max([data.avgAndStdData.stdDeviationCrestFactor.x, data.avgAndStdData.stdDeviationCrestFactor.y, data.avgAndStdData.stdDeviationCrestFactor.z])
      }
      var baseLine = _.max([data.reportData[type + 'X'][0].value, data.reportData[type + 'Y'][0].value, data.reportData[type + 'Z'][0].value])
      $scope.baseLineValue = baseLine
      $scope.maxWithOneSD = (maxAvg + maxStd)
      var date = []
      var severityValues = []
      _.times(data.reportData[type + 'X'].length, function (index) {
        date.push(new Date(data.reportData[type + 'X'][index].date).getTime())
        severityValues.push(_.max([data.reportData[type + 'X'][index].value, data.reportData[type + 'Y'][index].value, data.reportData[type + 'Z'][index].value]))
      })
      if (type === 'severity') {
        return {
          date: date,
          severity: severityValues,
          average: maxAvg,
          std: maxStd
        }
      } else {
        return {
          date: date,
          crestFactor: severityValues,
          average: maxAvg,
          std: maxStd
        }
      }
    }

    $scope.graphData = {}

    function generateGraph(filter, data) {
      var prevPointIndex, prevPoint = {}
      filter.trendChart.options.chart.lines.dispatch = {
        elementClick: function (event) {
          if (event.series.key === 'Severity' || event.series.key === 'Crest Factor') {
            event.series.selectedPointIndex || event.series.selectedPointIndex === 0 ? event.series.values[event.series.selectedPointIndex].pointSize = 50 : void 0
            event.point.pointSize = 150
            $scope.overallTrend.selectedSeverity = parseFloat(event.point.y.toFixed(2)) ? event.point.y.toFixed(2) : 0
            $scope.overallTrend.selectedDate = event.point.x
            event.series.selectedPointIndex = event.pointIndex
          }
          window.d3.selectAll('.nvtooltip').style('opacity', 0)
          if ((prevPointIndex || prevPointIndex === 0) && prevPoint) {
            window.d3.selectAll('.nv-group.nv-series-0 path.nv-point.nv-point-' + prevPointIndex).each(function (item) {
              if (item[0].x === prevPoint.x && item[0].y === prevPoint.y && item[0].pointSize === 50) {
                this.style.setProperty('fill', '#42d7f4')
              }
            })
          }
          window.d3.selectAll('.nv-group.nv-series-0 path.nv-point.nv-point-' + event.pointIndex).each(function (item) {
            if (item[0].x === event.point.x && item[0].y === event.point.y && item[0].pointSize === 150) {
              this.style.setProperty('fill', 'rgb(0, 44, 189)')
              prevPointIndex = event.series.selectedPointIndex
              prevPoint = item[0]
            }
          })
          event.resize()
        },
        elementMouseover: function (d) {
          if (d.seriesIndex === 1 || d.seriesIndex === 2) {
            window.d3.selectAll('.nvtooltip').each(function () {
              this.style.setProperty('display', 'none', 'important')
            })
          } else {
            window.d3.selectAll('.nvtooltip').each(function () {
              this.style.setProperty('display', 'block', 'important')
            })
          }
        }
      }
      $scope = GraphService.graphInitialization($scope, ['lineChart'])
      var allData = []
      filter.warning = parseFloat((data.average + data.std).toFixed(2)) ? (data.average + data.std).toFixed(2) : 0
      filter.trip = parseFloat((data.average + (2 * data.std)).toFixed(2)) ? (data.average + (2 * data.std)).toFixed(2) : 0
      allData = allData.concat(data[$scope.type])
      allData.push(parseFloat(filter.warning))
      allData.push(parseFloat(filter.trip))
      allData = _.sortBy(allData)
      var sum = allData.reduce(function (a, b) {
        return a + b
      }, 0)
      data[$scope.type].length > 20 ? filter.trendChart.options.chart.zoom.scaleExtent[1] = data[$scope.type].length : void 0

      var diff = moment(data.date[data.date.length - 1]).diff(data.date[0]) / 10
      $scope.tickValues = []
      _.times(data.date.length, function (index) {
        if (index === 0) {
          $scope.tickValues.push(data.date[0])
        } else {
          $scope.tickValues.push($scope.tickValues[index - 1] + diff)
        }
      })
      $scope.dates = data.date
      filter.trendChart.options.chart.forceX = [(data.date[0] - moment(data.date[1]).diff(data.date[0])), (data.date[data.date.length - 1] + moment(data.date[1]).diff(data.date[0]))]
      var YAvg = (sum / allData.length)
      filter.trendChart.options.chart.forceY = [0 - YAvg, allData[allData.length - 1] + YAvg]
      var allAxisData = [{
        values: getGraphFormatData(data[$scope.type]),
        key: filter.displayName,
        color: '#42d7f4'
      },
      {
        values: getAvgStdData(1, 1, data),
        key: 'Warning',
        color: '#FFA500'
      },
      {
        values: getAvgStdData(2, 1, data),
        key: 'Trip',
        color: '#cc3300'
      }
      ]
      filter.trendChart.data = allAxisData
    }

    $scope.getRMSTrendForOverallVibration = function () {
      $scope.busy = true
      var prevPointIndex, prevPoint = {}
      $scope.overallTrend.trendChart = angular.copy($scope.trendChart)
      $scope.overallTrend.trendChart.options.chart.lines.dispatch = {
        elementClick: function (event) {
          window.d3.selectAll('.nvtooltip').style('opacity', 0)
          if (event.series.key === 'Severity') {
            event.series.selectedPointIndex || event.series.selectedPointIndex === 0 ? event.series.values[event.series.selectedPointIndex].pointSize = 50 : void 0
            event.point.pointSize = 150
            $scope.overallTrend.selectedSeverity = parseFloat(event.point.y.toFixed(2)) ? event.point.y.toFixed(2) : 0
            $scope.overallTrend.selectedDate = event.point.x
            event.series.selectedPointIndex = event.pointIndex
            if ((prevPointIndex || prevPointIndex === 0) && prevPoint) {
              window.d3.selectAll('.nv-group.nv-series-0 path.nv-point.nv-point-' + prevPointIndex).each(function (item) {
                if (item[0].x === prevPoint.x && item[0].y === prevPoint.y && item[0].pointSize === 50) {
                  this.style.setProperty('fill', '#42d7f4')
                }
              })
            }
            window.d3.selectAll('.nv-group.nv-series-0 path.nv-point.nv-point-' + event.pointIndex).each(function (item) {
              if (item[0].x === event.point.x && item[0].y === event.point.y && item[0].pointSize === 150) {
                this.style.setProperty('fill', 'rgb(0, 44, 189)')
                prevPointIndex = event.series.selectedPointIndex
                prevPoint = item[0]
              }
            })
          }
          $scope.events.resize()
        },
        elementMouseover: function (d) {
          if (d.seriesIndex === 1 || d.seriesIndex === 2) {
            window.d3.selectAll('.nvtooltip').each(function () {
              this.style.setProperty('display', 'none', 'important')
            })
          } else {
            window.d3.selectAll('.nvtooltip').each(function () {
              this.style.setProperty('display', 'block', 'important')
            })
          }
        }
      }
      var params = {
        machineId: machineData._id
      }
      if (!$scope.isMonMachine) {
        params.pointSet = $scope.selected.point.internalName
      }
      if ($scope.sessionLimit) {
        params.limit = $scope.sessionLimit
        params.ignoreEarlier = $scope.ignoreEarlier
      } else {
        $scope.ignoreEarlier = false
      }

      ReportService.resource.getOverallVibrationTrendData(params, function (res) {
        res = res.result
        if (!res.date || (res.date && !res.date.length)) {
          $scope.overallTrend.trendChart.data = []
          return
        }
        if (!hasUserLimits) {
          $scope.overallTrend.warning = parseFloat((res.average + res.std).toFixed(2)) ? (res.average + res.std).toFixed(2) : 0
          $scope.overallTrend.trip = parseFloat((res.average + (2 * res.std)).toFixed(2)) ? (res.average + (2 * res.std)).toFixed(2) : 0
        } else {
          $scope.overallTrend.warning = res.warning ? res.warning.toFixed(2) : 0
          $scope.overallTrend.trip = res.alert ? res.alert.toFixed(2) : 0
        }
        var allData = []
        allData = allData.concat(res.severity)
        allData.push(parseFloat($scope.overallTrend.warning))
        allData.push(parseFloat($scope.overallTrend.trip))
        allData = _.sortBy(allData)
        var sum = allData.reduce(function (a, b) {
          return a + b
        }, 0)
        res.severity.length > 20 ? $scope.overallTrend.trendChart.options.chart.zoom.scaleExtent[1] = res.severity.length : void 0

        var diff = moment(res.date[res.date.length - 1]).diff(res.date[0]) / 10
        $scope.tickValues = []
        _.times(res.date.length, function (index) {
          if (index === 0) {
            $scope.tickValues.push(res.date[0])
          } else {
            $scope.tickValues.push($scope.tickValues[index - 1] + diff)
          }
        })

        $scope.dates = res.date
        $scope.overallTrend.trendChart.options.chart.forceX = [(res.date[0] - moment(res.date[1]).diff(res.date[0])), (res.date[res.date.length - 1] + moment(res.date[1]).diff(res.date[0]))]
        var YAvg = (sum / allData.length)
        $scope.overallTrend.trendChart.options.chart.forceY = [0 - YAvg, allData[allData.length - 1] + YAvg]
        var allAxisData = [{
          values: getGraphFormatData(res.severity),
          key: 'Severity',
          color: '#42d7f4',
          fName: 'overallTrend'
        },
        {
          values: (hasUserLimits ? getWarningAndAlertValues('warning', res) : getAvgStdData(1, res)),
          key: 'Warning',
          color: '#FFA500',
          fName: 'overallTrend'
        },
        {
          values: (hasUserLimits ? getWarningAndAlertValues('alert', res) : getAvgStdData(2, res)),
          key: 'Trip',
          color: '#cc3300',
          fName: 'overallTrend'
        }
        ]
        $scope.overallTrend.trendChart.data = allAxisData
      }, function (err) {
        $scope.busy = false
      })
    }

    $scope.initTrend = function () {
      $scope.getRMSTrendForOverallVibration()
    }
    $scope.initTrend()
  }
})();
(function () {
  'use strict'
  var angular = window.angular
  angular.module('Vibzer.components.hierarchy')
    .controller('AddHierarchyLevelCtrl', AddHierarchyLevelCtrl)

  function AddHierarchyLevelCtrl ($scope, $cookies, $rootScope, $state, $uibModal, CustomerService, toastr, constants) {
    $scope.webAppTexts = constants.webAppTexts
    $scope.levelInfo = {}
    $scope.hierarchyData = [
      {
        level: 1,
        name: undefined
      },
      {
        level: 2,
        name: undefined
      },
      {
        level: 3,
        name: undefined
      }
    ]

    $scope.hierarchyLevels = [
      {
        level: 1,
        name: '(Plant)'
      },
      {
        level: 2,
        name: '(Plant/Area)'
      },
      {
        level: 3,
        name: '(Plant/Area/Section)'
      }
    ]

    if ($rootScope.user.customer.hierarchyType.length !== 0) {
      $scope.disabled = true
      $scope.levelInfo.level = $rootScope.user.customer.hierarchyType.length
      for (var index = 0; index < $rootScope.user.customer.hierarchyType.length; index++) {
        $scope.hierarchyData[index].name = $rootScope.user.customer.hierarchyType[index].name
      }
    }

    $scope.saveDisabled = function () {
      if (!$scope.levelInfo.level) {
        return true
      }
      for (var index = 0; index < $scope.levelInfo.level; index++) {
        if (!$scope.hierarchyData[index].name) {
          return true
        }
      }
      return false
    }

    $scope.save = function () {
      var hierarchy = []
      for (var index = 0; index < $scope.levelInfo.level; index++) {
        hierarchy.push($scope.hierarchyData[index])
      }
      var message = constants.toastrMessages.success.hierarchyStructure
      var items = function () {
        return {
          buttons: {
            yes: 'Confirm',
            no: 'Cancel'
          },
          message: message,
          title: '<i aria-hidden="true"></i> ' + $scope.webAppTexts.headings.organizationStructure,
          showActiveWindow: true
        }
      }
      var modalInstance = $uibModal.open({
        templateUrl: 'app/components/confirmationDialog/confirmationDialog.html',
        controller: 'AllConfirmationDialogCtrl',
        resolve: {
          items: items
        }
      })

      modalInstance.result.then(function (result) {
        var data = {
          customer: {
            _id: $rootScope.user.customer._id,
            name: $rootScope.user.customerName,
            hierarchyType: hierarchy
          }
        }
        CustomerService.resource.update(data, function (res) {
          toastr.success(constants.toastrMessages.success.saveOrgStructure)
          $rootScope.user.customer.hierarchyType = res.hierarchyType
          $cookies.putObject('vcUser', $rootScope.user)
          $state.go('dashboard')
        }, function (err) {
          toastr.error(err.data.msg)
        })
      }, function () { })
    }

    /*
     Set level name to default values when user changes hierarchy level drop down.
   */
    $scope.levelChanged = function () {
      if ($scope.levelInfo.level > 0) {
        $scope.hierarchyData = [
          {
            level: 1,
            name: undefined
          },
          {
            level: 2,
            name: undefined
          },
          {
            level: 3,
            name: undefined
          }
        ]
      }
    }
    /*
     Handles browser back button event.
   */
    window.onhashchange = function (event) {
      if (!window.innerDocClick && $state.current.name !== 'addHierarchyLevel') {
        if (_.isEmpty($rootScope.user.customer.hierarchyType)) {
          $state.go('addHierarchyLevel')
        }
      }
    }
  }
})();

(function () {
  'use strict'
  var angular = window.angular
  angular.module('Vibzer.components.hierarchy')
    .controller('AddHierarchy', AddHierarchy)

  function AddHierarchy ($rootScope, $scope, $state, $stateParams, $uibModal, $location, UserService, toastr, hierarchyData, constants, HierarchyService, UtilService) {
    $scope.webAppTexts = constants.webAppTexts
    $scope.addForm = true
    $scope.tabNum = $stateParams.tab ? parseInt($stateParams.tab) : 0
    $scope.canEdit = $stateParams.canEdit ? $stateParams.canEdit === 'true' : true
    $scope.languages = ['English', 'Spanish']
    $scope.lineFreq = [{ label: '50 Hz', value: 50 }, { label: '60 Hz', value: 60 }, { label: 'Other', value: -1 }]
    $scope.limit = 10
    $scope.roles = [
      {
        _id: 0,
        name: 'Admin'
      },
      {
        _id: 1,
        name: 'Manager'
      }
    ]
    $scope.roleInfo = $rootScope.roleInfo ? $rootScope.roleInfo : []

    /* Check whether motor RPM is selected or not If not or if it is less than 300 display error block */
    $scope.$watch('hierarchy.customLineFrequency', function (newValue, oldValue) {
      if (parseInt($scope.hierarchy.customLineFrequency) || parseInt($scope.hierarchy.customLineFrequency) === 0) {
        if (parseInt($scope.hierarchy.customLineFrequency) > 200 || parseInt($scope.hierarchy.customLineFrequency) < 1) {
          $scope.customLineFrequencyRequired = true
        } else {
          $scope.customLineFrequencyRequired = false
        }
      } else {
        $scope.customLineFrequencyRequired = false
      }
    }, true)

    /* To get hierarchical level details of hierarchy by using hierarchyTypeId */
    $scope.getLevelByHierarchyId = function (hierarchyData) {
      if (hierarchyData && hierarchyData.hierarchyTypeId) {
        var level = _.find($rootScope.user.customer.hierarchyType, ['_id', hierarchyData.hierarchyTypeId])
        if (hierarchyData.add) {
          level = _.find($rootScope.user.customer.hierarchyType, ['level', level.level + 1])
        }
        return level
      } else {
        return _.find($rootScope.user.customer.hierarchyType, ['level', 1])
      }
    }

    $scope.currentLevel = $scope.getLevelByHierarchyId(hierarchyData)
    $scope.isFirstLevel = $scope.currentLevel.level === 1
    $scope.breadCrumbList = ['Add ' + $scope.currentLevel.name]

    /* Get user list to assign role */
    if ($scope.tabNum === 2 || $scope.currentLevel.level >= 1) {
      UserService.resource.getAllUsersOfCustomer({ customerId: $scope.user.customerIds[0], filters: { status: 'active' }, limit: 999 }, function (res) {
        $scope.users = res.users
        if (hierarchyData && hierarchyData.roleData && (hierarchyData.edit || hierarchyData.view)) {
          _.each(hierarchyData.roleData, function (item) {
            var role = {
              userId: item.userId,
              role: {
                name: item.role
              },
              resourcesId: item.resourcesId,
              existsInDb: true
            }
            var user = _.find($scope.users, ['_id', item.userId])
            if (user) {
              var userData = _.find($scope.users, ['_id', item.userId])
              role.userName = userData.firstName + ' ' + userData.lastName
              role.email = userData.email
            } else if (item.userId === $rootScope.user._id) {
              role.userName = $rootScope.user.firstName + ' ' + $rootScope.user.lastName      // login user
              role.email = $rootScope.user.email
            } else {
              UserService.resource.getUserById({ _id: role.userId }, function (res) {
                role.userName = res.firstName + ' ' + res.lastName
                role.email = res.email
              }, function (err) {
                toastr.error(err.data.msg)
              })
            }
            $scope.roleInfo.push(role)
          })
        }
        $scope.showUsers = true
      }, function (err) {
        toastr.error(err.data.msg)
      })
    }

    /* Initiate hierarchy detail for view and edit hierarchy */
    $scope.initHierarchyData = function () {
      $scope.addForm = true
      if ($scope.currentLevel.level === $rootScope.user.customer.hierarchyType.length) {
        var lowerHierarchyRoles = [
          {
            _id: 3,
            name: 'Engineer'
          }
        ]
        $scope.roles = _.concat($scope.roles, lowerHierarchyRoles)
      }
      if ($scope.currentLevel.level === 1) {
        $scope.hierarchy = !_.isEmpty($rootScope.hierarchy) ? $rootScope.hierarchy : hierarchyData
      }
      if (_.isEmpty($scope.hierarchy)) {
        $scope.hierarchy = {}
        $scope.hierarchy.meta = {
          address: {
            sameAsCompanyAddress: true
          }
        }
        $scope.hierarchy.meta.address = $rootScope.user.customer.address
        $scope.hierarchy.meta.address.sameAsCompanyAddress = true
        $scope.hierarchy.meta.language = 'English'
        $scope.hierarchy.meta.line_frequency = $scope.lineFreq[1].value
      }
      if (hierarchyData && (hierarchyData.edit || hierarchyData.view)) {
        $scope.addForm = false
        if (hierarchyData.edit) {
          $scope.breadCrumbList = ['Edit ' + $scope.currentLevel.name + ' : ' + hierarchyData.name]
          $scope.editForm = true
          $scope.viewDetails = false
        }
        if (hierarchyData.view) {
          $scope.breadCrumbList = [hierarchyData.name]
          $scope.viewDetails = true
          $scope.editForm = false
          $scope.viewForm = true
        }
        if ($scope.currentLevel.level === 1) {
          $scope.hierarchy.meta.language = !_.isEmpty($rootScope.hierarchy) ? $rootScope.hierarchy.meta.language : hierarchyData.meta.language
          var customLineFrequency = $scope.hierarchy.customLineFrequency || $scope.hierarchy.meta.line_frequency
          $scope.hierarchy.meta.line_frequency = _.find($scope.lineFreq, ['value', $scope.hierarchy.meta.line_frequency]) ? $scope.hierarchy.meta.line_frequency : -1
          $scope.hierarchy.customLineFrequency = $scope.hierarchy.meta.line_frequency === -1 ? customLineFrequency : null
        } else {
          $scope.hierarchy = hierarchyData
        }
        $scope.hierarchy.role = hierarchyData.roleData.role
        $scope.hierarchy.user = hierarchyData.roleData.userId
      }
    }

    $scope.initHierarchyData()

    /* Set current tab number in URL after changing the tab. */
    $scope.tabChange = function (tabNum) {
      if (tabNum === 1 && $scope.hierarchy.addressForm) {
        $scope.hierarchy.addressForm.$submitted = false
      }
      $location.search('tab', tabNum)
    }

    /*
      Save form data before moving to another tab. Also
      handles browser back button event.
    */
    $scope.$on('$stateChangeStart', function (event, toState, toParams, fromState, fromParams, options) {
      if (toState.name === fromState.name && $stateParams.tab) {
        $rootScope.hierarchy = angular.copy($scope.hierarchy)
        var addedRoles = _.filter($scope.roleInfo, function (item) {
          if (!item.existsInDb) {
            return item
          }
        })
        if (addedRoles && addedRoles.length > 0) {
          $rootScope.roleInfo = angular.copy(addedRoles)
        }
      } else {
        delete $rootScope['hierarchy']
        delete $rootScope['roleInfo']
      }
    })

    /* Back button click handler. If current state is edit machine redirect to view machine details otherwise redirect to machine list page. */
    $scope.goBack = function () {
      if ($scope.editForm) {
        $state.go('viewHierarchy', { hierarchyId: hierarchyData['_id'], tab: $stateParams.tab, navigation: $stateParams.navigation, page: $stateParams.page, parentHierarchyId: $stateParams.parentHierarchyId, sort: $stateParams.sort, order: $stateParams.order })
      } else {
        $state.go('hierarchy', { currentPage: $stateParams.page, hierarchyId: $stateParams.parentHierarchyId || (hierarchyData ? hierarchyData['_id'] : null), navigation: $stateParams.navigation, sort: $stateParams.sort, order: $stateParams.order })
      }
    }

    /* Check whether line frequency is selected or not If not then display error block */
    $scope.$watch('hierarchy.meta.line_frequency', function (newValue, oldValue) {
      $scope.hierarchy.isLineFrequencyRequired = false
    }, true)

    /* Check whether language is selected or not If not then display error block */
    $scope.$watch('hierarchy.meta.language', function (newValue, oldValue) {
      $scope.hierarchy.isLanguageRequired = false
    }, true)

    /* Edit button click handler redirects to edit form page. */
    $scope.editHierarchy = function () {
      $state.go('editHierarchy', { hierarchyId: $stateParams.hierarchyId, tab: $stateParams.tab, page: $stateParams.page, navigation: $stateParams.navigation, parentHierarchyId: $stateParams.parentHierarchyId })
    }

    /* Disable save button until all fields are not filled for area form */
    $scope.saveButtonVisibility = function () {
      return !($scope.hierarchy.name)
    }

    /* Validation basic information form wizard to check whether all information is entered or not. */
    $scope.validateBasicInfoForm = function () {
      $scope.hierarchy.basicInfoForm.$submitted = false
      if (!$scope.viewDetails) {
        $scope.hierarchy.isLineFrequencyRequired = !($scope.hierarchy.meta && $scope.hierarchy.meta.line_frequency)
        $scope.hierarchy.isLanguageRequired = !($scope.hierarchy.meta && $scope.hierarchy.meta.language)
        if ($scope.hierarchy.basicInfoForm.name.$error.required || $scope.hierarchy.isLineFrequencyRequired || $scope.hierarchy.isLanguageRequired || $scope.customLineFrequencyRequired) {
          $scope.hierarchy.basicInfoForm.$submitted = true
          return false
        } else {
          return true
        }
      }
      return true
    }

    /* Show or hide address form on selection of 'Same as company address' field */
    $scope.changingAddressType = function (labelClick) {
      if (labelClick) {
        $scope.hierarchy.meta.address.sameAsCompanyAddress = !$scope.hierarchy.meta.address.sameAsCompanyAddress
      }
      var sameAsCompanyAddress = $scope.hierarchy.meta.address.sameAsCompanyAddress
      $scope.hierarchy.meta.address = {}
      if (sameAsCompanyAddress) {
        $scope.hierarchy.meta.address = $rootScope.user.customer.address
      }
      $scope.hierarchy.meta.address.sameAsCompanyAddress = sameAsCompanyAddress
    }

    /* Validation address form wizard to check whether all information is entered or not. */
    $scope.validateAddressForm = function () {
      if (!$scope.hierarchy.meta.address.sameAsCompanyAddress) {
        if ($scope.hierarchy.addressForm.country.$invalid || $scope.hierarchy.addressForm.state.$invalid ||
          $scope.hierarchy.addressForm.city.$invalid || $scope.hierarchy.addressForm.emailId.$invalid || $scope.hierarchy.addressForm.pinCode.$invalid || $scope.hierarchy.addressForm.phone.$invalid) {
          $scope.hierarchy.addressForm.$submitted = true
          return false
        }
        return true
      }
      return true
    }

    /* For user information wizard form to save selected role and user */
    $scope.addRole = function () {
      var roleInfo = {
        role: $scope.hierarchy.role,
        userId: $scope.hierarchy.user,
        existsInDb: false
      }
      roleInfo['email'] = _.find($scope.users, { '_id': $scope.hierarchy.user }) ? _.find($scope.users, { '_id': $scope.hierarchy.user }).email : ''
      if ($scope.roleInfo && $scope.roleInfo.length >= 1) {
        var roleAlreadyExist = _.find($scope.roleInfo, function (roleItem) {
          if (roleItem.role.name === roleInfo.role.name && roleItem.userId === roleInfo.userId) {
            return roleItem
          }
        })
        if (roleAlreadyExist) {
          toastr.success('Role with same user already exists')
          return
        }
      }
      var userName = _.find($scope.users, ['_id', $scope.hierarchy.user])
      roleInfo['userName'] = userName.firstName + ' ' + userName.lastName
      $scope.hierarchy.user = null
      $scope.hierarchy.role = null
      $scope.roleInfo.push(roleInfo)
    }

    /* For user information wizard form to remove selected role and user */
    $scope.removeRole = function (indexToRemove) {
      var roleData = $scope.roleInfo[indexToRemove]
      if (roleData.existsInDb) {
        var message = 'Are you sure, you want to remove role?'
        var items = function () {
          return {
            buttons: {
              yes: 'Confirm',
              no: 'Cancel'
            },
            message: message,
            title: '<i class="fa fa-trash-o" aria-hidden="true"></i> Delete ' + hierarchyData.name
          }
        }
        var modalInstance = $uibModal.open({
          templateUrl: 'app/components/confirmationDialog/confirmationDialog.html',
          controller: 'AllConfirmationDialogCtrl',
          resolve: {
            items: items
          }
        })

        modalInstance.result.then(function (result) {
          var data = {
            userId: roleData.userId,
            role: roleData.role.name,
            resourceId: hierarchyData._id,
            resourcesId: roleData.resourcesId,
            resourceType: roleData.resourceType
          }
          UserService.resource.removeRole(data, function (res) {
            toastr.success(constants.toastrMessages.success.removeRole)
            var roleInfo = []
            for (var index = 0; index < $scope.roleInfo.length; index++) {
              if (index !== indexToRemove) {
                roleInfo.push($scope.roleInfo[index])
              }
            }
            $scope.roleInfo = roleInfo
          }, function (err) {
            toastr.error(err.data.msg)
          })
        }, function () { })
      } else {
        var roleInfo = []
        for (var index = 0; index < $scope.roleInfo.length; index++) {
          if (index !== indexToRemove) {
            roleInfo.push($scope.roleInfo[index])
          }
        }
        $scope.roleInfo = roleInfo
      }
    }

    /* Validation user information form wizard to check whether role is selected or not */
    $scope.validateUserInfoForm = function () {
      return true
    }

    /* To save or update hierarchy details */
    $scope.save = function () {
      var companyAddress = $rootScope.user.customer.address
      var saveData = _.pick($scope.hierarchy, ['name', 'description', 'meta'])
      saveData['customerId'] = $rootScope.user.customerIds[0]
      saveData['hierarchyTypeId'] = $scope.currentLevel['_id']
      if ($scope.currentLevel.level === 1) {
        if ($scope.hierarchy.meta.address.sameAsCompanyAddress) {
          saveData.meta.address.country = companyAddress.country
          saveData.meta.address.state = companyAddress.state
          saveData.meta.address.city = companyAddress.city
          saveData.meta.address.streetAddress = companyAddress.streetAddress
          saveData.meta.address.pinCode = companyAddress.pinCode
          saveData.meta.address.email = companyAddress.email
          saveData.meta.address.phone = companyAddress.phone
        }
        if (saveData.meta.line_frequency === -1) {
          saveData.meta.line_frequency = parseInt($scope.hierarchy.customLineFrequency)
        }
        delete saveData.customLineFrequency
      }
      if ($scope.editForm) {
        if ($scope.currentLevel.level >= 2) {
          saveData = _.omit(saveData, ['meta'])
        }
        saveData['_id'] = hierarchyData._id
        // Following if block is used to update roleData from user information form wizard
        if ($scope.roleInfo && $scope.roleInfo.length > 0) {
          var roleData = _.filter($scope.roleInfo, function (item) {
            if (!item.existsInDb) {
              return item
            }
          })
          roleData = _.map(roleData, function (item) {
            var role = {
              role: item.role.name,
              userId: item.userId
            }
            return role
          })
          saveData['roleData'] = roleData
        }
        HierarchyService.resource.update({ data: saveData }, function (res) {
          var message = constants.toastrMessages.success.updateHierarchy
          var properties = {
            Hierarchy: $scope.currentLevel.name
          }
          _.map(properties, function (value, prop) {
            var regex = new RegExp('{' + prop + '}', 'g')
            message = message.replace(regex, value)
          })
          toastr.success(message)
          // Following code is used to update navigation data of updated item.
          $stateParams.navigation = JSON.parse(decodeURIComponent($stateParams.navigation))
          var updateIndex = _.findIndex($stateParams.navigation, ['_id', res._id])
          if (updateIndex > 0) {
            $stateParams.navigation[updateIndex]['name'] = res.name
          }
          $stateParams.navigation = encodeURIComponent(JSON.stringify($stateParams.navigation))
          $state.go('viewHierarchy', { hierarchyId: hierarchyData['_id'], tab: $stateParams.tab, navigation: $stateParams.navigation, page: $stateParams.page, parentHierarchyId: $stateParams.parentHierarchyId, sort: $stateParams.sort, order: $stateParams.order })
        }, function (err) {
          toastr.error(err.data.msg)
        })
      } else {
        if ($scope.currentLevel.level >= 2) {
          saveData.parentId = hierarchyData._id
          saveData = _.omit(saveData, ['meta'])
        }
        // Following if block is used to update roleData from user information form wizard
        if ($scope.roleInfo && $scope.roleInfo.length > 0) {
          var roleInfo = _.map($scope.roleInfo, function (item) {
            var role = {
              role: item.role.name,
              userId: item.userId
            }
            return role
          })
          saveData['roleData'] = roleInfo
        }
        HierarchyService.resource.addHierarchy({ data: saveData }, function (res) {
          var message = constants.toastrMessages.success.addHierarchy
          var properties = {
            Hierarchy: $scope.currentLevel.name
          }
          _.map(properties, function (value, prop) {
            var regex = new RegExp('{' + prop + '}', 'g')
            message = message.replace(regex, value)
          })
          toastr.success(message)
          $state.go('hierarchy', { hierarchyId: $stateParams.hierarchyId, navigation: $stateParams.navigation, currentPage: $stateParams.page, sort: $stateParams.sort, order: $stateParams.order })
        }, function (err) {
          toastr.error(err.data.msg)
        })
      }
    }

    /* Control for delete confirmation dialog. Allow to delete selected hierarchical level. After delete redirect to hierarchical list page. */
    $scope.deleteHierarchy = function () {
      var items
      var message = ''
      var properties = {}
      // for lowest hierarchical level check machines available or not
      if (hierarchyData.hierarchyTypeId === $rootScope.user.customer.hierarchyType[$rootScope.user.customer.hierarchyType.length - 1]._id) {
        var machinesInHierarchy = false
        var queryParams = {
          hierarchyId: hierarchyData._id,
          customerId: $rootScope.user.customer._id
        }
        HierarchyService.resource.getMachineCountInHierarchy(queryParams, function (res) {
          // if both machines and users ara available
          if (res.machineCount && hierarchyData.roleData && hierarchyData.roleData.length) {
            message = constants.webAppTexts.popupMessages.deleteHierarchyWithMachinesAndUsers
            machinesInHierarchy = true
          } else if (res.machineCount) { // if only machines avaliable
            message = constants.webAppTexts.popupMessages.deleteLowestHierarchyWithMachines
            machinesInHierarchy = true
          } else if (hierarchyData.roleData && hierarchyData.roleData.length) { // only users are avaliable
            message = constants.webAppTexts.popupMessages.deleteHierarchyWithUsers
            machinesInHierarchy = true
          } else { // no machine and user avaliable
            message = constants.webAppTexts.popupMessages.deleteHierarchy + ' ' + hierarchyData.name + '?'
          }
          if (machinesInHierarchy) { // generate msg
            properties = {
              level: $scope.currentLevel.name,
              name: hierarchyData.name
            }
            message = UtilService.generateMsg(message, properties)
          }
          // check whether can delete hierarchy or not
          deleteHierarchyItem(items, machinesInHierarchy, message)
        }, function (err) {
          toastr.error(err.data.msg)
        })
      } else {
        var subLevelData
        // get sublevel count
        queryParams = {
          customerId: $scope.user.customerIds[0],
          page: 1,
          sort: { 'createdOn': -1 },
          filters: {},
          limit: $scope.limit,
          parentId: hierarchyData._id
        }
        HierarchyService.resource.getAll(queryParams, function (res) {
          // if both sub-levels and users are available
          if (res.totalCount && hierarchyData.roleData && hierarchyData.roleData.length) {
            message = constants.webAppTexts.popupMessages.deleteHierarchyWithSubLevelsAndUsers
            subLevelData = true
          } else if (res.totalCount) { // only sub-levels are available
            message = constants.webAppTexts.popupMessages.deleteHierarchyWithSubLevels
            subLevelData = true
          } else if (hierarchyData.roleData && hierarchyData.roleData.length) { // only users are available
            message = constants.webAppTexts.popupMessages.deleteHierarchyWithUsers
            subLevelData = true
          } else { // no sub-levels and user available
            message = constants.webAppTexts.popupMessages.deleteHierarchy + ' ' + hierarchyData.name + '?'
          }
          if (subLevelData) { // generate msg
            properties = {
              level: $scope.currentLevel.name,
              name: hierarchyData.name,
              unit: _.find($scope.user.customer.hierarchyType, { level: $scope.currentLevel.level + 1 }).name.toLowerCase()
            }
            message = UtilService.generateMsg(message, properties)
          }
          // check whether can delete hierarchy
          deleteHierarchyItem(items, subLevelData, message)
        }, function (err) {
          toastr.error(err.data.msg)
        })
      }
    }

    // delete hierarchical item if no sub-levels and roles are available
    function deleteHierarchyItem (items, subLevelData, message) {
      items = function () {
        return {
          buttons: {
            yes: subLevelData ? 'Ok' : 'Confirm',
            no: 'Cancel'
          },
          message: message,
          title: '<i aria-hidden="true"></i> Delete ' + hierarchyData.name
        }
      }
      var modalInstance = $uibModal.open({
        templateUrl: 'app/components/confirmationDialog/confirmationDialog.html',
        controller: 'AllConfirmationDialogCtrl',
        resolve: {
          items: items
        }
      })
      modalInstance.result.then(function (result) {
        // delete if no sub-level data or users are available
        if (!subLevelData) {
          HierarchyService.resource.deleteById({ id: hierarchyData._id, customerId: $rootScope.user.customer._id }, function (res) {
            if (_.findIndex(res, { isActive: false })) {
              var message = constants.toastrMessages.success.deleteHierarchy
              var properties = {
                Hierarchy: $scope.currentLevel.name
              }
              _.map(properties, function (value, prop) {
                var regex = new RegExp('{' + prop + '}', 'g')
                message = message.replace(regex, value)
              })
              toastr.success(message)
              // Following code is used to remove navigation data of deleted item.
              $stateParams.navigation = JSON.parse(decodeURIComponent($stateParams.navigation))
              var deleteIndex = _.findIndex($stateParams.navigation, ['_id', hierarchyData._id])
              if (deleteIndex > -1) {
                var navigation = []
                for (var index = 0; index < deleteIndex; index++) {
                  navigation.push($stateParams.navigation[index])
                }
                $stateParams.navigation = navigation
              }
              $stateParams.navigation = encodeURIComponent(JSON.stringify($stateParams.navigation))
              // This case is for delete operation at level 1.
              if ($stateParams.parentHierarchyId === hierarchyData._id) {
                $stateParams.parentHierarchyId = undefined
              }
              $state.go('hierarchy', { hierarchyId: $stateParams.parentHierarchyId, navigation: $stateParams.navigation, currentPage: $stateParams.page, sort: $stateParams.sort, order: $stateParams.order })
            } else {
              toastr.error('Failed to delete')
            }
          }, function (err) {
            toastr.error(err.data.msg)
          })
        }
      }, function () { })
    }
  }
})();
(function () {
  'use strict'
  var angular = window.angular
  angular.module('Vibzer.components.machines.machineDetails')
    .controller('MachineDetailsCtrl', MachineDetailsCtrl)
  var _ = window._
  /*
    Handles Add/Update/Delete machine
  */
  function MachineDetailsCtrl ($scope, $rootScope, $stateParams, $uibModal, $state, $location, $cookies, toastr, MachineTypeService, HierarchyService, MachineService, FormlyFormService, UserService, RouteService, CompositeService, PermissionService, machineData, constants, SystemSettingService, UtilService, DeviceService) {
    $scope.webAppTexts = constants.webAppTexts
    $scope.user = $cookies.getObject('vcUser')
    $scope.isDistributorUser = $scope.user && $scope.user.tempCache && $scope.user.tempCache.distributorIds && $scope.user.tempCache.distributorIds.length
    $scope.machineData = machineData
    $scope.model = {}
    $scope.breadCrumbList = [$scope.webAppTexts.breadcrumbs.addMachine]
    SystemSettingService.resource.getSetting({ select: { 'learningModeReadings': 1, 'learningDays': 1 } }, function (res) {
      if (!$scope.model.learningCount) {
        $scope.model.learningCount = res.learningModeReadings || 300
        $scope.model.minLearningDays = res.learningDays.min || 30
        $scope.model.maxLearningDays = res.learningDays.max || 90
      }
      if ($scope.schedule) {
        $scope.learningModeDays = MachineService.learningModeDaysCalculation($scope.schedule.operating, $scope.model.learningCount, $scope.model.minLearningDays, $scope.model.maxLearningDays)
      }
      if($scope.isDistributorUser) {
        $scope.validateLearningModeCount()
      }
    })
    var operatingSchedule
    $scope.model.selectedMonitoringPoint = '2'
    $scope.machineOwner = {
      normal: true
    }
    $scope.machineMetaData = {}
    $scope.addForm = true
    $scope.viewForm = false
    $scope.editForm = false
    $scope.isMachineType = false
    $scope.showMachineData = false
    $scope.isAnalyzedMachine = false
    $scope.isDeviceAttached = false
    $scope.isAlertRequired = false
    $scope.isNotificationTypeRequired = false
    $scope.isCompressor = false
    $scope.model.monitoredOnline = false
    $scope.tabNum = $stateParams.tab ? parseInt($stateParams.tab) : 0
    $scope.distributionList = []
    $scope.canEdit = true
    $scope.canDelete = true
    // initial analysis configuration
    var analysisConfiguration = {
      permanent: {
        type: '2',
        limits: {
          overallVibration: angular.copy(constants.userDefinedLimits.overallVibration),
          crestFactor: angular.copy(constants.userDefinedLimits.overallVibration)
        },
        learningModeInfo: {
          intervalType: 1,
          value: 1
        }
      }
    }
    $scope.analysisConfiguration = angular.copy(analysisConfiguration)
    // only manager can change owner
    $scope.canChangeOwner = $scope.user.permission.canViewMachines

    // Machine's owner info
    $scope.ownerUsers = [{
      _id: $scope.user._id,
      firstName: $scope.user.firstName,
      lastName: $scope.user.lastName,
      email: $scope.user.email
    }]
    $scope.selected = {
      distributionUsers: []
    }
    $scope.selected.machineOwners = $scope.ownerUsers[0]
    $scope.initialDistributionList = MachineService.initialDistributionList
    $scope.distributionList = []

    //learning mode configuration
    $scope.learningModeInOptions = angular.copy(constants.learningModeInOptions)
    $scope.readingsByInterval = angular.copy(constants.readingsByInterval)
    var availableReadingsInHour = angular.copy(constants.availableReadingsInHour)
    $scope.learningModeInType = $scope.learningModeInOptions[0].name
    $scope.frequencyPlaceHolderMsg = UtilService.generateMsg($scope.webAppTexts.placeholder.enter, { frequencyType: $scope.learningModeInType.toLowerCase()})
    $scope.readingsNotPossible = false
    $scope.learningMinutesInvalid = false
    // generate label and placeholder for select lowest hierarchical level
    $scope.levelRequiredMsg = UtilService.generateMsg($scope.webAppTexts.errorMessages.levelRequired, { level: $scope.user.customer.hierarchyType[$scope.user.customer.hierarchyType.length - 1].name })
    $scope.levelPlaceholder = UtilService.generateMsg($scope.webAppTexts.placeholder.selectLevel, { level: $scope.user.customer.hierarchyType[$scope.user.customer.hierarchyType.length - 1].name.toLowerCase() })
    /* Initial machine control ends */

    /* Get available machine types */
    MachineTypeService.resource.getAllMachineTypes({}, function (res) {
      $scope.machineTypes = _.sortBy(res.result, 'order')
    })

    /* Get customer's lowest hierarchy level list to add machine in it */
    HierarchyService.resource.getLowestHierarchies({ customerId: $scope.user.customerIds[0], select: 'name _id' }, function (res) {
      $scope.lowestLevelList = res.hierarchies
      $scope.levelName = res.hierarchyName
      if ($scope.lowestLevelList.length === 1) {
        $scope.model.selectedLevel = $scope.lowestLevelList[0]
        $scope.getSelectedLevel()
      }
    })

    /* invokes after selecting hierarchy level */
    $scope.getSelectedLevel = function () {
      /* Get managers of current hierarchy level */
      var data = {
        permissions: 'canViewMachines',
        permissionType: 'name',
        resource: $scope.model.selectedLevel._id,
        options: { populate: [{ path: 'userId', select: '_id firstName lastName email' }] }
      }

      UserService.resource.getLevelUsersBasedOnPermissions(data, function (res) {
        $scope.levelManagers = res.users
        getAllUsers()
        removeLevelManagersFromList()
        if (!$scope.addForm && $scope.machineData) {
          updateDistributionList()
        }
      })
      // get users to assign owner
      if ($scope.user.permission.canViewMachines) {
        getUsersForOwner()
      }
    }

    /* Get updated distribution list by removing level managers */
    function updateDistributionList () {
      if ($scope.machineData.distributionList && $scope.machineData.distributionList.length) {
        // $scope.distributionList = _.map($scope.machineData.distributionList, function (itm) {
        //   var user = _.pick(itm, ['portable', 'permanent'])
        //   user._id = itm.userId._id
        //   user.firstName = itm.userId.firstName
        //   user.lastName = itm.userId.lastName
        //   return user
        // })
        $scope.distributionList = $scope.machineData.distributionList.reduce(function (filtered, item) {
          if (item.userId._id !== $scope.machineData.owner[0]._id) {
            var user = _.pick(item, ['portable', 'permanent'])
            user._id = item.userId._id
            user.firstName = item.userId.firstName
            user.lastName = item.userId.lastName
            filtered.push(user)
          }
          return filtered
        }, [])
        if ($scope.levelManagers.length && $scope.distributionList.length) {
          _.forEach($scope.levelManagers, function (itm) {
            _.remove($scope.distributionList, { _id: itm.userId._id })
          })
        }
      }
    }
    // TODO remove
    /*
        This function is used to set everyMinute options for immediate lower level
    */
    // $scope.everyMinuteChange = function (condition, minute, initial) {
    //   if ((condition === 'warning' && $scope.schedule.normal.scheduleTime === 3) || (condition === 'alert' && $scope.schedule.warning.scheduleTime === 3)) {
    //     if (minute && minute !== '0' && parseInt(minute) !== $scope.everyMinutes[0]) {
    //       $scope.schedule[condition].everyMinutes = _.filter($scope.everyMinutes, function (itm) {
    //         return itm < parseInt(minute)
    //       })
    //     } else {
    //       $scope.schedule[condition].everyMinutes = minute && minute !== '0' ? [minute] : angular.copy($scope.everyMinutes)
    //     }
    //   } else {
    //     $scope.schedule[condition].everyMinutes = angular.copy($scope.everyMinutes)
    //   }
    //   if (initial) {
    //     if ($scope.schedule[condition].hours.everyMinutesOfOperatingHours === 0 && !$scope.schedule[condition].hours.everyMinutesOfOperatingHours) {
    //       $scope.schedule[condition].hours.everyMinutesOfOperatingHours = $scope.schedule[condition].everyMinutes[0].toString()
    //     } else {
    //       $scope.schedule[condition].hours.everyMinutesOfOperatingHours = $scope.schedule[condition].hours.everyMinutesOfOperatingHours.toString()
    //     }
    //   } else {
    //     if (condition === 'warning') {
    //       $scope.schedule.warning.hours.everyMinutesOfOperatingHours = parseInt($scope.schedule.normal.hours.everyMinutesOfOperatingHours) > parseInt($scope.initialSchedule.warning.hours.everyMinutesOfOperatingHours) ? $scope.initialSchedule.warning.hours.everyMinutesOfOperatingHours.toString() : $scope.schedule.warning.everyMinutes[0].toString()
    //       $scope.everyMinuteChange('alert', $scope.schedule.warning.hours.everyMinutesOfOperatingHours)
    //     } else {
    //       $scope.schedule.alert.hours.everyMinutesOfOperatingHours = parseInt($scope.schedule.warning.hours.everyMinutesOfOperatingHours) > parseInt($scope.initialSchedule.alert.hours.everyMinutesOfOperatingHours) ? $scope.initialSchedule.alert.hours.everyMinutesOfOperatingHours.toString() : $scope.schedule.alert.everyMinutes[0].toString()
    //     }
    //   }
    // }

    // validate whether min readings can be taken within a given time period
    $scope.validateLearningModeCount = function () {
      var totalHrs
      var totalMins
      $scope.analysisConfiguration.permanent.learningModeInfo ? totalMins = $scope.analysisConfiguration.permanent.learningModeInfo.value : void 0
      var totalOperatingHours = $scope.schedule.operating.hours.twentyFourHours ? 24 : $scope.schedule.operating.hours.specificHoursOfTheDay.length
      $scope.learningMinutesInvalid = $scope.analysisConfiguration.permanent.learningModeInfo && $scope.analysisConfiguration.permanent.learningModeInfo.intervalType === 3 && $scope.analysisConfiguration.permanent.learningModeInfo.value < 5
      $scope.minLearningmodeTime = UtilService.generateMsg($scope.webAppTexts.errorMessages.minLearningmodeTime, { time: $scope.learningModeInType})
      if(!$scope.learningMinutesInvalid) {
        // convert everything into minutes
        if($scope.analysisConfiguration.permanent.learningModeInfo && $scope.analysisConfiguration.permanent.learningModeInfo.intervalType != 3) {
          totalHrs = $scope.analysisConfiguration.permanent.learningModeInfo.intervalType === 1 ? $scope.analysisConfiguration.permanent.learningModeInfo.value * totalOperatingHours : $scope.analysisConfiguration.permanent.learningModeInfo.value
          totalMins = totalHrs * 60
        }
        // calculate how many readings can be taken in an hour
        var noOfReadingsInHour = ($scope.model.learningCount * 60)/totalMins
        // calculate closet of no of readings in hour
        var noOfReadingsInHourCloset = availableReadingsInHour.reduce(function(prev, curr) {
          return (Math.abs(curr - noOfReadingsInHour) < Math.abs(prev - noOfReadingsInHour) ? curr : prev);
        });
        // based on that calculate reading interval
        $scope.readingInterval = _.find($scope.readingsByInterval, {readings: noOfReadingsInHourCloset}).interval
        // calculate total possible readings within specified time
        $scope.totalPossibleReadings = Math.floor(totalMins/$scope.readingInterval)
        // check whether min. readings can be possible within a time
        $scope.readingsNotPossible = $scope.totalPossibleReadings < $scope.model.learningCount ? true : false
        // if not then check for min. interval
        if($scope.readingsNotPossible) {
          var index = _.findIndex($scope.readingsByInterval, {interval: $scope.readingInterval})
          if(index > 0) {
            $scope.totalPossibleReadings = Math.floor(totalMins/$scope.readingsByInterval[index-1].interval)
            $scope.readingsNotPossible = $scope.totalPossibleReadings < $scope.model.learningCount ? true : false
          }
        }
        // show msg indicating how many readings possible within a specified time
        $scope.possibleReadingCountMsg = UtilService.generateMsg($scope.webAppTexts.errorMessages.possibleReadingCount, { totalReadings: $scope.totalPossibleReadings, minutes: $scope.readingInterval})
      }
    }

    /* Initial machine details for view and edit machine */
    $scope.initMachineData = function () {
      if ($scope.machineData && !$scope.machineData.addMachine) {
        if ($scope.machineData.viewDetails) { // view machine details
          $scope.addForm = false
          $scope.viewForm = true
          $scope.machineMetaData.disableUnitField = true
          $scope.breadCrumbList = [$scope.machineData.name]
        }
        if ($scope.machineData.editMachine) { // edit machine details
          $scope.machineMetaData.disableUnitField = false
          $scope.addForm = false
          $scope.editForm = true
          var breadcrumbItem = 'Edit Machine : ' + $scope.machineData.name
          $scope.breadCrumbList = [breadcrumbItem]
        }
        $scope.model.name = $scope.machineData.name
        $scope.model.description = $scope.machineData.description
        $scope.model.selectedLevel = $scope.machineData.parentId
        $scope.model.machineType = $scope.machineData.machineTypeId
        $scope.selected.machineOwners = $scope.machineData.owner[0]
        if ($scope.machineData.viewDetails || $scope.machineData.editMachine) {
          var ownerInDistributorList = _.find($scope.machineData.distributionList, function (item) {
            if (item.userId._id === $scope.machineData.owner[0]._id) {
              return item
            }
          })
          if (ownerInDistributorList) {
            $scope.machineOwner.normal = ownerInDistributorList.portable.normal
          }
        }
        // Parse and evaluate formly fields
        $scope.machineMetaDataFields = FormlyFormService.parseAndEvaluateFormlyFormObject($scope.model.machineType.fields)
        $scope.model.monitoredOnline = $scope.machineData.monitoredOnline
        $scope.analysisConfiguration = $scope.model.monitoredOnline ? angular.copy($scope.machineData.analysisConfiguration) : $scope.analysisConfiguration
        if($scope.isDistributorUser && $scope.analysisConfiguration.permanent && !$scope.analysisConfiguration.permanent.learningModeInfo) {
          $scope.analysisConfiguration.permanent.learningModeInfo = {
            intervalType: 1,
            value: 1
          }
        }
        $scope.isUserDefinedLimit = $scope.model.monitoredOnline ? $scope.machineData.analysisConfiguration.permanent.type === 1 : false
        if (!$scope.isUserDefinedLimit && $scope.model.monitoredOnline && $scope.analysisConfiguration && $scope.analysisConfiguration.permanent.learningModeReadings && ($scope.analysisConfiguration.permanent.learningDays || $scope.analysisConfiguration.permanent.learningModeInfo && $scope.analysisConfiguration.permanent.learningModeInfo.intervalType)) {
          $scope.model.learningCount = $scope.analysisConfiguration.permanent.learningModeReadings
          $scope.model.minLearningDays = $scope.analysisConfiguration.permanent.learningDays.min
          $scope.model.maxLearningDays = $scope.analysisConfiguration.permanent.learningDays.max
          if($scope.isDistributorUser && $scope.analysisConfiguration.permanent.learningModeInfo &&  $scope.analysisConfiguration.permanent.learningModeInfo.intervalType) {
            $scope.learningModeInType = _.find($scope.learningModeInOptions, {id: $scope.analysisConfiguration.permanent.learningModeInfo.intervalType}).name
          }
        }
        $scope.getSelectedLevel() // get level managers and updated distribution list
        if ($scope.model.machineType.name === 'machine') {
          $scope.isMachineType = true
          $scope.showMachineData = false
          $scope.isDeviceAttached = $scope.machineData.meta && $scope.machineData.meta.pointInfo && $scope.machineData.meta.pointInfo.deviceMacId
          $scope.deviceState = $scope.isDeviceAttached ? $scope.machineData.meta.pointInfo.meta.state ? _.find(constants.deviceStates, { id: $scope.machineData.meta.pointInfo.meta.state }).displayName : null : null
        } else { // For rotating machines
          $scope.isMachineType = false
          $scope.showMachineData = true
          // get selected reading points
          var points = _.sortBy(angular.copy($scope.model.machineType.points), 'internalName').reverse()
          $scope.assessmentPoints = angular.copy(points)
          $scope.monitoringPoints = angular.copy(points)
          // get machine meta data
          $scope.machineMetaData = _.assign($scope.machineMetaData, $scope.machineData.meta)
          _.forEach($scope.machineData.meta.portablePoints, function (pt) {
            var filteredPoint = _.find($scope.assessmentPoints, { internalName: pt.internalName })
            filteredPoint.selected = true
            filteredPoint = _.assign(filteredPoint, pt)
          })
          $scope.model.selectedMonitoringPoint = $scope.model.monitoredOnline ? $scope.machineData.meta.points[0].internalName : null
        }

        // get route data
        if ($stateParams.routeId) {
          RouteService.resource.getRoute({ _id: $stateParams.routeId }, function (res) {
            $scope.routeData = res
            if ($scope.machineData.viewDetails) {
              $scope.breadCrumbList = [$scope.webAppTexts.breadcrumbs.routeList, $scope.routeData.name, $scope.machineData.name]
            } else {
              var breadcrumbItem = $scope.webAppTexts.breadcrumbs.editMachine + ' : ' + $scope.machineData.name
              $scope.breadCrumbList = [$scope.webAppTexts.breadcrumbs.routeList, $scope.routeData.name, breadcrumbItem]
            }
          })
        }

        // get composite machine data
        if ($stateParams.compositeId) {
          CompositeService.resource.getById({ _id: $stateParams.compositeId }, function (res) {
            $scope.compositeData = res
            if ($scope.machineData.viewDetails) {
              $scope.breadCrumbList = [$scope.webAppTexts.breadcrumbs.compositeMachineList, $scope.compositeData.name, $scope.machineData.name]
            } else {
              var breadcrumbItem = $scope.webAppTexts.breadcrumbs.editMachine + ' : ' + $scope.machineData.name
              $scope.breadCrumbList = [$scope.webAppTexts.breadcrumbs.compositeMachineList, $scope.compositeData.name, breadcrumbItem]
            }
          })
        }

        /* Check whether machine reading has been taken or not */
        if (($scope.machineData.portable && $scope.machineData.portable.condition) || ($scope.machineData.permanent && $scope.machineData.permanent.condition)) {
          $scope.isAnalyzedMachine = true
          $scope.machineMetaData.disableUnitField = true
        }
        // check device is attached or not
        if ($scope.machineData.meta.points && $scope.machineData.meta.points.length && $scope.machineData.meta.points[0].deviceMacId) {
          $scope.isDeviceAttached = true
          _.filter($scope.monitoringPoints, function (point) {
            if ($scope.model.selectedMonitoringPoint === point.internalName) {
              point.deviceMacId = $scope.machineData.meta.points[0].deviceMacId
              point.deviceState = $scope.machineData.meta.points[0].meta.state ? _.find(constants.deviceStates, { id: $scope.machineData.meta.points[0].meta.state }).displayName : null
            }
            return point
          })
        }
      }

      // get all timezones. Populate browser's timezone by default
      DeviceService.resource.getAllTimezones(function (res) {
        $scope.timezoneList = res.timezones
        var currentZone = $scope.machineData && $scope.machineData.timezone ? $scope.machineData.timezone : moment.tz.guess()
        _.filter($scope.timezoneList, function (zone) {
          if (_.includes(zone.utc, currentZone)) {
            $scope.model.timezone = zone
          }
        })
      })
    }
    $scope.initMachineData()

    // get users to assign owner
    function getUsersForOwner () {
      var data = {
        permissions: ['canViewOwnedMachines'],
        permissionType: 'name',
        resource: $scope.model.selectedLevel._id,
        options: { populate: [{ path: 'userId', select: '_id firstName lastName email' }], type: 'any' }
      }

      UserService.resource.getLevelUsersBasedOnPermissions(data, function (res) {
        $scope.ownerUsers = _.map(_.uniqBy(res.users, 'userId._id'), function (user) { return user.userId })
      })
    }

    // check edit/delete permissions for route machines (Manager of lowest hierarchical item and machine owner can edit/delete machine)
    if (($stateParams.routeId || $stateParams.compositeId) && $scope.viewForm) {
      var data = {
        userId: $scope.user._id,
        permissions: ['canViewMachines', 'editMachine', 'deleteMachine'],
        resourceType: constants.resourceTypes[1].internalName,
        resourceIds: $scope.machineData.parentId._id,
        hierarchyTypeIds: $scope.user.customer.hierarchyType[$scope.user.customer.hierarchyType.length - 1]._id
      }
      PermissionService.resource.hasPermission(data, function (res) {
        $scope.canEdit = res.hasPermission || _.some($scope.machineData.owner, _.pick($scope.user, ['_id', 'firstName', 'lastName'])) // can edit machine
        $scope.canDelete = res.hasPermission || _.some($scope.machineData.owner, _.pick($scope.user, ['_id', 'firstName', 'lastName'])) // can delete machine
      })
    }
    /*
      Initial schedule configuration
    */
    $scope.everyMinutes = [5, 10, 15, 20, 30]
    $scope.minutes = _.times(60, function (index) {
      return index
    })
    $scope.hours = _.times(24, function (index) {
      return index + 1
    })
    $scope.days = ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday', 'Sunday']
    var allSchedules = ['operating', 'normal', 'warning', 'alert']
    $scope.operatingDaysTypes = [
      { id: 1, name: 'All days' },
      { id: 2, name: 'Specific days in a week' }
    ]
    $scope.operatingHoursTypes = [
      { id: 1, name: '24 hours' },
      { id: 2, name: 'Specific hours of the day' }
    ]
    $scope.monitoringDaysTypes = [
      { id: 1, name: 'All days while in operation' },
      { id: 2, name: 'Specific days in a week' }
    ]
    var monitoringHoursTypes = [
      { id: 1, name: 'Once a day' },
      { id: 2, name: 'Specific hours of the day' },
      { id: 3, name: 'Every' }
    ]

    // Initial schedule information
    $scope.initialScheduleData = function () {
      $scope.initialSchedule = angular.copy(MachineService.initialSchedule)
      if ($scope.addForm || ($scope.editForm && !$scope.machineData.monitoredOnline && $scope.model.monitoredOnline)) {
        $scope.schedule = angular.copy(MachineService.initialSchedule)
      } else if ($scope.machineData.monitoredOnline && ($scope.viewForm || $scope.editForm)) {
        $scope.schedule = _.assign($scope.schedule, angular.copy($scope.machineData.schedule.permanent.userInputs))
      }

      if (($scope.addForm || ($scope.editForm && !$scope.machineData.monitoredOnline && $scope.model.monitoredOnline)) || ($scope.machineData.monitoredOnline && ($scope.viewForm || $scope.editForm))) {
        $scope.schedule.warning.scheduleTypes = [
          { id: 1, name: 'Same as Normal condition' },
          { id: 2, name: 'Different schedule' }
        ]
        $scope.schedule.alert.scheduleTypes = [
          { id: 1, name: 'Same as Warning condition' },
          { id: 2, name: 'Different schedule' }
        ]
        _.forEach(allSchedules, function (type) {
          if (type !== 'operating') {
            $scope.schedule[type].daysType = $scope.schedule[type].days.allOperatingDays ? $scope.monitoringDaysTypes[0].id : $scope.monitoringDaysTypes[1].id
            $scope.schedule[type].monitoringHoursTypes = angular.copy(monitoringHoursTypes)
            $scope.schedule[type].everyMinutes = angular.copy($scope.everyMinutes)
            if (type === 'warning' || type === 'alert') {
              _.remove($scope.schedule[type].monitoringHoursTypes, { id: 1 })
              $scope.schedule[type].scheduleTime = $scope.schedule[type].monitoringHoursTypes[0]
              if (type === 'warning') {
                $scope.schedule.warning.scheduleType = $scope.schedule.warning.sameAsNormal ? $scope.schedule.warning.scheduleTypes[0].id : $scope.schedule.warning.scheduleTypes[1].id
              } else {
                $scope.schedule.alert.scheduleType = $scope.schedule.alert.sameAsWarning ? $scope.schedule.alert.scheduleTypes[0].id : $scope.schedule.alert.scheduleTypes[1].id
              }
              $scope.schedule[type].scheduleTime = !$scope.addForm && $scope.schedule[type].hours.everyMinutesOfOperatingHours ? $scope.schedule[type].monitoringHoursTypes[1].id : $scope.schedule[type].monitoringHoursTypes[0].id
            } else {
              // set initial monitoring time for normal schedule
              if ($scope.schedule.normal.hours.onceDayAt && $scope.schedule.normal.hours.onceDayAt.hour) {
                $scope.schedule.normal.scheduleTime = $scope.schedule.normal.monitoringHoursTypes[0].id
                $scope.schedule.normal.hours.onceDayAt.hour = $scope.schedule.normal.hours.onceDayAt.hour.toString()
                $scope.schedule.normal.hours.onceDayAt.minutes = $scope.schedule.normal.hours.onceDayAt.minutes.toString()
              } else if ($scope.schedule.normal.hours.specificHoursOfTheDay && $scope.schedule.normal.hours.specificHoursOfTheDay.length) {
                $scope.schedule.normal.scheduleTime = $scope.schedule.normal.monitoringHoursTypes[1].id
                $scope.schedule.normal.hours.onceDayAt = angular.copy($scope.initialSchedule.normal.hours.onceDayAt)
              } else {
                $scope.schedule.normal.scheduleTime = $scope.schedule.normal.monitoringHoursTypes[2].id
                $scope.schedule.normal.hours.onceDayAt = angular.copy($scope.initialSchedule.normal.hours.onceDayAt)
              }
              $scope.schedule.normal.selectAllHours = $scope.schedule.normal.scheduleTime === 2 && $scope.schedule.normal.hours.specificHoursOfTheDay.length === $scope.hours.length
            }

            $scope.schedule[type].hours.specificHoursOfTheDay = $scope.schedule[type].scheduleTime === 2 ? angular.copy($scope.schedule[type].hours.specificHoursOfTheDay) : angular.copy($scope.initialSchedule[type].hours.specificHoursOfTheDay)
            $scope.schedule[type].hours.everyMinutesOfOperatingHours = $scope.schedule[type].scheduleTime === 3 ? $scope.schedule[type].hours.everyMinutesOfOperatingHours.toString() : $scope.initialSchedule[type].hours.everyMinutesOfOperatingHours.toString()
          } else {
            $scope.schedule[type].daysType = $scope.schedule[type].days.allDays ? $scope.operatingDaysTypes[0].id : $scope.operatingDaysTypes[1].id
            $scope.schedule[type].scheduleTime = $scope.schedule[type].hours.twentyFourHours ? $scope.operatingHoursTypes[0].id : $scope.operatingHoursTypes[1].id
            $scope.schedule.operating.days.allDays = $scope.schedule.operating.daysType === 1
            $scope.schedule.operating.hours.twentyFourHours = $scope.schedule.operating.scheduleTime === 1
          }
        })
        $scope.initialSchedule = angular.copy($scope.schedule)
        $scope.learningModeDays = MachineService.learningModeDaysCalculation($scope.schedule.operating, $scope.model.learningCount, $scope.model.minLearningDays, $scope.model.maxLearningDays)

        /* TODO remove */

        // _.forEach(allSchedules, function (type) {
        //   if (type !== 'operating') {
        //     $scope.schedule[type].daysType = $scope.schedule[type].days.allOperatingDays ? $scope.monitoringDaysTypes[0].id : $scope.monitoringDaysTypes[1].id
        // if (type === 'warning' || type === 'alert') {
        //   $scope.schedule[type].monitoringHoursTypes = angular.copy(monitoringHoursTypes)
        //   _.remove($scope.schedule[type].monitoringHoursTypes, { id: 1 })
        //   if (type === 'warning') {
        //     $scope.schedule.warning.scheduleType = $scope.schedule.warning.sameAsNormal ? $scope.schedule.warning.scheduleTypes[0].id : $scope.schedule.warning.scheduleTypes[1].id
        //     $scope.schedule.warning.scheduleTime = ($scope.schedule.warning.hours.specificHoursOfTheDay && $scope.schedule.warning.hours.specificHoursOfTheDay.length) ? $scope.schedule[type].monitoringHoursTypes[0].id : $scope.schedule[type].monitoringHoursTypes[1].id
        //     $scope.schedule.warning.hours.specificHoursOfTheDay = $scope.schedule.normal.scheduleTime === 2 && !$scope.schedule.warning.hours.specificHoursOfTheDay.length ? angular.copy($scope.schedule.normal.hours.specificHoursOfTheDay) : angular.copy($scope.schedule.warning.hours.specificHoursOfTheDay)
        //     // $scope.everyMinuteChange('alert', $scope.schedule.warning.hours.everyMinutesOfOperatingHours, true)
        //   } else {
        //     $scope.schedule.alert.scheduleType = $scope.schedule[type].sameAsWarning ? $scope.schedule[type].scheduleTypes[0].id : $scope.schedule[type].scheduleTypes[1].id
        //     $scope.schedule.alert.scheduleTime = $scope.schedule[type].hours.specificHoursOfTheDay && $scope.schedule[type].hours.specificHoursOfTheDay.length ? $scope.schedule[type].monitoringHoursTypes[0].id : $scope.schedule[type].monitoringHoursTypes[1].id
        //   }
        // } else {
        //       $scope.schedule.normal.monitoringHoursTypes = angular.copy(monitoringHoursTypes)
        //       $scope.schedule.normal.everyMinutes = angular.copy($scope.everyMinutes)
        //       $scope.schedule.normal.hours.everyMinutesOfOperatingHours = $scope.schedule.normal.hours.everyMinutesOfOperatingHours ? $scope.schedule.normal.hours.everyMinutesOfOperatingHours : $scope.everyMinutes[4].toString()
        //       // set initial monitoring time for normal schedule
        //       if ($scope.schedule.normal.hours.onceDayAt.hour) {
        //         $scope.schedule.normal.scheduleTime = $scope.schedule.normal.monitoringHoursTypes[0].id
        //         $scope.schedule.normal.hours.onceDayAt.hour = $scope.schedule.normal.hours.onceDayAt.hour.toString()
        //         $scope.schedule.normal.hours.onceDayAt.minutes = $scope.schedule.normal.hours.onceDayAt.minutes.toString()
        //       } else if ($scope.schedule.normal.hours.specificHoursOfTheDay && $scope.schedule.normal.hours.specificHoursOfTheDay.length) {
        //         $scope.schedule.normal.scheduleTime = $scope.schedule.normal.monitoringHoursTypes[1].id
        //         $scope.schedule.normal.hours.onceDayAt = angular.copy(MachineService.initialSchedule.normal.hours.onceDayAt)
        //       } else {
        //         $scope.schedule.normal.scheduleTime = $scope.schedule.normal.monitoringHoursTypes[2].id
        //         $scope.schedule.normal.hours.everyMinutesOfOperatingHours = $scope.schedule.normal.hours.everyMinutesOfOperatingHours.toString()
        //         $scope.schedule.normal.hours.onceDayAt = angular.copy(MachineService.initialSchedule.normal.hours.onceDayAt)
        //       }
        //       $scope.schedule.normal.allOperatingHours = $scope.schedule.operating.scheduleTime === 1 ? angular.copy($scope.hours) : angular.copy($scope.schedule.operating.hours.specificHoursOfTheDay)
        //       $scope.schedule.normal.selectAllHours = $scope.schedule.normal.hours.specificHoursOfTheDay && $scope.schedule.normal.hours.specificHoursOfTheDay.length !== 0 && $scope.schedule.normal.hours.specificHoursOfTheDay.length === $scope.schedule.operating.hours.specificHoursOfTheDay.length
        //       // $scope.everyMinuteChange('warning', $scope.schedule.normal.hours.everyMinutesOfOperatingHours, true)
        //     }
        //   } else {
        //     $scope.schedule[type].daysType = $scope.schedule[type].days.allDays ? $scope.operatingDaysTypes[0].id : $scope.operatingDaysTypes[1].id
        //     $scope.schedule[type].scheduleTime = $scope.schedule[type].hours.twentyFourHours ? $scope.operatingHoursTypes[0].id : $scope.operatingHoursTypes[1].id
        //   }
        // })
      }
    }
    $scope.initialScheduleData()

    /* Set current tab number in URL after changing the tab. */
    $scope.tabChange = function (tabNum) {
      $location.search('tab', tabNum)
    }

    /* Check whether level is selected or not if not then display error block */
    $scope.$watch('model.selectedLevel', function (newValue, oldValue) {
      $scope.isLevelRequired = false
    }, true)

    /* Check whether machine type is selected or not if not then display error block */
    $scope.$watch('model.machineType', function (newValue, oldValue) {
      $scope.isTypeRequired = false
    }, true)

    /* Check whether limits for overall vibration and crest factor are entered or not if yes then hide error block */
    $scope.$watch('analysisConfiguration.permanent.limits', function (newValue, oldValue) {
      if ($scope.isUserDefinedLimit) {
        if ($scope.model.machineInfoForm.$submitted) {
          if ($scope.analysisConfiguration.permanent.limits.overallVibration.warning && $scope.analysisConfiguration.permanent.limits.overallVibration.alert && $scope.analysisConfiguration.permanent.limits.crestFactor.warning && $scope.analysisConfiguration.permanent.limits.crestFactor.alert) {
            if ($scope.analysisConfiguration.permanent.limits.overallVibration.warning < $scope.analysisConfiguration.permanent.limits.overallVibration.alert && $scope.analysisConfiguration.permanent.limits.crestFactor.warning < $scope.analysisConfiguration.permanent.limits.crestFactor.alert) {
              $scope.isAlertRequired = false
            } else {
              $scope.isAlertRequired = true
            }
            $scope.isLimitRequired = false
          } else {
            $scope.isAlertRequired = false
            $scope.isLimitRequired = true
          }
        } else if ($scope.analysisConfiguration.permanent.limits.overallVibration.warning && $scope.analysisConfiguration.permanent.limits.overallVibration.alert && $scope.analysisConfiguration.permanent.limits.crestFactor.warning && $scope.analysisConfiguration.permanent.limits.crestFactor.alert) {
          if ($scope.analysisConfiguration.permanent.limits.overallVibration.warning < $scope.analysisConfiguration.permanent.limits.overallVibration.alert && $scope.analysisConfiguration.permanent.limits.crestFactor.warning < $scope.analysisConfiguration.permanent.limits.crestFactor.alert) {
            $scope.isAlertRequired = false
          }
          $scope.isLimitRequired = false
        }
      }
    }, true)

    // Check whether notification type for all users is selected or not. If yser then hide error message.
    $scope.$watch('distributionList', function (newValue, oldValue) {
      _.forEach($scope.distributionList, function (itm) {
        if ($scope.model.monitoredOnline) {
          // validation for notification frequency
          if ($scope.model.usersInfoForm.$submitted && ((itm.permanent.warning || itm.permanent.alert) && !(itm.permanent.frequency.instant || itm.permanent.frequency.digest))) {
            $scope.notificationFrequencyRequiredFor = itm.firstName + ' ' + itm.lastName
            $scope.isNotificationFrequencyRequired = true
            $scope.isNotificationTypeRequired = false
            return false
          } else {
            $scope.isNotificationFrequencyRequired = false
          }
          // validation for monitored notifaction type
          if ($scope.model.usersInfoForm.$submitted && ((itm.permanent.frequency.digest || itm.permanent.frequency.instant) && !(itm.permanent.warning || itm.permanent.alert))) {
            $scope.permanentNotificationTypeRequiredFor = itm.firstName + ' ' + itm.lastName
            $scope.isPermanentNotificationTypeRequired = true
            $scope.isNotificationTypeRequired = false
            return false
          } else {
            $scope.isPermanentNotificationTypeRequired = false
          }
          // validation if notification type is not selected
          if ($scope.model.usersInfoForm.$submitted && (!((itm.permanent.frequency.instant || itm.permanent.frequency.digest) && (itm.permanent.warning || itm.permanent.alert)) && !(itm.portable.normal || itm.portable.warning || itm.portable.alert))) {
            $scope.isNotificationTypeRequired = true
            $scope.notificationTypeRequiredFor = itm.firstName + ' ' + itm.lastName
            return false
          } else {
            $scope.isNotificationTypeRequired = false
          }
        } else if ($scope.model.usersInfoForm.$submitted && (!$scope.model.monitoredOnline && !(itm.portable.normal || itm.portable.warning || itm.portable.alert))) { // validations for portable notifications
          $scope.isNotificationTypeRequired = true
          $scope.notificationTypeRequiredFor = itm.firstName + ' ' + itm.lastName
          return false
        } else {
          $scope.isNotificationTypeRequired = false
          $scope.isNotificationFrequencyRequired = false
          $scope.isPermanentNotificationTypeRequired = false
        }
      })
    }, true)

    /* Get selected limit type. If it is
       user defined limits then limits for overall vibration and crest factor are required.
    */
    $scope.getLimitType = function (type) {
      $scope.isLimitTypeRequired = false
      $scope.isLimitRequired = false
      if (type === 1) {
        $scope.isUserDefinedLimit = true
        if ($scope.addForm) {
          $scope.analysisConfiguration.permanent.limits.overallVibration = angular.copy(constants.userDefinedLimits.overallVibration)
          $scope.analysisConfiguration.permanent.limits.crestFactor = angular.copy(constants.userDefinedLimits.crestFactor)
        } else {
          if ($scope.machineData.analysisConfiguration.permanent.type === 1) {
            $scope.analysisConfiguration.permanent = $scope.machineData.analysisConfiguration.permanent
          } else {
            $scope.analysisConfiguration.permanent.limits = {
              overallVibration: angular.copy(constants.userDefinedLimits.overallVibration),
              crestFactor: angular.copy(constants.userDefinedLimits.crestFactor)
            }
          }
          $scope.analysisConfiguration.permanent.type = type
        }
      } else {
        $scope.isUserDefinedLimit = false
      }
    }
    /* on change of monitoring type */
    $scope.onChangeMonitoringType = function (type) {
      if (type) {
        $scope.analysisConfiguration.permanent.type = $scope.machineData && $scope.machineData.analysisConfiguration.permanent.type ? $scope.machineData.analysisConfiguration.permanent.type.toString() : '2'
        $scope.isUserDefinedLimit = $scope.analysisConfiguration.permanent.type === '1'
      }
      !$scope.isMachineType ? $scope.model.selectedMonitoringPoint = $scope.machineData && $scope.machineData.monitoredOnline && $scope.model.monitoredOnline ? $scope.machineData.meta.points[0].internalName : $scope.monitoringPoints[0].internalName : void 0
      if (type && $scope.editForm && !$scope.machineData.monitoredOnline) {
        $scope.initialScheduleData()
      }
    }
    /* Get selected machine type. If it is
       monitoring machine then machine's technical info is not required.
    */
    $scope.getMachineType = function (type) {
      $scope.model.machineInfoForm ? $scope.model.machineInfoForm.$setPristine() : void 0
      if (type.name === 'machine') {
        $scope.isMachineType = true
        $scope.showMachineData = false
      } else {
        $scope.isMachineType = false
        $scope.showMachineData = true
        $scope.isCompressor = type.name === 'compressor'
        // get machine points
        var points = _.sortBy(angular.copy($scope.model.machineType.points), 'internalName').reverse()
        $scope.assessmentPoints = angular.copy(points)
        $scope.monitoringPoints = angular.copy(points)
        // set default machine points and limits
        $scope.assessmentPoints[0].selected = true
        $scope.model.selectedMonitoringPoint = $scope.monitoringPoints[0].internalName
        $scope.model.monitoredOnline = false
        $scope.analysisConfiguration = angular.copy(analysisConfiguration)
        $scope.isUserDefinedLimit = false
        // get initial meta data for machine
        $scope.machineMetaData = angular.copy(type.metaData)
        // get formly fields for machine meta data
        $scope.machineMetaDataFields = FormlyFormService.parseAndEvaluateFormlyFormObject(type.fields)
      }
    }

    /* Get selected assessment points.
       Display error block if none of the point is selected
    */
    $scope.getAssessmentPoints = function (point) {
      $scope.isAssessmentPointRequired = !_.filter($scope.assessmentPoints, function(point) { return point.selected}).length
    }
    // get all users of customer
    var getAllUsers = function () {
      var queryParams = {
        customerId: $scope.user.customerIds[0],
        page: 1,
        sort: { firstName: 1 },
        filters: { $or: [{ status: 'active' }] },
        limit: 9999,
        forDistributionList: true
      }
      UserService.resource.getAllUsersForDistributionList(queryParams, function (res) {
        $scope.allUsers = res.users
        removeLevelManagersFromList()
        _.remove($scope.allUsers, { _id: $scope.selected.machineOwners._id }) // remove logged in user from list
        if ($scope.distributionList && $scope.distributionList.length) {
          _.forEach($scope.distributionList, function (itm) {
            _.remove($scope.allUsers, { _id: itm._id })
          })
        }
      })
    }
    getAllUsers()
    /* Add user in distribution List */
    $scope.addUserInList = function (users) {
      _.forEach(users, function (user) {
        user.portable = {
          normal: false,
          warning: false,
          alert: false
        }
        user.permanent = {
          warning: false,
          alert: false,
          frequency: {
            instant: false,
            digest: false
          }
        }
        $scope.distributionList.push(user)
      })
      $scope.selected.distributionUsers = []
      getAllUsers()
    }

    function removeLevelManagersFromList () {
      if ($scope.levelManagers && $scope.levelManagers.length) { // remove level managers from user list
        _.forEach($scope.levelManagers, function (itm) {
          _.remove($scope.allUsers, { _id: itm.userId._id })
        })
      }
    }
    // remove user from distribution list
    $scope.removeUserFromList = function (user) {
      _.pull($scope.distributionList, user)
      $scope.allUsers.push(user)
      if (!$scope.distributionList.length) {
        $scope.isNotificationTypeRequired = false
        $scope.isPermanentNotificationTypeRequired = false
        $scope.isNotificationFrequencyRequired = false
      }
    }

    /*
       Edit machine button click handler changes state from
       view machine details to edit machine details.
    */
    $scope.editMachine = function () {
      if ($stateParams.routeId) {
        $state.go('editMachineFromRoute', { routeId: $stateParams.routeId, machineId: $stateParams.machineId, machineData: $stateParams.machineData, routeFilters: $stateParams.routeFilters, tab: $stateParams.tab })
      } else if ($stateParams.compositeId) {
        $state.go('editMachineFromComposite', { compositeId: $stateParams.compositeId, machineId: $stateParams.machineId, tab: $stateParams.tab, machineData: $stateParams.machineData, compositeData: $stateParams.compositeData })
      } else {
        $state.go('editMachine', { machineId: $scope.machineData._id, machineData: $stateParams.machineData, tab: $stateParams.tab })
      }
    }

    /*
      Control for delete confirmation dialog.
       Allow to delete machine only when device is not attached to that machine.
       After delete redirect to machine list page.
    */
    $scope.deleteMachine = function () {
      var dialogMessage
      var items
      if ($scope.isDeviceAttached) {
        dialogMessage = UtilService.generateMsg($scope.webAppTexts.popupMessages.deleteMachineWithDevice, { machine: $scope.model.name })
        items = function () {
          return {
            message: dialogMessage,
            type: 'reject'
          }
        }
      } else {
        dialogMessage = UtilService.generateMsg($scope.webAppTexts.popupMessages.deleteMachine, { machine: $scope.model.name })
        items = function () {
          return {
            buttons: {
              yes: 'Confirm',
              no: 'Cancel'
            },
            message: dialogMessage,
            title: '<i aria-hidden="true"></i> Delete Machine'
          }
        }
      }
      var modalInstance = $uibModal.open({
        templateUrl: 'app/components/confirmationDialog/confirmationDialog.html',
        controller: 'AllConfirmationDialogCtrl',
        resolve: {
          items: items
        }
      })

      modalInstance.result.then(function (result) {
        MachineService.resource.deleteMachine({ _id: $scope.machineData._id }, function (res) {
          if (_.findIndex(res, { isActive: false })) {
            toastr.success(constants.toastrMessages.success.deleteMachine)
            if ($stateParams.routeId) { // if machines from route
              $state.go('routeMachines', { routeId: $stateParams.routeId, machineData: $stateParams.machineData, routeFilters: $stateParams.routeFilters })
            } else if ($stateParams.compositeId) {
              $state.go('machinesFromComposite', { compositeId: $stateParams.compositeId, machineData: $stateParams.machineData, compositeData: $stateParams.compositeData })
            } else {
              $state.go('machines', { machineData: $stateParams.machineData })
            }
          } else {
            toastr.error('Failed to delete')
          }
        }, function (err) {
          toastr.error(err.data.msg)
        })
      }, function () { })
    }

    /* Back button click handler. If current state is edit machine redirect
       to view machine details otherwise redirect to machine list page.
    */
    $scope.goBack = function () {
      if ($scope.editForm) {
        if ($stateParams.routeId) { // if machines from route
          $state.go('viewMachineFromRoute', { routeId: $stateParams.routeId, machineId: $scope.machineData._id, machineData: $stateParams.machineData, routeFilters: $stateParams.routeFilters, tab: $stateParams.tab })
        } else if ($stateParams.compositeId) {
          $state.go('viewMachineFromComposite', { compositeId: $stateParams.compositeId, machineId: $stateParams.machineId, tab: $stateParams.tab, machineData: $stateParams.machineData, compositeData: $stateParams.compositeData })
        } else {
          $state.go('viewMachine', { machineId: $scope.machineData._id, machineData: $stateParams.machineData, tab: $stateParams.tab })
        }
      } else {
        if ($stateParams.routeId) { // if machines from route
          $state.go('routeMachines', { routeId: $stateParams.routeId, machineData: $stateParams.machineData, routeFilters: $stateParams.routeFilters })
        } else if ($stateParams.compositeId) {
          $state.go('machinesFromComposite', { compositeId: $stateParams.compositeId, machineData: $stateParams.machineData, compositeData: $stateParams.compositeData })
        } else {
          $state.go('machines', { machineData: $stateParams.machineData })
        }
      }
    }

    /*
      Add and update machine control.
       It saves machine data in databse after adding or updating machine.
    */
    $scope.save = function () {
      // check whether all forms are valid or not
      if (!($scope.model.basicInfoForm.$valid && $scope.model.machineInfoForm.$valid && $scope.model.scheduleForm.$valid)) {
        return
      }
      $scope.machineMetaData = _.omit($scope.machineMetaData, ['disableUnitField'])
      var saveData = _.omit($scope.model, ['machineType', 'selectedLevel', 'basicInfoForm', 'machineInfoForm', 'scheduleForm', 'usersInfoForm'])
      var engineerDetails = angular.copy(MachineService.initialDistributionList[0])
      engineerDetails = _.omit(engineerDetails, ['id', 'name'])
      engineerDetails.portable.normal = $scope.machineOwner.normal
      engineerDetails.userId = $scope.selected.machineOwners._id
      // add analysis configuration if monitoredOnline flag is true
      saveData.customerId = $rootScope.user.customerIds[0]
      saveData.timezone = $scope.model.timezone ? $scope.model.timezone.utc[0] : 'Asia/Kolkata'
      saveData.parentId = $scope.model.selectedLevel._id
      saveData.owner = [$scope.selected.machineOwners._id]
      saveData.distributionList = $scope.distributionList.length ? _.map($scope.distributionList, function (itm) {
        var user = _.pick(itm, ['portable', 'permanent'])
        user.userId = itm._id
        return user
      }) : []
      saveData.distributionList.push(engineerDetails)
      saveData.schedule = { permanent: {} }
      if ($scope.editForm) {
        saveData._id = $scope.machineData._id
        saveData.meta = $scope.machineData.meta
        saveData.schedule = $scope.machineData.schedule
      }
      if ($scope.model.monitoredOnline) {
        saveData.analysisConfiguration = $scope.isUserDefinedLimit ? $scope.analysisConfiguration : _.pick($scope.analysisConfiguration, ['permanent.type', 'permanent.learningModeReadings', 'permanent.learningDays'])
        saveData.analysisConfiguration.permanent.learningModeReadings = $scope.model.learningCount
        saveData.analysisConfiguration.permanent.learningDays = {
          min: $scope.model.minLearningDays,
          max: $scope.model.maxLearningDays
        }
        var schedule = {}
        _.forEach(allSchedules, function (type) {
          $scope.schedule[type].days.specificDaysInWeek = _.uniq($scope.schedule[type].days.specificDaysInWeek)
          $scope.schedule[type].hours.specificHoursOfTheDay = _.uniq($scope.schedule[type].hours.specificHoursOfTheDay)
          schedule[type] = MachineService.createJSON(type, $scope.schedule[type])
        })
        saveData.schedule.permanent.userInputs = schedule

        // learning mode settings fro salerep
        if($scope.isDistributorUser) {
          saveData.analysisConfiguration.permanent.learningModeInfo = $scope.analysisConfiguration.permanent.learningModeInfo
          saveData.analysisConfiguration.permanent.learningModeReadings = $scope.readingsNotPossible ? $scope.totalPossibleReadings : $scope.model.learningCount
          saveData.schedule.permanent.userInputs.learning = {
            interval: $scope.readingInterval,
            intervalType: $scope.analysisConfiguration.permanent.learningModeInfo.intervalType
          }
        }
      } else {
        saveData.analysisConfiguration = {}
      }
      if ($scope.model.machineType.name !== 'machine') { // Machine meta data for rotating machines
        saveData.meta = _.assign(saveData.meta, $scope.machineMetaData)
        if ($scope.editForm && !$scope.machineData.nextScheduleOn) {
          saveData.meta.portablePoints = _.filter($scope.assessmentPoints, function (pt) { return pt.selected })
          saveData.meta.points = $scope.model.monitoredOnline ? $scope.editForm && $scope.machineData.meta && $scope.machineData.meta.points && $scope.machineData.meta.points.length && $scope.machineData.meta.points[0].deviceMacId ? $scope.machineData.meta.points : [_.find($scope.monitoringPoints, { internalName: $scope.model.selectedMonitoringPoint.toString() })] : []
          saveData.meta.points = _.map(saveData.meta.points, function (point) {
            return _.omit(point, ['deviceState'])
          })
        } else {
          saveData.meta.portablePoints = _.filter($scope.assessmentPoints, function (pt) { return pt.selected })
          saveData.meta.points = $scope.model.monitoredOnline ? [_.find($scope.monitoringPoints, { internalName: $scope.model.selectedMonitoringPoint.toString() })] : []
        }
      }
      /* Update details of existing machine */
      if ($scope.editForm) {
        MachineService.resource.editMachine(saveData, function (res) {
          toastr.success(constants.toastrMessages.success.updateMachine)
          if ($stateParams.routeId) { // if machines from route
            $state.go('viewMachineFromRoute', { routeId: $stateParams.routeId, machineId: $scope.machineData._id, machineData: $stateParams.machineData, routeFilters: $stateParams.routeFilters, tab: $stateParams.tab })
          } else if ($stateParams.compositeId) {
            $state.go('viewMachineFromComposite', { compositeId: $stateParams.compositeId, machineId: $stateParams.machineId, tab: $stateParams.tab, machineData: $stateParams.machineData, compositeData: $stateParams.compositeData })
          } else {
            $state.go('viewMachine', { machineId: $scope.machineData._id, machineData: $stateParams.machineData, tab: $stateParams.tab })
          }
        }, function (err) {
          toastr.error(err.data.msg)
        })
      } else if ($scope.viewForm) {
        $state.go('machines', { machineData: $stateParams.machineData })
      } else {
        // Add new machine
        saveData.machineTypeId = $scope.model.machineType._id
        MachineService.resource.addMachine(saveData, function (res) {
          toastr.success(constants.toastrMessages.success.addMachine)
          $state.go('machines')
        }, function (err) {
          toastr.error(err.data.msg)
        })
      }
    }

    /* Validation machine's basic information form to check whether all information is entered or not. */
    $scope.validateBasicInfoForm = function () {
      $scope.model.machineInfoForm.$submitted = false
      if ($scope.model.machineInfoForm && $scope.model.machineInfoForm.$invalid) {
        $scope.model.scheduleForm.$valid = false
      }
      $scope.model.basicInfoForm.$submitted = false
      if (!$scope.viewForm) {
        $scope.isLevelRequired = !$scope.model.selectedLevel
        $scope.isPointRequired = false
        if ($scope.model.basicInfoForm.machineName.$error.required || $scope.model.basicInfoForm.machineName.$error.pattern) {
          $scope.model.basicInfoForm.$submitted = true
          return false
        } else if ($scope.model.name && $scope.model.selectedLevel) {
          $scope.isLimitRequired = $scope.isUserDefinedLimit ? !($scope.analysisConfiguration.permanent.limits.overallVibration.warning && $scope.analysisConfiguration.permanent.limits.overallVibration.alert && $scope.analysisConfiguration.permanent.limits.crestFactor.warning && $scope.analysisConfiguration.permanent.limits.crestFactor.alert) : false
          $scope.isAlertRequired = $scope.model.monitoredOnline && $scope.isUserDefinedLimit && !$scope.isLimitRequired ? !($scope.analysisConfiguration.permanent.limits.overallVibration.warning < $scope.analysisConfiguration.permanent.limits.overallVibration.alert && $scope.analysisConfiguration.permanent.limits.crestFactor.warning < $scope.analysisConfiguration.permanent.limits.crestFactor.alert) : false
          var machineFormValid = true
          if ($scope.showMachineData) {
            if (!_.filter($scope.assessmentPoints, function(point) { return point.selected}).length) {
              machineFormValid = false
            }
          }
          if (!$scope.model.machineType || $scope.isLimitTypeRequired || $scope.isLimitRequired || $scope.isAlertRequired) {
            machineFormValid = false
          }
          if (!machineFormValid) {
            $scope.model.machineInfoForm.$valid = false
            $scope.model.scheduleForm.$valid = false
          } else if ($scope.validateScheduleForm(true)) {
            $scope.model.scheduleForm.$valid = true
          } else {
            $scope.model.scheduleForm.$valid = false
          }
          return true
        } else {
          return false
        }
      }
      return true
    }

    /* Validation machine's technical information form to check whether all information is entered or not. */
    $scope.validateMachineInfoForm = function () {
      if ($scope.model.monitoredOnline) {
        $scope.learningModeDays = MachineService.learningModeDaysCalculation($scope.schedule.operating, $scope.model.learningCount, $scope.model.minLearningDays, $scope.model.maxLearningDays)
      }
      if ($scope.model.basicInfoForm.$valid) {
        var isFormValid = true
        $scope.model.machineInfoForm.$submitted = true
        if (!$scope.viewForm) {
          if (!$scope.model.machineType) {
            $scope.isTypeRequired = true
            isFormValid = false
          }
          $scope.isLimitTypeRequired = $scope.model.monitoredOnline ? !$scope.analysisConfiguration.permanent.type : false
          $scope.isLimitRequired = $scope.isUserDefinedLimit ? !($scope.analysisConfiguration.permanent.limits.overallVibration.warning && $scope.analysisConfiguration.permanent.limits.overallVibration.alert && $scope.analysisConfiguration.permanent.limits.crestFactor.warning && $scope.analysisConfiguration.permanent.limits.crestFactor.alert) : false
          $scope.isAlertRequired = $scope.model.monitoredOnline && $scope.isUserDefinedLimit && !$scope.isLimitRequired ? !($scope.analysisConfiguration.permanent.limits.overallVibration.warning < $scope.analysisConfiguration.permanent.limits.overallVibration.alert && $scope.analysisConfiguration.permanent.limits.crestFactor.warning < $scope.analysisConfiguration.permanent.limits.crestFactor.alert) : false
          if ($scope.isLimitTypeRequired || $scope.isLimitRequired || $scope.isAlertRequired) {
            isFormValid = false
          }
          if ($scope.showMachineData) {
            if ($scope.isAssessmentPointRequired) {
              isFormValid = false
            }
          }
          if (!$scope.isTypeRequired && isFormValid && $scope.model.machineInfoForm.$valid && (!($scope.isOperatingHrsRequired || $scope.isOperatingDaysRequired || $scope.isNormalHrsRequired || $scope.isNormalDaysRequired || $scope.isWarningHrsRequired || $scope.isWarningDaysRequired || $scope.isAlertHrsRequired || $scope.isAlertDaysRequired || !$scope.validateScheduleForm()))) {
            $scope.model.scheduleForm.$valid = true
          } else {
            $scope.model.scheduleForm.$valid = false
          }
        }
        return isFormValid
      } else {
        /* redirect to basic info tab if its empty */
        if (!alert('Please fill general information first.')) {
          changeTab(0)
        }
      }
    }

    /* Validation machine's schedule information formto check whether all information is entered or not. */
    $scope.validateScheduleForm = function (noPopup) {
      if ($scope.model.basicInfoForm.$valid && $scope.model.machineInfoForm.$valid) {
        if ($scope.model.monitoredOnline) {
          $scope.isOperatingHrsRequired = $scope.schedule.operating.scheduleTime === 2 && _.isEmpty($scope.schedule.operating.hours.specificHoursOfTheDay)
          $scope.isOperatingDaysRequired = $scope.schedule.operating.daysType === 2 && _.isEmpty($scope.schedule.operating.days.specificDaysInWeek)
          $scope.isNormalHrsRequired = $scope.schedule.normal.scheduleTime === 2 && _.isEmpty($scope.schedule.normal.hours.specificHoursOfTheDay)
          $scope.isNormalDaysRequired = $scope.schedule.normal.daysType === 2 && _.isEmpty($scope.schedule.normal.days.specificDaysInWeek)
          $scope.isWarningHrsRequired = !$scope.schedule.warning.sameAsNormal ? $scope.schedule.warning.scheduleTime === 2 && _.isEmpty($scope.schedule.warning.hours.specificHoursOfTheDay) : false
          $scope.isWarningDaysRequired = !$scope.schedule.warning.sameAsNormal ? $scope.schedule.warning.daysType === 2 && _.isEmpty($scope.schedule.warning.days.specificDaysInWeek) : false
          $scope.isAlertHrsRequired = !$scope.schedule.alert.sameAsWarning ? $scope.schedule.alert.scheduleTime === 2 && _.isEmpty($scope.schedule.alert.hours.specificHoursOfTheDay) : false
          $scope.isAlertDaysRequired = !$scope.schedule.alert.sameAsWarning ? $scope.schedule.alert.daysType === 2 && _.isEmpty($scope.schedule.alert.days.specificDaysInWeek) : false

          if ($scope.isOperatingHrsRequired || $scope.isOperatingDaysRequired || $scope.isNormalHrsRequired || $scope.isNormalDaysRequired || $scope.isWarningHrsRequired || $scope.isWarningDaysRequired || $scope.isAlertHrsRequired || $scope.isAlertDaysRequired || $scope.learningMinutesInvalid || !$scope.model.learningCount || ($scope.analysisConfiguration.permanent.learningModeInfo && !$scope.analysisConfiguration.permanent.learningModeInfo.value )) {
            return false
          }
        }
        return true
      } else {
        if(!noPopup) {
          // redirect to basic info tab if its empty
          if (!alert('Please fill general and machine information first.')) {
            changeTab(0)
          }
        }
      }
    }

    /* Validation machine's users information formto check whether all information is entered or not. */
    $scope.validateUsersInfoForm = function () {
      if ($scope.model.basicInfoForm.$valid && $scope.model.machineInfoForm.$valid && $scope.model.scheduleForm.$valid) {
        var isValidForm = true
        $scope.model.usersInfoForm.$submitted = true
        _.forEach($scope.distributionList, function (itm) {
          if ($scope.model.monitoredOnline) {
            // validations for notification frequency
            if ((itm.permanent.warning || itm.permanent.alert) && !(itm.permanent.frequency.instant || itm.permanent.frequency.digest)) {
              $scope.notificationFrequencyRequiredFor = itm.firstName + ' ' + itm.lastName
              $scope.isNotificationFrequencyRequired = true
              isValidForm = false
              return false
            }
            // validation for monitored notification type
            if ((itm.permanent.frequency.digest || itm.permanent.frequency.instant) && !(itm.permanent.warning || itm.permanent.alert)) {
              $scope.permanentNotificationTypeRequiredFor = itm.firstName + ' ' + itm.lastName
              $scope.isPermanentNotificationTypeRequired = true
              isValidForm = false
              return false
            }
            // validation if notification type is not selected
            if (!((itm.permanent.frequency.instant || itm.permanent.frequency.digest) && (itm.permanent.warning || itm.permanent.alert)) && !(itm.portable.normal || itm.portable.warning || itm.portable.alert)) {
              $scope.isNotificationTypeRequired = true
              $scope.notificationTypeRequiredFor = itm.firstName + ' ' + itm.lastName
              isValidForm = false
              return false
            }
          } else if (!$scope.model.monitoredOnline && !(itm.portable.normal || itm.portable.warning || itm.portable.alert)) { // validations for portable notifications
            $scope.isNotificationTypeRequired = true
            $scope.notificationTypeRequiredFor = itm.firstName + ' ' + itm.lastName
            isValidForm = false
            return false
          }
        })
        return isValidForm
      } else {
        // redirect to basic info tab if its empty
        if (!alert('Please fill general and machine information first.')) {
          changeTab(0)
        }
      }
    }

    /* Used to check whether weekly days are selected or not for every schedule if weekly is selected. */
    $scope.selectedDayChange = function (condition, day) {
      var length = $scope.schedule[condition].days.specificDaysInWeek.length
      length = _.includes($scope.schedule[condition].days.specificDaysInWeek, day) ? length - 1 : length + 1
      _.includes($scope.schedule[condition].days.specificDaysInWeek, day) ? _.pull($scope.schedule[condition].days.specificDaysInWeek, day) : $scope.schedule[condition].days.specificDaysInWeek.push(day)
      if (condition === 'operating') {
        operatingSchedule = angular.copy($scope.schedule.operating)
        $scope.learningModeDays = MachineService.learningModeDaysCalculation(operatingSchedule, $scope.model.learningCount, $scope.model.minLearningDays, $scope.model.maxLearningDays)
      }

      $scope.isOperatingDaysRequired = condition === 'operating' ? length === 0 : $scope.isOperatingDaysRequired
      $scope.isNormalDaysRequired = condition === 'normal' ? length === 0 : $scope.isNormalDaysRequired
      $scope.isWarningDaysRequired = condition === 'warning' ? length === 0 : $scope.isWarningDaysRequired
      $scope.isAlertDaysRequired = condition === 'alert' ? length === 0 : $scope.isAlertDaysRequired

      /* TODO remove */

      // var length = $scope.schedule[condition].days.specificDaysInWeek.length
      // length = $scope.schedule[condition].days.specificDaysInWeek.includes(day) ? length - 1 : length + 1
      // if (condition === 'operating') {
      //   operatingSchedule = angular.copy($scope.schedule.operating)
      //   operatingSchedule.days.specificDaysInWeek.includes(day) ? _.pull(operatingSchedule.days.specificDaysInWeek, day) : operatingSchedule.days.specificDaysInWeek.push(day)
      //   $scope.learningModeDays = MachineService.learningModeDaysCalculation(operatingSchedule, $scope.model.learningCount, $scope.model.minLearningDays, $scope.model.maxLearningDays)
      //   if ($scope.editForm && $scope.schedule.operating.days.specificDaysInWeek.includes(day)) {
      //     if ($scope.schedule.normal.days.specificDaysInWeek.includes(day)) {
      //       _.pull($scope.schedule.normal.days.specificDaysInWeek, day)
      //     }
      //     if ($scope.schedule.warning.days.specificDaysInWeek.includes(day)) {
      //       _.pull($scope.schedule.warning.days.specificDaysInWeek, day)
      //     }
      //     if ($scope.schedule.alert.days.specificDaysInWeek.includes(day)) {
      //       _.pull($scope.schedule.alert.days.specificDaysInWeek, day)
      //     }
      //   }
      // }
      // if (condition === 'normal') {
      //   $scope.schedule.normal.days.specificDaysInWeek.includes(day) && $scope.schedule.warning.days.specificDaysInWeek.includes(day) ? _.pull($scope.schedule.warning.days.specificDaysInWeek, day) : $scope.schedule.warning.days.specificDaysInWeek.push(day)
      //   $scope.schedule.normal.days.specificDaysInWeek.includes(day) && $scope.schedule.alert.days.specificDaysInWeek.includes(day) ? _.pull($scope.schedule.alert.days.specificDaysInWeek, day) : $scope.schedule.alert.days.specificDaysInWeek.push(day)
      // }
      // if (condition === 'warning') {
      //   $scope.schedule.warning.days.specificDaysInWeek.includes(day) && $scope.schedule.alert.days.specificDaysInWeek.includes(day) ? _.pull($scope.schedule.alert.days.specificDaysInWeek, day) : $scope.schedule.alert.days.specificDaysInWeek.push(day)
      // }
      // $scope.isOperatingDaysRequired = condition === 'operating' ? length === 0 : $scope.isOperatingDaysRequired
      // $scope.isNormalDaysRequired = condition === 'normal' ? length === 0 : $scope.isNormalDaysRequired
      // $scope.isWarningDaysRequired = condition === 'warning' || $scope.schedule.warning.daysType === 2 ? length === 0 : $scope.isWarningDaysRequired
      // $scope.isAlertDaysRequired = condition === 'alert' || $scope.schedule.alert.daysType === 2 ? length === 0 : $scope.isAlertDaysRequired
    }

    /* Used to check whether specific hours are selected or not for every schedule if schedule type is specific hour(s). */
    $scope.selectedHourChange = function (condition, hour) {
      var length = $scope.schedule[condition].hours.specificHoursOfTheDay.length
      length = _.includes($scope.schedule[condition].hours.specificHoursOfTheDay, hour) ? length - 1 : length + 1
      _.includes($scope.schedule[condition].hours.specificHoursOfTheDay, hour) ? _.pull($scope.schedule[condition].hours.specificHoursOfTheDay, hour) : $scope.schedule[condition].hours.specificHoursOfTheDay.push(hour)
      if (condition === 'operating') {
        operatingSchedule = angular.copy($scope.schedule.operating)
        $scope.learningModeDays = MachineService.learningModeDaysCalculation(operatingSchedule, $scope.model.learningCount, $scope.model.minLearningDays, $scope.model.maxLearningDays)
        if($scope.isDistributorUser) {
          $scope.validateLearningModeCount()
        }
      }
      condition === 'normal' ? $scope.schedule.normal.selectAllHours = length === $scope.hours.length : void 0
      $scope.isOperatingHrsRequired = condition === 'operating' ? length === 0 : $scope.isOperatingHrsRequired
      $scope.isNormalHrsRequired = condition === 'normal' ? length === 0 : $scope.isNormalHrsRequired
      $scope.isWarningHrsRequired = condition === 'warning' ? length === 0 : $scope.isWarningHrsRequired
      $scope.isAlertHrsRequired = condition === 'alert' ? length === 0 : $scope.isAlertHrsRequired

      /* TODO remove */

      // var length = $scope.schedule[condition].hours.specificHoursOfTheDay.length
      // length = $scope.schedule[condition].hours.specificHoursOfTheDay.includes(hour) ? length - 1 : length + 1
      // if (condition === 'operating') {
      //   operatingSchedule = angular.copy($scope.schedule.operating)
      //   operatingSchedule.hours.specificHoursOfTheDay.includes(hour) ? _.pull(operatingSchedule.hours.specificHoursOfTheDay, hour) : operatingSchedule.hours.specificHoursOfTheDay.push(hour)
      //   $scope.learningModeDays = MachineService.learningModeDaysCalculation(operatingSchedule, $scope.model.learningCount, $scope.model.minLearningDays, $scope.model.maxLearningDays)
      //   $scope.schedule.normal.allOperatingHours.includes(hour) ? _.pull($scope.schedule.normal.allOperatingHours, hour) : $scope.schedule.normal.allOperatingHours.push(hour)
      //   $scope.schedule.normal.allOperatingHours = _.sortBy($scope.schedule.normal.allOperatingHours)
      //   $scope.schedule.normal.hours.onceDayAt.hour = $scope.schedule.normal.allOperatingHours.length ? $scope.schedule.normal.allOperatingHours[0].toString() : null
      //   if ($scope.schedule.normal.hours.specificHoursOfTheDay.includes(hour)) {
      //     _.pull($scope.schedule.normal.hours.specificHoursOfTheDay, hour)
      //   }
      //   if ($scope.schedule.warning.hours.specificHoursOfTheDay.includes(hour)) {
      //     _.pull($scope.schedule.warning.hours.specificHoursOfTheDay, hour)
      //   }
      //   if ($scope.schedule.alert.hours.specificHoursOfTheDay.includes(hour)) {
      //     _.pull($scope.schedule.alert.hours.specificHoursOfTheDay, hour)
      //   }
      // }
      // if (condition === 'normal') {
      //   $scope.schedule.normal.hours.specificHoursOfTheDay.includes(hour) ? _.pull($scope.schedule.warning.hours.specificHoursOfTheDay, hour) : $scope.schedule.warning.hours.specificHoursOfTheDay.push(hour)
      //   $scope.schedule.normal.hours.specificHoursOfTheDay.includes(hour) ? _.pull($scope.schedule.alert.hours.specificHoursOfTheDay, hour) : $scope.schedule.alert.hours.specificHoursOfTheDay.push(hour)
      // $scope.schedule.normal.selectAllHours = $scope.schedule.operating.scheduleTime === 2 ? length === $scope.schedule.operating.hours.specificHoursOfTheDay.length : length === 24
      // }
      // if (condition === 'warning') {
      //   $scope.schedule.warning.hours.specificHoursOfTheDay.includes(hour) ? _.pull($scope.schedule.alert.hours.specificHoursOfTheDay, hour) : $scope.schedule.alert.hours.specificHoursOfTheDay.push(hour)
      // }
      // length = $scope.schedule[condition].hours.specificHoursOfTheDay.length
      // length = $scope.schedule[condition].hours.specificHoursOfTheDay.includes(hour) ? length - 1 : length + 1
      // $scope.isOperatingHrsRequired = condition === 'operating' ? length === 0 : $scope.isOperatingHrsRequired
      // $scope.isNormalHrsRequired = condition === 'normal' ? length === 0 : $scope.isNormalHrsRequired
      // $scope.isWarningHrsRequired = condition === 'warning' || $scope.schedule.warning.scheduleTime === 2 ? length === 0 : $scope.isWarningHrsRequired
      // $scope.isAlertHrsRequired = condition === 'alert' || $scope.schedule.alert.scheduleTime === 2 ? length === 0 : $scope.isAlertHrsRequired
    }

    // Initialize days to default on change of days type
    $scope.changingDaysType = function (condition, type) {
      $scope.schedule[condition].days.allOperatingDays = condition !== 'operating' && type === 1
      if (type === 1) {
        $scope.schedule[condition].days.specificDaysInWeek = angular.copy($scope.initialSchedule[condition].days.specificDaysInWeek)
      }
      if (condition === 'operating') {
        $scope.schedule.operating.days.allDays = type === 1
        $scope.learningModeDays = MachineService.learningModeDaysCalculation($scope.schedule.operating, $scope.model.learningCount, $scope.model.minLearningDays, $scope.model.maxLearningDays)
      }
    }

    // Initialize hours to default on change of hours type
    $scope.changingHoursType = function (condition, type) {
      if (type === 2) {
        $scope.schedule[condition].hours.specificHoursOfTheDay = angular.copy($scope.initialSchedule[condition].hours.specificHoursOfTheDay)
      }
      if (condition === 'operating') {
        $scope.schedule.operating.hours.twentyFourHours = type === 1
        $scope.learningModeDays = MachineService.learningModeDaysCalculation($scope.schedule.operating, $scope.model.learningCount, $scope.model.minLearningDays, $scope.model.maxLearningDays)
        if($scope.isDistributorUser) {
          $scope.validateLearningModeCount()
        }
      }
      if (condition === 'normal' && type === 1) {
        $scope.schedule.normal.hours.onceDayAt.hour = $scope.initialSchedule.normal.hours.onceDayAt.hour
        $scope.schedule.normal.hours.onceDayAt.minutes = $scope.initialSchedule.normal.hours.onceDayAt.minutes
      } else if (condition === 'normal' && type === 3) {
        $scope.schedule.normal.hours.everyMinutesOfOperatingHours = $scope.initialSchedule.normal.hours.everyMinutesOfOperatingHours.toString()
      }
    }

    /* TODO remove */

    // initialize days to default on change of operating days
    // $scope.changingOperatingDays = function (type) {
    //   if (type === 1) {
    //     $scope.schedule.operating.days.specificDaysInWeek = angular.copy($scope.initialSchedule.operating.days.specificDaysInWeek)
    //   }
    //   $scope.learningModeDays = MachineService.learningModeDaysCalculation($scope.schedule.operating, $scope.model.learningCount, $scope.model.minLearningDays, $scope.model.maxLearningDays)
    // $scope.schedule.normal.daysType = $scope.schedule.operating.daysType
    // if (type === 1) {
    //   $scope.schedule.operating.days.specificDaysInWeek = angular.copy($scope.initialSchedule.operating.days.specificDaysInWeek)
    //   $scope.schedule.normal.days.specificDaysInWeek = angular.copy($scope.initialSchedule.normal.days.specificDaysInWeek)
    //   $scope.schedule.operating.days.allDays = true
    // } else {
    //   $scope.schedule.operating.days.allDays = false
    //   $scope.schedule.normal.days.specificDaysInWeek = angular.copy($scope.initialSchedule.operating.days.specificDaysInWeek)
    // }
    // $scope.learningModeDays = MachineService.learningModeDaysCalculation($scope.schedule.operating, $scope.model.learningCount, $scope.model.minLearningDays, $scope.model.maxLearningDays)
    // $scope.changingNormalMonitoringDays(type)
    // }

    // initialize hours to default on change of operating hours
    // $scope.changingOperatingTime = function (type) {
    //   if (type === 1) {
    //     $scope.schedule.operating.hours.specificHoursOfTheDay = angular.copy($scope.initialSchedule.operating.hours.specificHoursOfTheDay)
    //   }
    //   $scope.learningModeDays = MachineService.learningModeDaysCalculation($scope.schedule.operating, $scope.model.learningCount, $scope.model.minLearningDays, $scope.model.maxLearningDays)
    // $scope.schedule.normal.scheduleTime = $scope.schedule.operating.scheduleTime
    // $scope.schedule.normal.selectAllHours = false
    // if (type === 1) {
    //   $scope.schedule.operating.hours = angular.copy($scope.initialSchedule.operating.hours)
    //   $scope.schedule.normal.hours = angular.copy($scope.initialSchedule.normal.hours)
    //   $scope.schedule.normal.allOperatingHours = angular.copy($scope.hours)
    //   $scope.schedule.operating.hours.twentyFourHours = true
    // } else {
    //   $scope.schedule.operating.hours.twentyFourHours = false
    //   $scope.schedule.normal.hours.specificHoursOfTheDay = angular.copy($scope.initialSchedule.normal.hours.specificHoursOfTheDay)
    //   $scope.schedule.normal.allOperatingHours = angular.copy($scope.initialSchedule.operating.hours.specificHoursOfTheDay)
    // }
    // $scope.learningModeDays = MachineService.learningModeDaysCalculation($scope.schedule.operating, $scope.model.learningCount, $scope.model.minLearningDays, $scope.model.maxLearningDays)
    // $scope.changingNormalMonitoringTime(type)
    // }

    // initialize normal monitoring days and to default set warning monitoring days  on change of operating days
    // $scope.changingNormalMonitoringDays = function (type) {
    //   $scope.schedule.warning.daysType = $scope.schedule.normal.daysType
    //   if (type === 1) {
    //     $scope.schedule.normal.days.specificDaysInWeek = $scope.schedule.operating.daysType !== 1 ? angular.copy($scope.schedule.operating.days) : angular.copy($scope.initialSchedule.normal.days.specificDaysInWeek)
    //     $scope.schedule.warning.days.specificDaysInWeek = angular.copy($scope.schedule.normal.days.specificDaysInWeek)
    //     $scope.schedule.normal.days.allOperatingDays = true
    //   } else {
    //     $scope.schedule.normal.days.allOperatingDays = false
    //     $scope.schedule.warning.days.specificDaysInWeek = angular.copy($scope.schedule.normal.days.specificDaysInWeek)
    //   }
    //   $scope.changingWarningMonitoringDays(type)
    // }

    // initialize normal monitoring hours to default and set warning monitoring hours on change of operating hours
    // $scope.changingNormalMonitoringTime = function (type) {
    //   $scope.schedule.warning.scheduleTime = type !== 1 ? $scope.schedule.normal.scheduleTime : $scope.schedule.warning.scheduleTime
    //   // $scope.everyMinuteChange('warning', $scope.schedule.normal.hours.everyMinutesOfOperatingHours)
    //   if (type !== 2) {
    //     $scope.schedule.normal.hours.specificHoursOfTheDay = $scope.schedule.operating.scheduleTime !== 1 ? angular.copy($scope.schedule.operating.hours.specificHoursOfTheDay) : angular.copy($scope.initialSchedule.normal.hours.specificHoursOfTheDay)
    //     $scope.schedule.warning.hours.specificHoursOfTheDay = angular.copy($scope.schedule.normal.hours.specificHoursOfTheDay)
    //     if (type === 1) {
    //       if ($scope.schedule.operating.scheduleTime === 1) {
    //         $scope.schedule.normal.hours.onceDayAt = angular.copy($scope.initialSchedule.normal.hours.onceDayAt)
    //       } else if ($scope.schedule.normal.allOperatingHours.length) {
    //         $scope.schedule.normal.hours.onceDayAt.hour = $scope.schedule.normal.allOperatingHours[0].toString()
    //       }
    //     }
    //     if (type === 3) {
    //       $scope.schedule.normal.hours.everyMinutesOfOperatingHours = $scope.initialSchedule.normal.hours.everyMinutesOfOperatingHours ? $scope.initialSchedule.normal.hours.everyMinutesOfOperatingHours.toString() : $scope.everyMinutes[0].toString()
    //     }
    //   } else {
    //     $scope.schedule.normal.hours.specificHoursOfTheDay = $scope.schedule.operating.scheduleTime !== 1 ? angular.copy($scope.initialSchedule.operating.hours.specificHoursOfTheDay) : angular.copy($scope.initialSchedule.normal.hours.specificHoursOfTheDay)
    //   }
    //   $scope.changingWarningMonitoringTime(type)
    // }

    // initialize warning monitoring days and to default set alert monitoring days  on change of operating days
    // $scope.changingWarningMonitoringDays = function (type) {
    //   $scope.schedule.alert.daysType = $scope.schedule.warning.daysType
    //   if (type === 1) {
    //     $scope.schedule.warning.days.specificDaysInWeek = angular.copy($scope.schedule.normal.days.specificDaysInWeek)
    //     $scope.schedule.alert.days.specificDaysInWeek = angular.copy($scope.schedule.warning.days.specificDaysInWeek)
    //     $scope.schedule.warning.days.allOperatingDays = true
    //     $scope.schedule.alert.days.allOperatingDays = true
    //   } else {
    //     $scope.schedule.warning.days.allOperatingDays = false
    //     $scope.schedule.alert.days.allOperatingDays = false
    //     $scope.schedule.alert.days.specificDaysInWeek = angular.copy($scope.schedule.warning.days.specificDaysInWeek)
    //   }
    // }

    // // initialize warning monitoring hours to default and set alert monitoring hours on change of operating hours
    // $scope.changingWarningMonitoringTime = function (type) {
    //   $scope.schedule.alert.scheduleTime = type !== 1 ? $scope.schedule.warning.scheduleTime : $scope.schedule.alert.scheduleTime
    //   // $scope.everyMinuteChange('alert', $scope.schedule.warning.hours.everyMinutesOfOperatingHours)
    //   if (type !== 2) {
    //     $scope.schedule.warning.hours.specificHoursOfTheDay = angular.copy($scope.initialSchedule.normal.hours.specificHoursOfTheDay)
    //     $scope.schedule.alert.hours.specificHoursOfTheDay = angular.copy($scope.schedule.warning.hours.specificHoursOfTheDay)
    //   } else {
    //     $scope.schedule.warning.hours.everyMinutesOfOperatingHours = $scope.initialSchedule.warning.hours.everyMinutesOfOperatingHours
    //     $scope.schedule.warning.hours.specificHoursOfTheDay = angular.copy($scope.schedule.normal.hours.specificHoursOfTheDay)
    //   }
    //   $scope.changingAlertMonitoringTime(type)
    // }

    // // set alert monitoring days to default on change of monitoring day option
    // $scope.changingAlertMonitoringDays = function (type) {
    //   if (type === 1) {
    //     $scope.schedule.alert.days.specificDaysInWeek = angular.copy($scope.schedule.warning.days.specificDaysInWeek)
    //   }
    // }
    // // set alert monitoring time to default on change of monitoring time option
    // $scope.changingAlertMonitoringTime = function (type) {
    //   if (type === 2) {
    //     $scope.schedule.alert.hours.specificHoursOfTheDay = angular.copy($scope.schedule.warning.hours.specificHoursOfTheDay)
    //   } else {
    //     $scope.schedule.alert.hours.everyMinutesOfOperatingHours = !$scope.addForm ? $scope.initialSchedule.alert.hours.everyMinutesOfOperatingHours.toString() : parseInt($scope.schedule.warning.hours.everyMinutesOfOperatingHours) > parseInt($scope.initialSchedule.alert.hours.everyMinutesOfOperatingHours) ? $scope.initialSchedule.alert.hours.everyMinutesOfOperatingHours.toString() : $scope.schedule.warning.hours.everyMinutesOfOperatingHours.toString()
    //   }
    // }

    // select all operating hours
    // $scope.selectAllHours = function (checked) {
    //   if (checked) {
    //     $scope.schedule.normal.hours.specificHoursOfTheDay = $scope.schedule.operating.scheduleTime !== 1 ? angular.copy($scope.schedule.operating.hours.specificHoursOfTheDay) : angular.copy($scope.hours)
    //     $scope.schedule.warning.scheduleTime = 3
    //     $scope.schedule.alert.scheduleTime = 3
    //   } else {
    //     $scope.schedule.normal.hours.specificHoursOfTheDay = []
    //   }
    // }

    // select all operating hours
    $scope.selectAllHours = function (checked) {
      if (checked) {
        $scope.schedule.normal.hours.specificHoursOfTheDay = angular.copy($scope.hours)
      } else {
        $scope.schedule.normal.hours.specificHoursOfTheDay = []
      }
    }

    // Clear previous values in case of warning and alert condition
    $scope.resetSchedule = function (condition, type) {
      if (type === 1) {
        if (condition === 'warning') {
          $scope.schedule.warning.sameAsNormal = true
          $scope.schedule.warning = _.assign($scope.schedule.warning, _.pick(angular.copy($scope.initialSchedule.warning), ['days', 'hours', 'daysType', 'scheduleTime']))
        } else {
          $scope.schedule.alert.sameAsWarning = true
          $scope.schedule.alert = _.assign($scope.schedule.alert, _.pick(angular.copy($scope.initialSchedule.alert), ['days', 'hours', 'daysType', 'scheduleTime']))
        }
        $scope.schedule[condition].scheduleType = type
      } else {
        condition === 'warning' ? $scope.schedule.warning.sameAsNormal = false : $scope.schedule.alert.sameAsWarning = false
      }
    }

    /* TODO remove */

    // Disabled fields based on operating days and hours.
    // $scope.disabledFields = function (condition, type, itm) {
    //   if (condition === 'normal') { // for normal monitoring schedule
    //     if (type === 'days') {
    //       return $scope.schedule.operating.daysType !== 1 && !_.includes($scope.schedule.operating.days.specificDaysInWeek, itm)
    //     }
    //     return $scope.schedule.operating.scheduleTime !== 1 && !_.includes($scope.schedule.operating.hours.specificHoursOfTheDay, itm)
    //   }
    //   if (condition === 'warning') { // for warning monitoring schedule
    //     if (type === 'days') {
    //       return $scope.schedule.operating.daysType !== 1 ? (!_.includes($scope.schedule.operating.days.specificDaysInWeek, itm) || _.includes($scope.schedule.normal.days.specificDaysInWeek, itm)) : (!_.includes($scope.days, itm) || _.includes($scope.schedule.normal.days.specificDaysInWeek, itm))
    //     }
    //     return $scope.schedule.operating.scheduleTime !== 1 ? (!_.includes($scope.schedule.operating.hours.specificHoursOfTheDay, itm) || _.includes($scope.schedule.normal.hours.specificHoursOfTheDay, itm)) : (!_.includes($scope.hours, itm) || _.includes($scope.schedule.normal.hours.specificHoursOfTheDay, itm))
    //   }
    //   if (condition === 'alert') { // for alert monitoring schedule
    //     if (type === 'days') {
    //       return $scope.schedule.operating.daysType !== 1 ? (!_.includes($scope.schedule.operating.days.specificDaysInWeek, itm) || _.includes($scope.schedule.warning.days.specificDaysInWeek, itm)) : (!_.includes($scope.days, itm) || _.includes($scope.schedule.warning.days.specificDaysInWeek, itm))
    //     }
    //     return $scope.schedule.operating.scheduleTime !== 1 ? (!_.includes($scope.schedule.operating.hours.specificHoursOfTheDay, itm) || _.includes($scope.schedule.warning.hours.specificHoursOfTheDay, itm)) : (!_.includes($scope.hours, itm) || _.includes($scope.schedule.warning.hours.specificHoursOfTheDay, itm))
    //   }
    // }


    // Learning mode configuration in

    $scope.changingLearningModeInType = function(type) {
      $scope.learningModeInType = _.find($scope.learningModeInOptions, {id: type }).name
      $scope.frequencyPlaceHolderMsg = UtilService.generateMsg($scope.webAppTexts.placeholder.enter, { frequencyType: $scope.learningModeInType.toLowerCase()})
      if($scope.machineData && $scope.machineData.analysisConfiguration && $scope.machineData.analysisConfiguration.permanent && $scope.machineData.analysisConfiguration.permanent.learningModeInfo && $scope.machineData.analysisConfiguration.permanent.learningModeInfo.intervalType === type) {
        $scope.analysisConfiguration.permanent.learningModeInfo.value = $scope.machineData.analysisConfiguration.permanent.learningModeInfo.value
      } else {
        $scope.analysisConfiguration.permanent.learningModeInfo.value = type === 3 ? 5 : 1
      }
      $scope.validateLearningModeCount()
    }

    /* Handles browser back button event.
    */
    window.onhashchange = function (event) {
      if (!window.innerDocClick && $state.current.name !== 'machines') {
        $scope.tabNum = $stateParams.tab ? parseInt($stateParams.tab) : 0
        changeTab($scope.tabNum)
        $scope.$apply()
      }
    }

    /* Select specific tab */
    var changeTab = function (tab) {
      $scope.$baWizardController.selectTab(tab)
    }

    /* Breadcrumb click handler redirects to routes page */
    $scope.breadCrumbClickHandler = function (itm) {
      if ($stateParams.routeId && itm === $scope.webAppTexts.breadcrumbs.routeList) {
        $state.go('routes', { routeFilters: $stateParams.routeFilters })
      } else if ($stateParams.routeId && itm === $scope.routeData.name) {
        $state.go('routeMachines', { routeId: $stateParams.routeId, machineData: $stateParams.machineData, routeFilters: $stateParams.routeFilters })
      } else if ($stateParams.compositeId && itm === $scope.webAppTexts.breadcrumbs.compositeMachineList) {
        $state.go('compositeMachines', { compositeData: $stateParams.compositeData })
      } else if ($stateParams.compositeId && itm === $scope.compositeData.name) {
        $state.go('machinesFromComposite', { compositeId: $stateParams.compositeId, machineData: $stateParams.machineData, compositeData: $stateParams.compositeData })
      }
    }

    $scope.duplicateMachine = function () {
      var modalInstance = $uibModal.open({
        templateUrl: 'app/components/machines/modals/duplicateMachine.html',
        controller: 'DuplicateMachineCtrl',
        resolve: {
          machineData: machineData
        }
      })

      modalInstance.result.then(function (result) {})
    }
  }
})();

(function () {
  'use strict'
  angular.module('Vibzer.components.machines')
    .controller('AddRouteCtrl', AddRouteCtrl);

  // @NgInject
  function AddRouteCtrl($scope, $uibModalInstance, data) {
    $scope.title = 'Add route'
    $scope.iconClass = 'fa fa-plus'
    $scope.routeData = data
    $scope.machineMembers = [
      {
        _id: 1,
        name: 'Machine Memb1'
      },
      {
        _id: 2,
        name: 'Machine Memb2'
      }
    ]

    $scope.owner = [
      {
        _id: 1,
        name: 'Owner1'
      },
      {
        _id: 2,
        name: 'Owner1'
      }
    ]

    $scope.scheduleTypes = [
      { month: 1, displayName: 'Every 1 Month' },
      { month: 2, displayName: 'Every 2 Month' },
      { month: 3, displayName: 'Every 3 Month' },
      { month: 4, displayName: 'Every 4 Month' },
      { month: 0, displayName: 'Custom' }
    ]
    $scope.selectedScheduleType = {
      value: $scope.scheduleTypes[0]
    }
    $scope.selectedMachines = []
    $scope.owner.selected = []

    if ($scope.routeData && $scope.routeData._id) {
      $scope.title = 'Edit Route'
      $scope.iconClass = 'fa fa-edit'
      $scope.selectedMachines = $scope.routeData.machines
      $scope.selectedScheduleType.value = _.filter($scope.scheduleTypes, { month: $scope.routeData.schedule.type === 'day' ? 0 : $scope.routeData.schedule.count })[0]
      $scope.owner.selected = $scope.routeData.owner
    }

    $scope.pushMachine = function () {
      $scope.selectedMachines.push($scope.routeData.machineMember)
      $scope.machineMembers = _.pull($scope.machineMembers, $scope.routeData.machineMember)
      $scope.routeData.machineMember = ''
    }

    $scope.removeMachine = function (machine) {
      $scope.selectedMachines = _.pull($scope.selectedMachines, machine)
      $scope.machineMembers.push(machine)
    }

    $scope.saveRouteVisibility = function () {
      return !($scope.routeData && $scope.selectedMachines.length && $scope.owner.selected.length)
    }

    $scope.addRoute = function () {
      var route = {}
      route.name = $scope.routeData.name
      route.description = $scope.routeData.description
      route.machines = $scope.selectedMachines
      route.owner = $scope.owner.selected
      route.schedule = {
        type: $scope.selectedScheduleType.value.month === 0 ? 'day' : 'month',
        count: $scope.selectedScheduleType.value.month === 0 ? $scope.scheduleDays : $scope.selectedScheduleType.value.month
      }
      $uibModalInstance.close()
    }
  }
})();
(function () {
  'use strict';
  var angular = window.angular
  angular.module('Vibzer.components.machines')
    .controller('AllDevicesCtrl', AllDevicesCtrl);

  /** @ngInject */
  function AllDevicesCtrl ($scope, machineData) {
    $scope.machinePoints = machineData.meta.points
    $scope.totalDevices = $scope.machinePoints.length
  }
})();

(function () {
    'use strict';
    angular.module('Vibzer.components.manage')
        .controller('CompareReportCtrl', CompareReportCtrl);

    /** @ngInject */
    function CompareReportCtrl($scope, $uibModalInstance, ReportCtrlService, reportData) {
        $scope.motorReportPropertiesSequence = constant.motorReportPropertiesSequence
        if (reportData.type === 'machine') {
            $scope.machineReportPropertiesSequence = constant.machineReportPropertiesSequence
        }
        $scope.reportData = ReportCtrlService.getAvgStdAndIsoReport({ type: reportData.type, name: reportData.machineName })
        $scope.reportData.type = reportData.type
        $scope.currentReportExpSysVersion = $scope.reportData.vibzerExSysVersion || '3.0.0'
        $scope.machineInfo = $scope.reportData.machine
        $scope.comments = [
            {
                commentText: 'There is a problem in machine',
                byWhome: 'Technician-1'
            }
        ]

        _.isEmpty($scope.reportData.lastReport) ? $scope.noLastReport = true : $scope.noLastReport = false
        $scope.stdReportProperties = ReportCtrlService.generateReportData($scope.reportData.report, $scope.reportData.lastReport, constant, reportData.type + 'Report')
        $scope.isoReportProperties = ReportCtrlService.generateReportData($scope.reportData.isoReport, {}, constant, reportData.type + 'Report')

        $scope.reportDataByProperty = []
        _.forEach($scope.stdReportProperties, function (item, index) {
            $scope.isoReportProperties[index].iso = true
            $scope.reportDataByProperty.push([$scope.stdReportProperties[index], $scope.isoReportProperties[index]])
        })

        $scope.isFinalSeverity = function (index, checkBelow) {
            return $scope.reportDataByProperty[index][0].severityName === $scope.motorReportPropertiesSequence[5].severityName || (index + 1 < $scope.reportDataByProperty.length && $scope.reportDataByProperty[index + 1][0].severityName === $scope.motorReportPropertiesSequence[5].severityName && checkBelow)
        }

        $scope.sendComment = function () {
            $scope.comments.push({ commentText: $scope.reportComment, byWhome: 'Test user' })
            $scope.reportComment = ''
        }
    }

})();

(function () {
  'use strict'
  angular.module('Vibzer.components.machines')
    .controller('DeleteConfirmationCtrl', DeleteConfirmationCtrl);

  // @NgInject
  function DeleteConfirmationCtrl($scope, $uibModalInstance, $state, toastr, MachineService, resolveData) {
    $scope.machine = resolveData;

    $scope.confirm = function () {
      if (!$scope.machine.machineId) return
      MachineService.resource.deleteMachine({ _id: $scope.machine.machineId }, function (res) {
        if (_.findIndex(res, { isActive: false })) {
          toastr.success(constant.toastrMessages.success.deleteMachine)
          $state.go('machines')
        } else {
          toastr.error('Failed to delete')
        }
        $uibModalInstance.close()
      }, function (err) {
        toastr.error(err.data.msg)
        $uibModalInstance.dismiss()
      })
    }
  }
})();
(function () {
  'use strict'
  angular.module('Vibzer.components.machines')
    .controller('DuplicateMachineCtrl', DuplicateMachineCtrl);

  // @NgInject
  function DuplicateMachineCtrl ($scope, $uibModalInstance, $state, toastr, MachineService, machineData, constants) {
    $scope.machine = machineData
    $scope.model = {
      name: $scope.machine.name,
      machineId: $scope.machine._id
    }
    $scope.webAppTexts = constants.webAppTexts
    $scope.confirm = function () {
      MachineService.resource.duplicateMachine($scope.model, function (res) {
        toastr.success(res.msg)
        $uibModalInstance.close()
      }, function (error) {
        console.log(error)
        toastr.error(error.msg || error.data.msg)
      })
    }
  }
})();
(function () {
  'use strict';
  var angular = window.angular
  var _ = window._
  angular.module('Vibzer.components.machines.sessions')
    .controller('CalibrationCtrl', CalibrationCtrl)

  function CalibrationCtrl($scope, $state, $stateParams, $cookies, $uibModal, machineData, ReadingService, DeviceService, ReportService, constants, toastr) {
    $scope.machineData = machineData
    $scope.webAppTexts = constants.webAppTexts
    $scope.user = $cookies.getObject('vcUser')
    $scope.sessionId = $stateParams.sessionId
    $scope.isMonPoint = $scope.machineData.machineTypeId.name === 'machine'
    $scope.isSinglePoint = false
    $scope.loading = false
    $scope.loadingDevice = true
    $scope.deviceMacId = $stateParams.deviceMacId || null
    $scope.deviceSerialNumber = null


    function isAxisShapeLoaded(cal) {
      return cal && cal.x && cal.y && cal.z &&
        cal.x.physicalConversionConstant !== undefined && cal.x.physicalConversionConstant !== null &&
        cal.y.physicalConversionConstant !== undefined && cal.y.physicalConversionConstant !== null &&
        cal.z.physicalConversionConstant !== undefined && cal.z.physicalConversionConstant !== null
    }
    function axisConstantsEqual(a, b) {
      if (!a || !b) return !a && !b
      var axes = ['x','y','z']
      for (var i = 0; i < axes.length; i++) {
        var ax = axes[i]
        if (a[ax].physicalConversionConstant !== b[ax].physicalConversionConstant ||
            a[ax].ordinateToOrigin !== b[ax].ordinateToOrigin ||
            a[ax].rawToPhysicalDevidationFactor !== b[ax].rawToPhysicalDevidationFactor) return false
      }
      return true
    }

    $scope.calibartionConstants = {
      x: { physicalConversionConstant: null, ordinateToOrigin: null, rawToPhysicalDevidationFactor: null },
      y: { physicalConversionConstant: null, ordinateToOrigin: null, rawToPhysicalDevidationFactor: null },
      z: { physicalConversionConstant: null, ordinateToOrigin: null, rawToPhysicalDevidationFactor: null }
    }
    $scope.originalCalibrationConstants = {}
    $scope.defaultCalibrationConstants = {}
    $scope.recalculatedGraphData = null
    $scope.hasChanges = false
    $scope.hasRecalculated = false
    $scope.calibrationAxes = constants.calibrationAxes

    $scope.checkForChanges = function() {
      if (!$scope.originalCalibrationConstants || !isAxisShapeLoaded($scope.originalCalibrationConstants)) {
        $scope.hasChanges = false
        return
      }
      var changed = !axisConstantsEqual($scope.calibartionConstants, $scope.originalCalibrationConstants)
      $scope.hasChanges = changed
      // If values have changed after recalculation, reset the recalculated flag
      if (changed && $scope.hasRecalculated) {
        $scope.hasRecalculated = false
      }
      if (!changed && isAxisShapeLoaded($scope.defaultCalibrationConstants) && axisConstantsEqual($scope.calibartionConstants, $scope.defaultCalibrationConstants)) {
        $scope.hasRecalculated = false
      }
    }

    $scope.$watch('calibartionConstants', function() { $scope.checkForChanges() }, true)

    $scope.openingChart = function (chart) {
      if ($scope.hasChanges) {
        toastr.error('Please recalculate calibration data before viewing charts')
        return
      }
      if (!isAxisShapeLoaded($scope.calibartionConstants)) {
        toastr.error('Please ensure calibration constants are loaded')
        return
      }
      var templateUrl = 'app/components/machines/reviews/modals/charts.html'
      var controller = null
      if (chart === 'wave') {
        controller = 'WaveChartCtrl'
      } else if (chart === 'spectrum') {
        controller = 'SpectrumChartCtrl'
      }
      
      if (!controller) {
        return
      }
      
      // Get session name from machineData or use default
      var sessionName = $scope.machineData.sessionName || 'Calibration Session'
      
      // Prepare machine data for modal - include point selection if available
      var modalMachineData = angular.copy($scope.machineData)
      modalMachineData.chartType = chart
      modalMachineData.sessionId = $scope.sessionId
      modalMachineData.sessionName = sessionName
      modalMachineData.readingType = $scope.machineData.readingType || 1
      modalMachineData.customerId = $scope.machineData.customerId
      modalMachineData.calibartionConstants = isAxisShapeLoaded($scope.originalCalibrationConstants)
        ? $scope.originalCalibrationConstants
        : $scope.calibartionConstants
      // If recalculated graph data is available, pass it for initial load only
      // When point changes, the chart controller will call API with new pointSet
      if ($scope.recalculatedGraphData) {
        // Pass pre-calculated graph data for initial load
        if (chart === 'spectrum') {
          modalMachineData.spectrum = $scope.recalculatedGraphData.spectrum
          modalMachineData.overallValues = $scope.recalculatedGraphData.overallValues
        } else if (chart === 'wave') {
          modalMachineData.wave = $scope.recalculatedGraphData.wave
        }
        // Mark that data is pre-calculated for initial load
        // But calibration constants are still passed so API can be called on point change
        modalMachineData.usePreCalculatedData = true
        // Store the pointSet for which this data was calculated
        if ($scope.selected && $scope.selected.point) {
          modalMachineData.originalPointSet = parseInt($scope.selected.point.internalName)
        }
      }
      
      // Ensure point selection is available in modal machineData for portable machines
      if (!$scope.isMonPoint && $scope.selected && $scope.selected.point) {
        // The chart controller will use selected.point from its own scope, but we ensure machineData has the points
        if (!modalMachineData.meta) {
          modalMachineData.meta = {}
        }
        if (!modalMachineData.meta.points && $scope.machineData.meta && $scope.machineData.meta.points) {
          modalMachineData.meta.points = angular.copy($scope.machineData.meta.points)
        }
        // Set the currently selected point as the first point so chart controller uses it
        if (modalMachineData.meta.points && modalMachineData.meta.points.length) {
          // Find the selected point and move it to first position
          var selectedPointIndex = _.findIndex(modalMachineData.meta.points, function(p) {
            return p.internalName === $scope.selected.point.internalName
          })
          if (selectedPointIndex > 0) {
            // Move selected point to first position
            var selectedPoint = modalMachineData.meta.points.splice(selectedPointIndex, 1)[0]
            modalMachineData.meta.points.unshift(selectedPoint)
          }
        }
      }
      
      var modalInstance = $uibModal.open({
        templateUrl: templateUrl,
        backdrop: true,
        controller: controller,
        resolve: {
          machineData: function () {
            return modalMachineData
          }
        },
        size: 'xt-lg'
      })
      modalInstance.result.then(function (result) {
        // Modal closed
      })
    }

    // Initialize points for portable machines - must be called before API calls
    function initializePoints() {
      if (!$scope.isMonPoint) {
        // Ensure meta object exists
        if (!$scope.machineData.meta) {
          $scope.machineData.meta = {}
        }
        // Check for portable points first (same logic as Spectrum/Wave pages)
        // Use $scope.machineData which comes from route resolve (same as sessions page)
        if ($scope.machineData && $scope.machineData.meta && $scope.machineData.meta.portablePoints && $scope.machineData.meta.portablePoints.length) {
          $scope.machineData.meta.points = angular.copy($scope.machineData.meta.portablePoints)
        }
        // Initialize points if not already set (from regular points array)
        if (!$scope.machineData.meta.points && $scope.machineData.meta && $scope.machineData.meta.points && $scope.machineData.meta.points.length) {
          $scope.machineData.meta.points = angular.copy($scope.machineData.meta.points)
        }
        // If points are still not available, use default points from constants
        if (!$scope.machineData.meta.points || !$scope.machineData.meta.points.length) {
          // Use default points from constants
          $scope.machineData.meta.points = constants.points.map(function (pt) {
            return {
              _id: null,
              name: pt.name,
              displayName: pt.name,
              internalName: pt.id,
              isActive: true
            }
          })
        }
        // Initialize selected point if points are available
        if ($scope.machineData.meta && $scope.machineData.meta.points && $scope.machineData.meta.points.length) {
          $scope.selected = $scope.selected || {}
          $scope.selected.point = $scope.machineData.meta.points[0]
          $scope.isSinglePoint = $scope.machineData.meta.points.length === 1
        }
      }
    }

    // Load device configuration and graphs from getCalibrationData API
    // This API returns both calibration constants and graph data
    function loadDeviceConfigAndGraphs() {
      // Ensure points are initialized before making API call
      initializePoints()
      $scope.loadingDevice = true
      var params = {
        machineId: $scope.machineData._id,
        sessionId: $scope.sessionId
      }
      
      // Always include pointSet for portable machines (non-monitoring points)
      if (!$scope.isMonPoint) {
        // Include pointSet in params - use selected point or default to first point
        if ($scope.selected && $scope.selected.point && $scope.selected.point.internalName !== undefined && $scope.selected.point.internalName !== null) {
        params.pointSet = parseInt($scope.selected.point.internalName)
        } else if ($scope.machineData.meta && $scope.machineData.meta.points && $scope.machineData.meta.points.length) {
          // Fallback: use first point's internalName if selected.point is not available
          var firstPoint = $scope.machineData.meta.points[0]
          if (firstPoint && firstPoint.internalName !== undefined && firstPoint.internalName !== null) {
            params.pointSet = parseInt(firstPoint.internalName)
          }
        }
      }
      
      // Call getCalibrationData to get calibration constants and graph data
      ReadingService.resource.getCalibrationData(params, function (res) {
        // Check if response contains error message
        if (res && res.msg) {
          $scope.loadingDevice = false
          toastr.error(res.msg || 'Failed to load calibration data')
          return
        }
        // Extract collectorName (deviceMacId) and serialNumber from response
        if (res && res.collectorName) {
          $scope.deviceMacId = res.collectorName
        }
        if (res && res.serialNumber) {
          $scope.deviceSerialNumber = res.serialNumber || null
        }
        if (res && res.calibartionConstants) {
          var calibConstants = res.calibartionConstants
          if (calibConstants.x && calibConstants.y && calibConstants.z) {
            $scope.calibartionConstants = { x: angular.copy(calibConstants.x), y: angular.copy(calibConstants.y), z: angular.copy(calibConstants.z) }
          }
          if (isAxisShapeLoaded($scope.calibartionConstants)) {
            $scope.originalCalibrationConstants = angular.copy($scope.calibartionConstants)
            if (!isAxisShapeLoaded($scope.defaultCalibrationConstants)) {
              $scope.defaultCalibrationConstants = angular.copy($scope.calibartionConstants)
            }
            // Store graph data from initial API call to avoid extra API calls when opening charts
            if (res.spectrum && res.wave) {
              $scope.recalculatedGraphData = {
                spectrum: res.spectrum,
                wave: res.wave,
                overallValues: res.overallValues || null
              }
            }
            // Initialize validation flags - no changes initially
            $scope.hasChanges = false
            $scope.hasRecalculated = false
            
            $scope.loadingDevice = false
            return
          }
        }
        
        // If calibration constants are missing or incomplete
        $scope.loadingDevice = false
        toastr.error('Device configuration not found. Cannot load calibration data.')
      }, function (err) {
        $scope.loadingDevice = false
        var errorMsg = 'Failed to load calibration data'
        if (err && err.data && err.data.msg) {
          errorMsg = err.data.msg
        } else if (err && err.msg) {
          errorMsg = err.msg
        }
        toastr.error(errorMsg)
      })
    }

    $scope.resetCalibrationConstants = function() {
      if (isAxisShapeLoaded($scope.defaultCalibrationConstants)) {
        $scope.calibartionConstants = angular.copy($scope.defaultCalibrationConstants)
        $scope.originalCalibrationConstants = angular.copy($scope.defaultCalibrationConstants)
        $scope.recalculatedGraphData = null
        $scope.hasChanges = false
        $scope.hasRecalculated = false
        toastr.success('Calibration constants reset to original database values')
      } else {
        toastr.warning('No original values available to reset')
      }
    }

    $scope.recalculate = function () {
      if (!isAxisShapeLoaded($scope.calibartionConstants)) {
        toastr.error('Please fill all calibration constant fields (X, Y, Z axes)')
        return
      }
      
      // Ensure points are initialized before making API call
      initializePoints()
      $scope.loading = true
      var params = {
        machineId: $scope.machineData._id,
        sessionId: $scope.sessionId,
        calibartionConstants: JSON.stringify($scope.calibartionConstants)
      }
      // Always include pointSet for portable machines (non-monitoring points)
      if (!$scope.isMonPoint) {
        // Include pointSet in params - use selected point or default to first point
        if ($scope.selected && $scope.selected.point && $scope.selected.point.internalName !== undefined && $scope.selected.point.internalName !== null) {
          params.pointSet = parseInt($scope.selected.point.internalName)
        } else if ($scope.machineData.meta && $scope.machineData.meta.points && $scope.machineData.meta.points.length) {
          var firstPoint = $scope.machineData.meta.points[0]
          if (firstPoint && firstPoint.internalName !== undefined && firstPoint.internalName !== null) {
            params.pointSet = parseInt(firstPoint.internalName)
          }
        }
      }
      
      // Call getCalibrationData API to recalculate with updated calibration constants
      ReadingService.resource.getCalibrationData(params, function (res) {
        $scope.loading = false
        // Check if response contains error message
        if (res && res.msg) {
          toastr.error(res.msg || 'Failed to recalculate calibration data')
          return
        }
        if (res && res.spectrum && res.wave) {
          // Update original calibration constants to the recalculated values
          // This ensures charts opened after recalculation use the new values
          $scope.originalCalibrationConstants = angular.copy($scope.calibartionConstants)
          // Store the recalculated graph data for use when charts are opened
          $scope.recalculatedGraphData = {
            spectrum: res.spectrum,
            wave: res.wave,
            overallValues: res.overallValues || null
          }
          // Mark as recalculated and clear changes flag since values are now "original"
          $scope.hasRecalculated = true
          $scope.hasChanges = false
          toastr.success('Calibration data recalculated successfully. Open charts to view the updated graphs.')
        } else {
          toastr.error('Invalid calibration data received')
        }
      }, function (err) {
        $scope.loading = false
        var errorMsg = 'Failed to recalculate calibration data'
        if (err && err.data && err.data.msg) {
          errorMsg = err.data.msg
        } else if (err && err.msg) {
          errorMsg = err.msg
        }
        toastr.error(errorMsg)
      })
    }

    $scope.saveAndClose = function () {
      if ($scope.hasChanges && !$scope.hasRecalculated) {
        toastr.error('Please recalculate calibration data before saving')
        $scope.loading = false
        return
      }
      if (!isAxisShapeLoaded($scope.calibartionConstants)) {
        toastr.error('Please fill all calibration constant fields (X, Y, Z axes)')
        return
      }
      
      if (!$scope.deviceMacId) {
        toastr.error('Device not found')
        return
      }
      
      $scope.loading = true
      
      var deviceData = {
        deviceMacId: $scope.deviceMacId,
        calibartionConstants: $scope.calibartionConstants
      }
      
      // Use the dedicated calibration constants update API
      DeviceService.resource.updateCalibrationConstants(deviceData, function (res) {
        toastr.success('Calibration constants saved successfully')
        $scope.loading = false
        
        // Update original calibration constants to the saved values
        $scope.originalCalibrationConstants = angular.copy($scope.calibartionConstants)
        // Update default values to saved values (since they're now in database)
        $scope.defaultCalibrationConstants = angular.copy($scope.calibartionConstants)
        // Reset validation flags after save
        $scope.hasChanges = false
        $scope.hasRecalculated = false
        
        // Navigate back to sessions page
        var params = {
          machineId: $stateParams.machineId,
          machineData: $stateParams.machineData
        }
        if ($stateParams.routeId) {
          params.routeId = $stateParams.routeId
          params.routeFilters = $stateParams.routeFilters
          $state.go('sessionsFromRoute', params)
        } else if ($stateParams.compositeId) {
          params.compositeId = $stateParams.compositeId
          params.compositeData = $stateParams.compositeData
          $state.go('sessionsFromComposite', params)
        } else {
          $state.go('sessions', params)
        }
      }, function (err) {
        var errorMsg = 'Failed to save calibration constants'
        if (err && err.data && err.data.msg) {
          errorMsg = err.data.msg
        }
        toastr.error(errorMsg)
        $scope.loading = false
      })
    }

    // Point selection for portable machines - initialize points early
    initializePoints()

    // Breadcrumb
    $scope.breadCrumbList = [$scope.webAppTexts.breadcrumbs.machineList, $scope.webAppTexts.breadcrumbs.sessions, 'Device Calibration']
    $scope.breadCrumbClickHandler = function (itm) {
      if (itm === $scope.webAppTexts.breadcrumbs.machineList) {
        $state.go('machines')
      } else if (itm === $scope.webAppTexts.breadcrumbs.sessions) {
        var params = {
          machineId: $stateParams.machineId,
          machineData: $stateParams.machineData
        }
        if ($stateParams.routeId) {
          params.routeId = $stateParams.routeId
          params.routeFilters = $stateParams.routeFilters
          $state.go('sessionsFromRoute', params)
        } else if ($stateParams.compositeId) {
          params.compositeId = $stateParams.compositeId
          params.compositeData = $stateParams.compositeData
          $state.go('sessionsFromComposite', params)
        } else {
          $state.go('sessions', params)
        }
      }
    }

    // Initialize - Load device configuration and graphs from getCalibrationData API
    loadDeviceConfigAndGraphs()

    // Initialize graph height on page load - same as existing chart controllers
    angular.element(document).ready(function () {
      ReportService.setChartModelHeight()
    })
  }
})();
(function () {
  'use strict';
  var angular = window.angular
  var _ = window._
  var moment = window.moment
  var $ = window.$
  angular.module('Vibzer.components.machines.sessions')
    .controller('ReviewCtrl', ReviewCtrl)

  function ReviewCtrl($scope, $state, $location, $stateParams, $uibModal, machineData, ReportService, RouteService, CompositeService, $cookies, constants) {
    $scope.machineData = machineData
    $scope.webAppTexts = constants.webAppTexts
    var lastReadingType = _.find(constants.readingTypes, { id: machineData.lastReadingType })
    var condition = _.find(constants.machineStates, { id: lastReadingType ? machineData[lastReadingType.internalName].condition : -1 })
    if (condition) {
      $scope.machineData.condition = condition.color
    }
    $scope.dateFormat = constants.dateFormats.default
    $scope.isMonitoringMachine = false
    $scope.page = 1
    $scope.limit = 10
    $scope.sessions = []
    $scope.selected = {}
    $scope.user = $cookies.getObject('vcUser')
    $scope.machineData.machineTypeId.name === 'machine' ? $scope.isMonitoringMachine = true : $scope.isMonitoringMachine = false
    $scope.machineData.icon = _.find(constants.typesOfMachine, { name: $scope.machineData.machineTypeId.name }).icon
    // get all reading types
    $scope.readingTypes = angular.copy(constants.readingTypes)
    $scope.readingTypes.unshift({ id: 0, internalName: 'all', displayName: 'All' })
    $scope.selected.readingType = $scope.readingTypes[0].id
    /* Get all machine conditions */
    $scope.machineConditions = angular.copy(_.filter(constants.machineStates, function (state) { return state.id > 0 }))
    $scope.machineConditions.unshift({ id: 0, name: 'all', displayName: 'All' })
    $scope.machineConditions = _.filter($scope.machineConditions, function (condition) {
      if (condition.name === 'all') {
        condition.displayName = condition.displayName.concat(' conditions')
      } else {
        condition.displayName = condition.displayName.concat(' condition')
      }
      return condition
    })
    $scope.condition = {}
    $scope.selected.condition = $scope.machineConditions[0]

    // dynamic breadcrumbs
    $scope.breadCrumbList = [$scope.webAppTexts.breadcrumbs.machineList, $scope.webAppTexts.breadcrumbs.sessions]
    // get route data
    if ($stateParams.routeId) {
      RouteService.resource.getRoute({ _id: $stateParams.routeId }, function (res) {
        $scope.routeData = res
        $scope.breadCrumbList = [$scope.webAppTexts.breadcrumbs.routeList, $scope.routeData.name, $scope.webAppTexts.breadcrumbs.sessions]
      })
    }

    // get composite machine data
    if ($stateParams.compositeId) {
      CompositeService.resource.getById({ _id: $stateParams.compositeId }, function (res) {
        $scope.compositeData = res
        if ($scope.machineData.forComposite) {
          $scope.breadCrumbList = [$scope.webAppTexts.breadcrumbs.compositeMachineList, $scope.webAppTexts.breadcrumbs.sessions]
        } else {
          $scope.breadCrumbList = [$scope.webAppTexts.breadcrumbs.compositeMachineList, $scope.compositeData.name, $scope.webAppTexts.breadcrumbs.sessions]
        }
      })
    }

    $scope.format = 'MM-dd-yyyy'
    $scope.startDateOptions = {
      dateDisabled: false,
      formatYear: 'yy',
      maxDate: new Date(2100, 1, 1),
      minDate: new Date(2000, 1, 1),
      startingDay: 1
    }

    $scope.endDateOptions = angular.copy($scope.startDateOptions)
    $scope.isStartDateOpened = false
    $scope.isEndDateOpened = false

    $scope.selectStartDate = function () {
      $scope.isStartDateOpened = true
    }

    $scope.selectEndDate = function () {
      $scope.isEndDateOpened = true
    }

    /* This function  invokes after selecting start or end session date and updates session list. */
    $scope.dateSelected = function (type) {
      $location.search('startSessionDate', null)
      $location.search('endSessionDate', null)
      if (type === 'end' && $scope.endSessionDate) {
        $scope.endSessionDate.setHours(23, 59, 59, 999)
      } else {
        $scope.endDateOptions.minDate = $scope.startSessionDate
      }
      $scope.page = 1
      $scope.sessions = []
      $scope.getSessions()
    }

    /* This function invokes after selecting machine condition and updates session list as per condition. */
    $scope.conditionSelected = function () {
      $scope.totalPages =null
      $scope.page = 1
      $scope.sessions = []
      $scope.getSessions()
    }

    /* This function invokes after selecting reading type and updates session list as per selected reading type. */
    $scope.readingTypeSelected = function (readingType) {
      $scope.totalPages =null
      $scope.page = 1
      $scope.sessions = []
      $scope.getSessions()
    }
    /* Get sessions of machine. */
    $scope.getSessions = function () {
      if ($scope.totalPages !== null && $scope.page > $scope.totalPages || $scope.page === 0) {
        return
      }
      $scope.busy = true
      var queryParams = {
        customerId: $scope.user.customerIds[0],
        machineId: $stateParams.machineId,
        limit: $scope.limit || 10,
        page: $scope.page || 1
      }

      if ($scope.selected.condition && $scope.selected.condition.name !== 'all') {
        queryParams.condition = $scope.selected.condition.id
      }
      if ($scope.selected.readingType && $scope.selected.readingType !== 0) {
        queryParams.readingType = $scope.selected.readingType
      }
      if ($scope.startSessionDate || $scope.endSessionDate) {
        queryParams.dates = {}
        if ($scope.startSessionDate) {
          queryParams.dates.fromDate = $scope.startSessionDate.toISOString()
          $location.search('startSessionDate', $scope.startSessionDate.toISOString())
        }
        if ($scope.endSessionDate) {
          queryParams.dates.toDate = $scope.endSessionDate.toISOString()
          $location.search('endSessionDate', $scope.endSessionDate.toISOString())
        }
      }

      ReportService.resource.getAllMachineSessions({ stringifyData: JSON.stringify(queryParams) }, function (res) {
      //  Stop further API calls when no session data is returned
        if (!res.result || res.result.length === 0) {
          $scope.busy = false;
          $scope.totalPages = $scope.page - 1;
          return;
        }
        $scope.sessions = $scope.sessions.concat(_.map(res.result, function (session, index) {
          session.name = 'S- ' + moment(session.createdOn).format('MM-DD-YY HH:mm:ss') // 'Session ' + (index + 1)
          session.readingType = _.find(constants.readingTypes, { id: session.readingType })
          var machineCondition = _.filter(constants.machineStates, { id: session.condition })[0]
          if (machineCondition) {
            session.color = machineCondition.color
          }
          session.icon = $scope.machineData.icon
          session.viewReport = true
          if (session.isTestReading) {
            session.comment = $scope.webAppTexts.notes.noTestReadingReport
            session.typeText = $scope.webAppTexts.labels.testReading
          } else if (!session.hasReport) {
            session.comment = $scope.webAppTexts.notes.failToGenerateReport
            // session.typeText = $scope.webAppTexts.labels.reportError
          }
          return session
        }))
        $scope.totalPages = res.totalPages
        $scope.page = $scope.page + 1
        $scope.busy = false
        $scope.$emit('list:filtered')
      }, function (err) {
        $scope.busy = false
        $scope.page = 0
        console.log(err)
      })
    }

    /* Redirects to machines page. */
    $scope.breadCrumbClickHandler = function (itm) {
      if ($stateParams.compositeId && $scope.machineData.forComposite) {
        $state.go('compositeMachines', { compositeData: $stateParams.compositeData })
      } else if ($stateParams.routeId && itm === $scope.webAppTexts.breadcrumbs.routeList) {
        $state.go('routes', { routeFilters: $stateParams.routeFilters })
      } else if ($stateParams.routeId && itm === $scope.routeData.name) {
        $state.go('routeMachines', { routeId: $stateParams.routeId, machineData: $stateParams.machineData, routeFilters: $stateParams.routeFilters })
      } else if ($stateParams.compositeId && itm === $scope.webAppTexts.breadcrumbs.compositeMachineList) {
        $state.go('compositeMachines', { compositeData: $stateParams.compositeData })
      } else if ($stateParams.compositeId && itm === $scope.compositeData.name) {
        $state.go('machinesFromComposite', { compositeId: $stateParams.compositeId, machineData: $stateParams.machineData, compositeData: $stateParams.compositeData })
      } else {
        $state.go('machines', { machineData: $stateParams.machineData })
      }
    }

    /* This block handles modal opening for all charts. */
    $scope.openingChart = function (chart, sessionId, sessionName, readingType) {
      var templateUrl = 'app/components/machines/reviews/modals/charts.html'
      if (chart === 'wave') {
        var controller = 'WaveChartCtrl'
      } else if (chart === 'spectrum') {
        controller = 'SpectrumChartCtrl'
      } else if (chart === 'rawData') {
        templateUrl = 'app/components/machines/reviews/modals/rawDataChart.html'
        controller = 'RawChartCtrl'
      }
      var modalInstance = $uibModal.open({
        templateUrl: templateUrl,
        backdrop: true,
        controller: controller,
        resolve: {
          machineData: function () {
            return _.assign(machineData, {
              chartType: chart,
              sessionId: sessionId,
              sessionName: sessionName,
              readingType: readingType.id
            })
          }
        },
        size: 'xt-lg'
      })
      modalInstance.result.then(function (result) {
      })
    }

    /* Open view report dialog */
    $scope.viewReportOfSession = function (sessionId, sessionName) {
      var modalInstance = $uibModal.open({
        templateUrl: 'app/components/machines/reviews/modals/viewReport.html',
        backdrop: true,
        controller: 'ViewReportCtrl',
        resolve: {
          reportData: {
            machineType: machineData.machineTypeId.name,
            sessionId: sessionId,
            sessionName: sessionName
          }
        }
      })
      modalInstance.result.then(function (result) {
      })
    }

    /* To view criteria wise analysis */
    $scope.viewCriteriaAnalysis = function (session) {
      $uibModal.open({
        templateUrl: 'app/components/machines/reviews/modals/viewCriteriaAnalysis.html',
        backdrop: true,
        controller: 'ViewCriteriaAnalysisCtrl',
        size: 'xt-lg',
        resolve: {
          reportData: angular.copy(_.assign(session, {
            machineId: $scope.machineData._id,
            machineName: machineData.name,
            machineType: machineData.machineTypeId.name,
            meta: machineData.meta
          }))
        }
      })
    }

    /* Navigate to calibration page */
    $scope.openCalibration = function (session) {
      // Get deviceMacId from machine data
      var deviceMacId = null
      if ($scope.machineData.machineTypeId.name === 'machine') {
        // For monitoring machines
        if ($scope.machineData.meta && $scope.machineData.meta.pointInfo && $scope.machineData.meta.pointInfo.deviceMacId) {
          deviceMacId = $scope.machineData.meta.pointInfo.deviceMacId
        }
      } else {
        // For portable machines, try to get from session uploadInfo or machine points
        if (session.uploadInfo && session.uploadInfo.collectorName) {
          deviceMacId = session.uploadInfo.collectorName
        } else if ($scope.machineData.meta && $scope.machineData.meta.points && $scope.machineData.meta.points.length) {
          // Get from first active point
          var activePoint = _.find($scope.machineData.meta.points, { isActive: true })
          if (activePoint && activePoint.deviceMacId) {
            deviceMacId = activePoint.deviceMacId
          }
        }
      }
      
      var params = {
        machineId: $stateParams.machineId,
        sessionId: session.sessionId,
        machineData: JSON.stringify($scope.machineData) 
      }
      if (deviceMacId) {
        params.deviceMacId = deviceMacId
      }
      if ($stateParams.routeId) {
        params.routeId = $stateParams.routeId
        params.routeFilters = $stateParams.routeFilters
        $state.go('calibrationFromRoute', params)
      } else if ($stateParams.compositeId) {
        params.compositeId = $stateParams.compositeId
        params.compositeData = $stateParams.compositeData
        $state.go('calibrationFromComposite', params)
      } else {
        $state.go('calibration', params)
      }
    }

    if ($stateParams.machineId) {
      $scope.getSessions()
    }
  }
})();
(function () {
  'use strict';
  var angular = window.angular
  var _ = window._
  var moment = window.moment
  angular.module('Vibzer.components.machines.trends')
    .controller('MonitoredMachineTrendCtrl', MonitoredMachineTrendCtrl)

  function MonitoredMachineTrendCtrl($scope, $state, $stateParams, $cookies, toastr, CompositeService, RouteService, GraphService, ReportService, UtilService, machineData, constants) {
    $scope.machineData = machineData
    $scope.webAppTexts = constants.webAppTexts
    $scope.dateFormat = constants.dateFormats.default
    $scope.user = $cookies.getObject('vcUser')
    // default severity unit
    $scope.severityUnits = constants.severityUnits
    $scope.selected = {
      severityUnit: $scope.user && $scope.user.setting && $scope.user.setting.reports ? _.find($scope.severityUnits, { internalName: $scope.user.setting.reports.severityUnit }) : $scope.severityUnits[0]
    }

    // dynamic breadcrumbs
    $scope.breadCrumbList = [$scope.webAppTexts.breadcrumbs.machineList, $scope.webAppTexts.breadcrumbs.trends]
    // get route data
    if ($stateParams.routeId) {
      RouteService.resource.getRoute({ _id: $stateParams.routeId }, function (res) {
        $scope.routeData = res
        $scope.breadCrumbList = [$scope.webAppTexts.breadcrumbs.routeList, $scope.routeData.name, $scope.webAppTexts.breadcrumbs.trends]
      })
    }

    // get composite machine data
    if ($stateParams.compositeId) {
      CompositeService.resource.getById({ _id: $stateParams.compositeId }, function (res) {
        $scope.compositeData = res
        if ($scope.machineData.forComposite) {
          $scope.breadCrumbList = [$scope.webAppTexts.breadcrumbs.compositeMachineList, $scope.webAppTexts.breadcrumbs.trends]
        } else {
          $scope.breadCrumbList = [$scope.webAppTexts.breadcrumbs.compositeMachineList, $scope.compositeData.name, $scope.webAppTexts.breadcrumbs.trends]
        }
      })
    }

    function getAvgStdData(stdDev, sessionCount, data) {
      return _.map(new Array($scope.dates.length), function (itm, index) {
        return {
          x: $scope.dates[index],
          y: data,
          pointSize: 0.1
        }
      })
    }

    function getGraphFormatData(array) {
      return _.map(array, function (rms, index) {
        return {
          x: $scope.dates[index],
          y: rms
        }
      })
    }

    function overAllVibration() {
      if ($scope.vibrationApiCalled) {
        return
      }
      $scope.vibrationApiCalled = true
      var params = {
        machineId: machineData._id
      }
      if (!$scope.isNonRotatingMachine) {
        params.pointSet = machineData.meta.points[0].internalName
      }
      var fault = angular.copy(constants.trendGraphs[0])
      var prevPointIndex, prevPoint = {}
      fault.trendChart = angular.copy($scope.trendChart)
      fault.trendChart.options.chart.lines.dispatch = {
        elementClick: function (event) {
          window.d3.selectAll('.nvtooltip').style('opacity', 0)
          if (event.series.key === 'Severity') {
            event.series.selectedPointIndex || event.series.selectedPointIndex === 0 ? event.series.values[event.series.selectedPointIndex].pointSize = 50 : null
            event.point.pointSize = 150
            var selectedFault
            if ($scope.isNonRotatingMachine) {
              selectedFault = _.find($scope.filterValues, {
                name: event.series.fName
              })
            } else {
              selectedFault = _.find($scope.trendFaults, {
                name: event.series.fName
              })
            }
            selectedFault.selectedSeverity = parseFloat(event.point.y.toFixed(2)) ? event.point.y.toFixed(2) : 0
            selectedFault.selectedDate = event.point.x
            event.series.selectedPointIndex = event.pointIndex
            if ((prevPointIndex || prevPointIndex === 0) && prevPoint) {
              d3.selectAll('.nv-group.nv-series-0 path.nv-point.nv-point-' + prevPointIndex).each(function (item) {
                if (item[0].x === prevPoint.x && item[0].y === prevPoint.y && item[0].pointSize === 50) {
                  this.style.setProperty('fill', '#42d7f4')
                }
              })
            }
            d3.selectAll('.nv-group.nv-series-0 path.nv-point.nv-point-' + event.pointIndex).each(function (item) {
              if (item[0].x === event.point.x && item[0].y === event.point.y && item[0].pointSize === 150) {
                this.style.setProperty('fill', 'rgb(0, 44, 189)')
                prevPointIndex = event.series.selectedPointIndex
                prevPoint = item[0]
              }
            })
          }
          $scope.$apply()
        },
        elementMouseover: function (d) {
          if (d.seriesIndex === 1 || d.seriesIndex === 2) {
            d3.selectAll('.nvtooltip').each(function () {
              this.style.setProperty('display', 'none', 'important')
            })
          } else {
            d3.selectAll('.nvtooltip').each(function () {
              this.style.setProperty('display', 'block', 'important')
            })
          }
        }
      }
      ReportService.resource.getOverallVibrationData(params, function (resp) {
        resp.result = [resp.result]
        if (resp.result.length === 0) {
          fault.trendChart.data = []
        }
        _.each(resp.result, function (item) {
          var res = item
          if (!res.date || (res.date && !res.date.length)) {
            fault.trendChart.data = []
            return
          }
          // convert values according to severity unit
          fault.warning = res.warning ? ($scope.selected.severityUnit.internalName === $scope.severityUnits[1].internalName ? UtilService.convertMMToInch(res.warning, 2) : res.warning.toFixed(2)) : 0
          fault.trip = res.alert ? ($scope.selected.severityUnit.internalName === $scope.severityUnits[1].internalName ? UtilService.convertMMToInch(res.alert, 2) : res.alert.toFixed(2)) : 0
          var severityInMM = _.map(res.severity, function(value) {
            return parseFloat(value.toFixed(2))
          })
          fault.severity = res.severity && res.severity.length ? ($scope.selected.severityUnit.internalName === $scope.severityUnits[1].internalName ? UtilService.convertMMToInch(res.severity, 2) : severityInMM) : []
          var allData = []
          allData = allData.concat(fault.severity)
          allData.push(parseFloat(fault.warning))
          allData.push(parseFloat(fault.trip))
          allData = _.sortBy(allData)
          var sum = allData.reduce(function (a, b) {
            return a + b
          }, 0)
          res.severity.length > 20 ? fault.trendChart.options.chart.zoom.scaleExtent[1] = res.severity.length : null

          var diff = moment(res.date[res.date.length - 1]).diff(res.date[0]) / 10
          $scope.tickValues = []
          _.times(res.date.length, function (index) {
            if (index === 0) {
              $scope.tickValues.push(res.date[0])
            } else {
              $scope.tickValues.push($scope.tickValues[index - 1] + diff)
            }
          })

          $scope.dates = res.date
          fault.trendChart.options.chart.forceX = [(res.date[0] - moment(res.date[1]).diff(res.date[0])), (res.date[res.date.length - 1] + moment(res.date[1]).diff(res.date[0]))]
          var YAvg = (sum / allData.length)
          fault.trendChart.options.chart.forceY = [0 - YAvg, allData[allData.length - 1] + YAvg]
          var allAxisData = [{
            values: getGraphFormatData(fault.severity),
            key: 'Severity',
            color: '#42d7f4',
            fName: fault.name
          },
          {
            values: getAvgStdData(1, 1, fault.warning),
            key: 'Warning',
            color: '#FFA500',
            fName: fault.name
          },
          {
            values: getAvgStdData(2, 1, fault.trip),
            key: 'Trip',
            color: '#cc3300',
            fName: fault.name
          }
          ]
          fault.trendChart.data = allAxisData
        })
        if ($scope.isNonRotatingMachine) {
          $scope.filterValues = [angular.copy(fault)]
        } else {
          $scope.trendFaults.unshift(fault)
        }
        crestFactor()
      }, function (err) {
        toastr.error(err.data.msg)
      })
    }

    function crestFactor() {
      // if ($scope.vibrationApiCalled) {
      //   return
      // }
      // $scope.vibrationApiCalled = true
      var params = {
        machineId: machineData._id
      }
      if (!$scope.isNonRotatingMachine) {
        params.pointSet = machineData.meta.points[0].internalName
      }
      var fault = angular.copy(constants.trendGraphs[1])
      var prevPointIndex, prevPoint = {}
      fault.trendChart = angular.copy($scope.trendChart)
      fault.trendChart.options.chart.lines.dispatch = {
        elementClick: function (event) {
          window.d3.selectAll('.nvtooltip').style('opacity', 0)
          if (event.series.key === 'Severity') {
            event.series.selectedPointIndex || event.series.selectedPointIndex === 0 ? event.series.values[event.series.selectedPointIndex].pointSize = 50 : null
            event.point.pointSize = 150
            var selectedFault
            if ($scope.isNonRotatingMachine) {
              selectedFault = _.find($scope.filterValues, {
                name: event.series.fName
              })
            } else {
              selectedFault = _.find($scope.trendFaults, {
                name: event.series.fName
              })
            }
            selectedFault.selectedSeverity = parseFloat(event.point.y.toFixed(2)) ? event.point.y.toFixed(2) : 0
            selectedFault.selectedDate = event.point.x
            event.series.selectedPointIndex = event.pointIndex
            if ((prevPointIndex || prevPointIndex === 0) && prevPoint) {
              d3.selectAll('.nv-group.nv-series-0 path.nv-point.nv-point-' + prevPointIndex).each(function (item) {
                if (item[0].x === prevPoint.x && item[0].y === prevPoint.y && item[0].pointSize === 50) {
                  this.style.setProperty('fill', '#42d7f4')
                }
              })
            }
            d3.selectAll('.nv-group.nv-series-0 path.nv-point.nv-point-' + event.pointIndex).each(function (item) {
              if (item[0].x === event.point.x && item[0].y === event.point.y && item[0].pointSize === 150) {
                this.style.setProperty('fill', 'rgb(0, 44, 189)')
                prevPointIndex = event.series.selectedPointIndex
                prevPoint = item[0]
              }
            })
          }
          $scope.$apply()
        },
        elementMouseover: function (d) {
          if (d.seriesIndex === 1 || d.seriesIndex === 2) {
            d3.selectAll('.nvtooltip').each(function () {
              this.style.setProperty('display', 'none', 'important')
            })
          } else {
            d3.selectAll('.nvtooltip').each(function () {
              this.style.setProperty('display', 'block', 'important')
            })
          }
        }
      }
      ReportService.resource.getCrestFactorData(params, function (resp) {
        resp.result = [resp.result]
        if (resp.result.length === 0) {
          fault.trendChart.data = []
        }
        _.each(resp.result, function (item) {
          var res = item
          if (!res.date || (res.date && !res.date.length)) {
            fault.trendChart.data = []
            return
          }
          // convert values according to severity unit
          fault.warning = res.warning ? ($scope.selected.severityUnit.internalName === $scope.severityUnits[1].internalName ? UtilService.convertMMToInch(res.warning, 2) : res.warning.toFixed(2)) : 0
          fault.trip = res.alert ? ($scope.selected.severityUnit.internalName === $scope.severityUnits[1].internalName ? UtilService.convertMMToInch(res.alert, 2) : res.alert.toFixed(2)) : 0
          var severityInMM = _.map(res.severity, function(value) {
            return parseFloat(value.toFixed(2))
          })
          fault.severity = res.severity && res.severity.length ? ($scope.selected.severityUnit.internalName === $scope.severityUnits[1].internalName ? UtilService.convertMMToInch(res.severity, 2) : severityInMM) : []
          var allData = []
          allData = allData.concat(fault.severity)
          allData.push(parseFloat(fault.warning))
          allData.push(parseFloat(fault.trip))
          allData = _.sortBy(allData)
          var sum = allData.reduce(function (a, b) {
            return a + b
          }, 0)
          res.severity.length > 20 ? fault.trendChart.options.chart.zoom.scaleExtent[1] = res.severity.length : null

          var diff = moment(res.date[res.date.length - 1]).diff(res.date[0]) / 10
          $scope.tickValues = []
          _.times(res.date.length, function (index) {
            if (index === 0) {
              $scope.tickValues.push(res.date[0])
            } else {
              $scope.tickValues.push($scope.tickValues[index - 1] + diff)
            }
          })

          $scope.dates = res.date
          fault.trendChart.options.chart.forceX = [(res.date[0] - moment(res.date[1]).diff(res.date[0])), (res.date[res.date.length - 1] + moment(res.date[1]).diff(res.date[0]))]
          var YAvg = (sum / allData.length)
          fault.trendChart.options.chart.forceY = [0 - YAvg, allData[allData.length - 1] + YAvg]
          var allAxisData = [{
            values: getGraphFormatData(fault.severity),
            key: 'Severity',
            color: '#42d7f4',
            fName: fault.name
          },
          {
            values: getAvgStdData(1, 1, fault.warning),
            key: 'Warning',
            color: '#FFA500',
            fName: fault.name
          },
          {
            values: getAvgStdData(2, 1, fault.alert),
            key: 'Trip',
            color: '#cc3300',
            fName: fault.name
          }
          ]
          fault.trendChart.data = allAxisData
        })
        if ($scope.isNonRotatingMachine) {
          $scope.filterValues.push(angular.copy(fault))
        } else {
          $scope.trendFaults.splice(1, 0, fault)
        }
      }, function (err) {
        toastr.error(err.data.msg)
      })
    }

    if (machineData.machineTypeId && machineData.machineTypeId.name === 'machine') {
      $scope.isNonRotatingMachine = true
      $scope.isMonMachine = true
      $scope.icon = _.find(constants.typesOfMachine, {
        name: machineData.machineTypeId.name
      }).icon
      $scope = GraphService.graphInitialization($scope, ['lineChart'])
      $scope.trendChart = angular.copy($scope.lineChart)
      $scope.trendChart.options.chart = _.assign(_.omit($scope.trendChart.options.chart, 'forceY'), {
        useInteractiveGuideline: false,
        lines: {},
        useVoronoi: true,
        height: 320,
        margin: {
          top: 10,
          right: 20,
          bottom: 80,
          left: 90
        },
        xAxis: {
          showMaxMin: false,
          axisLabel: 'Time',
          ticks: 10,
          tickFormat: function (d) {
            // return d >= 0 && d % 1 === 0 && $scope.dates[Math.round(d)] ? window.d3.time.format('%d %b %y %I:%M %p')(new Date($scope.dates[Math.round(d)])) : ''
            return window.d3.time.format('%d %b %y %I:%M %p')(new Date(d))
          },
          axisLabelDistance: -10
        },
        forceY: [0],
        showXAxis: true,
        yAxis: {
          ticks: 5,
          showMaxMin: false,
          axisLabel: 'Severity [' + $scope.selected.severityUnit.displayName + ' RMS]'
        },
        legend: {
          rightAlign: false
        },
        pointSize: function (d) {
          return d.pointSize || 50
        },
        showLegend: false,
        tooltips: true,
        zoom: {
          enabled: false,
          scaleExtent: [1, 20],
          useFixedDomain: false,
          useNiceScale: true,
          horizontalOff: false,
          verticalOff: true,
          unzoomEventType: 'dblclick.zoom'
        }
      })
      overAllVibration()
      // ReportService.resource.getOverallVibrationData(params, function (resp) {
      // }, function (err) {
      //   toastr.error(err.data.msg)
      // })
      // ReportService.resource.getCrestFactorData(params, function (resp) {
      // }, function (err) {
      //   toastr.error(err.data.msg)
      // })
    } else {
      $scope.isMonMachine = machineData.type === constants.typesOfMachine[4].name
      $scope.icon = _.find(constants.typesOfMachine, {
        name: machineData.machineTypeId.name
      }).icon
      $scope = GraphService.graphInitialization($scope, ['lineChart'])
      $scope.trendChart = angular.copy($scope.lineChart)
      $scope.trendFaults = angular.copy(constants.trendWithFaults)

      $scope.getOrClearCustomSessions = function (type, limit) {
        if (type === 'clear') {
          $scope.sessionLimit = null
        }
        if (!$scope.sessionLimit && type === 'get') {
          return
        } else {
          $scope.initTrend()
        }
      }
      $scope.trendChart.options.chart = _.assign(_.omit($scope.trendChart.options.chart, 'forceY'), {
        useInteractiveGuideline: false,
        lines: {},
        useVoronoi: true,
        height: 320,
        margin: {
          top: 10,
          right: 20,
          bottom: 80,
          left: 90
        },
        xAxis: {
          showMaxMin: false,
          axisLabel: 'Time',
          ticks: 10,
          tickFormat: function (d) {
            // return d >= 0 && d % 1 === 0 && $scope.dates[Math.round(d)] ? window.d3.time.format('%d %b %y %I:%M %p')(new Date($scope.dates[Math.round(d)])) : ''
            return window.d3.time.format('%d %b %y %I:%M %p')(new Date(d))
          },
          axisLabelDistance: -10
        },
        forceY: [0],
        showXAxis: true,
        yAxis: {
          ticks: 5,
          showMaxMin: false,
          axisLabel: 'Severity [' + $scope.selected.severityUnit.displayName + ' RMS]'
        },
        legend: {
          rightAlign: false
        },
        pointSize: function (d) {
          return d.pointSize || 50
        },
        showLegend: false,
        tooltips: true,
        zoom: {
          enabled: false,
          scaleExtent: [1, 20],
          useFixedDomain: false,
          useNiceScale: true,
          horizontalOff: false,
          verticalOff: true,
          unzoomEventType: 'dblclick.zoom'
        }
      })
      $scope.$on('scroll', function () {
        window.d3.selectAll('.nvtooltip').remove()
      })

      // function getGraphFormatData(array) {
      //   return _.map(array, function (rms, index) {
      //     return {
      //       x: $scope.dates[index],
      //       y: rms
      //     }
      //   })
      // }

      // function getAvgStdData(stdDev, sessionCount, data) {
      //   return _.map(new Array($scope.dates.length), function (itm, index) {
      //     return {
      //       x: $scope.dates[index],
      //       y: data.average + (stdDev * data.std),
      //       pointSize: 0.1
      //     }
      //   })
      // }

      $scope.getRMSTrendForFrequency = function (fault) {
        var prevPointIndex, prevPoint = {}
        fault.trendChart = angular.copy($scope.trendChart)
        fault.trendChart.options.chart.lines.dispatch = {
          elementClick: function (event) {
            window.d3.selectAll('.nvtooltip').style('opacity', 0)
            if (event.series.key === 'Severity') {
              event.series.selectedPointIndex || event.series.selectedPointIndex === 0 ? event.series.values[event.series.selectedPointIndex].pointSize = 50 : null
              event.point.pointSize = 150
              var selectedFault = _.find($scope.trendFaults, {
                name: event.series.fName
              })
              selectedFault.selectedSeverity = parseFloat(event.point.y.toFixed(2)) ? event.point.y.toFixed(2) : 0
              selectedFault.selectedDate = event.point.x
              event.series.selectedPointIndex = event.pointIndex
              if ((prevPointIndex || prevPointIndex === 0) && prevPoint) {
                d3.selectAll('.nv-group.nv-series-0 path.nv-point.nv-point-' + prevPointIndex).each(function (item) {
                  if (item[0].x === prevPoint.x && item[0].y === prevPoint.y && item[0].pointSize === 50) {
                    this.style.setProperty('fill', '#42d7f4')
                  }
                })
              }
              d3.selectAll('.nv-group.nv-series-0 path.nv-point.nv-point-' + event.pointIndex).each(function (item) {
                if (item[0].x === event.point.x && item[0].y === event.point.y && item[0].pointSize === 150) {
                  this.style.setProperty('fill', 'rgb(0, 44, 189)')
                  prevPointIndex = event.series.selectedPointIndex
                  prevPoint = item[0]
                }
              })
            }
            $scope.$apply()
          },
          elementMouseover: function (d) {
            if (d.seriesIndex === 1 || d.seriesIndex === 2) {
              d3.selectAll('.nvtooltip').each(function () {
                this.style.setProperty('display', 'none', 'important')
              })
            } else {
              d3.selectAll('.nvtooltip').each(function () {
                this.style.setProperty('display', 'block', 'important')
              })
            }
          }
        }
        var params = {
          machineId: machineData._id,
          faultName: fault.internalName,
          pointSet: machineData.meta.points[0].internalName
        }
        // if ($scope.sessionLimit) {
        //   params.limit = $scope.sessionLimit
        //   params.ignoreEarlier = $scope.ignoreEarlier
        // } else {
        //   $scope.ignoreEarlier = false
        // }

        ReportService.resource.getFaultSpecificTrendData(params, function (resp) {
          if (resp.result.length === 0) {
            fault.trendChart.data = []
          }
          _.each(resp.result, function (item) {
            var res = item
            if (!res.date || (res.date && !res.date.length)) {
              fault.trendChart.data = []
              return
            }
            // convert values according to severity unit
            fault.warning = res.warning ? ($scope.selected.severityUnit.internalName === $scope.severityUnits[1].internalName ? UtilService.convertMMToInch(res.warning, 2) : res.warning.toFixed(2)) : 0
            fault.trip = res.alert ? ($scope.selected.severityUnit.internalName === $scope.severityUnits[1].internalName ? UtilService.convertMMToInch(res.alert, 2) : res.alert.toFixed(2)) : 0
            var severityInMM = _.map(res.severity, function(value) {
              return parseFloat(value.toFixed(2))
            })
            fault.severity = res.severity && res.severity.length ? ($scope.selected.severityUnit.internalName === $scope.severityUnits[1].internalName ? UtilService.convertMMToInch(res.severity, 2) : severityInMM) : []
            var allData = []
            allData = allData.concat(fault.severity)
            allData.push(parseFloat(fault.warning))
            allData.push(parseFloat(fault.trip))
            allData = _.sortBy(allData)
            var sum = allData.reduce(function (a, b) {
              return a + b
            }, 0)
            res.severity.length > 20 ? fault.trendChart.options.chart.zoom.scaleExtent[1] = res.severity.length : null

            var diff = moment(res.date[res.date.length - 1]).diff(res.date[0]) / 10
            $scope.tickValues = []
            _.times(res.date.length, function (index) {
              if (index === 0) {
                $scope.tickValues.push(res.date[0])
              } else {
                $scope.tickValues.push($scope.tickValues[index - 1] + diff)
              }
            })

            $scope.dates = res.date
            fault.trendChart.options.chart.forceX = [(res.date[0] - moment(res.date[1]).diff(res.date[0])), (res.date[res.date.length - 1] + moment(res.date[1]).diff(res.date[0]))]
            var YAvg = (sum / allData.length)
            fault.trendChart.options.chart.forceY = [0 - YAvg, allData[allData.length - 1] + YAvg]
            var allAxisData = [{
              values: getGraphFormatData(fault.severity),
              key: 'Severity',
              color: '#42d7f4',
              fName: fault.name
            },
            {
              values: getAvgStdData(1, 1, fault.warning),
              key: 'Warning',
              color: '#FFA500',
              fName: fault.name
            },
            {
              values: getAvgStdData(2, 1, fault.alert),
              key: 'Trip',
              color: '#cc3300',
              fName: fault.name
            }
            ]
            fault.trendChart.data = allAxisData
          })
          overAllVibration()
        }, function (err) {
          toastr.error(err.data.msg)
        })
      }

      $scope.filterValues = angular.copy(constants.trendByFaultsForMonitoring)

      function getFaultValuesForMonitoringPoint(filter) {
        var params = {
          machineId: machineData._id,
          created: new Date(),
          monitoringPointName: machineData.dataCollectors[machineData.dataCollectors.length - 1].monitoringPointName,
          dataCollectorId: machineData.dataCollectors[machineData.dataCollectors.length - 1]._id
        }
        $scope.sessionLimit ? params.limit = $scope.sessionLimit : null
        filter.trendChart = angular.copy($scope.trendChart)
        MachineVibrationService.resource.getMonitoringReportGraph(params, function (res) {
          filter.isFilterActive = true
          $scope.type = filter.internalName
          $scope.trendChart.options.chart.yAxis.axisLabel = filter.yLabel
          generateGraph(filter, createStdAvgChartData(filter.internalName, res))
        })
      }

      $scope.ignoreChange = function () {
        $scope.initTrend()
      }

      function createStdAvgChartData(type, data) {
        if (type === 'severity') {
          var maxAvg = _.max([data.avgAndStdData.avgSeverity.x, data.avgAndStdData.avgSeverity.y, data.avgAndStdData.avgSeverity.z])
          var maxStd = _.max([data.avgAndStdData.stdDeviationSeverity.x, data.avgAndStdData.stdDeviationSeverity.y, data.avgAndStdData.stdDeviationSeverity.z])
        } else {
          maxAvg = _.max([data.avgAndStdData.avgCrestFactor.x, data.avgAndStdData.avgCrestFactor.y, data.avgAndStdData.avgCrestFactor.z])
          maxStd = _.max([data.avgAndStdData.stdDeviationCrestFactor.x, data.avgAndStdData.stdDeviationCrestFactor.y, data.avgAndStdData.stdDeviationCrestFactor.z])
        }
        var baseLine = _.max([data.reportData[type + 'X'][0].value, data.reportData[type + 'Y'][0].value, data.reportData[type + 'Z'][0].value])
        $scope.baseLineValue = baseLine
        $scope.maxWithOneSD = (maxAvg + maxStd)
        var date = []
        var severityValues = []
        _.times(data.reportData[type + 'X'].length, function (index) {
          date.push(new Date(data.reportData[type + 'X'][index].date).getTime())
          severityValues.push(_.max([data.reportData[type + 'X'][index].value, data.reportData[type + 'Y'][index].value, data.reportData[type + 'Z'][index].value]))
        })
        if (type === 'severity') {
          return {
            date: date,
            severity: severityValues,
            average: maxAvg,
            std: maxStd
          }
        } else {
          return {
            date: date,
            crestFactor: severityValues,
            average: maxAvg,
            std: maxStd
          }
        }
      }

      $scope.graphData = {}

      function generateGraph(filter, data) {
        var prevPointIndex, prevPoint = {}
        filter.trendChart.options.chart.lines.dispatch = {
          elementClick: function (event) {
            if (event.series.key === 'Severity' || event.series.key === 'Crest Factor') {
              event.series.selectedPointIndex || event.series.selectedPointIndex === 0 ? event.series.values[event.series.selectedPointIndex].pointSize = 50 : null
              event.point.pointSize = 150
              var selectedFault = _.find($scope.filterValues, {
                displayName: event.series.key
              })
              selectedFault.selectedSeverity = parseFloat(event.point.y.toFixed(2)) ? event.point.y.toFixed(2) : 0
              selectedFault.selectedDate = event.point.x
              event.series.selectedPointIndex = event.pointIndex
            }
            window.d3.selectAll('.nvtooltip').style('opacity', 0)
            if ((prevPointIndex || prevPointIndex === 0) && prevPoint) {
              d3.selectAll('.nv-group.nv-series-0 path.nv-point.nv-point-' + prevPointIndex).each(function (item) {
                if (item[0].x === prevPoint.x && item[0].y === prevPoint.y && item[0].pointSize === 50) {
                  this.style.setProperty('fill', '#42d7f4')
                }
              })
            }
            d3.selectAll('.nv-group.nv-series-0 path.nv-point.nv-point-' + event.pointIndex).each(function (item) {
              if (item[0].x === event.point.x && item[0].y === event.point.y && item[0].pointSize === 150) {
                this.style.setProperty('fill', 'rgb(0, 44, 189)')
                prevPointIndex = event.series.selectedPointIndex
                prevPoint = item[0]
              }
            })
          },
          elementMouseover: function (d) {
            if (d.seriesIndex === 1 || d.seriesIndex === 2) {
              d3.selectAll('.nvtooltip').each(function () {
                this.style.setProperty('display', 'none', 'important')
              })
            } else {
              d3.selectAll('.nvtooltip').each(function () {
                this.style.setProperty('display', 'block', 'important')
              })
            }
          }
        }
        $scope = GraphService.graphInitialization($scope, ['lineChart'])
        var allData = []
        filter.warning = parseFloat((data.average + data.std).toFixed(2)) ?($scope.selected.severityUnit.internalName === $scope.severityUnits[1].internalName ? UtilService.convertMMToInch((data.average + data.std), 2) : (data.average + data.std).toFixed(2))  : 0
        filter.trip = parseFloat((data.average +  (2 * data.std)).toFixed(2)) ?($scope.selected.severityUnit.internalName === $scope.severityUnits[1].internalName ? UtilService.convertMMToInch((data.average +  (2 * data.std)), 2) : (data.average +  (2 * data.std)).toFixed(2))  : 0
        var severityInMM = _.map(data[$scope.type], function(value) {
          return parseFloat(value.toFixed(2))
        })
        fault.severity = data[$scope.type] && data[$scope.type].length ? ($scope.selected.severityUnit.internalName === $scope.severityUnits[1].internalName ? UtilService.convertMMToInch(data[$scope.type], 2) : severityInMM) : []
        var allData = []
        allData = allData.concat(data[$scope.type])
        allData.push(parseFloat(filter.warning))
        allData.push(parseFloat(filter.trip))
        allData = _.sortBy(allData)
        var sum = allData.reduce(function (a, b) {
          return a + b
        }, 0)
        data[$scope.type].length > 20 ? filter.trendChart.options.chart.zoom.scaleExtent[1] = data[$scope.type].length : null

        var diff = moment(data.date[data.date.length - 1]).diff(data.date[0]) / 10
        $scope.tickValues = []
        _.times(data.date.length, function (index) {
          if (index === 0) {
            $scope.tickValues.push(data.date[0])
          } else {
            $scope.tickValues.push($scope.tickValues[index - 1] + diff)
          }
        })
        $scope.dates = data.date
        filter.trendChart.options.chart.forceX = [(data.date[0] - moment(data.date[1]).diff(data.date[0])), (data.date[data.date.length - 1] + moment(data.date[1]).diff(data.date[0]))]
        var YAvg = (sum / allData.length)
        filter.trendChart.options.chart.forceY = [0 - YAvg, allData[allData.length - 1] + YAvg]
        var allAxisData = [{
          values: getGraphFormatData(data[$scope.type]),
          key: filter.displayName,
          color: '#42d7f4'
        },
        {
          values: getAvgStdData(1, 1, data),
          key: 'Warning',
          color: '#FFA500'
        },
        {
          values: getAvgStdData(2, 1, data),
          key: 'Trip',
          color: '#cc3300'
        }
        ]
        filter.trendChart.data = allAxisData
      }

      $scope.viewReport = function () {
        var modalInstance = $uibModal.open({
          templateUrl: 'angular-app/views/dialog.compareReport.html',
          backdrop: true,
          controller: 'DialogCompareReportController',
          resolve: {
            reportData: _.assign({
              _id: machineData._id,
              isLatest: true,
              type: machineData.type,
              name: 'Report',
              dataCollectors: machineData.dataCollectors,
              created: new Date()
            })
          },
          size: 'lg'
        })
        modalInstance.result.then(function (data) { }, function () { })
      }

      $scope.initTrend = function () {
        if (machineData && machineData._id && machineData.type === constants.typesOfMachine[4].name) {
          _.forEach($scope.filterValues, function (item, index) {
            getFaultValuesForMonitoringPoint(item)
          })
        } else {
          _.forEach($scope.trendFaults, function (fault) {
            $scope.getRMSTrendForFrequency(fault)
          })
        }
      }
      $scope.initTrend()

      // var queryParams = {
      //   machineId: machineData._id,
      //   pointSet: machineData.meta.points[0].internalName,
      //   limit: 10
      // }
      // ReportService.resource.getFaultSpecificDetails(queryParams, function (res) {
      //   console.log(res)
      // }, function (err) {
      //   console.log(err)
      // })

      /* Redirects to machines page. */
      $scope.breadCrumbClickHandler = function (itm) {
        if ($stateParams.compositeId && $scope.machineData.forComposite) {
          $state.go('compositeMachines', { compositeData: $stateParams.compositeData })
        } else if ($stateParams.routeId && itm === $scope.webAppTexts.breadcrumbs.routeList) {
          $state.go('routes', { routeFilters: $stateParams.routeFilters })
        } else if ($stateParams.routeId && itm === $scope.routeData.name) {
          $state.go('routeMachines', { routeId: $stateParams.routeId, machineData: $stateParams.machineData, routeFilters: $stateParams.routeFilters })
        } else if ($stateParams.compositeId && itm === $scope.webAppTexts.breadcrumbs.compositeMachineList) {
          $state.go('compositeMachines', { compositeData: $stateParams.compositeData })
        } else if ($stateParams.compositeId && itm === $scope.compositeData.name) {
          $state.go('machinesFromComposite', { compositeId: $stateParams.compositeId, machineData: $stateParams.machineData, compositeData: $stateParams.compositeData })
        } else {
          $state.go('machines', { machineData: $stateParams.machineData })
        }
      }
    }
  }
})();
(function () {
    'use strict';
    angular.module('Vibzer.components.manage.settings', [])
        .controller('SettingsCtrl', SettingsCtrl);
    function SettingsCtrl($scope, $state, $uibModal, toastr) {
        $scope.editStructure = false
        $scope.addNode = false
        $scope.customer = {
            id: 1,
            name: 'Raykor',
            distributorName: 'Global Distributors',
            description: 'Test customer',
            taxes: [{
                id: 1,
                type: 'GST',
                value: '12345'
            }],
            address: {
                country: 'India',
                state: 'Maharashtra',
                city: 'Pune',
                street: 'MG Road',
                zipcode: '415423'
            },
            allEmailIds: ['test@test.com'],
            allPhoneNums: ['+912345673425']
        }

        $scope.allEmailIds = $scope.customer.allEmailIds
        $scope.allPhoneNums = $scope.customer.allPhoneNums

        $scope.pushEmail = function () {
            $scope.emailAlreadyAdded = false
            if ($scope.emailId && _.indexOf($scope.allEmailIds, $scope.emailId) < 0) {
                $scope.allEmailIds.push($scope.emailId)
                $scope.emailId = ''
            } else if (_.indexOf($scope.allEmailIds, $scope.emailId) != -1) {
                $scope.emailAlreadyAdded = true
            }
        }

        $scope.removeSelectedEmail = function (emailId) {
            _.pull($scope.allEmailIds, emailId)
        }

        $scope.pushPhone = function () {
            $scope.phoneAlreadyAdded = false
            if ($scope.phone && _.indexOf($scope.allPhoneNums, $scope.emailId) < 0) {
                $scope.allPhoneNums.push($scope.phone)
                $scope.phone = ''
            } else if (_.indexOf($scope.allPhoneNums, $scope.phone) != -1) {
                $scope.phoneAlreadyAdded = true
            }
        }

        $scope.removeSelectedPhone = function (phone) {
            _.pull($scope.allPhoneNums, phone)
        }

        //Hierarchy structure
        //JSTree configuration
        $scope.basicConfig = {
            'core': {
                'multiple': false,
                'check_callback': true,
                'worker': true
            },
            'types': {
                'level': {
                    'icon': 'fa fa-square-o'
                },
                'default': {
                    'icon': 'fa fa-square-o'
                }
            },
            'contextmenu': {
                'items': {
                    'Rename': {
                        'label': 'Rename',
                        "action": function (data) {
                            $scope.renameLevel(data)
                        }
                    }
                }
            },
            'plugins': ['types', 'contextmenu'],
            'version': 1
        };

        $scope.treeData = getDefaultData()
        function getDefaultData() {
            return [
                {
                    "id": "level1",
                    "parent": "#",
                    "type": "level",
                    "text": "Plant",
                    "state": {
                        "opened": true
                    }
                },
                {
                    "id": "level2",
                    "parent": "level1",
                    "text": "Area",
                    "state": {
                        "opened": true
                    }
                },
                {
                    "id": "level3",
                    "parent": "level2",
                    "text": "Section",
                    "state": {
                        "opened": true
                    }
                }
            ]
        }

        $scope.renameLevel = function (data) {
            var treeInstance = $.jstree.reference(data.reference)
            var treeNode = treeInstance.get_node(data.reference)
            treeInstance.edit(treeNode, null, function (node, status) {
                $scope.treeData = _.filter($scope.treeData, function (node) {
                    if (node.id == treeNode.original.id)
                        node.text = treeNode.text
                    $scope.basicConfig.version++;
                    return node
                })
            })
        }

        $scope.addTax = function () {
            var modalInstance = $uibModal.open({
                templateUrl: 'app/components/manage/settings/Modals/addTax.html',
                controller: 'AddTaxCtrl',
                backdrop: false,
                resolve: {
                    data: {}
                }
            });

            modalInstance.result.then(function (tax) {
                if (tax && $scope.customer.taxes && $scope.customer.taxes.length) {
                    tax.id = parseInt($scope.customer.taxes[$scope.customer.taxes.length - 1].id) + 1
                } else {
                    tax.id = 1
                }
                $scope.customer.taxes.push(tax)
            })
        }

        $scope.editTax = function (tax) {
            var modalInstance = $uibModal.open({
                templateUrl: 'app/components/manage/settings/Modals/addTax.html',
                controller: 'AddTaxCtrl',
                backdrop: false,
                resolve: {
                    data: tax
                }
            });

            modalInstance.result.then(function (tax) {
                if ($scope.customer && $scope.customer.taxes) {
                    $scope.customer.taxes = _.map($scope.customer.taxes, function (taxItm) {
                        if (tax && tax.id && tax.id === taxItm.id) {
                            taxItm = tax
                        }
                        return taxItm
                    })
                }
            })
        }

        $scope.removeTax = function (tax) {
            $scope.customer.taxes = _.pull($scope.customer.taxes, tax)
        }

        $scope.saveButtonVisbility = function () {
            return !($scope.customer.address.country && $scope.customer.address.state && $scope.customer.address.city && $scope.customer.address.zipcode && $scope.allEmailIds.length != 0 && $scope.allPhoneNums.length != 0)
        }

        $scope.saveSettings = function () {
            toastr.success('Settings has been saved successfully!');
            $state.go('dashboard')
        }
    }
})();
(function () {
  'use strict';
  var angular = window.angular
  var _ = window._
  angular.module('Vibzer.components.machines.alerts', [])
    .controller('MachineAlertsCtrl', MachineAlertsCtrl)

  function MachineAlertsCtrl($scope, $state, $stateParams, $location, toastr, EventLogService, RouteService, CompositeService, machineData, constants) {
    $scope.machineData = machineData
    $scope.webAppTexts = constants.webAppTexts
    $scope.isMonMachine = machineData.machineTypeId.name === 'machine'
    $scope.icon = _.find(constants.typesOfMachine, {
      name: $scope.machineData.machineTypeId.name
    }).icon
    $scope.dateFormat = constants.dateFormats.default
    $scope.limit = 10
    $scope.uibPage = {
      currentPage: $stateParams.currentPage || 1
    }

    // dynamic breadcrumbs
    $scope.breadCrumbList = [$scope.webAppTexts.breadcrumbs.machineList, $scope.webAppTexts.breadcrumbs.alerts]
    // get route data
    if ($stateParams.routeId) {
      RouteService.resource.getRoute({ _id: $stateParams.routeId }, function (res) {
        $scope.routeData = res
        $scope.breadCrumbList = [$scope.webAppTexts.breadcrumbs.routeList, $scope.routeData.name, $scope.webAppTexts.breadcrumbs.alerts]
      })
    }

    // get composite machine data
    if ($stateParams.compositeId) {
      CompositeService.resource.getById({ _id: $stateParams.compositeId }, function (res) {
        $scope.compositeData = res
        $scope.breadCrumbList = [$scope.webAppTexts.breadcrumbs.compositeMachineList, $scope.compositeData.name, $scope.webAppTexts.breadcrumbs.alerts]
      })
    }

    $scope.pageChanged = function (currentPage) {
      $location.search('currentPage', $scope.uibPage.currentPage)
      $scope.getAllMachinesAlert()
    }

    $scope.getAllMachinesAlert = function (refresh) {
      if (refresh) {
        $scope.uibPage.currentPage = 1
      }
      $scope.busy = true
      var params = {
        machineId: $stateParams.machineId,
        limit: $scope.limit
      }
      params.page = $scope.uibPage.currentPage || 1

      EventLogService.resource.getAllMachinesAlerts(params, function (res) {
        $scope.totalItems = res.totalCount
        $scope.alerts = res.data
        $scope.busy = false
        if (refresh) {
          toastr.info(constants.toastrMessages.success.refreshEventLogList)
        }
      }, function (err) {
        console.log(err)
        $scope.busy = false
      })
    }
    $scope.getAllMachinesAlert()

    $scope.breadCrumbClickHandler = function (itm) {
      if ($stateParams.routeId && itm === $scope.webAppTexts.breadcrumbs.routeList) {
        $state.go('routes', { routeFilters: $stateParams.routeFilters })
      } else if ($stateParams.routeId && itm === $scope.routeData.name) {
        $state.go('routeMachines', { routeId: $stateParams.routeId, machineData: $stateParams.machineData, routeFilters: $stateParams.routeFilters })
      } else if ($stateParams.compositeId && itm === $scope.webAppTexts.breadcrumbs.compositeMachineList) {
        $state.go('compositeMachines', { compositeData: $stateParams.compositeData })
      } else if ($stateParams.compositeId && itm === $scope.compositeData.name) {
        $state.go('machinesFromComposite', { compositeId: $stateParams.compositeId, machineData: $stateParams.machineData, compositeData: $stateParams.compositeData })
      } else {
        $state.go('machines', { machineData: $stateParams.machineData })
      }
    }

    $scope.goBack = function () {
      if ($stateParams.routeId) {
        $state.go('routeMachines', { routeId: $stateParams.routeId, machineData: $stateParams.machineData, routeFilters: $stateParams.routeFilters })
      } else if ($stateParams.compositeId) {
        $state.go('machinesFromComposite', { compositeId: $stateParams.compositeId, machineData: $stateParams.machineData, compositeData: $stateParams.compositeData })
      } else {
        $state.go('machines', { machineData: $stateParams.machineData })
      }
    }
  }
})();
(function () {
  'use strict'
  var angular = window.angular
  angular.module('Vibzer.theme.components')
    .controller('ChangePasswordDialogCtrl', ChangePasswordDialogCtrl);
  /*
  Change password dialog control
  */
  // @NgInject
  function ChangePasswordDialogCtrl ($scope, $uibModalInstance, $cookies, $state, toastr, UserService, constants, vcRecaptchaService) {
    $scope.showUniqePassword = false
    $scope.user = {}
    $scope.user.username = $cookies.getObject('vcUser') ? $cookies.getObject('vcUser').username : null
    $scope = UserService.recaptchaInit($scope)
    $scope.changePassword = function () {
      if ($scope.user.newPassword !== $scope.user.repeatPassword) {
        $scope.showUniqePassword = true
      } else {
        $scope.user.response = $scope.response
        UserService.resource.changePassword($scope.user, function (res) {
          toastr.success(constants.toastrMessages.success.changePassword)
          $scope.closeModal()
          $scope.notify = true
          UserService.logout()
          $state.go('login')
        }, function (err) {
          toastr.error(err.data.msg)
          vcRecaptchaService.reload($scope.widgetId)
        })
      }
    }
    $scope.closeModal = function () {
      $uibModalInstance.dismiss()
    }
  }
})();
(function () {
  'use strict'
  var angular = window.angular
  var _ = window._
  angular.module('Vibzer.components')
    .controller('RouteDetailsCtrl', RouteDetailsCtrl);

  // Route details control handles add/update/delete route
  // @NgInject
  function RouteDetailsCtrl ($scope, $rootScope, $state, $stateParams, $location, $uibModal, toastr, constants, MachineService, RouteService, UserService, PermissionService, DeviceService, routeData) {
    $scope.webAppTexts = constants.webAppTexts
    $scope.user = $rootScope.user
    $scope.breadCrumbList = [$scope.webAppTexts.breadcrumbs.addRoute]
    $scope.routeData = routeData
    $scope.tabNum = $stateParams.tab ? parseInt($stateParams.tab) : 0
    $scope.model = {}
    $scope.addForm = true
    $scope.viewForm = false
    $scope.usersToAssign = []
    $scope.ownerUsers = []
    var machines
    $scope.model.routeOwner = _.pick($scope.user, ['_id', 'firstName', 'lastName', 'email'])
    $scope.webAppTexts = constants.webAppTexts

    // only manager can change owner
    $scope.canChangeOwner = $scope.user.permission.canViewMachines
    // route schedule
    $scope.scheduleTypes = [
      { id: 1, name: 'Monthly' },
      { id: 2, name: 'Weekly' },
      { id: 3, name: 'Daily' }
    ]

    // 12 months
    $scope.months = _.times(12, function (index) {
      return index + 1
    })
    // 30 days of month
    $scope.dates = _.times(31, function (index) {
      return index + 1
    })

    // 24 hours
    $scope.hours = _.times(24, function (index) {
      return index + 1
    })

    // 60 minutes
    $scope.minutes = _.times(60, function (index) {
      return index
    })
    $scope.days = ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday', 'Sunday']

    $scope.machines = [
      { listName: $scope.webAppTexts.headings.avaliableMachines, items: [], dragging: false, disable: true, addItem: false },
      { listName: $scope.webAppTexts.headings.assignedMachines, items: [], dragging: false, removeItem: true }
    ]
    // route information for view/update route
    $scope.initRouteData = function () {
      if ($scope.routeData && !$scope.routeData.addRoute) {
        if ($scope.routeData.viewDetails) { // view route details
          $scope.addForm = false
          $scope.viewForm = true
          $scope.breadCrumbList = [$scope.routeData.name]
        }
        if ($scope.routeData.editRoute) { // edit route details
          $scope.addForm = false
          $scope.editForm = true
          var breadcrumbItem = $scope.webAppTexts.breadcrumbs.editRoute + ' : ' + $scope.routeData.name
          $scope.breadCrumbList = [breadcrumbItem]
        }
        $scope.model = _.pick($scope.routeData, ['name', 'description', 'userIds'])
        $scope.model.routeOwner = $scope.routeData.ownerIds[0]
      }
      // initial schedule values
      $scope.schedule = $scope.routeData ? $scope.routeData.schedule.userInputs : {}
      $scope.schedule.type = $scope.routeData ? $scope.schedule.type : $scope.scheduleTypes[0].id
      $scope.schedule.everyMonth = $scope.schedule.everyMonth ? $scope.schedule.everyMonth.toString() : $scope.months[0].toString()
      $scope.schedule.days = $scope.schedule.days && $scope.schedule.days.length ? $scope.schedule.days[0] : $scope.days[0]
      $scope.schedule.dates = $scope.schedule.dates && $scope.schedule.dates.length ? $scope.schedule.dates[0].toString() : $scope.dates[0].toString()
      $scope.schedule.hour = $scope.schedule.hour ? $scope.schedule.hour.toString() : $scope.hours[9].toString()
      $scope.schedule.minute = $scope.schedule.minute || $scope.schedule.minute === 0 ? $scope.schedule.minute.toString() : $scope.minutes[0].toString()
      $scope.initialSchedule = angular.copy($scope.schedule)
      getAllMachines()
      // get all timezones. Populate browser's timezone by default
      DeviceService.resource.getAllTimezones(function (res) {
        $scope.timezoneList = res.timezones
        var currentZone = $scope.routeData && $scope.routeData.timezone ? $scope.routeData.timezone : moment.tz.guess()
        _.filter($scope.timezoneList, function (zone) {
          if (_.includes(zone.utc, currentZone)) {
            $scope.model.timezone = zone
          }
        })
      })
    }

    $scope.initRouteData()

    // on change of schedule type initialize schedule values to default
    $scope.changingScheduleType = function (type) {
      if (type === $scope.initialSchedule.type) {
        $scope.schedule = angular.copy($scope.initialSchedule)
      } else {
        $scope.schedule.everyMonth = $scope.months[0].toString()
        $scope.schedule.dates = $scope.dates[0].toString()
        $scope.schedule.days = $scope.days[0]
        $scope.schedule.hour = $scope.hours[9].toString()
        $scope.schedule.minute = $scope.minutes[0].toString()
      }
    }

    // check edit/delete permissions (Manager of lowest hierarchical item and owner can edit/delete route)
    function checkPermissions () {
      var data = {
        userId: $scope.user._id,
        permissions: ['canViewMachines', 'editRoute', 'deleteRoute'],
        resourceIds: _.uniq(_.map(machines, function (machine) { return machine.ancestors[machine.ancestors.length - 1]._id })),
        resourceType: constants.resourceTypes[1].internalName,
        resourceCheck: 'any'
      }
      PermissionService.resource.hasPermission(data, function (res) {
        $scope.canEdit = res.hasPermission || _.some($scope.routeData.ownerIds, _.pick($scope.user, ['_id', 'firstName', 'lastName', 'email'])) // can edit route
        $scope.canDelete = res.hasPermission || _.some($scope.routeData.ownerIds, _.pick($scope.user, ['_id', 'firstName', 'lastName', 'email'])) // can delete route
      })
    }
    // get users to assign
    $scope.getUsersToAssign = function () {
      var data = {
        permissions: ['canViewMachines', 'canViewOwnedMachines', 'analyzeMachine'],
        permissionType: 'name',
        resource: _.uniq(_.map(machines, function (machine) { return machine.ancestors[machine.ancestors.length - 1]._id })),
        options: { populate: [{ path: 'userId', select: '_id firstName lastName email' }], type: 'any' }
      }

      UserService.resource.getLevelUsersBasedOnPermissions(data, function (res) {
        $scope.usersToAssign = _.map(_.uniqBy(res.users, 'userId._id'), function (user) { return user.userId })
        _.remove($scope.usersToAssign, { _id: $scope.model.routeOwner._id }) // remove owner from list
      })
    }

    // get users to assign owner
    $scope.getUsersToAssignOwner = function () {
      var data = {
        permissions: ['canViewMachines', 'canViewOwnedMachines'],
        permissionType: 'name',
        resource: _.uniq(_.map(machines, function (machine) { return machine.ancestors[machine.ancestors.length - 1]._id })),
        options: { populate: [{ path: 'userId', select: '_id firstName lastName email' }], type: 'any' }
      }

      UserService.resource.getLevelUsersBasedOnPermissions(data, function (res) {
        $scope.usersForOwner = _.map(_.uniqBy(res.users, 'userId._id'), function (user) { return user.userId })
        // remove assigned users
        _.forEach($scope.model.userIds, function (user) {
          _.remove($scope.usersForOwner, { _id: user._id })
        })
      })
    }

    // get machines to assign
    function getAllMachines () {
      $scope.busy = true
      var queryParams = {
        customerId: $scope.user.customerIds[0],
        sort: { createdOn: -1 },
        page: 1,
        limit: 99999
      }

      MachineService.resource.getAllMachines(queryParams, function (res) {
        machines = angular.copy(res.result)
        $scope.machines[0].items = _.map(angular.copy(res.result), function (machine) {
          machine.icon = _.find(constants.typesOfMachine, { name: machine.machineType.name }).icon
          return machine
        })
        if (res.result && res.result.length) {
          $scope.getUsersToAssign()
          $scope.getUsersToAssignOwner()
        }
        if ($scope.viewForm) {
          checkPermissions()
        }
        if ($scope.editForm) { // remove assigned machines from avaliables machines
          _.remove($scope.machines[0].items, function (machine) {
            return _.includes($scope.routeData.machineIds, machine._id)
          })
        }
        if ($scope.viewForm || $scope.editForm) { // assigned machines
          $scope.busy = true
          var queryParams = {
            customerId: $scope.user.customerIds[0],
            routeId: $stateParams.routeId,
            page: 1,
            sort: null,
            filters: {},
            limit: 99999
          }
          MachineService.resource.getAllMachines(queryParams, function (res) {
            $scope.machines[1].items = _.map(angular.copy(res.result), function (machine) {
              machine.icon = _.find(constants.typesOfMachine, { name: machine.machineType.name }).icon
              return machine
            })
          }, function (err) {
            toastr.error(err.data.msg)
          })
        }
      }, function (err) {
        console.log(err)
      })
    }
    // angular drag drop list

    // drag array of object
    $scope.getSelectedItemsIncluding = function (list, item) {
      item.selected = true
      return list.items.filter(function (item) { return item.selected })
    }

    // set the list into dragging state
    $scope.onDragstart = function (list, event) {
      list.dragging = true
    }

    // Insert dragged item in list
    $scope.onDrop = function (list, items, index) {
      angular.forEach(items, function (item) { item.selected = false })
      list.items = list.items.slice(0, index)
        .concat(items)
        .concat(list.items.slice(index))
      return true
    }

    // Remove dragged item from list
    $scope.onMoved = function (list) {
      list.items = list.items.filter(function (item) { return !item.selected })
    }

    /* TODO Remove */
    // // Add machine to assigned machines list
    // $scope.addMachineToList = function (machine) {
    //   _.remove($scope.machines[0].items, { _id: machine._id })
    //   machine.selected = false
    //   $scope.machines[1].items.push(machine)
    // }

    // Remove machine from selected list and push it in unassigned machine list
    $scope.removeMachineFromList = function (machine) {
      _.remove($scope.machines[1].items, { _id: machine._id })
      // add machine in available machine only if user has access to it
      if (_.find(machines, { _id: machine._id })) {
        machine.selected = false
        $scope.machines[0].items.unshift(machine)
      }
    }

    // edit route
    $scope.editRoute = function () {
      $state.go('editRoute', { routeId: $stateParams.routeId, routeFilters: $stateParams.routeFilters, tab: $stateParams.tab })
    }

    /* Set current tab number in URL after changing the tab. */
    $scope.tabChange = function (tabNum) {
      $location.search('tab', tabNum)
    }

    // delete route
    $scope.delete = function () {
      var items
      items = function () {
        return {
          buttons: {
            yes: 'Confirm',
            no: 'Cancel'
          },
          message: 'Are you sure you want to delete route <strong>' + $scope.routeData.name + '</strong>?',
          title: '<i class="fa fa-trash-o" aria-hidden="true"></i> Delete Route'
        }
      }
      var modalInstance = $uibModal.open({
        templateUrl: 'app/components/confirmationDialog/confirmationDialog.html',
        controller: 'AllConfirmationDialogCtrl',
        resolve: {
          items: items
        }
      })

      modalInstance.result.then(function (result) {
        RouteService.resource.deleteRoute({ _id: $scope.routeData._id }, function (res) {
          if (_.findIndex(res, { isActive: false })) {
            toastr.success(constants.toastrMessages.success.deleteRoute)
            $state.go('routes', { routeFilters: $stateParams.routeFilters })
          } else {
            toastr.error('Failed to delete')
          }
        }, function (err) {
          toastr.error(err.data.msg)
        })
      }, function () { })
    }
    // validate basic info form
    $scope.validateBasicInfoForm = function () {
      if ($scope.viewForm) {
        return true
      }
      $scope.model.machineInfoForm.$valid = $scope.machines[1].items.length > 0
      $scope.model.scheduleForm.$valid = $scope.model.machineInfoForm.$valid
      $scope.model.machineInfoForm.$submitted = false
      return true
    }

    // validate basic info form
    $scope.validateMachineInfoForm = function () {
      if ($scope.viewForm) {
        return true
      }
      if ($scope.model.basicInfoForm.$valid) {
        $scope.model.machineInfoForm.$submitted = true
        $scope.model.machineInfoForm.$valid = $scope.machines[1].items.length > 0
        $scope.model.scheduleForm.$valid = $scope.model.machineInfoForm.$valid
        return $scope.model.machineInfoForm.$valid
      } else {
        return false
      }
    }

    // validate route schedule info form
    $scope.validateScheduleForm = function () {
      return true
    }

    // validate assign users info form
    $scope.validateUsersInfoForm = function () {
      return true
    }

    // add/update route
    $scope.save = function () {
      var data = _.pick($scope.model, ['name', 'description', 'owner', 'routeOwners', 'userIds'])
      data.customerId = $rootScope.user.customerIds[0]
      data.timezone = $scope.model.timezone.utc[0]
      data.schedule = {
        userInputs: {
          type: $scope.schedule.type,
          hour: parseInt($scope.schedule.hour),
          minute: parseInt($scope.schedule.minute)
        }
      }
      if ($scope.schedule.type === 1) {
        data.schedule.userInputs.everyMonth = parseInt($scope.schedule.everyMonth)
        data.schedule.userInputs.dates = [$scope.schedule.dates]
      } else if ($scope.schedule.type === 2) {
        data.schedule.userInputs.days = [$scope.schedule.days]
      }
      data.userIds = _.map(data.userIds, function (user) {
        return user._id
      })
      data.ownerIds = [$scope.model.routeOwner]
      data.machineIds = _.map($scope.machines[1].items, function (machine) {
        return machine._id
      })
      // add route
      if ($scope.addForm) {
        RouteService.resource.addRoute({ data: data }, function (res) {
          toastr.success(constants.toastrMessages.success.addRoute)
          $state.go('routes')
        }, function (err) {
          toastr.error(err.data.msg)
        })
      } else if ($scope.editForm) {
        data._id = $stateParams.routeId
        data.removedUserIds = _.map(_.differenceBy($scope.routeData.userIds, $scope.model.userIds, '_id'), function (itm) { return itm._id })
        data.userIds = _.map(_.differenceBy($scope.model.userIds, $scope.routeData.userIds, '_id'), function (itm) { return itm._id })
        RouteService.resource.updateRoute({ data: data }, function (res) {
          toastr.success(constants.toastrMessages.success.updateRoute)
          $state.go('viewRoute', { routeId: $stateParams.routeId, routeFilters: $stateParams.routeFilters, tab: $stateParams.tab })
        }, function (err) {
          toastr.error(err.data.msg)
        })
      }
    }

    /* Back button click handler. */
    $scope.goBack = function () {
      if ($scope.editForm) {
        $state.go('viewRoute', { routeId: $stateParams.routeId, routeFilters: $stateParams.routeFilters, tab: $stateParams.tab })
      } else {
        $state.go('routes', { routeFilters: $stateParams.routeFilters })
      }
    }

    /* Handles browser back button event.
    */
    window.onhashchange = function (event) {
      if (!window.innerDocClick && $state.current.name !== 'routes') {
        $scope.tabNum = $stateParams.tab ? parseInt($stateParams.tab) : 0
        changeTab($scope.tabNum)
        $scope.$apply()
      }
    }

    /* Select specific tab */
    var changeTab = function (tab) {
      $scope.$baWizardController.selectTab(tab)
    }
  }
})();
(function () {
  'use strict';
  var angular = window.angular
  var _ = window._
  angular.module('Vibzer.components.users.userDetails', [])
    .controller('UserDetailsCtrl', UserDetailsCtrl);
  /*
    Handles add/update user details.
  */
  function UserDetailsCtrl($scope, $state, $cookies, $location, $stateParams, $uibModal, $rootScope, toastr, UserService, RoleService, HierarchyService, CustomerService, MachineService, RouteService, PermissionService, userData, constants) {
    $scope.webAppTexts = constants.webAppTexts
    $scope.user = $cookies.getObject('vcUser')
    $scope.breadCrumbList = [$scope.webAppTexts.breadcrumbs.addUser]
    $scope.tabNum = $stateParams.tab ? parseInt($stateParams.tab) : 0

    // Assign role related variables
    $scope.filter = { $or: [{ isActive: 'true' }] }
    $scope.isRoleSelected = false
    var existingRoles
    var topLevelRoleOfUser
    $scope.selected = {}
    $scope.roles = []
    $scope.roleInfo = []
    existingRoles = UserService.getRoles()
    $scope.isDisableAssignRole = true;

    $scope.userData = userData
    $scope.roleMessage = $scope.user.distributorIds && $scope.user.distributorIds.length > 0 ? 'customer' : 'unit'
    $scope.editForm = false
    $scope.viewForm = false
    $scope.busy = false
    $scope.model = {}
    $scope.userBasicInfo = {}
    $scope.roleInfo = []
    var userFullName
    /* Get user roles and basic info from userService. */
    $scope.userBasicInfo = UserService.getBasicInfo()
    if (UserService.getRoles()) {
      $scope.roleInfo = UserService.getRoles()
      changeDistributorRole(constants.distributorRoles[0].internalName, constants.distributorRoles[0].name)
    }

    // check whether logged in user is distributor user or customer user
    if ($scope.user && $scope.user.distributorIds && $scope.user.distributorIds.length) {
      $scope.isDistributorSuperAdmin = $scope.user.permission.addDistributorUser
      $scope.isSalesRep = !$scope.isDistributorSuperAdmin && !$scope.user.permission.addDistributorUser
    }
    /* Remove user roles and user's basic info from userService. */
    UserService.clearFields()
    /* Role list control for pagination */
    $scope.limit = 10
    $scope.uibPage = {
      rolesPage: 1
    }

    $scope.uibPage.rolesPage = $stateParams.rolesPage || 1
    /* Get updated role list after page change. */
    $scope.pageChanged = function (rolesPage) {
      // $location.search('rolesPage', $scope.uibPage.rolesPage)
      getRoles()
    }

    $scope.getResourcesToAssign = function (level) {
      $scope.isDisableAssignRole = true;
      if ($rootScope.user && $rootScope.user.distributorIds && $rootScope.user.distributorIds.length > 0) {
        $scope.isSalesRepRoleSelected = true;
        $scope.isRoleSelected = false;
        $scope.customersList = []
        var queryParams = {
          sort: { 'createdOn': -1 },
          filters: {},
          limit: 2999,
          requireCustomerCount: true,
          distributorId: $rootScope.user.distributorIds[0]
        }
        _.assign(queryParams.filters, $scope.filter)
        $scope.levelName = 'Customer';
        CustomerService.resource.getAll(queryParams, function (res) {
          res.customers = _.filter(res.customers, function (item) {
            if (_.isEmpty(item.salesRep)) {
              return item
            }
          })
          $scope.customersList = res.customers
          // remove already assigned roles in case of add
          var existingRoles = UserService.getRoles()
          if (existingRoles) {
            _.forEach(existingRoles, function (itm) {
              if ($scope.selected.role.internalName === itm.role || $scope.selected.role.name === itm.role) {
                if (itm.resource)
                  _.remove($scope.customersList, { _id: itm.resource._id })
              }
            })
          }
        }, function (err) {
          toastr.error(err.data.msg)
        })
      } else if (level.level) {
        $scope.isSalesRepRoleSelected = false;
        $scope.plantsList = [];
        $scope.areasList = [];
        $scope.sectionsList = [];
        $scope.machinesList = [];
        $scope.selected.plant = null;
        $scope.selected.area = null;
        $scope.selected.section = null;
        $scope.selected.machine = null;
        var queryParams = {
          customerId: $scope.user.customerIds[0],
          page: $scope.uibPage.currentPage || 1,
          sort: { 'createdOn': -1 },
          filters: {},
          limit: 2999
        }
        if ($stateParams.userId) {
          queryParams.assignee = $stateParams.userId
        }
        HierarchyService.resource.getAll(queryParams, function (res) {
          $scope.plantsList = res.result
          $scope.disablePlantField = false;
          // remove already assigned roles in case of add
          var existingRoles = UserService.getRoles()
          if (existingRoles) {
            _.forEach(existingRoles, function (itm) {
              if ($scope.selected.role.internalName === itm.role || $scope.selected.role.name === itm.role) {
                if (itm.resource)
                  _.remove($scope.plantsList, { _id: itm.resource._id })
              }
            })
          }
          if ($scope.plantsList.length == 1) {
            $scope.disablePlantField = true;
            $scope.isDisableAssignRole = false;
            $scope.selected.plant = $scope.plantsList[0];
            if ($scope.selected.roleForType.level == 1 && $scope.isTechnicianRole)
              $scope.getMachineLists($scope.selected.plant)
            if ($scope.selected.roleForType.level == 2 || $scope.selected.roleForType.level == 3)
              $scope.getSubLevel($scope.selected.plant, 'Area')
          }
        }, function (err) {
          toastr.error(err.data.msg)
        })
      } else {
        $scope.selected.resourceType = $scope.selected.roleForType;
        $scope.isHierarchy = false
        $scope.isSalesRepRoleSelected = false;
        $scope.selected.hierarchyLevel = null;
        $scope.isDisableAssignRole = false;
      }
    }
    // Get top(highest) level of user to check which role user can assign to anoth user.

    if ($rootScope.user && $rootScope.user.distributorIds && $rootScope.user.distributorIds.length > 0) {
      $scope.roles = constants.distributorRoles
      $scope.selected.role = constants.distributorRoles[0]
      $scope.isRoleSelected = true
      $scope.getResourcesToAssign()
    } else {
      var queryParams = {
        userId: $scope.user._id,
        customerId: $scope.user.customerIds[0]
      }
      RoleService.resource.getTopLevelRoleOfUser(queryParams, function (res) {
        topLevelRoleOfUser = res
        $scope.isCompanyLevelUser = topLevelRoleOfUser.type === constants.resourceTypes[0].internalName
        $scope.roles = _.find(_.cloneDeep(constants.roles), { level: topLevelRoleOfUser.roleLevel }).assignRoleTo
        var data = {
          userId: $scope.user._id,
          permissions: ['canViewMachines', 'canViewOwnedMachines'],
          permissionCheck: 'any',
          withResources: true
        }
        PermissionService.resource.hasPermission(data, function (permissionResult) {
          if (!permissionResult.hasPermission)
            _.remove($scope.roles, { id: 4 })
          if ($scope.roles && $scope.roles.length) {
            $scope.selected.role = $scope.roles[0]
            $scope.getRoleFor($scope.selected.role)
          }
        });
      })
    }

    /* View and edit user control */
    function initUserData() {
      if ($scope.userData) {
        getRoles()
        $scope.userData = _.assign(userData, $scope.userBasicInfo ? $scope.userBasicInfo : {})
        userFullName = $scope.userData.firstName + ' ' + $scope.userData.lastName
        if ($scope.userData.viewDetails) { // view user details
          $scope.viewForm = true
          $scope.addForm = false;
          $scope.breadCrumbList = [userFullName]
        }
        if ($scope.userData.editUser) { // edit user details
          $scope.editForm = true
          $scope.addForm = false;
          var breadCrumbItem = $scope.webAppTexts.breadcrumbs.editUser + ': ' + userFullName
          $scope.breadCrumbList = [breadCrumbItem]
          changeDistributorRole(constants.distributorRoles[0].name, constants.distributorRoles[0].internalName)
        }
        $scope.model = _.pick($scope.userData, ['firstName', 'lastName', 'email', 'phone'])
        $scope.roleInfo = $scope.userData.roleInfo
      } else {
        changeDistributorRole(constants.distributorRoles[0].name, constants.distributorRoles[0].internalName)
        $scope.addForm = true;
        $scope.model = _.assign($scope.model, $scope.userBasicInfo ? $scope.userBasicInfo : {})
      }
    }
    initUserData()

    /* Get roles of user with resources */
    function getRoles() {
      $scope.busy = true
      var queryParams = {
        _id: $scope.userData._id,
        limit: $scope.limit
      }
      queryParams.page = $scope.uibPage.rolesPage || 1
      UserService.resource.getUserRolesWithResource(queryParams, function (res) {
        $scope.roleInfo = res.result
        UserService.setRoles($scope.roleInfo)
        $scope.roleInfo = _.filter($scope.roleInfo, function (role) {
          // Following if-else block used to distinguish customer and distributor
          if ($rootScope.user && $rootScope.user.customerIds && $rootScope.user.customerIds.length > 0) {
            if (role.resourceType === constants.resourceTypes[0].internalName) {
              role.resource = { name: constants.resourceTypes[0].displayName, _id: $scope.user.customerIds[0] }
              return role
            } else if (_.some(role.resource, _.isEmpty)) {
              return role
            }
          } else {
            if (role.resourceType === constants.resourceTypes[0].internalName) {
              role.role = role.role === constants.distributorRoles[0].internalName ? constants.distributorRoles[0].name : role.role
              return role
            }
          }
        })
        $scope.totalItems = res.totalItems
        $scope.busy = false
      })
    }

    // get getRoleFor depends on selected role
    $scope.getRoleFor = function (role) {
      $scope.isDisableAssignRole = true;
      $scope.disableRoleForField = false;
      $scope.isRoleSelected = true
      $scope.roleForTypes = []
      $scope.resourceTypes = []
      $scope.hierarchyLevels = []
      $scope.resourcesList = []
      $scope.selected.resourceType = $scope.selected.hierarchyLevel = null
      $scope.selected.roleForType = $scope.selected.hierarchyLevel = null
      $scope.selected.customer = null;
      $scope.uibPage.resourcesPage = 1
      $scope.isHierarchy = false
      $scope.isAdminRole = role.id === 1
      $scope.isManagerRole = role.id === 2
      $scope.isEngineerRole = role.id === 3
      $scope.isTechnicianRole = role.id === 4
      $scope.resourceTypes = angular.copy(constants.resourceTypes)
      if ($rootScope.user && $rootScope.user.distributorIds && $rootScope.user.distributorIds.length > 0) {
        $scope.getResourcesToAssign()
      } else if ($scope.isCompanyLevelUser && ($scope.isAdminRole || $scope.isManagerRole)) {                    // for company level admin and manager role
        $scope.disableRoleForField = false;
        _.remove($scope.resourceTypes, { id: 3 })
        if ($scope.isCompanyLevelUser)
          $scope.roleForTypes.push(_.find(constants.resourceTypes, { id: 1 }))
        $scope.selected.resourceType = $scope.resourceTypes[1]
        $scope.getHierarchyLevels($scope.selected.resourceType)
        var existingRoles = UserService.getRoles()
        _.forEach(existingRoles, function (itm) {
          if ($scope.selected.role.name === itm.role && (itm.type === constants.resourceTypes[0].internalName || itm.resourceType === constants.resourceTypes[0].internalName)) {
            $scope.roleForTypes = [];
            $scope.selected.resourceType = $scope.resourceTypes[1]
            $scope.getHierarchyLevels($scope.selected.resourceType)
          }
        })
      } else if (!$scope.isTechnicianRole && (!$scope.isCompanyLevelUser || $scope.isEngineerRole)) {    // for engineer role
        $scope.disableRoleForField = $scope.isEngineerRole ? true : false;
        $scope.isRoleSelected = $scope.isEngineerRole ? false : true;
        $scope.selected.resourceType = _.find(constants.resourceTypes, { id: 2 })
        $scope.getHierarchyLevels($scope.selected.resourceType)
      } else if ($scope.isTechnicianRole) { // by default resource type 'machines' for 'technician' role
        $scope.disableRoleForField = true;
        $scope.isRoleSelected = false;
        $scope.selected.resourceType = _.find(constants.resourceTypes, { id: 3 })
        $scope.selected.roleForType = _.find(constants.resourceTypes, { id: 3 })
        $scope.selected.hierarchyLevel = $scope.user.customer.hierarchyType[$scope.user.customer.hierarchyType.length - 1]
        $scope.selected.roleForType.level = $scope.selected.hierarchyLevel.level;
        $scope.getResourcesToAssign($scope.user.customer.hierarchyType[$scope.user.customer.hierarchyType.length - 1])
      }
    }

    // get hierarchy levels to assign if selected resource type is hierarchy
    $scope.getHierarchyLevels = function (resourceType) {
      $scope.hierarchyLevels = []
      $scope.uibPage.resourcesPage = 1
      if (resourceType.id === $scope.resourceTypes[1].id) {
        $scope.isHierarchy = true
        if ($scope.isAdminRole || $scope.isManagerRole) {
          _.forEach($scope.user.customer.hierarchyType, function (type) {
            if (!$scope.isCompanyLevelUser && type.level >= topLevelRoleOfUser.hierarchyLevel) {
              $scope.hierarchyLevels.push(type)
              $scope.roleForTypes.push(type);
            } else if ($scope.isCompanyLevelUser) {
              $scope.hierarchyLevels.push(type)
              $scope.roleForTypes.push(type);
            }
          })
        } else if ($scope.isEngineerRole) { // Customer's lowest hierarchy level is the default hierarchy level for engineer role.
          $scope.selected.hierarchyLevel = $scope.user.customer.hierarchyType[$scope.user.customer.hierarchyType.length - 1]
          $scope.selected.roleForType = $scope.user.customer.hierarchyType[$scope.user.customer.hierarchyType.length - 1]
          $scope.getResourcesToAssign($scope.selected.roleForType)
        }
      } else {
        $scope.isHierarchy = false
        $scope.selected.hierarchyLevel = null
      }
    }

    $scope.selectCustomer = function () {
      if ($scope.selected.customer._id) {
        $scope.isDisableAssignRole = false;
      }
    }

    $scope.getSubLevel = function (selectedData, level) {
      $scope.isDisableAssignRole = true;
      $scope.machinesList = [];
      $scope.selected.machine = null;
      var queryParams = {
        customerId: $scope.user.customerIds[0],
        page: $scope.uibPage.currentPage || 1,
        sort: { 'createdOn': -1 },
        filters: {},
        limit: 2999,
        parentId: selectedData._id
      }
      HierarchyService.resource.getAll(queryParams, function (res) {
        if (level === 'Area') {
          $scope.areasList = [];
          $scope.disableAreaField = false;
          $scope.selected.area = null;
          $scope.selected.section = null;
          $scope.areasList = res.result;
          // remove already assigned roles in case of add
          var existingRoles = UserService.getRoles()
          if (existingRoles) {
            _.forEach(existingRoles, function (itm) {
              if ($scope.selected.role.internalName === itm.role || $scope.selected.role.name === itm.role) {
                if (itm.resource)
                  _.remove($scope.areasList, { _id: itm.resource._id })
              }
            })
          }
          if ($scope.areasList.length === 1) {
            $scope.disableAreaField = true;
            $scope.isDisableAssignRole = false;
            $scope.selected.area = $scope.areasList[0];
            if ($scope.selected.roleForType.level == 2 && $scope.isTechnicianRole)
              $scope.getMachineLists($scope.selected.area)
            if ($scope.selected.roleForType.level == 3)
              $scope.getSubLevel($scope.selected.area, 'Section')
          }
        }
        else {
          $scope.selected.section = null;
          $scope.sectionsList = [];
          $scope.disableSectionField = false;
          $scope.sectionsList = res.result;
          // remove already assigned roles in case of add
          var existingRoles = UserService.getRoles()
          if (existingRoles) {
            _.forEach(existingRoles, function (itm) {
              if ($scope.selected.role.internalName === itm.role || $scope.selected.role.name === itm.role) {
                if (itm.resource)
                  _.remove($scope.sectionsList, { _id: itm.resource._id })
              }
            })
          }
          if ($scope.sectionsList.length == 1) {
            $scope.disableSectionField = true;
            $scope.isDisableAssignRole = false;
            $scope.selected.section = $scope.sectionsList[0];
            if ($scope.isTechnicianRole)
              $scope.getMachineLists($scope.selected.section)
          }
        }
      })
    }

    $scope.getMachineLists = function (selectedItem) {
      $scope.machinesList = [];
      $scope.selected.machine = null;
      if (!$scope.isTechnicianRole && selectedItem._id) {
        $scope.isDisableAssignRole = false;
      } else {
        $scope.isDisableAssignRole = true;
        var queryParams = {
          customerId: $scope.user.customerIds[0],
          page: null,
          sort: { 'createdOn': -1 },
          filters: {},
          limit: 2999,
          resourceId: selectedItem._id
        }
        MachineService.resource.getAllMachines(queryParams, function (res) {
          $scope.machinesList = res.result;
          $scope.disableMachineField = false;
          // remove already assigned roles in case of add
          var existingRoles = UserService.getRoles()
          if (existingRoles) {
            _.forEach(existingRoles, function (itm) {
              if ($scope.selected.role.internalName === itm.role || $scope.selected.role.name === itm.role) {
                if (itm.resource)
                  _.remove($scope.machinesList, { _id: itm.resource._id })
              }
            })
          }
          if ($scope.machinesList.length === 1) {
            $scope.disableMachineField = true;
            $scope.isDisableAssignRole = false;
            $scope.selected.machine = $scope.machinesList[0];
          }
        })
      }
    }

    $scope.getSelectedMachine = function () {
      if ($scope.isTechnicianRole && $scope.selected.machine._id) {
        $scope.isDisableAssignRole = false;
      }
    }

    /* Edit user control ends */

    /* Assign role button click handler saves user's basic info and
       user roles in userService and redirect to assignRole state.
    */
    $scope.assignRole = function () {
      var basicInfo = {
        firstName: $scope.model.firstName ? $scope.model.firstName : null,
        lastName: $scope.model.lastName ? $scope.model.lastName : null,
        email: $scope.model.email ? $scope.model.email : null
      }
      UserService.setBasicInfo(basicInfo)
      changeDistributorRole(constants.distributorRoles[0].name, constants.distributorRoles[0].internalName)
      UserService.setRoles($scope.roleInfo)
      var state = $rootScope.user ? ($rootScope.user.distributorIds && $rootScope.user.distributorIds.length > 0 ? 'assignDistributorRole' : 'assignRole') : 'assignRole'
      if ($scope.editForm) {
        $state.go(state, $stateParams)
      } else {
        $state.go(state)
      }
    }

    /* Remove role button click handler removes user role from role list.
      If it's editForm then it will ask for confirmation and then role will be removed permanently from database
      and redirect to view user details.
    */
    $scope.removeRole = function (roleData) {
      if (!$scope.editForm) {
        _.pull($scope.roleInfo, roleData)
        resetDropdownValues();
      } else {
        if ($scope.roleInfo.length == 1) {
          var items = function () {
            return {
              buttons: {
                yes: 'Ok',
                no: 'Cancel'
              },
              message: constants.toastrMessages.invalid.removeOnlyOneRoleValidationMsg,
              title: '<i aria-hidden="true"></i> Remove Role '
            }
          }
          var modalInstance = $uibModal.open({
            templateUrl: 'app/components/confirmationDialog/confirmationDialog.html',
            controller: 'AllConfirmationDialogCtrl',
            resolve: {
              items: items
            }
          })
        } else if (roleData.role === constant.roles[2].name) {
          var assignedMachine = [];
          var assignedRoute = [];
          var machineQueryParams = {
            customerId: $scope.user.customerIds[0],
            page: 1,
            sort: { "createdOn": -1 },
            filters: {},
            limit: $scope.limit,
            forUser: $scope.userData._id
          };
          var routeQueryParams = {
            customerId: $scope.user.customerIds[0],
            page: 1,
            sort: { "createdOn": -1 },
            filters: {},
            limit: $scope.limit,
            forUser: $scope.userData._id
          };
          MachineService.resource.getAllMachines(machineQueryParams, function (machineListsResponse) {
            assignedMachine = machineListsResponse.result;
            RouteService.resource.getAll(routeQueryParams, function (routeListResponse) {
              assignedRoute = routeListResponse.result;
              if (assignedMachine.length > 0 || assignedRoute.length > 0) {
                var items = function () {
                  return {
                    buttons: {
                      yes: 'Ok',
                      no: 'Cancel'
                    },
                    message: constants.toastrMessages.invalid.removeEngineerRoleValidationMsg,
                    title: '<i class="fa fa-trash-o" aria-hidden="true"></i> Remove Role '
                  }
                }
                var modalInstance = $uibModal.open({
                  templateUrl: 'app/components/confirmationDialog/confirmationDialog.html',
                  controller: 'AllConfirmationDialogCtrl',
                  resolve: {
                    items: items
                  }
                })
              } else {
                confirmRemoveRole(roleData)
              }
            });
          });
        } else {
          confirmRemoveRole(roleData)
        }
      }
    }

    function confirmRemoveRole(roleData) {
      var modalInstance = $uibModal.open({
        templateUrl: 'app/components/confirmationDialog/confirmationDialog.html',
        controller: 'UserConfirmationDialogCtrl',
        backdrop: true,
        resolve: {
          items: function () {
            return {
              user: {
                role: roleData.role,
                fullName: userFullName,
                resource: roleData.resource.name
              },
              removeRole: true
            }
          }
        }
      })

      modalInstance.result.then(function (result) {
        var data = {
          userId: $scope.userData._id,
          role: roleData.role,
          resourceId: roleData.resource._id,
          resourcesId: roleData.resourcesId,
          resourceType: roleData.resourceType
        }
        if ($rootScope.user.distributorIds && $rootScope.user.distributorIds.length > 0) {
          data.role = (data.role === constants.distributorRoles[0].name) ? constants.distributorRoles[0].internalName : data.role
        }
        UserService.resource.removeRole(data, function (res) {
          if ($scope.roleInfo.length === 1 && $scope.uibPage.rolesPage > 1) {
            $scope.uibPage.rolesPage = $scope.uibPage.rolesPage - 1
            $location.search('rolesPage', $scope.uibPage.rolesPage)
          }
          toastr.success(constants.toastrMessages.success.removeRole)
          if ($stateParams.userId === $scope.user._id) {
            UserService.reloadUserPermission($scope.user._id)
          }
          $state.go('viewUser', { userId: $stateParams.userId, tab: $stateParams.tab })
        }, function (err) {
          toastr.error(err.data.msg)
        })
      }, function () { })
    }

    /* Edit user button click handler redirects to editUser state. */
    $scope.editUser = function () {
      $state.go('editUser', $stateParams)
    }

    /* Back and Cancel button click handler.
       This function used to remove user's info from userService and then redirect
       to viewUser state if current one is editUser otherwise redirect user list.
    */
    $scope.goBack = function () {
      UserService.clearFields()
      if (!$scope.editForm) {
        $state.go('users', $stateParams)
      } else {
        $state.go('viewUser', $stateParams)
      }
    }

    /* This function is used to save user info in database after adding and updating user. */
    $scope.save = function () {
      var userInfo = {
        firstName: $scope.model.firstName,
        lastName: $scope.model.lastName,
        email: $scope.model.email,
        phone: $scope.model.phone
      }
      if ($scope.roleInfo && !$scope.editForm) {
        changeDistributorRole(constants.distributorRoles[0].name, constants.distributorRoles[0].internalName)
        userInfo.roleData = UserService.createRolesJson($scope.roleInfo)
      }
      if ($scope.user.distributorIds && $scope.user.distributorIds.length > 0) {
        userInfo.distributorIds = $scope.user.distributorIds
        if ((!userInfo.roleData || (userInfo.roleData && !userInfo.roleData.length)) && !$scope.editForm) {
          userInfo.roleData = [{
            role: constants.distributorRoles[0].internalName,
            resources: []
          }]
        }
      } else {
        userInfo.customerIds = $scope.user.customerIds
      }
      if (!$scope.editForm) {
        if (userInfo.roleData.length > 0) {
          UserService.resource.addUser(userInfo, function (res) {
            toastr.success(constants.toastrMessages.success.addUser)
            UserService.clearFields()
            $state.go('users')
          }, function (err) {
            toastr.error(err.data.msg)
          })
        } else {
          toastr.warning(constants.toastrMessages.invalid.reqiredRole)
        }
      } else {
        userInfo._id = $scope.userData._id
        UserService.resource.updateUser(userInfo, function (res) {
          toastr.success(constants.toastrMessages.success.updateUser)
          UserService.clearFields()
          $state.go('viewUser', $stateParams)
        }, function (err) {
          toastr.error(err.data.msg)
        })
      }
    }

    /* Disable save button until all fields are not filled */
    $scope.saveButtonVisibility = function () {
      return !($scope.model.firstName && $scope.model.lastName && $scope.model.email)
    }

    /* Set current tab number in URL after changing the tab. */
    $scope.tabChange = function (tabNum) {
      $location.search('tab', tabNum)
    }

    /* Handles browser back button event.
    */
    window.onhashchange = function (event) {
      if (!window.innerDocClick && $state.current.name !== 'users') {
        $scope.tabNum = $stateParams.tab ? parseInt($stateParams.tab) : 0
        changeTab($scope.tabNum)
        $scope.$apply()
      }
    }

    /* Select specific tab */
    var changeTab = function (tab) {
      $scope.$baWizardController.selectTab(tab)
    }

    /* Validation basic information form wizard to check whether all information is entered or not. */
    $scope.validateBasicInfoForm = function () {
      return true
    }

    $scope.validateAssignRoles = function () {
      return true
    }

    /* If it's editUser form then roles are store in database and redirect to
       viewUser state otherwise concat with existing roles and set it in
       userService and redirect to addUser page.
    */
    $scope.addRole = function () {
      var roleInfo = []
      if ($scope.user.distributorIds && $scope.user.distributorIds.length > 0) {
        $scope.selected.customer.unitName = $scope.selected.customer.name
        roleInfo = [{
          resource: $scope.selected.customer,
          role: $scope.selected.role.internalName,
          type: constants.resourceTypes[0].internalName
        }];
        roleInfo[0].roleName = $scope.selected.role.name;
      } else if ($scope.selected.resourceType && $scope.selected.resourceType.id === 1) {
        roleInfo = [{
          resource: { _id: $scope.user.customerIds[0], name: $scope.selected.resourceType.displayName, unitName: $scope.selected.resourceType.displayName },
          role: $scope.selected.role.name,
          type: $scope.selected.resourceType.internalName
        }]
      } else {
        var itm;
        if ($scope.selected.roleForType.level === 1) {
          itm = $scope.selected.plant;
          itm.unitName = $scope.selected.plant.name
          if ($scope.isTechnicianRole) {
            itm = $scope.selected.machine;
            itm.unitName = $scope.selected.plant.name + '/' + $scope.selected.machine.name
          }
        } else if ($scope.selected.roleForType.level === 2) {
          itm = $scope.selected.area;
          itm.unitName = $scope.selected.plant.name + '/' + $scope.selected.area.name;
          if ($scope.isTechnicianRole) {
            itm = $scope.selected.machine;
            itm.unitName = $scope.selected.plant.name + '/' + $scope.selected.area.name + '/' + $scope.selected.machine.name
          }
        } else if ($scope.selected.roleForType.level === 3) {
          itm = $scope.selected.section;
          itm.unitName = $scope.selected.plant.name + '/' + $scope.selected.area.name + '/' + $scope.selected.section.name;
          if ($scope.isTechnicianRole) {
            itm = $scope.selected.machine;
            itm.unitName = $scope.selected.plant.name + '/' + $scope.selected.area.name + '/' + $scope.selected.section.name + '/' + $scope.selected.machine.name
          }
        }
        roleInfo = [{
          resource: itm,
          hierarchyTypeId: $scope.selected.roleForType._id ? $scope.selected.roleForType._id : $scope.selected.hierarchyLevel._id,
          role: $scope.selected.role.name,
          type: $scope.selected.resourceType.internalName
        }]

        if ($scope.selected.resourceType.id === 3) {
          var existingRoles = UserService.getRoles()
          if (existingRoles && existingRoles.length) {
            var existingHierarchy = _.find(existingRoles, function (role) {
              return role.resource && role.resource._id === itm.parentId
            })
          }
          if (!existingHierarchy) {
            roleInfo[0].parentId = itm.ancestors[itm.ancestors.length - 1]._id;
          }
        }
      }
      if (!$stateParams.userId) {
        $scope.roleInfo = $scope.roleInfo.concat(roleInfo);
        UserService.setRoles($scope.roleInfo)
      } else {
        roleInfo = UserService.createRolesJson(roleInfo) // create json structure for role data
        roleInfo[0].userId = $stateParams.userId
        var roleData = {
          data: roleInfo[0]
        }
        UserService.resource.assignRoles(roleData, function (res) {
          toastr.success(constants.toastrMessages.success.assignRole)
          UserService.clearFields()
          if ($stateParams.userId === $scope.user._id) {
            UserService.reloadUserPermission($scope.user._id)
          }
          $state.go('viewUser', { userId: $stateParams.userId, tab: $stateParams.tab })
        }, function (err) {
          toastr.error(err.data.msg)
        })
      }
      resetDropdownValues();
    }

    function resetDropdownValues() {
      $scope.selected.hierarchyLevel = null;
      $scope.selected.resource = null;
      $scope.selected.roleForType = null;
      $scope.selected.plant = null;
      $scope.selected.area = null;
      $scope.selected.section = null;
      $scope.selected.machine = null;
      $scope.customersList = [];
      $scope.roleForTypes = [];
      $scope.machinesList = [];
      $scope.plantsList = [];
      $scope.areasList = [];
      $scope.sectionsList = [];
      $scope.selected.role = null;
      $scope.isRoleSelected = false;
      $scope.isDisableAssignRole = true;
      $scope.isSalesRepRoleSelected = false;
    }

    function changeDistributorRole(fromName, toName) {
      if ($scope.user && $scope.user.distributorIds && $scope.user.distributorIds.length > 0) {
        _.each($scope.roleInfo, function (item) {
          item.role = item.role === fromName ? toName : item.role
        })
      }
    }
  }
})();
(function () {
  'use strict'
  var angular = window.angular
  var _ = window._
  angular.module('Vibzer.components')
    .controller('UserSettingCtrl', UserSettingCtrl)

  // User profile page controller. Handles view/edit profile and change password
  // @NgInject
  function UserSettingCtrl($scope, $state, $stateParams, $cookies, constants, UserService, toastr) {
    $scope.user = $cookies.getObject('vcUser')
    $scope.webAppTexts = constants.webAppTexts
    $scope.breadCrumbList = ['User Settings']
    $scope.viewForm = $state.current.name === 'viewUserSetting'
    $scope.editForm = $state.current.name === 'editUserSetting'
    $scope.severityUnits = constants.severityUnits
    $scope.limit = 10
    $scope.uibPage = {
      page: 1
    }
    $scope.selected = {
      severityUnit: $scope.user && $scope.user.setting && $scope.user.setting.reports ? _.find($scope.severityUnits, { internalName: $scope.user.setting.reports.severityUnit }) : $scope.severityUnits[0]
    }
    $scope.save = function () {
      var data = {
        _id: $scope.user._id,
        email: $scope.user.email,
        'setting.reports.severityUnit': $scope.selected.severityUnit.internalName
      }
      UserService.resource.updateUser(data, function (res) {
        if (res.setting) {
          $scope.user.setting = res.setting
          $cookies.putObject('vcUser', $scope.user)
        }
        toastr.success(constants.toastrMessages.success.updateUserSetting)
        UserService.clearFields()
        $scope.viewForm = false
        $state.go('viewUserSetting')
      }, function (err) {
        toastr.error(err.data.msg)
      })
    }

    $scope.editSetting = function () {
      $state.go('editUserSetting')
    }
    $scope.cancel = function () {
      $state.go('viewUserSetting')
    }
  }
})();
(function () {
  'use strict';
  angular.module('Vibzer.theme')
    .directive('baPanel', baPanel);
  function baPanel(baPanel, baConfig) {
    return angular.extend({}, baPanel, {
      template: function (el, attrs) {
        var res = '<div  class="panel ' + (baConfig.theme.blur ? 'panel-blur' : '') + ' full-invisible ' + (attrs.baPanelClass || '');
        res += '" zoom-in ' + (baConfig.theme.blur ? 'ba-panel-blur' : '') + '>';
        res += baPanel.template(el, attrs);
        res += '</div>';
        return res;
      }
    });
  }
})();

/**
 * @author v.lugovsky
 * created on 23.12.2015
 */
(function () {
  'use strict';

  angular.module('Vibzer.theme')
      .factory('baPanel', baPanel);

  /** @ngInject */
  function baPanel() {

    /** Base baPanel directive */
    return {
      restrict: 'A',
      transclude: true,
      template: function(elem, attrs) {
        var res = '<div class="panel-body" ng-transclude></div>';
        if (attrs.baPanelTitle) {
          var titleTpl = '<div class="panel-heading clearfix"><h3 class="panel-title">' + attrs.baPanelTitle + '</h3></div>';
          res = titleTpl + res; // title should be before
        }

        return res;
      }
    };
  }

})();

/**
 * @author v.lugovsky
 * created on 15.01.2016
 */
(function () {
  'use strict';

  angular.module('Vibzer.theme')
      .directive('baPanelBlur', baPanelBlur);

  /** @ngInject */
  function baPanelBlur(baPanelBlurHelper, $window, $rootScope) {
    var bodyBgSize;

    baPanelBlurHelper.bodyBgLoad().then(function() {
      bodyBgSize = baPanelBlurHelper.getBodyBgImageSizes();
    });

    $window.addEventListener('resize', function() {
      bodyBgSize = baPanelBlurHelper.getBodyBgImageSizes();
    });

    return {
      restrict: 'A',
      link: function($scope, elem) {
        if(!$rootScope.$isMobile) {
          baPanelBlurHelper.bodyBgLoad().then(function () {
            setTimeout(recalculatePanelStyle);
          });
          $window.addEventListener('resize', recalculatePanelStyle);

          $scope.$on('$destroy', function () {
            $window.removeEventListener('resize', recalculatePanelStyle);
          });
        }

        function recalculatePanelStyle() {
          if (!bodyBgSize) {
            return;
          }
          elem.css({
            backgroundSize: Math.round(bodyBgSize.width) + 'px ' + Math.round(bodyBgSize.height) + 'px',
            backgroundPosition: Math.floor(bodyBgSize.positionX) + 'px ' + Math.floor(bodyBgSize.positionY) + 'px'
          });
        }

      }
    };
  }

})();

/**
 * @author v.lugovsky
 * created on 15.01.2016
 */
(function () {
  'use strict';

  angular.module('Vibzer.theme')
      .service('baPanelBlurHelper', baPanelBlurHelper);

  /** @ngInject */
  function baPanelBlurHelper($q) {
    var res = $q.defer();
    var computedStyle = getComputedStyle(document.body, ':before');
    var image = new Image();
    image.src = computedStyle.backgroundImage.replace(/url\((['"])?(.*?)\1\)/gi, '$2');
    image.onerror = function() {
      res.reject();
    };
    image.onload = function() {
      res.resolve();
    };

    this.bodyBgLoad = function() {
      return res.promise;
    };

    this.getBodyBgImageSizes = function() {
      var elemW = document.documentElement.clientWidth;
      var elemH = document.documentElement.clientHeight;
      if(elemW <= 640) return;
      var imgRatio = (image.height / image.width);       // original img ratio
      var containerRatio = (elemH / elemW);     // container ratio

      var finalHeight, finalWidth;
      if (containerRatio > imgRatio) {
        finalHeight = elemH;
        finalWidth = (elemH / imgRatio);
      } else {
        finalWidth = elemW;
        finalHeight = (elemW * imgRatio);
      }
      return { width: finalWidth, height: finalHeight, positionX: (elemW - finalWidth)/2, positionY: (elemH - finalHeight)/2};
    };
  }

})();

/**
 * @author v.lugovsky
 * created on 23.12.2015
 */
(function () {
  'use strict';

  /**
   * Represents current element as panel, adding all necessary classes.
   */
  angular.module('Vibzer.theme')
      .directive('baPanelSelf', baPanelSelf);

  /** @ngInject */
  function baPanelSelf(baPanel) {
    return angular.extend({}, baPanel, {
      link: function(scope, el, attrs) {
        el.addClass('panel panel-white');
        if (attrs.baPanelClass) {
          el.addClass(attrs.baPanelClass);
        }
      }
    });
  }

})();

(function() {
  'use strict';

  angular.module('Vibzer.theme.components')
    .directive('baWizard', baWizard);

  /** @ngInject */
  function baWizard() {
    return {
      restrict: 'E',
      transclude: true,
      templateUrl: 'app/theme/components/baWizard/baWizard.html',
      controllerAs: '$baWizardController',
      controller: 'baWizardCtrl'
    }
  }
})();

(function () {
  'use strict';
  var angular = window.angular
  angular.module('Vibzer.theme.components')
    .controller('baWizardCtrl', baWizardCtrl)

  /* Handles form wizard */
  /** @ngInject */
  function baWizardCtrl ($scope) {
    var vm = this
    vm.tabs = []
    vm.tabNum = $scope.tabNum || 0
    vm.progress = 25
    vm.addForm = $scope.addForm
    vm.viewProgress = 100
    /* Get all avaiable tabs of form */
    vm.addTab = function (tab) {
      tab.setPrev(vm.tabs[vm.tabs.length - 1])
      vm.tabs.push(tab)
      vm.selectTab($scope.tabNum)
      vm.viewProgress = vm.tabs.length ? 100 / vm.tabs.length : 100
    }

    $scope.$watch(angular.bind(vm, function () { return vm.tabNum }), calcProgress)

    /* Select tab specified by tabNum and update url */
    vm.selectTab = function (tabNum) {
      var tabSelect = true
      if (tabNum > vm.tabNum || (tabNum !== vm.tabNum && !vm.addForm)) {
        tabSelect = vm.validateForm()
      }
      if (tabSelect && vm.tabs[vm.tabNum]) {
        vm.tabs[vm.tabNum].submit()
        if (vm.tabs[tabNum].isAvailiable()) {
          vm.tabNum = tabNum
          vm.tabs.forEach(function (t, tIndex) {
            tIndex === vm.tabNum ? t.select(true) : t.select(false)
          })
          if ($scope.tabChange) {
            $scope.tabChange(tabNum)
          }
        }
      }
    }

    vm.isFirstTab = function () { // check for first tab
      return vm.tabNum === 0
    }

    vm.isLastTab = function () { // check for last tab
      return vm.tabNum === vm.tabs.length - 1
    }

    vm.nextTab = function () { // validates current tab and select next tab
      if (vm.validateForm()) {
        vm.selectTab(vm.tabNum + 1)
      }
    }

    vm.previousTab = function () { // select previous tab
      vm.selectTab(vm.tabNum - 1)
    }

    /* calculate progress to indicate how many tabs are filled. */
    function calcProgress () {
      if (vm.tabNum === 0) {
        if (vm.tabs.length === 2)
          vm.progress = 50
        else
          vm.progress = 25
      } else {
        vm.progress = ((vm.tabNum + 1) / vm.tabs.length) * 100
      }
    }

    vm.cancel = function () { // back button click handler
      var tab = vm.tabs[vm.tabNum]
      if ($scope[tab.cancel]) {
        $scope[tab.cancel]()
      }
    }

    /* Save and Update button click handler */
    vm.save = function () {
      if (vm.validateForm()) {
        var tab = vm.tabs[vm.tabNum]
        if ($scope[tab.save]) {
          $scope[tab.save]()
        }
      }
    }

    /* validate current tab to check all fields are filled properly or not. */
    vm.validateForm = function () {
      var tab = vm.tabs[vm.tabNum]
      if ($scope[tab.validateForm]) {
        return $scope[tab.validateForm]()
      }
    }
  }
})();

(function () {
  'use strict';

  angular.module('Vibzer.theme.components')
    .directive('baWizardStep', baWizardStep);

  /** @ngInject */
  function baWizardStep() {
    return {
      restrict: 'E',
      transclude: true,
      require: '^baWizard',
      scope: {
        form: '='
      },
      templateUrl: 'app/theme/components/baWizard/baWizardStep.html',
      link: function ($scope, $element, $attrs, wizard) {
        $scope.selected = true;

        var tab = {
          title: $attrs.steptitle,
          select: select,
          submit: submit,
          isComplete: isComplete,
          isAvailiable: isAvailiable,
          prevTab: undefined,
          setPrev: setPrev,
          tabhide: $attrs.tabhide,
          save:$attrs.save,
          cancel:$attrs.cancel,
          validateForm:$attrs.validateform
        };

        wizard.addTab(tab);

        function select(isSelected) {
          if (isSelected) {
            $scope.selected = true;
          } else {
            $scope.selected = false;
          }
        }

        function submit() {
          $scope.form && $scope.form.$setSubmitted(true);
        }

        function isComplete() {
          return $scope.form ? $scope.form.$valid : true;
        }

        function isAvailiable() {
          return tab.prevTab ? tab.prevTab.isComplete() : true;
        }

        function setPrev(pTab) {
          tab.prevTab = pTab;
        }


      }
    };
  }
})();
(function () {
  'use strict';

  angular.module('Vibzer.theme.components')
      .directive('backTop', backTop);

  /** @ngInject */
  function backTop() {
    return {
      restrict: 'E',
      templateUrl: 'app/theme/components/backTop/backTop.html',
      controller: function () {
        $('#backTop').backTop({
          'position': 200,
          'speed': 100
        });
      }
    };
  }

})();
/**
 * @author v.lugovksy
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('Vibzer.theme.components')
    .controller('BaSidebarCtrl', BaSidebarCtrl);

  /** @ngInject */
  function BaSidebarCtrl ($rootScope, $scope, $state, $cookies, baSidebarService, constants) {
    $scope.webAppTexts = constants.webAppTexts
    $scope.menuItems = baSidebarService.getMenuItems();
    $scope.defaultSidebarState = $scope.menuItems[0].stateRef;

    $rootScope.$on('showOrHideSidebarMenu', function () {
      var distributorsSidebar = ['dashboard', 'customers', 'users', 'licenses', 'loginAsCustomer', 'devices', 'rpb']
      var customersSidebar = ['dashboard', 'machines', 'users', 'organization', 'licenses', 'routes', 'compositeMachines', 'devices', 'rpb']
      $state.get()
        .filter(function (s) {
          return s.sidebarMeta
        })
        .map(function (s) {
          if (!_.isEmpty($rootScope.user.distributorIds) && _.includes(distributorsSidebar, s.name)) {
            s.hide = false
            if (s.name === 'users') {
              s.hide = !$rootScope.user.permission.addDistributorUser
            }
          } else if (!_.isEmpty($rootScope.user.customerIds) && _.includes(customersSidebar, s.name)) {
            if (s.name === 'machines') {
              s.hide = !($rootScope.user.permission.canViewMachines || $rootScope.user.permission.canViewOwnedMachines)
            } else if (s.name === 'routes') {
              s.hide = !($rootScope.user.permission.viewRoutes)
            } else if (s.name === 'compositeMachines') {
              s.hide = !($rootScope.user.permission.viewComposites)
            } else if (s.name === 'devices') {
              s.hide = !($rootScope.user.permission.canViewMachines || $rootScope.user.permission.canViewOwnedMachines)
            } else {
              s.hide = false
            }
          } else {
            s.hide = true
          }
          if (s.name === 'rpb') {
            s.hide = !$rootScope.user.vibrationAnalyst
          }
          if (s.name === 'loginAsCustomer') {
            s.hide = !(($rootScope.user.distributorIds && $rootScope.user.distributorIds.length) || ($rootScope.user.tempCache && $rootScope.user.tempCache.distributorIds && $rootScope.user.tempCache.distributorIds.length))
            var cookie = $cookies.getObject('vcUser')
            if (cookie && cookie.tempCache) {
              s.title = cookie.tempCache.loggedInAs === 'distributor' ? $scope.webAppTexts.sidebarMenu.loginAsCustomer : $scope.webAppTexts.sidebarMenu.loginAsDistributor
            } else {
              s.title = $scope.webAppTexts.sidebarMenu.loginAsCustomer
            }
          }
          return s
        })
      $scope.menuItems = baSidebarService.getMenuItems()
    })

    $scope.hoverItem = function ($event) {
      $scope.showHoverElem = true;
      $scope.hoverElemHeight = $event.currentTarget.clientHeight;
      var menuTopValue = 66;
      $scope.hoverElemTop = $event.currentTarget.getBoundingClientRect().top - menuTopValue;
    };

    $scope.$on('$stateChangeSuccess', function () {
      if (baSidebarService.canSidebarBeHidden()) {
        baSidebarService.setMenuCollapsed(true);
      }
    });
  }
})();
/**
 * @author v.lugovksy
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('Vibzer.theme.components')
      .directive('baSidebar', baSidebar);

  /** @ngInject */
  function baSidebar($timeout, baSidebarService, baUtil, layoutSizes) {
    var jqWindow = $(window);
    return {
      restrict: 'E',
      templateUrl: 'app/theme/components/baSidebar/ba-sidebar.html',
      controller: 'BaSidebarCtrl',
      link: function(scope, el) {

        scope.menuHeight = el[0].childNodes[0].clientHeight - 84;
        jqWindow.on('click', _onWindowClick);
        jqWindow.on('resize', _onWindowResize);

        scope.$on('$destroy', function() {
          jqWindow.off('click', _onWindowClick);
          jqWindow.off('resize', _onWindowResize);
        });

        function _onWindowClick($evt) {
          if (!baUtil.isDescendant(el[0], $evt.target) &&
              !$evt.originalEvent.$sidebarEventProcessed &&
              !baSidebarService.isMenuCollapsed() &&
              baSidebarService.canSidebarBeHidden()) {
            $evt.originalEvent.$sidebarEventProcessed = true;
            $timeout(function () {
              baSidebarService.setMenuCollapsed(true);
            }, 10);
          }
        }

        // watch window resize to change menu collapsed state if needed
        function _onWindowResize() {
          var newMenuCollapsed = baSidebarService.shouldMenuBeCollapsed();
          var newMenuHeight = _calculateMenuHeight();
          if (newMenuCollapsed != baSidebarService.isMenuCollapsed() || scope.menuHeight != newMenuHeight) {
            scope.$apply(function () {
              scope.menuHeight = newMenuHeight;
              baSidebarService.setMenuCollapsed(newMenuCollapsed)
            });
          }
        }

        function _calculateMenuHeight() {
          return el[0].childNodes[0].clientHeight - 84;
        }
      }
    };
  }

})();
(function() {
  'use strict';

  angular.module('Vibzer.theme.components')
      .provider('baSidebarService', baSidebarServiceProvider);

  /** @ngInject */
  function baSidebarServiceProvider() {
    var staticMenuItems = [];

    this.addStaticItem = function() {
      staticMenuItems.push.apply(staticMenuItems, arguments);
    };

    /** @ngInject */
    this.$get = function($state, layoutSizes) {
      return new _factory();

      function _factory() {
        var isMenuCollapsed = shouldMenuBeCollapsed();

        this.getMenuItems = function() {
          var states = defineMenuItemStates();
          var menuItems = states.filter(function(item) {
            return item.level == 0 && !item.hide;
          });

          menuItems.forEach(function(item) {
            var children = states.filter(function(child) {
              return child.level == 1 && child.name.indexOf(item.name) === 0;
            });
            item.subMenu = children.length ? children : null;
          });

          return menuItems.concat(staticMenuItems);
        };

        this.shouldMenuBeCollapsed = shouldMenuBeCollapsed;
        this.canSidebarBeHidden = canSidebarBeHidden;

        this.setMenuCollapsed = function(isCollapsed) {
          isMenuCollapsed = isCollapsed;
        };

        this.isMenuCollapsed = function() {
          return isMenuCollapsed;
        };

        this.toggleMenuCollapsed = function() {
          isMenuCollapsed = !isMenuCollapsed;
        };

        this.getAllStateRefsRecursive = function(item) {
          var result = [];
          _iterateSubItems(item);
          return result;

          function _iterateSubItems(currentItem) {
            currentItem.subMenu && currentItem.subMenu.forEach(function(subItem) {
              subItem.stateRef && result.push(subItem.stateRef);
              _iterateSubItems(subItem);
            });
          }
        };

        function defineMenuItemStates() {
          return $state.get()
              .filter(function(s) {
                return s.sidebarMeta;
              })
              .map(function(s) {
                var meta = s.sidebarMeta;
                return {
                  name: s.name,
                  title: s.title,
                  level: (s.name.match(/\./g) || []).length,
                  order: meta.order,
                  icon: meta.icon,
                  stateRef: s.name,
                  hide: s.hide
                };
              })
              .sort(function(a, b) {
                return (a.level - b.level) * 100 + a.order - b.order;
              });
        }

        function shouldMenuBeCollapsed() {
          return window.innerWidth <= layoutSizes.resWidthCollapseSidebar;
        }

        function canSidebarBeHidden() {
          return window.innerWidth <= layoutSizes.resWidthHideSidebar;
        }
      }

    };

  }
})();

/**
 * @author v.lugovsky
 * created on 03.05.2016
 */
(function () {
  'use strict';

  angular.module('Vibzer.theme.components')
      .directive('baSidebarToggleMenu', baSidebarToggleMenu)
      .directive('baSidebarCollapseMenu', baSidebarCollapseMenu)
      .directive('baSidebarTogglingItem', baSidebarTogglingItem)
      .controller('BaSidebarTogglingItemCtrl', BaSidebarTogglingItemCtrl)
      .directive('baUiSrefTogglingSubmenu', baUiSrefTogglingSubmenu)
      .directive('baUiSrefToggler', baUiSrefToggler);

  /** @ngInject */
  function baSidebarToggleMenu(baSidebarService) {
    return {
      restrict: 'A',
      link: function(scope, elem) {
        elem.on('click', function($evt) {
          $evt.originalEvent.$sidebarEventProcessed = true;
          scope.$apply(function() {
            baSidebarService.toggleMenuCollapsed();
          });
        });
      }
    };
  }

  /** @ngInject */
  function baSidebarCollapseMenu(baSidebarService) {
    return {
      restrict: 'A',
      link: function(scope, elem) {
        elem.on('click', function($evt) {
          $evt.originalEvent.$sidebarEventProcessed = true;
          if (!baSidebarService.isMenuCollapsed()) {
            scope.$apply(function() {
              baSidebarService.setMenuCollapsed(true);
            });
          }
        });
      }
    };
  }

  /** @ngInject */
  function baSidebarTogglingItem() {
    return {
      restrict: 'A',
      controller: 'BaSidebarTogglingItemCtrl'
    };
  }

  /** @ngInject */
  function BaSidebarTogglingItemCtrl($scope, $element, $attrs, $state, baSidebarService) {
    var vm = this;
    var menuItem = vm.$$menuItem = $scope.$eval($attrs.baSidebarTogglingItem);
    if (menuItem && menuItem.subMenu && menuItem.subMenu.length) {
      vm.$$expandSubmenu = function() { console.warn('$$expandMenu should be overwritten by baUiSrefTogglingSubmenu') };
      vm.$$collapseSubmenu = function() { console.warn('$$collapseSubmenu should be overwritten by baUiSrefTogglingSubmenu') };

      var subItemsStateRefs = baSidebarService.getAllStateRefsRecursive(menuItem);

      vm.$expand = function() {
        vm.$$expandSubmenu();
        $element.addClass('ba-sidebar-item-expanded');
      };

      vm.$collapse = function() {
        vm.$$collapseSubmenu();
        $element.removeClass('ba-sidebar-item-expanded');
      };

      vm.$toggle = function() {
        $element.hasClass('ba-sidebar-item-expanded') ?
            vm.$collapse() :
            vm.$expand();
      };

      if (_isState($state.current)) {
        $element.addClass('ba-sidebar-item-expanded');
      }

      $scope.$on('$stateChangeStart', function (event, toState) {
        if (!_isState(toState) && $element.hasClass('ba-sidebar-item-expanded')) {
          vm.$collapse();
          $element.removeClass('ba-sidebar-item-expanded');
        }
      });

      $scope.$on('$stateChangeSuccess', function (event, toState) {
        if (_isState(toState) && !$element.hasClass('ba-sidebar-item-expanded')) {
          vm.$expand();
          $element.addClass('ba-sidebar-item-expanded');
        }
      });
    }

    function _isState(state) {
      return state && subItemsStateRefs.some(function(subItemState) {
            return state.name.indexOf(subItemState) == 0;
          });
    }
  }

  /** @ngInject */
  function baUiSrefTogglingSubmenu($state) {
    return {
      restrict: 'A',
      require: '^baSidebarTogglingItem',
      link: function(scope, el, attrs, baSidebarTogglingItem) {
        baSidebarTogglingItem.$$expandSubmenu = function() { el.slideDown(); };
        baSidebarTogglingItem.$$collapseSubmenu = function() { el.slideUp(); };
      }
    };
  }

  /** @ngInject */
  function baUiSrefToggler(baSidebarService) {
    return {
      restrict: 'A',
      require: '^baSidebarTogglingItem',
      link: function(scope, el, attrs, baSidebarTogglingItem) {
        el.on('click', function() {
          if (baSidebarService.isMenuCollapsed()) {
            // If the whole sidebar is collapsed and this item has submenu. We need to open sidebar.
            // This should not affect mobiles, because on mobiles sidebar should be hidden at all
            scope.$apply(function() {
              baSidebarService.setMenuCollapsed(false);
            });
            baSidebarTogglingItem.$expand();
          } else {
            baSidebarTogglingItem.$toggle();
          }
        });
      }
    };
  }

})();

/**
 * @author v.lugovksy
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('Vibzer.theme.components')
    .directive('pageTop', pageTop);

  /** @ngInject */
  function pageTop($state, $location) {
    return {
      restrict: 'E',
      controller: 'PageTopCtrl',
      link: function ($scope) {
        $scope.$watch(function () {
          $scope.activePageTitle = $state.current.title
        })
      },
      templateUrl: 'app/theme/components/pageTop/pageTop.html'
    }
  }
})();
(function () {
  'use strict';

  angular.module('Vibzer.theme.components')
    .controller('PageTopCtrl', pageTopCtrl)

  /** @ngInject */
  function pageTopCtrl ($scope, $state, $cookies, $rootScope, UserService) {
    $scope.user = $cookies.getObject('vcUser')
    $scope.logout = function () {
      $rootScope.$broadcast('clearNotifications')
      $scope.notify = true
      UserService.logout()
      $state.go('login')
    }

    // show user profile
    $scope.showProfile = function () {
      $state.go('profile')
    }
    $scope.showSettings = function () {
      $state.go('viewUserSetting')
    }
  }
})();
/**
 * Created by n.poltoratsky
 * on 28.06.2016.
 */
(function () {
    'use strict';

    angular.module('Vibzer.theme.components')
        .directive('progressBarRound', progressBarRound);

    /** @ngInject */
    function progressBarRound(baProgressModal) {
        return {
            restrict: 'E',
            templateUrl: 'app/theme/components/progressBarRound/progressBarRound.html',
            link:function($scope, element, attrs) {
                $scope.baProgressDialog = baProgressModal;
                $scope.$watch(function () {
                    return baProgressModal.getProgress();
                }, animateBar);

                function animateBar() {
                    var circle = element.find('#loader')[0];
                    circle.setAttribute("stroke-dasharray", baProgressModal.getProgress() * 180 * Math.PI / 100 + ", 20000");
                    $scope.progress = baProgressModal.getProgress();
                }
            }
        }
    }
})();
/**
 * @author v.lugovksy
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('Vibzer.theme.components')
      .directive('widgets', widgets);

  /** @ngInject */
  function widgets() {
    return {
      restrict: 'EA',
      scope: {
        ngModel: '='
      },
      templateUrl: 'app/theme/components/widgets/widgets.html',
      replace: true
    };
  }

})();
(function () {
  'use strict';

  angular.module('Vibzer.theme.components')
    .directive('contentTop', contentTop);

  /** @ngInject */
  function contentTop($location, $state) {
    return {
      restrict: 'E',
      templateUrl: 'app/theme/components/contentTop/contentTop.html',
      link: function ($scope) {
        $scope.$watch(function () {
          $scope.activePageTitle = $state.current.title;
        });
      }
    };
  }

})();
/**
 * @author v.lugovsky
 * created on 10.12.2016
 */
(function () {
  'use strict';

  angular.module('Vibzer.theme.inputs')
      .directive('baSwitcher', baSwitcher);

  /** @ngInject */
  function baSwitcher() {
    return {
      templateUrl: 'app/theme/inputs/baSwitcher/baSwitcher.html',
      scope: {
        switcherStyle: '@',
        switcherValue: '='
      }
    };
  }

})();

/**
 * @author a.demeshko
 * created on 23.12.2015
 */
(function () {
  'use strict';

  angular.module('Vibzer.theme')
    .filter('plainText', plainText);

  /** @ngInject */
  function plainText() {
    return function(text) {
      return  text ? String(text).replace(/<[^>]+>/gm, '') : '';
    };
  }

})();

/**
 * @author v.lugovsky
 * created on 17.12.2015
 */
(function () {
  'use strict';

  angular.module('Vibzer.theme')
      .filter('appImage', appImage);

  /** @ngInject */
  function appImage(layoutPaths) {
    return function(input) {
      return layoutPaths.images.root + input;
    };
  }

})();

/**
 * @author v.lugovsky
 * created on 17.12.2015
 */
(function () {
  'use strict';

  angular.module('Vibzer.theme')
      .filter('kameleonImg', kameleonImg);

  /** @ngInject */
  function kameleonImg(layoutPaths) {
    return function(input) {
      return layoutPaths.images.root + 'theme/icon/kameleon/' + input + '.svg';
    };
  }

})();

/**
 * @author v.lugovsky
 * created on 17.12.2015
 */
(function () {
  'use strict';

  angular.module('Vibzer.theme')
      .filter('profilePicture', profilePicture);

  /** @ngInject */
  function profilePicture(layoutPaths) {
    return function(input, ext) {
      ext = ext || 'png';
      return layoutPaths.images.profile + input + '.' + ext;
    };
  }

})();

(function () {
  'use strict'
  var angular = window.angular
  var _ = window._
  angular.module('Vibzer.components.machines')
    .controller('RawChartCtrl', ['$scope', '$uibModalInstance', 'constants', 'machineData', 'ReportService', 'ReadingService', function ($scope, $uibModalInstance, constants, machineData, ReportService, ReadingService) {
      var xAxisDividationValue = 3903.20
      $scope.combinationWave = false
      $scope.isSinglePoint = false
      $scope.optionLabels = []
      $scope.legendsLabel = {}
      $scope.machineDetails = machineData
      $scope.machineType = $scope.machineDetails.machineTypeId.name
      $scope.isMonPoint = $scope.machineType === 'machine'
      if (!$scope.isMonPoint) {
        // check for updated portable points
        if (machineData && machineData.readingType === 1 && machineData.meta.portablePoints && machineData.meta.portablePoints.length) {
          $scope.machineDetails.meta.points = angular.copy(machineData.meta.portablePoints)
        }
        $scope.selected = {
          point: $scope.machineDetails.meta.points[0]
        }
        $scope.isSinglePoint = $scope.machineDetails.meta.points.length === 1
      }
      var name
      $scope.fromReview = true

      $scope.filterValues = [
        {
          id: 0,
          internalName: 'mix',
          displayName: 'Overlap Waves',
          count: 'X,Y,Z',
          isFilterActive: true,
          onClickHandler: toggleFilter,
          display: true
        }
      ]

      /* Initialize vibration points for all machines except monitoring point. */
      $scope.initMotorPoints = function () {
        $scope.selectedPoints = $scope.machineDetails.vibrations.machinePoints || []
        $scope.allPoints = constants.machineVibrationPointsMap
        _.forEach($scope.allPoints, function (pointData, index) {
          if (_.includes($scope.selectedPoints, pointData.point)) {
            pointData.active = false
            pointData.showPoint = true
          } else {
            pointData.showPoint = false
            pointData.active = true
          }
        })
      }

      /* Initialize vibration points for monitoring point. */
      $scope.initMachinePoints = function () {
        $scope.allPoints = [{ point: 'x', axis: 'X', active: false, showPoint: true }, { point: 'y', axis: 'Y', active: false, showPoint: true }, { point: 'z', axis: 'Z', active: false, showPoint: true }]
      }

      $scope.updatePoints = function (data) {
        $scope.allPoints = _.map($scope.allPoints, function (pointData, index) {
          if (_.includes($scope.selectedPoints, pointData.point)) {
            pointData.active = true
          } else {
            pointData.active = true
          }
          return pointData
        })
      }

      /* Updates graph depends on selected axis */
      $scope.changeGraph = function (pointData) {
        $scope.allPoints = _.map($scope.allPoints, function (item, index) {
          if (pointData.point === item.point) {
            if (item.active) {
              _.pull($scope.selectedPoints, pointData.point)
            } else {
              $scope.selectedPoints.push(pointData.point)
            }
            item.active = !item.active
          }
          return item
        })
        var combineWaveData = createCombineWaveData($scope.selectedPoints)
        drawWaveChart('combine', combineWaveData)
        setTimeout(function () {
          ReportService.setChartModelHeight()
        }, 200)
      }

      /* Updates graph after changing the reading point */
      $scope.changePoint = function () {
        $scope.init()
      }

      function toggleFilter (filter) {
        _.each($scope.filterValues, function (object) {
          object.isFilterActive = false
        })
        $scope.filterValues[filter.id].isFilterActive = true
        $scope.combinationWave = true
        $scope.isMonPoint ? $scope.initMachinePoints() : $scope.initMotorPoints()
        $scope.selectedPoints = []
        var combineWaveData = createCombineWaveData($scope.selectedPoints)
        drawWaveChart('combine', combineWaveData)
      }

      /* Create wave data to plot graph */
      function createCombineWaveData (points) {
        if (points.length < 1) {
          $scope.legendsLabel = {}
          return []
        }
        $scope.optionLabels = getOptionLabels(points)
        $scope.legendsLabel = getLegendsForGraph(points)
        if ($scope.machineType === constants.typesOfMachine[4].name) { // machine
          var data = $scope.machineDetails.vibrations[name]
        } else {
          data = $scope.machineDetails.vibrations
        }
        var combineWaveData = _.times(12288, function (numberIndex) {
          var array = [(numberIndex / xAxisDividationValue)]
          _.forEach(points, function (point) {
            array.push(data[point][numberIndex])
          })
          return array
        }) || []
        return combineWaveData
      }

      /* Get option labels for graph */
      function getOptionLabels (points) {
        var array = ['x']
        _.map(points, function (point, index) {
          array.push(String.fromCharCode(65 + index))
        })
        return array
      }

      /* Get legend labels for graph */
      function getLegendsForGraph (points) {
        var legends = {}
        _.map(points, function (point, index) {
          var pointLable = {
            label: 'Amplitude For ' + point + '-point'
          }
          legends[String.fromCharCode(65 + index)] = pointLable
        })
        return legends
      }

      /* Show tooltip for graph */
      $scope.tooltipToggle = function (showToolTip) {
        $scope.graph.options.showPopover = showToolTip
      }
      /* Start of wave */
      function drawWaveChart (point, data) {
        // $scope.graph.data = data
        $scope.graph = {
          data: data,
          options: {
            labels: $scope.optionLabels,
            animatedZooms: false,
            showRangeSelector: true,
            interactionModel: window.Dygraph.defaultInteractionModel,
            xlabel: 'Time [s]',
            ylabel: 'Amplitude',
            showPopover: $scope.showToolTip || false,
            highlightCallback: function (a, b, point) {
              ReportService.getValuesOfCurrentPoint($scope, point)
              ReportService.setChartModelHeight()
            },
            legendColumn: 'legendColumn',
            legendColumnContainer: 'legendColumnContainer'
          },
          resetValues: function () {
            ReportService.resetValuesOfCurrentPoint($scope)
          },
          legend: {
            dateFormat: constants.dateFormats.default,
            series: $scope.legendsLabel
          }
        }
        setTimeout(function () {
          window.dygraphApi.resize()
        }, 200)
      }
      /* End of wave */

      /* Initial graph options */
      $scope.graph = {
        options: {
          labels: $scope.optionLabels,
          animatedZooms: false,
          showRangeSelector: true,
          interactionModel: window.Dygraph.defaultInteractionModel,
          xlabel: 'Time [s]',
          ylabel: 'Amplitude',
          showPopover: $scope.showToolTip || false,
          highlightCallback: function (a, b, point) {
            ReportService.getValuesOfCurrentPoint($scope, point)
            ReportService.setChartModelHeight()
          },
          legendColumn: 'legendColumn',
          legendColumnContainer: 'legendColumnContainer'
        },
        resetValues: function () {
          ReportService.resetValuesOfCurrentPoint($scope)
        },
        legend: {
          dateFormat: constants.dateFormats.default,
          series: $scope.legendsLabel
        }
      }

      /* dygraph control. Get vibration data for displaying graph. */
      $scope.init = function () {
        var params = {
          machineId: machineData._id,
          sessionId: machineData.sessionId
        }
        if (!$scope.isMonPoint) {
          params.pointSet = parseInt($scope.selected.point.internalName)
        }
        ReadingService.resource.getVibrationDataForGraph(params, function (res) {
          $scope.machineDetails.vibrations = res
          if ($scope.isMonPoint) {
            name = _.keys($scope.machineDetails.vibrations)[0]
            $scope.initMachinePoints()
          } else {
            _.map($scope.machineDetails.vibrations, function (value, key) {
              if (_.isArray(value) && value.length > 20) {
                name = key
              }
            })
            $scope.initMotorPoints()
          }
          toggleFilter($scope.filterValues[0])
        })
      }
      /* dygraph control ends here */
      $scope.init()
      $scope.expandModel = false
      $scope.toggleModel = function () {
        $scope.expandModel = !$scope.expandModel
        ReportService.expandShrinkModel($scope.expandModel)
      }
      angular.element(document).ready(function () {
        ReportService.setChartModelHeight()
      })
      $scope.confirm = function () {
        $uibModalInstance.close()
      }

      $scope.closeModal = function () {
        $uibModalInstance.dismiss()
      }
    }])
})();
(function () {
  'use strict'
  var angular = window.angular
  angular.module('Vibzer.components.machines')
    .controller('SpectrumChartCtrl', SpectrumChartCtrl);

  // @NgInject
  function SpectrumChartCtrl ($scope, $uibModalInstance, $cookies, ReadingService, ReportService, machineData, constants) {
    $scope.user = $cookies.getObject('vcUser')
    $scope.machineData = machineData
    $scope.isSinglePoint = false
    $scope.isMonPoint = $scope.machineData.machineTypeId.name === 'machine'
    $scope.severityUnits = constants.severityUnits
    $scope.selected = {
      severityUnit: $scope.user && $scope.user.setting && $scope.user.setting.reports ? _.find($scope.severityUnits, { internalName: $scope.user.setting.reports.severityUnit }) : $scope.severityUnits[0]
    }
    if (!$scope.isMonPoint) {
      // Ensure meta object exists
      if (!$scope.machineData.meta) {
        $scope.machineData.meta = {}
      }
      // check for updated portable points (for readingType === 1)
      if (machineData && machineData.readingType === 1 && machineData.meta && machineData.meta.portablePoints && machineData.meta.portablePoints.length) {
        $scope.machineData.meta.points = angular.copy(machineData.meta.portablePoints)
      }
      // Initialize points if not already set (from regular points array)
      if (!$scope.machineData.meta.points && machineData.meta && machineData.meta.points && machineData.meta.points.length) {
        $scope.machineData.meta.points = angular.copy(machineData.meta.points)
      }
      // Initialize selected point if points are available
      if ($scope.machineData.meta && $scope.machineData.meta.points && $scope.machineData.meta.points.length) {
        $scope.selected.point = $scope.machineData.meta.points[0]
        $scope.isSinglePoint = $scope.machineData.meta.points.length === 1
      }
    }
    // window.moment = null
    var xAxisMultiplicationValue = 0.9621 // 0.9676 // 0.3005
    $scope.chartTitle = 'Spectrum Chart: ' + $scope.machineData.sessionName
    $scope.changePoint = function () {
      $scope.init()
    }
    $scope.changeSeverityUnit = function () {
      drawSpectrumChart('H,V,A', createMixChartData(machineData.spectrum.x, machineData.spectrum.y, machineData.spectrum.z))
    }
    // Track if this is the initial load
    var isInitialLoad = true
    $scope.init = function () {
      $scope.loading = true
      var params = {
        machineId: machineData._id,
        sessionId: machineData.sessionId
      }
      
      // Always include pointSet for portable machines (non-monitoring points)
      // This matches the behavior of existing spectrum and wave charts (same as rawChartCtrl)
      if (!$scope.isMonPoint) {
        // Ensure selected.point is initialized if not set
        if (!$scope.selected || !$scope.selected.point) {
          if ($scope.machineData.meta && $scope.machineData.meta.points && $scope.machineData.meta.points.length) {
            $scope.selected = $scope.selected || {}
            $scope.selected.point = $scope.machineData.meta.points[0]
          }
        }
        // Include pointSet in params - same logic as rawChartCtrl
        // rawChartCtrl directly uses: params.pointSet = parseInt($scope.selected.point.internalName)
        if ($scope.selected && $scope.selected.point && $scope.selected.point.internalName !== undefined && $scope.selected.point.internalName !== null) {
          params.pointSet = parseInt($scope.selected.point.internalName)
        } else if ($scope.machineData.meta && $scope.machineData.meta.points && $scope.machineData.meta.points.length) {
          // Fallback: use first point's internalName if selected.point is not available
          var firstPoint = $scope.machineData.meta.points[0]
          if (firstPoint && firstPoint.internalName !== undefined && firstPoint.internalName !== null) {
            params.pointSet = parseInt(firstPoint.internalName)
          }
        }
      }
      
      // Check if we should use pre-calculated data (only on initial load and if point matches)
      var currentPointSet = params.pointSet
      var usePreCalculated = isInitialLoad && 
                             machineData.usePreCalculatedData && 
                             machineData.spectrum && 
                             machineData.overallValues &&
                             (!machineData.originalPointSet || currentPointSet === parseInt(machineData.originalPointSet))
      
      if (usePreCalculated) {
        // Use pre-calculated data only on initial load with matching point
        drawSpectrumChart('H,V,A', createMixChartData(machineData.spectrum.x, machineData.spectrum.y, machineData.spectrum.z))
        $scope.loading = false
        setTimeout(function () {
          ReportService.setChartModelHeight()
        }, 200)
        isInitialLoad = false
        return
      }
      
      // Mark that initial load is done
      isInitialLoad = false
      
      var cal = machineData.calibartionConstants
      var hasAxisShape = cal && cal.x && cal.y && cal.z
      if (hasAxisShape) {
        params.calibartionConstants = typeof cal === 'string' ? cal : JSON.stringify(cal)
        
        ReadingService.resource.getCalibrationData(params, function (res) {
          // Check if response contains error message
          if (res && res.msg) {
            $scope.loading = false
            alert('Error: ' + res.msg)
            return
          }
          if (res && res.spectrum && res.overallValues) {
            machineData.spectrum = res.spectrum
            machineData.overallValues = res.overallValues
            drawSpectrumChart('H,V,A', createMixChartData(machineData.spectrum.x, machineData.spectrum.y, machineData.spectrum.z))
          }
          $scope.loading = false
          setTimeout(function () {
            ReportService.setChartModelHeight()
          }, 200)
        }, function (err) {
          $scope.loading = false
          var errorMsg = 'Failed to load calibration data'
          if (err && err.data && err.data.msg) {
            errorMsg = err.data.msg
          } else if (err && err.msg) {
            errorMsg = err.msg
          }
          alert('Error: ' + errorMsg)
        })
      } else {
        // Use original API for normal chart viewing
        params.customerId = machineData.customerId
        params.type = machineData.chartType
        ReadingService.resource.processedVibrationDataOfPoint(params, function (res) {
          machineData.spectrum = res.spectrum
          machineData.overallValues = res.overallValues
          drawSpectrumChart('H,V,A', createMixChartData(machineData.spectrum.x, machineData.spectrum.y, machineData.spectrum.z))
          $scope.loading = false
          setTimeout(function () {
            ReportService.setChartModelHeight()
          }, 200)
        }, function (err) {
          $scope.loading = false
          console.log(err)
        })
      }
    }
    $scope.confirm = function () {
      $uibModalInstance.close()
    }

    // -- window.dygraph Chart control --
    function createMixChartData (xData, yData, zData) {
      var devideFactor = $scope.selected.severityUnit.divideFactor
      return _.times(machineData.spectrum.x.length, function (index) {
        if (index < 2) {
          xData[index] = 0
          yData[index] = 0
          zData[index] = 0
          return [((index + 1) * xAxisMultiplicationValue), undefined, undefined, undefined]
        } else {
          return [((index + 1) * xAxisMultiplicationValue), xData[index] / devideFactor, yData[index] / devideFactor, zData[index] / devideFactor]
        }
      })
    }

    $scope.tooltipToggle = function (showToolTip) {
      $scope.graph.options.showPopover = showToolTip
    }
    $scope.graph = {
      data: [],
      options: {
        labels: ['x', 'A', 'B', 'C'],
        showRangeSelector: true,
        animatedZooms: false,
        interactionModel: window.Dygraph.defaultInteractionModel,
        xlabel: 'Frequency [Hz]',
        ylabel: 'Severity [' + $scope.selected.severityUnit.displayName + ' RMS]',
        showPopover: false,
        highlightCallback: function (a, b, point) {
          ReportService.getValuesOfCurrentPoint($scope, point)
          ReportService.setChartModelHeight()
        },
        legendColumn: 'legendColumn',
        legendColumnContainer: 'legendColumnContainer'
      },
      resetValues: function () {
        ReportService.resetValuesOfCurrentPoint($scope)
      },
      legend: {
        dateFormat: constants.dateFormats.default,
        series: {
          A: {
            label: 'Severity for X-axis'
          },
          B: {
            label: 'Severity for Y-axis'
          },
          C: {
            label: 'Severity for Z-axis'
          }
        }
      }
    }
    function drawSpectrumChart (axis, data) {
      $scope.graph.overallVibrations = _.map(machineData.overallValues, function (value, key) {
        return { axis: 'Overall vibration for ' + key.toUpperCase() + '-axis', value: (value / $scope.selected.severityUnit.divideFactor).toFixed(2) + ' ' + $scope.selected.severityUnit.displayName + ' RMS' }
      })
      $scope.graph.data = data
      $scope.graph.options.ylabel = 'Severity [' + $scope.selected.severityUnit.displayName + ' RMS]'
      setTimeout(function () {
        window.dygraphApi.resize()
      }, 200)
    }
    $scope.init()
    $scope.expandModel = false
    $scope.toggleModel = function () {
      $scope.expandModel = !$scope.expandModel
      ReportService.expandShrinkModel($scope.expandModel)
    }
    angular.element(document).ready(function () {
      ReportService.setChartModelHeight()
    })
  }
})();
(function () {
  'use strict'
  var angular = window.angular
  var _ = window._
  angular.module('Vibzer.components.machines.sessions')
    .controller('ViewCriteriaAnalysisCtrl', ViewCriteriaAnalysisCtrl)

  /** @ngInject */
  function ViewCriteriaAnalysisCtrl($scope, $uibModalInstance, constants, ReportService, reportData) {
    $scope.reportData = reportData
    $scope.dateFormat = constants.dateFormats.default
    $scope.isMonMachine = reportData.machineType === 'machine'
    $scope.reportData.condition = _.find(constants.machineStates, { id: reportData.condition }).displayName
    $scope.useClassContainer = false
    $scope.closeModal = function () {
      $uibModalInstance.dismiss()
    }
    /* Create row wise array of received data from server to generate table */
    var createTableData = function (data) {
      var tableData = []
      var totalPoint = data.readings.length
      var tableHeads = ['criteria', 'fault', 'point', 'axis', 'current', 'avg', 'stdev', 'axisCondition', 'criteriaCondition']
      var tableTr = {}
      if (!$scope.isMonMachine) {
        /* Creating row for expert system criteria */
        _.forEach(tableHeads, function (itm) {
          tableTr[itm] = '-'
        })
        tableTr.criteria = 'Expert - system'
        var currentCondition = _.find(constants.machineStates, { id: data.report.statistical.report.finalSeverity <= 3 ? 1 : (data.report.statistical.report.finalSeverity === 4 ? 2 : 3) })
        tableTr.criteriaCondition = currentCondition.displayName
        tableTr.criteriaColor = currentCondition.color
        tableData.push(tableTr)
        tableTr = {}
        /* Creating rows for fault-specific criteria */
        tableTr.criteriaRowSpan = 12 * totalPoint
        var currentTableLength = tableData.length
        tableTr.criteria = 'Fault-Specific'
        _.forEach(constants.trendWithFaults, function (fault) {
          tableTr.fault = fault.displayName
          tableTr.faultRowSpan = 3 * totalPoint
          _.forEach(data.readings, function (reading) {
            var point = reading.pointSet === 1 ? 'Free End/Outboard' : 'Load End/Inboard'
            tableTr.point = point
            tableTr.pointRowSpan = 3
            _.forEach(['x', 'y', 'z'], function (axis) {
              tableTr.axis = axis
              /* setting current average and standard deviation data for axis */
              tableTr.current = reading.faultSpecific[fault.internalName].current[axis].toFixed(2)
              tableTr.avg = reading.faultSpecific[fault.internalName].avg ? reading.faultSpecific[fault.internalName].avg[axis].toFixed(2) : 'N/A'
              tableTr.stdev = reading.faultSpecific[fault.internalName].stdev ? reading.faultSpecific[fault.internalName].stdev[axis].toFixed(2) : 'N/A'
              var currentCondition = _.find(constants.machineStates, { id: data.report.faultSpecificConditions[fault.internalName][reading.pointSet][axis] })
              tableTr.axisCondition = currentCondition.displayName
              tableTr.axisColor = currentCondition.color
              if (currentTableLength === tableData.length) {
                /* setting criteria condition for fault specific */
                currentCondition = _.find(constants.machineStates, { id: data.report.faultSpecificConditions.maxCondition })
                tableTr.criteriaCondition = currentCondition.displayName
                tableTr.criteriaColor = currentCondition.color
              }
              tableData.push(tableTr)
              tableTr = {}
            })
          })
        })
      }
      /* Creating rows for crest-factor criteria */
      tableTr.criteria = 'CrestFactor'
      tableTr.fault = '-'
      tableTr.criteriaRowSpan = 3 * totalPoint
      tableTr.faultRowSpan = 3 * totalPoint
      _.forEach(data.readings, function (reading) {
        var point = reading.pointSet === 1 ? 'Free End/Outboard' : (!reading.pointSet ? '-' : 'Load End/Inboard')
        tableTr.point = point
        tableTr.pointRowSpan = 3
        currentTableLength = tableData.length
        _.forEach(['x', 'y', 'z'], function (axis) {
          tableTr.axis = axis
          /* setting current average and standard deviation data for axis */
          tableTr.current = reading.crestFactor.current[axis].toFixed(2)
          tableTr.avg = reading.crestFactor.avg[axis].toFixed(2)
          tableTr.stdev = reading.crestFactor.stdev[axis].toFixed(2)
          var currentCondition = _.find(constants.machineStates, { id: data.report.crestFactorAxisCondition[axis + (reading.pointSet || '')] })
          tableTr.axisCondition = currentCondition.displayName
          tableTr.axisColor = currentCondition.color
          if (currentTableLength === tableData.length) {
            /* setting criteria condition for crest factor */
            currentCondition = _.find(constants.machineStates, { id: _.max(_.values(data.report.crestFactorAxisCondition)) })
            tableTr.criteriaCondition = currentCondition.displayName
            tableTr.criteriaColor = currentCondition.color
          }
          tableData.push(tableTr)
          tableTr = {}
        })
      })
      if ($scope.isMonMachine) {
        /* Creating rows for overall vibration criteria */
        tableTr.criteria = 'overallVibration'
        tableTr.criteriaRowSpan = 3 * totalPoint
        tableTr.fault = '-'
        tableTr.faultRowSpan = 3 * totalPoint
        _.forEach(data.readings, function (reading) {
          var point = reading.pointSet === 1 ? 'Free End/Outboard' : (!reading.pointSet ? '-' : 'Load End/Inboard')
          tableTr.point = point
          tableTr.pointRowSpan = 3
          currentTableLength = tableData.length
          _.forEach(['x', 'y', 'z'], function (axis) {
            tableTr.axis = axis
            /* setting current average and standard deviation data for axis */
            tableTr.current = reading.overallVibration.current[axis].toFixed(2)
            tableTr.avg = reading.overallVibration.avg ? reading.overallVibration.avg[axis].toFixed(2) : 'N/A'
            tableTr.stdev = reading.overallVibration.stdev ? reading.overallVibration.stdev[axis].toFixed(2) : 'N/A'
            var currentCondition = _.find(constants.machineStates, { id: data.report.overallAxisCondition[axis + (reading.pointSet || '')] })
            tableTr.axisCondition = currentCondition.displayName
            tableTr.axisColor = currentCondition.color
            if (currentTableLength === tableData.length) {
              /* setting criteria condition for overall vibration */
              currentCondition = _.find(constants.machineStates, { id: _.max(_.values(data.report.overallAxisCondition)) })
              tableTr.criteriaCondition = currentCondition.displayName
              tableTr.criteriaColor = currentCondition.color
            }
            tableData.push(tableTr)
            tableTr = {}
          })
        })
      }
      $scope.tableData = tableData
    }

    /* Getting criteria wise analysis data from server for session */
    ReportService.resource.criteriaWiseAnalysis({ sessionId: reportData.sessionId, machineId: reportData.machineId }, function (res) {
      createTableData(res)
    }, function (err) {
      console.log(err)
    })
  }
})();

(function () {
  'use strict';
  var angular = window.angular
  var _ = window._
  angular.module('Vibzer.components.machines.sessions')
    .controller('ViewReportCtrl', ViewReportCtrl);

  /** @ngInject */
  function ViewReportCtrl ($scope, $uibModalInstance, $cookies, constants, ReportService, reportData) {
    var user = $cookies.getObject('vcUser')
    $scope.reportData = reportData
    $scope.machineType = $scope.reportData.machineType
    $scope.sessionName = reportData.sessionId ? reportData.sessionName : ''
    $scope.useClassContainer = false
    $scope.dateFormat = constants.dateFormats.default
    $scope.comments = []

    /* Get current and last session report */
    function init () {
      var queryParams = {}
      reportData.machineId ? queryParams.machineId = reportData.machineId : queryParams.sessionId = reportData.sessionId 
      ReportService.resource.getCurrentAndLastReport(queryParams, function (res) {
        $scope.reportData = res
        reportData.machineId ? $scope.sessionName = 'S- ' + moment(res.createdOn).format('MM-DD-YY HH:mm:ss') : void 0
        if (res.uploader) {
          $scope.takenBy = 'Captured by: ' + res.uploader.firstName + ' ' + res.uploader.lastName
        }
        $scope.comments = res.comments ? res.comments : []
        $scope.reportData.type = $scope.machineType
        $scope.currentReportExpSysVersion = res.expertSystemVersion || '3.0.0'
        $scope.machineInfo = res.machineData
        $scope.machineInfo.machineType = _.find(constants.typesOfMachine, { name: $scope.machineInfo.machineType }).displayName
        _.isEmpty(res.lastReport) ? $scope.noLastReport = true : $scope.noLastReport = false
        $scope.reportProperties = ReportService.generateReportData(res.statistical, res.lastReport, constants, $scope.machineType + 'Report')

        if (reportData.type !== constants.typesOfMachine[4].name) {
          var sortedReport = $scope.reportProperties.slice(0, $scope.reportProperties.length - 1)
          sortedReport = _.sortBy(sortedReport, 'Current').reverse()
          var firstIndex = _.findIndex(sortedReport, { 'recLength': 0 })
          sortedReport.splice(firstIndex, 0, $scope.reportProperties[$scope.reportProperties.length - 1])
          $scope.reportProperties = sortedReport
        }
      }, function (err) {
        console.log(err)
      })
    }

    /* Button click handler for show more or less details */
    $scope.toggleShowExcellent = function () {
      $scope.showExcellent = !$scope.showExcellent
    }

    /* Show thick line after all properties */
    $scope.isFinalSeverity = function (index, checkBelow) {
      return $scope.reportProperties[index].severityName === constants.motorReportPropertiesSequence[5].severityName || (index + 1 < $scope.reportProperties.length && $scope.reportProperties[index + 1].severityName === constants.motorReportPropertiesSequence[5].severityName && checkBelow)
    }

    init()

    /* Push comment in comments array and save it in database */
    $scope.addComment = function () {
      var data = {
        machineId: $scope.machineInfo._id,
        sessionId: $scope.reportData._id,
        comment: {
          message: $scope.reportComment
        }
      }
      ReportService.resource.addComment(data, function (res) {
        $scope.comments.push({ message: $scope.reportComment, uploadedBy: user })
        $scope.reportComment = ''
      })
    }

    $scope.closeModal = function () {
      $uibModalInstance.dismiss()
    }
  }
})();

(function () {
  'use strict'
  var angular = window.angular
  angular.module('Vibzer.components.machines')
    .controller('WaveChartCtrl', waveChartCtrl);

  // @NgInject
  function waveChartCtrl ($scope, $uibModalInstance, ReadingService, ReportService, machineData, constants) {
    $scope.machineData = machineData
    $scope.isMonPoint = $scope.machineData.machineTypeId.name === 'machine'
    $scope.isSinglePoint = false
    if (!$scope.isMonPoint) {
      // Ensure meta object exists
      if (!$scope.machineData.meta) {
        $scope.machineData.meta = {}
      }
      // check for updated portable points (for readingType === 1)
      if (machineData && machineData.readingType === 1 && machineData.meta && machineData.meta.portablePoints && machineData.meta.portablePoints.length) {
        $scope.machineData.meta.points = angular.copy(machineData.meta.portablePoints)
      }
      // Initialize points if not already set (from regular points array)
      if (!$scope.machineData.meta.points && machineData.meta && machineData.meta.points && machineData.meta.points.length) {
        $scope.machineData.meta.points = angular.copy(machineData.meta.points)
      }
      if ($scope.machineData.meta && $scope.machineData.meta.points && $scope.machineData.meta.points.length) {
        $scope.selected = {
          point: $scope.machineData.meta.points[0]
        }
        $scope.isSinglePoint = $scope.machineData.meta.points.length === 1
      }
    }
    // window.moment = null
    $scope.chartTitle = 'Wave Chart: ' + $scope.machineData.sessionName
    var dividingFactor = 3903.20
    $scope.changePoint = function () {
      $scope.init()
    }
    // Track if this is the initial load
    var isInitialLoad = true
    $scope.init = function () {
      $scope.loading = true
      var params = {
        machineId: machineData._id,
        sessionId: machineData.sessionId
      }
      
      // Always include pointSet for portable machines (non-monitoring points)
      // This matches the behavior of existing spectrum and wave charts (same as rawChartCtrl)
      if (!$scope.isMonPoint) {
        // Ensure selected.point is initialized if not set
        if (!$scope.selected || !$scope.selected.point) {
          if ($scope.machineData.meta && $scope.machineData.meta.points && $scope.machineData.meta.points.length) {
            $scope.selected = $scope.selected || {}
            $scope.selected.point = $scope.machineData.meta.points[0]
          }
        }
        
        // Include pointSet in params - same logic as rawChartCtrl
        // rawChartCtrl directly uses: params.pointSet = parseInt($scope.selected.point.internalName)
        if ($scope.selected && $scope.selected.point && $scope.selected.point.internalName !== undefined && $scope.selected.point.internalName !== null) {
          params.pointSet = parseInt($scope.selected.point.internalName)
        } else if ($scope.machineData.meta && $scope.machineData.meta.points && $scope.machineData.meta.points.length) {
          // Fallback: use first point's internalName if selected.point is not available
          var firstPoint = $scope.machineData.meta.points[0]
          if (firstPoint && firstPoint.internalName !== undefined && firstPoint.internalName !== null) {
            params.pointSet = parseInt(firstPoint.internalName)
          }
        }
      }
      
      // Check if we should use pre-calculated data (only on initial load and if point matches)
      var currentPointSet = params.pointSet
      var usePreCalculated = isInitialLoad && 
                             machineData.usePreCalculatedData && 
                             machineData.wave &&
                             (!machineData.originalPointSet || currentPointSet === parseInt(machineData.originalPointSet))
      
      if (usePreCalculated) {
        // Use pre-calculated data only on initial load with matching point
        drawWaveChart('X,Y,Z', createMixChartData(machineData.wave.x, machineData.wave.y, machineData.wave.z))
        setTimeout(function () {
          ReportService.setChartModelHeight()
        }, 200)
        $scope.loading = false
        isInitialLoad = false
        return
      }
      
      // Mark that initial load is done
      isInitialLoad = false
      
      var cal = machineData.calibartionConstants
      var hasAxisShape = cal && cal.x && cal.y && cal.z
      if (hasAxisShape) {
        params.calibartionConstants = typeof cal === 'string' ? cal : JSON.stringify(cal)
        
        ReadingService.resource.getCalibrationData(params, function (res) {
          // Check if response contains error message
          if (res && res.msg) {
            $scope.loading = false
            alert('Error: ' + res.msg)
            return
          }
          
          if (res && res.wave) {
            machineData.wave = res.wave
            drawWaveChart('X,Y,Z', createMixChartData(machineData.wave.x, machineData.wave.y, machineData.wave.z))
          }
          setTimeout(function () {
            ReportService.setChartModelHeight()
          }, 200)
          $scope.loading = false
        }, function (err) {
          $scope.loading = false
          var errorMsg = 'Failed to load calibration data'
          if (err && err.data && err.data.msg) {
            errorMsg = err.data.msg
          } else if (err && err.msg) {
            errorMsg = err.msg
          }
          alert('Error: ' + errorMsg)
        })
      } else {
        // Use original API for normal chart viewing
        params.customerId = machineData.customerId
        params.type = machineData.chartType
        ReadingService.resource.processedVibrationDataOfPoint(params, function (res) {
          machineData.wave = res.wave
          drawWaveChart('X,Y,Z', createMixChartData(machineData.wave.x, machineData.wave.y, machineData.wave.z))
          setTimeout(function () {
            ReportService.setChartModelHeight()
          }, 200)
          $scope.loading = false
        }, function (err) {
          $scope.loading = false
          console.log(err)
        })
      }
    }
    $scope.confirm = function () {
      $uibModalInstance.close()
    }

    function createMixChartData (xData, yData, zData) {
      var mixData = []
      _.times(xData.length, function (index) {
        var array = [index / dividingFactor, xData[index], yData[index], zData[index]]
        mixData.push(array)
      })
      return mixData
    }

    $scope.tooltipToggle = function (showToolTip) {
      $scope.graph.options.showPopover = showToolTip
    }

    $scope.graph = {
      data: [],
      options: {
        labels: ['x', 'A', 'B', 'C'],
        showRangeSelector: true,
        animatedZooms: false,
        interactionModel: window.Dygraph.defaultInteractionModel,
        xlabel: 'Time [s]',
        ylabel: 'Acceleration [g]',
        showPopover: false,
        highlightCallback: function (a, b, point) {
          ReportService.getValuesOfCurrentPoint($scope, point, 4)
          ReportService.setChartModelHeight()
        },
        legendColumn: 'legendColumn',
        legendColumnContainer: 'legendColumnContainer'
      },
      resetValues: function () {
        ReportService.resetValuesOfCurrentPoint($scope)
      },
      legend: {
        dateFormat: constants.dateFormats.default,
        series: {
          A: {
            label: 'Acceleration for X-axis'
          },
          B: {
            label: 'Acceleration for Y-axis'
          },
          C: {
            label: 'Acceleration for Z-axis'
          }
        }
      }
    }

    // -Start of wave
    function drawWaveChart (axis, data) {
      $scope.graph.data = data
      setTimeout(function () {
        window.dygraphApi.resize()
      }, 200)
    }
    // - end of wave chart
    // -- End of dygraph control --
    $scope.confirm = function () {
      $uibModalInstance.close()
    }

    $scope.closeModal = function () {
      $uibModalInstance.dismiss()
    }
    $scope.init()
    $scope.expandModel = false
    $scope.toggleModel = function () {
      $scope.expandModel = !$scope.expandModel
      ReportService.expandShrinkModel($scope.expandModel)
    }
    angular.element(document).ready(function () {
      ReportService.setChartModelHeight()
    })
  }
})();
(function () {
    'use strict';
    angular.module('Vibzer.components.manage.settings.AddTaxCtrl', [])
        .controller('AddTaxCtrl', AddTaxCtrl);
    function AddTaxCtrl($scope, $uibModalInstance, data) {
        $scope.taxData = data
        $scope.title = 'Add Tax'
        $scope.iconClass = 'fa fa-plus'
        $scope.taxTypes = ['GST', 'VAT']
        if ($scope.taxData && $scope.taxData.type) {
            $scope.title = 'Edit Tax'
            $scope.iconClass = 'fa fa-edit'
            $scope.taxTypes.taxType = $scope.taxData.type
            $scope.taxValue = $scope.taxData.value
        } else {
            $scope.taxTypes.taxType = $scope.taxTypes[0]

        }
        $scope.addTax = function () {
            $scope.tax = {
                id: $scope.taxData.id,
                type: $scope.taxTypes.taxType,
                value: $scope.taxValue
            }
            $uibModalInstance.close($scope.tax)
        }
    }
})();
(function () {
  'use strict'
  angular.module('Vibzer.components.manage.settings')
    .controller('SaveStructureCtrl', SaveStructureCtrl);

  // @NgInject
  function SaveStructureCtrl($scope, $state, $uibModalInstance) {
    $scope.confirm = function () {
      $uibModalInstance.close()
    }
  }
})();
(function () {
    'use strict';
    angular.module('Vibzer.components.manage.settings.addHierarchyStructure', [])
        .controller('HierarchyStructureCtrl', HierarchyStructureCtrl);
    function HierarchyStructureCtrl($scope, $state, $window, $uibModal, toastr) {
        $scope.addNode = false
        $scope.ignoreChanges = false;
        $scope.newNode = {};
        $scope.level = 1
        $scope.maxLevels = 3
        $scope.levelId = 'Level-' + $scope.level
        $scope.treeData = []
        $scope.levelName
        $scope.basicConfig = {
            'core': {
                'multiple': false,
                'check_callback': true,
                'worker': true
            },
            'types': {
                'level': {
                    'icon': 'fa fa-square-o'
                },
                'default': {
                    'icon': 'fa fa-square-o'
                }
            },
            'contextmenu': {
                'items': {
                    'Rename': {
                        'label': 'Rename',
                        "action": function (data) {
                            $scope.renameLevel(data)
                        }
                    }
                }
            },
            'plugins': ['types', 'contextmenu'],
            'version': 1
        };

        $scope.addNewNode = function (levelName) {
            $scope.maxLevels--
            $scope.ignoreChanges = true;
            var parent = '#'
            var type = ''
            if ($scope.level != 1) {
                parent = 'level' + ($scope.level - 1).toString()
                type = 'level'
            }
            $scope.treeData.push({
                id: 'level' + $scope.level,
                parent: parent,
                type: type,
                text: levelName,
                state: { opened: true }
            })
            $scope.level++
            $scope.addNode = true
            $scope.levelId = 'Level-' + $scope.level
        }

        $scope.renameLevel = function (data) {
            var inst = $.jstree.reference(data.reference)
            var obj = inst.get_node(data.reference)
            inst.edit(obj, null, function (node, status) {
                $scope.treeData = _.filter($scope.treeData, function (node) {
                    if (node.id == obj.original.id)
                        node.text = obj.text
                    $scope.basicConfig.version++;
                    return node
                })
            })
        }

        $scope.cancel = function () {
            $window.history.back()
        }

        $scope.save = function () {
            var modalInstance = $uibModal.open({
                templateUrl: 'app/components/manage/settings/Modals/saveStructureConfirmation.html',
                controller: 'SaveStructureCtrl',
                resolve: {
                }
            });

            modalInstance.result.then(function () {
                toastr.success('Organization Structure has been saved successfully!');
            })
        }
    }
})();
/* Minified js for jQuery BackTop */
!function(o){o.fn.backTop=function(e){var n=this,i=o.extend({position:400,speed:500,color:"white"},e),t=i.position,c=i.speed,d=i.color;n.addClass("white"==d?"white":"red"==d?"red":"green"==d?"green":"black"),n.css({right:40,bottom:40,position:"fixed"}),o(document).scroll(function(){var e=o(window).scrollTop();e>=t?n.fadeIn(c):n.fadeOut(c)}),n.click(function(){o("html, body").animate({scrollTop:0},{duration:1200})})}}(jQuery);
angular.module('Vibzer').run(['$templateCache', function($templateCache) {$templateCache.put('app/components/Licenses/licenses.html','<ul class="breadcrumb al-breadcrumb"><li ng-repeat="itm in breadCrumbList"><a>{{itm}}</a></li></ul><br><div class=clearfix></div><div class=panel style=margin-top:5px;><div ng-if="isDistributorSuperAdmin || isSalesRep" class="row search-bar no-left-right-padding"><div class=col-md-12><label ng-if="isDistributorSuperAdmin && !forCustomer" class="pull-left vertical-align-label" for=issuedBy style=padding-left:10px;>Issued by</label><div ng-if="isDistributorSuperAdmin && !forCustomer" class="col-sm-5 col-xs-5 col-md-3 sort-list" style="padding-left:15px !important;"><ui-select id=issuedBy ng-model=selected.issuedBy class="btn-group bootstrap-select form-control" on-select=getCustomersByIssuedBy(selected.issuedBy)><ui-select-match placeholder="Select issued by"><div class=text-truncate style=position:initial;><span ng-if=$select.selected.email>{{$select.selected.firstName}} {{$select.selected.lastName}} ({{$select.selected.email}})</span> <span ng-if=!$select.selected.email>{{$select.selected.firstName}}</span></div></ui-select-match><ui-select-choices repeat="issuedBy in allSalesRep | filter: $select.search"><div class=text-truncate style=position:initial;><span ng-if=issuedBy.email ng-bind-html="issuedBy.firstName + \' \' + issuedBy.lastName + \' (\' + issuedBy.email + \')\'"></span> <span ng-if=!issuedBy.email ng-bind-html=issuedBy.firstName></span></div></ui-select-choices></ui-select></div><div ng-if=!forCustomer class="col-xs-5 col-lg-3 col-md-3 col-sm-5 no-left-right-padding"><form name=searchForm><div class=input-group ng-class="{\'has-error\': searchForm.searchText.$invalid}"><input type=text class="form-control with-primary-addon" placeholder="Enter customer name" id=searchText name=searchText spellcheck=false ng-model=searchText ng-model-options="{ debounce: 200 }" ng-change=searchCustomer(searchText)> <a ng-show=searchText class=search-clear style=margin-top:3px; ng-click="searchCustomer(\'\');searchText = \'\'"><span class="fa fa-times"></span></a> <input type=hidden name=filter id=filter> <span class=input-group-btn><button class="btn btn-primary" type=button ng-click=searchCustomer(searchText)><i class="fa fa-search"></i></button></span></div></form></div></div><br class=visible-xs></div><uib-tabset active=activeTab><uib-tab select=tabSelect(0) heading="Handheld Devices"><div class=row><div class="col-md-12 table-responsive"><table id=licenses-table class="table table-bordered no-left-right-padding" style=margin-bottom:0px><thead><th ng-if="!forCustomer && (isDistributorSuperAdmin || isSalesRep)">Customer Name</th><th>Order ID</th><th>Issued (by/on)</th><th>Part No.</th><th>Quantity</th><th>Activation Date</th></thead><tbody><tr ng-repeat="device in allHandheldDevices" class=table-border><td class=col-md-2 ng-if="!forCustomer && (isDistributorSuperAdmin || isSalesRep)" ng-bind=device.customerName></td><td class=col-md-2>{{ device.orderId }}</td><td class=col-md-2><span ng-bind="device.createdBy.firstName + \' \' + device.createdBy.lastName"></span><br><span>{{device.createdOn | date: dateFormat}}</span></td><td class=col-md-2 ng-bind=device.productCode></td><td class=col-md-2 ng-bind=device.quantity></td><td class=col-md-2>{{ device.startDate | date: dateFormat }}</td></tr><tr ng-if=busy><td colspan=6><div class=text-center><i class="btn-lg fa fa-spinner fa-spin"></i> &nbsp;Loading handheld devices...</div></td></tr><tr ng-if="!busy && allHandheldDevices && allHandheldDevices.length === 0"><td colspan=6><div class=text-center><i class="btn-lg fa fa-ban"></i> &nbsp;No license found</div></td></tr></tbody><tfoot ng-if="totalHandheldDevices > limit"><tr style="border-bottom: none; text-align: center"><td colspan=6 class=gl-pagination><ul uib-pagination total-items=totalHandheldDevices items-per-page=limit ng-model=uibPage.handheldDevicePage max-size=10 class=pagination-sm rotate=false ng-change=pageChanged(0,uibPage.handheldDevicePage) style="margin-bottom: 0px;"></ul></td></tr></tfoot></table></div></div><div class=clearfix></div><br></uib-tab><uib-tab select=tabSelect(1) heading="Analysis Packs"><div class=row><div class="col-md-12 table-responsive"><table id=licenses-table class="table table-bordered no-left-right-padding" style=margin-bottom:0px><thead><th ng-if="!forCustomer && (isDistributorSuperAdmin || isSalesRep)">Customer Name</th><th>Order ID</th><th>Issued (by/on)</th><th>Name/Part No.</th><th>Quantity</th><th>Analyses Used</th><th>Activation Date</th><th>Expiry Date</th></thead><tbody><tr ng-repeat="license in allAssessmentLicenses" class=table-border ng-style="{\'border\': license.expired ? \'3px solid red\' : none}"><td ng-if="!forCustomer && (isDistributorSuperAdmin || isSalesRep)" ng-class="{\'text-red\': license.expired}" ng-bind=license.customerName></td><td ng-class="{\'text-red\': license.expired}" ng-bind=license.orderId></td><td><span ng-bind="license.createdBy.firstName + \' \' + license.createdBy.lastName" ng-class="{\'text-red\': license.expired}"></span><br><span ng-class="{\'text-red\': license.expired}">{{license.createdOn | date: dateFormat}}</span></td><td><span ng-class="{\'text-red\': license.expired}">{{license.name}}</span><br><span ng-class="{\'text-red\': license.expired}">{{license.productCode}}</span></td><td ng-bind=license.quantity ng-class="{\'text-red\': license.expired}"></td><td><span ng-class="{\'text-red\': license.expired}">{{license.used + \'/\' + license.total}}</span></td><td ng-class="{\'text-red\': license.expired}">{{ license.startDate | date: dateFormat }}</td><td ng-class="{\'text-red\': license.expired}">{{ license.expiryDate | date: dateFormat }}</td></tr><tr ng-if=busy><td colspan=8><div class=text-center><i class="btn-lg fa fa-spinner fa-spin"></i> &nbsp;Loading analysis packs...</div></td></tr><tr ng-if="!busy && allAssessmentLicenses && allAssessmentLicenses.length === 0"><td colspan=8><div class=text-center><i class="btn-lg fa fa-ban"></i> &nbsp;No license found</div></td></tr></tbody><tfoot ng-if="totalAssessmentLicenses > limit"><tr style="border-bottom: none; text-align: center"><td colspan=8 class=gl-pagination><ul uib-pagination total-items=totalAssessmentLicenses items-per-page=limit ng-model=uibPage.analysisPage max-size=10 class=pagination-sm rotate=false ng-change=pageChanged(1,uibPage.analysisPage) style="margin-bottom: 0px;"></ul></td></tr></tfoot></table></div><div class=clearfix></div><br></div></uib-tab><uib-tab select=tabSelect(2) heading="Fixed Devices"><div class=row><div class="col-md-12 table-responsive"><table id=licenses-table class="table table-bordered no-left-right-padding" style=margin-bottom:0px><thead><th ng-if="!forCustomer && (isDistributorSuperAdmin || isSalesRep)">Customer Name</th><th>Order ID</th><th>Issued (by/on)</th><th>Part No.</th><th>Quantity</th><th>Activation Date</th></thead><tbody><tr ng-repeat="device in allFixedDevices" class=table-border><td class=col-md-2 ng-if="!forCustomer && (isDistributorSuperAdmin || isSalesRep)" ng-bind=device.customerName></td><td class=col-md-2>{{ device.orderId }}</td><td class=col-md-2><span ng-bind="device.createdBy.firstName + \' \' + device.createdBy.lastName"></span><br><span>{{device.createdOn | date: dateFormat}}</span></td><td class=col-md-2 ng-bind=device.productCode></td><td class=col-md-2 ng-bind=device.quantity></td><td class=col-md-2>{{ device.startDate | date: dateFormat }}</td></tr><tr ng-if=busy><td colspan=6><div class=text-center><i class="btn-lg fa fa-spinner fa-spin"></i> &nbsp;Loading fixed devices...</div></td></tr><tr ng-if="!busy && allFixedDevices && allFixedDevices.length === 0"><td colspan=6><div class=text-center><i class="btn-lg fa fa-ban"></i> &nbsp;No license found</div></td></tr></tbody><tfoot ng-if="totalFixedDevices > limit"><tr style="border-bottom: none; text-align: center"><td colspan=6 class=gl-pagination><ul uib-pagination total-items=totalFixedDevices items-per-page=limit ng-model=uibPage.fixedDevicePage max-size=10 class=pagination-sm rotate=false ng-change=pageChanged(2,uibPage.fixedDevicePage) style="margin-bottom: 0px;"></ul></td></tr></tfoot></table></div></div><div class=clearfix></div><br></uib-tab><uib-tab select=tabSelect(3) heading="Subscription Kits"><div class=row><div class="col-md-12 table-responsive"><table id=licenses-table class="table table-bordered no-left-right-padding" style=margin-bottom:0px><thead><th ng-if="!forCustomer && (isDistributorSuperAdmin || isSalesRep)">Customer Name</th><th>Order ID</th><th>Issued (by/on)</th><th>Name/Part No.</th><th>Quantity</th><th>Subscriptions Used</th><th>Activation Date</th><th>Expiry Date</th><th ng-if="isDistributorSuperAdmin || isSalesRep">Actions</th></thead><tbody><tr ng-repeat="license in allMonitoringLicenses" class=table-border ng-style="{\'border\': license.expired ? \'3px solid red\' : none}"><td ng-if="!forCustomer && (isDistributorSuperAdmin || isSalesRep)" ng-class="{\'text-red\': license.expired}" ng-bind=license.customerName></td><td ng-class="{\'text-red\': license.expired}" ng-bind=license.orderId></td><td><span ng-bind="license.createdBy.firstName + \' \' + license.createdBy.lastName" ng-class="{\'text-red\': license.expired}"></span><br><span ng-class="{\'text-red\': license.expired}">{{license.createdOn | date: dateFormat}}</span></td><td><span ng-class="{\'text-red\': license.expired}">{{license.name}}</span><br><span ng-class="{\'text-red\': license.expired}">{{license.productCode}}</span></td><td ng-bind=license.quantity ng-class="{\'text-red\': license.expired}"></td><td><span ng-class="{\'text-red\': license.expired}">{{license.used + \'/\' + license.total}}</span></td><td ng-class="{\'text-red\': license.expired}">{{ license.startDate | date: dateFormat }}</td><td ng-class="{\'text-red\': license.expired}">{{ license.expiryDate | date: dateFormat }}</td><td ng-if="isDistributorSuperAdmin || isSalesRep" ng-class="{\'text-red\': license.expired}"><button ng-if=license.isExpiring class="btn btn-primary" ng-click=renewOrder(license)>Renew</button></td></tr><tr ng-if=busy><td colspan=8><div class=text-center><i class="btn-lg fa fa-spinner fa-spin"></i> &nbsp;Loading subscription kits...</div></td></tr><tr ng-if="!busy && allMonitoringLicenses && allMonitoringLicenses.length === 0"><td colspan=8><div class=text-center><i class="btn-lg fa fa-ban"></i> &nbsp;No license found</div></td></tr></tbody><tfoot ng-if="totalMonitoringLicenses > limit"><tr style="border-bottom: none; text-align: center"><td colspan=8 class=gl-pagination><ul uib-pagination total-items=totalMonitoringLicenses items-per-page=limit ng-model=uibPage.subscriptionPage max-size=10 class=pagination-sm rotate=false ng-change="pageChanged(3, uibPage.subscriptionPage)" style="margin-bottom: 0px;"></ul></td></tr></tfoot></table></div></div><div class=clearfix></div><br></uib-tab></uib-tabset></div>');
$templateCache.put('app/components/Notification/notification.html','<ul class="al-msg-center clearfix"><li uib-dropdown><a uib-dropdown-toggle><i tooltip-placement=auto uib-tooltip=Notifications class="fa fa-bell-o" style=font-size:x-large></i><span ng-if="unreadNotification > 0">{{unreadNotification}}</span><div class=notification-ring></div></a><div uib-dropdown-menu class=top-dropdown-menu style=width:280px;margin-top:15px;><i class=dropdown-arr></i><div class=msg-list><div class=header-text ng-if="unreadNotification > 0 || !userNotifications.length"><p ng-show="unreadNotification > 0">You have {{unreadNotification}} unread notifications</p><p ng-show=!userNotifications.length>No notifications</p></div><br ng-if="unreadNotification > 0 || !userNotifications.length"><br ng-if="unreadNotification > 0 || !userNotifications.length"><a ng-class="{\'unread-notification\': notification.status === \'pending\'}" ng-click="$event.stopPropagation();viewOrClearNotifications(notification, \'view\')" ng-repeat="notification in userNotifications"><div class=align-right><small><i class="fa fa-clock-o"></i>&nbsp;{{notification.fromNow}}</small></div><div class="pull-left notification-icon"><i class={{notification.icon}}></i></div><div class=notification-title><h4 class=notification-heading>{{notification.title}}</h4></div><div class=notification-msg-area><p>{{notification.message}}</p></div></a></div><div ng-if=userNotifications.length class=row style=padding-top:10px;><div class="col-md-6 text-center" style=margin-left:-20px;><a ng-click="$event.stopPropagation();getAllNotifications(\'moreNotification\')">Load more</a></div><div class="col-md-6 align-right no-left-right-padding"><a ng-click="viewOrClearNotifications({}, \'clear\')">Clear all</a></div></div></div></li></ul>');
$templateCache.put('app/components/changePassword/changePassword.html','<main class=auth-main><div class=auth-block><div class="login-page-logo text-center"><img src=./assets/img/logo.png alt=logo></div><form role=form name=resetPasswordForm id=resetPasswordForm class=form-horizontal novalidate><div class=form-group><label for=username class="col-sm-4 control-label required" style=padding-right:0px;>E-mail</label><div class=col-sm-8><label class=control-label ng-bind=user.username></label></div></div><div class=form-group><label for=password class="col-sm-4 control-label required" style=padding-right:0px;>Old password</label><div class=col-sm-8><input type=password ng-model=user.password class=form-control id=password placeholder="Old password" required></div></div><div class=form-group><label for=newPassword class="col-sm-4 control-label required" style=padding-right:0px;>New password</label><div class=col-sm-8><input type=password name=newPassword ng-minlength=6 ng-model=user.newPassword class=form-control id=newPassword placeholder="New password" required><p ng-if="resetPasswordForm.newPassword.$dirty && resetPasswordForm.newPassword.$invalid" style=margin-top:5px;color:red>Password should be at least 6 character long</p></div></div><div class=form-group><label for=repeatPassword class="col-sm-4 control-label required" style=padding-right:0px;>Confirm password</label><div class=col-sm-8><input type=password ng-minlength=6 ng-blur="user.newPassword!==user.repeatPassword ? showUniquePassword=true : null" ng-model=user.repeatPassword name=repeatPassword class=form-control id=repeatPassword placeholder="Confirm password" required><p ng-if=showUniquePassword style=margin-top:5px;color:red>Password should same as new password.</p><p ng-if="!showUniquePassword && resetPasswordForm.repeatPassword.$dirty && resetPasswordForm.repeatPassword.$invalid" style=margin-top:5px;color:red>Password should be at least 6 character long</p></div></div><div class=form-group><div class="col-sm-12 text-center" ng-include="\'app/components/commonHTMLs/recaptcha.html\'"></div></div><div class=form-group><div class=col-sm-12><button ng-click=cancel() type=submit class="btn btn-default pull-left btn-auth">Cancel</button> <button type=submit ng-click="resetPasswordForm.$valid && changePassword()" ng-disabled=resetPasswordForm.$invalid class="btn btn-default pull-right btn-auth">Reset</button></div></div></form></div></main>');
$templateCache.put('app/components/commonHTMLs/address.html','<div class=col-md-12><div class=col-md-6><div class="form-group has-feedback"><label for=addressLine1><strong>Address line 1</strong></label> <textarea class=form-control type=textarea placeholder="Enter address line 1" name=addressLine1 id=addressLine1 ng-model=info.address.addressLineOne style="min-height:60px !important; resize: none;"></textarea></div></div><div class=col-md-6><div class="form-group has-feedback"><label for=addressLine2><strong>Address line 2</strong></label> <textarea class=form-control type=textArea placeholder="Enter address line 2" name=addressLine2 id=addressLine2 ng-model=info.address.addressLineTwo style="min-height:60px !important; resize: none;"></textarea></div></div></div><div class=col-md-12><div class=col-md-6><div class="form-group has-feedback"><label for=addressLine3><strong>Address line 3</strong></label> <textarea class=form-control type=textArea placeholder="Enter address line 3" name=addressLine3 id=addressLine3 ng-model=info.address.addressLineThree style="min-height:60px !important; resize: none;"></textarea></div></div><div class=col-md-6><div class="form-group has-feedback" ng-class="{\'has-error\': info.addressForm.city.$invalid && (info.addressForm.city.$dirty || info.addressForm.$submitted)}"><label for=city><strong>City</strong></label> <input type=text class=form-control id=city name=city ng-model=info.address.city placeholder="Enter city" ng-pattern="/^[a-zA-Z]+$/"><span class="help-block error-block basic-block" ng-show=info.addressForm.city.$error.pattern>Not a valid city name. City name consist of alphabets only.</span></div></div></div><div class=col-md-12><div class=col-md-6><div class="form-group has-feedback" ng-class="{\'has-error\': info.addressForm.state.$invalid && (info.addressForm.state.$dirty || info.addressForm.$submitted)}"><label for=state><strong>State</strong></label> <input type=text class=form-control id=state name=state ng-model=info.address.state placeholder="Enter state" ng-pattern="/^[a-zA-Z]+$/"><span class="help-block error-block basic-block" ng-show=info.addressForm.state.$error.pattern>Not a valid state name. State name consist of alphabets only.</span></div></div><div class=col-md-6><div class="form-group has-feedback" ng-class="{\'has-error\': info.addressForm.pinCode.$invalid && (info.addressForm.pinCode.$dirty || info.addressForm.$submitted)}"><label for=pinCode><strong>ZIP Code</strong></label> <input type=text class=form-control id=pinCode ng-pattern=/^[A-Za-z0-9]{3,10}$/i name=pinCode ng-model=info.address.pinCode placeholder="Enter zip code"><span class="help-block error-block basic-block" ng-show=info.addressForm.pinCode.$error.pattern>Zip code should contain alphanumeric characters and length should be between 3 and 10.</span></div></div></div><div class=col-md-12><div class=col-md-6><div class="form-group has-feedback" ng-class="{\'has-error\': info.addressForm.country.$invalid && (info.addressForm.country.$dirty || info.addressForm.$submitted)}"><label for=country><strong>Country</strong></label><ui-select ng-disabled="viewDetails || viewForm || disabled" id=country name=country ng-model=info.address.country class="btn-group bootstrap-select form-control"><ui-select-match placeholder="Select Country"><span ng-bind=$select.selected.value.name></span></ui-select-match><ui-select-choices repeat="country.value.name as (key, country) in allCountries | filter: $select.search"><span ng-bind-html=country.value.name></span></ui-select-choices></ui-select><span class="help-block error-block basic-block" ng-show=info.addressForm.country.$error.pattern>Not a valid country name. Country name consist of alphabets only.</span></div></div><div class=col-md-6><div class="form-group has-feedback" ng-class="{\'has-error\': info.addressForm.phone.$invalid && (info.addressForm.phone.$dirty || info.addressForm.$submitted)}"><label for=phone><strong>Phone No</strong></label> <input type=text id=phone name=phone ng-pattern="/^\\s*(?:\\+?(\\d{1,3}))?[-. (]*(\\d{3})[-. )]*(\\d{3})[-. ]*(\\d{4})(?: *x(\\d+))?\\s*$/" placeholder="Enter phone number" class="form-control with-primary-addon" spellcheck=false ng-model=info.address.phone style=z-index:0><span class=help-block ng-show=info.addressForm.phone.$error.pattern>Phone no is invalid.</span></div></div></div><div class=col-md-12><div class=col-md-6><div class="form-group has-feedback" ng-class="{\'has-error\': info.addressForm.emailId.$invalid && (info.addressForm.emailId.$dirty || info.addressForm.$submitted)}"><label for=emailId><strong>Email</strong></label> <input type=email id=emailId name=emailId placeholder="Enter email" class="form-control with-primary-addon" spellcheck=false ng-model=info.address.email ng-pattern="/^[A-Za-z0-9._%+-]+@(?:[A-Za-z0-9](?:[A-Za-z0-9-]*[A-Za-z0-9])?\\.)+[A-Za-z]{2,}$/" style=z-index:0><span class=help-block ng-show=info.addressForm.emailId.$error.pattern>Email is invalid.</span></div></div></div><div class=clearfix></div><br>');
$templateCache.put('app/components/commonHTMLs/breadcrumb.html','<ul class="breadcrumb al-breadcrumb"><li ng-repeat="itm in breadCrumbList"><a>{{itm}}</a></li></ul>');
$templateCache.put('app/components/commonHTMLs/hierarchyAssignUser.html','<h3 ng-if=isAddForm class=form-heading>{{webAppTexts.labels.assignUser}}</h3><hr ng-if=isAddForm style="margin-top: 4px;"><fieldset ng-if=isAddForm><div class=col-md-12><div class="checkbox checkbox-inline" style=margin-right:10px><input id=assignUser name=assignUser type=checkbox ng-model=selected.assignUser> <label for=assignUser ng-bind="webAppTexts.labels.assignUser + \' to \' + selectedState.nextLevel.name"></label></div><div ng-show=selected.assignUser class="radio radio-inline"><input type=radio class=form-control name=statistical id=statistical value=2 ng-model=selected.userType> <label for=every><span style=font-size:14px; ng-bind=webAppTexts.labels.existingUser></span></label></div><div ng-show=selected.assignUser class="radio radio-inline"><input type=radio class=form-control name=statistical id=statistical value=1 ng-model=selected.userType> <label for=every><span style=font-size:14px; ng-bind=webAppTexts.labels.newUser></span></label></div></div><div class=col-md-12><hr ng-if="selected.assignUser && selected.userType" style="margin-top: 4px;"><fieldset ng-if="selected.assignUser && selected.userType === \'1\'"><div class=col-sm-6><div class="form-group has-feedback" ng-class="{\'has-error\': hierarchy.basicInfoForm.firstName.$invalid && (hierarchy.basicInfoForm.firstName.$dirty || hierarchy.basicInfoForm.$submitted)}"><label for=firstName class=required><strong>{{webAppTexts.labels.firstName}}</strong></label> <input type=text class=form-control id=firstName name=firstName ng-model=selected.userInfo.firstName placeholder={{webAppTexts.placeholder.enterFirstName}} ng-pattern="/^[a-zA-Z]*$/" required> <span class="help-block error-block basic-block" ng-show=hierarchy.basicInfoForm.firstName.$error.required>First name is required</span> <span class=help-block ng-show=hierarchy.basicInfoForm.firstName.$error.pattern>Special characters like \\ / : * ? " <> | and spaces, numbers are not allowed.</span></div></div><br class=visible-xs><div class=col-sm-6><div class="form-group has-feedback" ng-class="{\'has-error\': hierarchy.basicInfoForm.lastName.$invalid && (hierarchy.basicInfoForm.lastName.$dirty ||hierarchy.basicInfoForm.$submitted)}"><label for=lastName class=required><strong>{{webAppTexts.labels.lastName}}</strong></label> <input type=text class=form-control id=lastName name=lastName ng-model=selected.userInfo.lastName placeholder={{webAppTexts.placeholder.enterLastName}} ng-pattern="/^[a-zA-Z]*$/" required> <span class="help-block error-block basic-block" ng-show=hierarchy.basicInfoForm.lastName.$error.required>Last name is required</span> <span class=help-block ng-show=hierarchy.basicInfoForm.lastName.$error.pattern>Special characters like \\ / : * ? " <> | and spaces, numbers are not allowed.</span></div></div><div class=clearfix></div><br><div class=col-sm-6><div class="form-group has-feedback" ng-class="{\'has-error\' : hierarchy.basicInfoForm.email.$invalid && (hierarchy.basicInfoForm.email.$dirty ||hierarchy.basicInfoForm.$submitted)}"><label for=email class=required><strong>{{webAppTexts.labels.email}}</strong></label> <input type=email id=email name=email placeholder={{webAppTexts.placeholder.email}} class="form-control with-primary-addon" spellcheck=false ng-model=selected.userInfo.email ng-pattern="/^[a-zA-Z0-9._+]+@[a-zA-Z0-9]+\\.[a-z.]{1,500}$/" style=z-index:0 required> <span class="help-block error-block basic-block" ng-if=hierarchy.basicInfoForm.email.$error.pattern>Please enter valid email address eg. john@due.com or jhon_123@due.co.uk</span> <span class="help-block error-block basic-block" ng-if=!hierarchy.basicInfoForm.email.$error.pattern>Email ID is required</span></div></div><div class=col-md-6><div class="form-group has-feedback" ng-class="{\'has-error\': hierarchy.basicInfoForm.phone.$invalid && (hierarchy.basicInfoForm.phone.$dirty || hierarchy.basicInfoForm.$submitted)}"><label for=phone><strong>{{webAppTexts.labels.phoneNo}}</strong></label> <input type=text id=phone name=phone ng-pattern="/^\\s*(?:\\+?(\\d{1,3}))?[-. (]*(\\d{3})[-. )]*(\\d{3})[-. ]*(\\d{4})(?: *x(\\d+))?\\s*$/" placeholder={{webAppTexts.placeholder.phoneNo}} class="form-control with-primary-addon" spellcheck=false ng-model=selected.userInfo.phone style=z-index:0> <span class=help-block ng-show=hierarchy.basicInfoForm.phone.$error.pattern>Phone number is invalid.</span></div></div><div class=col-lg-6 ng-show="selected.assignUser && selected.userType"><div class=form-group><label for=role class=required><strong>{{webAppTexts.labels.role}}</strong></label><ui-select id=role ng-model=selected.role class="btn-group bootstrap-select form-control" on-select=getRoleFor(selected.role) required><ui-select-match placeholder="{{ roles.length == 0 ? \'No roles found\' : \'Select role\'}}"><span>{{$select.selected.name}}</span></ui-select-match><ui-select-choices repeat="role in roles | filter: $select.search"><span ng-bind-html=role.name></span></ui-select-choices></ui-select></div></div></fieldset><fieldset ng-if="selected.assignUser && selected.userType === \'2\'"><div class=col-lg-6><div class=form-group><label><strong>User</strong></label><ui-select id=user ng-model=selected.userInfo class="btn-group bootstrap-select form-control" required><ui-select-match placeholder={{webAppTexts.placeholder.selectUser}}><span>{{$select.selected.firstName + \' \' + $select.selected.lastName}}</span></ui-select-match><ui-select-choices repeat="user in allUsers | filter: $select.search"><div class=text-truncate style="position:initial !important;"><span>{{user.firstName + \' \' + user.lastName}}</span><br><small>{{user.email}}</small></div></ui-select-choices></ui-select></div></div><div class=col-lg-6 ng-show="selected.assignUser && selected.userType"><div class=form-group><label for=role class=required><strong>{{webAppTexts.labels.role}}</strong></label><ui-select id=role ng-model=selected.role class="btn-group bootstrap-select form-control" on-select=getRoleFor(selected.role) required><ui-select-match placeholder="{{ roles.length == 0 ? \'No roles found\' : \'Select role\'}}"><span>{{$select.selected.name}}</span></ui-select-match><ui-select-choices repeat="role in roles | filter: $select.search"><span ng-bind-html=role.name></span></ui-select-choices></ui-select></div></div></fieldset></div></fieldset>');
$templateCache.put('app/components/commonHTMLs/list.html','<div class="row vertical-align-row"><div class=col-xs-6><ul class="breadcrumb al-breadcrumb" style=margin:0;><li ng-repeat="itm in breadCrumbList" ng-style="{\'margin-top\': !canAdd ? \'10px\' : \'0px\'}"><a>{{itm}}</a></li></ul></div><div class="col-xs-6 align-right add-button"><button ng-if=canAdd name=add angular-ripple tooltip-placement=top-right uib-tooltip={{addTooltip}} class="btn btn-primary" ng-click=add()><i class="fa fa-plus"></i></button></div></div><div class=clearfix></div><div class=panel ng-style="{\'margin-top\':canAdd ? \'5px\' : \'10px\'}"><div class="container-limited container-fluid"><div class="row search-bar no-left-right-padding"><div class="col-xs-12 col-lg-4 col-md-4 col-sm-12 no-left-right-padding"><form name=searchForm><div class=input-group ng-class="{\'has-error\': searchForm.searchText.$invalid}"><input type=text class="form-control with-primary-addon" placeholder={{searchPlaceholder}} id=searchText name=searchText spellcheck=false ng-model=searchText ng-model-options="{ debounce: 200 }" ng-change=search(searchText)> <a ng-show=searchText class=search-clear style=margin-top:3px; ng-click="search(\'\')"><span class="fa fa-times"></span></a> <input type=hidden name=filter id=filter> <span class=input-group-btn><button class="btn btn-primary" type=button ng-click=search(searchText)><i class="fa fa-search"></i></button></span></div></form></div><div class="col-sm-8 col-md-8 col-xs-12 no-left-right-padding"><div class="col-sm-6 col-xs-6 col-md-3 pull-right sort-list"><ui-select id=order ng-model=selected.order class="btn-group bootstrap-select form-control" on-select="setSorting(\'order\', selected.order)"><ui-select-match placeholder="Select order"><span>{{$select.selected.value.displayName}}</span></ui-select-match><ui-select-choices repeat="type.value.id as (key, type) in orderBy | filter: $select.search"><span ng-bind-html=type.value.displayName></span></ui-select-choices></ui-select></div><div class="col-sm-6 col-xs-6 col-md-3 pull-right sort-list" style="padding-left: 2px;"><ui-select id=sort ng-model=selected.sort class="btn-group bootstrap-select form-control" on-select="setSorting(\'sort\', selected.sort)"><ui-select-match placeholder="Select sort"><span>{{$select.selected.value.displayName}}</span></ui-select-match><ui-select-choices repeat="type.value.id as (key, type) in sortBy | filter: $select.search"><span ng-bind-html=type.value.displayName></span></ui-select-choices></ui-select></div><div class="visible-xs clearfix"></div><br class=visible-xs></div></div><div class=row><div class=table-responsive style=margin-top:0px><table id=machine-table class="table no-left-right-padding" style=margin-bottom:0px><thead class=row><th ng-class="{\'col-md-2\':forRoute, \'col-sm-3\':forRoute, \'col-md-4\':forComposite}"><h5>Name</h5></th><th ng-if=forComposite class="text-center col-md-4 col-sm-4"><h5>Condition</h5></th><th ng-if=forRoute class="align-left col-md-2 col-sm-2"><h5>Assigned To</h5></th><th ng-if=forRoute class="text-center col-md-2 col-sm-2"><h5># Machines</h5></th><th ng-if=forRoute class="text-center col-md-3 col-sm-3"><h5>Next Analysis Schedule</h5></th><th ng-class="{\'col-md-1\':forRoute, \'col-md-4\':forComposite}"></th></thead><tbody><tr ng-repeat="itm in list" class=table-border><td class="vertical-align-middle text-truncate" ng-class="{\'col-md-3\':forRoute, \'col-md-4\':forComposite}"><span ng-if=forRoute class=detail-cursor-pointer ng-click=getMachines(itm)>{{itm.name}}</span><div ng-if=forComposite><div class=pull-left style="font-size: 30px; margin-right:5px"><i ng-style="{\'color\': itm.report.color}" class=icon-composite></i></div><span class=detail-cursor-pointer style="margin-left: 43px;padding-top: 8px;" ng-click=getMachines(itm)>{{itm.name}}</span></div></td><td ng-if=forComposite class="text-center col-md-4 col-sm-4" style="padding-top: 16px;"><span ng-style="{\'color\': itm.report.color}" ng-bind="itm.report.displayName + \' \'"></span></td><td ng-if=forRoute class="align left vertical-align-middle col-md-2 col-sm-2"><span ng-repeat="owner in itm.ownerIds"><span ng-bind="owner.firstName + \' \' + owner.lastName"></span> <span ng-if=!$last ng-bind="\', \'"></span></span></td><td ng-if=forRoute class="text-center vertical-align-middle col-md-2 col-sm-2"><span>{{itm.machineIds.length}}</span></td><td ng-if=forRoute class="text-center vertical-align-middle col-md-3 col-sm-3"><span ng-bind="itm.nextScheduleOn | date: dateFormat"></span></td><td ng-class="{\'col-md-1\':forRoute, \'col-md-4\':forComposite}"><div class="pull-right no-left-right-padding"><button ng-if="forComposite && (!itm.report.condition || itm.report.machineIds.length === 1 || itm.report.condition === -1)" angular-ripple tooltip-placement=top uib-tooltip={{webAppTexts.tooltips.trend}} class="btn btn-primary btn-space" ng-click=showTrend(itm) ng-disabled=!itm.lastReadingType><i class=icon-trend></i></button> <button ng-if="forComposite && (!itm.report.condition || itm.report.machineIds.length === 1 || itm.report.condition === -1)" angular-ripple tooltip-placement=top uib-tooltip={{webAppTexts.tooltips.sessions}} class="btn btn-primary btn-space" ng-click=showSessions(itm) ng-disabled=!itm.lastReadingType><i class=icon-review></i></button> <button angular-ripple tooltip-placement=auto uib-tooltip={{viewTooltip}} class="btn btn-primary btn-space" ng-click=viewDetails(itm)><i class="fa fa-info"></i></button></div></td></tr><tr ng-if=busy><td colspan=6><div class=text-center><i class="btn-lg fa fa-spinner fa-spin"></i> &nbsp;<span ng-bind="(forRoute ? webAppTexts.notes.loadingRoutes : webAppTexts.notes.loadingComposites)"></span></div></td></tr><tr ng-if="!busy && list && list.length === 0"><td colspan=6><div class=text-center><i class="btn-lg fa fa-ban"></i> &nbsp;<span ng-bind="(forRoute ? webAppTexts.notes.noRouteFound : webAppTexts.notes.noCompositeFound)"></span></div></td></tr></tbody><tfoot ng-if="totalItems > limit"><tr style="border-bottom: none; text-align: center"><td colspan=6 class=gl-pagination><ul uib-pagination total-items=totalItems items-per-page=limit ng-model=uibPage.page max-size=10 class=pagination-sm rotate=false ng-change=pageChanged(uibPage.page) style="margin-bottom: 0px;"></ul></td></tr></tfoot></table></div></div></div></div>');
$templateCache.put('app/components/commonHTMLs/recaptcha.html','<form><div vc-recaptcha theme="\'light\'" key=model.key size=normal on-create=setWidgetId(widgetId) on-success=setResponse(response) on-expire=cbExpiration() style="display: inline-block;"></div></form>');
$templateCache.put('app/components/confirmationDialog/confirmationDialog.html','<div class=modal-content><div class=modal-header ng-class=modalHeaderClass><h4 class=modal-title><span ng-bind-html=dialogTitle></span><div class="btn-group pull-right"><a class=modal-close-button ng-click=closeModal()><i class="fa fa-times"></i></a></div></h4></div><div class=modal-body><div class=container-fluid><div class=row><div class=col-md-12><form role=form><span ng-bind-html=dialogMessage></span></form></div></div></div></div><div class=modal-footer><div ng-repeat="button in dialogButtons"><button type=button ng-if=button.visibilityHandler ng-click=button.onClickHandler() class={{button.classes}}>{{button.displayName}}</button></div></div></div>');
$templateCache.put('app/components/compositeMachines/compositeMachineDetails.html','<div class="row vertical-align-row"><div class=col-lg-10><ul class="breadcrumb al-breadcrumb text-truncate" style=margin-top:0px;><li ng-repeat="itm in breadCrumbList" ng-style="{\'margin-top\': addForm || editForm || (viewForm && !canEdit) ? \'10px\' : \'0px\'}"><a>{{itm}}</a></li></ul><br></div><div ng-if=viewForm class="col-lg-2 align-right add-button"><button ng-if=canEdit angular-ripple tooltip-placement=auto uib-tooltip={{webAppTexts.tooltips.editComposite}} class="btn btn-primary" ng-click=editComposite()><i class="fa fa-edit"></i></button> <button ng-if=canDelete angular-ripple tooltip-placement=auto uib-tooltip={{webAppTexts.tooltips.editComposite}} class="btn btn-remove" ng-click=deleteComposite()><i class="fa fa-trash"></i></button></div></div><div class=panel ng-style="{\'margin-top\': addForm || editForm || (viewForm && !canEdit) ? \'20px\' : \'5px\'}"><div class="container-limited container-fluid panel"><div class=row><form name=model.basicInfoForm novalidate><div style="margin-bottom: -13px;" class="row vertical-align-row"><div class=col-lg-6><h3 class=form-heading>{{webAppTexts.headings.basicInfo}}</h3></div></div><hr class=roleList-divider><fieldset ng-disabled=viewForm><div class=col-md-6><div class="form-group has-feedback" ng-class="{\'has-error\': model.basicInfoForm.machineName.$invalid && (model.basicInfoForm.machineName.$dirty || model.basicInfoForm.$submitted)}"><label for=machineName class=required><strong>{{webAppTexts.labels.name}}</strong></label> <input type=text class=form-control id=machineName name=machineName placeholder={{webAppTexts.placeholder.machineName}} ng-model=model.name ng-pattern=\'/^(?!.*[*`\\\\;:"\\\\|,.<>\\/?])/\' required> <span class="help-block error-block basic-block" ng-show=model.basicInfoForm.machineName.$error.required>{{webAppTexts.errorMessages.machineNameRequired}}</span> <span class=help-block ng-show=model.basicInfoForm.machineName.$error.pattern>{{webAppTexts.errorMessages.invalidMachineName}}</span></div></div><div class=col-md-6><div class=form-group ng-class="{\'has-error\': model.basicInfoForm.description.$invalid && (model.basicInfoForm.description.$dirty || model.basicInfoForm.$submitted)}"><label for=description><strong>{{webAppTexts.labels.description}}</strong></label> <textarea type=textArea placeholder={{webAppTexts.placeholder.description}} class=form-control id=description ng-model=model.description style="min-height:60px !important; resize: none;" maxlength=512></textarea></div></div><div class=col-lg-6><div class="form-group has-feedback" ng-class="{\'has-error\':model.basicInfoForm.$submitted && !model.owner}"><label class=required><strong>{{webAppTexts.labels.select + \' \' + webAppTexts.labels.owner}}</strong></label><ui-select ng-model=model.owner class="btn-group bootstrap-select form-control" ng-disabled="!canChangeOwner || viewForm" required><ui-select-match placeholder={{webAppTexts.placeholder.compositeMachineOwner}}><div class=text-truncate style=position:initial;><span>{{$select.selected.firstName + \' \' + $select.selected.lastName}}</span></div></ui-select-match><ui-select-choices repeat="owner in usersForOwner | filter: $select.search"><div class=text-truncate style=position:initial;><span>{{owner.firstName + \' \' + owner.lastName}}</span><br><small>{{owner.email}}</small></div></ui-select-choices></ui-select><span class="help-block error-block basic-block">{{webAppTexts.errorMessages.selectOwner}}</span></div></div><div ng-if="addForm || editForm || (viewForm && model.userIds.length)" class=col-lg-6><label><strong>Assign Users</strong></label><ui-select multiple ng-model=model.userIds theme=bootstrap sortable=true close-on-select=false ng-disabled=viewForm on-select=getUsersToAssignOwner() on-remove=getUsersToAssignOwner()><ui-select-match placeholder={{webAppTexts.placeholder.routeUser}}><span>{{model.userIds[$index].firstName + \' \' + model.userIds[$index].lastName}}</span></ui-select-match><ui-select-choices repeat="user in usersToAssign | filter: $select.search"><span>{{user.firstName + \' \' + user.lastName}}</span><br><small>{{user.email}}</small></ui-select-choices></ui-select></div></fieldset><br><div style="margin-bottom: -13px;" class="row vertical-align-row"><div class=col-lg-6><h3 class=form-heading>{{webAppTexts.headings.compositeMachines}}</h3></div></div><hr class=roleList-divider><fieldset ng-disabled=viewForm><div class=col-md-12><h5 ng-if=!viewForm>{{webAppTexts.notes.addMachinesInComposite}}</h5><div class="col-lg-6 no-left-padding"><label class=required><strong>{{user.customer.hierarchyType[user.customer.hierarchyType.length - 1].name}}</strong></label><ui-select ng-model=model.selectedLevel class="btn-group bootstrap-select form-control" on-select=getMachines(model.selectedLevel) ng-disabled="lowestLevelList && lowestLevelList.length === 1 || machines[1].items.length || viewForm || editForm" required><ui-select-match placeholder={{selectLevelPlaceholder}}><div class=text-truncate style=position:initial;><span>{{$select.selected.name}}</span></div></ui-select-match><ui-select-choices repeat="level in lowestLevelList | filter: $select.search"><div class=text-truncate style=position:initial;><span>{{level.name}}</span></div></ui-select-choices></ui-select></div><div class=clearfix></div><br><div class="dragDropList row"><div ng-if="viewForm && $index === 1" ng-repeat="list in machines" class=col-md-6><div class="panel panel-primary"><div class=panel-heading><h3 class=panel-title>{{list.listName}}</h3></div><div class="panel-body dndListScrollContainer"><ul dnd-list><li ng-repeat="item in list.items" style=cursor:default;><div class=vertical-align-row style=padding-right:10px><i class="dndList-icon {{item.icon}}"></i> <span style=margin-left:5px;>{{item.name + \' (\' + item.owner[0].firstName + \' \' + item.owner[0].lastName + \')\'}}</span></div></li><div ng-if=!list.items.length class="col-md-12 gray-text text-center top-margin"><i class=icon-motor style=font-size:xx-large;></i><br><span>{{webAppTexts.placeholder.allMachinesDeletedFromComposite}}</span></div></ul></div></div></div><div ng-if="addForm || editForm" ng-repeat="list in machines" class=col-md-6><div class="panel panel-primary"><div class=panel-heading><h3 class=panel-title>{{list.listName}}</h3></div><div class="panel-body dndListScrollContainer"><ul dnd-list dnd-drop="onDrop(list, item, index)" dnd-disable-if=list.disable><li ng-repeat="item in list.items" dnd-draggable="getSelectedItemsIncluding(list, item)" dnd-dragstart="onDragstart(list, event)" dnd-moved=onMoved(list) dnd-dragend="list.dragging = false" dnd-selected="item.selected = !item.selected" ng-class="{\'selected\': item.selected}" ng-hide="list.dragging && item.selected"><div class=vertical-align-row style=padding-right:10px><i class="dndList-icon {{item.icon}}"></i> <span style=margin-left:5px;>{{item.name + \' (\' + item.owner[0].firstName + \' \' + item.owner[0].lastName + \')\'}}</span></div><i ng-if=list.removeItem class="pull-right fa fa-times cursor-pointer" ng-click=removeMachineFromList(item) style="color:#AC2925;margin-top: -15px;"></i></li><div ng-if="!list.items.length && $parent.$index === 1" class="col-md-12 gray-text text-center"><i class=icon-motor style=font-size:xx-large;></i><br><span>{{webAppTexts.placeholder.addMachinesInComposite}}</span></div><div ng-if="!list.items.length && $parent.$index === 0" class="col-md-12 gray-text text-center"><i class=icon-motor style=font-size:xx-large;></i><br><span>{{webAppTexts.placeholder.machinesNotAvaliable}}</span></div></ul></div></div><div ng-if="$index === 1" class=col-lg-12 style="padding:5px 0px;"><span class=text-red ng-if="model.basicInfoForm.$submitted && !machines[1].items.length">{{webAppTexts.errorMessages.addMachineInComposite}}</span></div></div></div></div><br></fieldset><br><div class=col-sm-12 style="padding-bottom: 12px;"><button ng-if=viewForm type=button class="btn btn-cancel pull-left" ng-click=back()>{{webAppTexts.buttons.back}}</button> <button ng-if="addForm || editForm" type=button class="btn btn-cancel pull-left" ng-click=back()>{{webAppTexts.buttons.cancel}}</button> <button type=submit class="btn btn-primary pull-right" style=margin-right:2px; ng-if="!viewForm && addForm" ng-disabled=saveButtonVisibility() ng-click=save()>{{webAppTexts.buttons.save}}</button> <button type=submit class="btn btn-primary pull-right" style=margin-right:2px; ng-if="!viewForm && editForm" ng-disabled=saveButtonVisibility() ng-click=save()>{{webAppTexts.buttons.update}}</button></div></form></div></div></div>');
$templateCache.put('app/components/customers/customers.html','<div class="row vertical-align-row"><div class=col-xs-6><ul class="breadcrumb al-breadcrumb" style=margin:0;><li ng-repeat="itm in breadCrumbList"><a>{{itm}}</a></li></ul></div><div class="col-xs-6 align-right" style=padding-right:25px;><button angular-ripple tooltip-placement=auto uib-tooltip={{webAppTexts.tooltips.addCustomer}} class="btn btn-primary" ng-click=addCustomer()><i class="fa fa-plus"></i></button></div></div><div class=clearfix></div><div class=panel style=margin-top:5px;><div class="container-limited container-fluid"><div class=row><div class=clearfix></div><br><div class=col-md-12><div class="container-limited container-fluid"><div class="row user-search-bar no-left-right-padding"><div ng-if="showFilter && user.permission.addDistributorUser" class="col-md-1 col-sm-1 col-lg-1 sort-list"><label class=form-control style="border:none;text-align: right;">{{webAppTexts.labels.salesRep}}</label></div><div ng-if="showFilter && user.permission.addDistributorUser" class="col-md-3 col-sm-3 col-lg-3 sort-list"><ui-select id=user ng-model=users.selected class="btn-group bootstrap-select form-control" on-select=getCustomersBySalesRep(users.selected) required><ui-select-match placeholder={{webAppTexts.placeholder.selectSalesRep}}><span ng-if=$select.selected.value.email>{{$select.selected.value.firstName}} {{$select.selected.value.lastName}} ({{$select.selected.value.email}})</span> <span ng-if=!$select.selected.value.email>{{$select.selected.value.firstName}}</span></ui-select-match><ui-select-choices repeat="user.value.id as (key, user) in users | filter: $select.search"><span ng-if=user.value.email ng-bind-html="user.value.firstName + \' \' + user.value.lastName + \' (\' + user.value.email + \')\'"></span> <span ng-if=!user.value.email ng-bind-html=user.value.firstName></span></ui-select-choices></ui-select></div><div class="col-md-3 col-sm-3 col-lg-3 sort-list" style="margin-right: 40px;"><form name=searchForm><div class=input-group ng-class="{\'has-error\': searchForm.searchText.$invalid}"><input type=text class="form-control with-primary-addon" placeholder={{webAppTexts.placeholder.searchCustomer}} id=searchText name=searchText spellcheck=false ng-pattern=\'/^(?!.*[*`\\\\;:"\\\\|,.<>\\/?])/\' ng-model=searchText ng-model-options="{ debounce: 200 }" ng-change=searchCustomer(searchText)> <a ng-show=searchText class=search-clear style=margin-top:3px; ng-click="searchCustomer(\'\')"><span class="fa fa-times"></span></a> <input type=hidden name=filter id=filter> <span class=input-group-btn><button class="btn btn-primary" type=button ng-click=searchCustomer(searchText)><i class="fa fa-search"></i></button></span></div><span class="help-block text-red" ng-show=searchForm.searchText.$error.pattern style=margin-top:-10px;>{{webAppTexts.errorMessages.invalidName}}</span></form></div><div class="col-sm-3 col-md-2 col-lg-2 pull-right sort-list"><ui-select ng-model=orderBy.selected class="btn-group bootstrap-select form-control" on-select=setSorting(orderBy.selected)><ui-select-match placeholder={{webAppTexts.placeholder.selectOrder}}><span>{{$select.selected.displayName}}</span></ui-select-match><ui-select-choices repeat="itm in orderBy | filter: $select.search"><span ng-bind-html=itm.displayName></span></ui-select-choices></ui-select></div><div class="col-sm-3 col-md-2 col-lg-2 pull-right sort-list"><ui-select ng-model=sortBy.selected class="btn-group bootstrap-select form-control" on-select=setSorting(sortBy.selected)><ui-select-match placeholder={{webAppTexts.placeholder.selectSort}}><span>{{$select.selected.displayName}}</span></ui-select-match><ui-select-choices repeat="itm in sortBy | filter: $select.search"><span ng-bind-html=itm.displayName></span></ui-select-choices></ui-select></div></div><div class=clearfix></div><div class=row style=margin-left:-30px;margin-right:-30px;><div class=table-responsive style=margin-top:0px><table id=user-table class="table no-left-right-padding" style=margin-bottom:0px><thead><tr><th rowspan=2 style="vertical-align: middle;"><h5>{{webAppTexts.headings.customerName}}</h5></th><th rowspan=2 ng-if=user.permission.addDistributorUser style="vertical-align: middle;"><h5>{{webAppTexts.headings.salesRep}}</h5></th><th colspan=4 style="padding-bottom: 0px;"><h5 style=text-align:center;>{{webAppTexts.headings.licenses}}</h5></th><th rowspan=2 ng-class="{ \'text-right\' : !user.permission.addDistributorUser, \'text-center\' : user.permission.addDistributorUser }" style="vertical-align: middle;"><h5>{{webAppTexts.headings.created}}</h5></th><th rowspan=2 style=text-align:right;><h5></h5></th></tr><tr><th style="white-space: nowrap;">{{webAppTexts.headings.handheldDevices}}</th><th style="white-space: nowrap;">{{webAppTexts.headings.analysisPacks}}</th><th style="white-space: nowrap;">{{webAppTexts.headings.fixedDevices}}</th><th style="white-space: nowrap;">{{webAppTexts.headings.subscriptionKits}}</th></tr></thead><tbody><tr ng-repeat="customer in customerList" class=table-border><td class=text-truncate ng-class=customerNameClass><div style=margin-bottom:-10px;><div class=pull-left><span class=detail-cursor-pointer ng-click=viewCustomerDetails(customer)>{{customer.name}}</span></div></div></td><td class="col-sm-2 text-truncate" ng-if=user.permission.addDistributorUser><div style=margin-bottom:-10px; ng-if=customer.salesRep><div class=pull-left ng-repeat="user in customer.salesRep track by $index"><span ng-if="$index < customer.salesRep.length -1">{{user.firstName}} {{user.lastName}},&nbsp;</span> <span ng-if="$index === customer.salesRep.length -1">{{user.firstName}} {{user.lastName}}</span></div><span>{{customer.salesRep.firstName}} {{customer.salesRep.lastName}}</span></div></td><td class=col-sm-1 style=text-align:center;><a ng-if=customer.licenseInfo.handheldDevices style=cursor:pointer; ng-click=viewLicenses(customer,0)>{{customer.licenseInfo.handheldDevices}}</a> <span ng-if=!customer.licenseInfo.handheldDevices>N/A</span></td><td class=col-sm-1 style=text-align:center;><a ng-if=customer.licenseInfo.analysis style=cursor:pointer; ng-click=viewLicenses(customer,1)>{{customer.licenseInfo.analysis}}({{customer.licenseInfo.totalAnalysis}})</a> <span ng-if=!customer.licenseInfo.analysis>N/A</span></td><td class=col-sm-1 style=text-align:center;><a ng-if=customer.licenseInfo.fixedDevices style=cursor:pointer; ng-click=viewLicenses(customer,2)>{{customer.licenseInfo.fixedDevices}}</a> <span ng-if=!customer.licenseInfo.fixedDevices>N/A</span></td><td class=col-sm-1 style=text-align:center;><a ng-if=customer.licenseInfo.subscriptions style=cursor:pointer; ng-click=viewLicenses(customer,3)>{{customer.licenseInfo.subscriptions}}({{customer.licenseInfo.totalSubscriptions}})</a> <span ng-if=!customer.licenseInfo.subscriptions>N/A</span></td><td ng-class="{ \'text-right\' : !user.permission.addDistributorUser, \'text-center\' : user.permission.addDistributorUser }">{{ customer.createdOn | date :dateFormat }}</td><td class=pull-right style=margin-top:2px;><button ng-if=customer.isActive style=width:38px; tooltip-placement=top-left uib-tooltip="Add license" class="btn btn-primary btn-space" ng-click=addLicense(customer)><i class="fa fa-key" aria-hidden=true></i></button> <button ng-if=customer.isActive style=width:38px; tooltip-placement=auto uib-tooltip="Manage customer admins" class="btn btn-primary btn-space" ng-click=manageCustomerAdmins(customer)><i class="fa fa-user-plus" aria-hidden=true></i></button> <button ng-disabled=customer.disable ng-if=customer.isActive tooltip-placement=top-right uib-tooltip="Deactivate customer" class="btn btn-remove btn-space" ng-click=activateOrDeactivate(customer)><i class="fa fa-user" aria-hidden=true></i></button> <button ng-if=!customer.isActive tooltip-placement=top-right uib-tooltip="Activate Customer" class="btn btn-primary btn-space" ng-click=activateOrDeactivate(customer)><i class="fa fa-user" aria-hidden=true></i></button></td></tr><tr ng-if=busy><td colspan=8><div class=text-center><i class="btn-lg fa fa-spinner fa-spin"></i> &nbsp;{{webAppTexts.notes.loadingCustomers}}</div></td></tr><tr ng-if="!busy && customerList && customerList.length === 0"><td colspan=8><div class=text-center><i class="btn-lg fa fa-ban"></i> &nbsp;{{webAppTexts.notes.noCustomerFound}}</div></td></tr></tbody><tfoot ng-if="totalItems > limit"><tr style="border-bottom: none; text-align: center"><td colspan=8 class=gl-pagination><ul uib-pagination total-items=totalItems items-per-page=limit ng-model=uibPage.currentPage max-size=10 class=pagination-sm rotate=false ng-change=pageChanged(uibPage.currentPage) style="margin-bottom: 0px;"></ul></td></tr></tfoot></table></div></div></div></div></div></div></div>');
$templateCache.put('app/components/dashboard/dashboard.html','<div ng-repeat="graph in graphList"><div class="panel panel-default col-md-12" style="margin-top:10px; margin: 5px;padding: 0px !important"><h3 style="background-color: #eee;border: 1px solid #ccc;height:36px;padding-left: 10px;padding-top: 5px;">{{ graph.name }}</h3><div ng-class="{\'col-md-6 col-lg-6\' : graph.showTable, \'col-md-12 col-lg-12\': !graph.showTable}" style="padding: 0px !important"><ui-select ng-if=graph.showDropDown class=col-md-4 ng-model=graph.duration name=duration theme=bootstrap on-select="getDuration(graph.name, graph.duration)"><ui-select-match placeholder="Select duration">{{$select.selected.value.label}}</ui-select-match><ui-select-choices repeat="duration.value.value as (key, duration) in timeList | filter: $select.search"><div ng-bind-html="duration.value.label | highlight: $select.search"></div></ui-select-choices></ui-select><div ng-if=graph.showTopLevel class="col-md-1 col-sm-1 col-lg-1 sort-list"><label class=form-control style=text-align:right;border:none; ng-bind=topLevelLabel></label></div><div class="col-md-3 col-sm-3 col-lg-3 sort-list" ng-if=graph.showTopLevel><ui-select ng-model=graph.selected.topLevel class="btn-group bootstrap-select form-control" on-select="getResourceList(\'middleLevel\', graph.selected.topLevel._id, false, graph.name, graph.selected)" ng-disabled=!topLevelList.length><ui-select-match placeholder={{topLevelPlaceholder}}><span>{{$select.selected.name}}</span></ui-select-match><ui-select-choices repeat="itm in topLevelList | filter: $select.search"><span ng-bind-html=itm.name></span></ui-select-choices></ui-select></div><div ng-if=graph.showMiddleLevel class="col-md-1 col-sm-1 col-lg-1 sort-list"><label class=form-control style=text-align:right;border:none; ng-bind=middleLevelLabel></label></div><div ng-if=graph.showMiddleLevel class="col-md-3 col-sm-3 col-lg-3 sort-list"><ui-select ng-model=graph.selected.middleLevel class="btn-group bootstrap-select form-control" on-select="getResourceList(\'lowerLevel\', graph.selected.middleLevel._id, false, graph.name, graph.selected)" ng-disabled="!graph.selected.topLevel || (graph.selected.topLevel && _.includes(graph.selected.topLevel._id, \'All\'))"><ui-select-match placeholder={{middleLevelPlaceholder}}><span>{{$select.selected.name}}</span></ui-select-match><ui-select-choices repeat="itm in middleLevelList | filter: $select.search"><span ng-bind-html=itm.name></span></ui-select-choices></ui-select><span ng-if="selected.topLevel && !middleLevelList.length" ng-bind="middleLevelLabel + \' not avaliable\'"></span></div><div ng-if=graph.showLowerLevel class="col-md-1 col-sm-1 col-lg-1 sort-list"><label class=form-control style=text-align:right;border:none; ng-bind=lowerLevelLabel></label></div><div ng-if=graph.showLowerLevel class="col-md-3 col-sm-3 col-lg-3 sort-list" style="padding-right: 15px;"><ui-select ng-model=graph.selected.lowerLevel class="btn-group bootstrap-select form-control" ng-disabled="!graph.selected.middleLevel || !lowerLevelList.length || (graph.selected.middleLevel && _.includes(graph.selected.middleLevel._id, \'All\'))" on-select="getResourceList(\'lastLevel\', graph.selected.lowerLevel._id, false, graph.name, graph.selected)"><ui-select-match placeholder={{lowerLevelPlaceholder}}><span>{{$select.selected.name}}</span></ui-select-match><ui-select-choices repeat="itm in lowerLevelList | filter: $select.search"><span ng-bind-html=itm.name></span></ui-select-choices></ui-select><br><br><span ng-if="selected.middleLevel && !lowerLevelList.length" ng-bind="lowerLevelLabel + \' not avaliable\'"></span></div><br><div class=clearfix></div><div class=hidden-xs><nvd3 options=graph.options data=graph.data></nvd3></div><div class="hidden-md hidden-lg hidden-sm"><nvd3 options="graph.mobileOptions || graph.options" data=graph.data></nvd3></div></div><div ng-if="graph.showTable && graph.tableData && graph.tableData.length" class="col-md-6 col-lg-6"><h5 style="border-bottom: 2px solid #777777;"><label ng-if=graph.forMachine ng-bind="(webAppTexts.headings.condition + \': \' + graph.conditionName + (graph.hierarchyName ? \'&nbsp;&nbsp;&nbsp;\' + graph.hierarchyName + \': \' + graph.levelName : \'\'))"></label> <label ng-if=graph.forUser ng-bind="(webAppTexts.headings.role + \': \' + graph.roleName)"></label> <label ng-if=graph.forSalesRep ng-bind="(webAppTexts.labels.salesRep + \': \' + graph.salesRepName)"></label></h5><table class="table table-bordered chart-table"><thead><th ng-class="{\'col-md-12\':(graph.forMachine && graph.selectedCondition === -1) || graph.forSalesRep, \'col-md-6\': graph.forUser}">{{graph.forSalesRep ? webAppTexts.labels.customerName : webAppTexts.labels.name }}</th><th ng-class="{\'col-md-4\': (graph.forMachine && graph.selectedCondition !== -1)}" ng-if="(graph.forMachine && graph.selectedCondition !== -1 || graph.forUser)"><span>{{graph.forMachine && graph.selectedCondition !== -1 ? webAppTexts.headings.lastMeasurement : webAppTexts.labels.email}}</span></th><th class=col-md-2 ng-if="graph.forMachine && graph.selectedCondition !== -1"></th></thead><tbody><tr ng-repeat="itm in graph.tableData"><td ng-class="{\'col-md-12\':(graph.forMachine && graph.selectedCondition === -1) || graph.forSalesRep, \'col-md-6\': graph.forUser}"><div ng-if=graph.forMachine class="pull-left chart-table-machine-icon"><i class={{itm.icon}}></i></div><div class=text-truncate><span ng-if="graph.forMachine || graph.forSalesRep" style="left:0px !important;">{{itm.name}}</span> <span ng-if=graph.forUser>{{itm.firstName + \' \' + itm.lastName}}</span></div></td><td ng-class="{\'col-md-4\': (graph.forMachine && graph.selectedCondition !== -1)}" class=text-truncate ng-if="(graph.forMachine && graph.selectedCondition !== -1 || graph.forUser)"><span>{{graph.forMachine && graph.selectedCondition !== -1 ? (itm.vibrationInfo.createdOn | date :dateFormat ): itm.email}}</span></td><td class="col-md-2 text-center" ng-if="graph.forMachine && graph.selectedCondition !== -1"><button tooltip-placement=top class="btn btn-primary btn-space" ng-disabled="itm.vibrationInfo && !itm.vibrationInfo.createdOn" ng-click=showReport(itm)><i class="fa fa-eye"></i></button></td></tr></tbody><tfoot ng-if="graph.totalItems > graph.limit"><tr style="border-bottom: none; text-align: center"><td colspan=4 class=gl-pagination style="padding:0px !important"><ul uib-pagination total-items=graph.totalItems items-per-page=graph.limit ng-model=graph.uibPage.currentPage max-size=10 class=pagination-sm rotate=false ng-change="pageChanged(graph.uibPage.currentPage,graph.name, graph.forMachine, graph.forUser, graph.forSalesRep)" style="margin-bottom: 0px;"></ul></td></tr></tfoot></table></div></div></div><br><div class=clearfix></div>');
$templateCache.put('app/components/demoCustomer/addDemoCustomer.html','<div class=modal-content><div class="modal-header bg-primary"><h4 class=modal-title><span>{{webAppTexts.headings.createDemoCustomer}}</span><div class="btn-group pull-right"><a class=modal-close-button ng-click=closeModal()><i class="fa fa-times"></i></a></div></h4></div><div class=modal-body><div class=row><form name=hierarchyLevelForm novalidate><fieldset ng-disabled=disabled><div class="col-sm-12 col-md-12 form-group has-feedback" ng-class="{\'has-error\': hierarchyLevelForm.name.$invalid && (hierarchyLevelForm.name.$dirty || hierarchyLevelForm.$submitted)}" style="margin-bottom:0px !important"><label for=name class=required><strong>{{webAppTexts.labels.name}}</strong></label> <input type=text class=form-control name=name id=name ng-model=model.customerName placeholder="Enter customer name" ng-pattern=\'/^(?!.*[*`\\\\;:"\\\\|,.<>\\/?])/\' maxlength=512 required> <span class="help-block error-block basic-block" ng-show=hierarchyLevelForm.name.$error.required>Customer name is required</span> <span class="help-block error-block basic-block" ng-show=hierarchyLevelForm.name.$error.pattern>Special characters like \\ / : * ? " <> | are not allowed.</span></div><div class="col-sm-12 col-md-12"><div class="form-group has-feedback"><br><div>Vibzer supports upto 3 levels of organization structure e.g. Plant --Area ----Section</div><br><div>You will be able to specify the display label for each level. All users are assigned to the elements of the organization structure. All machines are assigned to the lowest level of organization structure.</div><br><div>Note - The level of organization setup is one time activity and cannot be changed later.</div><br><label for=hierarchyLevel class=required><strong>{{webAppTexts.labels.selectHierarchyLevel}}</strong></label><ui-select style="display:inline-block; vertical-align:middle" id=type ng-model=model.level class="btn-group bootstrap-select form-control" ng-disabled=disabled ng-change=levelChanged() required><ui-select-match placeholder="Select number of levels for your organization structure"><span>{{$select.selected.value.name}}</span></ui-select-match><ui-select-choices repeat="levels.value.level as (key, levels) in hierarchyLevels | filter: $select.search"><span ng-bind-html=levels.value.name></span></ui-select-choices></ui-select></div></div><div class="col-sm-12 col-md-12" ng-if="model.level > 0" ng-class="{\'has-error\': hierarchyLevelForm.levelFirst.$invalid && (hierarchyLevelForm.levelFirst.$dirty || hierarchyLevelForm.$submitted)}"><div class="form-group has-feedback"><label for=levelFirst class=required><strong ng-bind=webAppTexts.labels.level1></strong></label> <input type=text class=form-control id=levelFirst name=levelFirst placeholder={{webAppTexts.placeholder.level1}} ng-model=model.hierarchyData[0].name required> <span class="help-block basic-block error-block">{{webAppTexts.errorMessages.levelOneName}}</span></div></div><div class=clearfix></div><div class="col-sm-12 col-md-12" ng-if="model.level > 1" ng-class="{\'has-error\': hierarchyLevelForm.levelSecond.$invalid && (hierarchyLevelForm.levelSecond.$dirty || hierarchyLevelForm.$submitted)}"><div class="form-group has-feedback"><label for=levelSecond class=required><strong ng-bind=webAppTexts.labels.level2></strong></label> <input type=text class=form-control id=levelSecond name=levelSecond placeholder={{webAppTexts.placeholder.level2}} ng-model=model.hierarchyData[1].name required> <span class="help-block basic-block error-block">{{webAppTexts.errorMessages.levelTwoName}}</span></div></div><div class=clearfix></div><div class="col-sm-12 col-md-12" ng-if="model.level > 2" ng-class="{\'has-error\': hierarchyLevelForm.levelThird.$invalid && (hierarchyLevelForm.levelThird.$dirty || hierarchyLevelForm.$submitted)}"><div class="form-group has-feedback"><label for=levelThird class=required><strong ng-bind=webAppTexts.labels.level3></strong></label> <input type=text class=form-control id=levelThird name=levelThird placeholder={{webAppTexts.placeholder.level3}} ng-model=model.hierarchyData[2].name required> <span class="help-block basic-block error-block">{{webAppTexts.errorMessages.levelThreeName}}</span></div></div></fieldset><div class=clearfix></div></form></div></div><div class=modal-footer><button type=button class="btn btn-cancel pull-left" ng-click=closeModal()>{{webAppTexts.buttons.cancel}}</button> <button type=button class="btn btn-primary pull-right" ng-click=createCustomer() ng-disabled=saveDisabled()>{{webAppTexts.buttons.createAndLogin}}</button></div></div>');
$templateCache.put('app/components/devices/allDeviceList.html','<div class="row vertical-align-row"><div class=col-lg-10><ul class="breadcrumb al-breadcrumb text-truncate no-top-margin"><li ng-repeat="itm in breadCrumbList"><a>{{itm}}</a></li></ul><br></div><div class="col-xs-2 align-right add-button"><button name=addDevice angular-ripple tooltip-placement=top-right uib-tooltip={{webAppTexts.tooltips.addDevice}} class="btn btn-primary" ng-click="manageDevice(\'add\', device)"><i class="fa fa-plus"></i></button></div></div><div class=clearfix></div><div class=panel style="margin-top: 5px;"><div class="container-limited container-fluid"><div class="row search-bar no-left-right-padding"><div class="col-xs-4 col-lg-4 col-md-4 sort-list"><form name=searchForm><div class=input-group style="margin-left: 2px; margin-bottom: 0px;" ng-class="{\'has-error\': searchForm.searchText.$invalid}"><input type=text class="form-control with-primary-addon" placeholder="Enter serial number" id=searchText name=searchText spellcheck=false ng-model=searchText ng-model-options="{ debounce: 200 }" ng-change=searchDevice(searchText)> <a ng-show=searchText class=search-clear style=margin-top:3px; ng-click="searchDevice(\'\');searchText = \'\'"><span class="fa fa-times"></span></a> <input type=hidden name=filter id=filter> <span class=input-group-btn><button class="btn btn-primary" type=button ng-click=searchDevice(searchText)><i class="fa fa-search"></i></button></span></div></form></div><div class="row col-xs-4"><div class="col-md-4 col-sm-4 col-lg-4 sort-list"><label class="form-control text-truncate" style=text-align:right;border:none;>{{webAppTexts.labels.deviceType}}</label></div><div class="col-sm-8 col-xs-8 col-md-8 sort-list"><ui-select id=type ng-model=selected.type class="btn-group bootstrap-select form-control" on-select=getDeviceType(selected.type)><ui-select-match placeholder={{webAppTexts.placeholder.selectDeviceType}}><span>{{$select.selected.value.displayName}}</span></ui-select-match><ui-select-choices repeat="type.value.id as (key, type) in deviceTypes | filter: $select.search"><span ng-bind-html=type.value.displayName></span></ui-select-choices></ui-select></div></div><div class="row col-xs-4"><div class="col-md-4 col-sm-4 col-lg-4 sort-list"><label class="form-control text-truncate" style=text-align:right;border:none;>{{webAppTexts.labels.distributors}}</label></div><div class="col-sm-8 col-xs-8 col-md-8 sort-list"><ui-select id=distributor ng-model=selected.distributor class="btn-group bootstrap-select form-control" on-select=pageChanged(1)><ui-select-match placeholder={{webAppTexts.placeholder.selectDistributor}}><span>{{$select.selected.value.name}}</span></ui-select-match><ui-select-choices repeat="type.value._id as (key, type) in distributors | filter: $select.search"><span ng-bind-html=type.value.name></span></ui-select-choices></ui-select></div></div></div><br><div class=row><div class=table-responsive style=margin-top:0px><table class="table no-left-right-padding" style=margin-bottom:0px><thead class=row><th class=col-md-2><h5>{{webAppTexts.headings.deviceId}}</h5></th><th class=col-md-2><h5>{{webAppTexts.headings.serialNo}}</h5></th><th class=col-md-2><h5>{{webAppTexts.headings.type}}</h5></th><th class=col-md-2><h5>{{webAppTexts.headings.distributor}}</h5></th><th class=col-md-2><h5>{{webAppTexts.headings.customer}}</h5></th><th class=col-md-2><h5>{{webAppTexts.headings.actions}}</h5></th></thead><tbody><tr ng-repeat="device in devices" class=table-border><td class=col-md-2><div class="vertical-align-row elipsis"><div class="pull-left vertical-align-row"><i class=icon-device_icon style="font-size: 27px !important;"></i></div><div class="pull-left elipsis" style="width:300px;margin-left: 6px;"><span>{{device.deviceId}}</span><br><span style="color: rgb(107, 106, 106);" ng-repeat="level in device.ancestors">{{level.name}} <span ng-if=!$last>/</span></span></div></div></td><td class=col-md-2 style="vertical-align: middle;"><span ng-if=device.serialNumber>{{device.serialNumber}}</span></td><td class=col-md-2 style="vertical-align: middle;"><span ng-if=device.typeName>{{device.typeName}}</span></td><td class=col-md-2 style="vertical-align: middle;"><span ng-if=device.typeName>{{device.distributorId.name}}</span></td><td class=col-md-2 style="vertical-align: middle;"><span ng-if=device.typeName>{{device.customerId.name}}</span></td><td class=col-md-2 style="vertical-align: middle;"><div class=pull-right><button ng-click="manageDevice(\'update\', device)" class="btn btn-primary" uib-tooltip={{webAppTexts.tooltips.updateDevice}}><i class="fa fa-edit"></i></button> <button ng-click="manageDevice(\'delete\', device)" class="btn btn-danger" uib-tooltip={{webAppTexts.tooltips.deleteDevice}} tooltip-placement=top-right><i class="fa fa-trash"></i></button></div></td></tr><tr ng-if=busy><td colspan=4><div class=text-center><i class="btn-lg fa fa-spinner fa-spin"></i> &nbsp;{{webAppTexts.notes.loadingDevices}}</div></td></tr><tr ng-if="!busy && devices && devices.length === 0"><td colspan=4><div class=text-center><i class="btn-lg fa fa-ban"></i> &nbsp;{{webAppTexts.notes.noDeviceFound}}</div></td></tr></tbody><tfoot ng-if="totalItems > limit"><tr style="border-bottom: none; text-align: center"><td colspan=4 class=gl-pagination><ul uib-pagination total-items=totalItems items-per-page=limit ng-model=uibPage.currentPage max-size=10 class=pagination-sm rotate=false ng-change=pageChanged(uibPage.currentPage) style="margin-bottom: 0px;"></ul></td></tr></tfoot></table></div></div></div></div>');
$templateCache.put('app/components/devices/devices.html','<div class="row vertical-align-row"><div class=col-lg-10><ul class="breadcrumb al-breadcrumb text-truncate" style=margin-top:7px;><li ng-repeat="itm in breadCrumbList"><a>{{itm}}</a></li></ul><br></div></div><div class=clearfix></div><div class=panel ng-style="{\'margin-top\': \'23px\'}"><div class="container-limited container-fluid"><div class="row search-bar no-left-right-padding"><div class="col-xs-4 col-lg-4 col-md-4 sort-list"><form name=searchForm><div class=input-group style="margin-left: 2px; margin-bottom: 0px;" ng-class="{\'has-error\': searchForm.searchText.$invalid}"><input type=text class="form-control with-primary-addon" placeholder="Enter serial number" id=searchText name=searchText spellcheck=false ng-model=searchText ng-model-options="{ debounce: 200 }" ng-change=searchDevice(searchText)> <a ng-show=searchText class=search-clear style=margin-top:3px; ng-click="searchDevice(\'\');searchText = \'\'"><span class="fa fa-times"></span></a> <input type=hidden name=filter id=filter> <span class=input-group-btn><button class="btn btn-primary" type=button ng-click=searchDevice(searchText)><i class="fa fa-search"></i></button></span></div></form></div><div class="row col-xs-4"><div class="col-md-4 col-sm-4 col-lg-4 sort-list"><label class="form-control text-truncate" style=text-align:right;border:none;>{{webAppTexts.labels.deviceType}}</label></div><div class="col-sm-8 col-xs-8 col-md-8 sort-list"><ui-select id=type ng-model=selected.type class="btn-group bootstrap-select form-control" on-select=getDeviceType(selected.type)><ui-select-match placeholder={{webAppTexts.placeholder.selectDeviceType}}><span>{{$select.selected.value.displayName}}</span></ui-select-match><ui-select-choices repeat="type.value.id as (key, type) in deviceTypes | filter: $select.search"><span ng-bind-html=type.value.displayName></span></ui-select-choices></ui-select></div></div></div><br><div class=row><div class=table-responsive style=margin-top:0px><table class="table no-left-right-padding" style=margin-bottom:0px><thead class=row><th ng-class="{\'col-md-2\': !isDistributorUser,\'col-md-4\': isDistributorUser }"><h5>{{webAppTexts.headings.deviceId}}</h5></th><th ng-class="{\'col-md-2\': !isDistributorUser,\'col-md-3\': isDistributorUser }"><h5>{{webAppTexts.headings.serialNo}}</h5></th><th ng-class="{\'col-md-2\': !isDistributorUser,\'col-md-2\': isDistributorUser }"><h5>{{webAppTexts.headings.type}}</h5></th><th ng-if=isDistributorUser class=col-md-5><h5>{{webAppTexts.headings.customer}}</h5></th><th ng-if=!isDistributorUser class=col-md-3><h5>{{webAppTexts.labels.machine}}</h5></th><th ng-if=!isDistributorUser class="text-align-center col-md-2"><h5>{{webAppTexts.headings.status}}</h5></th><th ng-if=!isDistributorUser class="text-align-center col-md-1" style=padding-left:50px;></th></thead><tbody><tr ng-repeat="device in devices" class=table-border><td ng-class="{\'col-md-2\': !isDistributorUser,\'col-md-4\': isDistributorUser }"><div class="vertical-align-row elipsis"><div class="pull-left vertical-align-row"><i class=icon-device_icon style="font-size: 27px !important;"></i></div><div class="pull-left elipsis" style="width:300px;margin-left: 6px;"><span>{{device.deviceId}}</span><br><span style="color: rgb(107, 106, 106);" ng-repeat="level in device.ancestors">{{level.name}} <span ng-if=!$last>/</span></span></div></div></td><td ng-class="{\'col-md-2\': !isDistributorUser,\'col-md-3\': isDistributorUser }" style="vertical-align: middle;"><span ng-if=device.serialNumber>{{device.serialNumber}}</span></td><td ng-class="{\'col-md-2\': !isDistributorUser,\'col-md-2\': isDistributorUser }" style="vertical-align: middle;"><span ng-if=device.typeName>{{device.typeName}}</span></td><td ng-if=isDistributorUser class=col-md-5 style="vertical-align: middle;"><span>{{device.customerId ? device.customerId.name : webAppTexts.placeholder.unsold}}</span></td><td ng-if=!isDistributorUser class=col-md-3 style="vertical-align: middle;"><span ng-if="device.machineName && !device.isHandheld">{{device.machineName}}</span> <span ng-if="(!device.machineName || device.isHandheld)">{{device.isHandheld ? webAppTexts.placeholder.NA : webAppTexts.placeholder.notAttached}}</span></td><td ng-if=!isDistributorUser class="text-align-center col-md-2" style="vertical-align: middle"><span ng-if="device.state && !device.isHandheld">{{device.state.displayName}}</span> <span ng-if="(!device.state || device.isHandheld)">{{webAppTexts.placeholder.NA}}</span></td><td ng-if=!isDistributorUser class="text-align-center col-md-1" style="font-size: 22px;vertical-align: middle"><a ng-if=device.state ng-click=detachDevice(device)><i class="fa fa-unlink btn unlink cursor-pointer" title={{webAppTexts.tooltips.detachDevice}}></i></a></td></tr><tr ng-if=busy><td colspan=4><div class=text-center><i class="btn-lg fa fa-spinner fa-spin"></i> &nbsp;{{webAppTexts.notes.loadingDevices}}</div></td></tr><tr ng-if="!busy && devices && devices.length === 0"><td colspan=4><div class=text-center><i class="btn-lg fa fa-ban"></i> &nbsp;{{webAppTexts.notes.noDeviceFound}}</div></td></tr></tbody><tfoot ng-if="totalItems > limit"><tr style="border-bottom: none; text-align: center"><td colspan=4 class=gl-pagination><ul uib-pagination total-items=totalItems items-per-page=limit ng-model=uibPage.currentPage max-size=10 class=pagination-sm rotate=false ng-change=pageChanged(uibPage.currentPage) style="margin-bottom: 0px;"></ul></td></tr></tfoot></table></div></div></div></div>');
$templateCache.put('app/components/distributor/distributors.html','<div class="row vertical-align-row"><div class=col-xs-6><ul class="breadcrumb al-breadcrumb" style=margin:0;><li ng-repeat="itm in breadCrumbList"><a>{{itm}}</a></li></ul></div><div class="col-xs-6 align-right" style=padding-right:25px;><button angular-ripple tooltip-placement=auto uib-tooltip={{webAppTexts.tooltips.addDistributor}} class="btn btn-primary" ng-click=addDistributor()><i class="fa fa-plus"></i></button></div></div><div class=clearfix></div><div class=panel style=margin-top:5px;><div class="container-limited container-fluid"><div class=row><div class=clearfix></div><br><div class=col-md-12><div class="container-limited container-fluid"><div class="row user-search-bar no-left-right-padding"><div class="col-md-3 col-sm-3 col-lg-3 sort-list" style="margin-right: 40px;"><form name=searchForm><div class=input-group ng-class="{\'has-error\': searchForm.searchText.$invalid}"><input type=text class="form-control with-primary-addon" placeholder={{webAppTexts.placeholder.searchDistributor}} id=searchText name=searchText spellcheck=false ng-pattern=\'/^(?!.*[*`\\\\;:"\\\\|,.<>\\/?])/\' ng-model=searchText ng-model-options="{ debounce: 200 }" ng-change=searchDistributor(searchText)> <a ng-show=searchText class=search-clear style=margin-top:3px; ng-click="searchDistributor(\'\')"><span class="fa fa-times"></span></a> <input type=hidden name=filter id=filter> <span class=input-group-btn><button class="btn btn-primary" type=button ng-click=searchDistributor(searchText)><i class="fa fa-search"></i></button></span></div><span class="help-block text-red" ng-show=searchForm.searchText.$error.pattern style=margin-top:-10px;>{{webAppTexts.errorMessages.invalidName}}</span></form></div><div class="col-sm-3 col-md-2 col-lg-2 pull-right sort-list"><ui-select ng-model=orderBy.selected class="btn-group bootstrap-select form-control" on-select=setSorting(orderBy.selected)><ui-select-match placeholder={{webAppTexts.placeholder.selectOrder}}><span>{{$select.selected.displayName}}</span></ui-select-match><ui-select-choices repeat="itm in orderBy | filter: $select.search"><span ng-bind-html=itm.displayName></span></ui-select-choices></ui-select></div><div class="col-sm-3 col-md-2 col-lg-2 pull-right sort-list"><ui-select ng-model=sortBy.selected class="btn-group bootstrap-select form-control" on-select=setSorting(sortBy.selected)><ui-select-match placeholder={{webAppTexts.placeholder.selectSort}}><span>{{$select.selected.displayName}}</span></ui-select-match><ui-select-choices repeat="itm in sortBy | filter: $select.search"><span ng-bind-html=itm.displayName></span></ui-select-choices></ui-select></div></div><div class=clearfix></div><div class=row style=margin-left:-30px;margin-right:-30px;><div class=table-responsive style=margin-top:0px><table id=user-table class="table no-left-right-padding" style=margin-bottom:0px><thead><tr><th style="vertical-align: middle;"><h5>{{webAppTexts.headings.distributorName}}</h5></th><th class=text-right style="vertical-align: middle;"><h5>{{webAppTexts.headings.created}}</h5></th><th class=text-right style="vertical-align: middle;"><h5>{{webAppTexts.headings.actions}}</h5></th></tr></thead><tbody><tr ng-repeat="dist in distributorList" class=table-border><td class=text-truncate ng-class=distributorNameClass><div style=margin-bottom:-10px;><div class=pull-left><span class=detail-cursor-pointer ng-click=viewDistributorDetails(dist)>{{dist.name}}</span></div></div></td><td class=text-right>{{ dist.createdOn | date :dateFormat }}</td><td class=pull-right style=margin-top:2px;><button ng-if=dist.isActive style=width:38px; tooltip-placement=auto uib-tooltip="Add distributor admin" class="btn btn-primary btn-space" ng-click=addAdmin(dist)><i class="fa fa-user-plus" aria-hidden=true></i></button></td></tr><tr ng-if=busy><td colspan=8><div class=text-center><i class="btn-lg fa fa-spinner fa-spin"></i> &nbsp;{{webAppTexts.notes.loadingDistributors}}</div></td></tr><tr ng-if="!busy && distributorList && distributorList.length === 0"><td colspan=8><div class=text-center><i class="btn-lg fa fa-ban"></i> &nbsp;{{webAppTexts.notes.noDistributorFound}}</div></td></tr></tbody><tfoot ng-if="totalItems > limit"><tr style="border-bottom: none; text-align: center"><td colspan=8 class=gl-pagination><ul uib-pagination total-items=totalItems items-per-page=limit ng-model=uibPage.currentPage max-size=10 class=pagination-sm rotate=false ng-change=pageChanged(uibPage.currentPage) style="margin-bottom: 0px;"></ul></td></tr></tfoot></table></div></div></div></div></div></div></div>');
$templateCache.put('app/components/formly_types/customRadioButton.html','<div class=row><div ng-disabled=to.disabled ng-repeat="option in to.options" class={{option.className}}><div class=radio><input type=radio name=unit id="{{option[to.internalName || \'name\']}}" ng-model="model[options[\'key\']]" value="{{option[to.valueProp || \'value\']}}"> <label for=unit>{{option[to.labelProp || \'name\']}}</label></div></div></div>');
$templateCache.put('app/components/formly_types/inputTemplate.html','<label for={{::id}} ng-class="{\'required\': options.templateOptions.required}"><strong>{{options.templateOptions.label}}</strong></label> <input type="{{options.templateOptions.type || \'text\'}}" class=form-control id={{id}} formly-dynamic-name=id formly-custom-validation=options.validators placeholder={{options.templateOptions.placeholder}} ng-required=options.templateOptions.required ng-disabled=options.templateOptions.disabled ng-pattern=options.templateOptions.pattern ng-min=options.templateOptions.min ng-max=options.templateOptions.max ng-model=model[options.key]> <span ng-if=options.templateOptions.spanText ng-class={{options.templateOptions.spanNgClass}} ng-style={{options.templateOptions.spanNgStyle}} ng-bind=options.templateOptions.spanText></span>');
$templateCache.put('app/components/formly_types/ngTableDynamic.html','<label class=required><strong>{{to.label}}</strong></label><div class=container-fluid><div class=row><table ng-table-dynamic="tableParams with to.cols" class="table table-bordered table-hover"><tr ng-repeat="row in $data" ng-class={{rowNgClass}}><td ng-class={{colNgClass}} ng-repeat="col in $columns" ng-switch=col.field><input ng-switch-when=selector type=checkbox ng-model=checkboxes.items[row[to.rowId]]> <span ng-switch-default>{{row[col.field]}}</span></td></tr></table></div></div>');
$templateCache.put('app/components/formly_types/uiSelect.html','<label for={{::id}} ng-class="{\'required\': options.templateOptions.required}"><strong>{{options.templateOptions.label}}</strong></label><ui-select ng-model=model[options.key] theme=bootstrap ng-required={{to.required}} ng-disabled=to.disabled><ui-select-match placeholder={{to.placeholder}}>{{$select.selected[to.valueProp || \'unit\']}}</ui-select-match><ui-select-choices group-by=to.groupBy repeat="option[to.labelProp || \'value\'] as option in to.options | filter: $select.search"><div ng-bind-html="option[to.valueProp || \'unit\'] | highlight: $select.search"></div></ui-select-choices></ui-select>');
$templateCache.put('app/components/hierarchy/hierarchy.html','<div class="row vertical-align-row"><div class=col-xs-6><ul class="breadcrumb al-breadcrumb" style=margin:0;><li><a>Organization Structure: {{hierarchyStructure}}</a></li></ul></div><div class="col-xs-6 align-right" style="padding-right: 25px;"><button ng-if=canAdd name=addHierarchy angular-ripple tooltip-placement=top-right uib-tooltip="Add {{levelName}}" class="btn btn-primary" ng-click="addOrViewHierarchy(\'add\')"><i class="fa fa-plus"></i></button></div></div><div class=clearfix></div><div class=panel style=margin-top:5px;><div class="container-limited container-fluid"><div class=row><div class=clearfix></div><br><div class=col-md-12><div class="container-limited container-fluid" style="padding-left: 0px; margin-left: -18px"><div><ul class="breadcrumb al-breadcrumb" style="margin: 0;color: black;padding-left: 1%;margin-bottom:1%"><li ng-repeat="itm in breadCrumbList" ng-click=breadCrumbClick(itm) style="cursor: pointer;"><a>{{itm.name}}</a></li></ul></div></div><div class=clearfix></div><div class=row><div class=table-responsive style=margin-top:0px><table id=user-table class="table no-left-right-padding" style=margin-bottom:0px><thead><th><h5>Select {{currentLevel.name}}</h5></th><th></th></thead><tbody><tr ng-repeat="level in levelData" class=table-border><td class=col-sm-4><div class=elipsis style=margin-bottom:-10px;><div class=pull-left><span ng-class="{\'detail-cursor-pointer\': currentLevel.level !== allLevel.length}" ng-click=viewHierarchyDetails(level)>{{level.name}}</span></div></div></td><td class="pull-right no-left-right-padding" style=margin-top:2px;><button ng-click="addOrViewHierarchy(\'view\', level)" tooltip-placement=top-right uib-tooltip="View {{currentLevel.name}}" class="btn btn-primary"><i class="fa fa-info"></i></button></td></tr><tr ng-if=busy><td colspan=4><div class=text-center><i class="btn-lg fa fa-spinner fa-spin"></i> &nbsp;Loading hierarchies...</div></td></tr><tr ng-if="!busy && levelData && levelData.length === 0"><td colspan=4><div class=text-center><i class="btn-lg fa fa-ban"></i> &nbsp;No organization unit found . . .!!!</div></td></tr></tbody><tfoot ng-if="totalItems > limit"><tr style="border-bottom: none; text-align: center"><td colspan=3 class=gl-pagination><ul uib-pagination total-items=totalItems items-per-page=limit ng-model=uibPage.currentPage max-size=10 class=pagination-sm rotate=false ng-change=pageChanged(uibPage.currentPage) style="margin-bottom: 0px;"></ul></td></tr></tfoot></table></div></div></div></div></div></div>');
$templateCache.put('app/components/login/login.html','<main class=auth-main><div class=auth-block><div class="login-page-logo text-center"><img src=./assets/img/logo.png alt=logo></div><form ng-if=!isForgetPassword id=loginForm class=form-horizontal><div class=form-group><label for=inputEmail3 class="col-sm-2 control-label required" style=padding-right:0px;>Email</label><div class=col-sm-10><input type=email ng-model=user.username class=form-control id=inputEmail3 placeholder=Email></div></div><div class=form-group><label for=inputPassword3 class="col-sm-2 control-label required" style=padding-right:0px;>Password</label><div class=col-sm-10><input type=password ng-model=user.password class=form-control id=inputPassword3 placeholder=Password></div></div><div class=form-group><div class="col-sm-offset-2 col-sm-10"><a class=forgot-pass ng-click=forgotPassword()>Forgot password?</a> <button type=submit ng-click=login() class="btn btn-default pull-right btn-auth">Sign in</button></div></div><div ng-show=loginError class="col-sm-offset-2 col-sm-10 alert login-alert-box text-center fade in" style="font-size:15px;font-weight:bold;color:red;border-color: #ebccd1;background-color: rgba(0,0,0,.4);">{{ loginError }}</div></form><div ng-if=isForgetPassword><form id=loginForm class=form-horizontal><div class=form-group><label for=email class="col-sm-2 control-label required" style=padding-right:0px;>Email</label><div class=col-sm-10><input type=email ng-model=user.username class=form-control id=email placeholder="Enter email address"></div></div><div class=form-group><div class="text-center col-sm-12" ng-include="\'app/components/commonHTMLs/recaptcha.html\'"></div></div><div class=form-group><div class=col-sm-12><button ng-click=cancel() type=submit class="btn btn-default pull-left btn-auth">Cancel</button> <button type=submit ng-click=resetPassword() class="btn btn-default pull-right btn-auth" ng-disabled=!user.username>Reset</button></div></div><div ng-show=forgotPasswordError class="col-sm-offset-2 col-sm-10 alert login-alert-box text-center fade in" style="font-size:15px;font-weight:bold;color:red;border-color: #ebccd1;background-color: rgba(0,0,0,.4);">{{ forgotPasswordError }}</div></form></div></div></main>');
$templateCache.put('app/components/machines/machines.html','<div class="row vertical-align-row"><div class=col-lg-10><ul class="breadcrumb al-breadcrumb text-truncate" ng-class="{\'no-top-margin\': canAdd}"><li ng-repeat="itm in breadCrumbList"><a ng-if=!$last class=cursor-pointer ng-click=breadCrumbClickHandler(itm)>{{itm}}&nbsp;</a> <span ng-show=$last ng-style="{\'color\': canAdd ? \'#209E91\' : \'black\' }">{{itm}}</span></li></ul><br></div><div class="col-xs-2 align-right add-button" ng-if=user.permission.addMachine><button ng-if=canAdd name=addMachine angular-ripple tooltip-placement=top-right uib-tooltip={{webAppTexts.tooltips.addMachine}} class="btn btn-primary" ng-click=addMachine()><i class="fa fa-plus"></i></button></div></div><div class=clearfix></div><div class=container-fluid><div class="row row-offcanvas" ng-class="{\'active\': !showFilter}"><div ng-show=showFilter class="sidebar-offcanvas sidebar"><div class=panel><div class="panel-heading filter-heading"><div class=row><div class=col-lg-6><i class="fa fa-filter" style=padding-right:10px;></i>{{webAppTexts.headings.filter}}</div><div class="pull-right no-left-right-padding"><a class=cursor-pointer><i tooltip-placement=bottom-right uib-tooltip={{webAppTexts.tooltips.clearFilter}} class="fa fa-remove" ng-click="getFilterMachines(\'reset\')"></i></a> <a class=cursor-pointer><i tooltip-placement=bottom-right uib-tooltip={{webAppTexts.tooltips.hideFilter}} class="fa fa-chevron-circle-right" ng-click=hideFilter()></i></a></div></div></div><div class=panel-body><h4>{{webAppTexts.headings.type}}</h4><div class=col-lg-12 ng-repeat="type in allMachineTypes"><label for={{type.name}} class=checkbox-label><input id={{type.name}} type=checkbox ng-model=type.selected ng-change=getMachineType(type)> {{type.displayName}}</label></div><div class=clearfix></div><br><h4>{{webAppTexts.headings.condition}}</h4><div class=col-lg-12 ng-repeat="condition in machineConditions"><label for={{condition.name}} class=checkbox-label><input id={{condition.name}} type=checkbox ng-model=condition.selected ng-change=getMachineCondition(condition)> {{condition.displayName}}</label></div><div class=clearfix></div><br><h4 ng-if="hierarchyLength > 1">{{webAppTexts.headings.unitTypes}}</h4><h4 ng-if="hierarchyLength === 1">{{webAppTexts.headings.unitType}}</h4><div class=col-lg-12><label ng-bind=topLevelLabel></label><ui-select ng-model=selected.topLevel class="btn-group bootstrap-select form-control" on-select="getResourceList(\'middleLevel\', selected.topLevel._id, false)" ng-disabled=!topLevelList.length><ui-select-match placeholder={{topLevelPlaceholder}}><span>{{$select.selected.name}}</span></ui-select-match><ui-select-choices repeat="itm in topLevelList | filter: $select.search"><span ng-bind-html=itm.name></span></ui-select-choices></ui-select></div><div class=clearfix></div><br><div ng-if="hierarchyLength >=2" class=col-lg-12><label ng-bind=middleLevelLabel></label><ui-select ng-model=selected.middleLevel class="btn-group bootstrap-select form-control" on-select="getResourceList(\'lowerLevel\', selected.middleLevel._id, false)" ng-disabled=!selected.topLevel><ui-select-match placeholder={{middleLevelPlaceholder}}><span>{{$select.selected.name}}</span></ui-select-match><ui-select-choices repeat="itm in middleLevelList | filter: $select.search"><span ng-bind-html=itm.name></span></ui-select-choices></ui-select><span ng-if="selected.topLevel && !middleLevelList.length" ng-bind="middleLevelLabel + \' not avaliable\'"></span></div><div class=clearfix></div><br><div ng-if="hierarchyLength === 3" class=col-lg-12><label ng-bind=lowerLevelLabel></label><ui-select ng-model=selected.lowerLevel class="btn-group bootstrap-select form-control" ng-disabled="!selected.middleLevel || !lowerLevelList.length"><ui-select-match placeholder={{lowerLevelPlaceholder}}><span>{{$select.selected.name}}</span></ui-select-match><ui-select-choices repeat="itm in lowerLevelList | filter: $select.search"><span ng-bind-html=itm.name></span></ui-select-choices></ui-select><br><br><span ng-if="selected.middleLevel && !lowerLevelList.length" ng-bind="lowerLevelLabel + \' not avaliable\'"></span></div><div class=clearfix></div><br><div class="col-lg-12 no-left-right-padding"><hr style="margin-top: 0px; margin-bottom: 5px;"><button type=button ng-click=getFilterMachines() class="btn btn-primary pull-right" ng-disabled=showFilterVisibility()>Filter</button></div></div></div></div><div class=content><div class=panel ng-style="{\'margin-top\': canAdd ? \'5px\' : \'20px\'}"><div class="container-limited container-fluid"><div class="row search-bar no-left-right-padding"><div class="col-xs-12 col-lg-4 col-md-4 col-sm-12 no-left-right-padding"><form name=searchForm><div class=input-group ng-class="{\'has-error\': searchForm.searchText.$invalid}"><input type=text class="form-control with-primary-addon" placeholder={{webAppTexts.placeholder.machineName}} id=searchText name=searchText spellcheck=false ng-model=searchText ng-model-options="{ debounce: 200 }" ng-change=searchMachine(searchText)> <a ng-show=searchText class=search-clear style=margin-top:3px; ng-click="searchMachine(\'\')"><span class="fa fa-times"></span></a> <input type=hidden name=filter id=filter> <span class=input-group-btn><button class="btn btn-primary" type=button ng-click=searchMachine(searchText)><i class="fa fa-search"></i></button></span></div></form></div><div class="col-sm-8 col-md-8 col-xs-12 no-left-right-padding"><div class="pull-right sort-list" uib-tooltip={{webAppTexts.tooltips.filterMachines}} tooltip-placement=bottom-right><a class="cursor-pointer pull-right" data-toggle=offcanvas><i class="fa fa-filter filter-icon"></i></a></div><div ng-if=!forRoute class="col-sm-3 col-xs-5 col-md-3 pull-right sort-list"><ui-select id=order ng-model=orderBy.selected class="btn-group bootstrap-select form-control" on-select="setSorting(\'order\', orderBy.selected)"><ui-select-match placeholder={{webAppTexts.placeholder.selectOrder}}><span>{{$select.selected.value.displayName}}</span></ui-select-match><ui-select-choices repeat="type.value.id as (key, type) in orderBy | filter: $select.search"><span ng-bind-html=type.value.displayName></span></ui-select-choices></ui-select></div><div ng-if=!forRoute class="col-sm-3 col-xs-5 col-md-3 pull-right sort-list" style="padding-left: 2px;"><ui-select id=sort ng-model=sortBy.selected class="btn-group bootstrap-select form-control" on-select="setSorting(\'sort\', sortBy.selected)"><ui-select-match placeholder={{webAppTexts.placeholder.selectSort}}><span>{{$select.selected.value.displayName}}</span></ui-select-match><ui-select-choices repeat="type.value.id as (key, type) in sortBy | filter: $select.search"><span ng-bind-html=type.value.displayName></span></ui-select-choices></ui-select></div><div class="visible-xs clearfix"></div><br class=visible-xs></div></div><div class=row><div class=table-responsive style=margin-top:0px><table id=machine-table class="table no-left-right-padding" style=margin-bottom:0px><thead class=row><th class=col-md-3><h5>{{webAppTexts.headings.machineName}}</h5></th><th class="text-align-center col-md-3"><h5>{{webAppTexts.headings.monitoringState}}</h5></th><th class="text-align-center col-md-4" style=padding-left:50px;><h5>{{webAppTexts.headings.condition}}</h5></th><th class="align-right col-md-2"></th></thead><tbody><tr ng-repeat="machine in machines" class=table-border><td class=col-md-3><div class="vertical-align-row elipsis"><div class="pull-left vertical-align-row" style="font-size: 30px; margin-right:5px"><i ng-style="{\'color\': machine.vibrationInfo.color}" class={{machine.icon}}></i></div><div class="pull-left elipsis" style="width:300px;padding-left: 7px;"><span class=detail-cursor-pointer ng-click=viewMachineDetails(machine)>{{machine.name}}</span><br><span style="color: rgb(107, 106, 106);" ng-repeat="level in machine.ancestors">{{level.name}} <span ng-if=!$last>/</span></span></div></div></td><td class=text-center style="vertical-align: middle;"><span ng-if=machine.state>{{machine.state}}</span> <span ng-if=!machine.state>{{webAppTexts.labels.notApplicable}}</span></td><td class="text-align-center col-md-4" style="vertical-align: middle;padding-left:50px;"><span ng-if="machine.condition || machine.condition === 0"><span ng-style="{\'color\': machine.vibrationInfo.color}" ng-bind="machine.vibrationInfo.displayName + \' \'"></span> <span ng-if="machine.lastReadingType.id === 1" ng-bind="\'(\'+ machine.lastReadingType.assessmentLabel + \')\'"></span><br ng-if=machine.vibrationInfo.createdOn><span ng-if=machine.vibrationInfo.createdOn>{{machine.vibrationInfo.createdOn | date :dateFormat}}</span></span></td><td class=col-md-2 style="padding-left:0px !important; padding-right:6px !important;"><div class=pull-right style=padding-top:5px;><button angular-ripple tooltip-placement=top uib-tooltip={{webAppTexts.tooltips.trends}} class="btn btn-primary btn-space" ng-click=showTrendsForMonitoredMachine(machine) ng-if=machine.monitoredOnline ng-disabled=!machine.lastReadingType><i class=icon-trend></i></button> <button angular-ripple tooltip-placement=top uib-tooltip={{webAppTexts.tooltips.trends}} class="btn btn-primary btn-space" ng-click=showTrendsForNonMonitoredMachine(machine) ng-if=!machine.monitoredOnline ng-disabled=!machine.lastReadingType><i class=icon-trend></i></button> <button angular-ripple tooltip-placement=top uib-tooltip={{webAppTexts.tooltips.sessions}} class="btn btn-primary btn-space" ng-click=showSessions(machine)><i class=icon-review></i></button> <button angular-ripple tooltip-placement=top-right uib-tooltip={{webAppTexts.tooltips.machineLogs}} class="btn btn-primary btn-space" ng-click=showAlerts(machine)><i class="fa fa-bell"></i></button></div></td></tr><tr ng-if=busy><td colspan=4><div class=text-center><i class="btn-lg fa fa-spinner fa-spin"></i> &nbsp;{{webAppTexts.notes.loadingMachines}}</div></td></tr><tr ng-if="!busy && machines && machines.length === 0"><td colspan=4><div class=text-center><i class="btn-lg fa fa-ban"></i> &nbsp;{{webAppTexts.notes.noMachineFound}}</div></td></tr></tbody><tfoot ng-if="totalItems > limit"><tr style="border-bottom: none; text-align: center"><td colspan=4 class=gl-pagination><ul uib-pagination total-items=totalItems items-per-page=limit ng-model=uibPage.currentPage max-size=10 class=pagination-sm rotate=false ng-change=pageChanged(uibPage.currentPage) style="margin-bottom: 0px;"></ul></td></tr></tfoot></table></div></div></div></div></div></div></div>');
$templateCache.put('app/components/organization/organization.html','<div class="row vertical-align-row"><div class="col-xs-6 col-lg-12"><ul class="breadcrumb al-breadcrumb" style=margin-top:7px;><li><a>Organization Structure</a></li></ul></div></div><div class=clearfix></div><div class=row><div class=col-lg-5 style=margin-top:4px;><div class="panel with-scroll panel-default bootstrap-panel"><div class=panel-heading><h5 title={{hierarchyStructure}}>{{hierarchyStructure}}</h5><div class=pull-right style="margin-top: -25px;"><button angular-ripple tooltip-placement=auto uib-tooltip="Delete {{selectedState.currentLevel.name}}" class="btn btn-remove" ng-click=deleteHierarchy() ng-disabled=selectedState.isDisabledEdit><i class="fa fa-trash"></i></button> <button angular-ripple tooltip-placement=auto uib-tooltip="Edit {{selectedState.currentLevel.name}}" class="btn btn-primary" ng-click=addOrganization(true) ng-disabled=selectedState.isDisabledEdit><i class="fa fa-edit"></i></button> <button angular-ripple tooltip-placement=top-right uib-tooltip="Add {{selectedState.nextLevel.name}}" class="btn btn-primary" ng-click=addOrganization() ng-disabled=selectedState.isDisabledAdd><i class="fa fa-plus"></i></button></div></div><div class=panel-body><div ng-if=showTree #organizationtreeview js-tree=basicConfig ng-model=treeData tree=organizationTree should-apply=applyModelChanges() tree-events=select_node:selectNode;ready:readyCB></div></div></div></div><div ng-if="isAddForm || isEditForm" class=col-lg-7 style=margin-top:4px;><div class="panel with-footer panel-default bootstrap-panel"><div class=panel-heading><h5>{{isEditForm ? \'Edit \' + selectedState.currentLevel.name + \': \' + updatedOrgName : \'Add \' + selectedState.nextLevel.name}}</h5></div><div class=panel-body><div ng-if=isFirstLevel style="margin-top: -12px;"><form name=hierarchy.basicInfoForm><h3 class=form-heading>{{webAppTexts.labels.details}}</h3><hr style="margin-top: 4px;"><fieldset ng-disabled=viewDetails><div class=row><div class=col-md-6><div class="form-group has-feedback" ng-class="{\'has-error\': hierarchy.basicInfoForm.name.$invalid && (hierarchy.basicInfoForm.name.$dirty || hierarchy.basicInfoForm.$submitted)}"><label for=name class=required><strong>{{webAppTexts.labels.name}}</strong></label> <input type=text class=form-control name=name id=name ng-model=hierarchy.name placeholder={{webAppTexts.placeholder.name}} ng-pattern=\'/^(?!.*[*`\\\\;:"\\\\|,.<>\\/?])/\' maxlength=512 required> <span class="help-block error-block basic-block" ng-show=hierarchy.basicInfoForm.name.$error.required>Name is required</span> <span class=help-block ng-show=hierarchy.basicInfoForm.name.$error.pattern>Special characters like \\ / : * ? " <> | are not allowed.</span></div></div><div class=col-md-6><label for=description>{{webAppTexts.labels.description}}</label> <textarea type=textArea placeholder={{webAppTexts.placeholder.description}} class=form-control name=description id=description maxlength=512 ng-model=hierarchy.description style="min-height:60px !important; resize: none;"></textarea></div></div><div class=clearfix></div><br><div class=row><div class=col-md-6><div class="form-group has-feedback" ng-class="{\'has-error\':hierarchy.isLineFrequencyRequired}"><label for=freq class=required><strong>{{webAppTexts.labels.lineFrequency}}</strong></label><ui-select ng-model=hierarchy.meta.line_frequency name=freq theme=bootstrap ng-disabled=viewDetails><ui-select-match placeholder={{webAppTexts.placeholder.lineFrequency}}>{{$select.selected.value.label}}</ui-select-match><ui-select-choices repeat="freq.value.value as (key, freq) in lineFreq | filter: $select.search"><div ng-bind-html="freq.value.label | highlight: $select.search"></div></ui-select-choices></ui-select><span class="help-block error-block basic-block">Line frequency is required</span></div></div><div class=col-md-6><div class="form-group has-feedback" ng-class="{\'has-error\':hierarchy.isLanguageRequired}"><label for=language class=required><strong>{{webAppTexts.labels.analysisLanguage}}</strong></label><ui-select ng-model=hierarchy.meta.language name=language theme=bootstrap ng-disabled=viewDetails><ui-select-match placeholder={{webAppTexts.placeholder.analysisLanguage}}>{{$select.selected}}</ui-select-match><ui-select-choices repeat="language in languages | filter: $select.search"><div ng-bind-html="language | highlight: $select.search"></div></ui-select-choices></ui-select><span class="help-block error-block basic-block">Analysis report langauge is required</span></div></div></div><div class=row><div class=col-md-6 ng-if="hierarchy.meta.line_frequency === -1"><div class="form-group has-feedback" ng-class="{\'has-error\': hierarchy.basicInfoForm.customLineFrequency.$invalid && (hierarchy.basicInfoForm.customLineFrequency.$dirty || hierarchy.basicInfoForm.$submitted)}"><input type=text class=form-control name=customLineFrequency id=customLineFrequency ng-model=hierarchy.customLineFrequency ng-pattern="/^\\d+$/" placeholder={{webAppTexts.placeholder.otherFrequency}} required> <span class="help-block error-block basic-block" ng-show=hierarchy.basicInfoForm.customLineFrequency.$error.required>Line frequency is required</span> <span class="help-block error-block basic-block" ng-show=hierarchy.basicInfoForm.customLineFrequency.$error.pattern>Line frequency should be number greater than 0 and smaller than 200.</span> <span ng-if=customLineFrequencyRequired style=color:#a94442;>Line frequency should be greater than 0 and smaller than 200.</span></div></div></div><br></fieldset><br><h3 class=form-heading>{{webAppTexts.labels.address}}</h3><hr style="margin-top: 4px;"><fieldset ng-disabled=viewDetails><div class=row><div class=col-md-1><div class=text-center><input type=checkbox ng-model=hierarchy.meta.address.sameAsCompanyAddress ng-change=changingAddressType() ng-disabled="user.customer && !user.customer.address"> <label for=radio></label></div></div><div class=col-md-11 style="margin-left: -25px;"><strong ng-if=!viewDetails ng-click=changingAddressType(true) style=cursor:pointer;>{{webAppTexts.labels.sameAsCompanyAddress}}</strong> <strong ng-if=viewDetails>{{webAppTexts.labels.sameAsCompanyAddress}}</strong></div><div class=clearfix></div><fieldset ng-disabled=viewDetails><div class=row><div><fieldset ng-disabled=hierarchy.meta.address.sameAsCompanyAddress><div class=col-md-12><div class=col-md-6><div class="form-group has-feedback"><label for=addressLine1><strong>{{webAppTexts.labels.addressLine1}}</strong></label> <textarea class=form-control type=textarea placeholder={{webAppTexts.placeholder.addressLine1}} name=addressLine1 id=addressLine1 ng-model=hierarchy.meta.address.addressLineOne style="min-height:60px !important; resize: none;"></textarea></div></div><div class=col-md-6><div class="form-group has-feedback"><label for=addressLine2><strong>{{webAppTexts.labels.addressLine2}}</strong></label> <textarea class=form-control type=textArea placeholder={{webAppTexts.placeholder.addressLine2}} name=addressLine2 id=addressLine2 ng-model=hierarchy.meta.address.addressLineTwo style="min-height:60px !important; resize: none;"></textarea></div></div></div><div class=col-md-12><div class=col-md-6><div class="form-group has-feedback"><label for=addressLine3><strong>{{webAppTexts.labels.addressLine3}}</strong></label> <textarea class=form-control type=textArea placeholder={{webAppTexts.placeholder.addressLine3}} name=addressLine3 id=addressLine3 ng-model=hierarchy.meta.address.addressLineThree style="min-height:60px !important; resize: none;"></textarea></div></div><div class=col-md-6><div class="form-group has-feedback" ng-class="{\'has-error\': hierarchy.basicInfoForm.city.$invalid && (hierarchy.basicInfoForm.city.$dirty || hierarchy.basicInfoForm.$submitted)}"><label for=city><strong>{{webAppTexts.labels.city}}</strong></label> <input type=text class=form-control id=city name=city ng-model=hierarchy.meta.address.city placeholder={{webAppTexts.placeholder.city}} ng-pattern="/^[a-zA-Z]+$/"><span class="help-block error-block basic-block" ng-show=hierarchy.basicInfoForm.city.$error.pattern>Not a valid city name. City name consist of alphabets only.</span></div></div></div><div class=col-md-12><div class=col-md-6><div class="form-group has-feedback" ng-class="{\'has-error\': hierarchy.basicInfoForm.state.$invalid && (hierarchy.basicInfoForm.state.$dirty || hierarchy.basicInfoForm.$submitted)}"><label for=state><strong>{{webAppTexts.labels.state}}</strong></label> <input type=text class=form-control id=state name=state ng-model=hierarchy.meta.address.state placeholder={{webAppTexts.placeholder.state}} ng-pattern="/^[a-zA-Z]+$/"><span class="help-block error-block basic-block" ng-show=hierarchy.basicInfoForm.state.$error.pattern>Not a valid state name. State name consist of alphabets only.</span></div></div><div class=col-md-6><div class="form-group has-feedback" ng-class="{\'has-error\': hierarchy.basicInfoForm.pinCode.$invalid && (hierarchy.basicInfoForm.pinCode.$dirty || hierarchy.basicInfoForm.$submitted)}"><label for=pinCode><strong>{{webAppTexts.labels.zipCode}}</strong></label> <input type=text class=form-control id=pinCode ng-pattern="/^[A-Za-z0-9]{3,10}$/" name=pinCode ng-model=hierarchy.meta.address.pinCode placeholder={{webAppTexts.placeholder.zipCode}}><span class="help-block error-block basic-block" ng-show=hierarchy.basicInfoForm.pinCode.$error.pattern>ZIP code should contain alphanumeric characters and length should be between 3 and 10.</span></div></div></div><div class=col-md-12><div class=col-md-6><div class="form-group has-feedback" ng-class="{\'has-error\': hierarchy.basicInfoForm.country.$invalid && (hierarchy.basicInfoForm.country.$dirty || hierarchy.basicInfoForm.$submitted)}"><label for=country><strong>{{webAppTexts.labels.country}}</strong></label><ui-select ng-disabled="viewDetails || viewForm || disabled || hierarchy.meta.address.sameAsCompanyAddress" id=country name=country ng-model=hierarchy.meta.address.country class="btn-group bootstrap-select form-control"><ui-select-match placeholder={{webAppTexts.placeholder.country}}><span ng-bind=$select.selected.value.name></span></ui-select-match><ui-select-choices repeat="country.value.name as (key, country) in allCountries | filter: $select.search"><span ng-bind-html=country.value.name></span></ui-select-choices></ui-select><span class="help-block error-block basic-block" ng-show=hierarchy.basicInfoForm.country.$error.pattern>Not a valid country name. Country name consist of alphabets only.</span></div></div><div class=col-md-6><div class="form-group has-feedback" ng-class="{\'has-error\': hierarchy.basicInfoForm.phone.$invalid && (hierarchy.basicInfoForm.phone.$dirty || hierarchy.basicInfoForm.$submitted)}"><label for=phone><strong>{{webAppTexts.labels.phoneNo}}</strong></label> <input type=text id=phone name=phone ng-pattern="/^\\s*(?:\\+?(\\d{1,3}))?[-. (]*(\\d{3})[-. )]*(\\d{3})[-. ]*(\\d{4})(?: *x(\\d+))?\\s*$/" placeholder={{webAppTexts.placeholder.phoneNo}} class="form-control with-primary-addon" spellcheck=false ng-model=hierarchy.meta.address.phone style=z-index:0><span class=help-block ng-show=hierarchy.basicInfoForm.phone.$error.pattern>Phone number is invalid.</span></div></div></div><div class=col-md-12><div class=col-md-6><div class="form-group has-feedback" ng-class="{\'has-error\': hierarchy.basicInfoForm.emailId.$invalid && (hierarchy.basicInfoForm.emailId.$dirty || hierarchy.basicInfoForm.$submitted)}"><label for=emailId><label for=emailId><strong>{{webAppTexts.labels.email}}</strong></label></label> <input type=email id=emailId name=emailId placeholder={{webAppTexts.placeholder.email}} class="form-control with-primary-addon" spellcheck=false ng-model=hierarchy.meta.address.email ng-pattern="/^[A-Za-z0-9._%+-]+@(?:[A-Za-z0-9](?:[A-Za-z0-9-]*[A-Za-z0-9])?\\.)+[A-Za-z]{2,}$/" style=z-index:0><span class=help-block ng-show=hierarchy.basicInfoForm.emailId.$error.pattern>Email is invalid.</span></div></div></div></fieldset></div></div></fieldset></div><br><br></fieldset><div ng-include="\'app/components/commonHTMLs/hierarchyAssignUser.html\'"></div></form></div><div ng-if=!isFirstLevel style="margin-top: -12px;"><form name=hierarchy.basicInfoForm><h3 class=form-heading>{{webAppTexts.labels.details}}</h3><hr style="margin-top: 4px;"><fieldset><div class=col-sm-6><div class="form-group has-feedback" ng-class="{\'has-error\': hierarchy.basicInfoForm.name.$invalid && (hierarchy.basicInfoForm.name.$dirty || hierarchy.basicInfoForm.$submitted)}"><label for=name class=required><strong>{{webAppTexts.labels.name}}</strong></label> <input type=text class=form-control id=name name=name ng-model=hierarchy.name placeholder={{webAppTexts.placeholder.name}} ng-pattern=\'/^(?!.*[*`\\\\;:"\\\\|,.<>\\/?])/\' maxlength=512 required> <span class="help-block basic-block text-red" ng-show="!hierarchy.name && !hierarchy.basicInfoForm.name.$pristine && hierarchy.basicInfoForm.name.$error.required">Name is required</span> <span class=help-block ng-show=hierarchy.basicInfoForm.name.$error.pattern>Special characters like \\ / : * ? " <> | are not allowed.</span></div></div><br class=visible-xs><div class=col-sm-6><label for=description>{{webAppTexts.labels.description}}</label> <textarea type=textArea placeholder={{webAppTexts.placeholder.description}} class=form-control name=description id=description ng-model=hierarchy.description maxlength=512 style="min-height:60px !important; resize: none;"></textarea></div></fieldset><div ng-include="\'app/components/commonHTMLs/hierarchyAssignUser.html\'"></div></form></div></div><div class=panel-footer><div style="margin-top: -16px;"><button type=button class="btn btn-cancel pull-left" ng-click=cancel()>Cancel</button> <button type=button class="btn btn-primary pull-right" ng-if=isAddForm ng-disabled=saveButtonVisibility() ng-click=save()>Save</button> <button type=button class="btn btn-primary pull-right" ng-if=isEditForm ng-disabled=saveButtonVisibility() ng-click=save()>Update</button></div></div></div></div></div>');
$templateCache.put('app/components/profilePage/profile.html','<ul class="breadcrumb al-breadcrumb"><li ng-repeat="itm in breadCrumbList"><a>{{itm}}</a></li></ul><br><div class=clearfix></div><div ba-panel-class=profile-page><div class=panel style=margin-top:10px;><div class="container-limited container-fluid panel"><div class=row><div class="col-md-12 top-margin"><button type=button class="btn btn-primary pull-right" ng-disabled=true>{{webAppTexts.buttons.updateProfile}}</button> <button type=button class="btn btn-primary pull-right" ng-click=changePassword() style="margin-right: 15px;">{{webAppTexts.buttons.changePassword}}</button></div></div><br><form name=userProfileForm><h3 class="form-heading no-left-padding">{{webAppTexts.headings.personalInformation}}</h3><hr class=no-top-margin><div class=row><fieldset ng-disabled=viewProfile><div class=col-sm-6><div class="form-group has-feedback" ng-class="{\'has-error\': userForm.firstName.$invalid && (userForm.firstName.$dirty || userForm.$submitted)}"><label for=firstName class="col-md-3 vertical-align-label no-left-padding"><strong>{{webAppTexts.labels.firstName}}</strong></label><div class=col-md-9><input type=text class=form-control id=firstName name=firstName ng-model=user.firstName placeholder="Enter first name" ng-pattern="/^[a-zA-Z]*$/" required></div></div></div><br class=visible-xs><div class=col-sm-6><div class="form-group has-feedback" ng-class="{\'has-error\': userForm.lastName.$invalid && (userForm.lastName.$dirty ||userForm.$submitted)}"><label for=lastName class="col-md-3 vertical-align-label"><strong>{{webAppTexts.labels.lastName}}</strong></label><div class="col-md-9 no-right-padding"><input type=text class=form-control id=lastName name=lastName ng-model=user.lastName placeholder="Enter last name" ng-pattern="/^[a-zA-Z]*$/" required></div></div></div><div class=clearfix></div><br><br><div class=col-sm-6><label for=email class="col-md-3 vertical-align-label no-left-padding"><strong>{{webAppTexts.labels.email}}</strong></label><div class=col-md-9><div ng-class="{\'has-error\' : userForm.email.$invalid && !userForm.email.$pristine}"><input type=email id=email name=email placeholder="Enter email address" class="form-control with-primary-addon" spellcheck=false ng-model=user.email></div></div></div></fieldset><div class="container-limited container-fluid top-margin"><div class=clearfix></div><div class="row left-right-margin"><h3 class="form-heading no-left-padding">{{webAppTexts.headings.roles}}</h3><hr class=no-top-margin><div class=table-responsive><table id=roles-table class="table no-left-right-padding" style=margin-bottom:0px><thead><th><h5 ng-if="user.distributorIds && user.distributorIds.length > 0">{{webAppTexts.headings.organizationName}}</h5><h5 ng-if="user.customerIds && user.customerIds.length > 0">{{webAppTexts.headings.unitName}}</h5></th><th class=pull-right><h5>{{webAppTexts.headings.role}}</h5></th></thead><tbody><tr ng-repeat="itm in roleInfo" class=table-border><td class=vertical-align-middle><span ng-if="itm.resource && itm.resource.ancestors && itm.resource.ancestors.length"><span style="color: rgb(107, 106, 106);" ng-repeat="level in itm.resource.ancestors">{{level.name}} <span>/</span></span> <span ng-if="itm.resourceType === \'machine\'" ng-bind="(itm.resource.parentId.name + \' / \')"></span></span> <span>{{itm.resource.name}}</span></td><td class=pull-right><span>{{itm.role}}</span></td></tr><tr ng-if=busy><td ng-attr-colspan=2><div class=text-center><i class="btn-lg fa fa-spinner fa-spin"></i> &nbsp;Loading user roles...</div></td></tr><tr ng-if="!busy && roleInfo && roleInfo.length === 0"><td ng-attr-colspan=2><div class=text-center><i class="btn-lg fa fa-ban"></i> &nbsp;No role found . . .!!!</div></td></tr></tbody><tfoot ng-if="totalItems > limit"><tr style="border-bottom: none; text-align: center"><td ng-attr-colspan=2 class=gl-pagination><ul uib-pagination total-items=totalItems items-per-page=limit ng-model=uibPage.page max-size=10 class=pagination-sm boundary-links="totalItems/limit > limit" rotate=false ng-change=pageChanged(uibPage.page) style="margin-bottom: 0px;"></ul></td></tr></tfoot></table></div></div></div></div></form><div class=clearfix></div><br></div></div></div>');
$templateCache.put('app/components/report/machineReportPage.html','<div id=currentReport ng-show=!loadReport class=container-fluid ng-class="{\'report-container\': webReportPage}"><div class=row><div class=col-xs-12><span ng-if=takenBy style="font-size: 11px;" ng-style=takenOnStyle class=pull-left ng-bind=takenBy></span> <span style="font-size: 11px;" ng-style=takenOnStyle class=pull-right ng-bind="reportData.createdOn | date:dateFormat"></span></div><div class=col-xs-12><h3 style=margin-top:0px class=text-center><strong ng-bind="(machineInfo ? ((machineInfo.machineType) + \': \') : \'\')"></strong>{{machineInfo.name}}</h3></div><div ng-if=greenAnimate class="col-xs-12 text-center"><div class=circle></div></div><div ng-if=redAnimate class=col-xs-12><div class="alert alert-danger"><strong>IMPORTANT NOTE:</strong><br>{{importantNote}}</div></div><div class=col-xs-12><div ng-repeat="property in reportProperties" ng-show="(property.recommendation.length || showExcellent)" ng-style="{\'margin-bottom\': ($index === reportProperties.length -1 || isFinalSeverity($index, false) ? \'0px\' :\'10px\')}"><div><label class=report-label>{{property.label}}</label></div><div ng-if="!isFinalSeverity($index, false)"><div ng-if="property.prev != property.Current && !noLastReport" ng-style="{\'margin-left\': property.prev + \'%\'}"><span class=status-notation-label>Previous</span><div class=arrow-down-prev></div></div><div ng-style="{\'margin-left\': property.Current + \'%\'}"><span class=status-notation-label ng-style="{\'margin-left\': ((property.prev === property.Current) && (property.currentSeverity>4) ? \'-46px\' : \'0px\')}">{{property.prev === property.Current ? ( noLastReport ? \'Current\' : \'Previous & Current\' ) : \'Current\'}}</span><div class=arrow-down-last></div></div><div id=conditon-status class=text-center><div class="col-xs-4 report-border">Good</div><div class="col-xs-4 report-border report-center-div-border" style=padding:0px>OK (Passable)</div><div class="col-xs-4 report-border">Bad</div></div></div><div><ul class=recommendation-list><li ng-repeat="rec in property.recommendation track by $index">{{rec}}</li></ul></div><hr ng-style="{\'margin-top\': (isFinalSeverity($index, false) ? \'20px\':\'10px\')}" ng-show="(property.recommendation.length || showExcellent)" class=report-divider ng-class="{\'thick-hr\':isFinalSeverity($index, true)}"><div class=text-center ng-if="isFinalSeverity($index, false)"><button ng-click=toggleShowExcellent() style="margin-top: -23px;" class="btn btn-sm btn-primary">{{!showExcellent ? \'More\': \'Less\'}} Details <i class="fa fa-chevron-down rotate" ng-class="{\'down\': showExcellent}"></i></button></div></div></div><div ng-if="currentReportExpSysVersion && !showMachineStatus" class="col-xs-12 text-right container-fluid current-report-version" ng-bind="\'Version: \' + currentReportExpSysVersion"></div><div class=col-xs-12><label for=comment><strong>Comments</strong></label><div><table class="table table-bordered" style=margin-top:8px; ng-if=comments.length><thead><tr><th><strong>Comment</strong></th><th class=text-center><strong>Submitted By</strong></th></tr></thead><tbody><tr ng-repeat="comment in comments"><td><span>{{comment.message}}</span></td><td class=text-center><span>{{comment.uploadedBy.firstName + \' \' + comment.uploadedBy.lastName}}</span></td></tr></tbody></table></div><textarea type=textArea placeholder="Enter comment" class=form-control name=comment id=comment ng-model=reportComment></textarea> <button class="btn btn-primary pull-right" ng-click=addComment() ng-disabled=!reportComment style=margin-top:10px>Submit</button></div></div></div><div ng-show=loadReport class="container-fluid text-center screen-center-text"><div class=row><div class=col-xs-12><h1><i class="fa fa-spinner fa-spin"></i>&nbsp;&nbsp;Loading ...</h1></div></div></div>');
$templateCache.put('app/components/rpb/downloadRpb.html','<div class=clearfix></div><div class=panel style=margin-top:10px;><div class="container-limited container-fluid"><div class="row search-bar no-left-right-padding" style=padding-bottom:15px;><div class="col-md-3 col-sm-3 col-lg-3 col-xs-6 sort-list"><ui-select id=distributor ng-model=selected.distributorId class="btn-group bootstrap-select form-control" on-select="selectedProperty(\'distributor\')" ng-disabled="!(distributors && distributors.length)"><ui-select-match placeholder="Select Distributor"><span ng-bind=$select.selected.value.name></span></ui-select-match><ui-select-choices repeat="type.value._id as (key, type) in distributors | filter: $select.search"><span ng-bind-html=type.value.name></span></ui-select-choices></ui-select></div><div class="col-md-3 col-sm-3 col-lg-3 col-xs-6 sort-list"><ui-select id=customer ng-model=selected.customerId class="btn-group bootstrap-select form-control" on-select="selectedProperty(\'customer\')" ng-disabled="!(customers && customers.length)"><ui-select-match placeholder="Select Customer"><span ng-bind=$select.selected.value.name></span></ui-select-match><ui-select-choices repeat="type.value._id as (key, type) in customers | filter: $select.search"><span ng-bind-html=type.value.name></span></ui-select-choices></ui-select></div><div class="col-md-3 col-sm-3 col-lg-3 col-xs-6 sort-list"><ui-select id=machine ng-model=selected.machineId class="btn-group bootstrap-select form-control" on-select="selectedProperty(\'machine\', type.value)" ng-disabled="!(machines && machines.length)"><ui-select-match placeholder="Select Machine"><span ng-bind=$select.selected.value.name></span></ui-select-match><ui-select-choices repeat="type.value._id as (key, type) in machines | filter: $select.search"><span ng-bind-html=type.value.name></span></ui-select-choices></ui-select></div><div class="visible-xs clearfix"></div><br class=visible-xs></div><div class=row><table class="table hidden-xs no-left-right-padding" style="overflow: hidden;margin-top:0px;margin-bottom:0px;table-layout: inherit;"><thead class=row><th class=col-md-3><h5>Session</h5></th><th class=col-md-2><h5>Reading Type</h5></th><th class=col-md-3><h5>Comment</h5></th><th class="text-right col-md-4" style="padding-right: 50px;"><h5>Graphs</h5></th></thead></table><div class="table-responsive infinite-div session-scroll-container" style=margin-top:0px;><table class="table no-left-right-padding" style=width:100%;margin-bottom:0px;><tbody infinite-scroll=getSessions() infinite-scroll-distance=1 infinite-scroll-container=\'".session-scroll-container"\' infinite-scroll-disabled=busy><tr class=row ng-repeat="session in sessions" style="border: none; border-bottom: 1px solid rgba(2, 2, 2, 0.05);"><td class=col-md-3><div class="vertical-align-row elipsis"><div class="pull-left vertical-align-row" style="font-size: 30px; margin-right:5px"><i ng-style="{\'color\': session.color}" class={{session.icon}}></i></div><div class=pull-left style="margin-top:-2px;padding-left: 7px;"><span>{{session.name}}</span><br ng-if=session.sessionId><span ng-if=session.sessionId>{{session.sessionId}}</span><br ng-if="session.readingType.id === 1 && session.createdBy"><span ng-if="session.readingType.id === 1 && session.createdBy" style="color: rgb(107, 106, 106);"><b>By:&nbsp;</b>{{session.createdBy.firstName + \' \' + session.createdBy.lastName}}</span></div></div></td><td class=col-md-2 style="vertical-align: middle;"><span ng-bind=session.readingType.displayName></span> <span ng-if=session.typeText ng-bind="\'/ \' + session.typeText"></span></td><td class="col-md-3 hidden-xs elipsis" style="max-width:0; vertical-align: middle;"><span tooltip-placement=top-left uib-tooltip={{session.comment}} ng-if=session.comment ng-bind=session.comment></span></td><td class="text-right no-left-right-padding col-md-4" style=min-width:100px;><button ng-disabled="!session.hasProcessedData || isMonitoringMachine" tooltip-placement=top-left uib-tooltip={{webAppTexts.tooltips.downLoadRpb}} class="btn btn-primary btn-space" ng-click=exportRpb(session)><i class="fa fa-download"></i></button> <button ng-disabled=!session.hasProcessedData tooltip-placement=top-left uib-tooltip={{webAppTexts.tooltips.spectrum}} class="btn btn-primary btn-space" ng-click="openingChart(\'spectrum\', session.sessionId, session.name, session.readingType)"><i class=icon-spectrum></i></button> <button ng-disabled=!session.hasProcessedData tooltip-placement=top uib-tooltip={{webAppTexts.tooltips.wave}} class="btn btn-primary btn-space" ng-click="openingChart(\'wave\', session.sessionId, session.name,session.readingType)"><i class=icon-wave></i></button> <button tooltip-placement=top uib-tooltip={{webAppTexts.tooltips.raw}} class="btn btn-primary btn-space" ng-click="openingChart(\'rawData\', session.sessionId, session.name, session.readingType)"><i class=icon-raw-data></i></button> <button ng-disabled="!(session.hasReport && session.viewReport)" tooltip-placement=auto uib-tooltip={{webAppTexts.tooltips.viewReport}} class="btn btn-primary btn-space" ng-click="viewReportOfSession(session.sessionId, session.name)"><i class="fa fa-eye"></i></button> <button ng-disabled="!(session.hasReport && session.readingType.id === 2)" tooltip-placement=top-right uib-tooltip="Criteria Analysis" class="btn btn-primary btn-space" ng-click=viewCriteriaAnalysis(session)><i class=icon-review></i></button></td></tr><tr ng-show="busy && sessions && sessions.length > 0"><td colspan=2><div class=text-center><i class="fa fa-spinner fa-spin fa-1x"></i>&nbsp;Loading sessions...</div></td></tr><tr ng-if="!sessions || (sessions && sessions.length === 0)"><td colspan=2><div class=text-center><i ng-class="{\'fa fa-spinner fa-spin fa-1x\': busy}"></i>{{busy ? \'Loading sessions...\': \'No sessions found. . .!!!\'}}</div></td></tr></tbody></table></div></div></div></div>');
$templateCache.put('app/components/users/users.html','<div class="row vertical-align-row"><div class=col-xs-6><ul class="breadcrumb al-breadcrumb" style=margin:0;><li ng-repeat="itm in breadCrumbList"><a>{{itm}}</a></li></ul></div><div class="col-xs-6 align-right" style=padding-right:25px;><button angular-ripple tooltip-placement=top uib-tooltip={{webAppTexts.tooltips.addUser}} class="btn btn-primary" ng-click=addUser()><i class="fa fa-plus"></i></button></div></div><div class=clearfix></div><div class=panel style=margin-top:5px;><div class="container-limited container-fluid"><div class=row><div class=col-md-12><ul class="nav navbar-nav vc-navbar-nav"><li ng-class="{\'active\':filterValue.isFilterActive}" ng-repeat="filterValue in filterValues"><a ng-click=filterValue.onClickHandler(filterValue)>{{filterValue.displayName}} <span class=badge>{{filterValue.count()}}</span></a></li></ul></div><div class=clearfix></div><br><div class=col-md-12><div class="container-limited container-fluid"><div class="row user-search-bar no-left-right-padding"><div class="col-xs-12 col-lg-4 col-md-4 col-sm-4 no-left-right-padding"><form name=searchForm><div class=input-group ng-class="{\'has-error\': searchForm.searchText.$invalid}"><input type=text class="form-control with-primary-addon" placeholder={{webAppTexts.placeholder.enterFirstName}} id=searchText name=searchText spellcheck=false ng-pattern="/^[a-zA-Z]*$/" ng-model=searchText ng-model-options="{ debounce: 200 }" ng-change=searchUser(searchText)> <a ng-show=searchText class=search-clear style=margin-top:3px; ng-click="searchUser(\'\')"><span class="fa fa-times"></span></a> <input type=hidden name=filter id=filter> <span class=input-group-btn><button class="btn btn-primary" type=button ng-click=searchUser(searchText)><i class="fa fa-search"></i></button></span></div><span class="help-block text-red" ng-show=searchForm.searchText.$error.pattern style=margin-top:-10px;>Please enter valid name.</span></form></div><div class="col-sm-8 col-xs-12 no-left-right-padding"><div class="col-sm-3 col-xs-4 pull-right sort-list"><ui-select ng-model=orderBy.selected class="btn-group bootstrap-select form-control" on-select=setSorting(orderBy.selected)><ui-select-match placeholder={{webAppTexts.placeholder.selectOrder}}><span>{{$select.selected.displayName}}</span></ui-select-match><ui-select-choices repeat="itm in orderBy | filter: $select.search"><span ng-bind-html=itm.displayName></span></ui-select-choices></ui-select></div><div class="col-sm-3 col-xs-4 pull-right sort-list" style="padding-left: 2px;"><ui-select ng-model=sortBy.selected class="btn-group bootstrap-select form-control" on-select=setSorting(sortBy.selected)><ui-select-match placeholder={{webAppTexts.placeholder.selectSort}}><span>{{$select.selected.displayName}}</span></ui-select-match><ui-select-choices repeat="itm in sortBy | filter: $select.search"><span ng-bind-html=itm.displayName></span></ui-select-choices></ui-select></div></div></div></div><div class=clearfix></div><div class=row><div class=table-responsive style=margin-top:0px><table id=user-table class="table no-left-right-padding" style=margin-bottom:0px><thead><th><h5>{{webAppTexts.labels.name}}</h5></th><th><h5>{{webAppTexts.labels.email}}</h5></th><th><h5>{{webAppTexts.labels.phone}}</h5></th><th ng-class="{\'text-center\': allUsersOfCustomer && !allUsersOfCustomer.length}"><h5 ng-bind=webAppTexts.labels.role></h5></th><th class=align-right><h5 ng-style="{\'padding-right\': filterValues[1].isFilterActive?null:\'10px\'}"></h5></th></thead><tbody><tr ng-repeat="user in allUsersOfCustomer" class=table-border><td class="col-sm-3 col-md-3 text-truncate"><div class=pull-left style="font-size: 15px; margin-right:5px"><i ng-class="{\'fa fa-user\': user.status === \'active\',\'fa fa-user-times\' : user.status === \'inactive\'}"></i> <span style="margin-left: 22px;" class=detail-cursor-pointer ng-click=viewUserDetails(user)>{{user.firstName + \' \' + user.lastName}}</span></div></td><td class="col-sm-3 col-md-3 text-truncate"><div class=pull-left style="font-size: 15px; margin-right:5px"><p style=margin-top:-2px;><i class="fa fa-envelope-o"></i> {{user.email}}</p></div></td><td class="col-sm-2 col-md-2"><div class=pull-left style="font-size: 15px; margin-right:5px"><p style=margin-top:-2px; ng-if=user.phone>{{user.phone}}</p></div></td><td ng-if="!isDistributorSuperAdmin && !isSalesRep" class="col-sm-1 col-md-1"><div class=elipsis ng-if="user.roleInfo && user.roleInfo.length" ng-repeat="itm in user.roleInfo"><span ng-bind="(itm.role + \' (\')"></span> <span ng-if="itm.resource && itm.resource.ancestors && itm.resource.ancestors.length"><span style="color: rgb(107, 106, 106);" ng-repeat="level in itm.resource.ancestors" ng-bind="(level.name + \' / \')"></span> <span ng-if="itm.resourceType === \'machine\'" ng-bind="(itm.resource.parentId.name + \' / \')"></span></span> <span ng-bind="(itm.resource.name +\' )\')"></span><br ng-if=!$last></div></td><td ng-if=isDistributorSuperAdmin class="col-sm-1 col-md-1"><div class=elipsis ng-if="user.roleInfo && user.roleInfo.length" ng-repeat="itm in user.roleInfo"><span ng-bind="(itm.role + \' (\')"></span> <span ng-if="itm.resource && itm.resource.name && itm.resourceType"><span ng-if="itm.resourceType === \'company\'" ng-bind="itm.resource.name + \' )\'"></span></span></div></td><td class="col-sm-3 col-md-3 no-left-right-padding" style=margin-top:2px;><div class=pull-right><button ng-if="user.status === \'active\'" tooltip-placement=top uib-tooltip={{webAppTexts.tooltips.resetPassword}} class="btn btn-primary btn-space" ng-click=resetPassword(user)><i class="fa fa-unlock-alt"></i></button> <button ng-disabled=user.disable ng-if="user.status === \'active\'" tooltip-placement=top-right uib-tooltip={{webAppTexts.tooltips.deActivateUser}} class="btn btn-remove btn-space" ng-click=activateOrDeactivate(user)><i class="fa fa-user" aria-hidden=true></i></button> <button ng-disabled=user.disable ng-if="user.status === \'inactive\'" tooltip-placement=top-right uib-tooltip={{webAppTexts.tooltips.activateUser}} class="btn btn-primary btn-space" ng-click=activateOrDeactivate(user)><i class="fa fa-user" aria-hidden=true></i></button></div></td></tr><tr ng-if=busy><td colspan=4><div class=text-center><i class="btn-lg fa fa-spinner fa-spin"></i> &nbsp;{{webAppTexts.notes.loadingUsers}}</div></td></tr><tr ng-if="!busy && allUsersOfCustomer && allUsersOfCustomer.length === 0"><td colspan=4><div class=text-center>{{webAppTexts.notes.noUserFound}}</div></td></tr></tbody><tfoot ng-if="totalItems > limit"><tr style="border-bottom: none; text-align: center"><td colspan=4 class=gl-pagination><ul uib-pagination total-items=totalItems items-per-page=limit ng-model=uibPage.currentPage max-size=10 class=pagination-sm rotate=false ng-change=pageChanged(uibPage.currentPage) style="margin-bottom: 0px;"></ul></td></tr></tfoot></table></div></div></div></div></div></div>');
$templateCache.put('app/components/utils/regenerateReport.html','<div class="row vertical-align-row"><div class=col-xs-12><div ng-include="\'app/components/commonHTMLs/breadcrumb.html\'"></div><br></div></div><div class=clearfix></div><div class=panel style=margin-top:10px;><div class="container-limited container-fluid"><div class="row search-bar no-left-right-padding" style=padding-bottom:15px;><div class="col-md-3 col-sm-3 col-lg-3 col-xs-6 sort-list"><ui-select id=distributor ng-model=selected.distributorId class="btn-group bootstrap-select form-control" on-select="selectedProperty(\'distributor\')" ng-disabled="!(distributors && distributors.length)"><ui-select-match placeholder="Select Distributor"><span ng-bind=$select.selected.value.name></span></ui-select-match><ui-select-choices repeat="type.value._id as (key, type) in distributors | filter: $select.search"><span ng-bind-html=type.value.name></span></ui-select-choices></ui-select></div><div class="col-md-3 col-sm-3 col-lg-3 col-xs-6 sort-list"><ui-select id=customer ng-model=selected.customerId class="btn-group bootstrap-select form-control" on-select="selectedProperty(\'customer\')" ng-disabled="!(customers && customers.length)"><ui-select-match placeholder="Select Customer"><span ng-bind=$select.selected.value.name></span></ui-select-match><ui-select-choices repeat="type.value._id as (key, type) in customers | filter: $select.search"><span ng-bind-html=type.value.name></span></ui-select-choices></ui-select></div><div class="col-md-3 col-sm-3 col-lg-3 col-xs-6 sort-list"><ui-select id=fromMachines ng-model=selected.fromMachineId class="btn-group bootstrap-select form-control" on-select="selectedProperty(\'fromMachine\', type.value)" ng-disabled="!(fromMachines && fromMachines.length)"><ui-select-match placeholder="Select from machine"><span ng-bind=$select.selected.value.name></span></ui-select-match><ui-select-choices repeat="type.value._id as (key, type) in fromMachines | filter: $select.search"><i class={{type.value.icon}}></i> <span ng-bind-html=type.value.name></span></ui-select-choices></ui-select></div><div class="col-md-3 col-sm-3 col-lg-3 col-xs-6 sort-list"><ui-select id=toMachines ng-model=selected.toMachineId class="btn-group bootstrap-select form-control" on-select="selectedProperty(\'toMachine\', type.value)" ng-disabled="!(selected.fromMachineId && toMachines && toMachines.length)"><ui-select-match placeholder="Select to machine"><span ng-bind=$select.selected.value.name></span></ui-select-match><ui-select-choices repeat="type.value._id as (key, type) in toMachines | filter: $select.search"><span ng-bind-html=type.value.name></span></ui-select-choices></ui-select></div><div class="visible-xs clearfix"></div><br class=visible-xs></div><div class=row ng-if="selected.fromMachineId && selected.toMachineId && sessions && sessions.length"><div class="col-md-12 no-left-right-padding"><label>Select the session which you want to ignore</label></div><table class="table hidden-xs no-left-right-padding" style="overflow: hidden;margin-top:0px;margin-bottom:0px;table-layout: inherit;"><thead class=row><th class=col-md-1><h5>Select</h5></th><th class=col-md-3><h5>Session</h5></th><th class=col-md-2><h5>Reading Type</h5></th><th class=col-md-3><h5>Comment</h5></th><th class="text-right col-md-3" style="padding-right: 50px;"><h5>Graphs</h5></th></thead></table><div class="table-responsive infinite-div session-scroll-container" style=margin-top:0px;><table class="table no-left-right-padding" style=width:100%;margin-bottom:0px;><tbody infinite-scroll=getSessions() infinite-scroll-distance=1 infinite-scroll-container=\'".session-scroll-container"\' infinite-scroll-disabled=busy><tr class=row ng-repeat="session in sessions" style="border: none; border-bottom: 1px solid rgba(2, 2, 2, 0.05);"><td class="col-md-1 text-center vertical-align-row"><div class=checkbox><input id={{session.sessionId}} name={{session.sessionId}} type=checkbox checklist-model=selected.sessions checklist-value=session.sessionId> <label for={{session.sessionId}}></label></div></td><td class=col-md-3><div class="vertical-align-row elipsis"><div class="pull-left vertical-align-row" style="font-size: 30px; margin-right:5px"><i ng-style="{\'color\': session.color}" class={{session.icon}}></i></div><div class=pull-left style="margin-top:-2px;padding-left: 7px;"><span>{{session.name}}</span><br ng-if=session.sessionId><span ng-if=session.sessionId>{{session.sessionId}}</span><br ng-if="session.readingType.id === 1 && session.createdBy"><span ng-if="session.readingType.id === 1 && session.createdBy" style="color: rgb(107, 106, 106);"><b>By:&nbsp;</b>{{session.createdBy.firstName + \' \' + session.createdBy.lastName}}</span></div></div></td><td class=col-md-2 style="vertical-align: middle;"><span ng-bind=session.readingType.displayName></span> <span ng-if=session.typeText ng-bind="\'/ \' + session.typeText"></span></td><td class="col-md-3 hidden-xs elipsis" style="max-width:0; vertical-align: middle;"><span tooltip-placement=top-left uib-tooltip={{session.comment}} ng-if=session.comment ng-bind=session.comment></span></td><td class="text-right no-left-right-padding col-md-3" style=min-width:100px;><button ng-disabled=!session.hasProcessedData tooltip-placement=top-left uib-tooltip={{webAppTexts.tooltips.spectrum}} class="btn btn-primary btn-space" ng-click="openingChart(\'spectrum\', session.sessionId, session.name, session.readingType)"><i class=icon-spectrum></i></button> <button ng-disabled=!session.hasProcessedData tooltip-placement=top uib-tooltip={{webAppTexts.tooltips.wave}} class="btn btn-primary btn-space" ng-click="openingChart(\'wave\', session.sessionId, session.name,session.readingType)"><i class=icon-wave></i></button> <button tooltip-placement=top uib-tooltip={{webAppTexts.tooltips.raw}} class="btn btn-primary btn-space" ng-click="openingChart(\'rawData\', session.sessionId, session.name, session.readingType)"><i class=icon-raw-data></i></button> <button ng-disabled="!(session.hasReport && session.viewReport)" tooltip-placement=auto uib-tooltip={{webAppTexts.tooltips.viewReport}} class="btn btn-primary btn-space" ng-click="viewReportOfSession(session.sessionId, session.name)"><i class="fa fa-eye"></i></button> <button ng-disabled="!(session.hasReport && session.readingType.id === 2)" tooltip-placement=top-right uib-tooltip="Criteria Analysis" class="btn btn-primary btn-space" ng-click=viewCriteriaAnalysis(session)><i class=icon-review></i></button></td></tr><tr ng-show="busy && sessions && sessions.length > 0"><td colspan=2><div class=text-center><i class="fa fa-spinner fa-spin fa-1x"></i>&nbsp;Loading sessions...</div></td></tr><tr ng-if="!sessions || (sessions && sessions.length === 0)"><td colspan=2><div class=text-center><i ng-class="{\'fa fa-spinner fa-spin fa-1x\': busy}"></i>{{busy ? \'Loading sessions...\': \'No sessions found. . .!!!\'}}</div></td></tr></tbody></table></div></div><div ng-if=selected.toMachineId class=row><div class=col-md-12 style=padding:10px><button class="btn btn-primary pull-right" ng-click=regenerateReports()>Regenerate</button></div></div></div></div>');
$templateCache.put('app/components/Licenses/LicenseDetails/addLicense.html','<div class="row vertical-align-row"><div class=col-lg-6><ul class="breadcrumb al-breadcrumb"><li ng-repeat="itm in breadCrumbList"><a>{{itm}}</a></li></ul><br></div></div><div class=clearfix></div><div class=panel style=margin-top:10px;><div class="container-limited container-fluid panel"><div class="row top-margin"><form name=licenseForm novalidate><div class="col-md-9 col-sm-12"><label for=customer class="col-md-2 no-left-padding"><strong>{{webAppTexts.labels.customerName}}</strong></label> <label for=customer class="col-md-6 no-left-padding"><strong>{{customerData.name}}</strong></label></div><div class=clearfix></div><br><div ng-if=!isSalesRep class="col-sm-12 col-md-9"><label for=customer class="col-md-2 no-left-padding"><strong>{{webAppTexts.labels.salesRep}}</strong></label> <label for=customer class="col-md-6 no-left-padding"><strong ng-bind="(salesRep && salesRep.length ? salesRep[0].userId.firstName +\' \' + salesRep[0].userId.lastName : \'Not assigned\')"></strong></label></div><div class=clearfix></div><br ng-if=!isSalesRep><div class="col-sm-12 col-md-9"><div class="form-group has-feedback" ng-class="{\'has-error\':licenseForm.$submitted && !model.licenseType}"><label for=licenseType class="required col-md-2 no-left-padding vertical-align-label"><strong>{{webAppTexts.labels.licenseType}}</strong></label><div class="col-md-6 no-left-padding"><ui-select id=licenseType ng-model=model.licenseType class="btn-group bootstrap-select form-control" on-select=onSelectLicenseType($select.selected) required><ui-select-match placeholder={{webAppTexts.placeholder.licenseType}}><span>{{$select.selected.displayName}}</span></ui-select-match><ui-select-choices repeat="type in licenseTypes | filter: $select.search"><span ng-bind-html=type.displayName></span></ui-select-choices></ui-select><span class="help-block error-block basic-block">{{webAppTexts.errorMessages.licenseTypeRequired}}</span></div></div></div><div class=clearfix></div><br><div ng-if=!isDeviceType class="col-sm-12 col-md-9"><div class="form-group has-feedback" ng-class="{\'has-error\': licenseForm.$submitted && !model.license}"><label for=license class="required col-md-2 no-left-padding vertical-align-label"><strong>{{webAppTexts.labels.license}}</strong></label><div class="col-md-6 no-left-padding"><ui-select id=license ng-model=model.license class="btn-group bootstrap-select form-control" on-select=onSelectLicense($select.selected) ng-disabled=!model.licenseType required><ui-select-match placeholder={{webAppTexts.placeholder.selectLicense}}><span>{{$select.selected.name}}</span></ui-select-match><ui-select-choices repeat="license in allLicenses | filter: $select.search"><span ng-bind-html=license.name></span></ui-select-choices></ui-select><span class="help-block error-block basic-block">{{webAppTexts.errorMessages.licenseRequired}}</span></div></div><div class=clearfix></div><br></div><div class="col-sm-12 col-md-9"><div class="form-group has-feedback" ng-class="{\'has-error\': licenseForm.$submitted && !model.productCode}"><label for=productCode class="col-md-2 no-left-padding vertical-align-label"><strong>{{webAppTexts.labels.partNo}}</strong></label><div class="col-md-6 no-left-padding"><input type=text class=form-control id=productCode name=productCode ng-model=model.productCode placeholder={{webAppTexts.labels.partNo}} disabled> <span class="help-block error-block basic-block">{{webAppTexts.errorMessages.partNoRequired}}</span></div></div></div><div class=clearfix></div><br><div ng-if=!isDeviceType class="col-sm-12 col-md-9"><div class="form-group has-feedback" ng-class="{\'has-error\': licenseForm.$submitted && !model.quantity}"><label for=quantity class="required col-md-2 no-left-padding vertical-align-label"><strong>{{webAppTexts.labels.quantity}}</strong></label><div class="col-md-6 no-left-padding"><input type=number class=form-control id=quantity name=quantity ng-model=model.quantity placeholder={{webAppTexts.placeholder.enterQuantity}} required> <span class="help-block error-block basic-block">{{webAppTexts.errorMessages.quantityRequired}}</span><div class=text-red style=margin-top:5px;><span ng-if="model.quantity < 1">{{webAppTexts.errorMessages.minQuantity}}</span> <span ng-if="model.quantity > 999">{{webAppTexts.errorMessages.maxQuantity}}</span></div></div></div></div><div class=clearfix></div><br ng-if=!isDeviceType><div class="col-sm-12 col-md-9 form-group has-feedback" ng-class="{\'has-error\': licenseForm.$submitted && !model.startDate}" style=margin-bottom:0px><label for=startDate class="required col-md-2 no-left-padding vertical-align-label"><strong>{{webAppTexts.labels.activationDate}}</strong></label><div class="col-md-6 no-left-padding"><div class="input-group no-left-padding"><input type=text class=form-control uib-datepicker-popup={{format}} ng-model=model.startDate placeholder={{webAppTexts.placeholder.selectActivationDate}} is-open=isStartDateOpened ng-change=dateSelected() datepicker-options=startDateOptions close-text=Close ng-click=selectStartDate()> <span class="input-group-btn width-review-datepicker"><button type=button class="btn btn-primary" ng-click=selectStartDate()><i class="glyphicon glyphicon-calendar"></i></button></span></div><span class="help-block error-block basic-block">{{webAppTexts.errorMessages.activationDateRequired}}</span></div></div><div><div ng-if=isDeviceType class="col-sm-12 col-md-6"><label><strong>{{webAppTexts.labels.selectDevices}}</strong></label><table class="table table-bordered" style=margin-bottom:5px;><thead><tr><th class="col-md-21 text-center"><strong>{{webAppTexts.headings.select}}</strong></th><th class=col-md-5><strong>{{webAppTexts.headings.serialNo}}</strong></th><th class=col-md-5><strong>{{webAppTexts.headings.macId}}</strong></th></tr></thead><tbody><tr ng-repeat="device in devices"><td class="col-md-1 text-center"><div class=checkbox style=margin:0px><input id={{device.serialNumber}} name={{device.serialNumber}} type=checkbox ng-model=device.selected ng-change=getSelectedDevices(device)> <label for=checkbox1></label></div></td><td class=col-md-5><span>{{device.serialNumber}}</span></td><td class=col-md-5><span>{{device.deviceMacId}}</span></td></tr><tr ng-if=busy><td colspan=3><div class=text-center><i class="btn-lg fa fa-spinner fa-spin"></i> &nbsp;{{webAppTexts.notes.loadingDevices}}</div></td></tr><tr ng-if="!busy && devices && devices.length === 0"><td colspan=3><div class=text-center><i class="btn-lg fa fa-ban"></i> &nbsp;{{webAppTexts.notes.noDeviceFound}}</div></td></tr></tbody><tfoot ng-if="totalItems > limit"><tr style="border-bottom: none; text-align: center"><td colspan=3 class=gl-pagination><ul uib-pagination total-items=totalItems items-per-page=limit ng-model=uibPage.devicePage max-size=10 class=pagination-sm rotate=false ng-change=pageChanged(uibPage.devicePage) style="margin-bottom: 0px;"></ul></td></tr></tfoot></table><span class=text-red ng-if="licenseForm.$submitted && deviceRequired">{{webAppTexts.errorMessages.deviceRequired}}</span></div></div><div class=clearfix></div><div class="col-sm-12 col-md-6"><button type=submit class="btn btn-primary pull-right" ng-click="licenseForm.$valid && addLicense()">Add License</button></div></form><div class=clearfix></div><br><div ng-if="licenseInfo && licenseInfo.length" class="container-limited container-fluid no-top-margin"><div class="row left-right-margin"><div class=table-responsive><table id=roles-table class="center-align-table table no-left-right-padding" style=margin-bottom:0px><thead><th class=pull-left>{{webAppTexts.headings.licenseType}}</th><th>{{webAppTexts.headings.licenseName}}</th><th>{{webAppTexts.headings.partNo}}</th><th>{{webAppTexts.labels.quantity}}</th><th>{{webAppTexts.headings.activationDate}}</th><th class=pull-right></th></thead><tbody><tr ng-repeat="license in licenseInfo" class=table-border><td class=vertical-align-middle><span>{{license.licenseType.displayName}}</span></td><td class=vertical-align-middle><span>{{license.license.name}}</span></td><td class="vertical-align-middle text-center"><span>{{license.productCode}}</span></td><td class="vertical-align-middle text-center"><span>{{license.selectedDevices && license.selectedDevices.length ? license.selectedDevices.length : license.quantity}}</span></td><td class=vertical-align-middle><span>{{license.startDate | date: dateFormat}}</span></td><td class="pull-right no-left-right-padding"><button angular-ripple tooltip-placement=auto uib-tooltip={{webAppTexts.tooltips.removeLicense}} class="btn btn-remove btn-space" ng-click=removeLicense(license)><i class="fa fa-times"></i></button></td></tr></tbody></table></div></div></div><div class=col-sm-12><button type=button class="btn btn-cancel pull-left" ng-click=back()>{{webAppTexts.buttons.back}}</button> <button type=button ng-disabled="licenseInfo && !licenseInfo.length" class="btn btn-primary pull-right" style=margin-right:2px; ng-click=save()>{{webAppTexts.buttons.save}}</button></div><div class=clearfix></div><br></div></div></div>');
$templateCache.put('app/components/Licenses/renewLicense/renewLicense.html','<div class=modal-content><div class="modal-header bg-primary"><h4 class=modal-title><span>{{webAppTexts.headings.renewLicense}}</span><div class="btn-group pull-right"><a class=modal-close-button ng-click=close()><i class="fa fa-times"></i></a></div></h4></div><div class=modal-body><div class=container-fluid><div class=row><div class=col-md-12><form name=renewLicenseForm><fieldset><div class="form-group col-md-12 table-responsive" style="margin-bottom: 10px;"><label for=LicenseSummery><strong>{{webAppTexts.labels.LicenseSummery}}</strong></label><table id=licenses-table class="table table-bordered no-left-right-padding" style=margin-bottom:0px><thead><th ng-if="!forCustomer && (isDistributorSuperAdmin || isSalesRep)">Customer Name</th><th>Order ID</th><th>Name/Part No.</th><th>License Type</th><th>Quantity</th><th>Activation Date</th><th>Expiry Date</th></thead><tbody><tr class=table-border><td ng-if="!forCustomer && (isDistributorSuperAdmin || isSalesRep)" ng-bind=license.customerName></td><td ng-bind=license.orderId></td><td><span>{{license.name}}</span><br><span>{{license.productCode}}</span></td><td ng-bind=license.type></td><td ng-bind=license.quantity></td><td>{{ license.startDate | date: dateFormat }}</td><td>{{ license.expiryDate | date: dateFormat }}</td></tr></tbody><tfoot ng-if="totalMonitoringLicenses > limit"><tr style="border-bottom: none; text-align: center"><td colspan=8 class=gl-pagination><ul uib-pagination total-items=totalMonitoringLicenses items-per-page=limit ng-model=uibPage.subscriptionPage max-size=10 class=pagination-sm rotate=false ng-change="pageChanged(3, uibPage.subscriptionPage)" style="margin-bottom: 0px;"></ul></td></tr></tfoot></table></div><div class=col-sm-6><div class=form-group><label for=newActivationDate class="col-md-5 vertical-align-label no-left-padding"><strong>{{webAppTexts.labels.newActivationDate}}:</strong></label><div class=col-md-7><input type=text class=form-control id=newActivationDate name=newActivationDate ng-model=license.newActivationDate disabled></div></div></div><br class=visible-xs><div class=col-sm-6><div class=form-group><label for=newExpiryDate class="col-md-5 vertical-align-label no-left-padding"><strong>{{webAppTexts.labels.newExpiryDate}}:</strong></label><div class=col-md-7><input type=text class=form-control id=newExpiryDate name=newExpiryDate ng-model=license.newExpiryDate disabled></div></div></div><div class=col-md-12><div class=form-group ng-class="{\'has-error\': model.renewLicenseForm.comment.$invalid && (model.renewLicenseForm.comment.$dirty || model.renewLicenseForm.$submitted)}"><label class=required for=comment><strong>{{webAppTexts.labels.comment}}</strong></label> <textarea type=textArea placeholder={{webAppTexts.placeholder.comment}} class=form-control id=comment ng-model=renewLicense.comment style="min-height:60px !important; resize: none;" maxlength=512 required></textarea></div></div></fieldset></form></div></div></div></div><div class=modal-footer><button type=button class="btn btn-cancel pull-left" ng-click=close()>{{webAppTexts.buttons.cancel}}</button> <button type=button class="btn btn-primary pull-right" style=margin-right:2px; ng-disabled=renewLicenseForm.$invalid ng-click=confirm()>{{webAppTexts.buttons.ok}}</button></div></div>');
$templateCache.put('app/components/Notification/modals/notificationDialog.html','<div class=modal-content><div class=modal-header ng-class=modalHeaderClass><h4 class=modal-title><span ng-bind-html=title></span><div class="btn-group pull-right"><a class=modal-close-button ng-click=$event.stopPropagation();$dismiss()><i class="fa fa-times"></i></a></div></h4></div><div class=modal-body><div ng-if=!showClear><span class=pull-right>{{notification.createdOn | date:dateFormat}}</span><br><div class=row><div class=col-lg-12 style=display:flex;><i class={{notification.icon}} aria-hidden=true style="font-size: 30px;"></i><h4 ng-bind=notification.title style="padding:7px 10px;"></h4></div><div class=col-md-12><span ng-bind=notification.message></span></div></div></div><div ng-if=showClear><div class=row><div class=col-md-12><span>Are you sure, you want to clear all notification ?</span><br><div class="radio radio-remove"><input type=radio name=clearAll id=clearAllWithoutUnread value=0 ng-model=clearAll.value> <label for=clearAllWithoutUnread>Clear only read notification</label></div><div class="radio radio-remove"><input type=radio name=clearAll id=clearAllWithUnread value=1 ng-model=clearAll.value> <label for=clearAllWithUnread>Clear all with unread notification</label></div></div></div></div></div><div class=modal-footer><button ng-if=!showClear class="btn btn-info btn-space pull-right" ng-click=$event.stopPropagation();confirm()>Ok</button> <button ng-if=showClear class="btn btn-remove btn-space pull-right" ng-click=clear(clearAll)>Clear</button></div></div>');
$templateCache.put('app/components/customers/actions/addCustomerAdminForm.html','<div class=modal-content><div class=modal-header ng-class=modalHeaderClass><h4 class=modal-title><span>{{webAppTexts.headings.addAdmin}}</span><div class="btn-group pull-right"><a class=modal-close-button ng-click=close()><i class="fa fa-times"></i></a></div></h4></div><div class=modal-body><div class=container-fluid><div class=row><div class=col-md-12><form name=customer.userInfoForm><fieldset><div class=row><div class="col-sm-6 form-group has-feedback" ng-class="{\'has-error\': customer.userInfoForm.firstName.$invalid && (customer.userInfoForm.firstName.$dirty || customer.userInfoForm.$submitted)}"><label for=firstName class=required><strong>{{webAppTexts.labels.firstName}}</strong></label> <input type=text class=form-control id=firstName name=firstName ng-model=customer.admin.firstName placeholder={{webAppTexts.placeholder.enterFirstName}} ng-pattern="/^[a-zA-Z]*$/" required> <span class="help-block basic-block error-block" ng-show=customer.userInfoForm.firstName.$error.required>{{webAppTexts.errorMessages.firstNameRequired}}</span> <span class=help-block ng-show=customer.userInfoForm.firstName.$error.pattern>{{webAppTexts.errorMessages.specialCharactersNotAllowed}}</span></div><br class=visible-xs><div class="col-sm-6 form-group has-feedback" ng-class="{\'has-error\': customer.userInfoForm.lastName.$invalid && (customer.userInfoForm.lastName.$dirty || customer.userInfoForm.$submitted)}"><label for=lastName class=required><strong>{{webAppTexts.labels.lastName}}</strong></label> <input type=text class=form-control id=lastName name=lastName ng-model=customer.admin.lastName placeholder={{webAppTexts.placeholder.enterLastName}} ng-pattern="/^[a-zA-Z]*$/" required> <span class="help-block error-block basic-block" ng-show=customer.userInfoForm.lastName.$error.required>{{webAppTexts.errorMessages.lastNameRequired}}</span> <span class=help-block ng-show=customer.userInfoForm.lastName.$error.pattern>{{webAppTexts.errorMessages.specialCharactersNotAllowed}}</span></div><div class=clearfix></div><br><div class="col-sm-6 form-group has-feedback" ng-class="{\'has-error\': customer.userInfoForm.email.$invalid && (customer.userInfoForm.email.$dirty || customer.userInfoForm.$submitted)}"><label for=email class=required><strong>{{webAppTexts.labels.email}}</strong></label> <input type=email id=email name=email placeholder={{webAppTexts.placeholder.emailAddress}} class="form-control with-primary-addon" spellcheck=false ng-model=customer.admin.email ng-pattern="/^[A-Za-z0-9._%+-]+@(?:[A-Za-z0-9](?:[A-Za-z0-9-]*[A-Za-z0-9])?\\.)+[A-Za-z]{2,}$/" style=z-index:0 required> <span class="help-block error-block basic-block" ng-if=customer.userInfoForm.email.$error.pattern>{{webAppTexts.errorMessages.enterValidEmailAddress}}</span> <span class="help-block error-block basic-block" ng-if=customer.userInfoForm.email.$error.required>{{webAppTexts.errorMessages.emailIdRequired}}</span></div><div class="col-sm-6 form-group has-feedback" ng-class="{\'has-error\': customer.userInfoForm.phone.$invalid && (customer.userInfoForm.phone.$dirty || customer.userInfoForm.$submitted)}"><label for=phone class=required><strong>{{webAppTexts.labels.phoneNo}}</strong></label><div class="form-group has-feedback"><input type=text id=phone name=phone ng-pattern="/^\\s*(?:\\+?(\\d{1,3}))?[-. (]*(\\d{3})[-. )]*(\\d{3})[-. ]*(\\d{4})(?: *x(\\d+))?\\s*$/" placeholder={{webAppTexts.placeholder.phoneNo}} class="form-control with-primary-addon" spellcheck=false ng-model=customer.admin.phone style=z-index:0 required> <span class="help-block error-block basic-block" ng-show=customer.userInfoForm.phone.$error.required>{{webAppTexts.errorMessages.phoneNoRequired}}</span> <span class=help-block ng-show=customer.userInfoForm.phone.$error.pattern>{{webAppTexts.errorMessages.phoneNoInvalid}}</span></div></div></div></fieldset></form></div></div></div></div><div class=modal-footer><button type=button class="btn btn-cancel pull-left" ng-click=close()>{{webAppTexts.buttons.cancel}}</button> <button type=button class="btn btn-primary pull-right" style=margin-right:2px; ng-disabled=validateForm() ng-click=save()>{{webAppTexts.buttons.save}}</button></div></div>');
$templateCache.put('app/components/customers/actions/customerAdminDetails.html','<div class="row vertical-align-row"><div class=col-xs-6><ul class="breadcrumb al-breadcrumb" style=margin:0;><li ng-repeat="itm in breadCrumbList"><a>{{itm}}</a></li></ul></div></div><div class=clearfix></div><div class=panel style=margin-top:5px;><div class="container-limited container-fluid"><div class=row><table class="table no-left-right-padding"><tr style=border:none;><td class=col-sm-2><strong>First Name :</strong></td><td>{{userData.firstName}}</td></tr><tr style=border:none;><td class=col-sm-2><strong>Last Name :</strong></td><td>{{userData.lastName}}</td></tr><tr style=border:none;><td class=col-sm-2><strong>Email :</strong></td><td>{{userData.email}}</td></tr><tr style=border:none;><td class=col-sm-2><strong>Phone No :</strong></td><td>{{userData.phone}}</td></tr></table><button type=button class="btn btn-cancel" style=margin-left:10px;margin-bottom:20px; ng-click=goBack()>Back</button></div></div></div>');
$templateCache.put('app/components/customers/actions/customerAdminList.html','<div class="row vertical-align-row"><div class=col-xs-6><ul class="breadcrumb al-breadcrumb" style=margin:0;><li ng-repeat="itm in breadCrumbList"><a>{{itm}}</a></li></ul></div><div class="col-xs-6 align-right" style=padding-right:25px;><button angular-ripple tooltip-placement=auto uib-tooltip="Add admin" class="btn btn-primary" ng-click=addAdmin()><i class="fa fa-plus"></i></button></div></div><div class=clearfix></div><div class=panel style=margin-top:5px;><div class="container-limited container-fluid"><div class=row><br><div class=col-md-12><div class="container-limited container-fluid"><div class="row user-search-bar no-left-right-padding"><div class="col-xs-12 col-lg-4 col-md-4 col-sm-4 no-left-right-padding"><form name=searchForm><div class=input-group ng-class="{\'has-error\': searchForm.searchText.$invalid}"><input type=text class="form-control with-primary-addon" placeholder={{webAppTexts.placeholder.searchAdmin}} id=searchText name=searchText spellcheck=false ng-pattern="/^[a-zA-Z]*$/" ng-model=searchText ng-model-options="{ debounce: 200 }" ng-change=searchAdmin(searchText)> <a ng-show=searchText class=search-clear style=margin-top:3px; ng-click="searchAdmin(\'\')"><span class="fa fa-times"></span></a> <input type=hidden name=filter id=filter> <span class=input-group-btn><button class="btn btn-primary" type=button ng-click=searchAdmin(searchText)><i class="fa fa-search"></i></button></span></div><span class="help-block text-red" ng-show=searchForm.searchText.$error.pattern style=margin-top:-10px;>{{webAppTexts.errorMessages.invalidName}}</span></form></div><div class="col-sm-8 col-xs-12 no-left-right-padding"><div class="col-sm-3 col-xs-4 pull-right sort-list"><ui-select ng-model=orderBy.selected class="btn-group bootstrap-select form-control" on-select=setSorting(orderBy.selected)><ui-select-match placeholder="Select order"><span>{{$select.selected.displayName}}</span></ui-select-match><ui-select-choices repeat="itm in orderBy | filter: $select.search"><span ng-bind-html=itm.displayName></span></ui-select-choices></ui-select></div><div class="col-sm-3 col-xs-4 pull-right sort-list" style="padding-left: 2px;"><ui-select ng-model=sortBy.selected class="btn-group bootstrap-select form-control" on-select=setSorting(sortBy.selected)><ui-select-match placeholder="Select sort"><span>{{$select.selected.displayName}}</span></ui-select-match><ui-select-choices repeat="itm in sortBy | filter: $select.search"><span ng-bind-html=itm.displayName></span></ui-select-choices></ui-select></div></div></div></div><div class=clearfix></div><div class=row><div class=table-responsive style="margin-top:0px;margin-bottom: 8px;"><table class="table table-border no-left-right-padding" style=margin-bottom:0px><thead><th class=col-md-5><h5>{{webAppTexts.labels.name}}</h5></th><th class=col-md-4><h5>{{webAppTexts.labels.email}}</h5></th><th class="align-right col-md-3 no-left-right-padding"><h5>{{webAppTexts.labels.phone}}</h5></th></thead><tbody><tr ng-repeat="user in adminList"><td class=col-sm-5><div class=elipsis style=margin-bottom:-10px;><div class=pull-left><span>{{user.firstName}} {{user.lastName}}</span></div></div></td><td class=col-sm-4><div class=elipsis style=margin-bottom:-10px;><div class=pull-left><i class="fa fa-envelope-o" style="margin-right: 4px;"></i> <span>{{user.email}}</span></div></div></td><td class="align-right col-sm-43 no-left-right-padding" style=margin-top:2px;><span>{{user.phone}}</span></td></tr><tr ng-if=busy><td colspan=4><div class=text-center><i class="btn-lg fa fa-spinner fa-spin"></i> &nbsp;{{webAppTexts.notes.loadingUsers}}.</div></td></tr><tr ng-if="!busy && adminList && adminList.length === 0"><td colspan=4><div class=text-center><i class="btn-lg fa fa-ban"></i> &nbsp;{{webAppTexts.notes.noUserFound}}</div></td></tr></tbody><tfoot ng-if="totalItems > limit"><tr style="border-bottom: none; text-align: center"><td colspan=3 class=gl-pagination><ul uib-pagination total-items=totalItems items-per-page=limit ng-model=uibPage.currentPage max-size=10 class=pagination-sm rotate=false ng-change=pageChanged(uibPage.currentPage) style="margin-bottom: 0px;"></ul></td></tr></tfoot></table></div></div></div></div></div></div><div><button type=button class="btn btn-cancel" ng-click=goBack()>{{webAppTexts.buttons.back}}</button></div>');
$templateCache.put('app/components/customers/modals/addCustomer.html','<div class="row vertical-align-row"><div class=col-lg-6><ul class="breadcrumb al-breadcrumb"><li ng-repeat="itm in breadCrumbList"><a>{{itm}}</a></li></ul><br></div><div ng-if=viewDetails class="col-lg-6 align-right add-button"><button angular-ripple tooltip-placement=auto uib-tooltip="Edit Customer" class="btn btn-primary" ng-click=editCustomer()><i class="fa fa-edit"></i></button></div></div><div class="panel top-margin"><div class="container-limited container-fluid"><div class=widgets><div class=row><div class=col-md-12><ba-wizard ng-if=addForm><ba-wizard-step steptitle=Name cancel=goBack save=save validateform=validateBasicInfoForm form=customer.basicInfoForm><form name=customer.basicInfoForm><fieldset ng-disabled=viewDetails><div class=row><div class=col-md-6><div class="form-group has-feedback" ng-class="{\'has-error\': customer.basicInfoForm.name.$invalid && (customer.basicInfoForm.name.$dirty || customer.basicInfoForm.$submitted)}"><label for=name class=required><strong>Name</strong></label> <input type=text class=form-control name=name id=name ng-model=customer.name placeholder="Enter customer name" ng-pattern=\'/^(?!.*[*`\\\\;:"\\\\|,.<>\\/?])/\' maxlength=512 required> <span class="help-block error-block basic-block" ng-show=customer.basicInfoForm.name.$error.required>Name is required</span> <span class="help-block error-block basic-block" ng-show=customer.basicInfoForm.name.$error.pattern>Special characters like \\ / : * ? " <> | are not allowed.</span></div></div><div class=col-md-6><label for=description>Description</label> <textarea type=textArea placeholder="Enter customer description" class=form-control name=description id=description maxlength=512 ng-model=customer.description style="min-height:60px !important; resize: none;"></textarea></div><hr><br></div><div class=clearfix></div></fieldset></form></ba-wizard-step><ba-wizard-step steptitle=Address cancel=goBack save=save validateform=validateAddressForm form=customer.addressForm><form name=customer.addressForm><fieldset ng-disabled=viewDetails><div class=row><div ng-include="\'app/components/commonHTMLs/address.html\'"></div></div><br><br></fieldset></form></ba-wizard-step><ba-wizard-step steptitle=Admin cancel=goBack save=save validateform=validateUserInfoForm form=customer.userInfoForm><form name=customer.userInfoForm><fieldset ng-disabled=viewDetails><div class=row><h3 style=margin-left:15px>Customer Admin User</h3><hr><div class=col-sm-6><div class="form-group has-feedback" ng-class="{\'has-error\': customer.userInfoForm.firstName.$invalid && (customer.userInfoForm.firstName.$dirty || customer.userInfoForm.$submitted)}"><label for=firstName class=required><strong>First name</strong></label> <input type=text class=form-control id=firstName name=firstName ng-model=customer.admin.firstName placeholder="Enter first name" ng-pattern="/^[a-zA-Z]*$/" required> <span class="help-block basic-block error-block" ng-show=customer.userInfoForm.firstName.$error.required>First name is required</span> <span class=help-block ng-show=customer.userInfoForm.firstName.$error.pattern>Special characters like \\ / : * ? " <> | and spaces, numbers are not allowed.</span></div></div><br class=visible-xs><div class=col-sm-6><div class="form-group has-feedback" ng-class="{\'has-error\': customer.userInfoForm.lastName.$invalid && (customer.userInfoForm.lastName.$dirty || customer.userInfoForm.$submitted)}"><label for=lastName class=required><strong>Last name</strong></label> <input type=text class=form-control id=lastName name=lastName ng-model=customer.admin.lastName placeholder="Enter last name" ng-pattern="/^[a-zA-Z]*$/" required> <span class="help-block error-block basic-block" ng-show=customer.userInfoForm.lastName.$error.required>Last name is required</span> <span class=help-block ng-show=customer.userInfoForm.lastName.$error.pattern>Special characters like \\ / : * ? " <> | and spaces, numbers are not allowed.</span></div></div><div class=clearfix></div><br><div class=col-sm-6><label for=email class=required><strong>Email</strong></label><div ng-class="{\'has-error\': customer.userInfoForm.email.$invalid && (customer.userInfoForm.email.$dirty || customer.userInfoForm.$submitted)}"><input type=email id=email name=email placeholder="Enter email address" class="form-control with-primary-addon" spellcheck=false ng-model=customer.admin.email ng-pattern="/^[A-Za-z0-9._%+-]+@(?:[A-Za-z0-9](?:[A-Za-z0-9-]*[A-Za-z0-9])?\\.)+[A-Za-z]{2,}$/" style=z-index:0 required> <span class="help-block error-block basic-block" ng-if=customer.userInfoForm.email.$error.pattern>Please enter valid email address eg. john@due.com or john_123@due.co.uk</span> <span class="help-block error-block basic-block" ng-if=customer.userInfoForm.email.$error.required>Email ID is required</span></div></div><div class=col-md-6><div class="form-group has-feedback" ng-class="{\'has-error\': customer.userInfoForm.phone.$invalid && (customer.userInfoForm.phone.$dirty || customer.userInfoForm.$submitted)}"><label for=phone><strong ng-bind=webAppTexts.labels.phoneNo></strong></label> <input type=text id=phone name=phone ng-pattern="/^\\s*(?:\\+?(\\d{1,3}))?[-. (]*(\\d{3})[-. )]*(\\d{3})[-. ]*(\\d{4})(?: *x(\\d+))?\\s*$/" placeholder="Enter Phone Number" class="form-control with-primary-addon" spellcheck=false ng-model=customer.admin.phone style=z-index:0> <span class=help-block ng-show=customer.userInfoForm.phone.$error.pattern>Phone number is invalid.</span></div></div><div class=clearfix></div><br><div class=col-sm-6 style="margin-right: 50%"><label for=verifyEmail class=required><strong>Re-Enter email</strong></label><div ng-class="{\'has-error\': customer.userInfoForm.verifyEmail.$invalid && (customer.userInfoForm.verifyEmail.$dirty || customer.userInfoForm.$submitted)}"><input ng-disabled=!customer.admin.email ng-keyup=verifyEmailField() type=verifyEmail id=verifyEmail name=verifyEmail placeholder="Enter email address" class="form-control with-primary-addon" spellcheck=false ng-model=customer.admin.verifyEmail ng-pattern="/^[A-Za-z0-9._%+-]+@(?:[A-Za-z0-9](?:[A-Za-z0-9-]*[A-Za-z0-9])?\\.)+[A-Za-z]{2,}$/" style=z-index:0 required> <span class="help-block error-block basic-block" ng-if=customer.userInfoForm.verifyEmail.$error.pattern>Please enter valid email address eg. john@due.com or john_123@due.co.uk</span> <span class="help-block error-block basic-block" ng-if=customer.userInfoForm.verifyEmail.$error.required>Email ID is required</span> <span ng-if=verifyEmailAddress style=color:#a94442;>Email Id should be same as above.</span></div></div><div class=clearfix></div><hr><div class=col-sm-6 ng-if=showUsers><label>Sales Rep</label><ui-select id=user name=user ng-model=salesRep.id class="btn-group bootstrap-select form-control" required><ui-select-match placeholder="Select Sales Rep"><span>{{$select.selected.value.firstName}} {{$select.selected.value.lastName}} ({{$select.selected.value.email}})</span></ui-select-match><ui-select-choices repeat="user.value.id as (key, user) in users | filter: $select.search"><span ng-bind-html="user.value.firstName + \' \' + user.value.lastName + \' (\' + user.value.email + \')\'"></span></ui-select-choices></ui-select></div></div></fieldset></form></ba-wizard-step></ba-wizard><ba-wizard ng-if=!addForm><ba-wizard-step steptitle="Basic Information" cancel=goBack save=save validateform=validateBasicInfoForm form=customer.basicInfoForm><form name=customer.basicInfoForm><fieldset ng-disabled=viewDetails><div class=row><div class=col-md-6><div class="form-group has-feedback" ng-class="{\'has-error\': customer.basicInfoForm.name.$invalid && (customer.basicInfoForm.name.$dirty || customer.basicInfoForm.$submitted)}"><label for=name class=required><strong>Name</strong></label> <input type=text class=form-control name=name id=name ng-model=customer.name placeholder="Enter Name" ng-pattern=\'/^(?!.*[*`\\\\;:"\\\\|,.<>\\/?])/\' maxlength=512 required> <span class="help-block error-block basic-block" ng-show=customer.basicInfoForm.name.$error.required>Name is required</span> <span class="help-block error-block basic-block" ng-show=customer.basicInfoForm.name.$error.pattern>Special characters like \\ / : * ? " <> | are not allowed.</span></div></div><div class=col-md-6><label for=description>Description</label> <textarea type=textArea placeholder="Enter Description" class=form-control name=description id=description maxlength=512 ng-model=customer.description style="min-height:60px !important; resize: none;"></textarea></div><hr><br></div><div class=clearfix></div></fieldset></form></ba-wizard-step><ba-wizard-step steptitle="Address Details" cancel=goBack save=save validateform=validateAddressForm form=customer.addressForm><form name=customer.addressForm><fieldset ng-disabled=viewDetails><div class=row><div class=col-md-12><div class=col-md-6>Please enter customer\'s shipping address details where devices will be send.</div></div><div class=clearfix></div><div ng-include="\'app/components/commonHTMLs/address.html\'"></div></div><br><br></fieldset></form></ba-wizard-step></ba-wizard></div></div></div></div></div>');
$templateCache.put('app/components/devices/modals/deviceDetachDialog.html','<div class=modal-content><div class="modal-header bg-danger"><h4 class=modal-title><span ng-bind-html=dialogTitle></span><div class="btn-group pull-right"><a class=modal-close-button ng-click=closeModal()><i class="fa fa-times"></i></a></div></h4></div><div class=modal-body><div class=container-fluid><div class=row><div class=col-md-12><form role=form><span ng-bind-html=dialogMessage></span><div class="radio radio-remove"><input type=radio id=faulty value=faulty ng-model=reason.value> <label for=faulty>{{webAppTexts.labels.faultyDevice}}</label></div><div class="radio radio-remove"><input type=radio id=other value=other ng-model=reason.value> <label for=other>{{webAppTexts.labels.otherReason}}</label></div><div><label>{{webAppTexts.labels.comment}}:</label><br><textarea rows=3 cols=70 style="resize: none;" ng-model=commentText></textarea></div></form></div></div></div></div><div class=modal-footer><button class="btn pull-left btn-cancel" ng-click=closeModal()>{{webAppTexts.buttons.cancel}}</button> <button class="btn pull-right btn-remove" ng-disabled=!reason.value ng-click=confirm()>{{webAppTexts.buttons.confirm}}</button></div></div>');
$templateCache.put('app/components/devices/modals/manageDeviceDialog.html','<div class=modal-content><div class="modal-header bg-primary"><h4 class=modal-title><span ng-bind-html=dialogTitle></span><div class="btn-group pull-right"><a class=modal-close-button ng-click=close()><i class="fa fa-times"></i></a></div></h4></div><div class=modal-body><div class=container-fluid><div class=row><div class=col-md-12><form name=deviceInfoForm><fieldset><div class=row><div class="col-sm-12 form-group has-feedback" ng-class="{\'has-error\': deviceInfoForm.macId.$invalid && (deviceInfoForm.macId.$dirty || deviceInfoForm.$submitted)}"><label for=macId class=required><strong ng-bind=webAppTexts.labels.deviceMacId></strong></label> <input type=text class=form-control style=text-transform:uppercase; id=macId name=macId ng-model=device.deviceMacId placeholder={{webAppTexts.placeholder.enterMacId}} ng-pattern="/^([0-9A-Fa-f]{2}[:]){5}([0-9A-Fa-f]{2})$/" required> <span class="help-block basic-block error-block" ng-show=deviceInfoForm.macId.$error.required ng-bind=webAppTexts.errorMessages.macIdRequired></span> <span class="help-block basic-block error-block" ng-show=deviceInfoForm.macId.$error.pattern ng-bind=webAppTexts.errorMessages.macIdPattern></span></div><div class="col-sm-12 form-group has-feedback" ng-class="{\'has-error\': deviceInfoForm.serialNumber.$invalid && (deviceInfoForm.serialNumber.$dirty || deviceInfoForm.$submitted)}"><label for=serialNumber class=required><strong ng-bind=webAppTexts.labels.serialNumber></strong></label> <input type=text class=form-control id=serialNumber name=serialNumber ng-model=device.serialNumber placeholder={{webAppTexts.placeholder.enterSerialNumber}} ng-pattern="/^[a-zA-Z0-9]*$/" required> <span class="help-block error-block basic-block" ng-show=deviceInfoForm.serialNumber.$error.required ng-bind=webAppTexts.errorMessages.serialNumberRequired></span> <span class=help-block ng-show=deviceInfoForm.serialNumber.$error.pattern ng-bind=webAppTexts.errorMessages.serialNumberPattern></span></div><div class="col-sm-12 form-group has-feedback" ng-class="{\'has-error\': deviceInfoForm.type.$invalid && (deviceInfoForm.type.$dirty || deviceInfoForm.$submitted)}"><label for=type class=required><strong>{{webAppTexts.labels.deviceType}}</strong></label><ui-select id=type name=type ng-model=device.type class="btn-group bootstrap-select form-control" required><ui-select-match placeholder={{webAppTexts.placeholder.selectDeviceType}}><span>{{$select.selected.value.displayName}}</span></ui-select-match><ui-select-choices repeat="type.value.id as (key, type) in deviceTypes | filter: $select.search"><span ng-bind-html=type.value.displayName></span></ui-select-choices></ui-select></div><div class="col-sm-12 form-group has-feedback" ng-class="{\'has-error\': deviceInfoForm.distributor.$invalid && (deviceInfoForm.distributor.$dirty || deviceInfoForm.$submitted)}"><label for=distributor class=required><strong ng-bind=webAppTexts.labels.distributor></strong></label><ui-select id=distributor ng-model=device.distributorId class="btn-group bootstrap-select form-control" required><ui-select-match placeholder={{webAppTexts.placeholder.selectDistributor}}><span>{{$select.selected.value.name}}</span></ui-select-match><ui-select-choices repeat="type.value._id as (key, type) in distributors | filter: $select.search"><span ng-bind-html=type.value.name></span></ui-select-choices></ui-select></div><div class=col-sm-12><fieldset class=form-group style="border: 1px solid #ddd; padding: 15px; margin-top: 15px; border-radius: 4px;"><legend style="width: auto; padding: 0 10px; margin-bottom: 15px; font-size: 16px; border-bottom: none;"><strong ng-bind=webAppTexts.labels.calibrationConstants></strong></legend><div class=row style="margin-bottom: 8px; padding-bottom: 6px; border-bottom: 1px solid #ddd;"><div class="col-sm-2 col-md-2"></div><div class="col-sm-4 col-md-3"><label class="required small" style="margin-bottom: 0;"><strong ng-bind=webAppTexts.labels.physicalConversionConstant></strong></label></div><div class="col-sm-4 col-md-3"><label class="required small" style="margin-bottom: 0;"><strong ng-bind=webAppTexts.labels.ordinateToOrigin></strong></label></div><div class="col-sm-4 col-md-3"><label class="required small" style="margin-bottom: 0;"><strong ng-bind=webAppTexts.labels.rawToPhysicalDevidationFactor></strong></label></div></div><div ng-repeat="axis in calibrationAxes" class="row form-group" style="margin-bottom: 12px; padding-bottom: 12px; border-bottom: 1px solid #eee;"><div class="col-sm-2 col-md-2" style="padding-top: 8px; text-align: center;"><label class=small style="margin-bottom: 0;"><strong>{{axis.label}}</strong></label></div><div class="col-sm-4 col-md-3 form-group has-feedback" style="margin-bottom: 0;"><input type=number class=form-control name=pcc_{{axis.key}} ng-model=device.calibartionConstants[axis.key].physicalConversionConstant placeholder={{webAppTexts.placeholder.enterPhysicalConversionConstant}} step=any required style="padding-right: 8px;"></div><div class="col-sm-4 col-md-3 form-group has-feedback" style="margin-bottom: 0;"><input type=number class=form-control name=oto_{{axis.key}} ng-model=device.calibartionConstants[axis.key].ordinateToOrigin placeholder={{webAppTexts.placeholder.enterOrdinateToOrigin}} step=any required style="padding-right: 8px;"></div><div class="col-sm-4 col-md-3 form-group has-feedback" style="margin-bottom: 0;"><input type=number class=form-control name=rtpd_{{axis.key}} ng-model=device.calibartionConstants[axis.key].rawToPhysicalDevidationFactor placeholder={{webAppTexts.placeholder.enterRawToPhysicalDevidationFactor}} step=any required style="padding-right: 8px;"></div></div></fieldset></div></div></fieldset></form></div></div></div></div><div class=modal-footer><button type=button class="btn btn-cancel pull-left" ng-click=close()>{{webAppTexts.buttons.cancel}}</button> <button type=button class="btn btn-primary pull-right" style=margin-right:2px; ng-click=save()>{{webAppTexts.buttons.save}}</button></div></div>');
$templateCache.put('app/components/distributor/actions/addAdminForm.html','<div class=modal-content><div class=modal-header ng-class=modalHeaderClass><h4 class=modal-title><span>{{webAppTexts.headings.addAdmin}}</span><div class="btn-group pull-right"><a class=modal-close-button ng-click=close()><i class="fa fa-times"></i></a></div></h4></div><div class=modal-body><div class=container-fluid><div class=row><div class=col-md-12><form name=userInfoForm><fieldset><div class=row><div class="col-sm-6 form-group has-feedback" ng-class="{\'has-error\': userInfoForm.firstName.$invalid && (userInfoForm.firstName.$dirty || userInfoForm.$submitted)}"><label for=firstName class=required><strong>{{webAppTexts.labels.firstName}}</strong></label> <input type=text class=form-control id=firstName name=firstName ng-model=adminInfo.firstName placeholder={{webAppTexts.placeholder.enterFirstName}} ng-pattern="/^[a-zA-Z]*$/" required> <span class="help-block basic-block error-block" ng-show=userInfoForm.firstName.$error.required>{{webAppTexts.errorMessages.firstNameRequired}}</span> <span class=help-block ng-show=userInfoForm.firstName.$error.pattern>{{webAppTexts.errorMessages.specialCharactersNotAllowed}}</span></div><br class=visible-xs><div class="col-sm-6 form-group has-feedback" ng-class="{\'has-error\': userInfoForm.lastName.$invalid && (userInfoForm.lastName.$dirty || userInfoForm.$submitted)}"><label for=lastName class=required><strong>{{webAppTexts.labels.lastName}}</strong></label> <input type=text class=form-control id=lastName name=lastName ng-model=adminInfo.lastName placeholder={{webAppTexts.placeholder.enterLastName}} ng-pattern="/^[a-zA-Z]*$/" required> <span class="help-block error-block basic-block" ng-show=userInfoForm.lastName.$error.required>{{webAppTexts.errorMessages.lastNameRequired}}</span> <span class=help-block ng-show=userInfoForm.lastName.$error.pattern>{{webAppTexts.errorMessages.specialCharactersNotAllowed}}</span></div><div class=clearfix></div><br><div class="col-sm-6 form-group has-feedback" ng-class="{\'has-error\': userInfoForm.email.$invalid && (userInfoForm.email.$dirty || userInfoForm.$submitted)}"><label for=email class=required><strong>{{webAppTexts.labels.email}}</strong></label> <input type=email id=email name=email placeholder={{webAppTexts.placeholder.emailAddress}} class="form-control with-primary-addon" spellcheck=false ng-model=adminInfo.email ng-pattern="/^[A-Za-z0-9._%+-]+@(?:[A-Za-z0-9](?:[A-Za-z0-9-]*[A-Za-z0-9])?\\.)+[A-Za-z]{2,}$/" style=z-index:0 required> <span class="help-block error-block basic-block" ng-if=userInfoForm.email.$error.pattern>{{webAppTexts.errorMessages.enterValidEmailAddress}}</span> <span class="help-block error-block basic-block" ng-if=userInfoForm.email.$error.required>{{webAppTexts.errorMessages.emailIdRequired}}</span></div><div class="col-sm-6 form-group has-feedback" ng-class="{\'has-error\': userInfoForm.phone.$invalid && (userInfoForm.phone.$dirty || userInfoForm.$submitted)}"><label for=phone class=required><strong>{{webAppTexts.labels.phoneNo}}</strong></label><div class="form-group has-feedback"><input type=text id=phone name=phone ng-pattern="/^\\s*(?:\\+?(\\d{1,3}))?[-. (]*(\\d{3})[-. )]*(\\d{3})[-. ]*(\\d{4})(?: *x(\\d+))?\\s*$/" placeholder={{webAppTexts.placeholder.phoneNo}} class="form-control with-primary-addon" spellcheck=false ng-model=adminInfo.phone style=z-index:0 required> <span class="help-block error-block basic-block" ng-show=userInfoForm.phone.$error.required>{{webAppTexts.errorMessages.phoneNoRequired}}</span> <span class=help-block ng-show=userInfoForm.phone.$error.pattern>{{webAppTexts.errorMessages.phoneNoInvalid}}</span></div></div></div></fieldset></form></div></div></div></div><div class=modal-footer><button type=button class="btn btn-cancel pull-left" ng-click=close()>{{webAppTexts.buttons.cancel}}</button> <button type=button class="btn btn-primary pull-right" style=margin-right:2px; ng-disabled=validateForm() ng-click=save()>{{webAppTexts.buttons.save}}</button></div></div>');
$templateCache.put('app/components/distributor/modals/distributorDetail.html','<div class="row vertical-align-row"><div class=col-lg-6><ul class="breadcrumb al-breadcrumb"><li ng-repeat="itm in breadCrumbList"><a>{{itm}}</a></li></ul><br></div><div ng-if=viewDetails class="col-lg-6 align-right add-button"><button angular-ripple tooltip-placement=auto uib-tooltip="Edit Distributor" class="btn btn-primary" ng-click=editDistributor()><i class="fa fa-edit"></i></button></div></div><div class="panel top-margin"><div class="container-limited container-fluid"><div class=widgets><div class=row><div class=col-md-12><ba-wizard ng-if=addForm><ba-wizard-step steptitle=Name cancel=goBack save=save validateform=validateBasicInfoForm form=distributor.basicInfoForm><form name=distributor.basicInfoForm><fieldset ng-disabled=viewDetails><div class=row><div class=col-md-6><div class="form-group has-feedback" ng-class="{\'has-error\': distributor.basicInfoForm.name.$invalid && (distributor.basicInfoForm.name.$dirty || distributor.basicInfoForm.$submitted)}"><label for=name class=required><strong>Name</strong></label> <input type=text class=form-control name=name id=name ng-model=distributor.name placeholder="Enter distributor name" ng-pattern=\'/^(?!.*[*`\\\\;:"\\\\|,.<>\\/?])/\' maxlength=512 required> <span class="help-block error-block basic-block" ng-show=distributor.basicInfoForm.name.$error.required>Name is required</span> <span class="help-block error-block basic-block" ng-show=distributor.basicInfoForm.name.$error.pattern>Special characters like \\ / : * ? " <> | are not allowed.</span></div></div><div class=col-md-6><label for=description>Description</label> <textarea type=textArea placeholder="Enter distributor description" class=form-control name=description id=description maxlength=512 ng-model=distributor.description style="min-height:60px !important; resize: none;"></textarea></div><hr><br><div class=col-md-6><div class="form-group has-feedback" ng-class="{\'has-error\': distributor.basicInfoForm.$submitted && !distributor.timezone}"><label for=timezone class=required><strong>{{webAppTexts.labels.selectTimezone}}</strong></label><ui-select id=timezone ng-model=distributor.timezone class="btn-group bootstrap-select form-control" ng-disabled=viewForm><ui-select-match placeholder={{webAppTexts.labels.selectTimezone}}><span>{{$select.selected.text}}</span></ui-select-match><ui-select-choices repeat="zone in timezoneList | filter: $select.search"><span ng-bind-html=zone.text></span></ui-select-choices></ui-select><span class="help-block error-block basic-block">{{webAppTexts.errorMessages.timezoneRequired}}</span></div></div></div><div class=clearfix></div></fieldset></form></ba-wizard-step><ba-wizard-step steptitle=Address cancel=goBack save=save validateform=validateAddressForm form=distributor.addressForm><form name=distributor.addressForm><fieldset ng-disabled=viewDetails><div class=row><div ng-include="\'app/components/commonHTMLs/address.html\'"></div></div><br><br></fieldset></form></ba-wizard-step><ba-wizard-step steptitle=Admin cancel=goBack save=save validateform=validateUserInfoForm form=distributor.userInfoForm><form name=distributor.userInfoForm><fieldset ng-disabled=viewDetails><div class=row><h3 style=margin-left:15px>Distributor Admin User</h3><hr><div class=col-sm-6><div class="form-group has-feedback" ng-class="{\'has-error\': distributor.userInfoForm.firstName.$invalid && (distributor.userInfoForm.firstName.$dirty || distributor.userInfoForm.$submitted)}"><label for=firstName class=required><strong>First name</strong></label> <input type=text class=form-control id=firstName name=firstName ng-model=distributor.admin.firstName placeholder="Enter first name" ng-pattern="/^[a-zA-Z]*$/" required> <span class="help-block basic-block error-block" ng-show=distributor.userInfoForm.firstName.$error.required>First name is required</span> <span class=help-block ng-show=distributor.userInfoForm.firstName.$error.pattern>Special characters like \\ / : * ? " <> | and spaces, numbers are not allowed.</span></div></div><br class=visible-xs><div class=col-sm-6><div class="form-group has-feedback" ng-class="{\'has-error\': distributor.userInfoForm.lastName.$invalid && (distributor.userInfoForm.lastName.$dirty || distributor.userInfoForm.$submitted)}"><label for=lastName class=required><strong>Last name</strong></label> <input type=text class=form-control id=lastName name=lastName ng-model=distributor.admin.lastName placeholder="Enter last name" ng-pattern="/^[a-zA-Z]*$/" required> <span class="help-block error-block basic-block" ng-show=distributor.userInfoForm.lastName.$error.required>Last name is required</span> <span class=help-block ng-show=distributor.userInfoForm.lastName.$error.pattern>Special characters like \\ / : * ? " <> | and spaces, numbers are not allowed.</span></div></div><div class=clearfix></div><br><div class=col-sm-6><label for=email class=required><strong>Email</strong></label><div ng-class="{\'has-error\': distributor.userInfoForm.email.$invalid && (distributor.userInfoForm.email.$dirty || distributor.userInfoForm.$submitted)}"><input type=email id=email name=email placeholder="Enter email address" class="form-control with-primary-addon" spellcheck=false ng-model=distributor.admin.email ng-pattern="/^[A-Za-z0-9._%+-]+@(?:[A-Za-z0-9](?:[A-Za-z0-9-]*[A-Za-z0-9])?\\.)+[A-Za-z]{2,}$/" style=z-index:0 required> <span class="help-block error-block basic-block" ng-if=distributor.userInfoForm.email.$error.pattern>Please enter valid email address eg. john@due.com or john_123@due.co.uk</span> <span class="help-block error-block basic-block" ng-if=distributor.userInfoForm.email.$error.required>Email ID is required</span></div></div><div class=col-md-6><div class="form-group has-feedback" ng-class="{\'has-error\': distributor.userInfoForm.phone.$invalid && (distributor.userInfoForm.phone.$dirty || distributor.userInfoForm.$submitted)}"><label for=phone><strong ng-bind=webAppTexts.labels.phoneNo></strong></label> <input type=text id=phone name=phone ng-pattern="/^\\s*(?:\\+?(\\d{1,3}))?[-. (]*(\\d{3})[-. )]*(\\d{3})[-. ]*(\\d{4})(?: *x(\\d+))?\\s*$/" placeholder="Enter Phone Number" class="form-control with-primary-addon" spellcheck=false ng-model=distributor.admin.phone style=z-index:0> <span class=help-block ng-show=distributor.userInfoForm.phone.$error.pattern>Phone number is invalid.</span></div></div><div class=clearfix></div><br><div class=col-sm-6 style="margin-right: 50%"><label for=verifyEmail class=required><strong>Re-Enter email</strong></label><div ng-class="{\'has-error\': distributor.userInfoForm.verifyEmail.$invalid && (distributor.userInfoForm.verifyEmail.$dirty || distributor.userInfoForm.$submitted)}"><input ng-disabled=!distributor.admin.email ng-keyup=verifyEmailField() type=verifyEmail id=verifyEmail name=verifyEmail placeholder="Enter email address" class="form-control with-primary-addon" spellcheck=false ng-model=distributor.admin.verifyEmail ng-pattern="/^[A-Za-z0-9._%+-]+@(?:[A-Za-z0-9](?:[A-Za-z0-9-]*[A-Za-z0-9])?\\.)+[A-Za-z]{2,}$/" style=z-index:0 required> <span class="help-block error-block basic-block" ng-if=distributor.userInfoForm.verifyEmail.$error.pattern>Please enter valid email address eg. john@due.com or john_123@due.co.uk</span> <span class="help-block error-block basic-block" ng-if=distributor.userInfoForm.verifyEmail.$error.required>Email ID is required</span> <span ng-if=verifyEmailAddress style=color:#a94442;>Email Id should be same as above.</span></div></div><div class=clearfix></div><hr><div class=col-sm-6 ng-if=showUsers><label>Sales Rep</label><ui-select id=user name=user ng-model=salesRep.id class="btn-group bootstrap-select form-control" required><ui-select-match placeholder="Select Sales Rep"><span>{{$select.selected.value.firstName}} {{$select.selected.value.lastName}} ({{$select.selected.value.email}})</span></ui-select-match><ui-select-choices repeat="user.value.id as (key, user) in users | filter: $select.search"><span ng-bind-html="user.value.firstName + \' \' + user.value.lastName + \' (\' + user.value.email + \')\'"></span></ui-select-choices></ui-select></div></div></fieldset></form></ba-wizard-step></ba-wizard><ba-wizard ng-if=!addForm><ba-wizard-step steptitle="Basic Information" cancel=goBack save=save validateform=validateBasicInfoForm form=distributor.basicInfoForm><form name=distributor.basicInfoForm><fieldset ng-disabled=viewDetails><div class=row><div class=col-md-6><div class="form-group has-feedback" ng-class="{\'has-error\': distributor.basicInfoForm.name.$invalid && (distributor.basicInfoForm.name.$dirty || distributor.basicInfoForm.$submitted)}"><label for=name class=required><strong>Name</strong></label> <input type=text class=form-control name=name id=name ng-model=distributor.name placeholder="Enter Name" ng-pattern=\'/^(?!.*[*`\\\\;:"\\\\|,.<>\\/?])/\' maxlength=512 required> <span class="help-block error-block basic-block" ng-show=distributor.basicInfoForm.name.$error.required>Name is required</span> <span class="help-block error-block basic-block" ng-show=distributor.basicInfoForm.name.$error.pattern>Special characters like \\ / : * ? " <> | are not allowed.</span></div></div><div class=col-md-6><label for=description>Description</label> <textarea type=textArea placeholder="Enter Description" class=form-control name=description id=description maxlength=512 ng-model=distributor.description style="min-height:60px !important; resize: none;"></textarea></div><hr><br></div><div class=clearfix></div></fieldset></form></ba-wizard-step><ba-wizard-step steptitle="Address Details" cancel=goBack save=save validateform=validateAddressForm form=distributor.addressForm><form name=distributor.addressForm><fieldset ng-disabled=viewDetails><div class=row><div class=col-md-12><div class=col-md-6>Please enter distributor\'s shipping address details where devices will be send.</div></div><div class=clearfix></div><div ng-include="\'app/components/commonHTMLs/address.html\'"></div></div><br><br></fieldset></form></ba-wizard-step></ba-wizard></div></div></div></div></div>');
$templateCache.put('app/components/graphs/trendByCondition/trendByCondition.html','<div ng-if=!mobileView class="row vertical-align-row"><div class=col-lg-10><ul class="breadcrumb al-breadcrumb" style=margin-bottom:0;><li ng-repeat="itm in breadCrumbList"><a ng-if=!$last class=cursor-pointer ng-click=breadCrumbClickHandler(itm)>{{itm}}&nbsp;</a> <span ng-show=$last>{{itm}}</span></li></ul></div></div><br ng-if=!mobileView><div class=clearfix ng-if=!mobileView></div><div class="panel container-fluid container-limited"><div ng-if=!mobileView class=row><div class="col-xs-12 vertical-align-middle"><i class="{{icon}} vertical-align-middle" style="font-size: 30px;"></i> <span class=vertical-align-middle style="font-size: 24px;padding-left: 2px;">{{machineData.name}}</span><br><span ng-if="machineData.machineTypeId.name !== \'machine\'"><span><strong>RPM:</strong> {{machineData.meta.rpm}}</span>&nbsp;&nbsp;&nbsp; <span ng-if="machineData.meta.size && machineData.meta.size.value"><strong>Power:</strong> {{machineData.meta.size.value + machineData.meta.size.unit.toUpperCase()}}</span></span></div></div><hr ng-if=!mobileView class="container-limited report-hr-thick"><div class=container-fluid><div class=row><div class=col-md-12><div class=row><div ng-class="{\'transition-delay\': chart.allData}" class=col-xs-12><nvd3 options=trendChart.options data=trendChart.data api=trendChart.chart.api config=config events=events></nvd3></div></div></div></div></div><div ng-if=!trendChart.data class=container-fluid style=margin-top:20vh><div class=row><div class="col-md-12 text-center"><h1><i class="btn-lg fa fa-spinner fa-spin"></i> Loading ...</h1></div></div></div></div>');
$templateCache.put('app/components/graphs/trendsByfaults/trends.html','<ul class="breadcrumb al-breadcrumb"><li ng-repeat="itm in breadCrumbList"><a><a ng-if=!$last class=cursor-pointer ng-click=breadCrumbClickHandler(itm)>{{itm}}&nbsp;</a> <span ng-show=$last>{{itm}}</span></a></li></ul><div class=clearfix></div><div class=panel><div class="container-fluid container-limited" style=margin-top:10px;><div class=row><div class=clearfix></div><hr style="margin: 0; margin-bottom: 15px;"><div class="col-xs-12 vertical-align-row no-left-right-padding"><div class="pull-left heading-machine-icon"><i class={{icon}}></i></div><div class=pull-left><span style="font-size: 24px;">{{machineData.name}}</span><br ng-if=!isMonMachine><span ng-if=!isMonMachine><span><strong>RPM:</strong> {{machineData.meta.rpm}}</span>&nbsp;&nbsp;&nbsp; <span ng-if="machineData.meta.size && machineData.meta.size.value"><strong>Power:</strong> {{machineData.meta.size.value + machineData.meta.size.unit.toUpperCase()}}</span></span></div></div></div></div><div class="container-fluid container-limited"><div ng-if=!isMonMachine class=row><div class="col-sm-4 col-xs-12 col-lg-2" style="padding: 8px 13px;"><ui-select ng-change=getOrClearCustomSessions() id=point ng-model=selected.point class="btn-group bootstrap-select form-control"><ui-select-match placeholder="Select Point"><span>{{$select.selected.displayName}}</span></ui-select-match><ui-select-choices repeat="point in machineData.meta.points | filter: $select.search"><span ng-bind-html=point.displayName></span></ui-select-choices></ui-select></div></div><hr class="container-limited report-hr-thick"><div id=trendCharts class="container-fluid container-limited"><div ng-if=overallTrend.trendChart.data class=row><div class=col-md-12><div class=row><div class=col-xs-12 style=padding-left:0px;><div class="title pull-left h4 report-chart-title text-center" ng-bind="\'Overall vibration trend\'"></div></div><div class=col-xs-9><span ng-show="overallTrend.selectedSeverity || overallTrend.selectedSeverity === 0"><span><strong>Severity:</strong> {{overallTrend.selectedSeverity}} mm/s</span><br><span><strong>Session time:</strong> {{overallTrend.selectedDate | date:dateFormat}}</span></span></div><div class=col-xs-3><span><svg height=12 width=20><line x1=0 x2=16 y1=8 y2=8 stroke="rgb(204, 51, 0)" stroke-width=3></line></svg><strong>Critical level ({{overallTrend.trip}} mm/s)</strong></span><br><span><svg height=12 width=20><line x1=0 x2=16 y1=8 y2=8 stroke="rgb(255, 165, 0)" stroke-width=3></line></svg><strong>Warning level ({{overallTrend.warning}} mm/s)</strong></span><br><span><svg height=12 width=20><line x1=0 x2=16 y1=8 y2=8 stroke="rgb(66, 215, 244)" stroke-width=3></line></svg><strong>Trending line</strong></span></div><div ng-class="{\'transition-delay\': chart.allData}" class=col-xs-12><nvd3 options=overallTrend.trendChart.options on-ready=overallTrend.callback data=overallTrend.trendChart.data api=overallTrend.trendChart.chart.api config=config events=events></nvd3></div></div></div></div><div ng-if="busy && !overallTrend.trendChart.data" class=row><div class="col-md-12 text-center"><h1><i class="btn-lg fa fa-spinner fa-spin"></i> &nbsp;Loading ...</h1></div></div><div ng-if="!busy && !overallTrend.trendChart.data" class=row><div class="col-md-12 text-center"><h1><i class="btn-lg fa fa-ban"></i> &nbsp;Data not found!</h1></div></div></div></div></div>');
$templateCache.put('app/components/hierarchy/adminHierarchy/adminHierarchy.html','<div class="row vertical-align-row"><div class=col-xs-6><ul class="breadcrumb al-breadcrumb" style=margin:0;><li><a>Organization Structure Setup</a></li></ul></div></div><div class=clearfix></div><div class=panel style=margin-top:10px;><div class="container-limited container-fluid panel"><div class=row><form name=hierarchyLevelForm novalidate><fieldset ng-disabled=disabled><div class=col-sm-6 style="margin-right: 50%"><div class="form-group has-feedback"><br><div>Vibzer supports upto 3 levels of organization structure e.g. Plant --Area ----Section</div><br><div>You will be able to specify the display label for each level. All users are assigned to the elements of the organization structure. All machines are assigned to the lowest level of organization structure.</div><br><div>Note - The level of organization setup is one time activity and cannot be changed later.</div><br><ui-select style="display:inline-block; vertical-align:middle" id=type ng-model=levelInfo.level class="btn-group bootstrap-select form-control" ng-disabled=disabled ng-change=levelChanged() required><ui-select-match placeholder="Select number of levels for your organization structure"><span>{{$select.selected.value.name}}</span></ui-select-match><ui-select-choices repeat="levels.value.level as (key, levels) in hierarchyLevels | filter: $select.search"><span ng-bind-html=levels.value.name></span></ui-select-choices></ui-select></div></div><div class=col-sm-6 style="margin-right: 50%" ng-if="levelInfo.level > 0" ng-class="{\'has-error\': hierarchyLevelForm.levelFirst.$invalid && (hierarchyLevelForm.levelFirst.$dirty || hierarchyLevelForm.$submitted)}"><div class="form-group has-feedback"><label for=levelFirst class=required><strong ng-bind=webAppTexts.labels.level1></strong></label> <input type=text class=form-control id=levelFirst name=levelFirst placeholder={{webAppTexts.placeholder.level1}} ng-model=hierarchyData[0].name required> <span class="help-block basic-block error-block">Level-1 Name is required</span></div></div><div class=clearfix></div><div class=col-sm-6 style="margin-right: 50%" ng-if="levelInfo.level > 1" ng-class="{\'has-error\': hierarchyLevelForm.levelSecond.$invalid && (hierarchyLevelForm.levelSecond.$dirty || hierarchyLevelForm.$submitted)}"><div class="form-group has-feedback"><label for=levelSecond class=required><strong ng-bind=webAppTexts.labels.level2></strong></label> <input type=text class=form-control id=levelSecond name=levelSecond placeholder={{webAppTexts.placeholder.level2}} ng-model=hierarchyData[1].name required> <span class="help-block basic-block error-block">Level-2 Name is required</span></div></div><div class=clearfix></div><div class=col-sm-6 style="margin-right: 50%" ng-if="levelInfo.level > 2" ng-class="{\'has-error\': hierarchyLevelForm.levelThird.$invalid && (hierarchyLevelForm.levelThird.$dirty || hierarchyLevelForm.$submitted)}"><div class="form-group has-feedback"><label for=levelThird class=required><strong ng-bind=webAppTexts.labels.level3></strong></label> <input type=text class=form-control id=levelThird name=levelThird placeholder={{webAppTexts.placeholder.level3}} ng-model=hierarchyData[2].name required> <span class="help-block basic-block error-block">Level-3 Name is required</span></div></div></fieldset><div class=clearfix></div><div class=col-sm-12 ng-if=!disabled><button type=button class="btn btn-primary pull-right" style=margin-right:2px; ng-disabled=saveDisabled() ng-click=save()>Save</button></div></form><div class=clearfix></div><br></div></div></div>');
$templateCache.put('app/components/hierarchy/modals/addLowerLevelHierarchy.html','<div class=panel style=margin-top:10px;><div class="container-limited container-fluid panel"><div class=row><form name=hierarchy.basicInfoForm novalidate><h3 class=form-heading>{{webAppTexts.labels.details}}</h3><hr><fieldset ng-disabled=viewForm><div class=col-sm-6><div class="form-group has-feedback" ng-class="{\'has-error\': hierarchy.basicInfoForm.name.$invalid && (hierarchy.basicInfoForm.name.$dirty || hierarchy.basicInfoForm.$submitted)}"><label for=name class=required><strong>Name</strong></label> <input type=text class=form-control id=name name=name ng-model=hierarchy.name placeholder="Enter Name" ng-pattern=\'/^(?!.*[*`\\\\;:"\\\\|,.<>\\/?])/\' maxlength=512 required> <span class="help-block basic-block text-red" ng-show="!hierarchy.name && !hierarchy.basicInfoForm.name.$pristine && hierarchy.basicInfoForm.name.$error.required">Name is required</span> <span class=help-block ng-show=hierarchy.basicInfoForm.name.$error.pattern>Special characters like \\ / : * ? " <> | are not allowed.</span></div></div><br class=visible-xs><div class=col-sm-6><label for=description>Description</label> <textarea type=textArea placeholder="Enter Description" class=form-control name=description id=description ng-model=hierarchy.description maxlength=512 style="min-height:60px !important; resize: none;"></textarea></div></fieldset><br><div ng-if="!roleInfo.length && !viewForm || roleInfo.length"><div style="margin-bottom: -13px;" class="row vertical-align-row"><div class=col-lg-6><h3 class=form-heading>{{webAppTexts.labels.users}}</h3></div></div><hr class=roleList-divider></div><div class="container-limited container-fluid top-margin"><div class=clearfix></div><div class="row left-right-margin"><form name=hierarchy.userInfoForm><fieldset ng-disabled=viewDetails><div class=row ng-if=!viewDetails><div class=col-md-5><div class="form-group has-feedback"><ui-select id=role ng-model=hierarchy.role class="btn-group bootstrap-select form-control" ng-disabled=viewDetails required><ui-select-match placeholder="Select Role"><span>{{$select.selected.name}}</span></ui-select-match><ui-select-choices repeat="level in roles | filter: $select.search"><span ng-bind-html=level.name></span></ui-select-choices></ui-select></div></div><div class=col-md-5 ng-if=showUsers><ui-select id=user ng-model=hierarchy.user class="btn-group bootstrap-select form-control" ng-disabled=viewDetails required><ui-select-match placeholder="Select User"><span>{{$select.selected.value.firstName}} {{$select.selected.value.lastName}} ({{$select.selected.value.email}})</span></ui-select-match><ui-select-choices repeat="user.value.id as (key, user) in users | filter: $select.search"><span ng-bind-html="user.value.firstName + \' \' + user.value.lastName + \' (\' + user.value.email + \')\'"></span></ui-select-choices></ui-select></div><div class=col-md-2><button ng-disabled="!(hierarchy.user && hierarchy.role)" class="btn btn-primary pull-right" ng-click=addRole()>{{webAppTexts.buttons.addRole}}</button></div></div><div class="container-limited container-fluid top-margin"><div class=clearfix></div><div class=row><div class=table-responsive style="margin-left: 0; margin-right: 0"><table id=roles-table class=table style=margin-bottom:0px><thead><th><h5>User Name</h5></th><th ng-class="{\'text-align-center\':!viewForm,\'align-right\':viewForm}" ng-style="{\'padding-right\':viewForm?\'20px\':\'87px\'}"><h5>Role</h5></th><th ng-if=!viewForm class=align-right><h5></h5></th></thead><tbody><tr ng-repeat="itm in roleInfo track by $index" class=table-border><td class=vertical-align-middle><div><span>{{itm.userName}}</span></div><div><i class="fa fa-envelope-o" style="margin-right: 4px;"></i> <span>{{itm.email}}</span></div></td><td class=vertical-align-middle ng-class="{\'text-align-center\':!viewForm,\'align-right\':viewForm}" ng-style="{\'padding-right\':viewForm?\'20px\':\'87px\'}"><span>{{itm.role.name}}</span></td><td ng-if=!viewForm class="pull-right no-left-right-padding"><button angular-ripple tooltip-placement=auto uib-tooltip="Remove role" class="btn btn-remove btn-space" ng-click=removeRole($index)><i class="fa fa-times"></i></button></td></tr><tr ng-if=busy><td ng-attr-colspan="{{viewForm ? 2 : 3}}"><div class=text-center><i class="btn-lg fa fa-spinner fa-spin"></i> &nbsp;Loading user roles...</div></td></tr><tr ng-if="!busy && roleInfo && roleInfo.length === 0"><td ng-attr-colspan="{{viewForm ? 2 : 3}}"><div class=text-center>{{webAppTexts.notes.noRoleFound}}</div></td></tr></tbody><tfoot ng-if="totalItems > limit"><tr style="border-bottom: none; text-align: center"><td ng-attr-colspan="{{viewForm ? 2 : 3}}" class=gl-pagination><ul uib-pagination total-items=totalItems items-per-page=limit ng-model=uibPage.rolesPage max-size=10 class=pagination-sm boundary-links="totalItems/limit > limit" rotate=false ng-change=pageChanged(uibPage.rolesPage) style="margin-bottom: 0px;"></ul></td></tr></tfoot></table></div></div></div></fieldset></form></div><br><div class=col-sm-12 style="padding-bottom: 12px;"><button type=button class="btn btn-cancel pull-left" ng-click=goBack()>Back</button> <button type=button class="btn btn-primary pull-right" style=margin-right:2px; ng-if="!viewForm && addForm" ng-disabled=saveButtonVisibility() ng-click=save()>Save</button> <button type=button class="btn btn-primary pull-right" style=margin-right:2px; ng-if="!viewForm && editForm" ng-disabled=saveButtonVisibility() ng-click=save()>Update</button></div></div></form></div></div></div>');
$templateCache.put('app/components/hierarchy/modals/addTopLevelHierarchy.html','<div class="row vertical-align-row"><div class=col-lg-6><ul class="breadcrumb al-breadcrumb"><li ng-repeat="itm in breadCrumbList"><a>{{itm}}</a></li></ul><br></div><div ng-if="viewDetails && canEdit" class="col-lg-6 align-right add-button"><button angular-ripple tooltip-placement=auto uib-tooltip="Edit {{currentLevel.name}}" class="btn btn-primary" ng-click=editHierarchy()><i class="fa fa-edit"></i></button> <button angular-ripple tooltip-placement=auto uib-tooltip="Delete {{currentLevel.name}}" class="btn btn-remove" ng-click=deleteHierarchy()><i class="fa fa-trash"></i></button></div></div><div class="panel top-margin" ng-if=isFirstLevel><div class="container-limited container-fluid"><div class=widgets><div class=row><div class=col-md-12><ba-wizard><ba-wizard-step steptitle={{webAppTexts.labels.details}} cancel=goBack save=save validateform=validateBasicInfoForm form=hierarchy.basicInfoForm><form name=hierarchy.basicInfoForm><fieldset ng-disabled=viewDetails><div class=row><div class=col-md-6><div class="form-group has-feedback" ng-class="{\'has-error\': hierarchy.basicInfoForm.name.$invalid && (hierarchy.basicInfoForm.name.$dirty || hierarchy.basicInfoForm.$submitted)}"><label for=name class=required><strong>Name</strong></label> <input type=text class=form-control name=name id=name ng-model=hierarchy.name placeholder={{webAppTexts.placeholder.name}} ng-pattern=\'/^(?!.*[*`\\\\;:"\\\\|,.<>\\/?])/\' maxlength=512 required> <span class="help-block error-block basic-block" ng-show=hierarchy.basicInfoForm.name.$error.required>Name is required</span> <span class=help-block ng-show=hierarchy.basicInfoForm.name.$error.pattern>Special characters like \\ / : * ? " <> | are not allowed.</span></div></div><div class=col-md-6><label for=description>Description</label> <textarea type=textArea placeholder={{webAppTexts.placeholder.description}} class=form-control name=description id=description maxlength=512 ng-model=hierarchy.description style="min-height:60px !important; resize: none;"></textarea></div></div><div class=clearfix></div><br><div class=row><div class=col-md-6><div class="form-group has-feedback" ng-class="{\'has-error\':hierarchy.isLineFrequencyRequired}"><label for=freq class=required><strong>{{webAppTexts.labels.lineFrequency}}</strong></label><ui-select ng-model=hierarchy.meta.line_frequency name=freq theme=bootstrap ng-disabled=viewDetails><ui-select-match placeholder={{webAppTexts.placeholder.lineFrequency}}>{{$select.selected.value.label}}</ui-select-match><ui-select-choices repeat="freq.value.value as (key, freq) in lineFreq | filter: $select.search"><div ng-bind-html="freq.value.label | highlight: $select.search"></div></ui-select-choices></ui-select><span class="help-block error-block basic-block">Line frequency is required</span></div></div><div class=col-md-6><div class="form-group has-feedback" ng-class="{\'has-error\':hierarchy.isLanguageRequired}"><label for=language class=required><strong>{{webAppTexts.labels.analysisLanguage}}</strong></label><ui-select ng-model=hierarchy.meta.language name=language theme=bootstrap ng-disabled=viewDetails><ui-select-match placeholder="Select Language">{{$select.selected}}</ui-select-match><ui-select-choices repeat="language in languages | filter: $select.search"><div ng-bind-html="language | highlight: $select.search"></div></ui-select-choices></ui-select><span class="help-block error-block basic-block">Language is required</span></div></div></div><div class=row><div class=col-md-6 ng-if="hierarchy.meta.line_frequency === -1"><div class="form-group has-feedback" ng-class="{\'has-error\': hierarchy.basicInfoForm.customLineFrequency.$invalid && (hierarchy.basicInfoForm.customLineFrequency.$dirty || hierarchy.basicInfoForm.$submitted)}"><input type=text class=form-control name=customLineFrequency id=customLineFrequency ng-model=hierarchy.customLineFrequency ng-pattern="/^\\d+$/" placeholder={{webAppTexts.placeholder.otherFrequency}} required> <span class="help-block error-block basic-block" ng-show=hierarchy.basicInfoForm.customLineFrequency.$error.required>Line frequency is required</span> <span class="help-block error-block basic-block" ng-show=hierarchy.basicInfoForm.customLineFrequency.$error.pattern>Line frequency should be number greater than 0 and smaller than 200.</span> <span ng-if=customLineFrequencyRequired style=color:#a94442;>Line frequency should be greater than 0 and smaller than 200.</span></div></div></div><br></fieldset></form></ba-wizard-step><ba-wizard-step steptitle={{webAppTexts.labels.address}} cancel=goBack save=save validateform=validateAddressForm form=hierarchy.addressForm><form name=hierarchy.addressForm><fieldset ng-disabled=viewDetails><div class=row><div class=col-md-1><div class=text-center><input type=checkbox ng-model=hierarchy.meta.address.sameAsCompanyAddress ng-change=changingAddressType()> <label for=radio></label></div></div><div class=col-md-11><strong ng-if=!viewDetails ng-click=changingAddressType(true) style=cursor:pointer;>Same as company address</strong> <strong ng-if=viewDetails>Same as company address</strong></div><div class=clearfix></div><fieldset ng-disabled=viewDetails><div class=row><div class=clearfix></div><div><fieldset ng-disabled=hierarchy.meta.address.sameAsCompanyAddress><div class=col-md-12><div class=col-md-6><div class="form-group has-feedback" ng-class="{\'has-error\': hierarchy.addressForm.addressLine1.$invalid && (hierarchy.addressForm.addressLine1.$dirty || hierarchy.addressForm.$submitted)}"><label for=addressLine1 class=required><strong>Address line 1</strong></label> <textarea class=form-control type=textarea placeholder="Enter Address Line 1" name=addressLine1 id=addressLine1 ng-model=hierarchy.meta.address.addressLineOne style="min-height:60px !important; resize: none;" required></textarea> <span class="help-block error-block basic-block" ng-show=hierarchy.addressForm.addressLine1.$error.required>Address Line 1 is required</span></div></div><div class=col-md-6><div class="form-group has-feedback" ng-class="{\'has-error\': hierarchy.addressForm.addressLine2.$invalid && (hierarchy.addressForm.addressLine2.$dirty || hierarchy.addressForm.$submitted)}"><label for=addressLine2 class=required><strong>Address line 2</strong></label> <textarea class=form-control type=textArea placeholder="Enter Address Line 2" name=addressLine2 id=addressLine2 ng-model=hierarchy.meta.address.addressLineTwo style="min-height:60px !important; resize: none;" required></textarea> <span class="help-block error-block basic-block" ng-show=hierarchy.addressForm.addressLine2.$error.required>Address Line 2 is required</span></div></div></div><div class=col-md-12><div class=col-md-6><div class="form-group has-feedback"><label for=addressLine3><strong>Address line 3</strong></label> <textarea class=form-control type=textArea placeholder="Enter Address Line 3" name=addressLine3 id=addressLine3 ng-model=hierarchy.meta.address.addressLineThree style="min-height:60px !important; resize: none;"></textarea></div></div><div class=col-md-6><div class="form-group has-feedback" ng-class="{\'has-error\': hierarchy.addressForm.city.$invalid && (hierarchy.addressForm.city.$dirty || hierarchy.addressForm.$submitted)}"><label for=city class=required><strong>City</strong></label> <input type=text class=form-control id=city name=city ng-model=hierarchy.meta.address.city placeholder="Enter City" ng-pattern="/^[a-zA-Z]+$/" required> <span class="help-block error-block basic-block" ng-show=hierarchy.addressForm.city.$error.required>City is required</span> <span class="help-block error-block basic-block" ng-show=hierarchy.addressForm.city.$error.pattern>Not a valid city name. City name consist of alphabets only.</span></div></div></div><div class=col-md-12><div class=col-md-6><div class="form-group has-feedback" ng-class="{\'has-error\': hierarchy.addressForm.state.$invalid && (hierarchy.addressForm.state.$dirty || hierarchy.addressForm.$submitted)}"><label for=state class=required><strong>State</strong></label> <input type=text class=form-control id=state name=state ng-model=hierarchy.meta.address.state placeholder="Enter State" ng-pattern="/^[a-zA-Z]+$/" required> <span class="help-block error-block basic-block" ng-show=hierarchy.addressForm.state.$error.required>State is required</span> <span class="help-block error-block basic-block" ng-show=hierarchy.addressForm.state.$error.pattern>Not a valid state name. State name consist of alphabets only.</span></div></div><div class=col-md-6><div class="form-group has-feedback" ng-class="{\'has-error\': hierarchy.addressForm.pinCode.$invalid && (hierarchy.addressForm.pinCode.$dirty || hierarchy.addressForm.$submitted)}"><label for=pinCode class=required><strong>ZIP Code</strong></label> <input type=text class=form-control id=pinCode ng-pattern="/^[A-Za-z0-9]{3,10}$/" name=pinCode ng-model=hierarchy.meta.address.pinCode placeholder="Enter Pin Code" required> <span class="help-block error-block basic-block" ng-show=hierarchy.addressForm.pinCode.$error.required>ZIP Code is required</span> <span class="help-block error-block basic-block" ng-show=hierarchy.addressForm.pinCode.$error.pattern>ZIP Code should contain alphanumeric characters and length should be between 3 and 10.</span></div></div></div><div class=col-md-12><div class=col-md-6><div class="form-group has-feedback" ng-class="{\'has-error\': hierarchy.addressForm.country.$invalid && (hierarchy.addressForm.country.$dirty || hierarchy.addressForm.$submitted)}"><label for=country class=required><strong>Country</strong></label> <input type=text class=form-control id=country name=country ng-model=hierarchy.meta.address.country placeholder="Enter Country" ng-pattern="/^[a-zA-Z]+$/" required> <span class="help-block error-block basic-block" ng-show=hierarchy.addressForm.country.$error.required>Country is required</span> <span class="help-block error-block basic-block" ng-show=hierarchy.addressForm.country.$error.pattern>Not a valid country name. Country name consist of alphabets only.</span></div></div><div class=col-md-6><div class="form-group has-feedback" ng-class="{\'has-error\': hierarchy.addressForm.phone.$invalid && (hierarchy.addressForm.phone.$dirty || hierarchy.addressForm.$submitted)}"><label for=phone><strong ng-bind=webAppTexts.labels.phoneNo></strong></label> <input type=text id=phone name=phone ng-pattern="/^\\s*(?:\\+?(\\d{1,3}))?[-. (]*(\\d{3})[-. )]*(\\d{3})[-. ]*(\\d{4})(?: *x(\\d+))?\\s*$/" placeholder="Enter Phone Number" class="form-control with-primary-addon" spellcheck=false ng-model=hierarchy.meta.address.phone style=z-index:0> <span class=help-block ng-show=hierarchy.addressForm.phone.$error.pattern>Phone No is invalid.</span></div></div></div><div class=col-md-12><div class=col-md-6><div class="form-group has-feedback" ng-class="{\'has-error\': hierarchy.addressForm.emailId.$invalid && (hierarchy.addressForm.emailId.$dirty || hierarchy.addressForm.$submitted)}"><label for=emailId><label for=emailId class=required><strong>Email</strong></label></label> <input type=email id=emailId name=emailId placeholder="Enter Email" class="form-control with-primary-addon" spellcheck=false ng-model=hierarchy.meta.address.email ng-pattern="/^[A-Za-z0-9._%+-]+@(?:[A-Za-z0-9](?:[A-Za-z0-9-]*[A-Za-z0-9])?\\.)+[A-Za-z]{2,}$/" style=z-index:0 required> <span class="help-block error-block basic-block" ng-show=hierarchy.addressForm.emailId.$error.required>Email is required</span> <span class=help-block ng-show=hierarchy.addressForm.emailId.$error.pattern>Email is invalid.</span></div></div></div></fieldset></div></div></fieldset></div><br><br></fieldset></form></ba-wizard-step><ba-wizard-step steptitle={{webAppTexts.labels.users}} cancel=goBack save=save validateform=validateUserInfoForm form=hierarchy.userInfoForm><form name=hierarchy.userInfoForm><fieldset ng-disabled=viewDetails><div class=row><div class=col-md-5 ng-if=!viewForm><div class="form-group has-feedback"><ui-select id=role ng-model=hierarchy.role class="btn-group bootstrap-select form-control" ng-disabled=viewDetails required><ui-select-match placeholder="Select role"><span>{{$select.selected.name}}</span></ui-select-match><ui-select-choices repeat="level in roles | filter: $select.search"><span ng-bind-html=level.name></span></ui-select-choices></ui-select></div></div><div class=col-md-5 ng-if="!viewForm && showUsers"><ui-select id=user ng-model=hierarchy.user class="btn-group bootstrap-select form-control" ng-disabled=viewDetails required><ui-select-match placeholder="Select user"><span>{{$select.selected.value.firstName}} {{$select.selected.value.lastName}} ({{$select.selected.value.email}})</span></ui-select-match><ui-select-choices repeat="user.value.id as (key, user) in users | filter: $select.search"><span ng-bind-html="user.value.firstName + \' \' + user.value.lastName + \' (\' + user.value.email + \')\'"></span></ui-select-choices></ui-select></div><div class=col-md-2 ng-if=!viewForm><button ng-disabled="!(hierarchy.user && hierarchy.role)" style="margin-right: 5px;" class="btn btn-primary pull-right" ng-click=addRole()>{{webAppTexts.buttons.addRole}}</button></div><div class="container-limited container-fluid top-margin"><div class=clearfix></div><div class="row left-right-margin"><div class=table-responsive><table id=roles-table class="table no-left-right-padding" style=margin-bottom:0px><thead><th><h5>User Name</h5></th><th ng-class="{\'text-align-center\':!viewForm,\'align-right\':viewForm}" ng-style="{\'padding-right\':viewForm?\'20px\':\'87px\'}"><h5>Role</h5></th><th ng-if=!viewForm class=align-right><h5></h5></th></thead><tbody><tr ng-repeat="itm in roleInfo track by $index" class=table-border><td class=vertical-align-middle><div><span>{{itm.userName}}</span></div><div><i class="fa fa-envelope-o" style="margin-right: 4px;"></i> <span>{{itm.email}}</span></div></td><td class=vertical-align-middle ng-class="{\'text-align-center\':!viewForm,\'align-right\':viewForm}" ng-style="{\'padding-right\':viewForm?\'20px\':\'87px\'}"><span>{{itm.role.name}}</span></td><td ng-if=!viewForm class="pull-right no-left-right-padding"><button angular-ripple tooltip-placement=auto uib-tooltip="Remove role" class="btn btn-remove btn-space" ng-click=removeRole($index)><i class="fa fa-times"></i></button></td></tr><tr ng-if=busy><td ng-attr-colspan="{{viewForm ? 2 : 3}}"><div class=text-center><i class="btn-lg fa fa-spinner fa-spin"></i> &nbsp;Loading user roles...</div></td></tr><tr ng-if="!busy && roleInfo && roleInfo.length === 0"><td ng-attr-colspan="{{viewForm ? 2 : 3}}"><div class=text-center>{{webAppTexts.notes.noRoleFound}}</div></td></tr></tbody><tfoot ng-if="totalItems > limit"><tr style="border-bottom: none; text-align: center"><td ng-attr-colspan="{{viewForm ? 2 : 3}}" class=gl-pagination><ul uib-pagination total-items=totalItems items-per-page=limit ng-model=uibPage.rolesPage max-size=10 class=pagination-sm boundary-links="totalItems/limit > limit" rotate=false ng-change=pageChanged(uibPage.rolesPage) style="margin-bottom: 0px;"></ul></td></tr></tfoot></table></div></div></div></div></fieldset></form></ba-wizard-step></ba-wizard></div></div></div></div></div><div ng-if=!isFirstLevel ng-include="\'app/components/hierarchy/modals/addLowerLevelHierarchy.html\'"></div>');
$templateCache.put('app/components/machines/alerts/machineAlerts.html','<ul class="breadcrumb al-breadcrumb"><li ng-repeat="itm in breadCrumbList"><a ng-if=!$last class=cursor-pointer ng-click=breadCrumbClickHandler(itm)>{{itm}}&nbsp;</a> <span ng-show=$last>{{itm}}</span></li></ul><br><div class=clearfix></div><div class=panel style=margin-top:10px;><div class="container-fluid container-limited"><div class=row><div class=clearfix></div><br><div class="col-xs-12 vertical-align-row no-left-right-padding"><div class="pull-left heading-machine-icon"><i class={{icon}}></i></div><div class=pull-left><span style="font-size: 24px;">{{machineData.name}}</span><br ng-if=!isMonMachine><span ng-if=!isMonMachine><span><strong>RPM:</strong> {{machineData.meta.rpm}}</span>&nbsp;&nbsp;&nbsp; <span ng-if="machineData.meta.size && machineData.meta.size.value"><strong>Power:</strong> {{machineData.meta.size.value + machineData.meta.size.unit.toUpperCase()}}</span></span></div><div class="pull-right event-log-refresh"><button name=refreshAlerts angular-ripple tooltip-placement=top-right uib-tooltip=Refresh class="btn btn-primary" ng-click=getAllMachinesAlert(true)><i class="fa fa-refresh"></i></button></div></div></div></div><br><div class="container-limited container-fluid"><div class=row><div class="table-responsive infinite-div" style=margin-top:0px><table class="table no-left-right-padding" style="width:100%; margin-bottom:0px" infinite-scroll=getSessions() infinite-scroll-distance=0 infinite-scroll-disabled=busy infinite-scroll-listen-for-event=list:filtered infinite-scroll-parent=true><thead><th style=padding-left:10px;><h5>Message</h5></th><th class=text-center><h5>By</h5></th><th class=align-right style=padding-right:53px><h5>Time</h5></th></thead><tbody><tr ng-repeat="alert in alerts track by $index" style="border: none; border-bottom: 1px solid rgba(2, 2, 2, 0.05);"><td><div class="col-xs-12 no-left-right-padding"><span>{{alert.message}}</span></div></td><td><div ng-if=alert.userId class="col-xs-12 no-left-right-padding text-center"><span>{{alert.userId.firstName + \' \' + alert.userId.lastName}}</span></div></td><td class="pull-right no-left-right-padding"><span>{{alert.createdOn | date :dateFormat}}</span></td></tr><tr ng-if=busy><td colspan=3><div class=text-center><i class="btn-lg fa fa-spinner fa-spin"></i> &nbsp;Loading alerts...</div></td></tr><tr ng-if="!busy && alerts && alerts.length === 0"><td colspan=3><div class=text-center><i class="btn-lg fa fa-ban"></i> &nbsp;No alerts found . . .!!!</div></td></tr></tbody><tfoot ng-if="totalItems > limit"><tr style="border-bottom: none; text-align: center"><td colspan=3 class=gl-pagination><uib-pagination total-items=totalItems boundary-links=false max-size=10 rotate=true force-ellipses=true ng-model=uibPage.currentPage ng-change=pageChanged(uibPage.currentPage) style="margin-bottom: 0px;"></uib-pagination></td></tr></tfoot></table></div></div></div></div><div><button class="btn btn-cancel" ng-click=goBack()>Back</button></div>');
$templateCache.put('app/components/machines/machineDetails/machineDetails.html','<div class="row vertical-align-row"><div class=col-lg-10><ul class="breadcrumb al-breadcrumb text-truncate" style=margin-top:0px;><li ng-repeat="itm in breadCrumbList" ng-style="{\'margin-top\': addForm || editForm || (viewForm && !canEdit) ? \'10px\' : \'0px\'}"><a ng-if=!$last class=cursor-pointer ng-click=breadCrumbClickHandler(itm)>{{itm}}&nbsp;</a> <span ng-show=$last ng-style="{\'color\': !routeData ? \'#209E91\' : \'black\' }">{{itm}}</span></li></ul><br></div><div ng-if=viewForm class="col-lg-2 align-right add-button"><button ng-if=user.permission.addMachine angular-ripple tooltip-placement=auto uib-tooltip="Duplicate machine" class="btn btn-primary" ng-click=duplicateMachine()><i class="fa fa-clone"></i></button> <button ng-if=canEdit angular-ripple tooltip-placement=auto uib-tooltip="Edit machine" class="btn btn-primary" ng-click=editMachine()><i class="fa fa-edit"></i></button> <button ng-if=canDelete angular-ripple tooltip-placement=auto uib-tooltip="Delete machine" class="btn btn-remove" ng-click=deleteMachine()><i class="fa fa-trash"></i></button></div></div><div class=panel ng-style="{\'margin-top\': addForm || editForm || (viewForm && (!canEdit || !canDelete)) ? \'20px\' : \'5px\'}"><div class="container-limited container-fluid"><div class=widgets><div class=row><div class=col-md-12><ba-wizard><ba-wizard-step steptitle={{webAppTexts.headings.identification}} cancel=goBack save=save validateform=validateBasicInfoForm form=model.basicInfoForm><fieldset ng-disabled=viewForm><form name=model.basicInfoForm><div class=row><div class=col-md-6><div class="form-group has-feedback" ng-class="{\'has-error\': model.basicInfoForm.machineName.$invalid && (model.basicInfoForm.machineName.$dirty || model.basicInfoForm.$submitted)}"><label for=machineName class=required><strong>{{webAppTexts.labels.name}}</strong></label> <input type=text class=form-control id=machineName name=machineName placeholder={{webAppTexts.placeholder.machineName}} ng-model=model.name ng-pattern=\'/^(?!.*[*`\\\\;:"\\\\|,.<>\\/?])/\' required> <span class="help-block error-block basic-block" ng-show=model.basicInfoForm.machineName.$error.required>{{webAppTexts.errorMessages.machineNameRequired}}</span> <span class=help-block ng-show=model.basicInfoForm.machineName.$error.pattern>{{webAppTexts.errorMessages.invalidMachineName}}</span></div></div><div class=col-md-6><div class=form-group ng-class="{\'has-error\': model.basicInfoForm.description.$invalid && (model.basicInfoForm.description.$dirty || model.basicInfoForm.$submitted)}"><label for=description><strong>{{webAppTexts.labels.description}}</strong></label> <textarea type=textArea placeholder={{webAppTexts.placeholder.description}} class=form-control id=description ng-model=model.description style="min-height:60px !important; resize: none;" maxlength=512></textarea></div></div><div class=clearfix></div><div class=col-md-6><div class="form-group has-feedback" ng-class="{\'has-error\':isLevelRequired}"><label for=area class=required><strong ng-bind=levelName></strong></label><ui-select id=area ng-model=model.selectedLevel class="btn-group bootstrap-select form-control" ng-disabled=viewForm on-select=getSelectedLevel() required><ui-select-match placeholder={{levelPlaceholder}}><span>{{$select.selected.name}}</span></ui-select-match><ui-select-choices repeat="level in lowestLevelList | filter: $select.search"><span ng-bind-html=level.name></span></ui-select-choices></ui-select><span class="help-block error-block basic-block">{{levelRequiredMsg}}</span></div></div><div class=col-md-6><div class="form-group has-feedback" ng-class="{\'has-error\': model.basicInfoForm.$submitted && !model.timezone}"><label for=timezone class=required><strong>{{webAppTexts.labels.selectTimezone}}</strong></label><ui-select id=timezone ng-model=model.timezone class="btn-group bootstrap-select form-control" ng-disabled=viewForm><ui-select-match placeholder={{webAppTexts.labels.selectTimezone}}><span>{{$select.selected.text}}</span></ui-select-match><ui-select-choices repeat="zone in timezoneList | filter: $select.search"><span ng-bind-html=zone.text></span></ui-select-choices></ui-select><span class="help-block error-block basic-block">{{webAppTexts.errorMessages.timezoneRequired}}</span></div></div></div><br><br></form></fieldset></ba-wizard-step><ba-wizard-step steptitle={{webAppTexts.headings.technicalInfo}} cancel=goBack save=save validateform=validateMachineInfoForm form=model.machineInfoForm><fieldset ng-disabled=viewForm><form name=model.machineInfoForm><div class=row><div class=col-md-6><div class="form-group has-feedback" ng-class="{\'has-error\':isTypeRequired}"><label for=type class=required><strong>{{webAppTexts.labels.machineType}}</strong></label><ui-select id=type ng-model=model.machineType class="btn-group bootstrap-select form-control" ng-disabled="viewForm || editForm" required on-select=getMachineType($select.selected)><ui-select-match placeholder={{webAppTexts.placeholder.machineType}}><span>{{$select.selected.displayName}}</span></ui-select-match><ui-select-choices repeat="type in machineTypes | filter: $select.search"><span ng-bind-html=type.displayName></span></ui-select-choices></ui-select><span class="help-block error-block basic-block">{{webAppTexts.errorMessages.machineTypeRequired}}</span></div></div><div class=clearfix></div><br><div ng-if="model.machineType && !showMachineData"><div ng-if="isDeviceAttached && !editForm" class="col-md-6 pull-left"><table class="table table-bordered" style=margin-bottom:5px;><thead><tr><th><strong>{{webAppTexts.headings.attachedDevice}}</strong></th><th ng-if="isDeviceAttached && deviceState"><strong>{{webAppTexts.headings.state}}</strong></th></tr></thead><tbody><tr><td><span>{{machineData.meta.pointInfo.deviceMacId}}</span></td><td ng-if="isDeviceAttached && deviceState"><span>{{deviceState}}</span></td></tr></tbody></table></div></div><fieldset ng-disabled=isAnalyzedMachine><div ng-if=showMachineData><div class=col-md-12 style=margin-top:-10px;><h5 class=readonly ng-if=isCompressor><strong>{{webAppTexts.notes.supportingCompressorTypes}}</strong></h5><h5 ng-if="!isAnalyzedMachine && !viewForm && showMachineData">{{webAppTexts.notes.notAbleToChangeMachineInfoLater}}</h5><h5 ng-if="isAnalyzedMachine && editForm">{{webAppTexts.notes.notAbleToChangeMachineInfo}}</h5></div><formly-form model=machineMetaData fields=machineMetaDataFields form=model.machineInfoForm></formly-form></div></fieldset><div ng-if=showMachineData class=col-lg-6 style=margin-top:-15px;><fieldset ng-disabled="viewForm || (editForm && machineData.portable.condition)"><label><strong>{{webAppTexts.labels.conditionAssessmentPoints}}</strong></label><div class=col-lg-12><label class=required><strong>{{webAppTexts.labels.selectReadingPoint}}</strong></label><div class=col-lg-12 style=margin-top:0px;><div class=checkbox ng-repeat="point in assessmentPoints"><input id={{point.name}} class=styled type=checkbox ng-model=point.selected ng-change=getAssessmentPoints(point) ng-disabled="viewForm || (editForm && machineData.portable.condition)"> <label for={{point.name}}>{{point.displayName}}</label></div><span class=text-red ng-if=isAssessmentPointRequired>{{webAppTexts.errorMessages.assessmentPointRequired}}</span></div></div></fieldset></div><div class=clearfix></div><div class="col-md-6 no-right-padding"><fieldset ng-disabled="viewForm || (editForm && machineData.permanent.condition)"><div ng-if=model.machineType class=checkbox ng-class="{\'no-top-margin\' : !showMachineData && !isDeviceAttached}"><input id=permanentMonitoring type=checkbox ng-model=model.monitoredOnline ng-change=onChangeMonitoringType(model.monitoredOnline) ng-disabled="viewForm || isDeviceAttached || (editForm && machineData.permanent.condition)"> <label for=permanentMonitoring><strong>{{webAppTexts.labels.enableConditionMonitoring}}</strong></label></div><div ng-if="showMachineData && model.monitoredOnline" class="col-lg-12 points-container"><label class=required><strong>{{webAppTexts.labels.selectReadingPoint}}</strong></label><div class=col-lg-12 style=margin-top:5px;><table class="table table-bordered"><thead><tr><th class=col-lg-4><strong>{{webAppTexts.headings.point}}</strong></th><th class=col-lg-5><strong>{{webAppTexts.headings.attachedDevice}}</strong></th><th class=col-lg-3><strong>{{webAppTexts.headings.state}}</strong></th></tr></thead><tbody><tr ng-repeat="point in monitoringPoints"><td class=col-lg-4><div class=radio style="margin:0px !important"><input type=radio name=monitoringPoint id={{point.internalName}} ng-model=model.selectedMonitoringPoint ng-value={{point.internalName}} ng-disabled="viewForm || (editForm && isDeviceAttached)"> <label for={{point.internalName}}>{{point.displayName}}</label></div></td><td class=col-lg-5><span ng-if=point.deviceMacId>{{point.deviceMacId}}</span> <span ng-if=!point.deviceMacId>{{webAppTexts.placeholder.NA}}</span></td><td class=col-lg-3><span ng-if=point.deviceState>{{point.deviceState}}</span> <span ng-if=!point.deviceState>{{webAppTexts.placeholder.NA}}</span></td></tr></tbody></table></div></div><div ng-if=model.monitoredOnline class=col-lg-12 style=margin-left:10px><fieldset ng-disabled="viewForm || (editForm && machineData.permanent.condition)"><label class=required><strong>{{webAppTexts.labels.generateWarningAndAlerts}}</strong></label><div class="form-group col-lg-12 no-right-padding" style=margin-top:5px; ng-class="{\'has-error\':isLimitTypeRequired}"><div class="radio radio-inline"><input type=radio class=form-control name=statistical id=statistical value=2 ng-model=analysisConfiguration.permanent.type ng-change=getLimitType(2)> <label for=every><span style=font-size:14px;>{{webAppTexts.headings.autoDerivedLimits}}</span></label></div><div class="radio radio-inline"><input type=radio class=form-control name=userDefined id=userDefined value=1 ng-model=analysisConfiguration.permanent.type ng-change=getLimitType(1)> <label for=specific><span class="text-margin no-left-margin" style=font-size:14px;>{{webAppTexts.headings.userDefinedLimits}}</span></label></div><span class="help-block error-block basic-block">{{webAppTexts.errorMessages.limitRequired}}</span><div class="col-lg-12 no-left-right-padding" ng-if="model.monitoredOnline && isUserDefinedLimit"><label class=required><strong>{{webAppTexts.headings.permissibleLimits}}</strong></label><div class="form-group has-feedback no-right-padding" ng-class="{\'has-error\':isLimitRequired || isAlertRequired}" style=margin-top:5px;><table class="table table-bordered"><thead><tr><td class=col-md-6><strong>{{webAppTexts.headings.parameter}}</strong></td><td class=col-md-3><strong>{{webAppTexts.headings.warning}}</strong></td><td class=col-md-3><strong>{{webAppTexts.headings.alert}}</strong></td></tr></thead><tbody><tr><td class=col-md-6>{{webAppTexts.headings.overallVibration}}<sup>2</sup>)</td><td class=col-md-3 style=padding:0;><input type=number min=0.001 max=999 class=form-control id=overallVibrationWarning name=overallVibrationWarning ng-model=analysisConfiguration.permanent.limits.overallVibration.warning style=border:none;></td><td class=col-md-3 style=padding:0;><input type=number min=0.001 max=999 class=form-control id=overallVibrationAlert name=overallVibrationAlert ng-model=analysisConfiguration.permanent.limits.overallVibration.alert style=border:none;></td></tr><tr><td class=col-md-6>{{webAppTexts.headings.crestFactor}}</td><td class=col-md-3 style=padding:0;><input type=number min=0.001 max=999 class=form-control id=crestFactorWarning name=crestFactorWarning ng-model=analysisConfiguration.permanent.limits.crestFactor.warning style=border:none;></td><td lass=col-md-3 style=padding:0;><input type=number min=0.001 max=999 class=form-control id=crestFactorAlert name=crestFactorAlert ng-model=analysisConfiguration.permanent.limits.crestFactor.alert style=border:none;></td></tr></tbody></table><span ng-if="isLimitRequired && !isAlertRequired" class="help-block error-block basic-block" style=margin-top:-10px>{{webAppTexts.errorMessages.limitValueRequired}}</span> <span ng-if="isAlertRequired && !isLimitRequired" class="help-block error-block basic-block" style=margin-top:-10px>{{webAppTexts.errorMessages.alertLimitRequired}}</span></div></div></div></fieldset></div></fieldset></div></div><br></form></fieldset></ba-wizard-step><ba-wizard-step steptitle={{webAppTexts.headings.monitoringSchedule}} cancel=goBack save=save validateform=validateScheduleForm form=model.scheduleForm><div ng-if=!model.monitoredOnline class="col-lg-12 text-center"><h3>{{webAppTexts.notes.scheduleNotApplicable}}</h3></div><fieldset ng-disabled=viewForm ng-hide=!model.monitoredOnline><form name=model.scheduleForm><div class=clearfix></div><div ng-if=model.monitoredOnline class=row ng-disabled=viewForm><div class=col-md-12><label for=operating class=required><strong>{{webAppTexts.labels.machineOperationSchedule}}</strong></label></div><div class="col-md-12 schedule-box"><div class="row schedule-type-box form-group"><div class="col-md-12 no-left-padding"><label><strong>{{webAppTexts.labels.operatingDays}}</strong></label></div><div class=col-md-12><div class="col-md-3 col-lg-3 col-sm-3"><div class="form-group form-inline" style=margin-bottom:5px;><ui-select ng-model=schedule.operating.daysType class="btn-group bootstrap-select form-control" on-select="changingDaysType(\'operating\', schedule.operating.daysType)" ng-disabled=viewForm><ui-select-match placeholder={{webAppTexts.placeholder.selectOperatingDays}}><span>{{$select.selected.value.name}}</span></ui-select-match><ui-select-choices repeat="type.value.id as (key, type) in operatingDaysTypes | filter: $select.search"><span ng-bind-html=type.value.name></span></ui-select-choices></ui-select></div></div><div class="col-md-9 schedule-value-box"><div ng-if="schedule.operating.daysType === 2" class="form-group form-inline specific-schedule"><div class="checkbox checkbox-inline" ng-repeat="day in days" ng-style="{\'padding-left\': ($index === 0 ? \'20px\' : \'5px\')}"><input type=checkbox id="{{\'schedule.operating-\' + day}}" checklist-model=schedule.operating.days.specificDaysInWeek ng-change="selectedDayChange(\'operating\',day)" checklist-value=day> <label for="{{\'schedule.operating-\' + day}}">{{day}}</label></div><br><span class=text-red ng-if=isOperatingDaysRequired>{{webAppTexts.errorMessages.dayRequired}}</span></div></div></div><div class=clearfix></div><hr class=schedule-divider><div class="col-md-12 no-left-padding"><label><strong>{{webAppTexts.labels.operatingHours}}</strong></label></div><div class=col-md-12><div class=col-md-3><div class="form-group form-inline"><ui-select ng-model=schedule.operating.scheduleTime class="btn-group bootstrap-select form-control" on-select="changingHoursType(\'operating\',schedule.operating.scheduleTime)" ng-disabled=viewForm><ui-select-match placeholder={{webAppTexts.placeholder.selectOperatingHours}}><span>{{$select.selected.value.name}}</span></ui-select-match><ui-select-choices repeat="type.value.id as (key, type) in operatingHoursTypes | filter: $select.search"><span ng-bind-html=type.value.name></span></ui-select-choices></ui-select></div></div><div class="col-md-9 schedule-value-box"><div ng-if="schedule.operating.scheduleTime === 2" class="form-group form-inline specific-schedule" style="padding-top:0px !important;"><div class="checkbox checkbox-inline" ng-style="{\'padding-left\': ($index === 0 ? \'20px\' : \'10px\')}" ng-repeat="hour in hours"><input type=checkbox id="{{\'schedule.operating-\' + hour}}" checklist-model=schedule.operating.hours.specificHoursOfTheDay ng-change="selectedHourChange(\'operating\',hour)" checklist-value=hour> <label for="{{\'schedule.operating-\' + hour}}">{{hour}}</label></div><br><span class=text-red ng-if=isOperatingHrsRequired>{{webAppTexts.errorMessages.hourRequired}}</span></div></div></div><div ng-if="learningModeDays && !isDistributorUser" class="col-md-12 no-left-padding"><span>{{webAppTexts.notes.learningMode}}<strong ng-bind="learningModeDays + \' \'"></strong>{{webAppTexts.labels.days}}</span></div></div></div></div><br><div ng-if="isDistributorUser && model.monitoredOnline && !isUserDefinedLimit" class=row ng-disabled=viewForm><div class=col-md-12><label for=operating class=required><strong>{{webAppTexts.labels.learningModeConfig}}</strong></label></div><div class="col-md-12 schedule-box"><div class="row schedule-type-box form-group"><div class="col-md-4 no-left-right-padding" style=margin-right:-50px><label class=required><strong>{{webAppTexts.labels.minNoOfReading}}</strong></label><br><div class="col-md-10 col-lg-10 col-sm-10 no-left-padding form-group has-feedback" ng-class="{\'has-error\': model.scheduleForm.minReadings.$invalid && (model.scheduleForm.minReadings.$dirty || model.scheduleForm.$submitted)}"><input type=number class=form-control id=minReadings name=minReadings placeholder={{webAppTexts.placeholder.learningCount}} ng-model=model.learningCount ng-pattern="/^[0-9]{1,7}$/" min=3 ng-change=validateLearningModeCount() required style="padding-right: 15px !important"> <span class=help-block error-block basic-block" ng-if=model.scheduleForm.minReadings.$error.required>{{webAppTexts.errorMessages.minReadingCountRequired}}</span> <span class="help-block error-block basic-block" ng-if="model.scheduleForm.minReadings.$error.pattern && !model.scheduleForm.minReadings.$error.min">{{webAppTexts.errorMessages.notValidNumber}}</span> <span class="help-block error-block basic-block" ng-if=model.scheduleForm.minReadings.$error.min>{{webAppTexts.errorMessages.minReadingCount}}</span></div></div><div class=col-md-3><label class=required><strong>{{webAppTexts.labels.in}}</strong></label><br><div class="col-md-12 col-lg-12 col-sm-12 no-left-padding"><ui-select ng-model=analysisConfiguration.permanent.learningModeInfo.intervalType class="btn-group bootstrap-select form-control" on-select=changingLearningModeInType(analysisConfiguration.permanent.learningModeInfo.intervalType) ng-disabled=viewForm><ui-select-match placeholder={{webAppTexts.placeholder.selectFrequency}}><span>{{$select.selected.value.name}}</span></ui-select-match><ui-select-choices repeat="type.value.id as (key, type) in learningModeInOptions | filter: $select.search"><span ng-bind-html=type.value.name></span></ui-select-choices></ui-select></div></div><div class="col-md-5 no-left-padding"><label class=required><strong>{{learningModeInType}}</strong></label><br><div class="col-md-8 col-lg-8 col-sm-8 no-left-padding form-group has-feedback" ng-class="{\'has-error\': (model.scheduleForm.value.$invalid && (model.scheduleForm.value.$dirty || model.scheduleForm.$submitted)|| learningMinutesInvalid)}"><input type=number class=form-control id=value name=value placeholder={{frequencyPlaceHolderMsg}} ng-model=analysisConfiguration.permanent.learningModeInfo.value ng-pattern="/^[0-9]{1,7}$/" ng-change=validateLearningModeCount() min=1 style="padding-right: 15px !important" required> <span class="help-block error-block basic-block" ng-if=model.scheduleForm.value.$error.required>{{learningModeInType + webAppTexts.errorMessages.isRequired}}</span> <span class="help-block error-block basic-block" ng-if=learningMinutesInvalid>{{webAppTexts.errorMessages.minFiveMinRequired}}</span> <span class="help-block error-block basic-block" ng-if="model.scheduleForm.value.$error.pattern && !model.scheduleForm.value.$error.min">{{webAppTexts.errorMessages.notValidNumber}}</span> <span class="help-block error-block basic-block" ng-if=model.scheduleForm.value.$error.min>{{minLearningmodeTime}}</span></div></div><div class=clearfix></div><span class=text-red ng-if=readingsNotPossible>{{possibleReadingCountMsg}}</span> <span ng-if=!readingsNotPossible>{{webAppTexts.notes.readingInterval}}<strong ng-bind="\': \'+ readingInterval + \' \' + webAppTexts.notes.minutes"></strong></span></div></div></div><br ng-if="isDistributorUser && model.monitoredOnline && !isUserDefinedLimit"><div ng-if=model.monitoredOnline class=row ng-disabled=viewForm><div class=col-md-12><label for=normal class=required><strong>{{webAppTexts.labels.monitoringScheduleInNormal}}</strong></label></div><div class="col-md-12 schedule-box"><div class="row schedule-type-box form-group"><div class="col-md-12 no-left-padding"><label><strong>{{webAppTexts.labels.monitoringDays}}</strong></label></div><div class=col-md-12><div class="col-md-3 col-lg-3 col-sm-3"><div class="form-group form-inline" style=margin-bottom:5px;><ui-select ng-model=schedule.normal.daysType class="btn-group bootstrap-select form-control" on-select="changingDaysType(\'normal\',schedule.normal.daysType)" ng-disabled=viewForm><ui-select-match placeholder={{webAppTexts.placeholder.selectMonitoringDays}}><span>{{$select.selected.value.name}}</span></ui-select-match><ui-select-choices repeat="type.value.id as (key, type) in monitoringDaysTypes | filter: $select.search"><span ng-bind-html=type.value.name></span></ui-select-choices></ui-select></div></div><div class="col-md-9 schedule-value-box"><div ng-if="schedule.normal.daysType === 2" class="form-group form-inline specific-schedule"><div class="checkbox checkbox-inline" ng-repeat="day in days" ng-style="{\'padding-left\': ($index === 0 ? \'20px\' : \'5px\')}"><input type=checkbox id="{{\'schedule.normal-\' + day}}" checklist-model=schedule.normal.days.specificDaysInWeek ng-change="selectedDayChange(\'normal\',day)" checklist-value=day> <label for="{{\'schedule.normal-\' + day}}">{{day}}</label></div><br><span class=text-red ng-if=isNormalDaysRequired>{{webAppTexts.errorMessages.dayRequired}}</span></div></div></div><div class=clearfix></div><hr class=schedule-divider><div class="col-md-12 no-left-padding"><label><strong>{{webAppTexts.labels.monitoringTime}}</strong></label></div><div class=col-md-12><div class=col-md-3><div class="form-group form-inline"><ui-select ng-model=schedule.normal.scheduleTime class="btn-group bootstrap-select form-control" on-select="changingHoursType(\'normal\',schedule.normal.scheduleTime)" ng-disabled=viewForm><ui-select-match placeholder={{webAppTexts.placeholder.selectMonitoringTime}}><span>{{$select.selected.value.name}}</span></ui-select-match><ui-select-choices repeat="type.value.id as (key, type) in schedule.normal.monitoringHoursTypes | filter: $select.search"><span ng-bind-html=type.value.name></span></ui-select-choices></ui-select></div></div><div class="col-md-9 schedule-value-box"><div ng-if="schedule.normal.scheduleTime === 1" class="form-group form-inline"><label>{{webAppTexts.labels.at}}</label>&nbsp;&nbsp;<select ng-model=schedule.normal.hours.onceDayAt.hour class="form-control input-sm"><option ng-repeat="hour in hours" value={{hour}}>{{hour}}</option></select>&nbsp; <label>{{webAppTexts.labels.hours}}</label>&nbsp;&nbsp;<select ng-model=schedule.normal.hours.onceDayAt.minutes class="form-control input-sm"><option ng-repeat="minute in minutes" value={{minute}}>{{minute}}</option></select>&nbsp; <label>{{webAppTexts.labels.minutes}}</label><br></div><div ng-if="schedule.normal.scheduleTime === 2" class="form-group form-inline specific-schedule" style="padding-top:0px !important;"><div class=checkbox><input type=checkbox id=normalSelectAllHours ng-model=schedule.normal.selectAllHours ng-change=selectAllHours(schedule.normal.selectAllHours)> <label for=normalSelectAllHours><strong>{{webAppTexts.labels.selectAllHours}}</strong></label></div><br><div class="checkbox checkbox-inline" ng-repeat="hour in hours" ng-style="{\'padding-left\': ($index === 0 ? \'20px\' : \'10px\')}"><input type=checkbox id="{{\'schedule.normal-\' + hour}}" checklist-model=schedule.normal.hours.specificHoursOfTheDay ng-change="selectedHourChange(\'normal\',hour)" checklist-value=hour> <label for="{{\'schedule.normal-\' + hour}}">{{hour}}</label></div><br><span class=text-red ng-if=isNormalHrsRequired>{{webAppTexts.errorMessages.hourRequired}}</span></div><div ng-if="schedule.normal.scheduleTime === 3" class="form-group form-inline specific-schedule" style="padding-top:0px !important;"><select ng-model=schedule.normal.hours.everyMinutesOfOperatingHours class="form-control input-sm"><option ng-repeat="everyMinute in schedule.normal.everyMinutes" value={{everyMinute}}>{{everyMinute}}</option></select>&nbsp;&nbsp; <label>{{webAppTexts.labels.minutesDuringOperation}}</label><br><br><span>{{webAppTexts.notes.nearestTimeWillChosen}}</span></div><br></div></div></div></div></div><br><div ng-if=model.monitoredOnline class=row ng-disabled=viewForm><div class=col-md-12><label for=warning class=required><strong>{{webAppTexts.labels.monitoringScheduleInWarning}}</strong></label></div><div class="col-md-12 schedule-box"><div class="row schedule-type-box form-group"><div class="col-md-3 no-left-padding" style="margin-bottom: 5px;"><ui-select ng-model=schedule.warning.scheduleType class="btn-group bootstrap-select form-control" on-select="resetSchedule(\'warning\', schedule.warning.scheduleType )" ng-disabled=viewForm><ui-select-match placeholder={{webAppTexts.placeholder.selectScheduleType}}><span>{{$select.selected.value.name}}</span></ui-select-match><ui-select-choices repeat="type.value.id as (key, type) in schedule.warning.scheduleTypes | filter: $select.search"><span ng-bind-html=type.value.name></span></ui-select-choices></ui-select></div><div ng-if="schedule.warning.scheduleType === 2"><div class="col-md-12 no-left-padding"><label><strong>{{webAppTexts.labels.monitoringDays}}</strong></label></div><div class=col-md-12><div class="col-md-3 col-lg-3 col-sm-3"><div class="form-group form-inline" style=margin-bottom:5px;><ui-select ng-model=schedule.warning.daysType class="btn-group bootstrap-select form-control" on-select="changingDaysType(\'warning\',schedule.warning.daysType)" ng-disabled=viewForm><ui-select-match placeholder={{webAppTexts.placeholder.selectMonitoringDays}}><span>{{$select.selected.value.name}}</span></ui-select-match><ui-select-choices repeat="type.value.id as (key, type) in monitoringDaysTypes | filter: $select.search"><span ng-bind-html=type.value.name></span></ui-select-choices></ui-select></div></div><div class="col-md-9 schedule-value-box"><div ng-if="schedule.warning.daysType === 2" class="form-group form-inline specific-schedule"><div class="checkbox checkbox-inline" ng-repeat="day in days" ng-style="{\'padding-left\': ($index === 0 ? \'20px\' : \'5px\')}"><input type=checkbox id="{{\'warning-\' + day}}" checklist-model=schedule.warning.days.specificDaysInWeek ng-change="selectedDayChange(\'warning\',day)" checklist-value=day> <label for="{{\'warning-\' + day}}">{{day}}</label></div><br><span class=text-red ng-if=isWarningDaysRequired>{{webAppTexts.errorMessages.dayRequired}}</span></div></div></div><div class=clearfix></div><hr class=schedule-divider><div class="col-md-12 no-left-padding"><label><strong>{{webAppTexts.labels.monitoringTime}}</strong></label></div><div class=col-md-12><div class=col-md-3><div class="form-group form-inline"><ui-select ng-model=schedule.warning.scheduleTime class="btn-group bootstrap-select form-control" on-select="changingHoursType(\'warning\',schedule.warning.scheduleTime)" ng-disabled=viewForm><ui-select-match placeholder={{webAppTexts.placeholder.selectMonitoringTime}}><span>{{$select.selected.value.name}}</span></ui-select-match><ui-select-choices repeat="type.value.id as (key, type) in schedule.warning.monitoringHoursTypes | filter: $select.search"><span ng-bind-html=type.value.name></span></ui-select-choices></ui-select></div></div><div class="col-md-9 schedule-value-box"><div ng-if="schedule.warning.scheduleTime === 2" class="form-group form-inline specific-schedule" style="padding-top:0px !important;"><div class="checkbox checkbox-inline" ng-repeat="hour in hours" ng-style="{\'padding-left\': ($index === 0 ? \'20px\' : \'10px\')}"><input type=checkbox id="{{\'schedule.warning-\' + hour}}" checklist-model=schedule.warning.hours.specificHoursOfTheDay ng-change="selectedHourChange(\'warning\',hour)" checklist-value=hour> <label for="{{\'schedule.warning-\' + hour}}">{{hour}}</label></div><br><span>{{webAppTexts.notes.disabledHoursAreNonOperatingHours}}</span><br><span class=text-red ng-if=isWarningHrsRequired>Select at least one hour</span></div><div ng-if="schedule.warning.scheduleTime === 3" class="form-group form-inline specific-schedule" style="padding-top:0px !important;"><select ng-model=schedule.warning.hours.everyMinutesOfOperatingHours class="form-control input-sm"><option ng-repeat="everyMinute in schedule.warning.everyMinutes" value={{everyMinute}}>{{everyMinute}}</option></select>&nbsp;&nbsp; <label>{{webAppTexts.labels.minutesDuringOperation}}</label><br><br><span>{{webAppTexts.notes.nearestTimeWillChosen}}</span></div></div></div></div></div></div></div><br><div ng-if=model.monitoredOnline class=row ng-disabled=viewForm><div class=col-md-12><label for=alert class=required><strong>{{webAppTexts.labels.monitoringScheduleInAlert}}</strong></label></div><div class="col-md-12 schedule-box"><div class="row schedule-type-box form-group"><div class="col-md-3 no-left-padding" style="margin-bottom: 5px;"><ui-select ng-model=schedule.alert.scheduleType class="btn-group bootstrap-select form-control" on-select="resetSchedule(\'alert\', schedule.alert.scheduleType )" ng-disabled=viewForm><ui-select-match placeholder={{webAppTexts.placeholder.selectScheduleType}}><span>{{$select.selected.value.name}}</span></ui-select-match><ui-select-choices repeat="type.value.id as (key, type) in schedule.alert.scheduleTypes | filter: $select.search"><span ng-bind-html=type.value.name></span></ui-select-choices></ui-select></div><div ng-if="schedule.alert.scheduleType === 2"><div class="col-md-12 no-left-padding"><label><strong>{{webAppTexts.labels.monitoringDays}}</strong></label></div><div class=col-md-12><div class="col-md-3 col-lg-3 col-sm-3"><div class="form-group form-inline" style=margin-bottom:5px;><ui-select ng-model=schedule.alert.daysType class="btn-group bootstrap-select form-control" on-select="changingDaysType(\'alert\',schedule.alert.daysType)" ng-disabled=viewForm><ui-select-match placeholder={{webAppTexts.placeholder.selectMonitoringDays}}><span>{{$select.selected.value.name}}</span></ui-select-match><ui-select-choices repeat="type.value.id as (key, type) in monitoringDaysTypes | filter: $select.search"><span ng-bind-html=type.value.name></span></ui-select-choices></ui-select></div></div><div class="col-md-9 schedule-value-box"><div ng-if="schedule.alert.daysType === 2" class="form-group form-inline specific-schedule"><div class="checkbox checkbox-inline" ng-repeat="day in days" ng-style="{\'padding-left\': ($index === 0 ? \'20px\' : \'5px\')}"><input type=checkbox id="{{\'alert-\' + day}}" checklist-model=schedule.alert.days.specificDaysInWeek ng-change="selectedDayChange(\'alert\',day)" checklist-value=day> <label for="{{\'alert-\' + day}}">{{day}}</label></div><br><span class=text-red ng-if=isAlertDaysRequired>{{webAppTexts.errorMessages.dayRequired}}</span></div></div></div><div class=clearfix></div><hr class=schedule-divider><div class="col-md-12 no-left-padding"><label><strong>{{webAppTexts.labels.monitoringTime}}</strong></label></div><div class=col-md-12><div class=col-md-3><div class="form-group form-inline"><ui-select ng-model=schedule.alert.scheduleTime class="btn-group bootstrap-select form-control" on-select="changingHoursType(\'alert\',schedule.alert.scheduleTime)" ng-disabled=viewForm><ui-select-match placeholder={{webAppTexts.placeholder.selectMonitoringTime}}><span>{{$select.selected.value.name}}</span></ui-select-match><ui-select-choices repeat="type.value.id as (key, type) in schedule.alert.monitoringHoursTypes | filter: $select.search"><span ng-bind-html=type.value.name></span></ui-select-choices></ui-select></div></div><div class="col-md-9 schedule-value-box"><div ng-if="schedule.alert.scheduleTime === 2" class="form-group form-inline specific-schedule" style="padding-top:0px !important;"><div class="checkbox checkbox-inline" ng-repeat="hour in hours" ng-style="{\'padding-left\': ($index === 0 ? \'20px\' : \'10px\')}"><input type=checkbox id="{{\'schedule.alert-\' + hour}}" checklist-model=schedule.alert.hours.specificHoursOfTheDay ng-change="selectedHourChange(\'alert\',hour)" checklist-value=hour> <label for="{{\'schedule.alert-\' + hour}}">{{hour}}</label></div><br><span>{{webAppTexts.notes.disabledHoursAreNonOperatingHours}}</span><br><span class=text-red ng-if=isAlertHrsRequired>{{webAppTexts.errorMessages.hourRequired}}</span></div><div ng-if="schedule.alert.scheduleTime === 3" class="form-group form-inline specific-schedule" style="padding-top:0px !important;"><select ng-model=schedule.alert.hours.everyMinutesOfOperatingHours class="form-control input-sm"><option ng-repeat="everyMinute in schedule.alert.everyMinutes" value={{everyMinute}}>{{everyMinute}}</option></select>&nbsp;&nbsp; <label>{{webAppTexts.labels.minutesDuringOperation}}</label><br><br><span>{{webAppTexts.notes.nearestTimeWillChosen}}</span></div></div></div></div></div></div></div></form></fieldset></ba-wizard-step><ba-wizard-step steptitle={{webAppTexts.headings.watchers}} cancel=goBack save=save validateform=validateUsersInfoForm form=model.usersInfoForm><fieldset ng-disabled=viewForm><form name=model.usersInfoForm><div class=row><div class=col-lg-6><div class=col-lg-2 style="padding:10px 0px;"><label><strong>{{webAppTexts.labels.owner}}</strong></label></div><div class=col-lg-10 style=padding:0px;><ui-select id=area ng-model=selected.machineOwners class="btn-group bootstrap-select form-control" ng-disabled="!canChangeOwner || viewForm" required><ui-select-match placeholder={{webAppTexts.placeholder.selectOwnerForMachine}}><span>{{$select.selected.firstName + \' \' + $select.selected.lastName}}</span></ui-select-match><ui-select-choices repeat="owner in ownerUsers | filter: $select.search"><div class=text-truncate style="position:initial !important;"><span>{{owner.firstName + \' \' + owner.lastName}}</span><br><small>{{owner.email}}</small></div></ui-select-choices></ui-select></div></div><div class="col-lg-6 row" ng-if="levelManagers && levelManagers.length" style=padding-top:10px;><div class=col-lg-2><label><strong>{{webAppTexts.labels.managers}}</strong></label></div><div class=col-lg-10><span ng-repeat="manager in levelManagers"><span ng-bind="manager.userId.firstName + \' \' + manager.userId.lastName"></span> <span ng-if=!$last ng-bind="\', \'"></span></span></div></div><div class=clearfix></div><br><div ng-if=!viewForm class="row col-lg-6"><div class=col-lg-11><label><strong>{{webAppTexts.labels.users}}</strong></label><br><ui-select multiple ng-model=selected.distributionUsers theme=bootstrap sortable=true close-on-select=false><ui-select-match placeholder={{webAppTexts.placeholder.selectUser}}>{{selected.distributionUsers[$index].firstName + \' \' + selected.distributionUsers[$index].lastName}}</ui-select-match><ui-select-choices repeat="user in allUsers | filter: $select.search"><div class=text-truncate style="position:initial !important"><span>{{user.firstName + \' \' + user.lastName}}</span><br><small>{{user.email}}</small></div></ui-select-choices></ui-select></div><div class="col-lg-1 col-md-1 pull-right" style=margin-top:20px;><button type=button class="btn btn-primary" ng-click=addUserInList(selected.distributionUsers) ng-disabled=!selected.distributionUsers.length>{{webAppTexts.buttons.add}}</button></div></div><div ng-if=!viewForm class=clearfix></div><br ng-if=!viewForm><div ng-class="{\'col-lg-12\':model.monitoredOnline,\'col-lg-6\':!model.monitoredOnline}"><div class="form-group has-feedback" ng-class="{\'has-error\':isNotificationTypeRequired}"><label><strong>{{webAppTexts.headings.notificationReceivers}}</strong></label><table class="table table-bordered center-align-table" style=margin-bottom:5px;><thead><tr><th rowspan=3 style="vertical-align: middle;"><strong>{{webAppTexts.headings.userAndRole}}</strong></th><th colspan=3><strong>{{webAppTexts.labels.conditionAssessment}}</strong></th><th ng-if=model.monitoredOnline colspan=4><strong>{{webAppTexts.labels.conditionMonitoring}}</strong></th></tr><tr><th colspan=3><strong>{{webAppTexts.headings.machineCondition}}</strong></th><th ng-if=model.monitoredOnline colspan=2><strong>{{webAppTexts.headings.machineCondition}}</strong></th><th ng-if=model.monitoredOnline colspan=2><strong>{{webAppTexts.headings.notificationFrequency}}</strong></th></tr><tr><th><strong>{{webAppTexts.headings.normal}}</strong></th><th><strong>{{webAppTexts.headings.warning}}</strong></th><th><strong>{{webAppTexts.headings.alert}}</strong></th><th ng-if=model.monitoredOnline><strong>{{webAppTexts.headings.warning}}</strong></th><th ng-if=model.monitoredOnline><strong>{{webAppTexts.headings.alert}}</strong></th><th ng-if=model.monitoredOnline><strong>{{webAppTexts.headings.onConditionChange}}</strong></th><th ng-if=model.monitoredOnline><strong>{{webAppTexts.headings.weeklyDigest}}</strong></th></tr></thead><tbody><tr ng-repeat="user in initialDistributionList"><td>{{user.name}}</td><td><span ng-if=user.portable.normal><i class="fa fa-check" ng-if="viewForm && machineOwner.normal"></i></span> <input ng-if="user.portable.normal && !viewForm" type=checkbox ng-model=machineOwner.normal></td><td><span ng-if=user.portable.warning><i class="fa fa-check"></i></span></td><td><span ng-if=user.portable.alert><i class="fa fa-check"></i></span></td><td ng-if=model.monitoredOnline><span ng-if=user.permanent.warning><i class="fa fa-check"></i></span></td><td ng-if=model.monitoredOnline><span ng-if=user.permanent.alert><i class="fa fa-check"></i></span></td><td ng-if=model.monitoredOnline><span ng-if=user.permanent.frequency.instant><i class="fa fa-check"></i></span></td><td ng-if=model.monitoredOnline><span ng-if=user.permanent.frequency.digest><i class="fa fa-check"></i></span></td></tr><tr ng-repeat="user in distributionList"><td>{{user.firstName + \' \' + user.lastName}} <span ng-if=!viewForm class=pull-right><i class="fa fa-times cursor-pointer" ng-click=removeUserFromList(user) style=color:#AC2925;></i></span></td><td><span ng-if="viewForm && user.portable.normal"><i class="fa fa-check"></i></span> <input ng-if=!viewForm type=checkbox ng-model=user.portable.normal ng-disabled=viewForm></td><td><span ng-if="viewForm && user.portable.warning"><i class="fa fa-check"></i></span> <input ng-if=!viewForm type=checkbox ng-model=user.portable.warning ng-disabled=viewForm></td><td><span ng-if="viewForm && user.portable.alert"><i class="fa fa-check"></i></span> <input ng-if=!viewForm type=checkbox ng-model=user.portable.alert ng-disabled=viewForm></td><td ng-if=model.monitoredOnline><span ng-if="viewForm && user.permanent.warning"><i class="fa fa-check"></i></span> <input ng-if=!viewForm type=checkbox ng-model=user.permanent.warning ng-disabled=viewForm></td><td ng-if=model.monitoredOnline><span ng-if="viewForm && user.permanent.alert"><i class="fa fa-check"></i></span> <input ng-if=!viewForm type=checkbox ng-model=user.permanent.alert ng-disabled=viewForm></td><td ng-if=model.monitoredOnline><span ng-if="viewForm && user.permanent.frequency.instant"><i class="fa fa-check"></i></span> <input ng-if=!viewForm type=checkbox ng-model=user.permanent.frequency.instant ng-disabled=viewForm></td><td ng-if=model.monitoredOnline><span ng-if="viewForm && user.permanent.frequency.digest"><i class="fa fa-check"></i></span> <input ng-if=!viewForm type=checkbox ng-model=user.permanent.frequency.digest ng-disabled=viewForm></td></tr></tbody></table><span class=text-red ng-if=isNotificationTypeRequired ng-bind="(webAppTexts.errorMessages.notificationTypeRequired + notificationTypeRequiredFor + \'.\')"></span> <span class=text-red ng-if=isNotificationFrequencyRequired ng-bind="(webAppTexts.errorMessages.notificationFrequencyRequired + notificationFrequencyRequiredFor + \'.\')"></span> <span class=text-red ng-if=isPermanentNotificationTypeRequired ng-bind="(webAppTexts.errorMessages.permanentNotificationTypeRequired + permanentNotificationTypeRequiredFor + \'.\')"></span></div></div></div></form></fieldset></ba-wizard-step></ba-wizard></div></div></div></div></div>');
$templateCache.put('app/components/machines/modals/addRoute.html','<div class=modal-content><div class="modal-header bg-info"><h4><i class={{iconClass}}></i> <span>{{title}}</span><div class="btn-group pull-right"><a class="btn modal-close-button" ng-click=$event.stopPropagation();$dismiss()><i class="fa fa-times"></i></a></div></h4></div><div class=modal-body><form role=form name=addRouteForm><div class=form-group><div class=col-sm-12><label class=required for=name><strong>Name</strong></label> <input type=text id=name ng-model=routeData.name class="form-control ng-touched ng-dirty ng-valid-parse ng-empty ng-invalid ng-invalid-required" ng-required=true placeholder="Enter route name" required><br><label for=description><strong>Description</strong></label> <textarea class=form-control id=description ng-model=routeData.description style="min-height:60px !important" maxlength=255 placeholder="Enter description"></textarea><br><label class=required for=machines><strong>Machines</strong></label><div class=input-group><ui-select id=machines ng-model=routeData.machineMember class="btn-group bootstrap-select form-control"><ui-select-match placeholder="select machines"><span>{{$select.selected.name}}</span></ui-select-match><ui-select-choices repeat="machine in machineMembers | filter: $select.search"><span ng-bind-html=machine.name></span></ui-select-choices></ui-select><span class=input-group-btn><button name=button type=submit ng-disabled=invalidMachine class="btn btn-primary" ng-click=pushMachine()><i class="fa fa-plus"></i></button></span></div><div><ul class=list-group dnd-list=selectedMachines style="margin-bottom: 5px;"><li class="list-group-item clearfix" ng-repeat="item in selectedMachines" dnd-draggable=item dnd-moved="selectedMachines.splice($index, 1)" dnd-effect-allowed=move>{{item.name}} <span ng-click=removeMachine(item) class="pull-right button-group"><span class="glyphicon glyphicon-remove"></span></span></li></ul><div ng-if="selectedMachines.length>=2"><span>Note: Drag and drop the machines for sequencing</span><br><br></div></div><label class=required for=owner><strong>Owners</strong></label><ui-select multiple id=owner ng-model=owner.selected class="btn-group bootstrap-select form-control"><ui-select-match><span>{{owner.selected[$index].name}}</span></ui-select-match><ui-select-choices repeat="itm in owner | filter: $select.search"><span ng-bind-html=itm.name></span></ui-select-choices></ui-select><br><br><div class=form-group><label><strong>How frequently you want to analyze Route?</strong></label><div ng-class="{\'has-error\' :addRouteForm.$invalid && !addRouteForm.scheduleStartFrom.$pristine && !addRouteForm.scheduleDays.$pristine && !addRouteForm.$pristine}"><ui-select on-select=selectSchedule($item) ng-model=selectedScheduleType.value class="btn-group bootstrap-select form-control"><ui-select-match placeholder="Select schedule ...">{{$select.selected.displayName}}</ui-select-match><ui-select-choices repeat="type in scheduleTypes| filter: $select.search"><div ng-bind-html="type.displayName | highlight: $select.search"></div></ui-select-choices></ui-select><br><br><div class="form-inline form-group" ng-show="selectedScheduleType.value && !selectedScheduleType.value.month"><label>Every &nbsp;</label> <input ng-change="selectSchedule(selectedScheduleType.value, true)" type=number class=form-control min=1 max=365 id=scheduleDays name=scheduleDays ng-model=scheduleDays ng-required="selectedScheduleType.value && !selectedScheduleType.value.month" ng-disabled=reqMachineData.viewDetails> <label>&nbsp; days</label> <span class="help-block text-red" ng-if=scheduleForm.scheduleDays.$error.min>Need to add atleast 1 day.</span> <span class="help-block text-red" ng-if=scheduleForm.scheduleDays.$error.max>Sorry..! You are exceeding the limit.</span><p ng-show="!scheduleForm.scheduleDays.$pristine && scheduleForm.scheduleDays.$error.required" class="help-block text-red ng-scope">Require schedule days.</p><br><br><br></div></div></div></div></div></form></div><div class=clearfix></div><div class=modal-footer><button type=button class="btn btn-danger pull-left" ng-click=$dismiss()>Cancel</button> <button type=button class="btn btn-info" ng-disabled=saveRouteVisibility() ng-click=addRoute()>Save</button></div></div>');
$templateCache.put('app/components/machines/modals/allDevicesDialog.html','<div class=modal-content><div class="modal-header bg-primary"><h4 class=modal-title><span>All Devices</span><div class="btn-group pull-right"><a class=modal-close-button ng-click=$dismiss()><i class="fa fa-times"></i></a></div></h4></div><div class=modal-body><div class=container-fluid><div class=row><span><h5>Total devices: {{totalDevices}}</h5></span><table class="table table-bordered"><thead><tr><th><strong>Point Name</strong></th><th><strong>Device Name</strong></th></tr></thead><tbody><tr ng-repeat="point in machinePoints"><td><span>{{point.displayName}}</span></td><td><span>{{point.deviceMacId}}</span></td></tr></tbody></table></div></div></div><div class=modal-footer><button type=button class="btn btn-cancel pull-left" ng-click=$dismiss()>Back</button></div></div>');
$templateCache.put('app/components/machines/modals/compareMachineReport.html','<div class=container-fluid ng-class="{\'report-container\': webReportPage}"><div class=row><div class=col-lg-12><div class=col-xs-12><h3 style=margin-top:0px class=text-center><strong ng-bind="(machineInfo ? ((machineInfo.type) + \': \') : \'\')"></strong>{{machineInfo.machineId}}</h3></div><div ng-if=greenAnimate class="col-xs-12 text-center"><div class=circle></div></div><div ng-if=redAnimate class=col-xs-12><div class="alert alert-danger"><strong>IMPORTANT NOTE:</strong><br>{{importantNote}}</div></div><div class="col-xs-12 same-height-col"><div class="row no-left-right-padding"><div class="col-lg-6 text-center no-left-right-padding hidden-md hidden-xs hidden-sm"><h3>Trending Report</h3></div><div class="col-lg-6 text-center no-left-right-padding hidden-md hidden-xs hidden-sm"><h3>Latest Report</h3></div><div class=row ng-repeat="property in reportDataByProperty track by $index"><div class="col-lg-12 text-center"><label class=report-label>{{property[0].label}}</label></div><label class="visible-xs visible-sm visible-md hidden-lg">Trending</label><div class="col-lg-6 no-left-right-padding" ng-style="{\'margin-bottom\': ($index === reportDataByProperty.length -1 || isFinalSeverity($index, false) ? \'10px\' :\'0px\')}"><div ng-if="!isFinalSeverity($index, false)"><div ng-if="property[0].prev != property[0].Current && !noLastReport && !property[0].iso" ng-style="{\'margin-left\': property[0].prev + \'%\'}"><span class=status-notation-label>Previous</span><div class=arrow-down-prev></div></div><div ng-style="{\'margin-left\': property[0].Current + \'%\'}"><span class=status-notation-label ng-style="{\'margin-left\': ((property[0].prev === property[0].Current) && (property[0].currentSeverity>4) ? \'-46px\' : \'0px\')}">{{(property[0].prev === property[0].Current && !property[0].iso) ? ( (noLastReport) ? \'Current\' : \'Previous & Current\' ) : \'Current\'}}</span><div class=arrow-down-last></div></div><div id=conditon-status class=text-center><div class="col-xs-4 report-border">Good</div><div class="col-xs-4 report-border report-center-div-border" style=padding:0px>OK (Passable)</div><div class="col-xs-4 report-border">Bad</div></div></div><div><ul class=recommendation-list ng-repeat="rec in property[0].recommendation track by $index"><li>{{rec}}</li></ul></div></div><label class="visible-xs visible-sm visible-md hidden-lg">Latest</label><div class="col-lg-6 no-left-right-padding" ng-style="{\'margin-bottom\': ($index === reportDataByProperty.length -1 || isFinalSeverity($index, false) ? \'10px\' :\'0px\')}"><div ng-if="!isFinalSeverity($index, false)"><div ng-if="property[1].prev != property[1].Current && !noLastReport && !property[1].iso" ng-style="{\'margin-left\': property[1].prev + \'%\'}"><span class=status-notation-label>Previous</span><div class=arrow-down-prev></div></div><div ng-style="{\'margin-left\': property[1].Current + \'%\'}"><span class=status-notation-label ng-style="{\'margin-left\': ((property[1].prev === property[1].Current) && (property[1].currentSeverity>4) ? \'-46px\' : \'0px\')}">{{(property[1].prev === property[1].Current && !property[1].iso) ? ( (noLastReport) ? \'Current\' : \'Previous & Current\' ) : \'Current\'}}</span><div class=arrow-down-last></div></div><div id=conditon-status class=text-center><div class="col-xs-4 report-border">Good</div><div class="col-xs-4 report-border report-center-div-border" style=padding:0px>OK (Passable)</div><div class="col-xs-4 report-border">Bad</div></div></div><div><ul class=recommendation-list ng-repeat="rec in property[1].recommendation track by $index"><li>{{rec}}</li></ul></div></div></div></div></div></div></div></div><div ng-if="currentReportExpSysVersion && !showMachineStatus" class="text-right container-fluid report-version" style="color: black">Version: {{currentReportExpSysVersion}}</div>');
$templateCache.put('app/components/machines/modals/compareMonitoringMachineReport.html','<div class=container-fluid ng-class="{\'report-container\': webReportPage}"><div class="col-xs-12 text-center"><h3 style=margin:0px><strong>Machine:</strong>{{machineInfo.machineId}}</h3></div><div class=row><div class=col-lg-12><div ng-if=greenAnimate class="col-xs-12 text-center"><div class=circle></div></div><div ng-if=redAnimate class=col-xs-12><div class="alert alert-danger"><strong>IMPORTANT NOTE:</strong><br>{{importantNote}}</div></div><div class="col-xs-12 same-height-col"><div class="row no-left-right-padding"><div class="col-lg-6 text-center no-left-right-padding hidden-md hidden-xs hidden-sm"><h3>Trending Report</h3></div><div class="col-lg-6 text-center no-left-right-padding hidden-md hidden-xs hidden-sm"><h3>Latest Report</h3></div><div class=row ng-repeat="property in reportDataByProperty track by $index"><div class="col-lg-12 text-center"><label class=report-label>{{property[0].label}}</label></div><label class="visible-xs visible-sm visible-md hidden-lg">Trending</label><div class="col-lg-6 no-left-right-padding" ng-style="{\'margin-bottom\': ($index === reportDataByProperty.length -1 || isFinalSeverity($index, false) ? \'10px\' :\'0px\')}"><div ng-if="!isFinalSeverity($index, false)"><div ng-if="property[0].prev != property[0].Current && !noLastReport && !property[0].iso" ng-style="{\'margin-left\': property[0].prev + \'%\'}"><span class=status-notation-label>Previous</span><div class=arrow-down-prev></div></div><div ng-style="{\'margin-left\': property[0].Current + \'%\'}"><span class=status-notation-label ng-style="{\'margin-left\': ((property[0].prev === property[0].Current) && (property[0].currentSeverity>4) ? \'-46px\' : \'0px\')}">{{(property[0].prev === property[0].Current && !property[0].iso) ? ( (noLastReport) ? \'Current\' : \'Previous & Current\' ) : \'Current\'}}</span><div class=arrow-down-last></div></div><div id=conditon-status class=text-center><div class="col-xs-4 report-border">Good</div><div class="col-xs-4 report-border report-center-div-border" style=padding:0px>OK (Passable)</div><div class="col-xs-4 report-border">Bad</div></div></div><div><ul class=recommendation-list ng-repeat="rec in property[0].recommendation track by $index"><li>{{rec}}</li></ul></div></div><label class="visible-xs visible-sm visible-md hidden-lg">Latest</label><div class="col-lg-6 no-left-right-padding" ng-style="{\'margin-bottom\': ($index === reportDataByProperty.length -1 || isFinalSeverity($index, false) ? \'10px\' :\'0px\')}"><div ng-if="!isFinalSeverity($index, false)"><div ng-if="property[1].prev != property[1].Current && !noLastReport && !property[1].iso" ng-style="{\'margin-left\': property[1].prev + \'%\'}"><span class=status-notation-label>Previous</span><div class=arrow-down-prev></div></div><div ng-style="{\'margin-left\': property[1].Current + \'%\'}"><span class=status-notation-label ng-style="{\'margin-left\': ((property[1].prev === property[1].Current) && (property[1].currentSeverity>4) ? \'-46px\' : \'0px\')}">{{(property[1].prev === property[1].Current && !property[1].iso) ? ( (noLastReport) ? \'Current\' : \'Previous & Current\' ) : \'Current\'}}</span><div class=arrow-down-last></div></div><div id=conditon-status class=text-center><div class="col-xs-4 report-border">Good</div><div class="col-xs-4 report-border report-center-div-border" style=padding:0px>OK (Passable)</div><div class="col-xs-4 report-border">Bad</div></div></div><div><ul class=recommendation-list ng-repeat="rec in property[1].recommendation track by $index"><li>{{rec}}</li></ul></div></div></div></div></div></div></div></div><div ng-if="currentReportExpSysVersion && !showMachineStatus" class="text-right container-fluid report-version" style="color: black">Version: {{currentReportExpSysVersion}}</div>');
$templateCache.put('app/components/machines/modals/compareReport.html','<div class=modal-content><div class="modal-header bg-info"><h2><span>Report</span><div class="btn-group pull-right"><a class="btn modal-close-button" ng-click=$event.stopPropagation();$dismiss()><i class="fa fa-times"></i></a></div></h2></div><div class=modal-body style=font-size:16px><div ng-show=reportDataByProperty style="overflow-x: auto;"><div ng-if="reportData.type !== \'machine\'" ng-include="\'app/components/machines/modals/compareMachineReport.html\'"></div><div ng-if="reportData.type === \'machine\'" ng-include="\'app/components/machines/modals/compareMonitoringMachineReport.html\'"></div><hr><label for=comment><strong>Comments</strong></label><div><table class="table table-bordered" style=margin-top:8px;><thead><tr><th><strong>Comment</strong></th><th class=text-center><strong>Submitted By</strong></th></tr></thead><tbody><tr ng-repeat="comment in comments"><td><span>{{comment.commentText}}</span></td><td class=text-center><span>{{comment.byWhome}}</span></td></tr></tbody></table></div><div class=row><div class=col-sm-12><textarea type=textArea placeholder="Enter comment" class=form-control name=comment id=comment ng-model=reportComment></textarea><hr><button class="btn btn-primary pull-left" ng-click=$dismiss() style=margin-top:10px>Close</button> <button class="btn btn-primary pull-right" ng-click=sendComment() ng-disabled=!reportComment style=margin-top:10px>Submit</button></div></div></div><div ng-show=!reportDataByProperty><div class=row><div class="col-md-12 text-center"><h1><i class="btn-lg fa fa-spinner fa-spin"></i> Loading report...</h1></div></div></div></div></div>');
$templateCache.put('app/components/machines/modals/deleteConfirmation.html','<div class=modal-content><div class="modal-header bg-danger"><h4><i class="fa fa-trash modal-icon"></i><span>Delete {{machine.name}}</span><div class="btn-group pull-right"><a class="btn modal-close-button" ng-click=$event.stopPropagation();$dismiss()><i class="fa fa-times"></i></a></div></h4></div><div class="modal-body text-center">Are you sure want to delete <strong>\'{{machine.name}}\'</strong>?</div><div class=modal-footer><button type=button class="btn btn-cancel pull-left" ng-click=$dismiss()>Cancel</button> <button type=button class="btn btn-remove" ng-click=confirm()>Confirm</button></div></div>');
$templateCache.put('app/components/machines/modals/duplicateMachine.html','<div class=modal-content><div class="modal-header bg-primary"><h4><i class="fa fa-clone modal-icon"></i><span>Duplicate machine: {{machine.name}}</span><div class="btn-group pull-right"><a class="btn modal-close-button" ng-click=$event.stopPropagation();$dismiss()><i class="fa fa-times"></i></a></div></h4></div><div class=modal-body><form name=machineForm><fieldset><div class=row><div class="col-sm-12 form-group has-feedback" ng-class="{\'has-error\': machineForm.name.$invalid && (machineForm.name.$dirty || machineForm.$submitted)}"><label for=name><strong>{{webAppTexts.labels.name}}</strong></label> <input ng-pattern=\'/^(?!.*[*`\\\\;:"\\\\|,.<>\\/?])/\' type=text class=form-control id=name name=name ng-model=model.name placeholder={{webAppTexts.placeholder.name}}> <span class=help-block ng-show=machineForm.name.$error.pattern>{{webAppTexts.errorMessages.specialCharactersNotAllowed}}</span> <span class=help-block ng-show=!model.name>Note: By default current machine name will be used for duplicating machine</span></div><div class="col-sm-12 form-group has-feedback" ng-class="{\'has-error\': machineForm.postFix.$invalid && (machineForm.postFix.$dirty || machineForm.$submitted)}"><label for=postFix><strong>{{webAppTexts.labels.postFix}}</strong></label> <input type=text class=form-control id=postFix name=postFix ng-model=model.postFix placeholder={{webAppTexts.placeholder.enterPostFix}} ng-maxlength=30 ng-pattern=\'/^(?!.*[*`\\\\;:"\\\\|,.<>\\/?])/\'> <span class=help-block ng-show=machineForm.postFix.$error.pattern>{{webAppTexts.errorMessages.specialCharactersNotAllowed}}</span></div><div class="col-sm-12 form-group has-feedback" ng-class="{\'has-error\': machineForm.duplicateMachineCount.$invalid && (machineForm.duplicateMachineCount.$dirty || machineForm.$submitted)}"><label for=duplicateMachineCount><strong>{{webAppTexts.labels.duplicateMachineCount}}</strong></label> <input type=number class=form-control id=duplicateMachineCount name=duplicateMachineCount ng-model=model.duplicateMachineCount min=1 max=50 placeholder={{webAppTexts.placeholder.duplicateMachineCount}}></div><div class=clearfix></div></div></fieldset></form></div><div class=modal-footer><button type=button class="btn btn-cancel pull-left" ng-click=$dismiss()>Cancel</button> <button type=button class="btn btn-primary" ng-click=confirm()>Duplicate</button></div></div>');
$templateCache.put('app/components/machines/partial/searchBar.html','<div class="container-limited container-fluid"><div class=row><ul class="breadcrumb al-breadcrumb" style="margin: 0;color: black;padding-left: 1%;margin-bottom:1%"><li ng-repeat="itm in breadCrumbList" ng-click=breadCrumbInHierarchy?checkLevel(itm):breadCrumbClickHandler(itm) style="cursor: pointer;"><a>{{itm}}</a></li></ul><div class=clearfix></div><hr style="margin: 0;margin-bottom: 1%"><div class="container-limited container-fluid"><div class=row><div class="col-xs-12 col-lg-3 col-md-2 col-sm-3"><div class=input-group><input type=text class="form-control with-primary-addon" placeholder="Enter name" style="z-index: 0"> <span class=input-group-btn><button class="btn btn-primary" type=button><i class="fa fa-search"></i></button></span></div></div><div class="col-sm-9 col-xs-12" style="padding: 0; padding-right: 4px"><div class=pull-right style="padding-right: 5px"><button tooltip-placement=top-right ng-click="showMachines || showMachinesInRoute ||showMachinesInHierarchy?addMachine():addRoute()" class="btn btn-primary">Add {{showMachines || showMachinesInRoute ||showMachinesInHierarchy ?\'Machine\':\'Routes\'}}</button></div><div class="col-sm-2 col-xs-3 pull-right" style="padding-left: 2px;"><ui-select ng-change=sort() ng-model=orderBy.selected class="btn-group bootstrap-select form-control"><ui-select-match placeholder="Select sort order"><span>{{$select.selected.displayName}}</span></ui-select-match><ui-select-choices repeat="itm in orderBy | filter: $select.search"><span ng-bind-html=itm.displayName></span></ui-select-choices></ui-select></div><div class="col-sm-2 col-xs-3 pull-right" style="padding-left: 2px;"><ui-select ng-change=setSorting(sortBy.selected) ng-model=sortBy.selected class="btn-group bootstrap-select form-control"><ui-select-match placeholder="Select sort filter"><span>{{$select.selected.displayName}}</span></ui-select-match><ui-select-choices repeat="itm in sortBy | filter: $select.search"><span ng-bind-html=itm.displayName></span></ui-select-choices></ui-select></div><div class="clearfix visible-xs"></div><br class=visible-xs><div ng-show="isTypeWise || isConditionWise" class="col-sm-2 col-xs-3 pull-right" style="padding-left: 2px;"><ui-select on-select=getMachines($item) ng-model=machineSortOptions.selected class="btn-group bootstrap-select form-control"><ui-select-match><span>{{$select.selected.displayName}}</span></ui-select-match><ui-select-choices repeat="itm in machineSortOptions | filter: $select.search" style=width:160px;><span ng-bind-html=itm.displayName></span></ui-select-choices></ui-select></div><div ng-if="(!breadCrumbInHierarchy && showMachinesInRoute) || (breadCrumbInHierarchy && !showMachinesInRoute) || !showMachinesInRoute" class="col-sm-2 col-xs-6 col-md-2 pull-right"><ui-select ng-model=viewBy.selected ng-required=true class="btn-group bootstrap-select form-control" ng-change=breadCrumbInHierarchy?getViewByHierarchy(viewBy.selected):getViewBy(viewBy.selected)><ui-select-match><span>{{$select.selected.displayName}}</span></ui-select-match><ui-select-choices repeat="choice in viewBy | filter: $select.search" style=width:150px;><span ng-bind-html=choice.displayName></span></ui-select-choices></ui-select></div></div></div></div></div></div>');
$templateCache.put('app/components/machines/reviews/calibration.html','<ul class="breadcrumb al-breadcrumb" style=margin-bottom:0;><li ng-repeat="itm in breadCrumbList"><a ng-if=!$last class=cursor-pointer ng-click=breadCrumbClickHandler(itm)>{{itm}}&nbsp;</a> <span ng-show=$last>{{itm}}</span></li></ul><br><div class="container-limited container-fluid" style="margin-top:14px;padding-left: 0px;"><i class="{{machineData.icon}} vertical-align-middle" style="font-size: 25px;" ng-style="{\'color\': machineData.condition}"></i> <span class=vertical-align-middle style="font-size: 20px;padding-left: 5px;" ng-bind=machineData.name></span></div><div class=clearfix></div><div class=panel style=margin-top:10px;><div class="container-limited container-fluid"><fieldset class=form-group style="border: 1px solid #ddd; padding: 20px; margin-bottom: 20px; margin-top: 10px; border-radius: 4px; background-color: #f9f9f9;"><legend style="width: auto; padding: 0 10px; margin-bottom: 8px; font-size: 16px; border-bottom: none;"><strong ng-bind=webAppTexts.headings.calibrationConstants></strong> <span ng-if="deviceMacId || deviceSerialNumber" style="margin-left: 10px;">( <span ng-if=deviceMacId><span ng-bind="webAppTexts.labels.deviceMacId || \'Mac ID\'"></span>-{{deviceMacId}}</span><span ng-if="deviceMacId && deviceSerialNumber">,&nbsp;</span><span ng-if=deviceSerialNumber><span ng-bind="webAppTexts.labels.serialNumber || \'Serial Number\'"></span>-{{deviceSerialNumber}}</span> )</span></legend><div ng-repeat="axis in calibrationAxes" class="row form-group" style="margin-bottom: 15px; padding-bottom: 15px; border-bottom: 1px solid #eee; align-items: flex-end;"><div class="col-sm-3 col-md-1" style="margin-top: 30px; text-align: center;"><strong>{{axis.label}}</strong></div><div class="col-sm-9 col-md-11" style="display: flex; flex: 1 1 auto;"><div style="flex: 1 1 0; min-width: 0; padding-right: 8px;"><label class="required small"><span ng-bind=webAppTexts.labels.physicalConversionConstant></span> <span ng-if="defaultCalibrationConstants[axis.key] && defaultCalibrationConstants[axis.key].physicalConversionConstant !== undefined">({{defaultCalibrationConstants[axis.key].physicalConversionConstant}})</span></label> <input type=number class=form-control ng-model=calibartionConstants[axis.key].physicalConversionConstant ng-disabled=loadingDevice placeholder={{webAppTexts.placeholder.enterPhysicalConversionConstant}} step=any required style="padding-right: 8px;"></div><div style="flex: 1 1 0; min-width: 0; padding-left: 4px; padding-right: 4px;"><label class="required small"><span ng-bind=webAppTexts.labels.ordinateToOrigin></span> <span ng-if="defaultCalibrationConstants[axis.key] && defaultCalibrationConstants[axis.key].ordinateToOrigin !== undefined">({{defaultCalibrationConstants[axis.key].ordinateToOrigin}})</span></label> <input type=number class=form-control ng-model=calibartionConstants[axis.key].ordinateToOrigin ng-disabled=loadingDevice placeholder={{webAppTexts.placeholder.enterOrdinateToOrigin}} step=any required style="padding-right: 8px;"></div><div style="flex: 1 1 0; min-width: 0; padding-left: 8px;"><label class="required small"><span ng-bind=webAppTexts.labels.rawToPhysicalDevidationFactor></span> <span ng-if="defaultCalibrationConstants[axis.key] && defaultCalibrationConstants[axis.key].rawToPhysicalDevidationFactor !== undefined">({{defaultCalibrationConstants[axis.key].rawToPhysicalDevidationFactor}})</span></label> <input type=number class=form-control ng-model=calibartionConstants[axis.key].rawToPhysicalDevidationFactor ng-disabled=loadingDevice placeholder={{webAppTexts.placeholder.enterRawToPhysicalDevidationFactor}} step=any required style="padding-right: 8px;"></div></div></div><div class=row><div class=col-md-12><button type=button class="btn btn-default" ng-click=resetCalibrationConstants() ng-disabled="loading || loadingDevice"><i class="fa fa-undo"></i> <span ng-bind=webAppTexts.buttons.reset></span></button> <button type=button class="btn btn-primary" ng-click=recalculate() ng-disabled="loading || loadingDevice || !hasChanges" style="margin-left: 10px;"><i class="fa fa-refresh"></i> <span ng-bind=webAppTexts.buttons.recalculate></span></button> <button type=button class="btn btn-success" ng-click=saveAndClose() ng-disabled="loading || loadingDevice || !hasRecalculated" style="margin-left: 10px;"><i class="fa fa-check"></i> <span ng-bind=webAppTexts.buttons.saveAndClose></span></button></div></div></fieldset><fieldset class=form-group style="border: 1px solid #ddd; padding: 20px; margin-bottom: 20px; border-radius: 4px; background-color: #f9f9f9;"><legend style="width: auto; padding: 0 10px; margin-bottom: 15px; font-size: 16px; border-bottom: none;"><strong ng-bind=webAppTexts.headings.calibratedCharts></strong></legend><div ng-show="!loading && !loadingDevice && calibartionConstants.x && calibartionConstants.x.physicalConversionConstant !== undefined && calibartionConstants.x.physicalConversionConstant !== null" class=row style="margin-bottom: 10px;"><div class="col-md-12 text-center"><button type=button class="btn btn-primary" ng-click="openingChart(\'spectrum\')" ng-disabled="loading || loadingDevice || hasChanges"><i class=icon-spectrum></i> <span ng-bind="webAppTexts.headings.spectrumChart || \'Spectrum Chart\'"></span></button> <button type=button class="btn btn-primary" ng-click="openingChart(\'wave\')" ng-disabled="loading || loadingDevice || hasChanges" style="margin-left: 10px;"><i class=icon-wave></i> <span ng-bind="webAppTexts.headings.waveChart || \'Wave Chart\'"></span></button></div></div><div ng-show="loading || loadingDevice" class=row><div class="col-md-12 text-center"><h1><i class="btn-lg fa fa-spinner fa-spin"></i> <span ng-bind="webAppTexts.notes.loading || \'Loading...\'"></span></h1></div></div></fieldset></div></div>');
$templateCache.put('app/components/machines/reviews/review.html','<ul class="breadcrumb al-breadcrumb" style=margin-bottom:0;><li ng-repeat="itm in breadCrumbList"><a ng-if=!$last class=cursor-pointer ng-click=breadCrumbClickHandler(itm)>{{itm}}&nbsp;</a> <span ng-show=$last>{{itm}}</span></li></ul><br><div class="container-limited container-fluid" style="margin-top:14px;padding-left: 0px;"><i class="{{machineData.icon}} vertical-align-middle" style="font-size: 25px;" ng-style="{\'color\': machineData.condition}"></i> <span class=vertical-align-middle style="font-size: 20px;padding-left: 5px;" ng-bind=machineData.name></span></div><div class=clearfix></div><div class=panel style=margin-top:10px;><div class="container-limited container-fluid"><div class="row search-bar no-left-right-padding"><div class="col-md-3 col-sm-3 col-lg-3 col-xs-6 sort-list"><ui-select id=readingType ng-model=selected.readingType class="btn-group bootstrap-select form-control" on-select=readingTypeSelected(readingType)><ui-select-match placeholder="Select reading type"><span>{{$select.selected.value.displayName}}</span></ui-select-match><ui-select-choices repeat="type.value.id as (key, type) in readingTypes | filter: $select.search"><span ng-bind-html=type.value.displayName></span></ui-select-choices></ui-select></div><div class="col-md-3 col-sm-3 col-lg-3 col-xs-6 sort-list"><ui-select ng-model=selected.condition class="btn-group bootstrap-select form-control" on-select=conditionSelected()><ui-select-match placeholder="Select condition"><span>{{$select.selected.displayName}}</span></ui-select-match><ui-select-choices repeat="condition in machineConditions | filter: $select.search"><span ng-bind-html=condition.displayName></span></ui-select-choices></ui-select></div><div class="col-md-3 col-sm-3 col-lg-3 col-xs-6 sort-list"><div class=input-group><input tooltip-placement=top uib-tooltip={{webAppTexts.tooltips.dateRestriction}} type=text class=form-control uib-datepicker-popup={{format}} ng-model=startSessionDate placeholder="Select start date" is-open=isStartDateOpened ng-change="dateSelected(\'start\')" datepicker-options=startDateOptions close-text=Close ng-click=selectStartDate()> <span class="input-group-btn width-review-datepicker"><button type=button class="btn btn-primary" ng-click=selectStartDate()><i class="glyphicon glyphicon-calendar"></i></button></span></div></div><div class="col-md-3 col-sm-3 col-lg-3 col-xs-6 sort-list" tooltip-placement=top uib-tooltip={{webAppTexts.tooltips.dateRestriction}}><div class=input-group style="margin-bottom: 0px;"><input type=text class=form-control uib-datepicker-popup={{format}} ng-model=endSessionDate placeholder="Select end date" is-open=isEndDateOpened ng-change="dateSelected(\'end\')" datepicker-options=endDateOptions ng-click=selectEndDate() close-text=Close> <span class="input-group-btn width-review-datepicker"><button type=button class="btn btn-primary" ng-click=selectEndDate()><i class="glyphicon glyphicon-calendar"></i></button></span></div></div><div class="visible-xs clearfix"></div><br class=visible-xs></div><div class=row><table class="table hidden-xs no-left-right-padding" style="overflow: hidden;margin-top:0px;margin-bottom:0px;table-layout: inherit;"><thead class=row><th class=col-md-3><h5>Session</h5></th><th class=col-md-2><h5>Reading Type</h5></th><th class=col-md-3><h5>Comment</h5></th><th class="text-right col-md-4" style="padding-right: 50px;"><h5>Graphs</h5></th></thead></table><div class="table-responsive infinite-div session-scroll-container" style=margin-top:0px;><table class="table no-left-right-padding" style=width:100%;margin-bottom:0px;><tbody infinite-scroll=getSessions() infinite-scroll-distance=1 infinite-scroll-container=\'".session-scroll-container"\' infinite-scroll-disabled=busy><tr class=row ng-repeat="session in sessions" style="border: none; border-bottom: 1px solid rgba(2, 2, 2, 0.05);"><td class=col-md-3><div class="vertical-align-row elipsis"><div class="pull-left vertical-align-row" style="font-size: 30px; margin-right:5px"><i ng-style="{\'color\': session.color}" class={{session.icon}}></i></div><div class=pull-left style="margin-top:-2px;padding-left: 7px;"><span>{{session.name}}</span><br ng-if=session.sessionId><span ng-if=session.sessionId>{{session.sessionId}}</span><br ng-if="session.readingType.id === 1 && session.createdBy"><span ng-if="session.readingType.id === 1 && session.createdBy" style="color: rgb(107, 106, 106);"><b>By:&nbsp;</b>{{session.createdBy.firstName + \' \' + session.createdBy.lastName}}</span></div></div></td><td class=col-md-2 style="vertical-align: middle;"><span ng-bind=session.readingType.displayName></span> <span ng-if=session.typeText ng-bind="\'/ \' + session.typeText"></span></td><td class="col-md-3 hidden-xs elipsis" style="max-width:0; vertical-align: middle;"><span tooltip-placement=top-left uib-tooltip={{session.comment}} ng-if=session.comment ng-bind=session.comment></span></td><td class="text-right no-left-right-padding col-md-4" style=min-width:100px;><button ng-if="$root.user.vibrationAnalyst && !$stateParams.routeId && !$stateParams.compositeId" ng-disabled=!session.hasProcessedData tooltip-placement=top-right uib-tooltip=Calibrate class="btn btn-primary btn-space" ng-click=openCalibration(session)><i class="fa fa-cog"></i></button> <button ng-disabled=!session.hasProcessedData tooltip-placement=top-left uib-tooltip={{webAppTexts.tooltips.spectrum}} class="btn btn-primary btn-space" ng-click="openingChart(\'spectrum\', session.sessionId, session.name, session.readingType)"><i class=icon-spectrum></i></button> <button ng-disabled=!session.hasProcessedData tooltip-placement=top uib-tooltip={{webAppTexts.tooltips.wave}} class="btn btn-primary btn-space" ng-click="openingChart(\'wave\', session.sessionId, session.name,session.readingType)"><i class=icon-wave></i></button> <button tooltip-placement=top uib-tooltip={{webAppTexts.tooltips.raw}} class="btn btn-primary btn-space" ng-click="openingChart(\'rawData\', session.sessionId, session.name, session.readingType)"><i class=icon-raw-data></i></button> <button ng-disabled="!(session.hasReport && session.viewReport)" tooltip-placement=auto uib-tooltip={{webAppTexts.tooltips.viewReport}} class="btn btn-primary btn-space" ng-click="viewReportOfSession(session.sessionId, session.name)"><i class="fa fa-eye"></i></button> <button ng-disabled="!(session.hasReport && session.readingType.id === 2)" tooltip-placement=top-right uib-tooltip="Criteria Analysis" class="btn btn-primary btn-space" ng-click=viewCriteriaAnalysis(session)><i class=icon-review></i></button></td></tr><tr ng-show="busy && sessions && sessions.length > 0"><td colspan=2><div class=text-center><i class="fa fa-spinner fa-spin fa-1x"></i>&nbsp;Loading sessions...</div></td></tr><tr ng-if="!sessions || (sessions && sessions.length === 0)"><td colspan=2><div class=text-center><i ng-class="{\'fa fa-spinner fa-spin fa-1x\': busy}"></i>{{busy ? \'Loading sessions...\': \'No sessions found. . .!!!\'}}</div></td></tr></tbody></table></div></div></div></div>');
$templateCache.put('app/components/manage/settings/settings.html','<div class="container-limited container-fluid"><div class="panel panel-body col-lg-8 col-md-8" style=margin-left:17%;><form name=customerSettingsForm><h3>Customer Information</h3><div class=form-group><div class=row><div class=col-sm-12><label for=customerName class=required><strong>Customer name</strong></label> <input type=text class=form-control id=customerName ng-model=customer.name ng-disabled=true><br><label for=distributorName><strong>Distributor</strong></label> <input type=text class=form-control id=distributorName ng-model=customer.distributorName ng-disabled=true><br><label for=description><strong>Description</strong></label> <textarea type=textArea class=form-control id=description ng-model=customer.description></textarea><br><div class=form-group><div><label for=tax><strong>Taxes</strong></label> <button class="btn btn-xs btn-primary pull-right" type=button ng-click=addTax() style=margin-bottom:5px;>Add Tax</button></div><div><table class="table table-bordered"><thead><tr><th><strong>Tax Type</strong></th><th class=text-center><strong>Value</strong></th><th class=text-center><strong>Action</strong></th></tr></thead><tbody><tr ng-repeat="tax in customer.taxes"><td><span>{{tax.type}}</span></td><td class=text-center><span>{{tax.value}}</span></td><td class=text-center><button class="btn btn-xs btn-primary" type=button ng-click=editTax(tax)><i class="fa fa-pencil"></i></button> <button class="btn btn-xs btn-remove" ng-click=removeTax(tax)><i class="fa fa-times"></i></button></td></tr></tbody></table></div></div><label><strong>Address</strong></label><div class="container-fluid container-limited"><div class=row><div class="col-sm-12 no-left-right-padding"><div class=col-sm-6><label for=street class=required><strong>Country</strong></label> <input type=text class="form-control ng-empty ng-invalid ng-invalid-required" ng-required=true id=country ng-model=customer.address.country placeholder="Enter country" required></div><br class=visible-xs><div class=col-sm-6><label for=state class=required><strong>State</strong></label> <input type=text class="form-control ng-empty ng-invalid ng-invalid-required" ng-required=true id=state ng-model=customer.address.state placeholder="Enter state" required></div></div></div><br><div class=row><div class="col-sm-12 no-left-right-padding"><div class=col-sm-6><label for=street class=required><strong>City</strong></label> <input type=text class="form-control ng-empty ng-invalid ng-invalid-required" ng-required=true id=city ng-model=customer.address.city placeholder="Enter city" required></div><br class=visible-xs><div class=col-sm-6><label for=street><strong>Street</strong></label> <input type=text class="form-control ng-valid ng-empty" id=street ng-model=customer.address.street placeholder="Enter street"></div></div></div><br><div class=row><div class="col-sm-12 no-left-right-padding"><div class=col-sm-6><label for=zipcode class=required><strong>Zipcode</strong></label> <input type=text class="form-control ng-empty ng-invalid ng-invalid-required" ng-required=true id=zipcode ng-model=customer.address.zipcode placeholder="Enter zipcode" required></div></div></div></div><div class=clearfix></div><br><div class=row><div class=col-sm-12><label for=emailId class=required><strong>Email</strong></label><div class=form-group><div ng-class="{\'has-error\' : customerSettingsForm.emailId.$invalid && !customerSettingsForm.email.$pristine}"><div class=input-group><input type=email id=emailId name=emailId ng-keypress="($event.charCode==13)? pushEmail() : return" placeholder="Enter Email" class="form-control with-primary-addon" spellcheck=false ng-model=emailId ng-pattern="/^[A-Za-z0-9._%+-]+@(?:[A-Za-z0-9](?:[A-Za-z0-9-]*[A-Za-z0-9])?\\.)+[A-Za-z]{2,}$/" style=z-index:0> <a ng-show=emailId class=search-clear ng-click="emailId = \'\';emailAlreadyAdded=false"><span class="fa fa-times"></span></a> <span class=input-group-btn><button class="btn btn-primary" type=button ng-click=pushEmail()><i class="fa fa-plus"></i></button></span></div><span style="color: red" ng-if=customerSettingsForm.emailId.$error.pattern>Please enter valid email address eg. jhon@due.com or jhon_123@due.co.uk</span> <span style="color: gray" ng-if="allEmailIds.length === 0 && !emailAlreadyAdded">Note : Need to add at least one EmailId</span><p ng-show=emailAlreadyAdded style="color: red">EmailId already added</p></div></div><div><ul class=list-group><li ng-repeat="emailId in allEmailIds" class="list-group-item clearfix"><span style="position:absolute; top:30%;">{{emailId}}</span> <span ng-click=removeSelectedEmail(emailId) class="pull-right button-group" style="cursor: pointer"><span class="glyphicon glyphicon-remove"></span></span></li></ul></div><label for=phone class=required><strong>Phone</strong></label><div class=form-group><div ng-class="{\'has-error\' : customerSettingsForm.phone.$invalid && !customerSettingsForm.phone.$pristine}"><div class=input-group><input type=text id=phone name=phone ng-keypress="($event.charCode==13)? pushPhone() : return" ng-pattern="/^\\s*(?:\\+?(\\d{1,3}))?[-. (]*(\\d{3})[-. )]*(\\d{3})[-. ]*(\\d{4})(?: *x(\\d+))?\\s*$/" placeholder="Enter Phone Number" class="form-control with-primary-addon" spellcheck=false ng-model=phone style=z-index:0> <a ng-show=phone class=search-clear ng-click="phone = \'\';phoneAlreadyAdded=false"><span class="fa fa-times"></span></a> <span class=input-group-btn><button class="btn btn-primary" type=button ng-click=pushPhone()><i class="fa fa-plus"></i></button></span></div><span style="color: red" ng-if=customerSettingsForm.phone.$error.pattern>Please enter valid Phone number eg. 1234567890 or +911234567890<br></span> <span style="color: gray" ng-if="allPhoneNums.length === 0 && !phoneAlreadyAdded">Note: Need to add at least one Phone Number<br></span> <span ng-show=phoneAlreadyAdded style="color: red">Phone number already added<br></span></div></div><div><ul ng-model=customer.allPhoneNums class=list-group><li ng-repeat="phone in allPhoneNums" class="list-group-item clearfix"><span style="position:absolute; top:30%;">{{phone}}</span> <span ng-click=removeSelectedPhone(phone) class="pull-right button-group" style="cursor: pointer"><span class="glyphicon glyphicon-remove"></span></span></li></ul></div></div></div></div></div></div><h3>Organization Structure</h3><br><div id=tree js-tree=basicConfig ng-model=treeData tree=basicTree tree-contextmenu=contextMenu style=margin-left:15px;></div><hr><button type=button class="btn btn-primary pull-right" ng-disabled=saveButtonVisbility() ng-click=saveSettings()>Save</button></form></div></div>');
$templateCache.put('app/components/profilePage/modals/changePasswordDialog.html','<div class=modal-content><div class="modal-header bg-primary"><h4 class=modal-title><span>Change Password</span><div class="btn-group pull-right"><a class=modal-close-button ng-click=closeModal()><i class="fa fa-times"></i></a></div></h4></div><div class=modal-body><form role=form name=changePasswordForm id=changePasswordForm class=form-horizontal novalidate><div class=form-group><label for=password class="col-sm-4 control-label required" style=padding-right:0px;><strong>Old password</strong></label><div class=col-sm-8><input type=password ng-model=user.password class=form-control id=password placeholder="Old password" required></div></div><div class=form-group><label for=newPassword class="col-sm-4 control-label required" style=padding-right:0px;><strong>New password</strong></label><div class=col-sm-8><input name=newPassword type=password ng-model=user.newPassword ng-minlength=6 class=form-control id=newPassword placeholder="New password" required><p ng-if="changePasswordForm.newPassword.$dirty && changePasswordForm.newPassword.$invalid" class=text-red style=margin-top:5px;>Password should be atleast 6 character long</p></div></div><div class=form-group><label for=repeatPassword class="col-sm-4 control-label required" style=padding-right:0px;><strong>Confirm password</strong></label><div class=col-sm-8><input name=repeatPassword type=password ng-minlength=6 ng-blur="user.newPassword!==user.repeatPassword ? showUniquePassword=true : null" ng-model=user.repeatPassword class=form-control id=repeatPassword placeholder="Confirm password" required><p ng-if=showUniquePassword class=text-red style=margin-top:5px;>Password should same as new password.</p><p ng-if="!showUniquePassword && changePasswordForm.repeatPassword.$dirty && changePasswordForm.repeatPassword.$invalid" class=text-red style=margin-top:5px;>Password should be atleast 6 character long</p></div></div><div class=form-group><div class="text-center col-sm-12" ng-include="\'app/components/commonHTMLs/recaptcha.html\'"></div></div></form></div><div class=modal-footer><button type=button class="btn btn-cancel btn-space pull-left" ng-click=closeModal()>Cancel</button> <button type=submit class="btn btn-primary btn-space pull-right" ng-click="changePasswordForm.$valid && changePassword()" ng-disabled=changePasswordForm.$invalid>Change Password</button></div></div>');
$templateCache.put('app/components/routes/routeDetails/routeDetails.html','<div class="row vertical-align-row"><div class=col-lg-10><ul class="breadcrumb al-breadcrumb text-truncate" style=margin-top:0px;><li ng-repeat="itm in breadCrumbList" ng-style="{\'margin-top\': addForm || editForm || (viewForm && !canEdit) ? \'10px\' : \'0px\'}"><a ng-if=!$last class=cursor-pointer ng-click=breadCrumbClickHandler(itm)>{{itm}}&nbsp;</a> <span ng-show=$last style="color: #209E91">{{itm}}</span></li></ul><br></div><div ng-if=viewForm class="col-lg-2 align-right add-button"><button ng-if=canEdit angular-ripple tooltip-placement=auto uib-tooltip="Edit route" class="btn btn-primary" ng-click=editRoute()><i class="fa fa-edit"></i></button> <button ng-if=canDelete angular-ripple tooltip-placement=top-right uib-tooltip="Delete route" class="btn btn-remove btn-space" ng-click=delete()><i class="fa fa-trash-o"></i></button></div></div><div class=panel ng-style="{\'margin-top\': addForm || editForm || (viewForm && !canEdit) ? \'20px\' : \'5px\'}"><div class="container-limited container-fluid"><div class=widgets><div class=row><div class=col-md-12><ba-wizard><ba-wizard-step steptitle=Name cancel=goBack save=save validateform=validateBasicInfoForm form=model.basicInfoForm><fieldset ng-disabled=viewForm><form name=model.basicInfoForm><div class=row><div class=col-md-6><div class="form-group has-feedback" ng-class="{\'has-error\': model.basicInfoForm.routeName.$invalid && (model.basicInfoForm.routeName.$dirty || model.basicInfoForm.$submitted)}"><label for=routeName class=required><strong>Name</strong></label> <input type=text class=form-control id=routeName name=routeName placeholder="Enter route name" ng-model=model.name ng-pattern=\'/^(?!.*[*`\\\\;:"\\\\|,.<>\\/?])/\' required> <span class="help-block error-block basic-block" ng-show=model.basicInfoForm.routeName.$error.required>Route name is required</span> <span class=help-block ng-show=model.basicInfoForm.routeName.$error.pattern>Please enter valid route name.</span></div></div><div class=col-md-6><div class=form-group ng-class="{\'has-error\': model.basicInfoForm.description.$invalid && (model.basicInfoForm.description.$dirty || model.basicInfoForm.$submitted)}"><label for=description><strong>Description</strong></label> <textarea type=textArea placeholder="Enter description" class=form-control id=description ng-model=model.description style="min-height:60px !important; resize: none;" maxlength=512></textarea></div></div><div class=col-md-6><div class="form-group has-feedback" ng-class="{\'has-error\': model.basicInfoForm.$submitted && !model.timezone}"><label for=timezone class=required><strong>{{webAppTexts.labels.selectTimezone}}</strong></label><ui-select id=timezone ng-model=model.timezone class="btn-group bootstrap-select form-control" ng-disabled=viewForm><ui-select-match placeholder={{webAppTexts.labels.selectTimezone}}><span>{{$select.selected.text}}</span></ui-select-match><ui-select-choices repeat="zone in timezoneList | filter: $select.search"><span ng-bind-html=zone.text></span></ui-select-choices></ui-select><span class="help-block error-block basic-block">{{webAppTexts.errorMessages.timezoneRequired}}</span></div></div></div><br><br></form></fieldset></ba-wizard-step><ba-wizard-step steptitle={{webAppTexts.labels.machine}} cancel=goBack save=save validateform=validateMachineInfoForm form=model.machineInfoForm><fieldset ng-disabled=viewForm><form name=model.machineInfoForm><h5 ng-if=!viewForm>{{webAppTexts.notes.machineDragMsg}}</h5><div class="dragDropList row"><div ng-if="viewForm && $index === 1" ng-repeat="list in machines" class=col-md-6><div class="panel panel-primary"><div class=panel-heading><h3 class=panel-title>{{list.listName}}</h3></div><div class="panel-body dndListScrollContainer"><ul dnd-list><li ng-repeat="item in list.items" style=cursor:default;><div class=vertical-align-row style=padding-right:10px><i class="dndList-icon {{item.icon}}"></i> <span style=margin-left:5px;>{{item.name}}</span></div></li><div ng-if=!list.items.length class="col-md-12 gray-text text-center top-margin"><span>{{webAppTexts.placeholder.allMachinesDeletedFromRoute}}</span></div></ul></div></div></div><div ng-if="addForm || editForm" ng-repeat="list in machines" class=col-md-6><div class="panel panel-primary"><div class=panel-heading><h3 class=panel-title>{{list.listName}}</h3></div><div class="panel-body dndListScrollContainer"><ul dnd-list dnd-drop="onDrop(list, item, index)" dnd-disable-if=list.disable><li ng-repeat="item in list.items" dnd-draggable="getSelectedItemsIncluding(list, item)" dnd-dragstart="onDragstart(list, event)" dnd-moved=onMoved(list) dnd-dragend="list.dragging = false" dnd-selected="item.selected = !item.selected" ng-class="{\'selected\': item.selected}" ng-hide="list.dragging && item.selected"><div class=vertical-align-row style=padding-right:10px><i class="dndList-icon {{item.icon}}"></i> <span style=margin-left:5px;>{{item.name}}</span></div><i ng-if=list.removeItem class="pull-right fa fa-times cursor-pointer" ng-click=removeMachineFromList(item) style="color:#AC2925;margin-top: -15px;"></i></li><div ng-if="!list.items.length && $parent.$index === 1" class="col-md-12 gray-text text-center"><i class=icon-motor style=font-size:xx-large;></i><br><span>Add machines in route</span></div><div ng-if="!list.items.length && $parent.$index === 0" class="col-md-12 gray-text text-center"><i class=icon-motor style=font-size:xx-large;></i><br><span>{{webAppTexts.notes.noMachineAvailable}}</span></div></ul></div></div><div ng-if="$index === 1" class=col-lg-12 style="padding:5px 0px;"><span class=text-red ng-if="model.machineInfoForm.$submitted && !machines[1].items.length">Please assign atleast single machine to route.</span></div></div></div><br><br></form></fieldset></ba-wizard-step><ba-wizard-step steptitle={{webAppTexts.labels.schedule}} cancel=goBack save=save validateform=validateScheduleForm form=model.scheduleForm><fieldset ng-disabled=viewForm><form name=model.scheduleForm><div class="row col-md-12" ng-disabled=viewForm><div class="col-md-2 align-right"><label class=vertical-align-label><strong>{{webAppTexts.labels.frequency}}</strong></label></div><div class="col-md-4 col-lg-4 col-sm-4"><ui-select ng-model=schedule.type class="btn-group bootstrap-select form-control" on-select=changingScheduleType(schedule.type) ng-disabled=viewForm><ui-select-match placeholder="Select schedule type"><span>{{$select.selected.value.name}}</span></ui-select-match><ui-select-choices repeat="type.value.id as (key, type) in scheduleTypes | filter: $select.search"><span ng-bind-html=type.value.name></span></ui-select-choices></ui-select></div><div class=clearfix></div><br><div class=row><div ng-if="schedule.type === 1" class=col-md-12><div class="col-md-2 align-right"><label class=vertical-align-label><strong>Every</strong></label></div><div class=col-md-10><div class="form-group form-inline"><select ng-model=schedule.everyMonth class="form-control input-sm"><option ng-repeat="month in months" value={{month}}>{{month}}</option></select>&nbsp; <span>month</span></div></div></div><div ng-if="schedule.type === 1" class=col-md-12><div class="col-md-2 align-right"><label class=vertical-align-label><strong>Date</strong></label></div><div class="col-md-10 form-group form-inline"><select ng-model=schedule.dates class="form-control input-sm"><option ng-repeat="date in dates" value={{date}}>{{date}}</option></select></div></div><div ng-if="schedule.type === 2" class=col-md-12><div class="col-md-2 align-right"><label class=vertical-align-label><strong>Day</strong></label></div><div class="col-md-10 form-group form-inline"><select ng-model=schedule.days class="form-control input-sm"><option ng-repeat="day in days" value={{day}}>{{day}}</option></select></div></div><div class=col-md-12><div class="col-md-2 align-right"><label class=vertical-align-label><strong>Time</strong></label></div><div class="col-md-10 form-group form-inline"><select ng-model=schedule.hour class="form-control input-sm"><option ng-repeat="hour in hours" value={{hour}}>{{hour}}</option></select>&nbsp; <label>hour</label>&nbsp;&nbsp;<select ng-model=schedule.minute class="form-control input-sm"><option ng-repeat="minute in minutes" value={{minute}}>{{minute}}</option></select>&nbsp;&nbsp; <label>minute(s)</label></div></div></div></div><br></form></fieldset></ba-wizard-step><ba-wizard-step steptitle={{webAppTexts.labels.users}} cancel=goBack save=save validateform=validateUsersInfoForm form=model.usersInfoForm><fieldset ng-disabled=viewForm><form name=model.usersInfoForm><div class=row><div class=col-lg-6><label><strong>Owner</strong></label><ui-select ng-model=model.routeOwner class="btn-group bootstrap-select form-control" ng-disabled="!canChangeOwner || viewForm" on-select=getUsersToAssign() required><ui-select-match placeholder="Select owner for route"><span>{{$select.selected.firstName + \' \' + $select.selected.lastName}}</span></ui-select-match><ui-select-choices repeat="owner in usersForOwner | filter: $select.search"><span>{{owner.firstName + \' \' + owner.lastName}}</span><br><small>{{owner.email}}</small></ui-select-choices></ui-select></div><div ng-if="addForm || editForm || (viewForm && model.userIds.length)" class=col-lg-6><label><strong>Assign Users</strong></label><ui-select multiple ng-model=model.userIds theme=bootstrap sortable=true close-on-select=false ng-disabled=viewForm on-select=getUsersToAssignOwner() on-remove=getUsersToAssignOwner()><ui-select-match placeholder={{webAppTexts.placeholder.routeUser}}><span>{{model.userIds[$index].firstName + \' \' + model.userIds[$index].lastName}}</span></ui-select-match><ui-select-choices repeat="user in usersToAssign | filter: $select.search"><span>{{user.firstName + \' \' + user.lastName}}</span><br><small>{{user.email}}</small></ui-select-choices></ui-select></div></div></form></fieldset></ba-wizard-step></ba-wizard></div></div></div></div></div>');
$templateCache.put('app/components/users/setting/userSetting.html','<div class="row vertical-align-row"><div class=col-lg-10><div ng-include="\'app/components/commonHTMLs/breadcrumb.html\'"></div><br></div><div ng-if=viewForm class="col-lg-2 align-right add-button"><button angular-ripple tooltip-placement=auto uib-tooltip="Edit Settings" class="btn btn-primary" ng-click=editSetting()><i class="fa fa-edit"></i></button></div></div><div class=clearfix></div><div ba-panel-class=profile-page><div class=panel style=margin-top:10px;><div class="container-limited container-fluid panel"><form name=userSettingForm><h3 class="form-heading no-left-padding" ng-bind=webAppTexts.headings.reportSetting></h3><hr class=no-top-margin><div class=row><fieldset ng-disabled=viewForm><div class=col-sm-4><div class="form-group has-feedback" ng-class="{\'has-error\': userForm.firstName.$invalid && (userForm.firstName.$dirty || userForm.$submitted)}"><label for=severityUnit class="col-md-3 vertical-align-label no-left-padding"><strong ng-bind=webAppTexts.labels.severityUnit></strong></label><div class=col-md-9><ui-select id=severityUnit ng-model=selected.severityUnit ng-disabled=viewForm class="btn-group bootstrap-select form-control"><ui-select-match placeholder="{{\'Select severity unit\'}}"><span ng-bind=$select.selected.displayName></span></ui-select-match><ui-select-choices repeat="severity in severityUnits | filter: $select.search"><span ng-bind-html=severity.displayName></span></ui-select-choices></ui-select></div></div></div></fieldset><fieldset><div class=col-md-12><hr ng-if=editForm><nav><ul class="pager ba-wizard-pager"><li ng-if=editForm class=previous><button type=button class="btn btn-cancel" style="margin-right: 3px" ng-click=cancel()>Cancel</button></li><li ng-if=editForm style="margin-right: 5px;" class=next><button type=button class="btn btn-primary" ng-click=save()>Update</button></li></ul></nav></div></fieldset></div></form><div class=clearfix></div></div></div></div>');
$templateCache.put('app/components/users/userDetails/userDetails.html','<div class="row vertical-align-row"><div class=col-lg-6><ul class="breadcrumb al-breadcrumb"><li ng-repeat="itm in breadCrumbList"><a>{{itm}}</a></li></ul><br></div><div ng-if=viewForm class="col-lg-6 align-right add-button"><button angular-ripple tooltip-placement=auto uib-tooltip={{webAppTexts.tooltips.editUser}} class="btn btn-primary" ng-click=editUser()><i class="fa fa-edit"></i></button></div></div><div class=clearfix></div><div class=panel style=margin-top:10px;><div class="container-limited container-fluid panel"><div class=widgets><div class=row><div class=col-md-12><ba-wizard><ba-wizard-step steptitle=Details cancel=goBack save=save validateform=validateBasicInfoForm form=user.basicInfoForm><form name=user.basicInfoForm novalidate><fieldset ng-disabled=viewForm><div class=col-sm-6><div class="form-group has-feedback" ng-class="{\'has-error\': user.basicInfoForm.firstName.$invalid && (user.basicInfoForm.firstName.$dirty || user.basicInfoForm.$submitted)}"><label for=firstName class=required><strong>{{webAppTexts.labels.firstName}}</strong></label> <input type=text class=form-control id=firstName name=firstName ng-model=model.firstName placeholder={{webAppTexts.placeholder.enterFirstName}} ng-pattern="/^[a-zA-Z]*$/" required> <span class="help-block error-block basic-block" ng-show=user.basicInfoForm.firstName.$error.required>First name is required</span> <span class=help-block ng-show=user.basicInfoForm.firstName.$error.pattern>Special characters like \\ / : * ? " <> | and spaces, numbers are not allowed.</span></div></div><br class=visible-xs><div class=col-sm-6><div class="form-group has-feedback" ng-class="{\'has-error\': user.basicInfoForm.lastName.$invalid && (user.basicInfoForm.lastName.$dirty ||user.basicInfoForm.$submitted)}"><label for=lastName class=required><strong>{{webAppTexts.labels.lastName}}</strong></label> <input type=text class=form-control id=lastName name=lastName ng-model=model.lastName placeholder={{webAppTexts.placeholder.enterLastName}} ng-pattern="/^[a-zA-Z]*$/" required> <span class="help-block error-block basic-block" ng-show=user.basicInfoForm.lastName.$error.required>Last name is required</span> <span class=help-block ng-show=user.basicInfoForm.lastName.$error.pattern>Special characters like \\ / : * ? " <> | and spaces, numbers are not allowed.</span></div></div><div class=clearfix></div><br><div class=col-sm-6><div class="form-group has-feedback" ng-class="{\'has-error\' : user.basicInfoForm.email.$invalid && (user.basicInfoForm.email.$dirty ||user.basicInfoForm.$submitted)}"><label for=email class=required><strong>{{webAppTexts.labels.email}}</strong></label> <input type=email id=email name=email placeholder={{webAppTexts.placeholder.email}} class="form-control with-primary-addon" spellcheck=false ng-model=model.email ng-pattern="/^[a-zA-Z0-9._+]+@[a-zA-Z0-9]+\\.[a-z.]{1,500}$/" style=z-index:0 required> <span class="help-block error-block basic-block" ng-if=user.basicInfoForm.email.$error.pattern>Please enter valid email address eg. john@due.com or jhon_123@due.co.uk</span> <span class="help-block error-block basic-block" ng-if=!user.basicInfoForm.email.$error.pattern>Email ID is required</span></div></div><div class=col-md-6><div class="form-group has-feedback" ng-class="{\'has-error\': user.basicInfoForm.phone.$invalid && (user.basicInfoForm.phone.$dirty || user.basicInfoForm.$submitted)}"><label for=phone><strong>{{webAppTexts.labels.phoneNo}}</strong></label> <input type=text id=phone name=phone ng-pattern="/^\\s*(?:\\+?(\\d{1,3}))?[-. (]*(\\d{3})[-. )]*(\\d{3})[-. ]*(\\d{4})(?: *x(\\d+))?\\s*$/" placeholder={{webAppTexts.placeholder.phoneNo}} class="form-control with-primary-addon" spellcheck=false ng-model=model.phone style=z-index:0> <span class="help-block error-block basic-block" ng-show=user.basicInfoForm.phone.$error.required>Phone number is required</span> <span class=help-block ng-show=user.basicInfoForm.phone.$error.pattern>Phone number is invalid.</span></div></div></fieldset></form></ba-wizard-step><ba-wizard-step steptitle=Role cancel=goBack save=save validateform=validateAssignRoles form=assignRolesForm><form name=assignRolesForm><fieldset ng-disabled=viewForm><div ng-if=!viewForm><div class=col-md-12 style="margin-bottom: 7px;"></div><div class=col-md-3><label ng-class="{required: !isSalesRepRoleSelected}" for=role><strong>{{webAppTexts.labels.role}}</strong></label><ui-select id=area ng-model=selected.role class="btn-group bootstrap-select form-control" on-select=getRoleFor(selected.role) required><ui-select-match placeholder="{{ roles.length == 0 ? \'No record found\' : \'Select role\'}}"><span>{{$select.selected.name}}</span></ui-select-match><ui-select-choices repeat="role in roles | filter: $select.search"><span ng-bind-html=role.name></span></ui-select-choices></ui-select></div><div ng-if=isRoleSelected class=col-md-3><label class=required><strong>{{webAppTexts.labels.for}}</strong></label><ui-select ng-model=selected.roleForType class="btn-group bootstrap-select form-control" ng-disabled=disableRoleForField on-select=getResourcesToAssign(selected.roleForType) required><ui-select-match placeholder="{{ roleForTypes.length == 0 ? \'No record found\' : \'Select role for\'}}"><span>{{$select.selected.name || $select.selected.displayName}}</span></ui-select-match><ui-select-choices repeat="roleForType in roleForTypes | filter: $select.search"><span ng-bind-html="roleForType.displayName || roleForType.name"></span></ui-select-choices></ui-select></div><div ng-if=isSalesRepRoleSelected class=col-md-3><label><strong>{{webAppTexts.labels.customer}}</strong></label><ui-select ng-model=selected.customer class="btn-group bootstrap-select form-control" on-select=selectCustomer()><ui-select-match placeholder="{{ customersList.length == 0 ? \'No record found\' : \'Select customer\'}}"><span>{{$select.selected.name || $select.selected.displayName}}</span></ui-select-match><ui-select-choices repeat="customer in customersList | filter: $select.search"><span ng-bind-html="customer.displayName || customer.name"></span></ui-select-choices></ui-select></div><div class=row><div ng-switch=selected.roleForType.level class=col-md-12 style="margin-top: 10px;"><div ng-switch-when=1><div class=col-md-3><label class=required><strong>{{user.customer.hierarchyType[selected.roleForType.level - 1].name}}</strong></label><ui-select ng-model=selected.plant class="btn-group bootstrap-select form-control" on-select=getMachineLists(selected.plant) ng-disabled=disablePlantField required><ui-select-match placeholder="{{ plantsList.length == 0 ? \'No record found\' : \'Select \' + user.customer.hierarchyType[selected.roleForType.level - 1].name}}"><span>{{$select.selected.name || $select.selected.displayName}}</span></ui-select-match><ui-select-choices repeat="plant in plantsList | filter: $select.search"><span ng-bind-html="plant.displayName || plant.name"></span></ui-select-choices></ui-select></div><div ng-if=isTechnicianRole class=col-md-3><label class=required><strong>{{webAppTexts.labels.machine}}</strong></label><ui-select ng-model=selected.machine class="btn-group bootstrap-select form-control" on-select=getSelectedMachine() ng-disabled=disableMachineField required><ui-select-match placeholder="{{ machinesList.length == 0 ? \'No record found\' : \'Select machine\'}}"><span>{{$select.selected.name || $select.selected.displayName}}</span></ui-select-match><ui-select-choices repeat="machine in machinesList | filter: $select.search"><span ng-bind-html="machine.displayName || machine.name"></span></ui-select-choices></ui-select></div></div><div ng-switch-when=2><div class=col-md-3><label class=required><strong>{{user.customer.hierarchyType[selected.roleForType.level - 2].name}}</strong></label><ui-select ng-model=selected.plant class="btn-group bootstrap-select form-control" ng-disabled=disablePlantField on-select="getSubLevel(selected.plant,\'Area\')" required><ui-select-match placeholder="{{ plantsList.length == 0 ? \'No record found\' : \'Select \' + user.customer.hierarchyType[selected.roleForType.level - 2].name}}"><span>{{$select.selected.name || $select.selected.displayName}}</span></ui-select-match><ui-select-choices repeat="plant in plantsList | filter: $select.search"><span ng-bind-html="plant.displayName || plant.name"></span></ui-select-choices></ui-select></div><div class=col-md-3><label class=required><strong>{{user.customer.hierarchyType[selected.roleForType.level - 1].name}}</strong></label><ui-select ng-model=selected.area class="btn-group bootstrap-select form-control" ng-disabled=disableAreaField on-select=getMachineLists(selected.area) required><ui-select-match placeholder="{{ areasList.length == 0 ? \'No record found\' : \'Select \' + user.customer.hierarchyType[selected.roleForType.level - 1].name}}"><span>{{$select.selected.name || $select.selected.displayName}}</span></ui-select-match><ui-select-choices repeat="area in areasList | filter: $select.search"><span ng-bind-html="area.displayName || area.name"></span></ui-select-choices></ui-select></div><div ng-if=isTechnicianRole class=col-md-3><label class=required><strong>{{webAppTexts.labels.machine}}</strong></label><ui-select ng-model=selected.machine class="btn-group bootstrap-select form-control" ng-disabled=disableMachineField on-select=getSelectedMachine() required><ui-select-match placeholder="{{ machinesList.length == 0 ? \'No record found\' : \'Select machine\'}}"><span>{{$select.selected.name || $select.selected.displayName}}</span></ui-select-match><ui-select-choices repeat="machine in machinesList | filter: $select.search"><span ng-bind-html="machine.displayName || machine.name"></span></ui-select-choices></ui-select></div></div><div ng-switch-when=3><div class=col-md-3><label class=required><strong>{{user.customer.hierarchyType[selected.roleForType.level - 3].name}}</strong></label><ui-select ng-model=selected.plant class="btn-group bootstrap-select form-control" on-select="getSubLevel(selected.plant,\'Area\')" ng-disabled=disablePlantField required><ui-select-match placeholder="{{ plantsList.length == 0 ? \'No record found\' : \'Select \' + user.customer.hierarchyType[selected.roleForType.level - 3].name}}"><span>{{$select.selected.name || $select.selected.displayName}}</span></ui-select-match><ui-select-choices repeat="plant in plantsList | filter: $select.search"><span ng-bind-html="plant.displayName || plant.name"></span></ui-select-choices></ui-select></div><div class=col-md-3><label class=required><strong>{{user.customer.hierarchyType[selected.roleForType.level - 2].name}}</strong></label><ui-select ng-model=selected.area class="btn-group bootstrap-select form-control" ng-disabled=disableAreaField on-select="getSubLevel(selected.area,\'Section\')" required><ui-select-match placeholder="{{ areasList.length == 0 ? \'No record found\' : \'Select \' + user.customer.hierarchyType[selected.roleForType.level - 2].name}}"><span>{{$select.selected.name || $select.selected.displayName}}</span></ui-select-match><ui-select-choices repeat="area in areasList | filter: $select.search"><span ng-bind-html="area.displayName || area.name"></span></ui-select-choices></ui-select></div><div class=col-md-3><label class=required><strong>{{user.customer.hierarchyType[selected.roleForType.level - 1].name}}</strong></label><ui-select ng-model=selected.section class="btn-group bootstrap-select form-control" ng-disabled=disableSectionField on-select=getMachineLists(selected.section) required><ui-select-match placeholder="{{ sectionsList.length == 0 ? \'No record found\' : \'Select \' + user.customer.hierarchyType[selected.roleForType.level - 1].name}}"><span>{{$select.selected.name || $select.selected.displayName}}</span></ui-select-match><ui-select-choices repeat="section in sectionsList | filter: $select.search"><span ng-bind-html="section.displayName || section.name"></span></ui-select-choices></ui-select></div><div ng-if=isTechnicianRole class=col-md-3><label class=required><strong>{{webAppTexts.labels.machine}}</strong></label><ui-select ng-model=selected.machine class="btn-group bootstrap-select form-control" ng-disabled=disableMachineField on-select=getSelectedMachine() required><ui-select-match placeholder="{{ machinesList.length == 0 ? \'No record found\' : \'Select machine\'}}"><span>{{$select.selected.name || $select.selected.displayName}}</span></ui-select-match><ui-select-choices repeat="machine in machinesList | filter: $select.search"><span ng-bind-html="machine.displayName || machine.name"></span></ui-select-choices></ui-select></div></div></div></div><br><div class=col-md-12 style="margin-left: -5px;"><button type=button class="btn btn-primary pull-right" ng-disabled=isDisableAssignRole ng-click=addRole()>{{webAppTexts.buttons.addRole}}</button></div></div><div class="container-limited container-fluid"><div class=clearfix></div><div class="row left-right-margin"><div class=table-responsive><table id=roles-table class="table no-left-right-padding" style=margin-bottom:0px><thead><th><h5 ng-if="user.customerIds && user.customerIds.length > 0" ng-bind=webAppTexts.labels.organizationalUnit></h5><h5 ng-if="user.distributorIds && user.distributorIds.length > 0">{{webAppTexts.headings.customerName}}</h5></th><th ng-class="{\'text-align-center\':!viewForm,\'align-right\':viewForm}" ng-style="{\'padding-right\':viewForm?\'20px\':\'87px\'}"><h5>{{webAppTexts.headings.role}}</h5></th><th ng-if=!viewForm class=align-right><h5></h5></th></thead><tbody><tr ng-repeat="itm in roleInfo" class=table-border><td class=vertical-align-middle><span ng-if="(viewForm || editForm) && !isDistributorSuperAdmin && !isSalesRep && itm.resource && itm.resource.ancestors && itm.resource.ancestors.length"><span style="color: rgb(107, 106, 106);" ng-repeat="level in itm.resource.ancestors">{{level.name}} <span>/</span></span> <span ng-if="itm.resourceType === \'machine\'" ng-bind="(itm.resource.parentId.name + \' / \')"></span></span> <span ng-if=!viewForm>{{itm.resource.unitName}}</span> <span ng-if="viewForm || editForm">{{itm.resource.name}}</span></td><td class=vertical-align-middle ng-class="{\'text-align-center\':!viewForm,\'align-right\':viewForm}" ng-style="{\'padding-right\':viewForm?\'20px\':\'87px\'}"><span ng-if="addForm && user.distributorIds && user.distributorIds.length > 0">{{itm.roleName}}</span> <span ng-if="!addForm && user.distributorIds && user.distributorIds.length > 0">{{itm.role}}</span> <span ng-if="user.distributorIds && user.distributorIds.length == 0 && (addForm || viewForm || editForm)">{{itm.role}}</span></td><td ng-if=!viewForm class="pull-right no-left-right-padding"><button angular-ripple tooltip-placement=auto uib-tooltip={{webAppTexts.tooltips.removeRole}} class="btn btn-remove btn-space" ng-click=removeRole(itm)><i class="fa fa-times"></i></button></td></tr><tr ng-if=busy><td ng-attr-colspan="{{viewForm ? 2 : 3}}"><div class=text-center><i class="btn-lg fa fa-spinner fa-spin"></i> &nbsp;{{webAppTexts.notes.loadingUserRoles}}</div></td></tr><tr ng-if="!busy && roleInfo && roleInfo.length === 0"><td ng-attr-colspan="{{viewForm ? 2 : 3}}"><div class=text-center>{{webAppTexts.notes.noRoleAssigned}}</div></td></tr></tbody><tfoot ng-if="totalItems > limit"><tr style="border-bottom: none; text-align: center"><td ng-attr-colspan="{{viewForm ? 2 : 3}}" class=gl-pagination><ul uib-pagination total-items=totalItems items-per-page=limit ng-model=uibPage.rolesPage max-size=10 class=pagination-sm boundary-links="totalItems/limit > limit" rotate=false ng-change=pageChanged(uibPage.rolesPage) style="margin-bottom: 0px;"></ul></td></tr></tfoot></table></div></div></div></fieldset></form></ba-wizard-step></ba-wizard></div></div></div></div></div>');
$templateCache.put('app/theme/components/baSidebar/ba-sidebar.html','<aside class=al-sidebar ng-swipe-right=$baSidebarService.setMenuCollapsed(false) ng-swipe-left=$baSidebarService.setMenuCollapsed(true) ng-mouseleave="hoverElemTop=selectElemTop"><ul class=al-sidebar-list slimscroll="{height: \'{{menuHeight}}px\'}" slimscroll-watch=menuHeight><li ng-repeat="item in menuItems" class=al-sidebar-list-item ng-class="{\'with-sub-menu\': item.subMenu}" ui-sref-active=selected ba-sidebar-toggling-item=item><a ng-mouseenter="hoverItem($event, item)" ui-state="item.stateRef || \'\'" ng-href="{{(item.fixedHref ? item.fixedHref: \'\')}}" ng-if=!item.subMenu class=al-sidebar-list-link><i class="{{ item.icon }}"></i><span>{{ item.title }}</span></a> <a ng-mouseenter="hoverItem($event, item)" ng-if=item.subMenu class=al-sidebar-list-link ba-ui-sref-toggler><i class="{{ item.icon }}"></i><span>{{ item.title }}</span> <b class="fa fa-angle-down" ui-sref-active=fa-angle-up ng-if=item.subMenu></b></a><ul ng-if=item.subMenu class=al-sidebar-sublist ng-class="{\'slide-right\': item.slideRight}" ba-ui-sref-toggling-submenu><li ng-repeat="subitem in item.subMenu" ng-class="{\'with-sub-menu\': subitem.subMenu}" ui-sref-active=selected ba-sidebar-toggling-item=subitem class=ba-sidebar-sublist-item><a ng-mouseenter="hoverItem($event, item)" ng-if=subitem.subMenu ba-ui-sref-toggler class="al-sidebar-list-link subitem-submenu-link"><span>{{ subitem.title }}</span> <b class=fa ng-class="{\'fa-angle-up\': subitem.expanded, \'fa-angle-down\': !subitem.expanded}" ng-if=subitem.subMenu></b></a><ul ng-if=subitem.subMenu class="al-sidebar-sublist subitem-submenu-list" ng-class="{expanded: subitem.expanded, \'slide-right\': subitem.slideRight}" ba-ui-sref-toggling-submenu><li ng-mouseenter="hoverItem($event, item)" ng-repeat="subSubitem in subitem.subMenu" ui-sref-active=selected><a ng-mouseenter="hoverItem($event, item)" ng-if=subSubitem.disabled class=al-sidebar-list-link>{{ subSubitem.title }}</a> <a ng-mouseenter="hoverItem($event, item)" ui-state="subSubitem.stateRef || \'\'" ng-if=!subSubitem.disabled ng-href="{{(subSubitem.fixedHref ? subSubitem.fixedHref: \'\')}}">{{subSubitem.title }}</a></li></ul><a ng-mouseenter="hoverItem($event, item)" ng-if="(!subitem.subMenu && subitem.disabled)" class=al-sidebar-list-link>{{ subitem.title }}</a> <a ng-mouseenter="hoverItem($event, item)" target="{{(subitem.blank ? \'_blank\' : \'_self\')}}" ng-if="(!subitem.subMenu && !subitem.disabled)" ui-state="subitem.stateRef || \'\'" ng-href="{{(subitem.fixedHref ? subitem.fixedHref: \'\')}}">{{ subitem.title}}</a></li></ul></li></ul><div class=sidebar-hover-elem ng-style="{top: hoverElemTop + \'px\', height: hoverElemHeight + \'px\'}" ng-class="{\'show-hover-elem\': showHoverElem }"></div></aside>');
$templateCache.put('app/theme/components/baWizard/baWizard.html','<div class=ba-wizard><div class=ba-wizard-navigation-container><div ng-repeat="t in $baWizardController.tabs" class="ba-wizard-navigation {{$baWizardController.tabNum == $index ? \'active\' : \'\'}}" ng-click=$baWizardController.selectTab($index)>{{t.title}}</div></div><div class="progress ba-wizard-progress"><div ng-if=$baWizardController.addForm class="progress-bar progress-bar-primary active" role=progressbar aria-valuemin=0 aria-valuemax=100 ng-style="{width: $baWizardController.progress + \'%\'}"></div><div ng-if=!$baWizardController.addForm class=progress-bar ng-class="{\'progress-bar-primary\': $index === $baWizardController.tabNum}" ng-repeat="t in $baWizardController.tabs" role=progressbar ng-style="{width: $baWizardController.viewProgress + \'%\'}"></div></div><div class=steps ng-transclude></div><nav><ul class="pager ba-wizard-pager"><li ng-if=viewForm class=previous><button type=button class="btn btn-cancel" style="margin-right: 3px" ng-click=$baWizardController.cancel()>Back</button></li><li ng-if="editForm || !viewForm" class=previous><button type=button class="btn btn-cancel" style="margin-right: 3px" ng-click=$baWizardController.cancel()>Cancel</button></li><li ng-if=!$baWizardController.isFirstTab() class=previous><button ng-disabled=$baWizardController.isFirstTab() ng-click=$baWizardController.previousTab() type=button class="btn btn-primary">Previous</button></li><li ng-if=!$baWizardController.isLastTab() class=next><button ng-disabled=$baWizardController.isLastTab() ng-click=$baWizardController.nextTab() type=button class="btn btn-primary">Next</button></li><li ng-if="$baWizardController.isLastTab() && addForm" style="margin-right: 5px;" class=next><button type=button class="btn btn-primary" ng-click=$baWizardController.save()>Save</button></li><li ng-if=editForm style="margin-right: 5px;" class=next><button type=button class="btn btn-primary" ng-click=$baWizardController.save()>Update</button></li></ul></nav></div>');
$templateCache.put('app/theme/components/baWizard/baWizardStep.html','<section ng-show=selected class=step ng-transclude></section>');
$templateCache.put('app/theme/components/backTop/backTop.html','<i class="fa fa-angle-up back-top" id=backTop title="Back to Top"></i>');
$templateCache.put('app/theme/components/contentTop/contentTop.html','<div class="content-top clearfix"><h1 class=al-title>{{ activePageTitle }}</h1><ul class="breadcrumb al-breadcrumb"><li><a href=#/dashboard>Home</a></li><li>{{ activePageTitle }}</li></ul></div>');
$templateCache.put('app/theme/components/pageTop/pageTop.html','<div class="page-top clearfix" scroll-position=scrolled max-height=50 ng-class="{\'scrolled\': scrolled}"><div class=pull-left style="vertical-align: middle;margin-top: 10px;"><span><img href=#/dashboard class=nav-logo src=./assets/img/logo.png alt=navLogo></span> <span><a class="nav-navigation-icon ion-navicon" ba-sidebar-toggle-menu></a></span></div><div ng-if="user && user.customer.name" class="pull-left branding hidden-xs hidden-sm"><span style="padding-top: 4px" class=pageTopElipsis ng-bind=user.customer.name></span></div><div ng-if="user && user.distributor && user.distributor.name" class="pull-left branding hidden-xs hidden-sm"><span style="padding-top: 4px" class=pageTopElipsis ng-bind=user.distributor.name></span></div><div class="user-profile align-profile-icon clearfix"><div class=al-user-profile uib-dropdown><a angular-ripple uib-dropdown-toggle class=profile-toggle-link style="position: unset !important;"><img tooltip-placement=bottom-right ng-src="{{::( \'Nasta\' | profilePicture )}}"></a><ul class="top-dropdown-menu profile-dropdown" uib-dropdown-menu><li><i class=dropdown-arr></i></li><li style="margin-left: 20px;"><div class=row><div class=col-md-2><img ng-src="{{::( \'Nasta\' | profilePicture )}}"></div><div class=col-md-10><div class=elipsis style="margin: 8px;">{{user.firstName + \' \' + user.lastName}}</div><div class=elipsis style="margin-top: -4px;margin-left: 8px;">{{user.email}}</div></div></div></li><li style="margin-top: 5px;" class=cursor-pointer ng-click=showProfile()><a class=signout><i class="fa fa-user"></i>Profile</a></li><li class=cursor-pointer ng-click=showSettings()><a class=signout><i class="fa fa-gear"></i>My setting</a></li><li class=cursor-pointer ng-click=logout()><a class=signout><i class="fa fa-power-off"></i>Log out</a></li></ul></div><notification></notification></div></div><div class=clearfix></div>');
$templateCache.put('app/theme/components/progressBarRound/progressBarRound.html','<svg class="center-block progress-bar-round" width=200 height=200><circle cx=100 cy=100 r=90 fill=none stroke=#F8F8FF stroke-width=8></circle><circle cx=100 cy=100 r=90 fill=none id=loader stroke=#209e91 stroke-width=8 stroke-dasharray=0,20000 transform=rotate(-90,100,100) stroke-linecap=round></circle><text text-anchor=middle class=loading x=100 y=90>Loading...</text><text class=percentage text-anchor=middle x=100 y=130>{{progress}}%</text></svg>');
$templateCache.put('app/theme/components/widgets/widgets.html','<div class=widgets><div ng-repeat="widgetBlock in ngModel" ng-class="{\'row\': widgetBlock.widgets.length > 1}"><div ng-repeat="widgetCol in widgetBlock.widgets" ng-class="{\'col-md-6\': widgetBlock.widgets.length === 2}" ng-model=widgetCol class=widgets-block><div ba-panel ba-panel-title={{::widget.title}} ng-repeat="widget in widgetCol" ba-panel-class="with-scroll {{widget.panelClass}}"><div ng-include=widget.url></div></div></div></div></div>');
$templateCache.put('app/theme/inputs/baSwitcher/baSwitcher.html','<label class=switcher-container><input type=checkbox ng-model=switcherValue><div class=switcher ng-class=::switcherStyle><div class=handle-container><span class="handle handle-on">ON</span> <span class=handle></span> <span class="handle handle-off">OFF</span></div></div></label>');
$templateCache.put('app/components/machines/trends/monitoredMachineTrend.html','<div class="row vertical-align-row"><div class=col-lg-12><ul class="breadcrumb al-breadcrumb text-truncate" style=margin-bottom:0px;><li ng-repeat="itm in breadCrumbList"><a ng-if=!$last class=cursor-pointer ng-click=breadCrumbClickHandler(itm)>{{itm}}&nbsp;</a> <span ng-show=$last>{{itm}}</span></li></ul></div></div><br><div class=clearfix></div><h2 class=top-margin>Vibration Trend Graphs</h2><div class="panel container-fluid container-limited"><div class=row><div class="col-xs-12 vertical-align-middle"><i class="{{icon}} vertical-align-middle" style="font-size: 30px;"></i> <span class=vertical-align-middle style="font-size: 24px;padding-left: 2px;">{{machineData.name}}</span><br><span ng-if=!isMonMachine><span><strong>RPM:</strong> {{machineData.meta.rpm}}</span>&nbsp;&nbsp;&nbsp; <span ng-if="machineData.meta.size && machineData.meta.size.value"><strong>Power:</strong> {{machineData.meta.size.value + machineData.meta.size.unit.toUpperCase()}}</span></span></div></div><hr class="container-limited report-hr-thick"><div id=trendCharts ng-if=!isMonMachine><div class="container-fluid container-limited" ng-repeat="itm in trendFaults"><div ng-if=itm.trendChart.data class=row><div class=col-md-12><div class=row><div class=col-xs-12><div class="title pull-left h4 report-chart-title text-center" ng-bind="itm.displayName + \' trend\'"></div></div><div class=col-xs-9><span ng-show="itm.selectedSeverity || itm.selectedSeverity === 0"><span><strong>Severity:</strong> {{itm.selectedSeverity + \' \' + selected.severityUnit.displayName}}</span><br><span><strong>Session time:</strong> {{itm.selectedDate | date:dateFormat}}</span></span></div><div class=col-xs-3><span><svg height=12 width=20><line x1=0 x2=16 y1=8 y2=8 stroke="rgb(204, 51, 0)" stroke-width=3></line></svg><strong>Critical level ({{itm.trip + \' \' + selected.severityUnit.displayName}})</strong></span><br><span><svg height=12 width=20><line x1=0 x2=16 y1=8 y2=8 stroke="rgb(255, 165, 0)" stroke-width=3></line></svg><strong>Warning level ({{itm.warning + \' \' + selected.severityUnit.displayName}})</strong></span><br><span><svg height=12 width=20><line x1=0 x2=16 y1=8 y2=8 stroke="rgb(66, 215, 244)" stroke-width=3></line></svg><strong>Trending line</strong></span></div><div ng-class="{\'transition-delay\': chart.allData}" class=col-xs-12><nvd3 options=itm.trendChart.options on-ready=itm.callback data=itm.trendChart.data api=itm.trendChart.chart.api config=config events=events></nvd3></div></div></div></div><div ng-if=!itm.trendChart.data class=row><div class="col-md-12 text-center"><h1><i class="btn-lg fa fa-spinner fa-spin"></i> &nbsp;Loading ...</h1></div></div><hr></div></div><div id=trendCharts ng-if=isMonMachine><div class="container-fluid container-limited" ng-repeat="itm in filterValues"><div ng-if=itm.trendChart.data class=row><div class=col-md-12><div class=row><div class=col-xs-12><div class="title pull-left h4 report-chart-title text-center" ng-bind="itm.displayName + \' trend\'"></div></div><div class=col-xs-9><span ng-show="itm.selectedSeverity || itm.selectedSeverity === 0"><span><strong>Severity:</strong> {{itm.selectedSeverity + \' \' + selected.severityUnit.displayName}}</span><br><span><strong>Session time:</strong> {{itm.selectedDate | date:dateFormat}}</span></span></div><div class=col-xs-3><span><svg height=12 width=20><line x1=0 x2=16 y1=8 y2=8 stroke="rgb(204, 51, 0)" stroke-width=3></line></svg><strong>Critical level ({{itm.trip + \' \' + selected.severityUnit.displayName}})</strong></span><br><span><svg height=12 width=20><line x1=0 x2=16 y1=8 y2=8 stroke="rgb(255, 165, 0)" stroke-width=3></line></svg><strong>Warning level ({{itm.warning + \' \' + selected.severityUnit.displayName}})</strong></span><br><span><svg height=12 width=20><line x1=0 x2=16 y1=8 y2=8 stroke="rgb(66, 215, 244)" stroke-width=3></line></svg><strong>Trending line</strong></span></div><div ng-class="{\'transition-delay\': chart.allData}" class=col-xs-12><nvd3 options=itm.trendChart.options on-ready=itm.callback data=itm.trendChart.data api=itm.trendChart.chart.api config=config events=events></nvd3></div></div></div></div><div ng-if=!itm.trendChart.data class=row><div class="col-md-12 text-center"><h1><i class="btn-lg fa fa-spinner fa-spin"></i> &nbsp;Loading ...</h1></div></div><hr></div></div></div>');
$templateCache.put('app/components/machines/reviews/modals/charts.html','<div id=graphContent class="modal-content chart-modal" style="height:100% !important;"><div class="modal-header bg-primary"><h4 class=modal-title><span>{{chartTitle}}</span><div class="btn-group pull-right"><a class=modal-close-button ng-click=toggleModel()><i ng-class="{\'fa fa-expand\': !expandModel, \'fa fa-compress\': expandModel}"></i></a> <a class=modal-close-button ng-click=$event.stopPropagation();$dismiss()><i class="fa fa-times"></i></a></div></h4></div><div id=graphBody ng-show="graph.data.length && !loading" class=modal-body style="margin:0px 15px;"><div id=vData class=row style="margin-left:-20px !important;"><div class="col-md-4 session-graph-machine-icon-container"><span class=session-graph-machine-icon><i class="{{machineData.icon}} vertical-align-middle" style="font-size: 25px;margin-right:5px;"></i>{{machineData.name}}</span></div><div ng-if=!isMonPoint class="sort-list col-md-6 col-sm-2 col-lg-6"><label class=form-control style="text-align:right;border:none; white-space: nowrap;">Reading Point</label></div><div ng-if=!isMonPoint class="col-md-2 col-sm-4 col-lg-2 sort-list"><ui-select id=point ng-change=changePoint() ng-model=selected.point class="btn-group bootstrap-select form-control" ng-disabled=isSinglePoint><ui-select-match placeholder="Select Point"><span>{{ $select.selected.displayName }}</span></ui-select-match><ui-select-choices repeat="point in machineData.meta.points | filter: $select.search"><span ng-bind-html=point.displayName></span></ui-select-choices></ui-select></div><div ng-mouseleave=graph.resetValues() class=col-md-12><div ng-show=!showToolTip class="row current-point-values-box"><div class="col-xs-12 graph-header-data"><span class=graph-span-elipsis><strong>{{graph.options.xlabel}}</strong></span> <span class=graph-span-elipsis>{{\': \' + graph.currentValues.xValue}}</span></div><div ng-show=graph.overallVibrations class="col-sm-6 col-sm-4" ng-repeat="itm in graph.overallVibrations"><span uib-tooltip={{itm.axis}} tooltip-placement=top class="graph-span-elipsis graph-data-property"><strong>{{itm.axis}}</strong></span> <span class=graph-span-elipsis>{{\': \' + itm.value}}</span></div><div class="col-sm-6 col-sm-4" ng-repeat="value in graph.currentValues.yValues"><span uib-tooltip={{value.label}} tooltip-placement=top class="graph-span-elipsis graph-data-property" "><strong>{{value.label}}</strong></span> <span class=graph-span-elipsis>{{\': \' + value.yVal}}</span></div></div></div></div><div id=dgf class="row graph-container"><ng-dygraphs ng-if="graph.data && graph.data.length > 0" data=graph.data options=graph.options legend=graph.legend></ng-dygraphs><span ng-show=graph.overallVibrations style="font-size: 90%">Note: The overall vibration values are derived from available data and may differ with measured values.</span></div></div><div ng-show="!loading && !graph.data.length" class=modal-body><div class=row><div class="col-md-12 text-center"><h5>Fail to collect data. Please try again.</h5></div></div></div><div ng-show=loading class=modal-body><div class=row><div class="col-md-12 text-center"><h1><i class="btn-lg fa fa-spinner fa-spin"></i>Loading ...</h1></div></div></div></div>');
$templateCache.put('app/components/machines/reviews/modals/machineReport.html','<div><span ng-if=takenBy style="font-size: 11px;" ng-style=takenOnStyle class=pull-left ng-bind=takenBy></span> <span style="font-size: 11px;" ng-style=takenOnStyle class=pull-right>{{reportData.createdOn | date:dateFormat}}</span><div class=row><div class="col-xs-12 text-center"><h3 style=margin:0px><strong>Machine:</strong>{{machineInfo.name}}</h3></div><div ng-if=greenAnimate class="col-xs-12 text-center"><div class=circle></div></div><div ng-if=redAnimate class=col-xs-12><div class="alert alert-danger"><strong>IMPORTANT NOTE:</strong><br>{{importantNote}}</div></div><div ng-repeat="property in reportProperties" class=col-xs-12 style="margin-bottom: 10px"><div><label class=report-label>{{property.label}}</label></div><div ng-if="property.prev != property.Current && !noLastReport" ng-style="{\'margin-left\': property.prev + \'%\'}"><span class=status-notation-label>Previous</span><div class=arrow-down-prev></div></div><div ng-style="{\'margin-left\': property.Current + \'%\'}"><span class=status-notation-label ng-style="{\'margin-left\': ((property.prev === property.Current) && (property.currentSeverity>4) ? \'-46px\' : \'0px\')}">{{property.prev === property.Current ? ( noLastReport ? \'Current\' : \'Previous & Current\' ) : \'Current\'}}</span><div class=arrow-down-last></div></div><div id=conditon-status class=text-center><div class="col-xs-4 report-border">Good</div><div class="col-xs-4 report-border report-center-div-border" style=padding:0px>OK (Passable)</div><div class="col-xs-4 report-border">Bad</div></div><div><ul class=recommendation-list ng-repeat="rec in property.recommendation track by $index"><li>{{rec}}</li></ul></div><hr style=margin-top:10px class=report-divider></div></div></div><div ng-if="currentReportExpSysVersion && !showMachineStatus" class="text-right container-fluid report-version">Version: {{currentReportExpSysVersion}}</div>');
$templateCache.put('app/components/machines/reviews/modals/motorReport.html','<div><span ng-if=takenBy style="font-size: 11px;" ng-style=takenOnStyle class=pull-left ng-bind=takenBy></span> <span style="font-size: 11px;" ng-style=takenOnStyle class=pull-right>{{reportData.createdOn | date:dateFormat}}</span><div class=row><div class=col-xs-12><h3 style=margin-top:0px class=text-center><strong ng-bind="(machineInfo ? ((machineInfo.machineType) + \': \') : \'\')"></strong>{{machineInfo.name}}</h3></div><div ng-if=greenAnimate class="col-xs-12 text-center"><div class=circle></div></div><div ng-if=redAnimate class=col-xs-12><div class="alert alert-danger"><strong>IMPORTANT NOTE:</strong><br>{{importantNote}}</div></div><div ng-repeat="property in reportProperties" ng-show="(property.recommendation.length || showExcellent)" class=col-xs-12 ng-style="{\'margin-bottom\': ($index === reportProperties.length -1 || isFinalSeverity($index, false) ? \'0px\' :\'10px\')}"><div><label class=report-label>{{property.label}}</label></div><div ng-if="!isFinalSeverity($index, false)"><div ng-if="property.prev != property.Current && !noLastReport" ng-style="{\'margin-left\': property.prev + \'%\'}"><span class=status-notation-label>Previous</span><div class=arrow-down-prev></div></div><div ng-style="{\'margin-left\': property.Current + \'%\'}"><span class=status-notation-label ng-style="{\'margin-left\': ((property.prev === property.Current) && (property.currentSeverity>4) ? \'-46px\' : \'0px\')}">{{property.prev === property.Current ? ( noLastReport ? \'Current\' : \'Previous & Current\' ) : \'Current\'}}</span><div class=arrow-down-last></div></div><div id=conditon-status class=text-center><div class="col-xs-4 report-border">Good</div><div class="col-xs-4 report-border report-center-div-border" style=padding:0px>OK (Passable)</div><div class="col-xs-4 report-border">Bad</div></div></div><div><ul class=recommendation-list ng-repeat="rec in property.recommendation track by $index"><li>{{rec}}</li></ul></div><hr ng-style="{\'margin-top\': (isFinalSeverity($index, false) ? \'20px\':\'10px\')}" ng-show="(property.recommendation.length || showExcellent)" class=report-divider ng-class="{\'thick-hr\':isFinalSeverity($index, true)}"><div class=text-center ng-if="isFinalSeverity($index, false)"><button ng-click=toggleShowExcellent() style="margin-top: -30px;" class="btn btn-primary">{{!showExcellent ? \'More\': \'Less\'}} Details <i class="fa fa-chevron-down rotate" ng-class="{\'down\': showExcellent}"></i></button></div></div></div></div><div ng-if="currentReportExpSysVersion && !showMachineStatus" class="text-right container-fluid report-version">Version: {{currentReportExpSysVersion}}</div>');
$templateCache.put('app/components/machines/reviews/modals/rawDataChart.html','<div id=graphContent class=modal-content style="height:100% !important;"><div class="modal-header bg-primary"><h4 class=modal-title><span>Raw Data Chart: {{machineDetails.sessionName}}</span><div class="btn-group pull-right"><a class=modal-close-button ng-click=toggleModel()><i ng-class="{\'fa fa-expand\': !expandModel, \'fa fa-compress\': expandModel}"></i></a> <a class=modal-close-button ng-click=closeModal()><i class="fa fa-times"></i></a></div></h4></div><div id=graphBody class=modal-body style="margin:0px 15px;"><div id=vData class=row style="margin-left:-20px !important;"><div class=col-md-12 style=margin-bottom:5px;><div class=row><div class="col-md-6 session-graph-machine-icon-container"><span class=session-graph-machine-icon><i class="{{machineDetails.icon}} vertical-align-middle" style="font-size: 25px;margin-right:5px;"></i>{{machineDetails.name}}</span></div><div ng-if=!isMonPoint class="sort-list col-md-4 col-sm-2 col-lg-4"><label class=form-control style="text-align:right;border:none; white-space: nowrap;">Reading Point</label></div><div ng-if=!isMonPoint class="col-md-2 col-sm-4 col-lg-2 sort-list"><ui-select id=point ng-change=changePoint() ng-model=selected.point class="btn-group bootstrap-select form-control" ng-disabled=isSinglePoint><ui-select-match placeholder="Select Point"><span>{{ $select.selected.displayName }}</span></ui-select-match><ui-select-choices repeat="point in machineDetails.meta.points | filter: $select.search"><span ng-bind-html=point.displayName></span></ui-select-choices></ui-select></div></div></div><div ng-mouseleave=graph.resetValues() class=col-md-12><div class="row text-center" style="margin-bottom: 10px;"><span ng-if="selectedPoints.length === 0 && combinationWave" class=select-point><mark><em>Please select atleast one axis point to visualize the graph</em></mark></span></div><div ng-if=!combinationWave class=text-center><h3><i class="fa fa-spinner fa-spin fa-1x"></i> Loading data...</h3></div><div ng-if=combinationWave class=text-center><div class=btn-group><div data-toggle=buttons class="btn-group itemcontent" ng-repeat="pointData in allPoints"><label class="btn btn-default" ng-class="{\'active\':pointData.active}" ng-if=pointData.showPoint ng-click=changeGraph(pointData)><input type=checkbox name={{pointData.point}} checklist-value=pointData.point checklist-model=selectedPointsForGraph value=pointData><h5><strong>{{pointData.axis.toUpperCase()}}</strong></h5></label></div></div></div><div ng-show=!showToolTip class="row current-point-values-box"><div ng-show=graph.currentValues class="col-xs-12 graph-header-data"><span class=graph-span-elipsis><strong>{{graph.options.xlabel}}</strong></span> <span class=graph-span-elipsis>{{\': \' + graph.currentValues.xValue}}</span></div><div class="col-sm-6 col-sm-4" ng-repeat="value in graph.currentValues.yValues"><span uib-tooltip={{value.label}} tooltip-placement=top class="graph-span-elipsis graph-data-property"><strong>{{value.label}}</strong></span> <span class=graph-span-elipsis>{{\': \' + value.yVal}}</span></div></div></div></div><div id=dgf class="row graph-container" style=height:100%><ng-dygraphs ng-if="graph.data && graph.data.length > 0" data=graph.data options=graph.options legend=graph.legend></ng-dygraphs></div></div></div>');
$templateCache.put('app/components/machines/reviews/modals/viewCriteriaAnalysis.html','<div class=modal-content style="height: 100% !important;"><div class="modal-header bg-primary"><h4 class=modal-title><strong>Criteria wise analysis</strong><div class="btn-group pull-right"><a class=modal-close-button ng-click=closeModal()><i class="fa fa-times"></i></a></div></h4></div><div class=modal-body style="font-size:16px;height: 90% !important;;overflow: scroll;"><div class=row><div class="col-md-12 col-xs-12"><div class="pull-left heading-machine-icon"><i class={{reportData.icon}} ng-style="{\'color\': reportData.color}"></i></div><div class=pull-left><span style="font-size: 24px;" ng-bind=reportData.machineName></span><br ng-if=!isMonMachine><span ng-if=!isMonMachine><span><strong>RPM:</strong><span ng-bind=reportData.meta.rpm></span></span>&nbsp;&nbsp;&nbsp; <span ng-if="reportData.meta.size && reportData.meta.size.value"><strong>Power:</strong> <span ng-bind="reportData.meta.size.value + reportData.meta.size.unit.toUpperCase()"></span></span></span></div><div class=pull-right><span><strong>Session Taken On:</strong><span ng-bind="reportData.createdOn | date:dateFormat"></span></span>&nbsp;&nbsp;&nbsp;</div></div><hr><div class="col-md-12 col-xs-12"><table id=analysis-table class="table table-bordered"><thead><tr><th>Criteria</th><th>Faults</th><th ng-if=!isMonMachine>Reading Point</th><th>Axis</th><th>Current</th><th>Average</th><th>Standard Deviation</th><th>Axis Condition</th><th>Criteria Condition</th></tr></thead><tbody><tr ng-repeat="tr in tableData"><td ng-if=tr.criteria rowspan={{tr.criteriaRowSpan}} ng-bind=tr.criteria></td><td ng-if=tr.fault rowspan={{tr.faultRowSpan}} ng-bind=tr.fault></td><td ng-if="tr.point && !isMonMachine" rowspan={{tr.pointRowSpan}} ng-bind=tr.point></td><td ng-if=tr.axis ng-bind=tr.axis.toUpperCase()></td><td ng-if="tr.current || tr.current === 0" ng-bind=tr.current></td><td ng-if="tr.avg || tr.avg === 0" ng-bind=tr.avg></td><td ng-if="tr.stdev || tr.stdev === 0" ng-bind=tr.stdev></td><td ng-class="{\'condition\': tr.axisColor}" ng-style="{\'background-color\': tr.axisColor }" ng-if=tr.axisCondition ng-bind=tr.axisCondition></td><td ng-class="{\'condition\': tr.criteriaColor}" ng-style="{\'background-color\': tr.criteriaColor }" ng-if=tr.criteriaCondition rowspan={{tr.criteriaRowSpan}} ng-bind=tr.criteriaCondition></td></tr></tbody></table></div></div></div></div>');
$templateCache.put('app/components/machines/reviews/modals/viewReport.html','<div class=modal-content><div class="modal-header bg-primary"><h4 class=modal-title><strong>{{\'Session \\\'\' + sessionName + \'\\\' Report \'}}</strong><div class="btn-group pull-right"><a class=modal-close-button ng-click=closeModal()><i class="fa fa-times"></i></a></div></h4></div><div class=modal-body style=font-size:16px><div><div ng-if="reportData.type !== \'machine\'" ng-include="\'app/components/machines/reviews/modals/motorReport.html\'"></div><div ng-if="reportData.type === \'machine\'" ng-include="\'app/components/machines/reviews/modals/machineReport.html\'"></div></div><div class=row><div class=col-xs-12><label for=comment><strong>Comments</strong></label><table class="table table-bordered" ng-if=comments.length style=margin-top:8px;><thead><tr><th class=col-md-8><strong>Comment</strong></th><th class="col-md-4 text-center"><strong>Submitted By</strong></th></tr></thead><tbody><tr ng-repeat="comment in comments"><td style=word-break:break-word;><span>{{comment.message}}</span></td><td class=text-center><span ng-bind="(comment.uploadedBy.firstName + \' \' + comment.uploadedBy.lastName)">{{comment.uploadedBy.firstName + \' \' + comment.uploadedBy.lastName}}</span></td></tr></tbody></table></div><div class=col-sm-12><textarea type=textArea placeholder="Enter comment" class="form-control report-comment" id=comment ng-model=reportComment maxlength=512></textarea><hr><button class="btn btn-primary pull-right" ng-click=addComment() ng-disabled=!reportComment style=margin-top:10px>Submit</button></div></div></div></div>');
$templateCache.put('app/components/machines/reviews/partial_templates/datePicker.html','<label ng-class="{\'required\': datePickerOptions.isRequired}" ng-bind=datePickerOptions.label></label><div class=input-group><input id=datePicker name=datePicker type=text class=form-control uib-datepicker-popup={{datePickerOptions.format}} ng-model=datePickerOptions.pickedDate is-open=datePickerOptions.isOpen placeholder={{datePickerOptions.placeHolder}} datepicker-options=datePickerOptions ng-click=datePickerOptions.selected() close-text=Close ng-required=measuringFrequency.nextScheduleOn> <span class="input-group-btn width-review-datepicker"><button type=button class="btn btn-primary" ng-click=datePickerOptions.selected()><i class="glyphicon glyphicon-calendar"></i></button></span></div>');
$templateCache.put('app/components/manage/settings/Hierarchy_Structure/addHierarchyStructure.html','<div class="container-limited container-fluid"><div class="panel panel-body"><div class=col-sm-12><h1>Organization Structure</h1><hr style="margin-top: 5px"><span style="text-justify: auto">Enter your structure of organization. We have support for maximum 3 level structure. Lowest level will contain your machines.<br><br><span><strong>Example-</strong><span><br><span>Plant (Level 1)</span><br><span style="padding-left: 10px">|_ Area (Level 2)</span><br><span style="padding-left: 20px">|_ Sections (Level 3)</span></span></span><hr></span></div><div class=col-sm-8 ng-if=addNode><div js-tree=basicConfig ng-model=treeData tree=basicTree tree-events=select_node:nodeSelected tree-contextmenu=contextMenu></div><br></div><div class=col-sm-12><div style="margin-top: 10px;" ng-if="maxLevels > 0" class="form-inline form-group"><label><strong>{{levelId}}</strong> &nbsp;</label> <input type=text class=form-control id=levelName name=levelName ng-model=levelName><br class=visible-xs><button class="btn btn-primary" ng-click="addNewNode(levelName);levelName = \'\'" ng-disabled=!levelName>Add</button></div><hr></div><div class=col-sm-12><button type=button class="btn btn-danger pull-left" ng-click=cancel()>Cancel</button> <button type=button class="btn btn-primary pull-right" ng-disabled=!treeData.length ng-click=save()>Save</button></div></div></div>');
$templateCache.put('app/components/manage/settings/Modals/addTax.html','<div class=modal-content><div class="modal-header bg-info"><h4><i class={{iconClass}}></i> <span>{{title}}</span><div class="btn-group pull-right"><a class="btn modal-close-button" ng-click=$event.stopPropagation();$dismiss()><i class="fa fa-times"></i></a></div></h4></div><div class=modal-body><form role=form name=addTaxFrom><div class=form-group><div class=col-sm-12><label class=required for=taxType><strong>Tax type</strong></label><ui-select id=taxType ng-model=taxTypes.taxType class="btn-group bootstrap-select form-control" ng-disabled=taxData.type><ui-select-match><span>{{$select.selected}}</span></ui-select-match><ui-select-choices repeat="tax in taxTypes | filter: $select.search"><span ng-bind-html=tax></span></ui-select-choices></ui-select><br><br><label class=required for=taxValue><strong>Tax value</strong></label> <input type=text class=form-control ng-required=true id=taxValue ng-model=taxValue placeholder="Enter tax value"><div class=clearfix></div><br></div></div></form></div><div class=clearfix></div><br><div class=modal-footer><button type=button class="btn btn-danger pull-left" ng-click=$dismiss()>Cancel</button> <button type=button class="btn btn-info" ng-disabled="!(taxTypes.taxType && taxValue)" ng-click=addTax()>Save</button></div></div>');
$templateCache.put('app/components/manage/settings/Modals/saveStructureConfirmation.html','<div class=modal-content><div class="modal-header bg-info"><h4><i class="ion-information-circled modal-icon"></i><span>Save organization structure</span><div class="btn-group pull-right"><a class="btn modal-close-button" ng-click=$event.stopPropagation();$dismiss()><i class="fa fa-times"></i></a></div></h4></div><div class="modal-body text-center">Are you sure want to save organization structure? You cannot change it later</div><div class=modal-footer><button type=button class="btn btn-danger pull-left" ng-click=$dismiss()>Cancel</button> <button type=button class="btn btn-info" ng-click=confirm()>Ok</button></div></div>');}]);